import { jsxs, jsx, Fragment } from 'react/jsx-runtime';
import { Help, Menu as Menu$1, ChevronLeft, ChevronRight, ExpandLess, ExpandMore, Delete, Add, Dehaze, Close, Article, WebAssetOutlined, DescriptionOutlined, ArticleOutlined, MoreVert, KeyboardArrowRight, Check, AddOutlined, DataObjectSharp, DesignServicesOutlined, AutoAwesome, KeyboardArrowDown, VolumeUp, Settings, OpenInNew, ContentCopy, Download, WebAsset, Description, Error as Error$1, Mic, MicOff, StopCircle, TransitEnterexit, Share, LightbulbOutlined, VolumeOff, Translate, RecordVoiceOver, VolumeOffOutlined, VolumeUpOutlined, SettingsOutlined, LogoutOutlined, ArrowUpward, ChatBubbleOutline, MicNone, TouchAppOutlined, HistoryOutlined, DeleteOutlined, CropFree, Save, DriveFileRenameOutline, DriveFileMove } from '@mui/icons-material';
import { Popover, CircularProgress, ClickAwayListener } from '@mui/material';
import classNames from 'classnames';
import { NestedMenuItem, IconMenuItem } from '/opt/build/repo/node_modules/mui-nested-menu/module.js';
import * as React from 'react';
import React__default, { useEffect, memo, useRef, useState, useLayoutEffect, Fragment as Fragment$1, useCallback, forwardRef, useContext } from 'react';
import { useNavigate, Link, useLocation, useSearchParams } from 'react-router-dom';
import { Tooltip } from '/opt/build/repo/node_modules/react-tooltip/dist/react-tooltip.min.mjs';
import { IonMenuButton, IonMenu } from '@ionic/react';
import { menuController } from '/opt/build/repo/node_modules/@ionic/core/components/index.js';
import { Capacitor } from '/opt/build/repo/node_modules/@capacitor/core/dist/index.js';
import { Switch } from '@headlessui/react';
import Select$1, { components as components$1 } from 'react-select';
import { DndContext, closestCorners } from '/opt/build/repo/node_modules/@dnd-kit/core/dist/core.esm.js';
import { restrictToParentElement } from '/opt/build/repo/node_modules/@dnd-kit/modifiers/dist/modifiers.esm.js';
import { arrayMove, SortableContext, useSortable } from '/opt/build/repo/node_modules/@dnd-kit/sortable/dist/sortable.esm.js';
import { CSS } from '/opt/build/repo/node_modules/@dnd-kit/utilities/dist/utilities.esm.js';
import CreatableSelect from '/opt/build/repo/node_modules/react-select/creatable/dist/react-select-creatable.esm.js';
import ReactSlider from '/opt/build/repo/node_modules/react-slider/dist/es/prod/index.mjs';
import { Resizable } from '/opt/build/repo/node_modules/react-resizable/index.js';
import dayjs from '/opt/build/repo/node_modules/dayjs/dayjs.min.js';
import InfiniteScroll from '/opt/build/repo/node_modules/react-infinite-scroll-component/dist/index.es.js';
import { CircleNotch, Sparkle } from '/opt/build/repo/node_modules/phosphor-react/dist/index.esm.js';
import Tooltip$1, { tooltipClasses } from '/opt/build/repo/node_modules/@mui/material/Tooltip/index.js';
import { styled } from '/opt/build/repo/node_modules/@mui/system/esm/index.js';
import { TypeAnimation } from '/opt/build/repo/node_modules/react-type-animation/dist/esm/index.es.js';
import { Howl } from '/opt/build/repo/node_modules/howler/dist/howler.js';
import { T } from '/opt/build/repo/node_modules/@tolgee/react/dist/tolgee-react.esm.js';
import { toast } from '/opt/build/repo/node_modules/react-toastify/dist/react-toastify.esm.mjs';
import axios from '/opt/build/repo/node_modules/axios/index.js';
import { useDebounce } from '/opt/build/repo/node_modules/use-debounce/dist/index.module.js';
import imageCompression from '/opt/build/repo/node_modules/browser-image-compression/dist/browser-image-compression.mjs';
import { v4 } from '/opt/build/repo/node_modules/uuid/dist/esm-browser/index.js';
import { createContext } from '/opt/build/repo/node_modules/@radix-ui/react-context/dist/index.mjs';
import { useComposedRefs } from '/opt/build/repo/node_modules/@radix-ui/react-compose-refs/dist/index.mjs';
import { Presence } from '/opt/build/repo/node_modules/@radix-ui/react-presence/dist/index.module.js';
import { useControllableState } from '/opt/build/repo/node_modules/@radix-ui/react-use-controllable-state/dist/index.mjs';
import { Primitive } from '/opt/build/repo/node_modules/@radix-ui/react-primitive/dist/index.mjs';
import { useSize } from '/opt/build/repo/node_modules/@radix-ui/react-use-size/dist/index.mjs';
import { Portal } from '/opt/build/repo/node_modules/@radix-ui/react-portal/dist/index.mjs';
import { DismissableLayer } from '/opt/build/repo/node_modules/@radix-ui/react-dismissable-layer/dist/index.mjs';
import { useLayoutEffect as useLayoutEffect$1 } from '/opt/build/repo/node_modules/@radix-ui/react-use-layout-effect/dist/index.mjs';
import * as ArrowPrimitive from '/opt/build/repo/node_modules/@radix-ui/react-arrow/dist/index.mjs';
import { useFloating, autoUpdate, inline, offset, flip, shift, limitShift, arrow, hide } from '/opt/build/repo/node_modules/@floating-ui/react-dom/dist/floating-ui.react-dom.mjs';
import BrokenImageIcon from '/opt/build/repo/node_modules/@mui/icons-material/BrokenImage.js';
import '/opt/build/repo/node_modules/katex/dist/katex.min.css';
import ReactMarkdown from '/opt/build/repo/node_modules/react-markdown/index.js';
import { Prism } from '/opt/build/repo/node_modules/react-syntax-highlighter/dist/esm/index.js';
import { oneLight } from '/opt/build/repo/node_modules/react-syntax-highlighter/dist/esm/styles/prism/index.js';
import rehypeKatex from '/opt/build/repo/node_modules/rehype-katex/index.js';
import rehypeRaw from '/opt/build/repo/node_modules/rehype-raw/index.js';
import remarkGfm from '/opt/build/repo/node_modules/remark-gfm/index.js';
import remarkMath from '/opt/build/repo/node_modules/remark-math/index.js';
import { CSSTransition } from '/opt/build/repo/node_modules/react-transition-group/esm/index.js';

var TokenEnum = /* @__PURE__ */ ((TokenEnum2) => {
  TokenEnum2["IMAGES"] = "images";
  TokenEnum2["WORDS"] = "words";
  TokenEnum2["MESSAGES"] = "messages";
  return TokenEnum2;
})(TokenEnum || {});

function ModalMenuItem({
  onClick,
  icon,
  text,
  isDangerous = false,
  onClose
}) {
  const handleClick = () => {
    onClose?.();
    if (onClose) {
      setTimeout(() => onClick(), 50);
    } else {
      onClick();
    }
  };
  return /* @__PURE__ */ jsxs(
    "div",
    {
      onClick: handleClick,
      className: classNames(
        "flex cursor-pointer items-center gap-3 border-b border-gray-100 px-5 py-4 transition-colors last:border-b-0 hover:bg-gray-50",
        isDangerous && "hover:bg-red-50"
      ),
      children: [
        /* @__PURE__ */ jsx("div", { className: classNames("flex shrink-0", isDangerous ? "text-brand-red" : "text-gray-700"), children: icon }),
        /* @__PURE__ */ jsx(
          "span",
          {
            className: classNames(
              "text-[15px] font-normal",
              isDangerous ? "text-brand-red" : "text-gray-900"
            ),
            children: text
          }
        )
      ]
    }
  );
}

function CheckBox({
  classes,
  id,
  checkBoxName,
  label,
  labelClasses,
  setChecked,
  containerClasses,
  checkBoxValue,
  size = 13,
  checkColor = "white",
  checkedBackgroundColor = "dark",
  title
}) {
  return /* @__PURE__ */ jsx("div", { className: classNames(containerClasses, "inline-flex items-center gap-[6px]"), children: /* @__PURE__ */ jsxs(
    "label",
    {
      className: "relative flex cursor-pointer items-center gap-[6px] rounded-full",
      htmlFor: id,
      "data-ripple-dark": "true",
      children: [
        /* @__PURE__ */ jsx(
          "input",
          {
            title,
            type: "checkbox",
            name: checkBoxName,
            className: classNames(
              classes,
              "before:content[''] before:bg-blue-gray-500 checked:border-brand-violet checked:before:bg-brand-violet peer relative h-[13px] w-[13px] cursor-pointer appearance-none rounded-[2px] border border-black border-opacity-50 bg-[#ffffff] transition-all  before:absolute before:left-2/4 before:top-2/4 before:block before:-translate-x-2/4 before:-translate-y-2/4 before:rounded-full before:opacity-0 before:transition-opacity hover:before:opacity-10",
              {
                "checked:bg-brand-violet": checkedBackgroundColor === "dark",
                "checked:bg-white": checkedBackgroundColor === "light"
              }
            ),
            style: { width: `${size}px`, height: `${size}px` },
            id,
            checked: checkBoxValue,
            onChange: (e) => setChecked({
              checkBoxName: e.target.name,
              checked: e.target.checked
            })
          }
        ),
        /* @__PURE__ */ jsx(
          "div",
          {
            className: "pointer-events-none absolute top-[49%] -translate-y-1/2 scale-90 opacity-0 transition-opacity peer-checked:opacity-100",
            style: { width: `${size}px`, height: `${size}px`, color: checkColor },
            children: /* @__PURE__ */ jsx(
              "svg",
              {
                xmlns: "http://www.w3.org/2000/svg",
                className: "flex  h-full w-full items-center justify-center",
                viewBox: "0 0 24 24",
                fill: "currentColor",
                stroke: "currentColor",
                strokeWidth: "1%",
                children: /* @__PURE__ */ jsx("path", { d: "M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" })
              }
            )
          }
        ),
        label ? /* @__PURE__ */ jsx("span", { className: classNames(labelClasses, "text-brand-body leading-[1.2em]"), children: label }) : null
      ]
    }
  ) });
}

function HelpButton({
  context,
  tooltipId,
  className,
  iconOnly = false,
  onClick = null,
  disableAction = false
}) {
  let { cursorMode, setCursorMode } = context;
  useEffect(() => {
    cursorMode = context.cursorMode;
  }, [context]);
  const handleClick = (e) => {
    if (!disableAction) changeMode();
    onClick && onClick(e);
  };
  const changeMode = () => {
    if (cursorMode === "DEFAULT") setCursorMode("HELP");
    else setCursorMode("DEFAULT");
  };
  if (iconOnly) {
    return /* @__PURE__ */ jsx(
      "div",
      {
        id: "header-help",
        "data-tooltip-id": tooltipId,
        onClick: handleClick,
        className: classNames(
          cursorMode === "HELP" ? "text-brand-green" : "text-brand-header-text",
          className
        ),
        children: /* @__PURE__ */ jsx(Help, { style: { cursor: "pointer" } })
      }
    );
  }
  return /* @__PURE__ */ jsxs(
    "button",
    {
      id: "header-help",
      type: "button",
      onClick: handleClick,
      className: classNames(
        cursorMode === "HELP" ? "text-brand-green" : "text-brand-header-text",
        "group flex w-full gap-x-3 rounded-xl p-2 text-left text-[15px] leading-6 transition duration-300",
        className
      ),
      children: [
        /* @__PURE__ */ jsx(Help, { style: { cursor: "pointer" } }),
        "Help"
      ]
    }
  );
}

function StyledTooltip(props) {
  return /* @__PURE__ */ jsxs(
    Tooltip,
    {
      disableStyleInjection: "core",
      ref: props.tooltipRef,
      id: props.id,
      style: {
        maxWidth: "300px",
        background: "#6363e5",
        zIndex: 999,
        borderRadius: "10px",
        padding: "14px"
      },
      className: "rounded-[10px]",
      clickable: props.clickable,
      children: [
        props.title && /* @__PURE__ */ jsx("h3", { className: "mb-2.5 text-[14px]/none font-bold", children: props.title }),
        props.content && /* @__PURE__ */ jsx("p", { className: "text-[13px]/4", children: props.content }),
        props.actions && /* @__PURE__ */ jsx("div", { className: "mt-2.5 flex flex-col text-[13px]/4", children: props.actions }),
        props.children
      ]
    }
  );
}

const baseStyles$5 = {
  solid: "group inline-flex items-center justify-center rounded-[10px] py-[14px] px-8 text-lg font-semibold focus:outline-none focus-visible:outline-2 focus-visible:outline-offset-2",
  outline: "group inline-flex ring-1 items-center justify-center rounded-full py-2 px-4 text-sm focus:outline-none",
  small: "group inline-flex items-center justify-center rounded-xl px-3.5 py-2.5 text-sm shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
};
const variantStyles = {
  solid: {
    none: "text-brand-text-primary",
    slate: "bg-slate-900 text-brand-text-primary hover:bg-slate-700 hover:text-slate-100 active:bg-slate-800 active:text-slate-300 focus-visible:outline-slate-900",
    teal: "bg-brand-green text-brand-text-primary hover:text-slate-100 hover:bg-teal-500 active:bg-teal-800 active:text-teal-100 focus-visible:outline-teal-600",
    green: "bg-brand-green text-brand-text-primary hover:bg-brand-green-light active:bg-brand-green-light",
    violet: "bg-brand-microbutton-solid-bg text-brand-text-primary hover:bg-brand-microbutton-solid-bg-highlight active:bg-brand-violet-light",
    white: "bg-white text-slate-900 hover:bg-teal-50 active:bg-teal-200 active:text-slate-600 focus-visible:outline-white",
    gray: "bg-[#36363612] text-brand-gray-dark hover:bg-[#36363622]",
    pink: "bg-brand-pink text-brand-text-primary",
    dark: "bg-brand-body text-brand-text-primary hover:bg-[#363636db] hover:text-slate-100 active:bg-slate-800 active:text-slate-300 focus-visible:outline-slate-900",
    red: "bg-brand-red text-brand-text-primary hover:opacity-90"
  },
  outline: {
    slate: "ring-slate-200 text-slate-700 hover:text-slate-900 hover:ring-slate-300 active:bg-slate-100 active:text-slate-600 focus-visible:outline-teal-600 focus-visible:ring-slate-300",
    white: "ring-slate-700 text-brand-text-primary hover:ring-slate-500 active:ring-slate-700 active:text-slate-400 focus-visible:outline-white"
  },
  small: {
    none: "text-brand-text-primary",
    green: "bg-brand-green text-brand-text-primary hover:bg-brand-green-light active:bg-brand-green-light",
    pink: "bg-brand-pink text-brand-text-primary",
    dark: "bg-brand-microbutton-solid-bg text-brand-text-primary",
    grey: "bg-brand-grey text-brand-body hover:bg-brand-grey-dark",
    greyToViolet: "bg-brand-body bg-opacity-10 text-brand-body hover:bg-brand-violet active:bg-brand-violet hover:text-brand-text-primary active:text-brand-text-primary",
    violet: "bg-brand-violet text-brand-text-primary hover:bg-brand-violet-light active:bg-brand-violet-light",
    yellow: "bg-orange-300 text-brand-text-primary hover:opacity-80 active:bg-orange-400",
    red: "bg-brand-red text-brand-text-primary hover:opacity-80"
  }
};
const Button = memo(function Button2({ variant, color, className, ...props }) {
  const buttonVariant = variant ?? "solid";
  const buttonColor = color ?? "none";
  const buttonClassName = classNames(
    "disabled:opacity-50 disabled:pointer-events-none",
    baseStyles$5[buttonVariant],
    variantStyles[buttonVariant][buttonColor],
    className
  );
  return typeof props.href === "undefined" ? /* @__PURE__ */ jsx("button", { type: "button", className: buttonClassName, ...props }) : /* @__PURE__ */ jsx("a", { className: buttonClassName, ...props });
});

function Header({
  words,
  tokens,
  images,
  messages,
  plan,
  email,
  avatar,
  isOwner,
  logo,
  setMobileMenuOpen,
  handleOpenFeedbackModal,
  upgradeButtonText,
  translations,
  langSelector,
  cursorModeContext,
  helpTranslations,
  docsUrl,
  logoUrl,
  isLayoutLarge,
  helpMenuData,
  limits,
  isShowHelp = true,
  isShowUpgrade = true,
  t,
  pwaInstall,
  AssistantWidget,
  upgradeButtonColor = "green",
  isHideHeader = false,
  menuId = "app-menu"
}) {
  const emailEl = useRef(null);
  const optionsEl = useRef(null);
  const tooltip = useRef();
  const navigate = useNavigate();
  const [activeAvatar, setActiveAvatar] = useState(avatar);
  const [headerOffset, setHeaderOffset] = useState(0);
  const [isEmailShown, setIsEmailShown] = useState(false);
  const [emailTimeout, setEmailTimeout] = useState(0);
  const [helpAnchorEl, setHelpAnchorEl] = useState(null);
  const open = Boolean(helpAnchorEl);
  const handleHelpClick = (event) => {
    setHelpAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setHelpAnchorEl(null);
  };
  const tokenType = tokens;
  let tokensRemaining;
  if (tokens === TokenEnum.WORDS) tokensRemaining = words;
  if (tokens === TokenEnum.IMAGES) tokensRemaining = images;
  if (tokens === TokenEnum.MESSAGES) tokensRemaining = messages;
  useEffect(() => {
    const tooltipShown = Number(localStorage.getItem("tooltipShown"));
    if (tooltip.current && tooltipShown < 3) {
      tooltip.current.open({ delay: 1e3 });
      const timeout = setTimeout(() => tooltip.current?.close(), 8e3);
      localStorage.setItem("tooltipShown", String(tooltipShown + 1));
      return () => clearTimeout(timeout);
    }
    return () => {
    };
  }, []);
  useLayoutEffect(() => {
    if (emailEl.current) {
      setHeaderOffset(-emailEl.current.offsetWidth + 55);
    }
  }, [langSelector]);
  function tokensBelowThreshold() {
    if (tokensRemaining == null) return false;
    if (!limits[tokenType] || tokensRemaining > limits[tokenType] * 0.6) return false;
    return true;
  }
  let upgradeColor = upgradeButtonColor;
  if (!upgradeButtonColor) {
    if (tokensBelowThreshold()) {
      upgradeColor = "pink";
    } else {
      upgradeColor = "green";
    }
  }
  const planInfo = /* @__PURE__ */ jsxs(Fragment, { children: [
    plan ?? "",
    " ",
    translations.plan,
    " |",
    " ",
    t("plan-limit-text", `{numLeft} {tokenType} left`, {
      numLeft: Math.max(tokensRemaining, 0),
      tokenType: t(`header-token-type-${tokenType}`, tokenType)
    })
  ] });
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      "header",
      {
        className: classNames(
          "bg-brand-header z-[998] h-[var(--header-height)] w-[100vw] overflow-x-clip rounded-b-[6px]",
          isHideHeader && "hidden md:block"
        ),
        children: /* @__PURE__ */ jsxs("nav", { className: "flex h-full items-center justify-between py-2", "aria-label": "Global", children: [
          /* @__PURE__ */ jsx("div", { className: "flex h-[var(--header-height)] w-36 shrink-0 items-center lg:w-[12.5rem]", children: /* @__PURE__ */ jsx("a", { href: logoUrl ?? "/", children: logo }) }),
          isLayoutLarge ? /* @__PURE__ */ jsxs("div", { className: "relative hidden lg:block", children: [
            email && /* @__PURE__ */ jsx(
              "button",
              {
                type: "button",
                className: "bg-brand-header peer relative z-50 flex h-[59px] w-auto cursor-default flex-col justify-center rounded-br-[6px] p-3 px-4",
                onMouseEnter: () => {
                  if (emailEl.current && optionsEl.current) {
                    clearTimeout(emailTimeout);
                    setIsEmailShown(true);
                    setHeaderOffset(70);
                  }
                },
                onMouseLeave: () => {
                  if (emailEl.current) {
                    clearTimeout(emailTimeout);
                    const id = setTimeout(() => {
                      setIsEmailShown(false);
                    }, 200);
                    setEmailTimeout(id);
                    setHeaderOffset(-emailEl.current.offsetWidth + 55);
                  }
                },
                children: AssistantWidget
              }
            ),
            /* @__PURE__ */ jsxs(
              "div",
              {
                className: classNames(
                  email ? "absolute top-[10px] flex items-center gap-x-4" : "mr-4 flex items-center gap-x-4",
                  tokensRemaining !== null && "transition-all duration-200"
                ),
                style: { right: `${tokensBelowThreshold() ? 70 : headerOffset}px` },
                children: [
                  /* @__PURE__ */ jsxs("div", { ref: optionsEl, className: "flex items-center gap-4", children: [
                    isShowHelp && /* @__PURE__ */ jsxs(Fragment, { children: [
                      /* @__PURE__ */ jsx(
                        HelpButton,
                        {
                          disableAction: true,
                          onClick: handleHelpClick,
                          context: cursorModeContext,
                          tooltipId: "main-help-tooltip",
                          iconOnly: true,
                          className: "header-help ml-auto"
                        }
                      ),
                      /* @__PURE__ */ jsx(
                        StyledTooltip,
                        {
                          tooltipRef: tooltip,
                          id: "main-help-tooltip",
                          title: helpTranslations.title,
                          content: helpTranslations.descriptionDesktop,
                          "data-tooltip-hidden": true,
                          clickable: true
                        }
                      )
                    ] }),
                    isShowUpgrade && isOwner && tokensRemaining !== null && /* @__PURE__ */ jsx(Link, { to: "/account/plans", className: "whitespace-nowrap", children: /* @__PURE__ */ jsx(Button, { variant: "small", color: upgradeColor, children: upgradeButtonText }) }),
                    langSelector ? /* @__PURE__ */ jsx(Fragment, { children: langSelector }) : null
                  ] }),
                  email ? /* @__PURE__ */ jsxs(
                    "div",
                    {
                      className: classNames(
                        "text-brand-header-text text-end",
                        !isEmailShown && !tokensBelowThreshold() && "invisible"
                      ),
                      children: [
                        /* @__PURE__ */ jsx("div", { ref: emailEl, className: "h-[20px] text-base", children: email ?? "" }),
                        /* @__PURE__ */ jsx("div", { className: "overflow-hidden text-ellipsis whitespace-nowrap text-sm", children: /* @__PURE__ */ jsx("div", { children: planInfo }) })
                      ]
                    }
                  ) : /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-x-2", children: [
                    pwaInstall,
                    /* @__PURE__ */ jsx(Button, { color: "red", variant: "small", onClick: () => navigate("/signin"), children: t("sign-in", "Sign in") })
                  ] })
                ]
              }
            )
          ] }) : /* @__PURE__ */ jsxs("div", { className: "flex min-w-0 items-center justify-end gap-2", children: [
            langSelector ? /* @__PURE__ */ jsx(Fragment, { children: langSelector }) : null,
            isShowHelp && /* @__PURE__ */ jsxs(Fragment, { children: [
              /* @__PURE__ */ jsx(
                HelpButton,
                {
                  disableAction: true,
                  onClick: handleHelpClick,
                  context: cursorModeContext,
                  tooltipId: "mobile-help-tooltip",
                  iconOnly: true,
                  className: "header-help ml-auto"
                }
              ),
              /* @__PURE__ */ jsx(
                StyledTooltip,
                {
                  id: "mobile-help-tooltip",
                  title: helpTranslations.title,
                  content: helpTranslations.descriptionMobile
                }
              )
            ] }),
            AssistantWidget,
            /* @__PURE__ */ jsx(
              IonMenuButton,
              {
                menu: menuId,
                className: "text-brand-header-text inline-flex items-center justify-center rounded-md p-2.5 pl-0",
                onClick: () => setMobileMenuOpen?.((prev) => !prev),
                children: /* @__PURE__ */ jsx(Menu$1, { className: "h-6 w-6", "aria-hidden": "true" })
              }
            )
          ] })
        ] })
      }
    ),
    isShowHelp && /* @__PURE__ */ jsxs(
      Popover,
      {
        anchorEl: helpAnchorEl,
        open,
        onClose: handleClose,
        className: "mt-2",
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "center"
        },
        transformOrigin: {
          vertical: "top",
          horizontal: "center"
        },
        children: [
          /* @__PURE__ */ jsxs("div", { children: [
            /* @__PURE__ */ jsx("div", { className: "px-2 pt-2 font-medium", children: helpTranslations.helpMode }),
            /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-2 px-3 pt-2", children: [
              /* @__PURE__ */ jsx(
                CheckBox,
                {
                  id: "help-mode",
                  size: 15,
                  checkBoxName: "help-mode",
                  checkBoxValue: cursorModeContext.cursorMode === "HELP",
                  setChecked: () => cursorModeContext.cursorMode === "DEFAULT" ? cursorModeContext.setCursorMode("HELP") : cursorModeContext.setCursorMode("DEFAULT")
                }
              ),
              /* @__PURE__ */ jsx("label", { htmlFor: "help-mode", className: "cursor-pointer select-none", children: helpTranslations.helpModeLabel })
            ] })
          ] }),
          /* @__PURE__ */ jsx("div", { className: "my-2 w-full border-b" }),
          /* @__PURE__ */ jsx("div", { className: "px-2 font-medium", children: helpTranslations.startTour }),
          helpMenuData.map((item, id) => /* @__PURE__ */ jsx("div", { children: item.children ? /* @__PURE__ */ jsx(NestedMenuItem, { label: item.name, parentMenuOpen: open, children: item.children.map((child, id2) => /* @__PURE__ */ jsx(
            IconMenuItem,
            {
              onClick: () => {
                handleClose();
                navigate(child.href + "?tour=1");
              },
              label: child.name
            },
            id2
          )) }) : /* @__PURE__ */ jsx(
            IconMenuItem,
            {
              onClick: () => {
                handleClose();
                navigate(item.href + "?tour=1");
              },
              label: item.name
            }
          ) }, id)),
          /* @__PURE__ */ jsx("div", { className: "my-2 w-full border-b" }),
          /* @__PURE__ */ jsxs("div", { className: "px-2 pb-2 font-medium", children: [
            /* @__PURE__ */ jsx(
              "div",
              {
                onClick: () => {
                  handleOpenFeedbackModal?.(true, true);
                  handleClose();
                },
                className: "cursor-pointer",
                children: helpTranslations.feedback
              }
            ),
            /* @__PURE__ */ jsx(
              "a",
              {
                href: docsUrl,
                target: "_blank",
                rel: "noreferrer",
                onClick: () => {
                  handleClose();
                },
                children: helpTranslations.docs
              }
            )
          ] })
        ]
      }
    )
  ] });
}

function getWindowDimensions() {
  if (typeof window !== 'undefined') {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    }
  }
}

function useWindowDimensions() {
  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize)
  }, []);

  return windowDimensions
}

const NavIcon = ({
  icon: Icon,
  variant,
  isActive
}) => {
  if (!Icon) return null;
  const isMobileVariant = variant === "mobile";
  const size = isMobileVariant ? 22 : 20;
  return /* @__PURE__ */ jsx(
    Icon,
    {
      className: classNames(
        "shrink-0 transition-all duration-300",
        isActive ? "text-brand-navbar-text-highlight fill-brand-navbar-text-highlight" : "text-brand-navbar-text group-hover:text-brand-navbar-text-highlight fill-brand-navbar-text group-hover:fill-brand-navbar-text-highlight"
      ),
      "aria-hidden": "true",
      width: size,
      height: size,
      sx: {
        width: size,
        height: size
      }
    }
  );
};

const NavClickable = ({
  link,
  action,
  onClick,
  className,
  children,
  id
}) => {
  const navigate = useNavigate();
  const handleNavigation = async (e) => {
    e.preventDefault();
    menuController.close();
    onClick?.();
    if (link) {
      navigate(link);
    }
  };
  if (link) {
    return /* @__PURE__ */ jsx(
      "div",
      {
        id,
        onClick: handleNavigation,
        className: classNames(className, "whitespace-nowrap", "cursor-pointer"),
        children
      }
    );
  }
  if (action) {
    return /* @__PURE__ */ jsx(
      "div",
      {
        id,
        onClick: async () => {
          await menuController.close();
          action();
          onClick?.();
        },
        className: classNames(className, "whitespace-nowrap"),
        children
      }
    );
  }
  return null;
};

function normalizeNavPath(path) {
  if (!path) return path;
  return path.split("/").map((segment) => {
    if (!segment) return segment;
    try {
      return decodeURIComponent(segment);
    } catch {
      return segment;
    }
  }).join("/");
}
function navPathsEqual(a, b) {
  return normalizeNavPath(a) === normalizeNavPath(b);
}
function navPathStartsWith(pathname, prefix) {
  if (!prefix) return false;
  const p = normalizeNavPath(pathname);
  const pre = normalizeNavPath(prefix);
  return p === pre || p.startsWith(`${pre}/`);
}
function AppNav({
  items,
  profileItems = [],
  settingsItems = [],
  bottomItem,
  avatar,
  tokens,
  limits,
  images,
  plan,
  words,
  email,
  isOwner,
  setMobileMenuOpen,
  upgradeButtonText,
  translations,
  langSelector,
  messages,
  t,
  links,
  menuId = "app-menu",
  contentId = "main-content"
}) {
  const { width } = useWindowDimensions();
  const accountRef = useRef(null);
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const isMobile = width < 1024;
  const tokenType = tokens;
  let tokensRemaining = 0;
  if (tokens === TokenEnum.WORDS) tokensRemaining = words;
  if (tokens === TokenEnum.IMAGES) tokensRemaining = images;
  if (tokens === TokenEnum.MESSAGES) tokensRemaining = messages;
  const [isOpen, setIsOpen] = useState(localStorage.getItem("isNavOpen") === "true");
  const [expandedSections, setExpandedSections] = useState(() => {
    try {
      const stored = localStorage.getItem("navExpandedSections");
      return stored ? JSON.parse(stored) : {};
    } catch {
      return {};
    }
  });
  useEffect(() => {
    localStorage.setItem("navExpandedSections", JSON.stringify(expandedSections));
  }, [expandedSections]);
  useEffect(() => {
    localStorage.setItem("isNavOpen", isOpen.toString());
  }, [isOpen]);
  useEffect(() => {
    if (width < 1024) setIsOpen(true);
  }, [width]);
  useLayoutEffect(() => {
    settingsItems.forEach((item, index) => {
      if (item.dropDown) {
        const isActive = item.link && navPathsEqual(item.link, pathname) || item.dropDown?.some((el) => el.link && navPathStartsWith(pathname, el.link));
        if (isActive) {
          setExpandedSections((prev) => ({
            ...prev,
            [`settings-${index}`]: true
          }));
        }
      }
    });
  }, [pathname]);
  const navItems = items.map((item) => {
    const isActive = item.link && navPathsEqual(item.link, pathname) || item.dropDown?.some((el) => el.link && navPathsEqual(el.link, pathname)) || item.dropDown && item.link && navPathStartsWith(pathname, item.link);
    return { ...item, current: isActive };
  });
  async function handleClose() {
    await menuController.close();
    localStorage.setItem("isMobileMenuOpen", "false");
    setMobileMenuOpen?.(false);
  }
  function toggleAccordion(key) {
    setExpandedSections((prev) => ({ ...prev, [key]: !prev[key] }));
    setTimeout(() => {
      const element = document.getElementById(key);
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "nearest" });
      }
    }, 300);
  }
  function tokensBelowThreshold() {
    return true;
  }
  const getProgressPercentage = () => {
    const max = limits[tokenType] || 1e3;
    return Math.min(tokensRemaining / max * 100, 100);
  };
  let planInfo;
  const isLowOnTokens = tokensBelowThreshold();
  if (isLowOnTokens) {
    planInfo = /* @__PURE__ */ jsxs("div", { className: "flex flex-col", children: [
      /* @__PURE__ */ jsxs("div", { children: [
        plan ?? "",
        " ",
        translations.plan
      ] }),
      /* @__PURE__ */ jsx("div", { children: t("plan-limit-text", `{numLeft} {tokenType} left`, {
        numLeft: Math.max(tokensRemaining, 0),
        tokenType: t(`header-token-type-${tokenType}`, tokenType)
      }) })
    ] });
  } else {
    planInfo = `${plan ?? ""} ${translations.plan}`;
  }
  const renderNavItem = (item, index, variant, keyPrefix = "nav") => {
    const isMobileVariant = variant === "mobile";
    const isActive = item.current ?? (item.link ? navPathStartsWith(pathname, item.link) : false);
    if (isMobileVariant) {
      if (item.dropDown) return null;
      return /* @__PURE__ */ jsxs(
        NavClickable,
        {
          id: item.tourId,
          link: item.link,
          action: item.action,
          onClick: handleClose,
          className: classNames(
            "mx-2 flex cursor-pointer  items-center gap-4 rounded-xl px-5 py-2.5 text-[15px] font-medium text-[#534b4f] no-underline transition-all duration-200",
            isActive ? "text-brand-navbar-text-highlight bg-brand-navbar-highlight font-semibold" : "hover:text-brand-navbar-text-highlight hover:bg-brand-navbar-highlight"
          ),
          children: [
            /* @__PURE__ */ jsx(NavIcon, { icon: item.icon, variant, isActive }),
            item.label
          ]
        },
        `${keyPrefix}-${index}`
      );
    }
    return /* @__PURE__ */ jsx(
      "li",
      {
        className: classNames(
          "text-brand-navbar-text relative text-nowrap px-[11px] text-left transition-all"
        ),
        children: /* @__PURE__ */ jsxs(
          NavClickable,
          {
            id: item.tourId,
            link: item.link,
            action: item.action,
            className: classNames(
              "group flex h-[40px] w-full items-center gap-x-3 rounded-xl p-2 text-left text-[15px] leading-6 transition-all duration-300",
              isActive ? "bg-brand-navbar-highlight text-brand-navbar-text-highlight" : "hover:bg-brand-navbar-highlight hover:text-brand-navbar-text-highlight"
            ),
            children: [
              /* @__PURE__ */ jsx(NavIcon, { icon: item.icon, variant, isActive }),
              isOpen ? item.label : void 0
            ]
          }
        )
      },
      `${keyPrefix}-${index}`
    );
  };
  const renderAccordionItem = (item, index, variant) => {
    const isMobileVariant = variant === "mobile";
    const accordionKey = `settings-${index}`;
    const isExpanded = expandedSections[accordionKey];
    const isActive = item.link && navPathsEqual(item.link, pathname) || item.dropDown?.some((el) => el.link && navPathStartsWith(pathname, el.link));
    const handleAccordionClick = () => {
      if (isMobileVariant) {
        toggleAccordion(accordionKey);
      } else if (isOpen) {
        setExpandedSections((prev) => ({ ...prev, [accordionKey]: !prev[accordionKey] }));
      } else {
        setIsOpen(true);
        localStorage.setItem("isNavOpen", "true");
        setTimeout(() => setExpandedSections((prev) => ({ ...prev, [accordionKey]: true })), 100);
      }
    };
    if (!item.dropDown) {
      return renderNavItem(item, index, variant, "settings");
    }
    const ExpandIcon = isExpanded ? ExpandLess : ExpandMore;
    if (isMobileVariant) {
      return /* @__PURE__ */ jsxs("div", { id: accordionKey, className: "border-t border-black/[0.03]", children: [
        /* @__PURE__ */ jsxs(
          "div",
          {
            onClick: handleAccordionClick,
            className: classNames(
              "flex cursor-pointer items-center justify-between px-6 py-3 text-[15px] font-medium text-[#534b4f] transition-colors hover:bg-[#fafafa]",
              isExpanded && "bg-[#fafafa]"
            ),
            children: [
              /* @__PURE__ */ jsx("span", { children: item.label }),
              /* @__PURE__ */ jsx(ExpandIcon, { className: "h-5 w-5 text-[#888888]" })
            ]
          }
        ),
        /* @__PURE__ */ jsx(
          "div",
          {
            className: classNames(
              "overflow-hidden bg-[#fafafa] transition-all duration-300",
              isExpanded ? "max-h-[500px] pb-3" : "max-h-0"
            ),
            children: item.dropDown.filter((s) => !s.hidden).map(
              (subItem, i) => subItem.divider ? /* @__PURE__ */ jsx("hr", { className: "mx-5 my-1 border-black/5" }, i) : /* @__PURE__ */ jsx(
                NavClickable,
                {
                  link: subItem.link,
                  action: subItem.action,
                  onClick: handleClose,
                  className: classNames(
                    "hover:text-brand-red block cursor-pointer px-6 py-2.5 pl-9 text-[14px] font-normal text-[#888888] no-underline transition-colors",
                    subItem.link && navPathStartsWith(pathname, subItem.link) ? "text-brand-red font-normal" : "font-light opacity-70"
                  ),
                  children: subItem.label
                },
                i
              )
            )
          }
        )
      ] }, accordionKey);
    }
    if (!isOpen) return null;
    return /* @__PURE__ */ jsxs(
      "li",
      {
        id: accordionKey,
        className: "text-brand-navbar-text relative text-nowrap text-left",
        children: [
          /* @__PURE__ */ jsxs(
            "div",
            {
              onClick: handleAccordionClick,
              className: classNames(
                "flex cursor-pointer items-center justify-between px-[11px] transition-all",
                isActive || isExpanded ? "bg-[#fafafa]" : "hover:bg-[#fafafa]"
              ),
              children: [
                /* @__PURE__ */ jsxs(
                  "button",
                  {
                    type: "button",
                    className: "group flex h-[40px] w-full items-center gap-x-3 rounded-xl p-2 text-left text-[15px] leading-6 transition-all duration-300",
                    children: [
                      /* @__PURE__ */ jsx(NavIcon, { icon: item.icon, variant }),
                      isOpen ? item.label : void 0
                    ]
                  }
                ),
                isOpen && /* @__PURE__ */ jsx(ExpandIcon, { className: "text-brand-navbar-text mr-2 h-5 w-5" })
              ]
            }
          ),
          isOpen && /* @__PURE__ */ jsx(
            "ul",
            {
              className: classNames(
                "overflow-hidden bg-[#fafafa] transition-all duration-300",
                isExpanded ? "max-h-[500px] pb-2" : "max-h-0"
              ),
              children: item.dropDown.filter((s) => !s.hidden).map((subItem, i) => /* @__PURE__ */ jsx(
                "li",
                {
                  className: classNames(
                    "text-brand-navbar-text hover:text-brand-navbar-text-highlight cursor-pointer text-[13px]",
                    subItem.link && navPathStartsWith(pathname, subItem.link) ? "text-brand-navbar-text-highlight font-normal" : "font-light opacity-70"
                  ),
                  children: /* @__PURE__ */ jsx(
                    NavClickable,
                    {
                      link: subItem.link,
                      action: subItem.action,
                      className: "line-clamp-2 block w-full min-w-[165px] px-5 py-1.5 pl-10",
                      children: subItem.label
                    }
                  )
                },
                i
              ))
            }
          )
        ]
      },
      accordionKey
    );
  };
  const renderSectionLabel = (labelKey, defaultLabel, variant) => {
    if (variant === "mobile") {
      return /* @__PURE__ */ jsx("div", { className: "mb-2 mt-8 whitespace-nowrap px-5 text-[11px] font-bold uppercase tracking-[1.5px] text-[#888888] ", children: t(labelKey, defaultLabel) });
    }
    return /* @__PURE__ */ jsx(
      "div",
      {
        className: classNames(
          "text-brand-navbar-text whitespace-nowrap px-4 text-[10px] font-bold uppercase tracking-[1px] opacity-60 transition-all",
          isOpen ? "mb-1 h-[15px]" : "mb-0 h-0 overflow-hidden"
        ),
        children: t(labelKey, defaultLabel)
      }
    );
  };
  const getProgressColor = (progressPercent) => {
    if (progressPercent < 30) return "bg-brand-red";
    if (progressPercent < 70) return "bg-brand-orange";
    return "bg-brand-green";
  };
  if (isMobile)
    return /* @__PURE__ */ jsx(IonMenu, { menuId, contentId, side: "end", swipeGesture: true, children: /* @__PURE__ */ jsxs(
      "div",
      {
        className: "flex h-full flex-col overflow-y-auto bg-white",
        style: {
          paddingTop: Capacitor.getPlatform() === "ios" ? "0" : "max(var(--ion-safe-area-top), 1em)"
        },
        children: [
          /* @__PURE__ */ jsxs("div", { className: "flex-1", children: [
            email ? /* @__PURE__ */ jsxs("div", { className: "mx-5 mb-2 mt-1 rounded-[20px] border border-[#e6e2de] bg-white p-4 shadow-[0_3px_8px_rgba(0,0,0,0.08)]", children: [
              /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-3", children: [
                avatar ? /* @__PURE__ */ jsx(
                  "img",
                  {
                    src: avatar,
                    alt: "User",
                    className: "h-12 w-12 rounded-full object-cover",
                    referrerPolicy: "no-referrer"
                  }
                ) : /* @__PURE__ */ jsx("div", { className: "flex h-12 w-12 items-center justify-center rounded-full bg-[#f5f0ec] text-[#534b4f]", children: email?.charAt(0).toUpperCase() }),
                /* @__PURE__ */ jsxs("div", { className: "flex min-w-0 flex-1 flex-col", children: [
                  /* @__PURE__ */ jsx("span", { className: "truncate text-sm font-semibold text-[#534b4f]", children: email }),
                  /* @__PURE__ */ jsx("span", { className: "mt-0.5 text-xs text-[#888888]", children: planInfo }),
                  /* @__PURE__ */ jsx("div", { className: "mt-1.5 h-1.5 w-full overflow-hidden rounded-[3px] bg-[#eee]", children: /* @__PURE__ */ jsx(
                    "div",
                    {
                      className: classNames(
                        "h-full rounded-[3px] transition-all duration-300",
                        getProgressColor(getProgressPercentage())
                      ),
                      style: { width: `${getProgressPercentage()}%` }
                    }
                  ) })
                ] })
              ] }),
              isOwner && plan === "Free" && /* @__PURE__ */ jsx(
                "button",
                {
                  type: "button",
                  onClick: () => {
                    handleClose();
                    navigate("/account/plans");
                  },
                  className: classNames(
                    "mt-3 w-full cursor-pointer rounded-[10px] border-none px-2.5 py-2.5 text-center text-[13px] font-semibold text-white transition-colors",
                    isLowOnTokens ? "bg-brand-red hover:bg-brand-red-dark" : "bg-brand-green hover:bg-brand-green-dark"
                  ),
                  children: upgradeButtonText
                }
              )
            ] }) : null,
            /* @__PURE__ */ jsx("div", { className: "mb-2 mt-4 px-5 text-[11px] font-bold uppercase tracking-[1.5px] text-[#888888]", children: t("nav-section-learning", "Learning") }),
            navItems.map((item, index) => renderNavItem(item, index, "mobile")),
            email && profileItems.length > 0 && /* @__PURE__ */ jsxs(Fragment, { children: [
              renderSectionLabel("nav-section-my-space", "My space", "mobile"),
              (() => {
                const result = [];
                for (let i = 0; i < profileItems.length; i++) {
                  const item = profileItems[i];
                  const nextItem = profileItems[i + 1];
                  if (item.tourGroupId && nextItem?.tourGroupId === item.tourGroupId) {
                    result.push(
                      /* @__PURE__ */ jsxs("div", { id: item.tourGroupId, children: [
                        renderNavItem(item, i, "mobile", "profile"),
                        renderNavItem(nextItem, i + 1, "mobile", "profile")
                      ] }, `profile-group-${i}`)
                    );
                    i++;
                  } else {
                    result.push(
                      /* @__PURE__ */ jsx(Fragment$1, { children: renderNavItem(item, i, "mobile", "profile") }, `profile-${i}`)
                    );
                  }
                }
                return result;
              })()
            ] }),
            email && settingsItems.length > 0 && /* @__PURE__ */ jsxs(Fragment, { children: [
              /* @__PURE__ */ jsx("div", { className: "mt-8" }),
              settingsItems.map((item, index) => renderAccordionItem(item, index, "mobile"))
            ] }),
            !email && /* @__PURE__ */ jsxs("div", { className: "mt-8 flex flex-col items-center gap-4 px-5", children: [
              langSelector && /* @__PURE__ */ jsx("div", { className: "w-full", children: langSelector }),
              /* @__PURE__ */ jsx(
                Button,
                {
                  color: "red",
                  variant: "small",
                  onClick: () => {
                    handleClose();
                    navigate("/signup");
                  },
                  className: "w-full",
                  children: t("sign-up", "Sign up")
                }
              ),
              /* @__PURE__ */ jsx(
                Button,
                {
                  color: "grey",
                  variant: "small",
                  onClick: () => {
                    handleClose();
                    navigate("/signin");
                  },
                  className: "w-full",
                  children: t("sign-in", "Sign in")
                }
              ),
              links && links.length > 0 && /* @__PURE__ */ jsx("div", { className: "mt-4 flex flex-col gap-2", children: links.map((link) => /* @__PURE__ */ jsx(
                "a",
                {
                  href: link.href,
                  target: "_blank",
                  rel: "noopener noreferrer",
                  className: "hover:text-brand-red text-sm font-medium text-[#534b4f] no-underline",
                  children: link.label
                },
                link.href
              )) })
            ] })
          ] }),
          /* @__PURE__ */ jsx("div", { className: "mt-auto flex flex-col gap-2.5 border-t border-[#eee] bg-[#fafafa] px-5 py-5", children: bottomItem.map((item, i) => /* @__PURE__ */ jsx(Fragment$1, { children: item.link ? /* @__PURE__ */ jsxs(
            "a",
            {
              href: item.link,
              target: "_blank",
              rel: "noopener noreferrer",
              className: "hover:text-brand-red flex cursor-pointer items-center gap-1.5 py-1 text-[12px] text-[#999] no-underline transition-colors",
              children: [
                item.image && /* @__PURE__ */ jsx("img", { src: item.image, alt: "", className: "h-[18px] w-[18px] shrink-0" }),
                item.icon && /* @__PURE__ */ jsx(item.icon, { className: "h-[18px] w-[18px] shrink-0" }),
                item.label
              ]
            }
          ) : /* @__PURE__ */ jsxs(
            "div",
            {
              onClick: async () => {
                await menuController.close();
                item.action?.();
              },
              className: "hover:text-brand-red flex cursor-pointer items-center gap-1.5 py-1 text-[12px] text-[#999] transition-colors",
              children: [
                item.icon && /* @__PURE__ */ jsx(item.icon, { className: "h-[18px] w-[18px] shrink-0" }),
                item.label
              ]
            }
          ) }, i)) })
        ]
      }
    ) });
  return /* @__PURE__ */ jsxs(
    "div",
    {
      id: "scrollableDiv",
      className: classNames(
        "bg-brand-navbar hidden h-full overflow-y-auto overflow-x-clip transition-all duration-300 lg:flex lg:flex-col",
        isOpen ? "w-[12.5rem]" : "w-[3.6rem]"
      ),
      children: [
        /* @__PURE__ */ jsx("div", { className: "flex grow flex-col", children: /* @__PURE__ */ jsxs("nav", { className: "flex flex-1 flex-col pt-2", children: [
          /* @__PURE__ */ jsx(
            "button",
            {
              className: classNames(
                "text-brand-navbar-text mb-2 hidden lg:block",
                isOpen ? "self-end pr-4" : "self-center"
              ),
              type: "button",
              onClick: () => setIsOpen((prev) => !prev),
              children: isOpen ? /* @__PURE__ */ jsx(ChevronLeft, {}) : /* @__PURE__ */ jsx(ChevronRight, {})
            }
          ),
          renderSectionLabel("nav-section-learning", "Learning", "desktop"),
          /* @__PURE__ */ jsx("ul", { className: "space-y-0.5", children: navItems.map((item, index) => renderNavItem(item, index, "desktop")) }),
          email && profileItems.length > 0 && /* @__PURE__ */ jsxs(Fragment, { children: [
            /* @__PURE__ */ jsx("hr", { className: "border-brand-navbar-separator my-3" }),
            renderSectionLabel("nav-section-my-space", "My space", "desktop"),
            /* @__PURE__ */ jsx("ul", { className: "space-y-0.5", children: (() => {
              const result = [];
              for (let i = 0; i < profileItems.length; i++) {
                const item = profileItems[i];
                const nextItem = profileItems[i + 1];
                if (item.tourGroupId && nextItem?.tourGroupId === item.tourGroupId) {
                  const isActive1 = item.link ? navPathStartsWith(pathname, item.link) : false;
                  const isActive2 = nextItem?.link ? navPathStartsWith(pathname, nextItem.link) : false;
                  result.push(
                    /* @__PURE__ */ jsxs(
                      "li",
                      {
                        id: item.tourGroupId,
                        className: classNames(
                          "text-brand-navbar-text relative text-nowrap space-y-0.5 px-[11px] text-left transition-all"
                        ),
                        children: [
                          /* @__PURE__ */ jsxs(
                            NavClickable,
                            {
                              id: item.tourId,
                              link: item.link,
                              action: item.action,
                              className: classNames(
                                "group flex h-[40px] w-full items-center gap-x-3 rounded-xl p-2 text-left text-[15px] leading-6 transition-all duration-300",
                                isActive1 ? "bg-brand-navbar-highlight text-brand-navbar-text-highlight" : "hover:bg-brand-navbar-highlight hover:text-brand-navbar-text-highlight"
                              ),
                              children: [
                                /* @__PURE__ */ jsx(
                                  NavIcon,
                                  {
                                    icon: item.icon,
                                    variant: "desktop",
                                    isActive: isActive1
                                  }
                                ),
                                isOpen ? item.label : void 0
                              ]
                            }
                          ),
                          /* @__PURE__ */ jsxs(
                            NavClickable,
                            {
                              id: nextItem.tourId,
                              link: nextItem.link,
                              action: nextItem.action,
                              className: classNames(
                                "group flex h-[40px] w-full items-center gap-x-3 rounded-xl p-2 text-left text-[15px] leading-6 transition-all duration-300",
                                isActive2 ? "bg-brand-navbar-highlight text-brand-navbar-text-highlight" : "hover:bg-brand-navbar-highlight hover:text-brand-navbar-text-highlight"
                              ),
                              children: [
                                /* @__PURE__ */ jsx(
                                  NavIcon,
                                  {
                                    icon: nextItem.icon,
                                    variant: "desktop",
                                    isActive: isActive2
                                  }
                                ),
                                isOpen ? nextItem.label : void 0
                              ]
                            }
                          )
                        ]
                      },
                      `profile-group-${i}`
                    )
                  );
                  i++;
                } else {
                  result.push(
                    /* @__PURE__ */ jsx(Fragment$1, { children: renderNavItem(item, i, "desktop", "profile") }, `profile-${i}`)
                  );
                }
              }
              return result;
            })() })
          ] }),
          settingsItems.length > 0 && /* @__PURE__ */ jsxs(Fragment, { children: [
            /* @__PURE__ */ jsx("hr", { className: "border-brand-navbar-separator my-3" }),
            /* @__PURE__ */ jsx("ul", { className: "space-y-0.5", children: settingsItems.map((item, index) => renderAccordionItem(item, index, "desktop")) })
          ] }),
          !email && isOpen && /* @__PURE__ */ jsxs("div", { className: "mt-4 flex flex-col items-center justify-center gap-y-4 px-4", children: [
            /* @__PURE__ */ jsx(
              Button,
              {
                color: "red",
                variant: "small",
                onClick: () => navigate("/signup"),
                className: "w-full text-nowrap",
                children: t("sign-up", "Sign up")
              }
            ),
            /* @__PURE__ */ jsx("div", { className: "flex w-fit flex-col gap-y-1 pr-2 font-medium", children: links?.map((link) => /* @__PURE__ */ jsx(
              "a",
              {
                href: link.href,
                target: "_blank",
                rel: "noopener noreferrer",
                className: "w-fit text-nowrap",
                children: link.label
              },
              link.href
            )) })
          ] }),
          /* @__PURE__ */ jsx("ul", { className: "mt-auto space-y-1 px-3 pb-3 !text-[12px]", children: bottomItem.map((item, i) => {
            if (!isOpen && !item.icon) return null;
            return /* @__PURE__ */ jsx(Fragment$1, { children: item.link ? /* @__PURE__ */ jsx("div", { className: "hover:bg-brand-navbar-highlight bg-brand-form-accent-light cursor-pointer rounded-[4px] py-[7px] pl-[5px] pr-[7px] transition duration-300 ease-in-out", children: /* @__PURE__ */ jsx(
              "a",
              {
                href: item.link,
                target: "_blank",
                rel: "noopener noreferrer",
                className: "no-underline",
                children: /* @__PURE__ */ jsxs(
                  "div",
                  {
                    className: classNames(
                      "flex items-center gap-1",
                      isOpen ? "justify-between" : "justify-center"
                    ),
                    children: [
                      isOpen && /* @__PURE__ */ jsx("p", { className: "text-brand-navbar-text min-w-[141px] whitespace-nowrap text-[12px] font-medium leading-[1em]", children: item.label }),
                      item.icon && /* @__PURE__ */ jsx(
                        item.icon,
                        {
                          className: "text-brand-navbar-text !h-[18px] !w-[18px] shrink-0 transition duration-300",
                          "aria-hidden": "true"
                        }
                      ),
                      item.image && /* @__PURE__ */ jsx(
                        "img",
                        {
                          src: item.image,
                          alt: "",
                          className: "h-[18px] w-[18px] shrink-0 transition duration-300"
                        }
                      )
                    ]
                  }
                )
              }
            ) }) : /* @__PURE__ */ jsx(
              "div",
              {
                onClick: item.action,
                className: "hover:bg-brand-navbar-highlight bg-brand-form-accent-light cursor-pointer rounded-[4px] py-[7px] pl-[5px] pr-[7px] transition duration-300 ease-in-out",
                children: /* @__PURE__ */ jsxs(
                  "div",
                  {
                    className: classNames(
                      "flex items-center gap-1",
                      isOpen ? "justify-between" : "justify-center"
                    ),
                    children: [
                      isOpen && /* @__PURE__ */ jsx("p", { className: "text-brand-navbar-text min-w-[141px] whitespace-nowrap text-[12px] font-medium leading-[1em]", children: item.label }),
                      item.icon && /* @__PURE__ */ jsx(
                        item.icon,
                        {
                          className: "text-brand-navbar-text !h-[18px] !w-[18px] shrink-0 transition duration-300",
                          "aria-hidden": "true"
                        }
                      )
                    ]
                  }
                )
              }
            ) }, i);
          }) })
        ] }) }),
        /* @__PURE__ */ jsx("div", { ref: accountRef })
      ]
    }
  );
}

const baseStyles$4 = "flex justify-start border-solid border-[1px] border-brand-grey bg-brand-grey-bg rounded-xl p-2";
function Select({ className, options, value, onChange }) {
  const selectClassName = classNames(className, baseStyles$4);
  return /* @__PURE__ */ jsx("div", { className: selectClassName, children: /* @__PURE__ */ jsx(
    "select",
    {
      className: "bg-brand-grey-bg w-full focus-visible:outline-none",
      value,
      onChange,
      children: options.map((item) => /* @__PURE__ */ jsx("option", { value: item, children: item }, item))
    }
  ) });
}

function Toggle({
  isChecked,
  setIsChecked,
  type = "default",
  disabled,
  className
}) {
  const defaultStyles = classNames(
    isChecked ? "bg-brand-violet" : "bg-gray-200",
    "relative inline-flex h-7 w-[3.25rem] flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2"
  );
  const simpleStyles = classNames(
    "bg-transparent relative inline-flex h-7 w-[3.25rem] flex-shrink-0 cursor-pointer rounded-[25px] border-2 transition-colors duration-200 ease-in-out focus:outline-none border-grey-200"
  );
  const mainStyles = type === "default" ? defaultStyles : simpleStyles;
  return /* @__PURE__ */ jsxs(
    Switch,
    {
      checked: isChecked,
      onChange: setIsChecked,
      className: classNames(mainStyles, className),
      disabled,
      children: [
        /* @__PURE__ */ jsx("span", { className: "sr-only", children: "Use setting" }),
        /* @__PURE__ */ jsx(
          "span",
          {
            className: classNames(
              "pointer-events-none absolute inline-block transform rounded-full shadow ring-0 transition duration-200 ease-in-out",
              type === "default" ? { "h-6 w-6 bg-white": true, "translate-x-6": isChecked, "translate-x-0": !isChecked } : {
                "bg-brand-violet top-1/2 h-4 w-4 -translate-y-1/2": true,
                "translate-x-[28px]": isChecked,
                "translate-x-[4px]": !isChecked
              }
            ),
            children: type === "default" && /* @__PURE__ */ jsxs(Fragment, { children: [
              /* @__PURE__ */ jsx(
                "span",
                {
                  className: classNames(
                    isChecked ? "opacity-0 duration-100 ease-out" : "opacity-100 duration-200 ease-in",
                    "absolute inset-0 flex h-full w-full items-center justify-center transition-opacity"
                  ),
                  "aria-hidden": "true",
                  children: /* @__PURE__ */ jsx("svg", { className: "h-3 w-3 text-gray-400", fill: "none", viewBox: "0 0 12 12", children: /* @__PURE__ */ jsx(
                    "path",
                    {
                      d: "M4 8l2-2m0 0l2-2M6 6L4 4m2 2l2 2",
                      stroke: "currentColor",
                      strokeWidth: 2,
                      strokeLinecap: "round",
                      strokeLinejoin: "round"
                    }
                  ) })
                }
              ),
              /* @__PURE__ */ jsx(
                "span",
                {
                  className: classNames(
                    isChecked ? "opacity-100 duration-200 ease-in" : "opacity-0 duration-100 ease-out",
                    "absolute inset-0 flex h-full w-full items-center justify-center transition-opacity"
                  ),
                  "aria-hidden": "true",
                  children: /* @__PURE__ */ jsx("svg", { className: "h-3 w-3 text-indigo-600", fill: "currentColor", viewBox: "0 0 12 12", children: /* @__PURE__ */ jsx("path", { d: "M3.707 5.293a1 1 0 00-1.414 1.414l1.414-1.414zM5 8l-.707.707a1 1 0 001.414 0L5 8zm4.707-3.293a1 1 0 00-1.414-1.414l1.414 1.414zm-7.414 2l2 2 1.414-1.414-2-2-1.414 1.414zm3.414 2l4-4-1.414-1.414-4 4 1.414 1.414z" }) })
                }
              )
            ] })
          }
        )
      ]
    }
  );
}

const baseStyles$3 = "rounded-[4px] px-4 py-2 bg-white focus:outline-none transition duration-300 border border-brand-grey max-h-[500px] min-w-0";
function Input({
  className,
  style,
  placeholder,
  value,
  disabled,
  onChange,
  onKeyDown,
  onFocus,
  showBorderOnFocus = true,
  isTextArea = false,
  required = false,
  resize = "y",
  type,
  refHandle,
  id,
  maxLength,
  ...props
}) {
  const inputClassName = classNames(className, baseStyles$3, {
    "focus:border-brand-violet-light": showBorderOnFocus,
    "opacity-80": disabled
  });
  return /* @__PURE__ */ jsxs("section", { className: "relative flex w-full", children: [
    maxLength && /* @__PURE__ */ jsx(
      "div",
      {
        className: classNames(
          `absolute text-right text-[10px] text-gray-300`,
          isTextArea ? { "bottom-2 right-2": resize !== "none", "bottom-1 right-2": resize === "none" } : "bottom-1 right-2"
        ),
        children: `${value?.length || 0} / ${maxLength}`
      }
    ),
    isTextArea ? /* @__PURE__ */ jsx(
      "textarea",
      {
        rows: 1,
        placeholder: placeholder ?? "Start typing here",
        className: classNames(inputClassName, {
          "resize-none": resize === "none",
          "resize-y": resize === "y",
          "resize-x": resize === "x"
        }),
        style,
        value,
        disabled,
        onChange: (e) => onChange(e.target.value),
        onKeyDown,
        required,
        ref: refHandle,
        id,
        maxLength,
        ...props
      }
    ) : /* @__PURE__ */ jsx(
      "input",
      {
        type: type || "text",
        className: inputClassName,
        style,
        placeholder: placeholder ?? "Start typing here",
        value,
        disabled,
        onChange: (e) => onChange(e.target.value),
        onKeyDown,
        onFocus,
        required,
        ref: refHandle,
        id,
        maxLength,
        ...props
      }
    )
  ] });
}

const baseStyles$2 = "isolate inline-flex rounded-[4px] h-full bg-white border border-brand-gray-light min-w-fit";
function ButtonGroup({
  options,
  value,
  className,
  onClick,
  activeBgClass,
  buttonClass,
  tooltipId,
  disabled
}) {
  const buttonGroupClassName = classNames(className, baseStyles$2);
  return /* @__PURE__ */ jsx("div", { className: buttonGroupClassName, children: options.map((item, i) => /* @__PURE__ */ jsx(
    "button",
    {
      type: "button",
      value: item.value,
      onClick,
      disabled,
      "data-tooltip-id": `${tooltipId?.length ? tooltipId[i] : ""}`,
      className: classNames(
        buttonClass,
        "body-secondary border-brand-gray-light relative inline-flex min-w-fit flex-1 items-center justify-center px-[10px] py-3 text-sm first:ml-0 first:rounded-l-[3px] last:rounded-r-[3px] focus:z-10 [&:not(:last-child)]:border-r",
        {
          "text-brand-gray-dark bg-brand-form-accent": item.value === value,
          [`${activeBgClass}`]: activeBgClass && item.value === value
        }
      ),
      children: item.label
    },
    item.value
  )) });
}

const baseStyles$1 = "px-4 py-2 bg-transparent focus:outline-none transition duration-300 rounded-lg border border-brand-grey focus:border-brand-green resize-none";
function TextArea({ className, placeholder, value, onChange, rows, style }) {
  const textAreaClassName = classNames(className, baseStyles$1);
  return /* @__PURE__ */ jsx(
    "textarea",
    {
      className: textAreaClassName,
      style,
      placeholder,
      value,
      onChange: (event) => onChange(event.target.value),
      rows
    }
  );
}

const baseStyles = "w-full h-1 bg-brand-grey accent-brand-violet cursor-pointer";
function Range({ className, min, max, step, value, onChange }) {
  const rangeClassName = classNames(className, baseStyles);
  return /* @__PURE__ */ jsx(
    "input",
    {
      className: rangeClassName,
      type: "range",
      min: min ?? 1,
      max: max ?? 10,
      value,
      onChange: (event) => onChange(event.target.value),
      step: step ?? 1
    }
  );
}

const PreviewImage = ({ imageUrl, alt }) => {
  return /* @__PURE__ */ jsx("div", { className: "max-h-[300px] max-w-[300px]", children: /* @__PURE__ */ jsx("img", { src: imageUrl, alt, className: "max-h-[300px] max-w-[300px]" }) });
};

var DropDownMenuPlacementEnum = /* @__PURE__ */ ((DropDownMenuPlacementEnum2) => {
  DropDownMenuPlacementEnum2["BOTTOM"] = "bottom";
  DropDownMenuPlacementEnum2["TOP"] = "top";
  DropDownMenuPlacementEnum2["AUTO"] = "auto";
  return DropDownMenuPlacementEnum2;
})(DropDownMenuPlacementEnum || {});
var DropDownMenuAlignmentEnum = /* @__PURE__ */ ((DropDownMenuAlignmentEnum2) => {
  DropDownMenuAlignmentEnum2["LEFT"] = "left";
  DropDownMenuAlignmentEnum2["RIGHT"] = "right";
  DropDownMenuAlignmentEnum2["AUTO"] = "auto";
  return DropDownMenuAlignmentEnum2;
})(DropDownMenuAlignmentEnum || {});
function Menu(props, action) {
  return /* @__PURE__ */ jsxs(components$1.Menu, { ...props, children: [
    props.children,
    action?.label && /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsxs("div", { children: [
        /* @__PURE__ */ jsx("div", { className: "h-2 border-b" }),
        /* @__PURE__ */ jsx("div", { className: "h-2" })
      ] }),
      /* @__PURE__ */ jsxs(
        "div",
        {
          className: "hover:bg-brand-violet hover:text-brand-text-primary flex min-h-8 cursor-pointer items-center justify-center rounded-[4px]",
          onClick: () => action?.callback && action.callback(),
          children: [
            /* @__PURE__ */ jsx(Add, { fontSize: "small" }),
            action.label
          ]
        }
      )
    ] })
  ] });
}
function Indicator() {
  return /* @__PURE__ */ jsx("div", { className: "flex cursor-pointer text-[18px]", children: /* @__PURE__ */ jsx(ExpandMore, { fontSize: "inherit", className: "text-brand-gray-dark" }) });
}
function Option({
  showDeleteIcon,
  isFocused,
  deleteAction,
  ...props
}) {
  const showDeleteOption = props.data?.showDeleteOption ?? true;
  const isDefaultValue = props.data?.isDefault === "DEFAULT_VALUE";
  if (props.value === "options-divider")
    return /* @__PURE__ */ jsxs(components$1.Option, { ...props, children: [
      /* @__PURE__ */ jsx("div", { className: "h-2 border-b" }),
      /* @__PURE__ */ jsx("div", { className: "h-2" })
    ] });
  if (isDefaultValue)
    return /* @__PURE__ */ jsx(components$1.Option, { ...props, children: /* @__PURE__ */ jsx(
      "div",
      {
        className: "flex items-center justify-between",
        style: { margin: "-6px -20px", padding: "6px 20px" },
        onClick: props.clearValue,
        children: /* @__PURE__ */ jsx("div", { className: "flex w-full items-center overflow-hidden text-ellipsis capitalize", children: props.label })
      }
    ) });
  return /* @__PURE__ */ jsx(
    components$1.Option,
    {
      ...props,
      className: classNames({
        "sm:!text-brand-red sm:!bg-[#FFF0F0]": isFocused && !isDefaultValue
      }),
      children: /* @__PURE__ */ jsxs("div", { className: classNames("flex items-center justify-between gap-2"), children: [
        props.icon && /* @__PURE__ */ jsx("div", { className: "object-contain", children: props.icon }),
        props.data?.icon && /* @__PURE__ */ jsx("div", { className: "object-contain", children: props.data.icon }),
        /* @__PURE__ */ jsx(
          "div",
          {
            className: classNames(
              "flex items-center overflow-hidden text-ellipsis capitalize",
              showDeleteIcon && showDeleteOption ? "w-5/6" : "w-full"
            ),
            children: props.label
          }
        ),
        showDeleteIcon && showDeleteOption && /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(
          Delete,
          {
            sx: {
              "&:hover": { color: "#FB427C" },
              color: "#363636",
              fontSize: "25px"
            },
            onClick: (e) => {
              e.stopPropagation();
              deleteAction?.(props.value);
            }
          }
        ) })
      ] })
    }
  );
}
function MenuList(props, withImages, menuListClasses) {
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: classNames(menuListClasses, {
        "flex flex-wrap items-center lg:flex-nowrap": withImages
      }),
      children: [
        /* @__PURE__ */ jsx(
          "div",
          {
            className: classNames({
              "w-full lg:w-auto": withImages
            }),
            children: /* @__PURE__ */ jsx(components$1.MenuList, { ...props })
          }
        ),
        withImages && props.focusedOption?.image && /* @__PURE__ */ jsx("div", { className: "hidden w-full lg:contents", children: /* @__PURE__ */ jsx(PreviewImage, { imageUrl: props.focusedOption?.image, alt: props.focusedOption?.value }) })
      ]
    }
  );
}
const filterOptions = (candidate, input) => {
  if (input) {
    const lookup = candidate.data?.lookup ?? candidate.data?.data?.lookup;
    if (lookup)
      return lookup.toLowerCase().includes(input.toLowerCase());
    return candidate.value?.toLowerCase().includes(input.toLowerCase()) || candidate.label?.toLowerCase?.().includes(input.toLowerCase());
  }
  return true;
};
const ReactSelect = memo(function ReactSelect2({
  placeHolder,
  clearLabel = "Default",
  isClearable = false,
  options,
  id,
  customOptions = [],
  defaultValue,
  menuWrapperMaxHeight,
  menuPlacement = "auto" /* AUTO */,
  menuAlignment = "auto" /* AUTO */,
  menuMinWidth = "max-content",
  menuWidth = "100%",
  menuListClasses,
  name,
  value,
  setSelectedValue,
  menuPortalTarget,
  onClear,
  disabled = false,
  withImages = false,
  portalToBody = false,
  showDeleteIcon,
  deleteAction,
  CSSClassNames,
  action,
  actionLabel,
  onClick,
  isMulti = false,
  controlHeight = "44px",
  controlMinHeight = "44px",
  closeMenuOnSelect = true,
  components: components2,
  className
}) {
  const [isMobileOrTablet, setIsMobileOrTablet] = useState(false);
  useEffect(() => {
    if (typeof window !== "undefined") {
      const checkDeviceSize = () => {
        setIsMobileOrTablet(window.innerWidth < 1024);
      };
      checkDeviceSize();
      window.addEventListener("resize", checkDeviceSize);
      return () => window.removeEventListener("resize", checkDeviceSize);
    }
  }, []);
  const divider = { value: "options-divider", label: "", isDisabled: true };
  let selectOptions = options;
  if (customOptions?.length) {
    if (options?.length) selectOptions = [...options, divider, ...customOptions];
    else selectOptions = customOptions;
  }
  if (isClearable) {
    if (selectOptions?.length)
      selectOptions = [
        { value: null, label: clearLabel, showDeleteOption: false, isDefault: true },
        divider,
        ...selectOptions
      ];
    else
      selectOptions = [{ value: null, label: clearLabel, showDeleteOption: false, isDefault: true }];
    if (!defaultValue)
      defaultValue = { value: null, label: clearLabel, showDeleteOption: false, isDefault: true };
  }
  return /* @__PURE__ */ jsx(
    "div",
    {
      id,
      className: classNames(
        "",
        {
          "pointer-events-none": disabled
        },
        className
      ),
      onClick,
      children: /* @__PURE__ */ jsx(
        Select$1,
        {
          isDisabled: onClick ? true : false,
          classNames: {
            singleValue: () => {
              return CSSClassNames?.singleValue ?? "";
            }
          },
          ...portalToBody ? { menuPortalTarget: menuPortalTarget || document.body } : {},
          isSearchable: !isMobileOrTablet,
          filterOption: filterOptions,
          value,
          isMulti,
          isClearable: false,
          closeMenuOnSelect,
          blurInputOnSelect: closeMenuOnSelect,
          placeholder: placeHolder,
          defaultValue,
          menuPlacement,
          onChange: (data, action2) => {
            if (action2.action === "clear" && onClear) return onClear(action2.action);
            setSelectedValue({
              value: data?.value || action2?.option?.value,
              label: data?.label || action2?.option?.label,
              name,
              data: data || action2?.option
            });
          },
          options: selectOptions,
          components: {
            Menu: (props) => Menu(props, { callback: action, label: actionLabel }),
            MenuList: (props) => MenuList(props, withImages, menuListClasses),
            IndicatorSeparator: () => null,
            DropdownIndicator: Indicator,
            Option: (props) => (
              // @ts-ignore
              /* @__PURE__ */ jsx(Option, { ...props, showDeleteIcon, deleteAction })
            ),
            ...components2
          },
          styles: {
            menuPortal: (baseStyles) => ({
              ...baseStyles,
              zIndex: 999999999999
            }),
            control: (baseStyles) => ({
              ...baseStyles,
              padding: "8px 16px",
              borderRadius: "12px",
              height: isMulti ? "auto" : controlHeight || "auto",
              minHeight: controlMinHeight,
              fontSize: "15px",
              backgroundColor: "#FFFFFF",
              border: "1px solid transparent",
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08)",
              transition: "all 0.2s",
              alignItems: "center",
              "&:hover": {
                borderColor: "#E6E2DE",
                backgroundColor: "#FCFCFC"
              }
            }),
            valueContainer: (baseStyles) => ({
              ...baseStyles,
              padding: 0,
              alignItems: "center",
              flexWrap: "wrap",
              overflow: "hidden"
            }),
            placeholder: (baseStyles) => ({
              ...baseStyles,
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis"
            }),
            option: (baseStyles, { data, isFocused, isSelected }) => {
              if (data && data.value === "options-divider") {
                return {
                  cursor: "default"
                };
              }
              return {
                ...baseStyles,
                borderRadius: 8,
                margin: 0,
                padding: showDeleteIcon ? "12px 14px 12px 20px" : "12px",
                transition: "background 0.1s",
                cursor: "pointer",
                lineHeight: 1.2,
                fontSize: "15px",
                backgroundColor: isFocused || isSelected && !data?.isDefault ? "#FFF0F0" : "#ffffff",
                color: isFocused || isSelected && !data?.isDefault ? "#E30022" : data?.isDefault ? "#888888" : "#534B4F"
              };
            },
            menu: (baseStyles) => ({
              ...baseStyles,
              zIndex: 999,
              borderRadius: "12px",
              minWidth: menuMinWidth !== "max-content" ? `${menuMinWidth}px` : "max-content",
              maxWidth: "100dvw",
              ...menuAlignment === "right" /* RIGHT */ && { right: 0 },
              border: "1px solid #EEE",
              boxShadow: "0 8px 24px rgba(0, 0, 0, 0.12)",
              marginTop: 4,
              width: menuWidth
            }),
            menuList: (baseStyles) => ({
              ...baseStyles,
              padding: "6px",
              paddingTop: 0,
              paddingBottom: 0,
              overflowX: "clip",
              maxHeight: menuWrapperMaxHeight || baseStyles.maxHeight
            }),
            multiValue: (baseStyles) => ({
              ...baseStyles,
              backgroundColor: "#E8E4E0",
              borderRadius: "10px",
              paddingLeft: "8px",
              paddingRight: 0
            }),
            multiValueLabel: (baseStyles) => ({
              ...baseStyles,
              color: "#534B4F",
              borderRadius: "10px",
              padding: "2px 0",
              paddingLeft: 0,
              paddingRight: "2px"
            }),
            multiValueRemove: (baseStyles) => ({
              ...baseStyles,
              borderRadius: "0 10px 10px 0",
              color: "#534B4F",
              padding: "2px 8px 2px 4px",
              ":hover": {
                backgroundColor: "rgba(83, 75, 79, 0.12)",
                color: "#534B4F"
              }
            }),
            singleValue: (baseStyles) => ({
              ...baseStyles,
              color: "#534B4F",
              fontWeight: 500,
              fontSize: "15px",
              textTransform: "capitalize",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              maxWidth: "100%",
              alignSelf: "center"
            }),
            input: (baseStyles) => ({
              ...baseStyles,
              margin: 0,
              padding: 0
            })
          }
        }
      )
    }
  );
});

const MultiValue = (props) => {
  const onMouseDown = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };
  const innerProps = { ...props.innerProps, onMouseDown };
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({
    id: props.data.value
  });
  const style = {
    transform: CSS.Translate.toString(transform),
    transition,
    touchAction: "none"
  };
  return /* @__PURE__ */ jsx("div", { style, ref: setNodeRef, ...attributes, ...listeners, children: /* @__PURE__ */ jsx(components$1.MultiValue, { ...props, innerProps }) });
};
const MultiValueRemove = (props) => {
  return /* @__PURE__ */ jsx(
    components$1.MultiValueRemove,
    {
      ...props,
      innerProps: {
        onPointerDown: (e) => e.stopPropagation(),
        ...props.innerProps
      }
    }
  );
};
const SortableMultiSelect = ({
  options,
  onChange,
  defaultValue = [],
  portalToBody = false
}) => {
  const [selected, setSelected] = React__default.useState(defaultValue);
  const onDragEnd = useCallback(
    (event) => {
      const { active, over } = event;
      if (!active || !over) return;
      setSelected((items) => {
        const oldIndex = items.findIndex((item) => item.value === active.id);
        const newIndex = items.findIndex((item) => item.value === over.id);
        const res = arrayMove(items, oldIndex, newIndex);
        onChange(res);
        return res;
      });
    },
    [onChange]
  );
  return /* @__PURE__ */ jsx(
    DndContext,
    {
      modifiers: [restrictToParentElement],
      onDragEnd,
      collisionDetection: closestCorners,
      children: /* @__PURE__ */ jsx(SortableContext, { items: selected.map((o) => o.value), children: /* @__PURE__ */ jsx(
        ReactSelect,
        {
          isMulti: true,
          options,
          closeMenuOnSelect: false,
          isClearable: false,
          value: selected,
          setSelectedValue: ({ data }) => {
            setSelected([...data]);
            onChange(data);
          },
          portalToBody,
          components: {
            MultiValue,
            MultiValueRemove
          }
        }
      ) })
    }
  );
};

const components = {
  DropdownIndicator: null
};
const createOption = (label) => ({
  label,
  value: label
});
function MultipleSelect({
  inputValue,
  setValue,
  value,
  setInputValue,
  placeHolder
}) {
  const handleKeyDown = (event) => {
    if (!inputValue) return;
    switch (event.key) {
      case "Enter":
      case "Tab":
        setValue((prev) => [...prev, createOption(inputValue)]);
        setInputValue("");
        event.preventDefault();
    }
  };
  const handleBlur = (event) => {
    if (!inputValue) return;
    setValue((prev) => [...prev, createOption(inputValue)]);
    setInputValue("");
    event.preventDefault();
  };
  return /* @__PURE__ */ jsx(
    CreatableSelect,
    {
      components,
      inputValue,
      isClearable: true,
      isMulti: true,
      menuIsOpen: false,
      onChange: (newValue) => setValue(newValue),
      onBlur: (e) => handleBlur(e),
      onInputChange: (newValue) => setInputValue(newValue),
      onKeyDown: handleKeyDown,
      placeholder: placeHolder || "Type something and press enter...",
      value,
      styles: {
        control: (baseStyles) => ({
          ...baseStyles,
          borderRadius: "10px",
          backgroundColor: "white",
          border: "1px solid #E6E6E6",
          boxShadow: "0 !important",
          "&:hover": {
            border: "1px solid #E6E6E6"
          }
          // This line disable the blue border
        }),
        menu: (baseStyles) => ({
          ...baseStyles,
          // top: 52,
          zIndex: 999,
          borderRadius: 10,
          paddingTop: 0,
          // border: "1px solid #E6E6E6",
          boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
          marginTop: 0
        }),
        singleValue: (baseStyles) => ({
          ...baseStyles,
          color: "#363636",
          fontWeight: "400",
          fontSize: "13px",
          textTransform: "capitalize"
          // This line disable the blue border
        }),
        placeholder: (baseStyles) => ({
          ...baseStyles,
          color: "#36363670",
          fontWeight: "400",
          fontSize: "13px"
          // This line disable the blue border
        }),
        input: (baseStyles) => ({
          ...baseStyles,
          margin: 0,
          padding: 0
          // This line disable the blue border
        })
      }
    }
  );
}

function RadioBox({
  classes,
  id,
  radioBoxName,
  label,
  labelClasses,
  setChecked,
  containerClasses,
  radioBoxValue
}) {
  return /* @__PURE__ */ jsxs("div", { className: classNames(containerClasses, "inline-flex items-center gap-[6px]"), children: [
    /* @__PURE__ */ jsxs(
      "label",
      {
        className: "relative flex cursor-pointer items-center rounded-full",
        htmlFor: id,
        "data-ripple-dark": "true",
        children: [
          /* @__PURE__ */ jsx(
            "input",
            {
              id,
              name: radioBoxName,
              type: "radio",
              checked: radioBoxValue,
              onChange: (e) => {
                setChecked({ radioBoxName: e.target.id, checked: e.target.checked });
              },
              className: classNames(
                classes,
                "before:content[''] before:bg-blue-gray-500 checked:bg-brand-violet border-brand-gray-light peer relative h-5 w-5 cursor-pointer appearance-none  rounded-full border bg-[#ffffff] text-pink-500 transition-all before:absolute before:left-2/4  before:top-2/4 before:block before:-translate-x-2/4 before:-translate-y-2/4 before:rounded-full before:opacity-0 before:transition-opacity  hover:before:opacity-10"
              )
            }
          ),
          /* @__PURE__ */ jsx("div", { className: "pointer-events-none absolute left-2/4 top-2/4 -translate-x-2/4 -translate-y-2/4 text-[#ffffff]  opacity-0 transition-opacity peer-checked:opacity-100", children: /* @__PURE__ */ jsx(
            "svg",
            {
              xmlns: "http://www.w3.org/2000/svg",
              className: "h-[7px] w-[7px]",
              viewBox: "0 0 16 16",
              fill: "currentColor",
              children: /* @__PURE__ */ jsx("circle", { cx: "8", cy: "8", r: "8" })
            }
          ) })
        ]
      }
    ),
    label ? /* @__PURE__ */ jsx("span", { className: classNames(labelClasses, "text-brand-body leading-[1.2em]"), children: label }) : null
  ] });
}

const trackBaseClasses = {
  simple: "h-[4px] rounded-full top-1/2 -translate-y-1/2",
  advanced: "h-full top-1/2 -translate-y-1/2 flex justify-center items-center pr-[15px] text-brand-gray-dark body-small"
};
const thumbBaseClasses = {
  simple: "rounded-full bg-white shadow shadow-slate-600 h-[15px] w-[15px] top-1/2 -translate-y-1/2 focus-visible:outline-none active:scale-110",
  advanced: "rounded-[8px] flex items-center justify-center gap-[1px] bg-white shadow-[0_0_3px_#00000025] h-[calc(100%+10px)] w-[15px] top-1/2 -translate-y-1/2 focus-visible:outline-none active:scale-105"
};
function Slider({
  value,
  onChange,
  min = 0,
  max = 10,
  step = 1,
  showPercentageThreshold,
  type = "simple"
}) {
  const containerClasses = {
    simple: "mb-2 mt-3 h-[15px] rounded-full",
    advanced: "border-brand-gray-light h-full rounded-[4px] border"
  };
  return /* @__PURE__ */ jsx(
    ReactSlider,
    {
      className: classNames("cursor-pointer", containerClasses[type]),
      value,
      min,
      max,
      step,
      onChange: (val) => onChange(val),
      renderTrack: (props, state) => /* @__PURE__ */ jsx(
        "div",
        {
          ...props,
          className: classNames(
            trackBaseClasses[type],
            type === "simple" && {
              "bg-brand-violet": state.index === 0,
              "bg-brand-grey": state.index === 1
            },
            type === "advanced" && {
              "bg-brand-form-accent rounded-l-[3px]": state.index === 0,
              "rounded-r-[3px]": state.index === 1
            }
          ),
          children: type === "advanced" && state.index === 0 && value !== min && (!showPercentageThreshold || value >= showPercentageThreshold) ? `${Math.round(value / max * 100)}%` : ""
        }
      ),
      renderThumb: (props) => /* @__PURE__ */ jsx("div", { ...props, className: thumbBaseClasses[type], children: type === "advanced" && /* @__PURE__ */ jsx(Dehaze, { fontSize: "inherit", className: "text-brand-gray-light rotate-90" }) })
    }
  );
}

function FormField(props) {
  return /* @__PURE__ */ jsx("div", { className: "flex flex-col gap-y-2", children: props.children });
}

const FeatureHeader = ({
  title,
  subtitle,
  description,
  link,
  videoLink,
  additionalInfo
}) => {
  return /* @__PURE__ */ jsxs("div", { className: "mb-[80px] border-b bg-white", children: [
    /* @__PURE__ */ jsx("div", { className: "relative isolate py-14", children: /* @__PURE__ */ jsxs("div", { className: "mx-auto max-w-7xl px-6 lg:px-8", children: [
      /* @__PURE__ */ jsxs("div", { className: "mx-auto max-w-2xl text-center", children: [
        /* @__PURE__ */ jsx("h1", { className: "text-brand-text-primary text-4xl font-bold tracking-tight sm:text-6xl", children: title }),
        /* @__PURE__ */ jsx("p", { className: "text-md text-brand-violet mt-2 font-bold", children: subtitle }),
        link && /* @__PURE__ */ jsx(
          Button,
          {
            className: classNames("mt-6", link.className),
            href: link.href,
            color: "violet",
            target: link.target,
            children: link.text
          }
        ),
        description && /* @__PURE__ */ jsx("h2", { className: "text-brand-text-primary mt-6 text-xl font-bold tracking-tight sm:text-2xl", children: description })
      ] }),
      videoLink && /* @__PURE__ */ jsx("div", { className: "relative mx-auto mt-6 w-[1216px] max-w-[90vw] pb-[56.25%]", children: /* @__PURE__ */ jsx(
        "iframe",
        {
          title,
          src: videoLink,
          className: "absolute inset-0 h-full w-full rounded-xl shadow-2xl ring-1 ring-gray-900/10",
          allow: "full"
        }
      ) })
    ] }) }),
    additionalInfo
  ] });
};

const UseEleoToday = ({ header, subHeader, buttonText, href }) => {
  return /* @__PURE__ */ jsx("div", { className: "bg-brand-yellow", children: /* @__PURE__ */ jsx("div", { className: "px-6 py-24 sm:px-6 sm:py-32 lg:px-8", children: /* @__PURE__ */ jsxs("div", { className: "mx-auto max-w-2xl text-center", children: [
    /* @__PURE__ */ jsx("h2", { className: "text-brand-text-primary text-3xl font-bold tracking-tight sm:text-4xl", children: header }),
    /* @__PURE__ */ jsx("p", { className: "text-brand-text-secondary mx-auto mt-6 max-w-xl text-lg leading-8", children: subHeader }),
    /* @__PURE__ */ jsx("div", { className: "mt-10 flex items-center justify-center gap-x-6", children: /* @__PURE__ */ jsx(
      Button,
      {
        href,
        color: "violet",
        children: buttonText
      }
    ) })
  ] }) }) });
};

const ManageCookiesContent = ({
  options,
  optionsMainTitle
}) => {
  return /* @__PURE__ */ jsxs("div", { className: "flex flex-col gap-[26px]", children: [
    /* @__PURE__ */ jsx("h4", { className: "text-[16px] font-semibold leading-[1.3em] text-[#2e2e2e]   lg:text-[18px] xl:text-[20px]", children: optionsMainTitle }),
    /* @__PURE__ */ jsx("div", { className: "flex flex-col gap-[10px]  md:gap-[20px]", children: options.map((option, i) => /* @__PURE__ */ jsx(Fragment$1, { children: /* @__PURE__ */ jsxs("div", { className: "flex flex-col gap-[6px]", children: [
      /* @__PURE__ */ jsxs("div", { className: "flex  items-center gap-[6px]", children: [
        /* @__PURE__ */ jsx(
          CheckBox,
          {
            checkBoxName: option.id,
            checkBoxValue: option.defaultSelected,
            classes: "before:bg-blue-gray-500 checked:!border-[#2e2e2e] checked:!bg-[#2e2e2e] checked:!before:bg-[#2e2e2e]   !h-[15px] !w-[15px]",
            setChecked: option.onSelect,
            size: 15
          }
        ),
        /* @__PURE__ */ jsx("p", { className: "mt-[2px] text-[13px] font-medium capitalize leading-[1.1em]", children: option.optionTitle })
      ] }),
      /* @__PURE__ */ jsx(
        "p",
        {
          className: classNames(
            "text-brand-black pl-[21px] text-[12px]  font-normal leading-[1.2em] text-[#2e2e2e]  lg:text-[14px] xl:text-[16px]",
            option.defaultSelected ? "opacity-70" : "opacity-50"
          ),
          children: option.optionDescription
        }
      )
    ] }) }, i)) })
  ] });
};

const CookieConsent = ({
  bannerTitle,
  acceptAllButtonText,
  manageButtonText,
  leaveSiteButtonText,
  acceptSelectionButtonText,
  options,
  optionsMainTitle,
  bannerContent,
  handleAcceptAllCookies,
  showBanner,
  handleAcceptSelectedConsents,
  handleLeaveApp
}) => {
  const [content, setContent] = useState(0 /* DEFAULT */);
  return /* @__PURE__ */ jsx(Fragment, { children: showBanner ? /* @__PURE__ */ jsx("div", { className: "fixed bottom-0 left-0 z-[9999] w-full", children: /* @__PURE__ */ jsx(
    "div",
    {
      className: classNames(
        "relative flex items-end justify-center px-[10px] lg:items-center",
        content === 0 /* DEFAULT */ ? "min-h-[80dvh] lg:min-h-[60dvh]" : "min-h-[90dvh] lg:min-h-[80dvh]"
      ),
      style: { backgroundColor: "#0000001a" },
      children: /* @__PURE__ */ jsx("div", { className: "mx-auto flex w-full min-w-[340px] max-w-[950px] items-center justify-center  rounded-[10px] bg-white p-[20px]   md:rounded-[20px] lg:p-[30px] xl:p-[50px]", children: /* @__PURE__ */ jsxs("div", { className: "flex flex-col  gap-[16px]", children: [
        content === 0 /* DEFAULT */ ? /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx("h4", { className: "text-[16px] font-semibold leading-[1.3em] text-[#2e2e2e]   lg:text-[18px] xl:text-[20px]", children: bannerTitle }),
          /* @__PURE__ */ jsx("div", { className: "flex flex-col gap-[10px] px-[10px] text-[12px]  leading-[1.3em] text-[#2e2e2e] opacity-80 lg:text-[14px] xl:text-[16px]", children: /* @__PURE__ */ jsx(Fragment, { children: bannerContent }) })
        ] }) : /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(ManageCookiesContent, { options, optionsMainTitle }) }),
        /* @__PURE__ */ jsxs(
          "div",
          {
            className: classNames(
              "flex flex-wrap  gap-[10px]  md:flex-nowrap",
              content === 1 /* MANAGE */ ? "pt-[20px]" : "pt-[16px]"
            ),
            children: [
              /* @__PURE__ */ jsxs("div", { className: "flex w-full  items-center gap-[10px] md:w-auto", children: [
                /* @__PURE__ */ jsx(
                  Button,
                  {
                    className: "!h-[36px] !w-1/2 !rounded-[12px] !bg-[#2e2e2e1a] !px-[24px] !py-[16px] transition-transform duration-300 hover:scale-105 md:!h-[46px] md:!w-auto",
                    onClick: () => handleLeaveApp(),
                    children: /* @__PURE__ */ jsx("p", { className: "whitespace-nowrap text-[13px] font-medium text-[#2e2e2e] opacity-70 sm:text-[14px]", children: leaveSiteButtonText })
                  }
                ),
                content === 1 /* MANAGE */ ? /* @__PURE__ */ jsx(
                  Button,
                  {
                    className: "!h-[36px] !w-1/2 !rounded-[12px] !bg-[#2e2e2e1a] !px-[24px] !py-[16px] transition-transform duration-300 hover:scale-105 md:!h-[46px] md:!w-auto",
                    onClick: () => handleAcceptAllCookies(),
                    children: /* @__PURE__ */ jsx("p", { className: "whitespace-nowrap text-[13px] font-medium text-[#2e2e2e] opacity-70  sm:text-[14px]", children: acceptAllButtonText })
                  }
                ) : null,
                content === 0 /* DEFAULT */ ? /* @__PURE__ */ jsx(
                  Button,
                  {
                    className: "!h-[36px] !w-1/2 !rounded-[12px] !bg-[#2e2e2e1a] !px-[24px] !py-[16px] transition-transform duration-300 hover:scale-105 md:!h-[46px] md:!w-auto",
                    onClick: () => setContent(1 /* MANAGE */),
                    children: /* @__PURE__ */ jsx("div", { className: "flex items-center gap-[5px]", children: /* @__PURE__ */ jsx("p", { className: "whitespace-nowrap text-[13px] font-medium text-[#2e2e2e] opacity-70 sm:text-[14px]", children: manageButtonText }) })
                  }
                ) : null
              ] }),
              content === 1 /* MANAGE */ ? /* @__PURE__ */ jsx("div", { className: "w-full", children: /* @__PURE__ */ jsx(
                Button,
                {
                  className: "!bg-brand-green-heavy !h-[36px] !w-full !rounded-[12px] !px-[24px] !py-[16px] transition-transform duration-300 hover:scale-105 md:!h-[46px]",
                  onClick: () => handleAcceptSelectedConsents(),
                  children: /* @__PURE__ */ jsx("div", { className: "flex items-center gap-[5px]", children: /* @__PURE__ */ jsx("p", { className: "text-brand-text-primary whitespace-nowrap text-[13px] font-medium  sm:text-[14px]", children: acceptSelectionButtonText }) })
                }
              ) }) : null,
              content === 0 /* DEFAULT */ ? /* @__PURE__ */ jsx("div", { className: "w-full", children: /* @__PURE__ */ jsx(
                Button,
                {
                  className: "!bg-brand-green-heavy !h-[36px] w-full !rounded-[12px]  !px-[24px] !py-[16px] transition-transform duration-300 hover:scale-105 md:!h-[46px]",
                  onClick: () => handleAcceptAllCookies(),
                  children: /* @__PURE__ */ jsx("p", { className: "text-brand-text-primary whitespace-nowrap text-[13px] font-medium  sm:text-[14px]", children: acceptAllButtonText })
                }
              ) }) : null
            ]
          }
        )
      ] }) })
    }
  ) }) : null });
};

const Handle = forwardRef((props, ref) => {
  const { handleAxis, isOpen, setIsOpen, ...restProps } = props;
  const [clickTimeout, setClickTimeout] = useState();
  function handleMouseDown() {
    const timeout = setTimeout(() => {
      setClickTimeout(null);
    }, 150);
    setClickTimeout(timeout);
  }
  function handleMouseUp() {
    if (clickTimeout) {
      clearTimeout(clickTimeout);
      setClickTimeout(null);
      setIsOpen(!isOpen);
    }
  }
  return /* @__PURE__ */ jsx(
    "div",
    {
      ref,
      className: `handle-${handleAxis} absolute -right-[1px] top-1/2 z-50 -translate-y-1/2 cursor-col-resize rounded-[4px] bg-white`,
      ...restProps,
      children: /* @__PURE__ */ jsxs(
        "div",
        {
          onMouseDown: handleMouseDown,
          onMouseUp: handleMouseUp,
          className: "bg-brand-violet flex h-[50px] w-[16px] flex-col items-center justify-around rounded-[4px] border bg-opacity-10",
          children: [
            isOpen && /* @__PURE__ */ jsx(ChevronLeft, { className: "text-brand-violet text-[18px]" }),
            /* @__PURE__ */ jsx(ChevronRight, { className: "text-brand-violet text-[18px]" })
          ]
        }
      )
    }
  );
});

function ResizableContainer({
  children,
  minWidth = 215,
  maxWidth = 450,
  initWidth = 225,
  isOpen = null,
  hideResizeHandler = false,
  setIsOpen,
  storageKey,
  breakpoint = 500
}) {
  const savedWith = localStorage.getItem(`${storageKey}-panel-width`);
  if (savedWith) initWidth = Number(savedWith);
  const breakpoint1 = 350;
  const breakpoint2 = breakpoint;
  const [state, setState] = useState({
    width: initWidth,
    height: 0
  });
  useEffect(() => {
    const event = new CustomEvent("onPanelResize", { detail: state.width });
    window.dispatchEvent(event);
  }, []);
  useEffect(() => {
    if (state.width > maxWidth) setState((prev) => ({ ...prev, width: maxWidth }));
  }, [maxWidth, state]);
  useLayoutEffect(() => {
    if (isOpen === null || isOpen === void 0) return;
    if (isOpen) setState({ width: initWidth, height: 0 });
    else setState({ width: minWidth - 25, height: 0 });
  }, [isOpen, initWidth, minWidth]);
  useEffect(() => {
    if (storageKey && isOpen && state.width >= minWidth) {
      const timeout = setTimeout(
        () => localStorage.setItem(`${storageKey}-panel-width`, String(state.width)),
        500
      );
      return () => clearTimeout(timeout);
    }
    return () => null;
  }, [state.width, minWidth, isOpen, storageKey]);
  const onResize = (_event, { size }) => {
    if (size.width >= minWidth && !isOpen && setIsOpen) setIsOpen(true);
    if (size.width < minWidth && isOpen && setIsOpen) {
      setIsOpen(false);
      localStorage.setItem(`${storageKey}-panel-width`, String(minWidth));
    }
    if (state.width <= breakpoint1 && size.width > breakpoint1 || state.width <= breakpoint2 && size.width > breakpoint2 || state.width > breakpoint1 && size.width <= breakpoint1 || state.width > breakpoint2 && size.width <= breakpoint2) {
      const event = new CustomEvent("onPanelResize", { detail: size.width });
      window.dispatchEvent(event);
    }
    setState({ width: size.width, height: size.height });
  };
  return /* @__PURE__ */ jsx(
    Resizable,
    {
      axis: "x",
      height: state.height,
      width: state.width,
      onResize,
      handle: !hideResizeHandler ? /* @__PURE__ */ jsx(Handle, { isOpen: state.width >= minWidth, setIsOpen }) : null,
      minConstraints: [minWidth - 25, null],
      maxConstraints: [maxWidth, null],
      children: /* @__PURE__ */ jsx(
        "div",
        {
          className: "box",
          style: {
            width: state.width >= minWidth ? state.width : "0px",
            height: "100%",
            paddingRight: state.width >= minWidth ? "5px" : "16px"
          },
          children: /* @__PURE__ */ jsx(
            "div",
            {
              className: classNames(
                "border-r-4 border-double sm:h-full",
                state.width < minWidth && "hidden"
              ),
              children
            }
          )
        }
      )
    }
  );
}

function Loader() {
  return /* @__PURE__ */ jsx("div", { className: "absolute left-1/2 top-1/2 z-50 flex -translate-x-1/2 -translate-y-1/2 justify-center", children: /* @__PURE__ */ jsxs(
    "svg",
    {
      "aria-hidden": "true",
      className: "fill-brand-violet h-8 w-8 animate-spin text-gray-200 dark:text-gray-600",
      viewBox: "0 0 100 101",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z",
            fill: "currentFill"
          }
        )
      ]
    }
  ) });
}

function HistoryItem({
  id,
  question,
  answer,
  date_created,
  context,
  words,
  isLayoutLarge,
  loadItem,
  isChecked,
  switchIsChecked,
  closeHistory,
  dateText,
  storyText,
  storyMissingText,
  wordCounterText,
  showYourStory
}) {
  if (isChecked === void 0) isChecked = false;
  const [isLoading, setIsLoading] = useState(false);
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: classNames(
        "hover:bg-brand-violet relative flex cursor-pointer gap-x-[6px] border-b text-[13px] transition-colors hover:bg-opacity-10"
      ),
      children: [
        isLoading && /* @__PURE__ */ jsx(Loader, {}),
        /* @__PURE__ */ jsx("div", { className: "self-start pl-4 pt-[15px]", children: /* @__PURE__ */ jsx(
          CheckBox,
          {
            id,
            checkBoxName: id,
            checkBoxValue: isChecked,
            setChecked: switchIsChecked
          }
        ) }),
        /* @__PURE__ */ jsxs(
          "div",
          {
            onClick: async () => {
              if (!loadItem) return;
              setIsLoading(true);
              await loadItem(id);
              setIsLoading(false);
            },
            onDoubleClick: () => closeHistory && closeHistory(),
            className: classNames(
              "min-w-0 flex-1 justify-between gap-x-[6px]",
              isLayoutLarge ? "flex" : "",
              isLoading && "opacity-50"
            ),
            children: [
              /* @__PURE__ */ jsxs("div", { className: classNames("min-w-0 flex-1 space-y-[6px] py-[14px] pl-[4px] pr-[6px]"), children: [
                /* @__PURE__ */ jsx("div", { className: "line-clamp-2", children: question ?? "Hello world" }),
                /* @__PURE__ */ jsx("div", { className: "text-brand-body line-clamp-2 text-opacity-70", children: answer ?? "Goodbye world" })
              ] }),
              /* @__PURE__ */ jsx(
                "div",
                {
                  className: classNames(
                    isLayoutLarge ? "my-[12px] h-[calc(100%-24px)] border-r" : "ml-[4px] mr-[12px] w-[calc(100%-16px)] border-b"
                  )
                }
              ),
              /* @__PURE__ */ jsxs(
                "div",
                {
                  className: classNames(
                    "text-brand-body grid h-fit  gap-x-[10px] gap-y-1 overflow-hidden py-[14px]  pr-[16px] text-[13px] leading-[1.2em] text-opacity-70",
                    isLayoutLarge ? "w-[185px] pl-[10px]" : "w-full pl-[4px]"
                  ),
                  style: {
                    gridTemplateColumns: "auto minmax(0, 1fr)"
                  },
                  children: [
                    /* @__PURE__ */ jsx("div", { children: dateText ?? "Started:" }),
                    /* @__PURE__ */ jsx("div", { className: "truncate", children: dayjs(date_created).format("DD.MM.YYYY") }),
                    showYourStory && /* @__PURE__ */ jsxs(Fragment, { children: [
                      /* @__PURE__ */ jsx("div", { children: storyText ?? "Your story:" }),
                      " ",
                      /* @__PURE__ */ jsx("div", { className: "truncate", children: context?.name ?? storyMissingText })
                    ] }),
                    /* @__PURE__ */ jsx("div", { children: wordCounterText ?? "Words:" }),
                    /* @__PURE__ */ jsx("div", { className: "truncate", children: words ?? "0" })
                  ]
                }
              )
            ]
          }
        )
      ]
    }
  );
}

function History({
  headerText,
  dateText,
  storyText,
  wordCounterText,
  historyEmptyText,
  clearHistoryText,
  storyMissingText,
  // logo,
  items,
  loadItem,
  removeItems,
  clearHistory,
  closeHistory,
  fetchMoreItems,
  storageKey,
  hasMore = false,
  showYourStory = true
}) {
  const [isLayoutLarge, setIsLayoutLarge] = useState(
    Number(localStorage.getItem(`${storageKey}-panel-width`)) > 350
  );
  const [checkboxValues, setCheckboxValues] = useState(
    Object.fromEntries(items?.map((item) => [item.id, false]))
  );
  useEffect(() => {
    function listener(e) {
      if (isLayoutLarge && e.detail <= 350) setIsLayoutLarge(false);
      else if (!isLayoutLarge && e.detail > 350) setIsLayoutLarge(true);
    }
    window.addEventListener("onPanelResize", listener);
    return () => window.removeEventListener("onPanelResize", listener);
  }, [isLayoutLarge]);
  useEffect(() => {
    setCheckboxValues((prev) => {
      const newData = {};
      for (const item of items) {
        if (!Object.keys(prev).includes(item.id)) newData[item.id] = false;
        else newData[item.id] = prev[item.id];
      }
      return newData;
    });
  }, [items]);
  return /* @__PURE__ */ jsxs("div", { className: classNames("flex h-full flex-col"), children: [
    /* @__PURE__ */ jsx("div", { className: classNames("border-b px-[14px] py-[6px]"), children: /* @__PURE__ */ jsxs("div", { className: "flex items-center justify-between ", children: [
      /* @__PURE__ */ jsx("p", { className: "text-brand-body flex items-center gap-[10px] text-[15px] font-normal uppercase leading-[1.2em]", children: headerText }),
      /* @__PURE__ */ jsx("div", { className: "flex items-center justify-end gap-[8px]", children: /* @__PURE__ */ jsx(
        Close,
        {
          style: { color: "#363636", fontSize: 24 },
          className: "cursor-pointer",
          onClick: () => closeHistory && closeHistory()
        }
      ) })
    ] }) }),
    /* @__PURE__ */ jsx("div", { className: classNames("border-b px-[14px] py-[6px]"), children: /* @__PURE__ */ jsxs("div", { className: "flex flex-wrap items-center justify-between", children: [
      /* @__PURE__ */ jsx(
        Button,
        {
          onClick: () => {
            const checkboxes = Object.keys(checkboxValues).filter(
              (key) => checkboxValues[key] === true
            );
            if (!checkboxes.length) return;
            removeItems(checkboxes);
          },
          disabled: !Object.values(checkboxValues).some((value) => value === true),
          className: "!bg-brand-violet !h-[28px] rounded-md !bg-opacity-10 !p-1",
          children: /* @__PURE__ */ jsx(Delete, { fontSize: "small", className: "text-brand-violet" })
        }
      ),
      /* @__PURE__ */ jsx(
        Button,
        {
          onClick: () => items.length && clearHistory(),
          disabled: !items.length,
          className: "!text-brand-violet !bg-brand-violet !h-[28px] rounded-md !bg-opacity-10 !px-[6px] !py-[4px] !text-[13px] !font-medium uppercase",
          children: clearHistoryText
        }
      )
    ] }) }),
    /* @__PURE__ */ jsx("div", { id: "history-holder", className: "flex-1 overflow-y-auto overflow-x-clip", children: /* @__PURE__ */ jsx(
      InfiniteScroll,
      {
        next: () => fetchMoreItems && fetchMoreItems(),
        hasMore,
        loader: /* @__PURE__ */ jsx("div", { className: "flex h-10 items-center justify-center", children: /* @__PURE__ */ jsx(CircleNotch, { weight: "fill", size: 24, className: "text-brand-violet animate-spin" }) }),
        dataLength: items.length,
        scrollableTarget: "history-holder",
        className: "!overflow-clip",
        children: items?.length ? items?.map((item) => /* @__PURE__ */ jsx(
          HistoryItem,
          {
            ...item,
            isLayoutLarge,
            loadItem,
            isChecked: checkboxValues[item.id],
            switchIsChecked: ({ checkBoxName, checked }) => {
              setCheckboxValues((prev) => ({ ...prev, [checkBoxName]: checked }));
            },
            closeHistory,
            dateText,
            storyText,
            wordCounterText,
            storyMissingText,
            showYourStory
          },
          item.id
        )) : /* @__PURE__ */ jsx("div", { className: "flex items-center justify-center py-[120px]", children: /* @__PURE__ */ jsx("div", { className: "flex flex-col items-center gap-[10px]", children: /* @__PURE__ */ jsx("h2", { className: "text-brand-body px-2 text-center text-[30px] font-bold  uppercase leading-[1.2em]", children: historyEmptyText }) }) })
      }
    ) })
  ] });
}

function Microbutton({
  onClick,
  icon,
  text,
  variant = "solid",
  type = "primary",
  iconPlacement = "left",
  className = "",
  disabled = false,
  children,
  title,
  tooltipId,
  tooltipKeyname,
  hoverClasses,
  iconSize,
  id,
  textClasses = "",
  isLoading = false,
  ariaLabel
}) {
  const classes = {
    solid: "bg-brand-microbutton-solid-bg text-brand-microbutton-solid-text hover:bg-brand-microbutton-solid-bg-highlight",
    transparent: "bg-brand-microbutton-transparent-bg hover:bg-brand-microbutton-transparent-bg-highlight text-brand-microbutton-transparent-text hover:text-brand-microbutton-transparent-text-highlight",
    "transparent-light": "bg-brand-microbutton-transparent-light-bg hover:bg-brand-microbutton-transparent-light-bg-highlight text-brand-microbutton-transparent-light-text hover:text-brand-microbutton-transparent-light-text-highlight",
    grey: "bg-black/5 text-brand-body  capitalize hover:bg-[#D4D4D4]/50 hover:transition-all",
    plain: "",
    primary: "text-[12px] p-[5px] px-2",
    "large-size": "text-[12px] px-3 py-2",
    "large-font": "text-[13px] px-3 py-2",
    main: "text-[12px] leading-[1.5em] px-3 py-2",
    tiny: "text-[12px] px-[5px] py-[7px]",
    frosted: "bg-brand-microbutton-frosted-bg hover:bg-brand-microbutton-frosted-bg-highlight backdrop-blur-sm text-brand-microbutton-frosted-text",
    outlined: "bg-white text-[#534B4F] border border-[#E6E2DE] hover:border-[#D0CCC9] hover:bg-[#FAFAFA]",
    "gray-dark": "bg-[#534B4F] text-white border-none shadow-[0_4px_10px_rgba(83,75,79,0.2)] hover:bg-[#3E383B]",
    "gray-dark-pill": "h-[40px] shrink-0 !rounded-[30px] bg-[#534b4f] px-3 !text-[13px] font-semibold uppercase tracking-[0.03em] text-white shadow-[0_3px_8px_rgba(0,0,0,0.18)] transition-all duration-200 hover:bg-[#3f383c] hover:shadow-[0_4px_12px_rgba(0,0,0,0.22)] sm:px-4",
    red: "w-full p-4 rounded-[12px] bg-brand-red text-white border-none text-[15px] font-bold uppercase tracking-[1px] shadow-[0_4px_12px_rgba(227,0,34,0.3)] transition-[background_0.2s,box-shadow_0.2s] hover:bg-brand-red-dark",
    "red-pill": "!rounded-[30px] bg-[#e30022] px-5 py-2.5 !text-[13px] font-semibold text-white shadow-[0_4px_12px_rgba(227,0,34,0.3)] transition-all duration-200 hover:bg-[#c9001f] hover:shadow-[0_4px_14px_rgba(227,0,34,0.35)]"
  };
  const baseTextClasses = {
    solid: "text-[12px]",
    transparent: "text-[12px]",
    "transparent-light": "text-[12px]",
    plain: "text-[12px]",
    primary: "text-[12px]",
    "large-size": "text-[12px]",
    "large-font": "text-[13px]",
    main: "text-[15px] leading-[1.5em]",
    tiny: "text-[12px]",
    frosted: "text-[12px]"
  };
  const variantTextOverrides = {
    "gray-dark-pill": "!text-[13px] font-semibold uppercase tracking-[0.03em]",
    "red-pill": "!text-[13px] font-semibold"
  };
  const iconSizes = {
    primary: 18,
    "large-size": 24,
    "large-font": 24,
    main: 24,
    tiny: 14
  };
  return /* @__PURE__ */ jsx(
    "button",
    {
      id,
      type: "button",
      title,
      "aria-label": ariaLabel,
      "data-tooltip-id": tooltipId,
      "data-tooltip-keyname": tooltipKeyname,
      className: classNames(
        className,
        hoverClasses,
        classes[variant],
        classes[type],
        "group relative flex cursor-pointer select-none items-center justify-center gap-[3px] rounded-[12px] transition-all active:scale-[0.97] disabled:opacity-50"
      ),
      disabled: disabled || isLoading,
      onClick: (e) => onClick && onClick(e),
      children: /* @__PURE__ */ jsxs(Fragment, { children: [
        isLoading && /* @__PURE__ */ jsx("div", { className: "absolute inset-0 flex items-center justify-center", children: /* @__PURE__ */ jsx(
          CircularProgress,
          {
            size: iconSize ?? iconSizes[type],
            sx: { animationDuration: "1000ms" },
            color: "inherit",
            disableShrink: true
          }
        ) }),
        iconPlacement === "left" && icon && /* @__PURE__ */ jsx(
          "div",
          {
            className: classNames("flex", isLoading && "opacity-0"),
            style: { fontSize: `${iconSize ?? iconSizes[type]}px` },
            children: icon
          }
        ),
        text && /* @__PURE__ */ jsx(
          "div",
          {
            className: classNames(
              "truncate px-[3px] text-center font-medium",
              variantTextOverrides[variant] ?? baseTextClasses[type],
              textClasses,
              isLoading && "opacity-0"
            ),
            children: text
          }
        ),
        iconPlacement === "right" && icon && /* @__PURE__ */ jsx(
          "div",
          {
            className: classNames("flex", isLoading && "opacity-0"),
            style: { fontSize: `${iconSize ?? iconSizes[type]}px` },
            children: icon
          }
        ),
        children && /* @__PURE__ */ jsx("div", { className: classNames("flex", isLoading && "opacity-0"), children })
      ] })
    }
  );
}

const LanguageSelector = memo(function LanguageSelector2({
  onClick,
  language,
  label,
  languages,
  translations,
  tooltipId,
  tooltipKeyname,
  microButtonVariant,
  showAllLanguagesButton = true,
  buttonTextClassOverrides,
  labelWrapperClassOverrides,
  portalContainer,
  uiAddOn,
  callback,
  isPopupOpen,
  isCompact = false,
  buttonElement
}) {
  if (isCompact) microButtonVariant = "transparent-light";
  else microButtonVariant = "transparent";
  const [anchorEl, setAnchorEl] = useState(null);
  const popoverRef = useRef();
  const [showAll, setShowAll] = useState(false);
  const [filter, setFilter] = useState("");
  const [hideFromDom, setHideFromDom] = useState(true);
  let filteredLanguages = languages;
  if (filter.length)
    filteredLanguages = filteredLanguages.filter(
      (item) => item?.label?.toLowerCase().includes(filter.toLowerCase())
    );
  useEffect(() => {
    setShowAll(false);
  }, [anchorEl]);
  useEffect(() => {
    const timeout = setTimeout(() => popoverRef?.current?.updatePosition(), 150);
    return clearTimeout(timeout);
  }, [showAll]);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    setHideFromDom(false);
    isPopupOpen?.(true);
  };
  const handleClose = () => {
    setAnchorEl(null);
    isPopupOpen?.(false);
    setHideFromDom(true);
  };
  const open = Boolean(anchorEl);
  const id = open ? "language-popover" : void 0;
  return /* @__PURE__ */ jsxs("div", { "data-tooltip-id": tooltipId, "data-tooltip-keyname": tooltipKeyname, children: [
    /* @__PURE__ */ jsx("div", { onClick: handleClick, children: buttonElement ?? /* @__PURE__ */ jsx(
      Microbutton,
      {
        iconPlacement: "none",
        variant: microButtonVariant,
        className: classNames(
          "px-2",
          isCompact ? {
            "h-[28px]": true,
            "hover:!bg-brand-form-accent !bg-transparent": !language.code
          } : "h-[30px]"
        ),
        "aria-describedby": id,
        textClasses: buttonTextClassOverrides,
        children: /* @__PURE__ */ jsxs(
          "div",
          {
            className: classNames(
              "flex flex-1 items-center gap-2 text-[12px] capitalize",
              (language.code || !isCompact) && "font-medium",
              buttonTextClassOverrides
            ),
            children: [
              !isCompact && /* @__PURE__ */ jsx("div", { className: "flex-1", children: label }),
              /* @__PURE__ */ jsxs(
                "div",
                {
                  className: classNames(
                    "flex items-center gap-2",
                    !isCompact && "w-[85px] justify-end",
                    labelWrapperClassOverrides
                  ),
                  children: [
                    !isCompact && /* @__PURE__ */ jsx(
                      "div",
                      {
                        className: classNames("border-brand-violet/10 h-[14px] border-r", {
                          "group-hover:border-white/10": microButtonVariant !== "grey"
                        })
                      }
                    ),
                    /* @__PURE__ */ jsx("div", { className: "truncate text-end", children: isCompact ? language.code ? /* @__PURE__ */ jsx("span", { className: "uppercase", children: language.code }) : label : language.label })
                  ]
                }
              )
            ]
          }
        )
      }
    ) }),
    /* @__PURE__ */ jsx(
      Popover,
      {
        action: popoverRef,
        id,
        open,
        hidden: hideFromDom,
        anchorEl,
        ...portalContainer ? { container: portalContainer } : {},
        onClose: handleClose,
        anchorOrigin: {
          vertical: "top",
          horizontal: "left"
        },
        transformOrigin: {
          vertical: "bottom",
          horizontal: "left"
        },
        children: /* @__PURE__ */ jsxs(
          "div",
          {
            className: classNames(
              "h-[400px] rounded-[4px] bg-white transition-all"
              // showAll ? 'w-[730px]' : 'w-[310px]'
            ),
            style: {
              width: showAll ? `calc(310px + ${Math.ceil(Math.max(filteredLanguages.length - 20, 0) / 10) * 140}px)` : "310px"
            },
            children: [
              /* @__PURE__ */ jsxs("div", { className: "flex justify-between gap-1 border-b px-6 py-3", children: [
                /* @__PURE__ */ jsx("div", { className: "h-[28px] flex-1", children: /* @__PURE__ */ jsx(
                  "input",
                  {
                    autoFocus: true,
                    type: "text",
                    placeholder: translations.searchPlaceholder,
                    value: filter,
                    onChange: (e) => setFilter(e.target.value),
                    className: "h-full w-full text-[14px] outline-none"
                  }
                ) }),
                filteredLanguages.length > 20 && showAllLanguagesButton ? /* @__PURE__ */ jsx(
                  Microbutton,
                  {
                    iconPlacement: "right",
                    icon: showAll ? /* @__PURE__ */ jsx(ChevronLeft, { fontSize: "inherit" }) : /* @__PURE__ */ jsx(ChevronRight, { fontSize: "inherit" }),
                    variant: microButtonVariant,
                    text: !showAll && translations.showAll,
                    onClick: () => setShowAll((prev) => !prev),
                    className: "hidden sm:flex"
                  }
                ) : null
              ] }),
              /* @__PURE__ */ jsx(
                "div",
                {
                  className: classNames("px-5", {
                    "pb-0 pt-[14px]": uiAddOn,
                    "py-[14px]": !uiAddOn
                  }),
                  children: /* @__PURE__ */ jsx("div", { className: "flex h-full max-h-[320px] w-[310px] flex-wrap gap-x-[10px] overflow-auto text-[13px] sm:w-full sm:flex-col sm:overflow-clip", children: filteredLanguages.length ? filteredLanguages.map((lang) => /* @__PURE__ */ jsx(
                    "div",
                    {
                      className: classNames(
                        "w-[130px] cursor-pointer rounded-[4px] p-[6px] capitalize transition-colors",
                        lang.value === language.value ? "bg-brand-violet/30" : "hover:bg-brand-violet/20"
                      ),
                      onClick: () => {
                        onClick({ value: lang.value, label: lang.label, code: lang.code });
                        callback?.();
                        handleClose();
                      },
                      children: lang.label
                    },
                    lang.value
                  )) : translations.languageNotFound })
                }
              ),
              /* @__PURE__ */ jsx("div", { children: uiAddOn })
            ]
          }
        )
      }
    )
  ] });
});

const iconMap$3 = {
  story: /* @__PURE__ */ jsx(ArticleOutlined, { fontSize: "inherit", className: "fill-brand-violet w-[15px]" }),
  document: /* @__PURE__ */ jsx(DescriptionOutlined, { fontSize: "inherit", className: "fill-brand-violet w-[15px]" }),
  website: /* @__PURE__ */ jsx(WebAssetOutlined, { fontSize: "inherit", className: "fill-brand-violet w-[15px]" })
};
const ConversationContext = memo(function ConversationContext2({
  translations,
  documentContext,
  docOptions = ["documents", "websites", "stories"],
  tooltipId,
  tooltipKeyname,
  callback,
  isPopupOpen,
  id,
  portalContainer,
  popoverClassOverrides,
  popoverClasses,
  isCompact = false
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const handleClose = () => {
    setAnchorEl(null);
    isPopupOpen?.(false);
  };
  const open = Boolean(anchorEl);
  const popoverId = open ? "context-popover" : void 0;
  const stories = documentContext.docContext?.filter((doc) => doc.type === "story");
  const websites = documentContext.docContext?.filter((doc) => doc.type === "website");
  const documents = documentContext.docContext?.filter((doc) => doc.type === "document");
  return /* @__PURE__ */ jsxs("div", { "data-tooltip-id": tooltipId, "data-tooltip-keyname": tooltipKeyname, children: [
    /* @__PURE__ */ jsx(
      Microbutton,
      {
        id,
        iconPlacement: "none",
        variant: "transparent",
        onClick: () => {
          callback?.();
          documentContext.openModal();
        },
        className: classNames(
          "h-[30px]"
          // isCompact
          //   ? {
          //       'h-[28px]': true,
          //       'hover:!bg-brand-form-accent !bg-transparent': !documentContext.docContext.length,
          //     }
          //   : 'h-[30px]'
        ),
        "aria-describedby": id,
        children: isCompact ? /* @__PURE__ */ jsx("div", { className: classNames("flex items-center text-nowrap text-[12px] font-medium"), children: translations.buttonLabel + (documentContext.docContext.length ? ": " + documentContext.docContext.length : "") }) : /* @__PURE__ */ jsxs("div", { className: "flex min-w-[150px] items-center justify-between gap-2 text-[12px] font-medium", children: [
          translations.buttonLabel,
          /* @__PURE__ */ jsx("div", { className: "border-brand-violet/10 h-[14px] flex-1 border-r group-hover:border-white/10" }),
          /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-1", children: [
            /* @__PURE__ */ jsx("div", { className: "max-w-[75px] truncate", children: documentContext.docContext[0]?.label ?? translations.noContextSelected }),
            documentContext.docContext.length > 1 ? `+${documentContext.docContext.length - 1}` : "",
            /* @__PURE__ */ jsx("span", { className: "group flex min-w-[15px] text-[14px]", children: /* @__PURE__ */ jsx(Article, { fontSize: "inherit", className: "fill-brand-violet group-hover:fill-white" }) })
          ] })
        ] })
      }
    ),
    /* @__PURE__ */ jsx(
      Popover,
      {
        id: popoverId,
        open,
        anchorEl,
        ...portalContainer ? { container: portalContainer } : {},
        ...popoverClasses ? { classes: popoverClasses } : {},
        onClose: handleClose,
        anchorOrigin: {
          vertical: "top",
          horizontal: "right"
        },
        transformOrigin: {
          vertical: "bottom",
          horizontal: "right"
        },
        children: /* @__PURE__ */ jsx(
          "div",
          {
            className: classNames(
              "w-[250px] rounded-[4px] bg-white transition-all",
              popoverClassOverrides
            ),
            children: /* @__PURE__ */ jsx("div", { className: "p-2 pb-[10px]", children: /* @__PURE__ */ jsxs("div", { className: "flex flex-col text-[13px] sm:w-full", children: [
              docOptions.includes("stories") && Boolean(stories.length) && /* @__PURE__ */ jsxs(Fragment, { children: [
                /* @__PURE__ */ jsxs("div", { className: "text-brand-violet flex items-center gap-[6px] p-[6px] text-[13px]", children: [
                  iconMap$3.story,
                  /* @__PURE__ */ jsxs("span", { className: "font-medium", children: [
                    " ",
                    translations.storiesLabel
                  ] })
                ] }),
                /* @__PURE__ */ jsx("div", { className: "text-brand-violet pl-[19px] text-[13px]", children: stories.map((doc) => /* @__PURE__ */ jsxs(
                  "div",
                  {
                    className: "hover:bg-brand-violet/10 group relative flex items-center gap-x-[10px] rounded-[4px] bg-white p-[6px] transition-all duration-300",
                    children: [
                      /* @__PURE__ */ jsx("div", { className: "flex-1 truncate", children: doc.label }),
                      /* @__PURE__ */ jsx(
                        "div",
                        {
                          className: "hover:bg-brand-violet/10 -my-2 flex !size-[26px] cursor-pointer items-center justify-center rounded-[4px] text-[18px] opacity-0 transition-colors group-hover:opacity-100",
                          onClick: () => documentContext.removeDocument(doc.id),
                          children: /* @__PURE__ */ jsx(Close, { fontSize: "inherit", className: "fill-brand-violet w-[15px]" })
                        }
                      )
                    ]
                  },
                  doc.id
                )) }),
                /* @__PURE__ */ jsx("div", { className: "my-[8px] border-b" })
              ] }),
              docOptions.includes("documents") && Boolean(documents.length) && /* @__PURE__ */ jsxs(Fragment, { children: [
                /* @__PURE__ */ jsxs("div", { className: "text-brand-violet flex items-center justify-between gap-[6px] p-[6px] text-[13px]", children: [
                  /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-[6px]", children: [
                    iconMap$3.document,
                    /* @__PURE__ */ jsxs("span", { className: "font-medium", children: [
                      " ",
                      translations.documentsLabel
                    ] })
                  ] }),
                  /* @__PURE__ */ jsx("span", { className: "text-brand-violet/50", children: "PDF, DOC, TXT, CSV" })
                ] }),
                /* @__PURE__ */ jsx("div", { className: "text-brand-violet pl-[19px] text-[13px]", children: documents.map((doc) => /* @__PURE__ */ jsxs(
                  "div",
                  {
                    className: "hover:bg-brand-violet/10 group relative flex items-center gap-x-[10px] rounded-[4px] bg-white p-[6px] transition-all duration-300",
                    children: [
                      /* @__PURE__ */ jsx("div", { className: "flex-1 truncate", children: doc.label }),
                      /* @__PURE__ */ jsx(
                        "div",
                        {
                          className: "hover:bg-brand-violet/10 -my-2 flex !size-[26px] cursor-pointer items-center justify-center rounded-[4px] text-[18px] opacity-0 transition-colors group-hover:opacity-100",
                          onClick: () => documentContext.removeDocument(doc.id),
                          children: /* @__PURE__ */ jsx(Close, { fontSize: "inherit", className: "fill-brand-violet w-[15px]" })
                        }
                      )
                    ]
                  },
                  doc.id
                )) }),
                /* @__PURE__ */ jsx("div", { className: "my-[8px] border-b" })
              ] }),
              docOptions.includes("websites") && Boolean(websites.length) && /* @__PURE__ */ jsxs(Fragment, { children: [
                /* @__PURE__ */ jsxs("div", { className: "text-brand-violet flex items-center gap-[6px] p-[6px] text-[13px]", children: [
                  iconMap$3.website,
                  /* @__PURE__ */ jsxs("span", { className: "font-medium", children: [
                    " ",
                    translations.websitesLabel
                  ] })
                ] }),
                /* @__PURE__ */ jsx("div", { className: "text-brand-violet pl-[14px] text-[13px]", children: websites.map((doc) => /* @__PURE__ */ jsxs(
                  "div",
                  {
                    className: "hover:bg-brand-violet/10 group relative flex items-center gap-x-[10px] rounded-[4px] bg-white p-[6px] transition-all duration-300",
                    children: [
                      /* @__PURE__ */ jsx("div", { className: "flex-1 truncate", children: doc.label }),
                      /* @__PURE__ */ jsx(
                        "div",
                        {
                          className: "hover:bg-brand-violet/10 -my-2 flex !size-[26px] cursor-pointer items-center justify-center rounded-[4px] text-[18px] opacity-0 transition-colors group-hover:opacity-100",
                          onClick: () => documentContext.removeDocument(doc.id),
                          children: /* @__PURE__ */ jsx(Close, { fontSize: "inherit", className: "fill-brand-violet w-[15px]" })
                        }
                      )
                    ]
                  },
                  doc.id
                )) }),
                /* @__PURE__ */ jsx("div", { className: "my-[8px] border-b" })
              ] }),
              /* @__PURE__ */ jsx("div", { className: "px-2", children: /* @__PURE__ */ jsx(
                Microbutton,
                {
                  iconPlacement: "left",
                  icon: /* @__PURE__ */ jsx(Add, { fontSize: "inherit", className: "fill-brand-violet w-[15px]" }),
                  variant: "transparent",
                  className: "h-[28px] w-full",
                  text: translations.addContextLabel,
                  onClick: () => {
                    callback?.();
                    handleClose();
                    documentContext.openModal();
                  }
                }
              ) })
            ] }) })
          }
        )
      }
    )
  ] });
});

const AttachFileDark = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20height='24px'%20viewBox='0%20-960%20960%20960'%20width='24px'%20fill='%23646464'%3e%3cpath%20d='M640-520v-200h80v200h-80ZM440-244q-35-10-57.5-39T360-350v-370h80v476Zm30%20164q-104%200-177-73t-73-177v-370q0-75%2052.5-127.5T400-880q75%200%20127.5%2052.5T580-700v300h-80v-300q-1-42-29.5-71T400-800q-42%200-71%2029t-29%2071v370q-1%2071%2049%20120.5T470-160q25%200%2047.5-6.5T560-186v89q-21%208-43.5%2012.5T470-80Zm170-40v-120H520v-80h120v-120h80v120h120v80H720v120h-80Z'/%3e%3c/svg%3e";

const AttachedFileWhite = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20height='24px'%20viewBox='0%20-960%20960%20960'%20width='24px'%20fill='%23FFFFFF'%3e%3cpath%20d='M640-520v-200h80v200h-80ZM440-244q-35-10-57.5-39T360-350v-370h80v476Zm30%20164q-104%200-177-73t-73-177v-370q0-75%2052.5-127.5T400-880q75%200%20127.5%2052.5T580-700v300h-80v-300q-1-42-29.5-71T400-800q-42%200-71%2029t-29%2071v370q-1%2071%2049%20120.5T470-160q25%200%2047.5-6.5T560-186v89q-21%208-43.5%2012.5T470-80Zm170-40v-120H520v-80h120v-120h80v120h120v80H720v120h-80Z'/%3e%3c/svg%3e";

function MessageContext({
  translations,
  tooltipId,
  tooltipKeyname,
  isDisabled,
  hideTooltip,
  handleShowWebCam,
  handleOpenModal,
  enableImages = true,
  handleImageUpload,
  handleDocumentUpload,
  id,
  disableWebsites = false,
  messageContextClassOverrides,
  showCameraContext = false
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);
  const popoverId = open ? "message-context-popover" : void 0;
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsxs(
      "button",
      {
        id,
        type: "button",
        "data-tooltip-id": tooltipId,
        "data-tooltip-keyname": tooltipKeyname,
        "data-tooltip-hidden": hideTooltip,
        "aria-describedby": id,
        className: classNames(
          "hover:bg-brand-violet xs:mt-[6px] text-brand-gray hover:text-brand-text-primary group ml-[6px] mt-0 flex size-[40px] items-center justify-center rounded-[4px] bg-black/5 transition-all sm:ml-0",
          isDisabled ? "pointer-events-none opacity-40" : "",
          messageContextClassOverrides
        ),
        onClick: handleClick,
        children: [
          /* @__PURE__ */ jsx("img", { src: AttachFileDark, className: "block group-hover:hidden", height: 30 }),
          /* @__PURE__ */ jsx("img", { src: AttachedFileWhite, className: "hidden group-hover:block", height: 30 })
        ]
      }
    ),
    /* @__PURE__ */ jsx(
      Popover,
      {
        id: popoverId,
        open,
        anchorEl,
        onClose: handleClose,
        anchorOrigin: {
          vertical: "top",
          horizontal: "right"
        },
        transformOrigin: {
          vertical: "bottom",
          horizontal: "right"
        },
        children: /* @__PURE__ */ jsx("div", { className: classNames("w-[250px] rounded-[10px] bg-white transition-all"), children: /* @__PURE__ */ jsxs("div", { className: "p-2 pb-[10px]", children: [
          /* @__PURE__ */ jsx("div", { className: "text-brand-violet p-[6px] text-[13px] font-medium opacity-80", children: translations.header }),
          /* @__PURE__ */ jsx("div", { className: "mx-[6px] my-2 border-b" }),
          /* @__PURE__ */ jsxs(
            "label",
            {
              htmlFor: "document-input",
              className: "text-brand-violet hover:bg-brand-violet/10 flex cursor-pointer items-center justify-between rounded-[6px] p-[6px] text-[13px] transition-colors",
              children: [
                /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-[6px]", children: [
                  /* @__PURE__ */ jsx("span", { className: "flex text-[14px]", children: /* @__PURE__ */ jsx(Add, { fontSize: "inherit" }) }),
                  /* @__PURE__ */ jsx("span", { className: "font-medium", children: translations.documentsLabel })
                ] }),
                /* @__PURE__ */ jsx("span", { className: "text-brand-violet/50", children: "PDF, DOC, TXT, CSV" }),
                /* @__PURE__ */ jsx(
                  "input",
                  {
                    id: "document-input",
                    multiple: true,
                    type: "file",
                    className: "hidden",
                    accept: "application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document,text/plain,text/csv",
                    onChange: (e) => {
                      handleDocumentUpload(e);
                      handleClose();
                    }
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "label",
            {
              htmlFor: "image-input",
              className: classNames(
                "text-brand-violet hover:bg-brand-violet/10 flex cursor-pointer items-center justify-between rounded-[6px] p-[6px] text-[13px] transition-colors",
                !enableImages && "pointer-events-none opacity-70"
              ),
              children: [
                /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-[6px]", children: [
                  /* @__PURE__ */ jsx("span", { className: "flex text-[14px]", children: /* @__PURE__ */ jsx(Add, { fontSize: "inherit" }) }),
                  /* @__PURE__ */ jsx("span", { className: "font-medium", children: translations.imagesLabel })
                ] }),
                /* @__PURE__ */ jsx("span", { className: "text-brand-violet/50", children: "JPG, PNG, WEBP" }),
                /* @__PURE__ */ jsx(
                  "input",
                  {
                    id: "image-input",
                    type: "file",
                    className: "hidden",
                    accept: "image/*",
                    onChange: (e) => {
                      handleImageUpload(e);
                      handleClose();
                    }
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "div",
            {
              className: classNames(
                "text-brand-violet hover:bg-brand-violet/10 flex cursor-pointer items-center gap-[6px] rounded-[6px] p-[6px] text-[13px] transition-colors",
                disableWebsites && "pointer-events-none opacity-80"
              ),
              onClick: () => {
                handleClose();
                handleOpenModal("website");
              },
              children: [
                /* @__PURE__ */ jsx("span", { className: "flex text-[14px]", children: /* @__PURE__ */ jsx(Add, { fontSize: "inherit" }) }),
                /* @__PURE__ */ jsx("span", { className: "font-medium", children: translations.websitesLabel })
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "div",
            {
              className: "text-brand-violet hover:bg-brand-violet/10 flex cursor-pointer items-center gap-[6px] rounded-[6px] p-[6px] text-[13px] transition-colors",
              onClick: () => {
                handleClose();
                handleOpenModal("story");
              },
              children: [
                /* @__PURE__ */ jsx("span", { className: "flex text-[14px]", children: /* @__PURE__ */ jsx(Add, { fontSize: "inherit" }) }),
                /* @__PURE__ */ jsx("span", { className: "font-medium", children: translations.storiesLabel })
              ]
            }
          ),
          showCameraContext ? /* @__PURE__ */ jsxs(
            "div",
            {
              className: classNames(
                "text-brand-violet hover:bg-brand-violet/10 flex cursor-pointer items-center gap-[6px] rounded-[6px] p-[6px] text-[13px] transition-colors",
                !enableImages && "pointer-events-none opacity-70"
              ),
              onClick: () => {
                handleClose();
                handleShowWebCam();
              },
              children: [
                /* @__PURE__ */ jsx("span", { className: "flex text-[14px]", children: /* @__PURE__ */ jsx(Add, { fontSize: "inherit" }) }),
                /* @__PURE__ */ jsx("span", { className: "font-medium", children: translations.cameraLabel })
              ]
            }
          ) : null
        ] }) })
      }
    )
  ] });
}

const ModelSelector = memo(function ModelSelector2({
  model,
  models,
  translations,
  handleModelChange,
  title,
  callback,
  isPopupOpen,
  portalContainer,
  className,
  id,
  origin = "top",
  isCompact = false
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    isPopupOpen?.(true);
  };
  const handleClose = () => {
    setAnchorEl(null);
    isPopupOpen?.(false);
  };
  const open = Boolean(anchorEl);
  const popoverId = open ? "context-popover" : void 0;
  return /* @__PURE__ */ jsxs("div", { title, children: [
    /* @__PURE__ */ jsx(
      Microbutton,
      {
        id,
        iconPlacement: "none",
        variant: isCompact ? "transparent-light" : "transparent",
        onClick: handleClick,
        className: classNames(
          isCompact ? { "h-[28px]": true, "hover:!bg-brand-form-accent !bg-transparent": model.isDefault } : "h-[30px] min-w-[150px]",
          className
        ),
        children: /* @__PURE__ */ jsxs(
          "div",
          {
            className: classNames(
              "flex flex-1 items-center justify-between gap-2 text-[12px]",
              !model.isDefault && "font-medium"
            ),
            children: [
              !isCompact && /* @__PURE__ */ jsxs(Fragment, { children: [
                /* @__PURE__ */ jsx("div", { className: "flex-1", children: translations.buttonLabel }),
                /* @__PURE__ */ jsx("div", { className: "border-brand-violet/10 h-[14px] border-r group-hover:border-white/10" })
              ] }),
              /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-1", children: [
                /* @__PURE__ */ jsx("div", { className: "truncate break-keep capitalize", children: model.isDefault ? translations.defaultModel : model.label?.replace("Claude ", "") }),
                !isCompact && /* @__PURE__ */ jsx(Sparkle, { size: 14, weight: "fill" })
              ] })
            ]
          }
        )
      }
    ),
    /* @__PURE__ */ jsx(
      Popover,
      {
        id: popoverId,
        ...portalContainer ? { container: portalContainer } : {},
        open,
        anchorEl,
        onClose: handleClose,
        anchorOrigin: {
          vertical: origin,
          horizontal: "left"
        },
        transformOrigin: {
          vertical: origin === "top" ? "bottom" : "top",
          horizontal: "left"
        },
        children: /* @__PURE__ */ jsx("div", { className: "w-[300px] rounded-[4px] bg-white transition-all", children: /* @__PURE__ */ jsxs("div", { className: "flex flex-col p-2 pr-1", children: [
          /* @__PURE__ */ jsxs("div", { className: "text-brand-violet p-[6px]", children: [
            /* @__PURE__ */ jsx("div", { className: "text-[13px] font-medium", children: translations.popupTitle }),
            /* @__PURE__ */ jsx("div", { className: "text-[12px]", children: translations.popupDescription })
          ] }),
          /* @__PURE__ */ jsx("div", { className: "mx-[7px] my-2 border-b" }),
          /* @__PURE__ */ jsx("div", { className: "flex max-h-[500px] flex-col overflow-y-auto pr-1", children: models.map((option) => /* @__PURE__ */ jsxs(
            "label",
            {
              htmlFor: option.value,
              className: "text-brand-violet hover:bg-brand-violet/10 cursor-pointer rounded-[4px] p-[6px] transition-colors",
              children: [
                /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-2", children: [
                  /* @__PURE__ */ jsxs("div", { className: "relative flex items-center justify-center", children: [
                    /* @__PURE__ */ jsx(
                      "input",
                      {
                        id: option.value,
                        type: "radio",
                        name: "chat-model",
                        className: "border-brand-violet text-brand-violet peer relative h-3 w-3 cursor-pointer appearance-none rounded-full border transition-all ",
                        value: option.value,
                        checked: option.value === model.value,
                        onChange: () => {
                          handleModelChange(option);
                          handleClose();
                          callback?.();
                        }
                      }
                    ),
                    /* @__PURE__ */ jsx("span", { className: "text-brand-violet pointer-events-none absolute left-2/4 top-2/4 -translate-x-2/4 -translate-y-2/4 opacity-0 transition-opacity peer-checked:opacity-100", children: /* @__PURE__ */ jsx(
                      "svg",
                      {
                        xmlns: "http://www.w3.org/2000/svg",
                        className: "size-[6px]",
                        viewBox: "0 0 16 16",
                        fill: "currentColor",
                        children: /* @__PURE__ */ jsx("circle", { "data-name": "ellipse", cx: "8", cy: "8", r: "8" })
                      }
                    ) })
                  ] }),
                  /* @__PURE__ */ jsx("div", { className: classNames("text-[13px]", option.isGuru && "font-medium"), children: `${option.label}${option.isDefault ? ` (${translations.defaultModel})` : ""}` })
                ] }),
                /* @__PURE__ */ jsx("div", { className: "ml-[21px] text-[12px] leading-[1.3em] opacity-70", children: option.description })
              ]
            },
            option.value
          )) })
        ] }) })
      }
    )
  ] });
});

function ListPosition({
  height = 30,
  padding = 6,
  text,
  icon,
  iconPlacement = "right",
  className,
  type = "primary",
  onClick,
  disabled = false
}) {
  const typeClasses = { primary: "font-medium", secondary: "" };
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: classNames(
        className,
        typeClasses[type],
        "text-brand-violet flex items-center rounded-[4px]",
        onClick && "hover:bg-brand-form-accent-light cursor-pointer transition-all",
        disabled && "pointer-events-none opacity-50"
      ),
      style: { paddingLeft: `${padding}px`, paddingRight: `${padding}px`, height: `${height}px` },
      onClick,
      children: /* @__PURE__ */ jsxs(
        "div",
        {
          className: classNames(
            "flex min-w-0 flex-1 items-center gap-2 truncate",
            iconPlacement === "right" && "justify-between"
          ),
          children: [
            iconPlacement === "left" && /* @__PURE__ */ jsx("div", { className: "flex text-[14px]", children: icon }),
            /* @__PURE__ */ jsx("div", { className: "flex items-center gap-1 truncate text-[13px]", children: text }),
            iconPlacement === "right" && /* @__PURE__ */ jsx("div", { className: "flex text-[14px]", children: icon })
          ]
        }
      )
    }
  );
}

function BasicTooltip({
  title,
  content,
  id,
  place = "top-start",
  delayShow
}) {
  return /* @__PURE__ */ jsx(
    Tooltip,
    {
      disableStyleInjection: true,
      id,
      place,
      opacity: 100,
      noArrow: true,
      style: {
        backgroundColor: "#EFEFF8",
        padding: 0,
        boxShadow: "0px 0px 6px rgba(0, 0, 0, 0.25)"
      },
      delayShow,
      children: /* @__PURE__ */ jsxs("div", { className: "text-brand-violet-light w-[250px] space-y-[6px] px-[14px] py-[12px]", children: [
        title && /* @__PURE__ */ jsx("div", { className: "text-[13px] font-bold leading-[1.2em]", children: title }),
        /* @__PURE__ */ jsx("div", { className: "text-[12px] leading-[1.2em]", children: content })
      ] })
    }
  );
}

let currentOpenTooltipId = null;
const tooltipCloseCallbacks = /* @__PURE__ */ new Map();
const MuiTooltip = styled(
  ({
    content,
    title,
    portalContainer,
    className,
    titleClassOverrides,
    offset = [0, 0],
    fontSize = 12,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    borderColor: _borderColor,
    ...props
  }) => {
    const [open, setOpen] = useState(false);
    const { width } = useWindowDimensions();
    const tooltipIdRef = useRef(`tooltip-${Math.random().toString(36).substr(2, 9)}`);
    const handleTooltipClose = useCallback(() => {
      setOpen(false);
      if (currentOpenTooltipId === tooltipIdRef.current) {
        currentOpenTooltipId = null;
      }
    }, []);
    const handleTooltipOpen = useCallback(() => {
      if (currentOpenTooltipId && currentOpenTooltipId !== tooltipIdRef.current) {
        const closeCallback = tooltipCloseCallbacks.get(currentOpenTooltipId);
        if (closeCallback) {
          closeCallback();
        }
      }
      setOpen(true);
      currentOpenTooltipId = tooltipIdRef.current;
    }, []);
    const isMobile = width <= 768;
    useEffect(() => {
      const tooltipId = tooltipIdRef.current;
      tooltipCloseCallbacks.set(tooltipId, handleTooltipClose);
      return () => {
        tooltipCloseCallbacks.delete(tooltipId);
        if (currentOpenTooltipId === tooltipId) {
          currentOpenTooltipId = null;
        }
      };
    }, [handleTooltipClose]);
    useEffect(() => {
      if (!isMobile || !open) return void 0;
      const handleScroll = () => {
        handleTooltipClose();
      };
      window.addEventListener("scroll", handleScroll, { passive: true });
      document.addEventListener("scroll", handleScroll, { passive: true, capture: true });
      return () => {
        window.removeEventListener("scroll", handleScroll);
        document.removeEventListener("scroll", handleScroll, { capture: true });
      };
    }, [isMobile, open, handleTooltipClose]);
    if (!content && !title) {
      return /* @__PURE__ */ jsx(Fragment, { children: props.children });
    }
    return /* @__PURE__ */ jsx(ClickAwayListener, { onClickAway: handleTooltipClose, children: /* @__PURE__ */ jsx(
      Tooltip$1,
      {
        ...props,
        ...(isMobile || props.openOnClick) && {
          open,
          onClose: handleTooltipClose,
          onOpen: handleTooltipOpen,
          onClick: (e) => {
            e.stopPropagation();
            e.preventDefault();
            handleTooltipOpen();
          },
          autoFocus: true,
          disableFocusListener: true,
          disableHoverListener: true,
          disableTouchListener: true
          // slotProps: {
          //   popper: {
          //     disablePortal: true,
          //   },
          // },
        },
        enterDelay: props.enterDelay,
        classes: { popper: className },
        title: /* @__PURE__ */ jsxs(
          "div",
          {
            className: classNames(
              "text-brand-violet-light space-y-[6px] whitespace-pre-line px-[14px] py-[12px]",
              titleClassOverrides
            ),
            children: [
              title && /* @__PURE__ */ jsx("div", { className: "text-[13px] font-bold leading-[1.2em]", children: title }),
              content && /* @__PURE__ */ jsx("div", { style: { fontSize: `${fontSize}px` }, className: "leading-[1.2em] opacity-80", children: content })
            ]
          }
        ),
        PopperProps: {
          ...props.PopperProps,
          container: portalContainer,
          modifiers: [
            {
              name: "offset",
              options: {
                offset
              }
            },
            ...props.PopperProps?.modifiers || []
          ]
        }
      }
    ) });
  }
)(
  ({
    borderColor = "rgba(var(--brand-accent-light-flat))",
    shadow = "0px 0px 6px rgba(0, 0, 0, 0.25)",
    backgroundColor = "rgba(var(--brand-accent-light-flat))",
    additionalStyles
  }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor,
      padding: 0,
      boxShadow: shadow,
      border: `1px solid ${borderColor}`,
      maxWidth: "min(500px, 95dvw)",
      ...additionalStyles
    }
  })
);

const TypingAnimation = ({ words }) => {
  const sequence = [];
  for (let i = 0; i < words.length; ++i) {
    sequence.push(words[i]);
    sequence.push(4e3);
  }
  return /* @__PURE__ */ jsx(
    TypeAnimation,
    {
      sequence,
      wrapper: "span",
      cursor: true,
      repeat: Infinity
    },
    words[0]
  );
};

const AudioPlayer = ({
  streamSource,
  setSource,
  callback
}) => {
  const audioRef = useRef();
  const howlerRef = useRef(
    new Howl({
      src: [URL.createObjectURL(getMediaSource().mediaSource)],
      autoplay: true,
      html5: true,
      format: "mp3",
      onunlock: () => howlerRef.current.play()
    })
  );
  const getAudio = () => {
    const audio = document.createElement("audio");
    audio.disableRemotePlayback = true;
    audio.controls = true;
    audio.autoplay = true;
    audio.style.display = "none";
    audio.src = `${process.env["PUBLIC_URL"]}/assets/silent.mp3`;
    const b = document.body;
    const events = ["touchend", "mousedown"];
    events.forEach((e) => b.addEventListener(e, unlock, false));
    function unlock() {
      if (audio.currentTime > 0) return clean();
      audio.play().then(clean).catch((e) => console.log(e));
    }
    function clean() {
      events.forEach((e) => b.removeEventListener(e, unlock));
    }
    document.body.appendChild(audio);
    return audio;
  };
  useEffect(() => {
    if (window.MediaSource) return () => {
    };
    audioRef.current = getAudio();
    return () => {
      document.body.removeChild(audioRef.current);
    };
  }, []);
  useEffect(() => {
    if (!streamSource) return () => {
    };
    const { mediaSource, isIOS } = getMediaSource();
    let audio;
    if (isIOS) {
      audio = audioRef.current;
    } else {
      audio = howlerRef.current;
      audio.unload();
      audio._src = [URL.createObjectURL(mediaSource)];
      audio.load();
    }
    const sourceOpenHandler = async () => {
      try {
        const sourceBuffer = mediaSource.addSourceBuffer("audio/mpeg");
        const reader = streamSource.getReader();
        const processStream = ({ done, value }) => {
          try {
            if (done) {
              if (sourceBuffer.updating)
                return setTimeout(() => processStream({ done, value }), 100);
              if (mediaSource.readyState === "ended") return;
              return mediaSource.endOfStream();
            }
            if (!sourceBuffer.updating) {
              sourceBuffer.appendBuffer(value);
            } else {
              return setTimeout(() => processStream({ done, value }), 100);
            }
            reader.read().then(processStream);
          } catch (err) {
            console.log(err);
          }
        };
        reader.read().then(processStream);
      } catch (error) {
        console.error("Error handling MediaSource", error);
      }
    };
    const handlePlaybackEnd = () => {
      setSource(null);
      callback?.();
    };
    mediaSource.addEventListener("sourceopen", sourceOpenHandler);
    if (isIOS) {
      audio.addEventListener("ended", handlePlaybackEnd);
      audio.src = URL.createObjectURL(mediaSource);
    } else {
      audio.once("end", handlePlaybackEnd);
      audio.play();
    }
    return () => {
      mediaSource.removeEventListener("sourceopen", sourceOpenHandler);
      if (isIOS) {
        audio.removeEventListener("ended", handlePlaybackEnd);
        audio.pause();
        URL.revokeObjectURL(audio.src);
      } else {
        audio.off();
        audio.stop();
        audio._queue = [];
        URL.revokeObjectURL(audio._src);
        audio.unload();
      }
    };
  }, [streamSource, setSource, callback]);
  return null;
};
function getMediaSource() {
  if (window.MediaSource) {
    return { mediaSource: new window.MediaSource(), isIOS: false };
  }
  if (window.ManagedMediaSource) {
    return { mediaSource: new window.ManagedMediaSource(), isIOS: true };
  }
  throw new Error("No MediaSource API available");
}

function Badge({ text, color, paddingX = 4, paddingY = 0, className }) {
  const badgeClasses = {
    gray: "border-gray-300 bg-gray-100 text-gray-500",
    red: "border-brand-red text-brand-red bg-brand-red/20",
    green: "border-brand-green text-brand-green bg-[#A0D6B4]/20"
  };
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: classNames("text-nowrap rounded-md border", badgeClasses[color], className),
      style: { padding: `${paddingY}px ${paddingX}px` },
      children: text
    }
  );
}

const ToolGeneratorLayoutPrimary = ({
  topContent,
  options,
  actions
}) => {
  return /* @__PURE__ */ jsx("div", { className: "flex h-full", children: /* @__PURE__ */ jsxs("div", { className: "flex h-full w-full flex-col justify-between ", children: [
    /* @__PURE__ */ jsxs("div", { className: "flex h-[calc(100%-77px)] w-full flex-col", children: [
      topContent,
      /* @__PURE__ */ jsx(
        "div",
        {
          className: "flex h-full flex-col overflow-y-auto overflow-x-clip px-4 pt-4",
          style: { scrollbarGutter: "stable both-edges" },
          children: options
        }
      )
    ] }),
    /* @__PURE__ */ jsx("div", { className: "writer-actions bg-brand-grey-bg border-brand-gray-light sticky bottom-0 z-[30] flex items-center gap-[10px] border-t p-4", children: actions })
  ] }) });
};

const ToolLayoutPrimary = ({
  folded,
  setFolded,
  leftSideContent,
  rightSideContent,
  children,
  storageKey,
  breakpoint = 500,
  maxPanelWidth = 750,
  minPanelWidth = 320,
  useTabularLayout = false,
  tabs = {},
  mobileTabsId
}) => {
  const { width } = useWindowDimensions();
  const layoutLarge = width >= 1024;
  const panelMaxWidth = Math.min(maxPanelWidth, Math.floor(width * 0.5));
  const [activeTab, setActiveTab] = useState(Object.keys(tabs)?.[0]);
  if (!useTabularLayout)
    return /* @__PURE__ */ jsx("div", { className: "relative h-full", children: /* @__PURE__ */ jsxs("div", { className: "relative flex h-full flex-wrap overflow-y-auto lg:flex-nowrap", children: [
      layoutLarge ? /* @__PURE__ */ jsx(
        ResizableContainer,
        {
          isOpen: !folded,
          setIsOpen: (val) => setFolded(!val),
          storageKey,
          minWidth: minPanelWidth,
          initWidth: 600,
          maxWidth: panelMaxWidth,
          breakpoint,
          children: leftSideContent
        }
      ) : /* @__PURE__ */ jsx(
        "div",
        {
          className: classNames(" w-full", {
            "absolute hidden": folded
          }),
          children: leftSideContent
        }
      ),
      /* @__PURE__ */ jsxs("div", { className: classNames("relative", layoutLarge ? "flex-1" : "w-full"), children: [
        !layoutLarge && /* @__PURE__ */ jsx(
          "div",
          {
            className: classNames(
              "fold absolute -top-[15px] left-1/2 z-[10] flex h-[50px] w-[16px]  rotate-90 cursor-pointer items-center justify-center rounded-[4px] lg:left-0 lg:top-[50%] lg:rotate-0",
              {
                "bg-brand-green": !folded,
                "bg-[#36363680]": folded
              }
            ),
            onClick: () => setFolded((prev) => !prev),
            children: folded ? /* @__PURE__ */ jsx(ChevronRight, { style: { color: "#ffffff" } }) : /* @__PURE__ */ jsx(ChevronLeft, { style: { color: "#ffffff" } })
          }
        ),
        rightSideContent
      ] }),
      children
    ] }) });
  if (layoutLarge)
    return /* @__PURE__ */ jsx("div", { className: "relative h-full", children: /* @__PURE__ */ jsxs("div", { className: "bg-brand-grey-bg relative flex h-full flex-wrap lg:flex-nowrap", children: [
      /* @__PURE__ */ jsx(
        ResizableContainer,
        {
          isOpen: !folded,
          setIsOpen: (val) => setFolded(!val),
          storageKey,
          minWidth: minPanelWidth,
          initWidth: 600,
          maxWidth: panelMaxWidth,
          breakpoint,
          children: leftSideContent
        }
      ),
      /* @__PURE__ */ jsx("div", { className: "relative flex-1", children: rightSideContent })
    ] }) });
  return /* @__PURE__ */ jsxs("div", { className: "relative h-full", children: [
    /* @__PURE__ */ jsx("div", { id: mobileTabsId, className: "flex", children: Object.keys(tabs).map((tab) => /* @__PURE__ */ jsx(
      "div",
      {
        className: classNames(
          activeTab === tab ? "text-brand-violet border-brand-violet-light border-b-[3px] bg-[#F6F6FA] font-medium shadow-[0_0_5px_#00000025]" : "text-brand-violet-light opacity-80",
          " flex h-[40px] flex-1 items-center justify-center text-[12px] capitalize"
        ),
        onClick: () => setActiveTab(tab),
        children: /* @__PURE__ */ jsx("div", { children: tabs[tab].title })
      },
      tab
    )) }),
    /* @__PURE__ */ jsx("div", { className: "border-brand-form-accent-light h-[calc(100%-40px)] border-t shadow-[0_0_5px_#00000025]", children: tabs[activeTab].component })
  ] });
};

function ChatbotGeneratorHeader({
  handleHideModal,
  chatbotId,
  isDraft,
  chatBotList,
  t,
  translations = {},
  id
}) {
  return /* @__PURE__ */ jsxs("div", { id, className: "border-brand-form-accent flex items-center justify-between rounded-t-[4px] border-b py-[14px] pl-[24px] pr-[16px]", children: [
    /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-[10px]", children: [
      /* @__PURE__ */ jsx("span", { className: "dialog-title text-brand-violet font-medium", children: chatbotId ? t("eleo-edit-chatbot-named", "Edit {chatbotName}", {
        chatbotName: chatBotList.find((bot) => bot.id === chatbotId)?.name
      }) : translations.title ?? t("eleo-create-new-chatbot", "Create new chatbot") }),
      isDraft && /* @__PURE__ */ jsx("div", { className: "border-brand-gray-light flex rounded-[4px] border px-[6px] py-1", children: /* @__PURE__ */ jsx("span", { className: "text-brand-gray text-[12px] leading-[1.4em] opacity-75", children: t("eleo-draft", "Draft") }) })
    ] }),
    /* @__PURE__ */ jsx("div", { className: "flex gap-[10px]", children: /* @__PURE__ */ jsx(
      Microbutton,
      {
        variant: "plain",
        icon: /* @__PURE__ */ jsx(Close, { fontSize: "inherit" }),
        className: "hover:bg-brand-form-accent-light text-brand-violet",
        onClick: handleHideModal
      }
    ) })
  ] });
}

const displayToast = ({
  text,
  id,
  type = 'success',
  autoClose = 3000,
  isSafeBottomArea = false,
}) => {
  toast(text, {
    position: window.innerWidth > 768 ? 'bottom-right' : 'top-right',
    style: {
      marginBottom: isSafeBottomArea ? '5rem' : '1rem',
    },
    type: type,
    theme: 'colored',
    icon: false,
    toastId: id ?? text,
    autoClose: autoClose,
    closeOnClick: true,
  });
};

const successToast = (text, id, { autoClose, isSafeBottomArea } = {}) => {
  displayToast({ text, id, type: 'success', autoClose, isSafeBottomArea });
};

const errorToast = (text, id, { autoClose, isSafeBottomArea } = {}) => {
  displayToast({ text, id, type: 'error', autoClose, isSafeBottomArea });
};

const transformSelectOptionValue = (optionsArr, selectedValue, defaultVal) => {
  return optionsArr?.find((option) => option.value === selectedValue) || defaultVal
};

const detectRtlDirection = (selectedLanguage) => {
  return ['Farsi', 'Arabic', 'Hebrew'].includes(selectedLanguage)
};

const downloadFile = (file) => {
  if (file) {
    const fileUrl = window.URL.createObjectURL(file);

    const downloadLink = document.createElement('a');
    downloadLink.href = fileUrl;
    downloadLink.download = file.name;

    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);

    window.URL.revokeObjectURL(fileUrl);
  }
};

const isValidUrl = (urlString) => {
  try {
    return Boolean(new URL(urlString))
  } catch (e) {
    return false
  }
};

const CopyToClipBoard = async (text, notificationText, htmlContent) => {
  if (!text && !htmlContent) return
  try {
    if (htmlContent) {
      const inlinedText = inlineAllStyles(htmlContent);
      const textBlob = new Blob([text], { type: 'text/plain' });
      const htmlBlob = new Blob([inlinedText], { type: 'text/html' });

      const clipboardItem = new ClipboardItem({
        [htmlBlob.type]: htmlBlob,
        [textBlob.type]: textBlob,
      });

      await navigator.clipboard.write([clipboardItem]);
    } else await navigator.clipboard.writeText(text);

    successToast(notificationText ?? 'Successfully copied to clipboard', 'copy-toast');
    console.log('Async: Copying to clipboard was successful!');
    return true
  } catch (err) {
    console.error('Async: Could not copy text: ', err);
    errorToast(err.toString(), 'copy-error');
    return false
  }
};

function inlineAllStyles(htmlString) {
  const wrapper = document.createElement('div');
  wrapper.innerHTML = htmlString;
  document.body.appendChild(wrapper);

  const elements = wrapper.querySelectorAll('*');
  elements.forEach((el) => {
    const originalClasses = Array.from(el.classList);

    // Identify and remove 'hover:' classes
    const classesToRemove = originalClasses.filter((className) => className.startsWith('hover:'));
    el.classList.remove(...classesToRemove);

    const computedStyle = getComputedStyle(el);
    const styleString = Array.from(computedStyle)
      .filter((prop) => !prop.startsWith('background'))
      .map((prop) => {
        return `${prop}: ${computedStyle.getPropertyValue(prop)};`
      })
      .join(' ');
    el.style.cssText = styleString;

    el.classList.add(...classesToRemove);
  });

  const inlinedHtml = wrapper.innerHTML;
  document.body.removeChild(wrapper);

  return inlinedHtml
}

const processLatexDelimiters = (text) => {
  return text
    ?.replace(/\\\[/g, '$$$') // Replace all occurrences of \[ with $$
    ?.replace(/\\\]/g, '$$$') // Replace all occurrences of \] with $$
    ?.replace(/\\\(/g, '$$$') // Replace all occurrences of \( with $$
    ?.replace(/\\\)/g, '$$$') // Replace all occurrences of \) with $$
};

const handleCopyWithStyles = (e) => {
  e.preventDefault();

  const selection = window.getSelection();
  if (!selection || selection.rangeCount === 0) {
    return
  }

  const range = selection.getRangeAt(0);
  const clonedSelection = range.cloneContents();

  const container = document.createElement('div');
  container.appendChild(clonedSelection);

  applyComputedStyles(range, container);

  const selectedHtml = container.innerHTML;
  const selectedText = selection.toString();

  e.clipboardData.setData('text/html', selectedHtml);
  e.clipboardData.setData('text/plain', selectedText);
};

const applyComputedStyles = (range, container) => {
  const originalNodes = getNodesInRange(range);
  const clonedNodes = getAllNodes(container);

  for (let i = 0; i < originalNodes.length; i++) {
    const originalNode = originalNodes[i];
    const clonedNode = clonedNodes[i];

    if (originalNode.nodeType === Node.ELEMENT_NODE) {
      applyStyles(originalNode, clonedNode);
    } else if (originalNode.nodeType === Node.TEXT_NODE) {
      const originalParent = originalNode.parentNode;
      const clonedParent = clonedNode.parentNode;
      applyStyles(originalParent, clonedParent);
    }
  }
};

const getNodesInRange = (range) => {
  const nodes = [];
  const treeWalker = document.createTreeWalker(
    range.commonAncestorContainer,
    NodeFilter.SHOW_ALL,
    {
      acceptNode: (node) => {
        return range.intersectsNode(node) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT
      },
    },
    false
  );

  while (treeWalker.nextNode()) {
    nodes.push(treeWalker.currentNode);
  }

  return nodes
};

const getAllNodes = (container) => {
  const nodes = [];
  const treeWalker = document.createTreeWalker(container, NodeFilter.SHOW_ALL, null, false);

  while (treeWalker.nextNode()) {
    nodes.push(treeWalker.currentNode);
  }

  return nodes
};

const applyStyles = (originalNode, clonedNode) => {
  const computedStyle = window.getComputedStyle(originalNode);

  let cssText = '';
  for (let prop of computedStyle) {
    const value = computedStyle.getPropertyValue(prop);
    cssText += `${prop}: ${value}; `;
  }

  clonedNode.style.cssText = cssText;
};

function replaceLinksWithString(text) {
  const imgTagRegex = /<img\s+[^>]*src\s*=\s*['"][^'"]*['"][^>]*\/?>/gi;
  const text1 = text.replace(imgTagRegex, '"image"');
  const text2 = text1.replace('</img>', '');

  const urlRegex = /(https?:\/\/|www\.)[^\s/$.?#].[^\s]*/gi;

  return text2.replace(urlRegex, '"link"')
}

const transcribeLanguageCodeMap = {
  en: 'en',
  ar: 'ar-AE',
  fr: 'fr-FR',
  es: 'es-ES',
  tr: 'tr-TR',
  ru: 'ru-RU',
  ro: 'ro-RO',
  pt: 'pt-PT',
  pl: 'pl-PL',
  nl: 'nl-NL',
  it: 'it-IT',
  is: 'is-IS',
  fi: 'fi-FI',
  de: 'de-DE',
  yue: 'yue-CN',
  ko: 'ko-KR',
  hi: 'hi-IN',
  arb: 'arb',
  cs: 'cs-CZ',
  da: 'da-DK',
  sv: 'sv-SE',
  ja: 'ja-JP',
  ca: 'ca-ES',
};

async function downloadImage(imageUrl, name = null) {
  try {
    const image = await fetch(imageUrl, {
      mode: 'cors',
      cache: 'no-cache',
    });
    const blob = await image.blob();
    const data = window.URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = data;
    link.download = name || 'your-image.png';

    link.dispatchEvent(
      new MouseEvent('click', {
        bubbles: true,
        cancelable: true,
        view: window,
      })
    );

    // Firefox support
    setTimeout(() => {
      window.URL.revokeObjectURL(data);
      link.remove();
    }, 100);
  } catch (err) {
    errorToast("Couldn't download you image. Please try again");
  }
}

const FallbackImage = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAgAAAAIACAIAAAB7GkOtAAAAIGNIUk0AAHomAACAhAAA+gAAAIDoAAB1MAAA6mAAADqYAAAXcJy6UTwAAAAGYktHRAD/AP8A/6C9p5MAAAABb3JOVAHPoneaAACAAElEQVR42uy9d5ykR3E/XFXdz/NM2tlwu3s56rLCKeccQUhCAkSSyWBjjAnG9g+Ds8E2BoPBL9iIZHJGBIFyzukk3el0p8s5bN6JT+juev94ZmZnZmdmZ3b3pJN09bmPNPs8nZ5++qlvdVV1FW7esJWZYRyVX8Qa98cKIuJYyfA3mrHfZT/K/6xRq/I317pb1TIAAFPVgJAqhlvVe4Pr9Uq2VKb57kIyTbdf81YzY57K40z6uV4uxC0Ov+G3cMSNf8LR1vz2Wx5D40bQNLxZt+74Znnc0zbounjLVBWrqtJ48FU91hiSqV2gsiQxc/m3Pm4MWHOo9R8Zw2I1uyv8HscYq2ceEQDktKyAo/Syo6mz/lcAtcr9j9IrjxDx1cwDaWrVeUJBvoomJ3c3X/7IFP+n5dGmhbBIzRc+3EN6cYixxr+jNC30oi0SHLejaX4lN6jScNvdFD9pYk5Mg7vFXprnxk3MQ+ONV7E8TeXlNcP9W1JcTPhuXiruPyErbFyg3iRUUeP2m5/GyT3C+IE13/iRTEd5/cuUai7CSWNA4yrTtdrrtGOa77FpjsfQkLEATIABIckGT9J4Z4SIJSAaU/fXZ8ETsrAJn7y8x7Krpknm2JIWu1Xe2nzhSdBLruh/+dJR1v/i0Jjp7ohRp1RxsHCEpSvj+Vu9Rwghp6SLH99svUduPICqAojMjAAUosWE01gsg6XCdbqrrlXVzsQ2gJp2pKnwx5rG4cJwy4uN/SoZfnnCxicxPGZuGnUnMxVTETcmbXqdXsXay5SOcv8jnxAFFNiiqVNgPKfmKtPoeN5aVrduaw1rTSD7NsCAqi6ab6r8ucrH1ryVosZcETe2BlfeC4sWKxQGMV65VGAWjcT/ejqEBty/Qd2aPLTODhFrttaAkx5W7j+VKpNmyi118UrS9hyll5wmt6JaL19bFmxG2Grme6/FFrhBgfF/NuiuwQAQGYCaNAYUZWJu0B0AAJoGuiBZXbT031Jzhmu1Po77FyX0Jue3mcmqN4PNzE4zhaeoCmym8CQG36otYRIjn0T5lyMhH90EvGTUvNxaKl/6XVM501gz06Cd8bqd8eogaGIrUHPnUV6pntheU/kDdfVRpoQBiBWPUH9DwBPvbNDU3AoUASC8F7J+pmoMmOid1ZTroUXmjuNgvWqrAa2w7EnwypdE8zMtG4LDtKs4HCBxuIGnmk1MhAFHml9/U8/4MkG1oimyNnttXLFJzcx4pjyuSvV46uln6sDM5J1EJ7QW1FQWhZJ08To1ViiVjZknfpwSVy9DAlkDForlGn8bFUy/1hZjQlRoivs3B0X1um7pVvN0uNHlcLT5ajYFH6WXnOpx0jLGUcaI0NSGjdoXGcYdyBprdCK2Cw1l83HlQ9Y8NlSkIrMu05w3wJhmMKBsGKYKAxo2y40HXzG9xdFWqoBKYDCBDymUbLQ1ZfzGKrDmyzS40vzFKWpdJl2yyVFxixWnpffD2t2RRiXJ4uUiODegl/Uj1FxdPJGU2exWoGiAHI8E9ZRCk1PRFCX08Q4sY/J1YwyARgAznrMDATKAKSrYG/r8VPgF1esRYIzDy3LBm7HoctPwdHQ1928Y+KHmm6goUyn719tPNHipDS5OI0ebHJBMYkit2i0mV2bqVV529HLU9pTTy5r716Pa7KlMLYFYI0BCPa09QLUnOhiqrFjO1qsY8fheGhWGepiBpjEGQG1GX7swIQMwAsE4uKqzqaqBAVAHNQFAlq8qLMBMA+LGnHcSNgCuU77exWkxAzRfbCr8ulV7+BSH2mprkyh/lF5tNH6FHA5P/wYMvVRgEv6aEzY1oYqm+aYat9B8ydq30AgEbUxJ+xSWqacLah4DZCUDbvy8teO+tWQKrvizjPuXXWyk9J927t+AJi1rT53Rt1r3qMj/iqdXpPhfRbUdgYo+KfWMtNXl67TZvNYFGil/msO/cMCFGHBQr3pLmiIAIETDTWJAjTZrEhW8RBv6ioYTWPM5W+VNL44+unnZ//DhR+PWsEiTHmHzjUyxylE6SuX04iyhBh9mPQFrwo+l3p9T0QE0Eklx4ggQjYcxvrAgQhwTxOuPbQI4LFHdUBCNKzcYazMrg+vaA0yDRqZFpTNFahUwJm2WmLol4MWclqN0lKadxqTg5pxTymuNUX030Kpaze8DJjRIjJVBg1htl25JZq9xBQC4Ilp+qcwktGRNAsA0K38mwd2mi39Ne9dTZP0vd619q+NpWWlLdaa3TjNH2vy0+sh1x1/v8gRuZBMMYHr32bU7migw/YS91ORrjXoso/GIUfLinLQBoFWDRMFVdFLzwHVMAsRkoLEJoeCt0/gxmwGA2kq3JpcOlxXmcRXL/YigFWZa73rjPeDkTEYt3eVa/p3lj99ky5MYzBQbP0qHiSa38F6OdJgsxhVbAayOq9xEzMpx7jpcUKVPWvCvZ1ooXanFdmESHcE4DCgykxoYUCrWPAZMDAC1WQkagLrif5N6/8kVm/B6g2LTrlcZX5fr35p0R0f5/sudXj0YMP7Bq67Uc0hvMoNV4++rSb8aU/9Wg4pT9BEaOzJW63kbW5vr7QPQYOgdUH9sY177NakxANQNk9mI6Tf07KxV3kCLXP5wWG6nqJ+pp5uctA281fIvjoqsJarpuDKmu3yV8cNXLQaMn4eqv4s/6p7kqqBxm4DxjU+o5Q+LGWaY2j4AWsGPSfxZPgyuNRIkhiIGVDVSVrj26bDwzwYAUEfvVl/1X+in6vlhYjp8XH5yFtfmfQnMi27+nXr5F4Ga8VlkPIoBR6kGhSe56sEAIkJzap+QGiheqqq0GKShKcBo1NG482ITlK+lQy7HgNIwWsKAetuusQPTlX3W4P5haa78zZUXodJ/C4lLvqfTxf0nxwcbu46Vl6kqaepw//Elm+xlKk9xRFHzHuuvBt/2Kpr0+0V+deFl9YHecmIa+zdlMsXte2OJrf4XHTZg6hVu1GzIAIkbFK6+WEtUReLS2ihcqcGla7B0RKzaAZQK1ZKI67u1Vll3EUvhHDhEuXFVagPM5Pj7pLU3zQxg/BXTXFMttdkqvQJwIqSj+4DW6r6aAlwjcaN9AABMFEprgvbryPIAzR4EQ0SuiFrBwDKMBtHCpoEJsVFgoqphACKME+TLdUFYeUCs8T5AVj15vYmud0B3/FHeMu5fo4V63H/S5tlp9KVpEg+wiaZaavNVTq9ODJh83VcTBkxMDU0CADWCxNXUhIRNUNlFaC5yXGVr4WCajTNRuFJgjBVar8YqqdqGXTTINNHaqK4qG0BpOe+uJ2VXy/5UofhBxPEHMaBp7j9pM0CrbLfxeKo0P83TFC3Ak3v2l5zCNTFBFP6qmalfsh401Gv/SMOSeuOkhr4ZR00FITW2B0DTVsbxtaDFhDANqjRvNK6zhygWrtzxNCiMlWkQxkR+KGBA/U0AVGUOqKtEK6l9qrj/eG+fSu4PNUrW+rN0saXrMN3cv6qjmup7aIVqGgwm0c4rlZo3h0yOGF8JAnK9VXSUJk1I3MiuUGdlNi8aTsYG0Hrh8uvjnS1D7Ut4o74xAMrdO2Xj/moOrvzHmAqIuLoKU2ULDJN92mbuTjj+CVub8EoD8f/F+VCPsoMmqaAMPSpGvzKoTjrDws2mTwXXrNhMXIfy9mv+Wes3V2V4h4Z6JCiGkh5jn7V0VuM3JVB5q2ofUDXU8fuAMQCowf5qmafH7wCKFyv5eyvhO+oNoPm7NctMWtffPGy8enx7ppcqzEgTn+avOo9iCmHSi0REQggpJREZYK21MQYMM4cfoamxu5+QV6BhIGZkAEIOP63xtSpaLmVUHfewU1HptDRXr0hCENzA3FtKxQXAoCdoqr5hGYrZeKG+UqiiqToKouJ1QjS1cgg36z/agO9XnxGrrFKOAVVVxmOArMslJ3JOqrhbzuUrzOLYTFy6qbP+Zmo1gwdlv2vYscs8nsbuVT3yUZoEMUKd/RUBADBpbcKVLaWUlkVEUkrHso3S+bw3nMmlcpnUcCqbcVPZHBvs7UmeePyywMsyoykyhcZq98KWmUtDMgAG0NLFHElOJLF710FPBY5jJdoiNkE86sRjNgoyQQBK+4q11kozMxMRhR4X+Crl2tNJaKZRrzehqr3ercYa/KqK4/cBzTRS6e1jEAGYasaWKKeaNuHxZ8RqjZlrHwSrpyyrqfyZMJLP+LtNcv9mblXtyybRVC1qydZbkBYLP8fN3FHxvzEV50fUuGeQGW0phS2EEJYjtdaDA6mD/cPbdx3atqtv5479ffuH9x44mHb9TNpzXZdIsq/aY/a//uv73/iGc/O5nG3bY/r0+j4PHGbiNszMBlAFxihXBQa00QLJavv8l7/zwx/+Joj0Sots6SSTiZ6O5JzeGYuOmTdrUe+xc5PzZs6Y2dVmWcIYo5RyvSDn5gTKEK5KH54xLa6u8XNV2Pq/inClseQ+Vqy5zVZjH5sji2qBX029E5Y9SMmCi0xQdqXGVnjrhq01Wsea8m+ll1Lpd5X2vyw5cuEBalUff7HmQ07u7vgCUxf/AcBg3eotAUCrWssXE0Kmq6+WvIBC/YpAQkRtQGtNRI4tHccSlhzNePsODW3dvm/98zvWb9j5wtY9A/0jmUzOy7mgwEYLLAGCLEmCLCfeJqXUboqU/7UbPzp7ZuehgyPANDo6GgRBznNDCrQyxjAzEUgpI45t23Y8Ho3FYm1t8ZgTS8TaElGrPe7Y0YidSH7yH774rf+7aUbvwmGOeqk8k+C8ApKgjECiiBXtglkzuxfN7ly5ePZJKxeesHz+wjnd7ckYSDZKpXKe1hoAiKi01Zg0x+EyAGjGznGEsrbCUmgWDpsBgFJrEz5y3RMGtSpWR2dr4k9mLrERrvMxVGhy6vyuGm2jYrVuhRXLt6FVgaMnAICaht9CQ5WFy7X/FZ/3uFA/0yj+N6BJG+IB4FUKAIU0RqLm9VbVXA0AoPg4FGrnEZEZ2aDvB7Ztx2NRYZFRvGPvwWc373rw0Rd2bN+/5YW9g/3Dbt7XmqVA2yZK2qozYs/uiMyeIbo7u9o6uzG6/q5H9U5ly8AiHbijGjxCkc0H2qDWuvwLKW1xEQFYI7JhJQQRsm1LKSWBSiYSbW0wZ/6s+YuX/+Tnt0ci3TlPxVesXvHmU3NshgeGhvcPuYdG8wdGvUNpeyRQSvnKI0kRG9oTztIF3SsWzjnhjAWnH3vM4jndPZ1JT2mllApMxba1aOEc09hOtCiOAkAzrU3w1Ey1tTf11CzjmXL9K6H1adIAUPvP4gdYt1bNFpi4uDuoYv2F9VMFAFg8WwwND3nVY6DjWVW14pWaEsyhLt+cYLlMKPgzisZVmrzVoMAUoWt6qXGPhTURquDRMJAhIQxJA4DGoBlTL7Zs5wjLG6gEA0QEIGZGBiLSbHzfta2Y7cSijmQf1m3a8tBjjz+49pkNG/cc6PfyWRAQR5tllyVmJMWsbmd+F3Z1dMydl5y5QFoxA6S9IWtoJLN++6GHng0OjCIisO9mXQwCo5iVCXcYQAWz2BgnQUQwBIxcyDzOkpCklFIIRNKBVkzgRCN21DZGBYEnu9rOftOVM49bPmPZgkRHDJEOZNS2/sF9z2wY2Lw5s/1Adke/GAZI+aiImZF0sjvWPddZc+KSS84+6awTls6f2W5blu8G2WyeIUCJCKImiyhn7nWDv9fhcvUAuA7Xm9Iaa4bqrcPJb4OarFgfElraBNR0JYBGUnyBWYUG4QZjruLIzYx2TH6fcBtRGTJ6PAZUAMAYHy8CQA05umGes5cWAJqR+g1QS7Ua0+HwZJ1emrDHIqcwDJrZNiQEFwRkLgMA5Mlrrksn1AEAgJDJGKNZaR3YEae9vW007W19fvt9962947EXtm0dyA7nfZcNaKvT4jmOXNwWOXaFM29JYu6iZHuXJROmb9A/2JffvSO9Y2dq+67s8CBnslaWY/n4iB8E4MtIYEWCaLtItDltyXgkYs+cOdOyrIjtxKPRiO1YlhVqnDzPM8C+CnJZP5vNpnL50dHUyHAqk3dHR3KeB8iWBEugbaMQQiCx63tKsExEZszvmbNswYITj5+zcnnHkjmRbpFKq9Rg5rnnntv5wvOjW3a6u/qpH8QgqTz6ZCBhuucmzjj+mCvOPvm8M5cds7ib2IyMZhmNRhCh+3a5V9FRAKhPLVSs3GRUxWSu2Q7VaN/ARBy86s8it8VS9XpI0ORWYDwG4ITVTbUbQiMV0OQAoDEDnRwATF38rzfIBgAwCe78CgAAIARC5gAiSdh/EDY8KQ7sJQZgYgS1bJU+8SwAkOy12PF4xVHht2YjhIjGEkRi05bd993/2P33P/n0s7tH0gS+r50gaLPkzLbYqoXxVce1r1iBM2fZkJR9WW/3ttSW9ant2/L7h73BAenmrCAmclHPDxQrK+bHet0lx8XXrFpxyqrVC+ctndXd09nZGY06toSIE6kxEaGjKBEzAwoA4yrfdV3PV5m0t+/A4N6De/ce2r2/f9+eQ/37Dg4PDeVG+pTKRHWWLG0xCU3CtX2KyfZ5nTNXLJh30sp5J6+cfex838EMy4Ed6X0b1u/ftG7guc16X1YcFDAqPd/YXaZ7tnXGKcuuufjUi886rjsRc/N+LsiHDq8Cy9WJhY3UUQCYUt1pwIAJlEvVqhVE5pIjcnl1qtnOBDYArj4RPf0AUME9xwFAFTZUzG19BlrtOk1c/vzNc/+yi9XGiZpHNmAiAJicO3/Tg2yhyuGmibVYzAYN2BIGDombbxKjwwCATGA7HPgMFJxwuj73csn5FjseAwBTOHWCAGDZtnTskUzuqSeev/UPDzzy8HN7944QOsoB0xGBeUl5wtLY6lXRBSvi7XPsnPb3Hxh5bpP//Hq1d7c/NKzzynKjNjrpbCYgsJMs24Mli7tOO37BWScff+YJp8+aHU3EYwDCAIJBBShQhx8K1fKWYwNskKioGEQAZjCKiYFQszYgCKVSkMsPZXOpnQcObNy174UtW17YtmPzlkN9BwIejdiuA8RCAtsQRCA2r3PemlVzTjuxd81JPYuSxg6yKb1/694dG9buf2ZzfuOgOGTLnM67aTsBS46ZcfEFq9989bmrFs9TgRcEQagfY4Syj8XUY3atAkBLjdRueVIs+yUGAJgAA2q2RhUl61evf7ESAxqVbwYAYBwGYBNNhebJ8YqmahtADRZf0/+naQAod6ops/tBzcINLsI47g/N8LWmAWDqap9JjOdFo4lVQIyIiMLQg7fg049bVlupargJ0EjBde+EGe2T6r+gdmcAy7IsW+w9MPSHW+77wy0Pbti4L52HCDocBXduNH7qcdETj48ec7IlO61Uzt2zPfPcs7nnn3V3HkzkFQagPUspGyzwY6nuhbx0Ydtxq+actOyUU1atmTN3Vry9DQG0AaPB9RgExIS2bWamvKLB/fm9Bw/uODSwu39oMJ3tHx7NedoLfGYkYEKdjDidycTMGe2L5s5aMm/W7N6emV3SlgAgAE3OzRNGpBAk8oQSwFIm8AI9OpDa9MLzj2988tmtG557pv/QLhAjUTsgy5FBm0iLnOyQ0RULe049ZdbZp/Usm9XWGc0O5fft2LXlqQeyj++gTRnRL/wca8olZtH556x68+vPO+v0YzqcRCqd1zrA4vtDRBMeEx3vYvCiA0D9hTTBsalJ1JqWrssGYWpX5NqaGaooVqfuRMMoYgCPj7szCQCAKtNFEy1wUQ1Vcx+AWzdsreaVVNzChH9W8co6YUHr7wPKVUZUp0zdi2W3wmN6BppjpvVYfEtG4GZKHuGHgZvpl2Qbpg/Sr7+Bo2lLg0EEJgJAGQEArXz/qrfqhYta7Lng2cIAZNmxRHTjpt2/+dV9t9z80N7dQ1o7xgryXR6dML/tzDOjK85s713gpkfVjs167TP5DVt4z37OG4CY5yrjoYpmInP85cs6zjtx5fmnrDlu+erOru5IPE6AqCylQRnWJjCaSJh43Dbs79uXe+rp/fc+tvmR53ftH86kje+2RezeTmdGR7SrPZpMxOJxIYRgJmXc0dFgeNQfGXWHRjCbjxAdN6/zzBMWnXXKsuNXzk1GiBm9gH1NxCAILEQ7fEoBLMEH7+D+/Vue3/DYhsce2rj++U3Dqd2W47ZHpQ2OyJAXxKjtmIUzzjxlxqmndB17jGhH3Z89+OzThx59Kv3UZtyjnXTU9X0TyZ10yqo3X3/WJRceP6enI5/J5TwXDQshEJFBH8kAUOi33k7liAQAaAEDap8xbmy5LV2cEAOabKfwoxQlogkU4cKftTEAtz2/rWKKypz6uY7s35IReEJlS9Nqk6aOm03Y4+QAoCVt1aSLHQ5qCgCcNji4Vf7sG8gCC2vLIINgQAZF4L/1/XpGb4MuKtcrAaFk4WtlCyseja3bu/tnP7rrD797eOBQSpBjhPLnGHnyquSZl1pLj1NOPNiyy3vq8eDZp4KdOx0POW/nXFK2KxPZhQtiJ6+Zf/4Zp5y+5pQFixc4jkMoIcBAsadBk5IW20DsIyKKCCtNDz6+9Qc3P/bAo88fGBl05nbNPnbhvBOPm7tkYfusGTJmI6L2vCCdM3kPGQDQcRzLsixhW2QBi+Hh4T37D+x+YsOuh581A/4xc7svunD5ddeccvySWXFLZPM5IYQkixm1MRrJMsrWBEKAQ4wBKrN1x/ZH1j7zwDNPrntux+4tHuZ6HemAyOQoZ2Yk5IrFs88/r+vUNcmFPTabYM+erfc+MPDo+mDzkN1vBS4pmVl5XO9Vrzn7DdeesXjBzGwqr3XAzOV5P8Ym/ygAtNRmHa/Tcj/LqhaKV1s2AlddPBwY0NgGUBDzx/6sgQEVAFDF4itsANPB/QFa071ML/ev6QU0adXNFPcNLxo10TsBKuHl5c+/g/0jxpGh0pCMtpiRQc2a5V3/3nppcEouxmVBFIiBJMmIHd28c+d3bv7lXb/cvG9vv5QyGrNGFrSLc49tP/GiyMyFwVA6v/bp4IlHxZ7t7mAmptr8HLiQc3qCRcusi8459oKzz1yz+oSezi5bRLTWSqNBYgNIYEAbIAQBDDrvtScdV8HNdz/+zR/fedcDL0AsuuCyU5a99pTFK5fGrEh6NNW3bdfoxp3Dm3flD/S7IxkRmCAIAt8XUgZGgyWi7W3RGV2JWb2zFi2as2ThvGVzIjHnhbVbH7v7kU0Pr0sG9mvPOfa9f3TRBecskgzaA8UAqCRolkBGImIAKlTWC+FISQDQP3TgnocfeuCZtQ89seXQDhFkbFuABFZo1LzOjjNWzr3o3NknHWvbMp0aOrBh464HH889szWxz5IZkc+mFiy0rn7d2X/07stnz+lOj47CGKc2oSttg+AWr2YAmKD9SWJAoyNmjRU4peslAGjsONS4qXKD8HQCQA0Wj0UlJNZVvtc7J1w951P1lmlK89OMe1KTADBdvvw1C1f4xR+29V9+ErvGeYjSOmApQFpWwAc3DN3xk87dCUkgpWQl8p7rzw4i19yg2hcpq+YMi9DZAQhZGykwUEZYFI237dw58Ksf3/Kz396z+8BIAhNe3PGOTUZOO9k57VKRmOtu2uo/cGfuqWeTIxkrFxifPSDdPnzMCfYl5666+Ixzzzz+jGR7rzHAyEhoDBjDAKBDezKgFOAqo9lYDDFHPvT0ns/f+PMHbn/Ks+WCy85ccuX5XSuW5A4MHVq7/uATzw48t1MPZSHwSDJFpEgIIpYRSZYEJvbZeKx8E/haa2DFmkXvivlLT199wRVnL1gyd8vOXbf++Nanf7d2gZh51dXzPvLh1y9fMsfzcgxSIKEYO45vjDHAFB6mQ7QkMYIO1NDwoXufeOi+xx5/6ond21/w0Gu3tRORo/luX5yweuYVl/acf6Y1y9YZMbB+7aH7HnRvPxQ/JDWa0XRq2cLoDe88/4a3X97ZJtOjKa05VKtiZU5X09y6mvDAwUtLhwkPqputf/qs6nBAqSI1NAK3IrxTlR9OVZUJmyrfBDRnBC6vW40BuO35bTXj+I+pgJrg/jCFfUATt6aq9y//s1wFVPpupzC2pgZTRUcCAIw9OJNSKhK1JShrcE9+8/3+7i16QCH5uKjDOvlNuvuEAEaFdohqnAUjkuE60Rq04o7O5MH+4R//6Fe/+ulje3b3oYzSDPRPbpdnXNl24rl5E4F123L33aE3POYMjthoZ13WiXzHYnPJecveevlVZ60+I97ZBSCVYm1MuMMoLUgIVbUMyMCajTGOLZSBL//wgf/52i9H9u9pP2Huwhuu6z311PyOgX2/v/vgvWuzB4c4hvZMK7aox5k7x54z1+rqEG3twrZQOCQFa8WBQjAyMGo0nTvYl9p/KHeoP7dvMN+fjczoWXrWcVded8HKNQvuefjR3379V+7DmcVL3I996P1vu+F8gjRyXApCYQg4/LaNMab0mTEza0lCWqSUIoJ9h3Y/8PQDf7jn3rVPHTq0PRZzk46jc1EXVvXOvPi1sy+7IDIvbpgOPr1u5503B4/uifbFMWPnswdPOKH7fe957bWvu4DYZPI5yxLCZq0166JkWvmGX6YAUL04D1+DrWIAmir3l8liwNgOoEkjcCObcK3TYVW/TXVrFUwPt2+qdQ6gpAKqpfmZXhtA4+vFu9xi+bqdjgeAZmh6WX+5D+tLCAAw5t7AAALYlkxSCk4N6lQ/oJLdC0wk6nlZsGKIpUykFR7NoRbCV4GTsJmd3/72vm9/8xcbntsV5YjdmwhOnc0XXhoce4YNNLxuk7ztZrNxUySnpC/z7mhkRvrYs2Zfc9EF159zVe+ChSDQaA50OGBGkgBgCgBQmrHCVlq75OZdEwv+/b9v+u4375Ey333+yUvf9l4t5b7f3nrglruDgdHoslnRU+bbqxZhz0yrYy7ZjkFg7SEKlsDasAoMAgppSCAiMaFmMoyGzZ7t7o6NfY8+n9uZ9ZPJc9586bVve82Af+im//npoe8+Lyz3yivP/sKX3i+MD7qNhHIk2xYKEW6J0BijDQEAgweogZHAARaIIC3wg+wLL2y8+Z67bn7g4W1P52T/zEhEenF2lySTl13Ye/mF3cs7fFC7n3hi9L575GOjtNUDF/I0esaZcz/6x2+86OxTPM9LeSmQKFBirZgQL3cAGLdKD0M7LWEAGiiLIFKzzeYYdyOnzBabCiNKYb2S5SqgyutjGFAAgNocE7Hxsa/xV1oFgCYYq2mp1oQDaBUApov1A0B5ioay55vE4h6LslBrEMUZC9UD2Hj/VO5gTmFUHjaEaAEHKBzteyApDBBUswlkAyQi0ejjT2z42v/++KF7nzWadMyB0+eJs66mU88gh70ndwd3/SryzHbL5JSXGPUGe4/xzn3NnHe99s3nrz5XxpJKg2aj0CMBwkgEwRT6ZhMAGCxoV/JukHNVKuvlsyqVBSshv//T3//4hzdLKee97tIl114/sGlX3/e/3r9tr1wxL37emvhpx0LbDKMFChKakQ0K0kWDHBS5oTAgWUBJnCIGABPYMRFTuQMDzz6evn99fnd64XGrX/+JtyaPif3hf3678ycPZFPpc85d9JUv/xP7PjMaDGxbOFJISY4lbEtaJBDDgwbhcXwDaBCE1oCISgWxmJ0ezt3xxO9+dMdPH78/5+5oj3NCxZgX2m2XX7TkiouSSzuGLdi3/unh++73b9/Zdshy3RzYQ6+/+pQ/++O3rFy4JJPJMLMBLijiyvxEXyoAoAp3PTMtkdKndzdQ0VqDSERVB8Sw8KU02AdM6Bha0wYwFQwopF/lRvsArt1aAQNw+6atddlr0R+09t1xf7ZqBoDmAKB5DVIz4GSaOInW3MBaL0+1yrQGAFQrwHeNo3DMuqAjbuVBuHgsoNiaYNYMVIgrW3KVG/tsKBaLDY+m/ufrP/vp938/OJCOtDlm1RJ10fnizAtlfFZq01r3rls7H1vnZD10nQx5vQtT11976luuum716jNYscfsEWvySXDEWGAsIhBcYMaKjW903lOprDeS9jK5QCmjtNYMyfZZ9z1w13/91/cQxezXvWb2Va8fuO+2vm//IGgLnKtf75x5PnS2o+eyUQBABEKI0qcbfgyhOSG8GB68KstmbAAZgVgDoOGR1Mgt96bvf8bqXnDZZ989/+Jlz3z651tvenA4GL3w7EX/9e+f1mxynm8BMRpkEJKlICGQCGJOLGZbtgUMrFkBGA0aEYElaQEGJAAKeHrDEz/9w02/+e3D7o6ZbWaO25nKzrU7Lj1j1lVXOsfMcoPUgXvvSf/6UXtt2jLOoBrqnokfevd173nT1bYV5F2P2RQObxa9Fevy9FqLsAEAtMR8CQyCJoaAkDHEb0ImYjBNB32b4hhabrBJDCgrRtws14Y6nLdBxQYN1pgHw1AfAKDSBlBzE4A7XthW1eaYDQAnZr5NAkCrRuDw4RDFeDm3Se5/OGwAzfRbj2qL/9DyDqD4rgkAjIZ4PK6UGh7KKMXxeKy9I6q1SqXS0kLHEUopQa2JYFw3TTRBMccQsw6CQEoZjyfvu+fJ//yPbzz73At2zFJzu+m1l+jTzuGeY2jroewffpVc+1R0xPXY8rVKrNx33dtO/tDVf7pk5mqtIQAyAgSyMIAAikABSg3SAAAoA4PZ/MBoOpXzPTcoy67HiEhEoyPwl5/+8mDfnplXXDbnmhsyt9+28+ffwjWLrOuvlwsWkrDYzQpkMEyIQmCJ109MhhmL6cTCtKaCBMrRex4f/NUtSdl++j/86fw3LH3gY/87dPOGtJ/62Lsv+9gn39M3mFVKMWsiAjSITAIRmUhKSZZlxW2yBQkiBDIAAAZQMSNowZqdiACAHTu3/viWb/7kVw8Pb5rXZtogrvPzZeTi03qvuEYu7XFzh/beeWfmprXJLYo0ZvyBMy9a+s8fefea1YtGU2nfaEuitAVzISdabbZ+GAGAAMggGiBGYNaCNbCWUOAnk0eAw+0tWm9o5YcDKgEAmpbcoRbnhaYBoPGtEvdooAgydSAkrFINAOXa/JYAoCUjMDTHN5tR/TejHZq6DaD+CJtugeqUbBEAhEWuq4BFJBLL59Sdtz5z753rDh4YDHxKtkeXr5z7preds+q4uZ6XM+wHQWBboqX26wBAITNXKB17npfs6h7sS3/jxu98/9u/dAMpZsTERafiZZerxSdRNsjcdQv9+va2/n7txxVj18rh66888a3XvWPFwmNRmbwNbFFEgUFQBS0/WAhCm0ArpexDo5lDo+m87wOEOWEYuXDawFfaEtSWsP/hX3/yyD0P4VknLH3HnwePPrr7R/+duOISvPYqz5KoAzQsgcGyLSRBQAyELItST6hQKu2gqUI+QEYwAo0xrA0aBsOQ1ZSICUukHnpg6Ps3RaPzT/vPT3ScM/PRG/4jv3WYIPWtr//lCStXZTIZA2zbko0CMBQKvogEzIwSgSyKSBGRlk0EghhAEwD6zIxaiDAuqAr6D+371s0/+NEvHkhv6ekwiWwyGJkbi73+irZrLrRmWWbb88O/uIdv3Z3IWoP54fisyMffceWH3365p1XWd1EYFBRmxKztJHrYAIDTo6ZvN2W0sW3T0QXdM1EKQk2A1HKKpSmNZDJtTogBlckmqzAAJoKBMiaOda43Wb1SWuXaLTc0Ao+pfJlZfOzPPwoAWKRCu+HJW2xBkJ92AMBaq3ISBwuqL2JTKqAJqXy6mqxQ+3qLq1ob0Arisc4d2wY/83c/vvmmp0eGVODZWolMytu8afe9d62VUh63ZmGgAiKklh+xZoVCclwANECRts777nvib/7ys7//3X15svDU1da7/ii4/I2QnKcffCz/zW+333xfJMuuseLzh9/2ocVf+fuPX3nZm7oTvS4JT6IFYBsMEAwCMiAAMuRdf2DU39mX3d7XP5jNaW0QBSIQAhIjAQMDEiIkktbtD26/6Qc3OyuP6X7rh3O7dvb95BuRy16Xf/vbDJCSmiWAJUEKIERABAbDRikT5goGQ4RShke/bNu2LUlEIvRxMqADZq2UYYMAjEBoY1uSbMnajZ20IkrO4FPPHnjkWfuYJXY04q19YRD84WzqdReelc6mNIC0JRiNCETEwIhMSIgGAYEh8H0v8AOtNRtAJkZCCSiBjEHPAASIsXjyglMufN3l55juzesPbHIHZXtau8+syz++LqISHStOdM48LlgZH3D7rQGTz2fueOTZJ5/fceYJy+fO7s55HjAzaAREEDWWV81vZNKfQZHM3h3qybt5sC8xdNAe2S8G99LADuyZi9IiKRj0dHQy/TT2FdfDQGQo7GCq5EjAVnTIZeyR6lyfjLMMVrQApUmuKFZ3kIiIuHPz9jp9mHJhoUnOOxV9/bjrTSl/GnRdc5BN2gAmpLp163Dc6Qq3og3F4/EXNu361Md+5rtO2b0xCWV4pO+9f3LZez54oeflAVVN98161rmaRkJG0IzGqLZoZDCj/r+vf//73/55kJLOzB54zbnqksvMwnm0Y1j9+qfy/oedVC7w2mHW9iuvPv4v3/2hFYtWs3TyOkBpIZBARDSIFLIEAsh6qi+VGUx76ayPyNKigvWiKGSForphwcwgQHv2p/7mi5ue39l77pm4oCO/dqM/qnHpAkiQ5fjGdiDeYRJxjCcoHrXjEactmkjGk+3xRCwasaUAJAbJgohcGyMCYgSkjdaBAswFPJjODgxncmlfe4rymtNZTmV0Oh2k0oGXs0aD4Rc22l4AnoxFLQTb99CJ5W78zsdntyezeWULGXGkI0BIAgCB4XfGAERghBAQKrKAETFi2WG2SBAFj6xQjhOaiUlIfm7bhv/9zg9u//16dWhmW8IZSBKcvybx9qusNXO4f3fm5juD3zwZPcQjAczoiP/LJ97whivPTWWHGQ2CRQYBg+L6K35NWHtHOJX1iUN96v6bhUUIRgACFhIQ+p0z8YxLwHJYm/DoQs0l3fzin/wQK4bbaDfSuJfxd8u3As0bgaFpGb/xoYHxf3ITjqHle4VqAKjgv4TQHAefFvEfy7NZToH7Ny45oQ2gSXpJAACADDARfeS9P9uyeXc81j52pwwApKXTo+of/v31F1+xKpUeCZlONbUEAEC+4hndHY+u3fgv//DVpx7dDhbKUxaJN74xWH4CQQD3Pq1v+kFsz4hRiRyn1lwF/+8DH3rNGZcbIz2tlGRLRASUvyMAgFQ22Dc8OpDJBUoLIkdaAKCBRUlrbEyYpBcAtCENSJK/+Y3/u+nXd0RjyXyWSDlWJEmOQK2MMQIJCIkIpJAE2kKyCKNSRB0rHrViEeHYQtooJCMBCiZhC4o4FjGw0TpQyvfz2Vw+NDqn8+5IWqVzkPfRaAkoUfrIEHNkLOLELBnRsTYn2dadzac++/d/tnhmR+ArgVISSEExGy1ZMMEgogBE4pLIGaIgISCilNIWVLrFzBq0YEIF0hYg1D2P3f/lr3/todtVJ830o7ncws6Oq66MvvYcvzfuP/lI9ud3x59KcVq7auR977j0Lz78BhLGGNAGJAXMmsAYBAANIOoBwFSWKD9+P+zfShYQFzbYBWEL7eDY03jJSlIK6623lxUAlBerElPGVW8t9P+Ev5s1DpcZrlsDgHE81FQ5rY8vVqciNC7f3MXGAECIRYeqMtNeU1gFrenE69FLBADgRO2bf/X8Fz97Z3sXKt8au1EGALZtp9PpE09Z8PmvvjnvZie1A6hW28po27d/8YevfOl76f0jMLNdX3ShufQy7p1n7dnPN/2a77/LMULn7N6VuT/748vfdd27o7EZgQ4C0giWABnOVuggKAlG88HewVR/OssMId8veCWXiYmIiGBmdyZ7EhYADGS8Z3dmheCR0eHh0ZHdu7fnUsP9g9m+tGtGs3nPG1YMOUsp4/nKc5XyWWuttQYNrLQJfKMDDDSrANiwDowO9xcaQBVPlzEAApJwImQ7VsSR8WgsmXCSiVgi6kRtYVtt7W3xZFt7e3tXW0fMicRi0Ugkun3HgcvPX76oN+EHAZK2WBBBIkoRq6BZQkSB5dwfAUyYkSZcGYhsWZZFAos7ecOsQWtPOWRLWwynBn/yux98+X9+O7J9yQxbZBOuf+rK2PXXWOeszvftE3+4G3/3lOjDdD5zwYXHf+bv3zu7O5LNpeyobQIfOUBEU+DNE6z/SSxUvvmn4Kcsu2BMGfN3MJyffYw54+KYq5RocBKluV6OJACoKjye1VKdqBKtOv+0ChhV3qsTYkABAGoxcVPTcWXqANDwSo13g9VL1pRf4fpBimpenxYAaKQ7OtwAEJN/9/FbH3lgayIptCp7lhIAhCsA/UjU+sq33jZzdjJMR15NDQGAgUqxJ6Px2PDo6L985oc/vukO2yg4fql/7RXqpNMlG+eOtXjz76J7+n1lPJG+7n0rPv3Bjyyctww8CtgoyQiWBEQwwKQIACDjqgMDQ4NZj5ktElJapeGN6WNDIgaAVbM7444EgKyn7npm2LYiQmIkiu0JZ4YF0kEXfDJaGHD9IJd1fT8YTWfT6Xw2m03nAtcLcr5yPZ31fDcf+EobYzQjGlSF8wAskSK2E3UiliDLRifmROIxcoQi0kgoHEInTAomURoEjcisAA0a1ibnBn42DasXdi+fk2BQAn1HUMSWEUfKcDsCUOL+4RMSlIFBaF9nzcxSSotEaJEI5yS04KFBUki22rBjyxe+/h/3/GYg4s2iRD7blRBXX5q45g2j3Tl6eq33nVuj61JKO92LnS/+w7svOH3Z6NCoQmbwLLANSAAFTRiFWl2reNtNnDlk21b47gwWvgICzs6YD2deEQlYCaz5dbfK1qcBBg4DANT4zeExyQlKQisY0NQmgAmahQ0EANy1ZUflQ4WePzQJAJi0+F8JABWyZ2kwUCeRi8EWToqNHY+aiCZvHjjMAACEH3nvL3ZuH4hGba312BqrDldriOAzX7rqxFOOyedr5XKpOQ9oILQbss2ktMl1tc18/PHtf/vZL6x/apeJWHDpafSaN5l589W+3eq3N7U/vNnJZkeC9IJV+G+ffv9rL36DMZAnFGyIKPTiJSBGCBgyvuofTafSWY0EQAyIwKGjTAnHC5y/DNfiluhORgCgL+1u2joKGHWk09ZuxywQlrAtNEZZNtk2RaIWs7YkJWzpAEtgBAjNoYUgDcCMAsNQcgBlWfqo8HbCY9ECNEIWYEcf7DiU3jfs5gOd97xcPp1LZ8AAah24o7lsEI+22UBexs0OpQf79rzpLaeefeoJ2jeJeAQZiA1A4Sw9UUHDQ1Da6BTxIDzDVVzzRGSRkKHjauF8FyhWAhG0lAI0+z/93c+++vXf7F6XTDptoxFXXnKC9ebr8itnyN078ce3Wfc/745GnI78P33qj954+RluZlQLAUwUenYQNumS0/yKpQfuxANbIGoJoFALHYoRXiZvjjvHOv50oXXh9MP4ZfjiA8C4BT8t46nmzmZsK127QCsi/4QbgrErE+WOr8IAWdmCKfthsInIyVOw8ZZ3V+NikfVXTWONpiY0ANS8VXZmakrnAF5kymb8fC4QgsKkdeMLFHaghLmc53l+a60zMRoAEgxGW8nk3J/+8MHPff7GvUP9wcIoXHklXnKx7cngnrXR3/wo2t+XzTqZpLrhDcf+y19+tKNncZDTSoooay0sCMeHxAD5wAxn8v2pUV8bg7Kk5QDA0JsiNAqEUn84/aELozEm7QWpvsJTdM2Qyoe9O3be8pvHDu7tHxnMcaAQ0batSNR2HMu2bduW8WQ0ErcjkYgdsSKObUccRzqOJW1LCCktCVKgEITEiKw1e75mZjevtNb5fN7TJp33Up4eGPFG0sHQsOfnVC6bVW7eTWfzWV/lla9cFbAmg7Y3cwbNX5B4zeVLzlq1tMOKKaG1CUMDFZZTiaq4f2nWiajM+gWB0cwshSjABoCNAhFRgFI+a7jh2rdefOZFX/3et773w6fiqdnirmdTuw5G3/6W/KlzzR+/EZbOsX9xDx+Mf+rT392778BH33udznt59gJkCaL5xV06GTch0dKVav92ERiNGHJ/YQAAsoN+ZM5CDVoRC8RQzfZKJawMil760xSZF1ZHTZ9qL+MbLMgTBqHp7sp3AFWidCgsNPKZqcd5G/PQ8caGOmUahe0cY98t2gDKJd/DwusP8w6AJH78j3+xeWN/LBbTWpU919gOgJmVzkci8ivfumH+wu4gCGo0xLUxVQt0WTkkY5H2L33px//z//04bzv2kl689kpvxRpmT990R/TWO6VJqxG748TcZz7xrjdedgMYEYicsqUFtlSgGAyAlOArSOfd/tHRdN4DYQOTqWVYgrJoi4gosJwhFoOdgSZAQdGhwdFnnnkmnRnt7xvu2z84NJQaHkqNDGey2bzvKaOM9jVrIBBCSBQohAQUIIiIJAIihlmQBWAhkBFrpUEHRmkMzQaaFbNmQkQ0hIgsLGnZZFkilqRIR6RjRqRrhrV00cJjZi9avWjJ6uUrYom2nK+1yQCECGeIC5BWMgOUa34KV4igoB0a2wMV7pb2Q0UYYAbDPhgkkgY0g//Aw3f88399f+vTbT3R9qF2X11zFV91kmoTHeu3ZL9+U2SHqzD/lref9/cffTv7GVdpy44YY7DOF9cSeypfzxZZ+rE71dqHqb3HxggzBiMp1T+oTjkh8aY359y8YKDaft2Tl+gP01ZgKjuSKl181RVqWL55wR8m3AcYbLJ9qAKAavG8CAATCv6tc/9G8f2LF2tz6qoqE9oA4JUFAPFk5GtfvOtH3366ozNU7nNByOCAjGQIGC0kTo8OnHDynC9/632e59V+zEoA4KIztGaworHAh3/5x/++6cd3BvF4cM6JkddfwV1z0wd26e/+KLp5tzAJF9Xr39T12U9+fFbXQsOCgAEtBMNALugISEYINAyOZg8NDyoAJIlgAYT5ZrgeACAXzvpWz14xuAWRJJTxeFxIZNYA7Ho513W9nJfLZYaHUplM7tCh/v6R1Ggmnc252XyQy7mu6/qe1ppRASpkDcpoMMgGhURHaA3KCKnY2LZtR5xEeyQas9viVlxaHclEMtHW3d3V3tbWnoi0d8TbE+1xqz0SDaSwDcuscoPAYQhQZJHjiIIwPG1AJc8fIiqcYS46OBEAFxRlSDTmkF4OAAUX2AKxBo/YJiJjDABoNpbtDAzs+dyXv/bTX25KBL2YQDzjOHH11SPHdCcO7Mh871fy8V2szWVvPO6f/vL9bWT7vi+EAAyAJaLPIAHM3rR/KBcsn5HosEuhRSem8vUswCLO6acf1hs2YDbjg86SgZWL5px7bQpisg7kFxbeFPj44cCAKaqkqnTxMA4DDrsROLzSNAaUAKBak46IxZAv1FjD3jz3h8rjXRPhysTJe+vZABoNhmniMi1SRXjnOg3Wy93R6oIjYYaHg4+8/9tDh6LxBGvFAGAwACZkQg6k7bk5zOX7v/DVPz7z/NX5fLbRyJkrk49DLGYf6Mv+0ye/fNutj0Xak+a1ZwTXXa2xCx9+auRnN3b2uxq62nsG/vqTr3vX9X9MRAbDwAYkwvfFgAKUgUw2GMhmhtNpTZaUEs2Y2Dte8VrgfVzUg1ewQlNVEsMzWoTAIYtFSwgh0SJBBFIIIBamdOIXlDKBr5XSShkv0EqzUQYNG2PCKEGh56gklEJISbYUQqCURAKMpPDFMXPokBoeITZQa/ddDNNPaACIyBCAEAU7MCEwYHikGcL9BwGUzAPEIQrUXBuIAkAxEgGG+qLCmgJABkL8vx/d+K//eRulZkasTPq4ZcEN1+SPX+YMD8CPb47f/7RW7hmXnPqFv/yAHUP2DckAQQoIAJ19OfX7Jze7gbj02Pmr5ggztQO7YngE9m8AAJ63jJO9xZUPAHVjAVXF3Zw0TRcYVEV9mETXhT/reAHV+7NJbJjYBlD6PQ4DJgCAmmydsdoSMDnuX+T74w28DepSgwKtmn/H7o7bmk0dAyYEgMJnX7NuiwsXSUcjnU8/tfGTH79R5xbH4rbWgYGs5hiTiiLzcDSvdr/vUye+5d1X5zM8odI3BAAk8n3V3tX2wsbBT37iP9c/8iwtaMc3XUwXvCaT0/Jnt2Xv+V0Uommvc87i/f/z3x+4+JRrmNH3fcuyGMIQmwgAEtFVeiiTG0hl8godSxQYVjnuhpF1YTwDhYLzII+pTcK7oTolXNLEhRjRRGOR7gqryrAxBg0jYhFFQFQ4l46JrogoAJmBdXjeABWPxUblUE4Pq1KFD095hwCAhQcxAhmREUNtEwghbEmiaM4NeyxfCQU3jCJy1H3j9Z0swqBFgkggPrT+gU//6zdfeIjmtbePdgbeW6/n885mZ1Df9PvOm9ap0f41l5z+z3/73hk2oHHY8i0jHYue3j9089O7E9GOi1f1rJpFUwQAgPo73cMMADBNGFBoZAoYMB4AYCJmDQDYnBEYmsaAJjcBBQCo0s+Vr7l63G1C1l9TgmuyepUNoLwAV3H8JmwAFQUqAWCK3L9WbM7i1HHt69UttKR4DVmJUW2J7oceeexLn//+wa3dRkWEsKJC+Jmcj6Pdq3e/7b3nXPva96oAjRWAUWQaOj4RAlCgTDzhbN964M//9DMb1212lsyPvOlaPPsSL51Ofe87/MiDkUTXwQy/5jWJL3/yY0vnn5hXrh1xtDEhL2ZGiegrk/X8/nRmOOOSlBEpmLFGcCE0Nbk/FGR/E7Lm8kmkikNkYaRJrGIdMpSkiwI7MYTqF0uQFGiRkFJQUb8UTrsARA6zuLABNsYEmo0BY4w2oLioEyg4NY6tZwJTXNgcqtSFEI4lQpIkyvl+g5c+dUFECOF6mqWJotV/4MCn/u3zt9+ysze+MM058/rXBG85X7VbeNPdiR/fJkayx15x4n/+4/siwqEAEAWj8Q38/KnnD2W9d566vDeJL2sAaDzVkyzfHBI0UMLUK1YPAKAJDGjcVLkaavxB4qrfuHvrTgAYv9Eu+0Gl8L9Vasrx5Wv9OVUAqCpZ1dxUAGDauf/YFHHt6wAQBMHQYDoas5PJBExiBxCyW0RLRoeHh2+//daH79820A8irnrnyBNXLbj4oosWzZnjsTYsNHpokBtKlxowCIJEW2zzpj0fet8Xtu3cIVbMdd75VrPmfLVps/eD7+RfeKE9Mmc0lnvfO0743Ef/NKJiPlkoiAiYoaikBgA4MJrZP5wyxjiWjSgKjxYaRYrJCUItf8VclaTjUNKnavtQKDiXX2EENoV4zqGvfcGlXxspyZYkBUalZUkSAoVALIsAxaErTkkSL0lqWArGwMzIOHYKf/wKLse0cqF+whVV73VPZSkGFCA4jkZAcP30f3z1f7/7zUdmwDE5HNQXngJvvSG7RDq3Pc4/vCl6cOjUy09645+8dtuG/NsvO9WHVFxaw563ta//zLk9hrkmABRfZUkhrJlF3e/6VQkANSpWpROoVawC/puT8VvdCky4D6gBAONYM0FBF1R7lU+0Fajn5FO3SrkRuEL2J66hwcdG9uQavbzUAJBKZfbtHUgkIvMXzIJJAUDpv1LKaDQ6NDTk+z4AxONxO+JwoAKtJREwGfbNOAG86ql9DW3tsOHp/g/+8d9t23cwufrY2Htu8FYd769/3vvOd+SBXY7s2S/l5z990Z9e9xZiKy+UEWyjhQgha0QC19P7R0ZHsnlEtIQsf3fFuPBhSS4BQAV/L5qgiAHGGYGrNCcwDjkAQBIQASG3RaKELJHCwwSh9bV4bh8BDFbvzXXYbvE1TDWBSZMvdJocEAygAWBgocECAgtV4PKPb/rFP/7Hzzu8eQQ8smYOfeDd/qLu6CMP442/xFS+58z5nTOXf/B1p5574sx0PrDYRkYBur6sJrQObFuODHvDw4MLFs7USiDp2oVbBIDx3mjTa9qdznMGLZ0gq2UEhuYAAOoL/tA6PDSODiQ+/pGPhX+ODaX6SwuVs1jahdcDgDprusaENlbul/2s2vgzlIW7K9ytFCfrUXmz9bpuibhO1TJddu0BEKHvB+0dCcexJ9FvOdczxoR+HbZtO44DAFrp8OyoYTZguJblufypfQ2JtsjaRw/9yfv/dmDfQPyUpbH3v8s7ZlX+yWdT//tfiXRfRs3Nd9n//qUrPvCa6yyDWiAKYbFgNCg0KSTCgXR+99BQJu/Z0hJkAWBZL4QEiKV/iEUXoKJplGlMoY8CqaB3r6LS6WAau116CltS1BZtkUh7zKYwARgyMGAo1ZtQ3U4IZYu4bD4q/02Vxg+vwXucal+MyCRYEAtNhlETCyl51erjV662/nD/I5zvTAwc8rduVwsXiFNW65k9Zusus3EgpgZeWLfn+BNX9XR1QqCJQxf9Wp8q2MpkY7HI8ID+5Ce+cvpZK7p7ZhhjQj+mWuXrjrXejanPw4tErXnyjeNUzZQu/VluN2p6qdTkq9hQpmkWAAoN1XTRmwIANNQdVTw5l4+kvBg2JctPOwBAfQCoWidU5IiFGReivX1i7l/14qvYylTZByEWuf/mTXv+9P2f2rvrQOykEyLve6eec6x6aP3QN76YDHzOzostEp/5ynvef9plaLQmG+wwqjGQ1KRIZ/WeTPrASNooIy1LEBXtpqW1C6Wg4kQUJvoqsHJkxGpZfjx4lq5VqR+JAQEcSyQjVnvEitm2JGQ2gggRynGiSY487VQLx8YAbHq6AAAWyARkBCvJaAABJApYOXf1GcfNvffZ+7OZWCSd8Z7bwLPnq/OOi3V1+lu36b171+/tnzV/welrlhjPZ1JYJ2KzVhyJSjdv/uz9X7zsypOuvPpsN89SojG67pBq32gWAF6q99XcfDd9Oq4JYKv4wJsfRFPqk7LfyFhLnR5SNQDU4shY0VbLXkDV89Uc9wesDNzP9Uo2BwDjH2eqK6xO7fHuniWORcCMXDGDaOptJSaanMkPPlSoBNok2qJbNu750Pu/sH/nQevkE+TH3skLlps7H01//38SUvo52bES/uG///yG4082Xl5ISY7QBgQDgsFA5H2/z3f7RlOWsEgKRAQc8zka49Rh6OPi1xMG90cEKsMJACAuTl3lu0VADK21YVscetMb25LJmJ2MSMeSpc2EKPoOvYTcHxvSdHcGgMykARCBwm8dgAF0VvHiJYvOO2vlfWsfODCoZvjAGzfpmQvp7NX27MVDm3dZykuTe93lp0EQAHLJlIEM5alkolGjg8QH3v25ZSuTf/k370yNMhEY9plNzW/glbwDmOBBmnquemugZurWclbZvPxXo2SY8rRW4+LjH/lIPfEfKMx6wEjht1jJuyq7qT+mqi02IlLphykuPQYEJK74s7ApDRl8/RnE0uqf8B/WUohP8MXSmP6i/B/VvAoYurhg4R8iFwbGABSqokv67IIba81WiBEACUlkPeNYNmPh6y5NNZc9WclmUvXAHPZSnFQumlLdwIsmInu2ZT/+J/+2Y+cWedJy+73vsOcck7n7D/63vkMS3FEz7/iev/78/7ts0Yp2W6AgJEkFXb0RRFkV7M/k+vN524oygUAZAjYWp4vGxPyC5AtQcMuBcDdQtB4LLFaicGVUaoyg6MdJjIwCSSK0xZ22qBOxhCCgMKTmy42NTB+Z0M7OQKHaK3zHNkrX82bOnH3BmtWPPPvE7v1el4qY9S/k5851jl8GC+aorXvzG/du3td/2WVnSd8xoELziAhztBVb11q8/x1f7pkX/9znP5rJuERMBI4T9VVQc8rrv4c6sjNyvX/1Po2WkLVV0G0CuevylvJ/NZttMKQCl8MKvjf+H41rpN4DVhVALKitq3i4+PhHPlpzshBLUVpqGN8mLZBWDYvrtFBvY1Gzo0n03kJdbOkyVK5oYiRGNIjFENZhxGEqFITaYlQxD5G+67ndv31qq6+9Rb1xKGhTsMYIsMDuq/+FOgIGBDAIDOjYttY6GksMD1gf/OO/X7/uObFqifyz90Tmrxi5517vBz9yLKEyevEpC970hU+evHDGKhFDCZ4gwWBMgaEP5rwDKTfjG0JBhZxbVRux0PDEhIhgsOC7y1jMFoJFm1LpeagWDw/1PEJiMUoy2QI6EtGYJSUVjAdNvvpXLhW3TThm8UEAQJaCPM+bMXvmVWef8ei6J3ftc3s5Mrh5q1m8wDphmUlEslv7Njz+9P3rn5g/d+mSGR2KjCEMM7BJRoOoCP/tPz9vxYf+64t/HwQBGibASDT61W/c8eRTT59/zsnjo4w0FE2nxbrb8ht/SRZJTWRqRVFR0U7Nh6+5P6jJLQu3iierytucJABMborHoxbXqt489291W/0iAEAomJOQRJZyCKRE20bHAksaQGYl2BCKgisicL2WEGXW5d8+sX80iwTOSYtnIYQ5DnlsAGW6lcIOr0ouARhzRyBEJKM1Cun68sN/+rknHnw0tnJR9APvosWrU48/5H77B0mwcjnsWtP7wc//9ar2ngvicYwguKwBgUEQGMbBnH8w7aYDZY3lmxx7BEIsxDwovBtTekelmDblOCbGTFU15oEQSYAoNtYZt5MxRxBSLVvUURpPQgjP89q62l931mkPP/PwrkO5zgyPbNqkF8yUJx3nShE7OLTr/nsf/d0Dp11xQc/cDkx7ZNvMwMiCIRBw2vJjr7vqGq01IGjmRCLxrW/c/aPvff/Df35tT29v4L8MAABeIgwodT0JtjNe51P8dBptJiboCGtwmzEAqMFqKwFgurg/VALAVLj/JF5Gy420AgBc0GYjMxoG3jYa3L7Nv3272jAgNJu5baH4X/CfaAgAgGxbsPlA/1Auu2ZxcsmsaCFEa4WOHABBI8DWg+4vH/RveUrvG6CedmyPI3MYzzs864pEYFAbg0IiRv/xU/955y/vksvmWe97Gxx7YrB+ffob3+zQmBnR3Sd0/fmX/nlWe/sJCTvuoGFkBxFcNNIADOa9faO5vNY2IlZkcCtMZij4j8n1OHarctSIGIa4LCjTBDJV7aIRAFkgEZFA6EhEYrYQBYXPUe7fLAkhfDeIdyUuPfWEh9Y+2L/f9CCMbt0sF64wa5axp+O7dg1qfvL5DZedfd6MjojveiwJGZEAiaLxWEEVDBCLx//ts3f+6je3f/07H1+5fHkuUyPKyJEJAPCSYsB0japJabehWqyaoxYAoDarLQOABiqnJtFs/O/w7wZNNQCAyb3Oww0AAkAgaILA6PT3HnM/fzc9sUts3CvX7tGPbVeb+3HZLEhEEQDZQEEHVqslJkAJLJfN6lg1t2v5nE5bOoXI9UXdfjgIgwDbDor/ujm6tT8y6tLz+3AgRWcuY0RkkEQEpEMx3IAxnOzq+NJ/fu9bX/+5Nbfd/qM3yzPPVTs2D/z312ZkdY6t5ML4X3/17zraZy1xcFnM1sShIgmBNOJgzt0/mvOZnTB/uinEMiufSSxGNSiIKlDDRI8Fvg9QZjOvl6dEEDmW7ElGHEsCQBXkHKVmSEgKlEl0Js9bs+rhZ9eODOrYaG44P2gfezxGJaf8Ts/r331gz/NbLrrqUoE6PDenBREVImoQ4FBf/998/Gfb9zz1na9/dMHceblMprbyssE4XlIAgCMMAyZU4tckbv35qzcBXMFUxcc/8tG6fBZrjLKBfmp8x9UKrHGMoJ5vTyPMmMKLPOw7AABXgkHwv/gwfvfpWHtMWEJHyI+BI6V6YdBf10fH9FozY2AaAkDRiGBbsiMWs6VVNBjoUFcS2nsLhubfPGHW7TQRIgQpBfelqKtNrJjHgTIIzEAogCEwOtnR/YffPvqZf/iK6uqVN1wVPe9iPtCf+eZ3Y/v6jd0mO8VHvvjh7oWLEso7ttOOG8GERYsUDOXcAynXZ7YRAUAziEprXDjwEh8nxDD0Z9UMi1A7FPoAQMHGS2O2gQoi4PZ4pCNmGUZgc5T7T44MsNKBYeiaNeO4NYvuvechSEs4sMMfHeZzT5FnrIBNG2Ips27r1qE9+6+88gJfKwXGJsFGAzMggiVu/L9vRzpS//H5T0Vj0cD3DRgIzx7adrkl4EgGAHjpMKAe/yz9qDewGsLT1DqtcgcSf/HRj9XtrJgUvvHoa3Y8IavF+kbgadf8TKm1Fm0AImH7D+3O/fdDoicBRoNhYBAGQLOMSs4E6sCofdJsiMjiJqDeDiAUkTVQAKiKUFEUrsNSCIxgntkJWw+gLUJfSZ1x6aTFuHxuCACIaAFprWKd3Zs2HfiLD/59X94kL7+ALrmUg2D0hz/Dp18QyY6M7X7gX//s2BOO89Puyb2JHhuMFsxGStKah/PBvlTWGLaFAABjjCAsxSUeWx5UtESEO44KpwVALKQjKXB3BgAoZYrHSr+JUF05r7vNEQQAJbf+Sb/6VzUhCiFIoFY8p7d77pzY7++9R0C7PTw02tUeO2+lbI/33/NEr5144ulnTdS58Mw1qJmLbgRCMyh91smnXnbhxYEKXM8DS8SjEdu2n33uwB13P7pty7PLly8vdNVoGFMFAESsewKzpUZeUmrA62qOreoiF7fXzTzO+L5K7kAhNQIAqKP8mVDwn/BiuQ0ADj/3b6AUm3YAUIT5Lz0Ee9IyLskwFfy6EFGSZkQ2I1manaRjZiDXNssAhDsAKvZDpcNkpa5LAIAIKpWDJ7dGhCDEwHXNzA684TwWQgAKFoFAOzAkI56yPvxn/7zumW1t554efcPlXqwj+Plv4JFnYk5nxht5/z++58TLzh4c8pYmo6scaVAEbIRAxWbQ9Q6kc/lAWVJCGPxHEDAYY8onFhFLjqoQmqWLk1ua43Lf/4KRYOxwX8UEEKg5M9qwuFeYxEs/SmNUnD8NJjB6xcKFM7r02r255csvPnTrT3uS87pPPBXiNPzo+ra29gfuf+CYYxatWbXE8zwGJiFAEAgyhIH2iTAajRHg3b8f/NH37j40uOXsM5auWLEiEolUdlVzGBMAAJXrJxDRVHsGIBEDOBFHSKm0nvSyaLSi0MDUNhnNdNpYLzJ+Y11VvuQcj7WqTCgqlWPAGADU4NETqYCanNkGChw+nNy/mbmo2SyX+c4j1PlXO2QBylww+pPHKauFTcQApqBEDY822AyOkooC+/ylhg0gYh1PUERAYCwegEYALIvrVm4+thb05tIb9XbXV56OiciHLpSLF6pAIyEhKSRLc7Q98eUv/egnP7wZj5st3vFW1bvUfuyZzC9uirXF06n+qz92zaXXv350MOgRcHpXxLGk0gzEQJjOq0PZfDZQjrCgsOyKujtEJByL3V8p8oe6ICqb/zI8GDMSFA6JEXLBQRYAgIB7uzotKng8Ya1kVUdRoXkq7TM5zABhzAnHHT8ysOuhxzbxqJ3etq7rmJWRc07NpYe85zfGYzPuu+eJM889Zf7cZKAMCBm62zIxIhDCuqd3//fn7hvo67vubSde9frTZ/V2C7LG3PQbjaMRADAzIAaWvf/OvfFZHcIGo8JY9GNfgJA0Mky/+eVj2bS/YFFPoAKkSa6D2uunEO2nNhNrlc827rSKv09uPZfLj41CQ9f4fAq1ax8RHpPpxt1tEM6wJstuwP3h8HD/yb2b6SL2POX7KJCMDtOtoGEyGlkDgGah2NfbBk3WbyruGJqxfwA1UqkwAEDy3e+LfuIM549Oin3iannCsUEQEAEzKzbSD5xk9MnHtv3Pjd8zcTt6zZv0zC7euX/0pl8nrVh/39Bpbzj/8hvekM0xSJ6fiCQs6WnDAJJEzleDeS/jGVmWpr20NkoWYCSGytwMleHeqkO/1ftRfCIzo71Nlistpzfx06uYJKBlWS7ogM0H3/n6mdF+7am56cjeH/9cjQZzrn89nL6C8obMjI/89efSQ3kppe+7YV1i0oGPxLu2D19z/eq//bfLjjthZi7jZTPetIwNEa244z9/cP+n/uBuOISi1tdB+L0bf/elf/r1337se48/sD4ejU2sVSr/gir/FdZt1ScG0FIygKlgALQCAzXZY5M8s275MOFpvT3I5J6wpYef8HdLY2hS3m9AQFye/WMSz24ciV1xLOa/xkK2H0IwwK5hVoAQMKrSIiPgWv9aIQIQx77WvuI6sXwVM4oiITIIyObxnz77v8MjqfbXXAwrjkMvEvzhd9H+/ozvLz512es/9o6Ui66rYhYvanfCIPhSYD7QQ1l/OB9A8Sxu7VdTmSwFEcu5PyJU3iruD6De6jIdiZgjAcHAtK69VzmVjiaCMTLi5Mg4be3//s/va+91ldMttuzI/uA30NPT+a635HosQ9m9W1L/8Lc3EpEjC0sC0AhhuXn1hrcdf+Z5i7PZfDbjTW+Sd80mv3UQAk4/tR/qvP1DBzKOmJcZat++pV9KOdVpGb/7L5ygNI1sDZWY0SqvaCwWN2hqEsqMCRU21GqFZpQ8NS82uf2ZBPefLpGfW0wDVJMoGYvPmylMqEcSYboQZAMswcS0zBoCWtCOiYlCgXILwGAAQA4zZgxoNsiMYXh8gdje0fnN795258OPdJx6unXu+YBCPvqceHatIMdOius/9T4dS4J2skF+sePEBWsDgiBQZiTvDeY9w2yHh7vKPHDqAWQDoaGZt0Ng2mKRmCMmLPkyIp4UHa7BICCDNGCRCNisWr7iQ+8+Z+/AhoS9YOiO+0cffCZ2/LGJP3tjyqR7ujp/9sCT3//J3cm2aIjoYS5MIshmfDfvI0z/azKE+b6MiDqZjQNG8fg8FsaYt733tJnLdpxxRfaya1YopaZsEq7WSAMQIwHbwBaDrNF+fS7REgtqrBqZ9nbqfZsTZEhvZliT4P7Nj35ygNTSUKeT0KAtY5cvc03aaAKgosWAmFmJnIaoymr78qXoWGENhtpGhkkPALCQrMoYY0WsZ9bt+48vfSPS2yMuucTv6qa9e73bft9mKC+Daz/y5p6Vx3gZ7aNKOrjIcYBV2HNgzGDeC5QRNPmVWq9kTfE/CIJY1EnEIvW2GkdpukgaiGgUDBrprddeftrqyN79u2fGk30//aW7e6DzokuSb758cPBAe1fv1/73pg0bdllImXymkD6aBLMAkKaQ0XJaBwYYidmOsDGn2Dc1tECGTz51xY3f/eTnPv+xnq5e13Wnpd+xjSkiABjfHFp/MD9oIajqLc50yIjj+x3/54TycemHaR1LygtU2AAaf3tT//JbrTUh959EL/VoWsR/YNKj6cTZc9tuWJxPe5z3MdDKcJ7ZBzSewyOBdU1SXrCYJ06+R3X+1SYNrEEbNBp0SYoUUv7XF787kh6NnHG+O29OkHXh0ccio4fyWh7/mtNOueYKP20QIQB/lhQzoshcyFR+MJ33lZECZeUecbwyZ9yP8vS2FSFmq05+Vb4+k4hacccS2DKovyLpsJo9wujABKgRIomOf/p/7460HeRAde8dcW++XStsf/vViROOj6dNZtT7wle+CQZtRzJrZj6sCbwsRhtkJCDJFhuDON6qiZ4XJNo7yHZ8M50IVFpyjsOHnt70xP/8vn/d5jDHxuTameIwoEVZvhnjQc3yjVRALY2mySvTpfc/UnkEkXCUr7vefW3i3TNGug4G+Uw8Y8VVUmekTqfFa3TsA2cCFDzoAQBRIIqQuQshIhG7LRlt74jFE1Y8YdXsIvzfrl27NmzYMHaZZZWOKBaP/P43D95+273tK5bAWaf5diK2e6f/7LNGJpz5XVf+8dsymkizJIGGF8ZjhrUFEhHTrhrIeogV3L8mx29G5zOh8YrAkNHJRJslpJl6UtqjNBExgiIgIhTk6uC4NSd9+AMXHzi4KW63qd89nH9yXbp3RuSGKzJGtyXjD9235Z57n4hacWVqZO8aHWlFBp/IssVs8jsGmSHIBSbl1zgdbgoqMgWsSuFUpokKwo1nEjPsRWfPmndi92F7A9WdTnh3wn0ANPweG5SXDThyvVCdzT9PM7gErxzuD4AKGFhpLZyuD1zffs62wUef7N+83xq07Ll+5LQTnUsvEgjaGCRiMABgWcL3DSI6jvB9s23z4K7tw6MjeSKxeGnnitWz4gkrlwnCqL/lSfva29vLOiZAVfjAWAIYAhgZzf7X53+ai+joOedSZ3s0nc/ee38UrIDhtR95Y6S7J5sLhCSLTVRYnTEHSStfGaS+bL40z9OewzaU2oqVDTNroPaIE7eFNhoM85H8fl8pFKoIpUEU0g/8d7/7j267+5ktGw61i/YDN92VPHYJX3yieP7M3A/uB6vr+9+/+eJLz0ETeoJWeeaPTwtDjbsNPRfDTN5V2wnX9VL7RzgZzWeVtztnzUtAUNE+cyHiNRVW0fSvE2M6Zi49pnvBfLCiYabVI5wQEcpTSxa/2Xofb9X1MTN6Ia5kqVB5B/U6rv9nM1VMc8VauttkrZYgreX9OFoa2GhhrVzZu3SZl3d933cSMZKCETUSGM3MQMyMrqeltBEid9zy7O9+/dDz6/cOD+WApSQhLV6+uvua686//obTshkPCis/RALo6Ojq6Oga65SphBBKmc4ZHd/48i8f3fx8+4XnidUrSZPe/Izce2g0nT/tdWefeN45Q54iEYaXYAlsGxP4RgAazZmAURCi0GDG8nkV3HIACjkdS0FJudB9Zd72AlHxuBsAI3Ix/GcIfuH1iMREPGK0Iiyccwi/86PUDE0up/QYkzYshGgT8X/+6w9f+/6/jdnt4tntwV2P43XnRd90Qd8Tm3p27XluXd+jD68/+7zV2Yw3FuoDEAA6OpKV3zEBsCJSBMxsKQbDAMCS0LIEGtaKjAbWBpiYiAFRlOq7m/PmeWXyDo2I/DODyXN7da3BQy1HfSyeRBl/p3Zy9lpAhQyGUgoAbBtAA8B40XRcO2Z8ovKpaPCw9AnUulX7WRBxshggPvGxjxeu0gTbh8YXx9ea0MTBzTXV0t0ma9VopM5mEuvNQG1JB6GQwyrcqhoGkFLajkNCaABDUORtIT+VlhXPpPUX//2XN371tj07R4SwE/FkLBaNRKNE4tDB1L13Pbtr575zzjsxErGCIKA6uViLSxMBIBZv27Z34JOf/lraoY4rr/VmzrLT2fwtN1P/aHzWzDd96t0Ub3e1EmgEhl+yOTYRiQpExKG8GnA9WfDxL3PoLP4uNwMgYnl46ooda+XnOjaHGJ5+DlszRNgejSQiNhtTEO647vnoqS+DlxEdpgcsvJoCxxxbSfPm9QxmRx54Yl3Siru7d1tnHMcLZ9odtvvI43qYLHQvveo81w9Ki74E/FXNh//V2w/qm58ytzzNtz1r7t0Aj2/Vz+0KRrJGOMqJaCeGYAlGychjC8gEwTAtycMaSB/a0XPmysjqLlatqASxpd0q1r42GaXSYVyKDZQ5FXrUJgwGNZUusvQ3N6w/lUFDLe5vmig5XeOpRyUj0viHr+pmcqhuAArhmgG45gQzZVLw6b/8v8cefqGzsxNBcJj6iwEwEBLiMh6Ptf3hN09phZ/5/HullGzUxB0T/eJnj27es3/B66715i0QxvLXPxPfOzgE5qo3Xdi7eEnfUIosYg5Tp3OYR14gaTZp5UPleio5gIZZveq9hSbVfRVPzxyzrWQ0wsYAYSgtlt5IQVn0Smf0RwjlEf/fe95xz71r9+3MwO5c6nf3J951NV14ilh7gfe9e+5du3bLCweOWdiTz3vYiEUaitnBAxv8b9yOIzmKOJYBMsDMBBDcu8HvajMLe2HpLHPVqSoqpaeIdekVR2f1dFy3xFbaPWmX29PG/rQZhBqI1dPR+jRvAsYPnisF/NKzlN8qXi9sXMqqlNelqvKTSVHdvJn3iKUqV8tm3AmwkprvhRFKWSKRgQCFEGEs5UQi8aXP/eqxh7bMnNkLLItZwwyE+0oWwARoumbMvP3Wtb/55QPRmFW3r/AMGxAD7Ttw6Oc/+alcONs97QTPisPIiHziGa155tJFp117/mg6Z8mCs334LWtAHwwRMICnxpK0hFTKY97kmm5ycowxQoi2SBQRNJtCXDlu9nW8VHSEePRP80MhkM/J7sSfvOs69HMORdUtT47sPpT3RPwNV+GaOX07+3/0/T+gY6EZ0/XVJE5ng2/eLlI5O+5QmGFSAkWlSDhWm+1kR53N2+hHd/Dnfir2DUPUQRRQyBUnGCCXGUm7uWDFHLsnyXoaACB8AcRETMDhB3IY9IvT6h4K9QX2miWhTA1X3z2vdlPNegE1M5TGQxw/3GkR/7E5qjezJSpnOtPIfwoAEDbLIBjAFDYD8Xj8uXU777v72Z7eLq0NIgMqQDNuhGyMsa3YT3/0QCqdr3dKABGFEL5S7Z2JX/z6ju0Htvacfp7p6GaDYv06OTiaRzjz+gswnlSAgKpkiAMAZh4ONAAYBBrz42zhLO4kVoVBaHOcqCUNF3BxrLWXB9s8vPRi4gdqJEQf6PrXXrripLkmk48MeeZXD+Coys+d237dtU6s844H7tq5YzAWiwXKI67rkcw7+tANLMsiZaRm0oyG2Qtc19V+AGQL10S6Op2N+/A/f6e25XMR8gIlpY3MgskiQUSCjVF66o9fUCUWDlFKRAtQAIkpHbWpO4kVGDAtcnBLGDD+z2YwgOrdqMmdJ4SECS0BRywhE7YYgKG5ZgHCYJ48xte0ZkQhhPXEoy94rkLEIAgKrB9Eldd/6HttR2M7t/c99vDGZDJZoxdEZnZ9P2Lb+w4M/fhXD8Ris6NzV/gqGskM0VPPpb1gzuolay4+K+0Hxhg2mpl1URJymQ96WjMIEJYcWzTTvohLpNjYQiYiESIY84g9yvdfKiImQHQDpy3yiT97p4JU1JC4Zx2+sMf32DvvZHny6uHdA/fddTcIiLe1hVrBmmQyeSzacjSwQg6QNTBpRg1oGFGwF0A0AvsOyi99X/SlZCyi817ZB2LCMwdTX35kGJVBZi1Z28hWqAJhZjwsi21SGND8YzbmtKZhlXoY0CzLqzfKll7SEaL9bwD+04sBpXBAY6wfwQAb0EQUBHrD+t2WFWVDgiwEEWqBxjcDLAiFCmDn9r5a/ZBhRMRIxInHY9/57f07tmwUc7v7YNQXI/TsOt03RFbkrLdfxk4UtBWGpSt8Bxz+wIO+yjMbhKho+Yh/zXXZ4H0xs9HQ5ji2QK1rf4hHshboxaQXTZskkNnCnOtecvbJr3ntaaP50VjKzd/6QJAJON4mTj0BorO+/N3fXnn9R3932/pEe6KeE1/44kJLfkHhEi4GQmMUqIARyTB4Hkcc2LHffOtOyUi2xYLqpoWbLCEiUlRSPD2Az68dWf/0yNAwSooLaPmEV4MuKv8+vBhQ/XRVjvsNv76aupDaoSCa0ZlAw53FkS/7l0scZVdbPunIJbfk+r2UY0CRyPdUJp1HRIByvl++gMYCxhkDjhN181XLK5RkDIKJxKIbt+/78L9/5/u/v78t1uNcdjEuWhYd0Xr9xoD0kpOWLj/nZFejNMqIsbEUTEkMIwFrZgCQRHD4zGXFlh1LRByL+WikzxbosNoYDBqB7JAUBO973xudiAuoxROb1Ka9Qhpx3km6vScHC7fs6f7ox/7nH//p26UhVbVDiXi4eWUkY8AYQINgELQBbVibovVSUBBwV5If3sIPbKS2KAdKVx40njoDMQg5Sx/YO3jHj9bf9I0nv/3Vh3/96+c849c6vjB5quZ104oBjTX4DQq0ZgOYomYfYAL1Eby04n8xdF8p3kMxSGdhRIyKKWBSAGNiS4FqRWRjIBJOxGlDabm6tXC4hXkwxhjWxjVGFbajxRg+lSEfKHSxJzDKV53tneHhKSi4U4bpWaC9I/nr3z/2J3/zpVs2Qm6rZ2b1uMeeHu3qdDZvMgd22BatvuZCjraxMQSG2ZhixAVGYGZJ0OcHz6V8NhC1RdwWRcVVjZGXL6wJtYJVqyK0JzOzTegIQjBITMVkkFBK+1WWamFK7/0oNU3hcQ0SwAgnr1l25dVne/lRyvrWQ/eTCJYs721f1C2Mbj9mXmLO0q/f+OuP/cXnpO2A0J7nla9YOSMJAAGBKe0yNbM2bBCYmJG1NsaAYTBInrIcmb/1iSCVZkEAgCAYhYFpk0KiyA/e8/Tau59WwwczQyNPP7Pv4EAe0JvQWNgqNcAAIATCCQ0Pk8aAeuWb2Y7XDgfduLNJVDlCqOClXFI1IjCSRqnR1hzVEDEgNZKZSDOGDKlB+r//vePhu7d0JGcp06xAEW4FmFErjkSt7p6kUsqyITyQBVC5dIrBZsNo/LYjFi+doXVBN8qMyMw6wGT0a//7zY//1Re9i97FtlKZQdHZbSJR3n9APrOOmWcdv3TJ+af62bwENgWjRMUmQJJgA1uyAQBEpGyTFkz0+U1oDap5q+DZyToWdSRCqIMqp8NinXtJaRpZzGEmAjSIrLS2JPzJn7w50ga20sGj63nvPhBaA4Lv5/y0bu/sWLDmt79f9/73/aMUEdtJuJ4CKCxX6kyIuTM4lQtlC2YOw4gaYAMFrSMY1lprHSbMQL3toNp+kC0BZabvaeH+DBC1ncGBkYNpM5hBzDIeytgZiSZ6OGaw4v2OT93RxNsfX6CUMalBsWbsw/U8O1rzAqr5DBMagUu1TBMtNDMpLVB5ngeoiEYShvw2QAyCRw7x3vU8csCAYKAJeRABfOfLP/nWF35x60/usZW2aTJxyYnozHNWMrMKJsiUZDQQ4ey5yZWre8sTcGvGto6eX/3y3o989ns9174799s7snfdG43NsucvYtvCTZtgoJ+ZV73uPLKtKv/fcK9tgBnIAAvCQ77akQ8QMWGRI8gwN28iavLFhWOQAuOWzeZVmuH9yAUDJgQDaJQ2xy6fe/W15+Wyw/aBjPfQcyQtNy3AifpeRpmALWvBghNvv/WZv/rQv4tIxHainpcvMJeoLdYsAk+B0jDOsM88xvoRURktEMEL1Av7wJHN6LWwFSJEQ3rhqt7RTD9nuvKpzKyFbtdsi2F6ktjUG2Hxlxkv0Ez46ienMmp1LZXKt+YFNOnhwosb+KFYeQLnXGQiFmLPk/bt/2g/8v9Zd/y9eOJGrJqWWo0YgHUbd81ftGLTppH7H3wuGo+1NC4hhLQom8mfe8EJ8xbpfAbZhIkhxywBiMgGNWhEJOTUsHvSafPa2+O+65WmhSz7qecP/ONff7/7+Kv3PfqQNns7rzw7Z0Zx2XJiEOvW6cxo97KFS845xU9nqwAAQnmcyQArAwLJY3581A0MRmyRsAQzAxgx3accNZuIZTvycB7MefnQEQYDhAxYPBj49rdeiXbOMfH8Xc+N3rXR2DMCm9DLExvd3qn8/vlzFt70m0c/80//5cQlSDJaGlYAxjp7KSYLIjaWOYyG4aQhlGmMUUppZhbE2phDI6SnTfAfm14Qfla/5rUn/9GnF0XPefS0P8p84C/OTkQlTutBrXoUhjuqO7ZWMYBak5ubbHZKXkCtGoFf+rWOCrBwkhaZ0Ag5tNd5+Gs2Z23OWpC1d91Dex9FroxcOA4DCKA7mUgNpnKj7t7th0qmreaJiJR2u7pif/qRawwOhHtlAAPGMQAAhiEwCIw6ECpQ1Nlr3vZHV4QBcJEBUTAIo8Vn/v7GVDpwc7vFcfHZ//mJ6IIeahPRVQucZ56QB/a44K247CwnmRhL31gVjqlwShnCPGjbXH9zJhu15IxoNGoTABSDlRbP/zSY2voKx4qFASYascO/jwLAkUdEGCZKhJNOOOa8C49PD++M7B5+7jsPGduGaEJrjcYTwspSp/Jg5tzlN371t9/65g/a2jsVG2ZmE9DxC+jyY9WIUmQBhFEPx5IUlcMAAaAuKCUCWSowbcZtBo3MzHjd1W/4wj9/+mMf/PPe3gXa5A837lY2PpkzYpMY4STKYzNeQNAE9y8fbs2hm0ltIA6r+A9hJsW+TQSBAE9AniCPmBf5/uJ9XTyRWw2TBuCtf3zB8ed2LlgjT7twket7LQ01lICEwHQmc/nrzvqLfzgLYvuYtCYdWBkt8h4GLquAlA0kUsks9//JX527atVM33cREYDYQHtH/L+/8pP7Hlqb6Em2966c9YZ3xtoXqef3JXqPcdu7/Cc2eMOp6PzelVee72ayIKqt/aWdqQFiZs0gEBykR4bzQ0p3RLEnZjOCYgNgBE7I/5t7JwwWYURMNZPfS0gtqSAmt51/CYmBkEmQ8QIfCW546zUkfTOUiqZBWwKcdhbS6CwEWs2a66ICgzN7l3/usz966MEn2zvjxligoiIPzrvOz5xqiUEXSBs0GseJwywRLDCosz4lY9ala6ilsD9Nk0FT4Vk0LgTp4aIpYwC0Yu+ddIPTf/RpWgZ62CjckEoAYFIGNSMzmnCVFJwUYh2MIX7UN50znXDs4j/54JV/+Yk3Lpo3V6tJhI01AIDE+ZHsm65+47//y58nIlplNWRt8qWtow4mo2l7OJsTqzf87b+desPrXpdL+YhoQAOAE43ddueTX/36r9p65ox6KdHWowZU9unt+U07I4sWuRu38votAYhlF5wV7Uiy0hO+Bc1skyCiA4F5Op0Z1rrTcTpsKzyV0zgXTQvvF41NaEkK3f+PmFVxlMYoxABENgbOO/e0k05bkR/JcGoIQXM0JqPtzIHnpZefPidxTHsq58qosKyev/mrz+/d3W9HnEAHSpPdllzwiXfmLnEyqawfAIILQIWUFSGhAVRh1BP7NSfLhb2cyr3Uj35YqQYGTPv6b7ALr0eTBIB624Wa23+uM5rDKP43oDFxnhmVmrnctHUbJIOkQQSLzjLzTy5E4wEOXSNqNiMdp7tn9rLVK5VShShplamiG5IBKPjAaFLZIL3yhCV5lUnMGO2c42tK5f1+F/fyoj2vvz7+/X/66zdf8sbhIJ8XZEdj4bSMjI7+3T/+G8o2W7YL1r46mNm5u++2O9xc2vVG/VvuYTeLXYnlF56h/TEPpcLm2nAYjqLKQOex1mxitnx8OLs15zpSdEctmxjQVMVpmMopSikEHXX/P+JJIAGYtoRz7RuukKxFtk9nDhmBkXi3oGjOG7E9efLrXssYQ6ZYgg7s9/7p77+tGcDiALwgrynZMf8v/kR+8LjsLM8d0qAdYAdAIAgjAShgcM2q3vhnbrBfc5Le3Q+eqrdnYpymhH0vMb00j9CYkcoyp/fyb1JUjng8sJRbFAvuIuNlZhx34npamH5FscmsDAMAwAIBoH1OcOHf6F2/ddxdEOnBRdcjRxjDkAzFB6qRmo4RVKSdGLRhBgSkQtyR0IBW8OCsaUjgMEZ+mByDEJEIDLr9/Qff+JYL/uxjb3ju2a1DgykpE6uXzluweBYAZDUIQgL2fd8PuKMj+um/+q8tm/3ZCxd7Kosqlx9xaeiQI9pzM9pHdmztHs3nlL/kpJO6Vy3RXoCFGIEYat0LxgDDDEwMTMwMAlnr8LUaIuvhoWyvE+2x7Z42HsjktUECMqjD58MQ1UPPzlbmnRiEEKG74eEIyfXypTHV3BEAjQxUyNWj9eVXnPf1r/5070gmNjQQRBeRFCBE3LF35YZXRGY5bYIRBXZ1dUfuuuux73zj1g9/7Mrh0VEEmZOCgDquvTZ2ymkj9z6YfnI9HVBWOi6DBEKUIcLgStkWrJoDaGRnFACYTTgNtdiAADSNDuq3yAewLjuufRK+9bwLptY7NQUW2XTEgQreUyum6Tg/TlE8J1SIDAolJ+zQglgRKBSmpI1tbASesPxLRxXcGZ0Zcvl7TJmSG8cOZDVqgkr6RC5sFEwhzkitjdiYc1ghD0JYseCWD4CMjm3PntkTO9ORZBFT1ekCBM0Abe0dN9/66E9+dk/P7GOAImxG0U/bWspcMuPtimAyOmRU0AcSl192JjmWchWFHtkAYdRFNAX1S7laHxnCVFwE0rDOKPzDgaG3zOmd4UR8hQfyuRgLgFpxs1t0R7OELA/7fJSOVCos/nkLkhdfes63v3NHkBq05qaEdJCVOmNNam7Xg89tg+4Z2fRIxLCjE4m2nm9+4+cXXbxy2Yp5uUxeSgkEhtmeP7f3HdfD5RcGB/bnt23yd+6ADhYUEakILY40s10WTMCWAWLUCOalEqVfdtSMs9PEAIATKXAQMWRnXEcF9FLPw2EgNMBkxtYuAVNaawvBEchhhp5mRYYwjyMBEBs0zFohCA6PRY6nvr7cf3zue068F23baNbuiC0d3b/fW9i18oLo1tuklx2R6XTn4jlz1qw0eTXhIJgZAAmRDQRGA4BNaKHV5/l39o1e2tveFXMCMmnXJ8PAwMiv0Jd6lGoQI1zxunN+8cv7sumRyOgBiHTn5s1RJx1vu+7Q/s22iDkOGz8XsEpGewdH9nzxCz/96jc/YVnhWUIDhegqArtnOd2zomtON6CN0hBztOezIDSax/Jj11pWbHvKWDEG0CqnLPkimS1fvjQh3y8vUCsvGrYcDmy6xt1MmSOP+RAAbMyom/tyt/R7u/NmQpNpNRX3IlLahFIIC1GUcgmUEgkgQzRif+vGX27b2RePJzRIDgLjZaNWm+nfc+qC7hvf+8arzz49lzoY+Nl5p65um9Xl5bwxnV3xgGWVFwSVyfXF83oYGGGhvT2r7hlIA0F3ItLuSAIhAQ1iGEa09UyZBsAIIV4014OjNHVSCk47c8WqlXPIA9y712Vwl65UmuLGifocsRxpO8KJKpQ5NrHYrMcfeu7+O9fGE05JTjdoNBqFgWbfZ09hYAQb12dtjOvrYAJx3pCiCGeHgwPPDgghX47i//SyrKrWeGpK9WkwAr9KqczYm1b8TDoPTK6G51MqrdgCTYimKTX3WDtCFPRC41WEjOBE7U2bdv/sl/d2zJjD0onFYip3CAOt2Ehh+jbue6EPupMdkdGE5diLzz3FGIOyBSzH0OcfUTMb0AgCEXekcnftH/ERe614W0QGQthGWLpQHspg4EXyrjtK9ak88uB0hTs2GmIxceY5x0kteHTENUqIGAylcvc9QMoERjEioiAiBkKSJOLfvPHn2QwyQvnhJcZwhZjC1hgNItpS0kQrlBikpie+9rs//N0P7vrKfa7bREa8ImU8pQ9nvsYjhKbCjVsAgMZq/SnicpPi/9Q6OQyEBgByhoEJACMkA6YBj7FkRW+s4izcDYuZMW+iMuLSP4TvffuW4ZwmJyaiUcVeLtdP6BjjR6Nt/Vue++znf3nzbX/wrENtvfN7li9RKVcAM4CufMmNY62EMGBIG6E1oSZrS8Z7eM/IIHAyGu+wbQIkkqbCC6BARzHgJaQa5pnpM7VcfOlZtpDaIjF4IPHC850/+Gl7/7Dp6vRRmSDP2gfWYRiJSLRj/TM77rrjsWRbcizlanjuEgWEPqbhRWLTnOU28FPpLZm2dEfq5j2D/dnmh70lEwT+dAb+nDZq2mTdpDG1jimOym+Vn+UpqVLGxwISjXuCI5MR16dJHMxpkUxMMGAhmpur0S1GuWnqoFDhcLIB5ESbXUBSNFVCnB21n9+0+9e/eSjS1iEjCSfS4WVHtTYkAgQ7n+qMiYVqc+rAs0MWx7uXLY4mO33fLyTu4BYirCEiEQlAg4aRNYEWYksmf9ehvv15ryMaTXS2MbEoZtaoylZ6FANapWkR2+tVnCIGMCMJYwytWDVvyTHz/ZEhkR5yNq2XqRGKd2A0oXVgjDGmEGOQAQyhkB2/+dV92awnBHIVh5lUvo1IvPu4d5+gFg30vDM+d3578xWXtDkpZYyZ/ogmRxSZSdwBgILTR8XfokHRCUfw8gKGqZGBMm+ENiEunhEFNK5RvuEIieaUP1A4EBB6OjN3dsYZOEyHpIG5cH6SmAQA/N93bjEIHR0dVjRGjpXPDAoJAIQEJ1288fjT+zL5XKCHQYm5Jx+HWGHeH6/6LydEDL+Q4hs0RR8hg8gaSZHsD+C+gcFnU6OOwZ62RIgTYZzC8ch6RJpqjlLLhAIQUWtob4+ffuYazwD7eaU8bTvu3hes0VSEpHHzEATGKMOhcE/xePe6p3dteG6rFBFjFBpdFGuwPAwtVPjzNPTt8dWx553y9s986NK3XtvS+Nst2wOV8RkKnmeFgPDTcqz9xXsLzYXVqbUJGHf+f9yTl0qI8dy/pYPIR+YHf9hGVZa/BQ2AmWnTVb2x5XGxcoZ7TKIQ7JAKXs11FUGICIaJpJf3UZn2eBQDAiADgUHDIBAlgvSl3L97+L571upk0sxJikW9vskH2azluHnB560e+uW/XPqe80/r27Yt4rRRu+5ZuUTrgIhMpc+vKbgC19b/hHuF4rohAhH+RkQgiSgyRqxL+w8Oj3oBzI8mokKqQgA7KhQDKMR9AcMADKF7WPEVFOKC8cvRjneYqCA4H6lJ5EOOHjrznHzaEseeZTIklBIo2fV13x7h+ZLA6AARwRIKWIOtOd4/wLfdvM6yLGMMoiAmRA7DAQEAo2bUBe8GNFjcPReIqWqFGAhyJg+90reD8V8TAVChvOFylSkAo9q71x3N5pHA9/2x9opRDpufbiSu+W+qMzypfJDjydQKt1P7VF3lmGWrPj/jndwNTvVMz4sQ8uJwUuFwR5ugk9otAxIRNTM2teskRm0JE6RGSSsnIbNEihMWMxhWKjBGM6vOiPzxrx7dvzs/Y+Usq3eGFU8Ob3qOjI7as6L5kU+8Z02k03nk8R0qyGlleo/pnLFkvp/PoyBErHo1XH9g4VGAyitheEgkNAQoSASG9+a9Ec9fGY8sikSkMTaQYsMINmDAXNprl5+HKKYBAADQ2kDrWSdfYfRyyX4cniQiwYh00qnHdM9I7u/vs9lGwcgycDOgjVGajfI1IAaIAijjxIKlJzmQ6EvnRxkkYDQ9OmLbjgVAwhgShhxEAFSIzKhYm+IpRYVIQAGwVT6MxnrFQvaYwsmccWSJWNRBxLhtAYBCAAQ0wBxGv54eDj6G3PVFvWp0R9OqQqyqkZrunuPKCM1MYJgQiteZuKSrlQ06g3GGviNTzD8CyIRBIwSiAGwtnzVLYeu8F/G8Tglz9Egq6N/Napfl7rWDg1INk86nO7rvuHsglujBrpg9f6YZyqn0iO3IbJqvOjt64smzBofsBx/bIkQQ5HMzjz/ZiTtuykWr9ssNHf9Lf5aDRPnJ7YIZI/wNggiQgdAA6yzzcxn/oKeWxqKh41IAJstoAwukojqYTdH4UPD7eEXrYSdHR5rIP57CrHGG1Zy5nSuPnbv37gOGA2IHwSg3ywaB2RgDxjBJJJFx3faeztdddV3gZ75+4/2Onetqjw33p+a22yev9Lpiox6jiM2NxGcrmsGyE0SShGZwAVwgjyEGJg5oEBp6+4R8lgkK4kVFDg/k4sECgLMWtTOCr0EaYIRR3zBA0iIRnkWfMgZM/Q02c1yrybql8xRhpNUGhUsYIGs22uDP5ss0/wxTLHBkkAEAYxhR1BmwQUQGKnLD4tOpLmlg9/4dQFsiQz+IbRy2+odA9guBliVCP851T3S+sMklx8GFM2RnPLVrP+fyjmNzMHLtaxdAp9r2LG3fnYtaMpfnmatPMNovOBQ1pCqgCq3FY3NefjiAwZjQp48AARgCMHt9M6zycyNytk0xFATGAHmsCdDBUCNUWG6FXhgMgjK63mn7Vxsd+dwfwsRzRFoHUshTTl92+52PagVCogk0QYCWwxpYBcKKWnbMGGOJtj07h9c/v2VO78xMxjgk95OORxcfPJhqV32LTtqjvIMYCB5FtmJePBYVq3T8OJBzGTsQcoABYw4QGZBAVAm81ZOGRmm2bXFoxN3YN3rGkt6IhUopKCxsCr80RkAmw8yIHRGx33VZYxLYJgyQtUDSVU4SxFhCEWJmrL9lqxhVQ9+eBoy+eQwYPwk1pqXwzXLJNGuYgAuut8xcBpwTnQSeUMsfZpetpwJ6mfDuyVHNM3R1inJxGysUaCQVMRIZhoxKWbmHMxl3mXPXT/9tdE3H3SJtQ0xihEkyIgWQteL2Lc+lfBZWdzS6aB5aInegL5bXeVeeuDp+xsk9Om+eeubQYC5vOb7TluhdsVTlg1L8ZygkfqkeUjkOUbgdrvMSuRBSBBFQAAsQTKAZkCFnYIur9ns4xxFzbRFFCEAy6zxrArQQRdXqZAqUArBf6nd3lJonKvmQHXf8sra2NmZMxOOZ4VEAbYxGL/3JD+ZufRTXPXdsbIbrB5agxLYtu3pnxqK2YbQ95ef97bGoXrJqb+Ck0Y4ApBGDKOScPLLZLrO36uRMHbuAzdnGngE0CBwBUAaKpoOaumxmRI44dl7Bdx/YsvFQ9uCIf92pC2xCDuNbFQO6IAOAYQJmYF/PkZGtWd9EdBcLm8kv6sSLMQo1MLIklMJ13WgkbgIl0JjDnEOmJh9vqXpVXcYxnU/xUhh0gMuBSo5vqPr1j0sjWa79LwZNm/wzT73M1KtMI9WDSQYJqFEntM9+fiPn77NH19nptOagjYaXWxIWL2LwNfgALiqBrMHEhFTBsLxvvacEJuZ0id4ulfHdAwfaQbI7dN1rero6dKDM+k0jTHk/yHUvXRrraQdTQx/KzBPqYMo3AVUkCnHgCsZtRGmMIWAiDIB3euqgr2bZco4FMRLaGA3sGxBgJGK5US8T6HalI62cUHuFUcnwO70NNrg7hTTLY24khvXK1fM7OhN7B0dnzbVAMmjhau/sxZEbTllBqcH1z4+QPRNiacz5h3b2H1o+O9GVdFO5gD0l3FhACJ5tBb5niAyjD6ARNSCDNnI4J9KbTdt9mt9krJPB9hmJtTHMVIw5WL11RtRaJWN09/P79464c7o7Ht3SN68zcsHK3jJ77xgxhnYCAFRzImJPkO+KxbXPouggZ7CgPJGAZEA9/ULmwXX2eafRSYsN1z9MUEjc3dQLrWbTrZsBardT52LpSvktRCzXD9VNCQkFr9AaqY0NgsGiSFvrGQ6n0/0RQ6XzuuGPhi+SATSSZ9rzwV4e/FJ85z927buj3T0YkYfiMsWWMAIY8siuML4AjzFjMKdEQLZ4anty1y5BTkIsmMm27R7sl8OpQOWWL1FXXRQHHlE5vWt32rZtrXnOqqXkWEw4FZeSmj6dJZ8HDRywYQAkKp30REQfYJcXrM2qbZ5SiBFAG4AQDYACLveLVfploPo4SgAwdioFmTno7k0sXNwTeJ5WxhZSgKd8a8HC9sjs9Hkn+TOiPqRidixiCD3P27Zl71DgHSKVddAjSOX1s3ttZg601MyGmUEhKUEeSZfIFUZb6Y2Roa84oz+SmRypQjRNw4UUlVVEDEQ0lHWf3TMci9pAoj3Z1p92m3mqDkvGAIY9PxAV8MkAgIIBEH0BHo4OmSALUuiJRNzmv7UJwyE3eWip1RNa9XQ5YwjfzFkyKLPIF6rU4v7NzEIzqv8jDkJKQFrwaKzH98ehJoAwIjZ6e8fz/9y5654o+WQpbVwgANKhGUoLXwtPCaVYmiARpOeo0XZ/lG5/QGXzTqKzXc3pUkqlt+9xTBCozKUXJbo7IZ9JpUaDvXuyBBZztHfRQtu2ta5QatZbnQYLglVFyqSaZUsnlov+2hoKcU9L74gYLAQDfMhX63P+C8qkC/EBgQCp7JxBNlCN+jpKRxYZZo0EzBy1xbGrFyg/yGUzXsJWbKRSflbpPC6cR3NnDWe9gYgtrXZHRp2Duw6NjGZUT0zM7ojGbEli3c62rG8RAbFFIDDMy4SEIAWgAEBQBGnp3WGNfFXkd5ApU/7UOWIokNoiUghh23Zn3F6zuDcIJj76q1kt7ehgbe5dvw9F9Sds0CgCeeqitvddYp+y1Bg1IX+fvMg7kdmg1WabtM6WrssJkaT8eOcRaLDF8RbFxjviSbnuhnXYAIMExwIoKNTQVwgmtBdRMeBykYqv1kQBtdV3o+h/SPh9HCUiNqDBKGLJzGFuegRhgEwQN6OWSQ/GRj1/FMGKP/xCQkQjMDtpZiTyQV737wI/6O7AN1zSqwYPOl3xQ7vTmZwnrYgdlcll81U+MBB6XBvJWFTrVHt/Mhpg0AhYFAIEskEwUGEMYAQkREADQGNhQFg7nHYAAIAASURBVA0AIpV8/IlZE4nQZ5SBFfOQDxkwEqHbkgmJEQEOIhg2htKB6fI5ItFgXQVFCRsmrb6oiS5TUIZMGxXGUO/LnMyjTvH+RNWZ0CCBAIBVqxZKAt9LR+QCD/o1BAcGs25Kxtuc4xfG1m7OcBCxotLNkcrpwY17lh13jOmJ50EY/+D2wcTGLXB816iWcbARIy5agkASAAgfWSEysCf0oICUGR0x5nqOngpChdkj0GgoixwURiQUBJcf13vXun3ppHvZgpmLksTaVBxvLde4hL7/Bhg57/rt0XgimtoxkFkwo63gqQzAjIyAjL5OWrOTGgxoICIOvUdrvM6W+ckk3H6a1Pm0dB0L+q5a5cr/NA3MAGXyb5Osf3qLvYhEAMC+hpijt/app3fAqCtOXGwft3Bsngr/FcASMCh8dyYK5EV3fBa9nTI4CI5kaWv2CZgJkcEECgmMiplsuxkKeCQN2RHWJo/SsWBDxtmYidodljqmWyaj7oYdom8w7w1cc2H7inl5lTZaq0MDOusbhV6yd0a8pxu0ASgEEG1MXHlOqzDzDEAVC4WZAYrCPgMAhKbdEFcY2CASCDaogC1gRNCAxGDQ+AwHfSV8jglKWthOwkIAoLTWEUvmNRfcSI/SkU6EyAhwyikrume0u5lsIp4JUALxzkM663K8Q56+yrrxdyOsuolARGydzw8e7O9c90Jy/jxwDRD3m7andnScaPabtItxwA5NMYYoaYdAkgBBoAG0QtTkk3nByX4bALR9LscC1G7VxhoRAYQxMC8ZvXTNvGTEiUghAI2YmCdrRkAUbM5YNvOxLYfmd7eNaxnHHhzqe3eMo8n4dDZnCZi0t+g4A0AFBsjGNaGIoI3dgY48fj19FEr6JNggRaz8b5/w//A0ZwNhSXX/Jn3G8ug7zgVbiLGJDQ2wCKhBJ0LuT9nHhQGwEIRlWAGwMQoNgjFsWSaI8ahv9gzygEGSaEcEa4IIxfxHtrWllJWcY4nFswwa3rrTGkgJS153QRtwhgMjDeztN1kFlmVi3Z3R9jYupiMIEyxh0emSmcNdCgIbHDP+1HIGrTAf1XzX412/FLI91hEAoAKWgAZYAOS0cQ0MgrER4oL6fM0I3Y4sieRjgcOqN1JH6UghY2DuvJ4F83s3bN7t+qMMgjkYGvX2p0zvTFy91O5N9OfTKdnhyKhw0+T5NLBuR3t+QCSzWixlEdmeX5ilgwkxAp6GvoBRc5uANoI2Q45RFrIQBojAAAIGI5HUN/LdcROcBCKLwkcTBzBVyiCDNLctgig0sAZu9VDq6nmd5X++OKxscj4/Dcy8E5asR400+NXhOZiACUFU4dV0mTXKy09+aqeXKnM6er970vvZI6SROpMYiaBlq/s2+L95Eh0LQYylAaA8AJVkf8o+DowGjQFhNLNBrY1RGozRga/zdrA1FzyXNmkpIm3oIKCSwhE2ZkncuqMjZiCY22FmJPRQWm7f43ne8tnWid22HgxAGWTTN6xRIhpum9sr49HQAGAKmVTLHqVot+dxu7dJvwgsxCoCCA/CMY6vSIDFXHQEAAowpXRamyeG8n2+Ko2tfJyHj45aHSZHITcxGhIJZ/7CXt9TvhcYkIjG9+DgKICGng553FzIjh4UKK1ojBzHsPADS8iopVC6W9pNds/wzNv2zydEAmRjgSYaBb3HN/s1ehHjo/GBlEEtUEUADfJeJ/M14W8EdpiiBk1NU4BB0pONRtAWnWan5Gm2BJRlGmdoIbJpPZG9anh1WTmXBYorMP3ypOdFv5cjiFkfDioGHkFkO+sF973gSEci2XklApaAMhHV9zwHB0e0KCnHGdgC0MDCPvRDyj4MbBUUK4hgGDRorTGdRYp50Os8q+09ZAcxaawwIjSSTSRFwjy5u+fR3aR7ImZVj3IE9A/j/kNZiF5wsmiLDICfBxUYT+3pU2AhC0rO6Q21N5XvMTwHQDBRSLgmqRRNmnnMtye08VJZpt/w7EzBdkJcEkkYxrLcPDWYf37UzSs+HIHs677SlxsGVE3OSzV+RDTGAMDyFQuNUqzQGLQs9nze228M+xELTl4RVSM+aGVQxpOdClmZNIksauUYT+ZfkNmHf/NMfq07SxAYJgJANhEiZ4B5T15qh5QtjAVMzAohwzJC3jYn/R1ys6AFEjWvjXmpqCWPoIn5Z8nJMBS+x4VCatBIM8y5thLflP23fCgFJCiy/mnn/s1bCF5UT1M0iKxHMibto00FhxZgMIwMCEbtGUBiAGOQQksSmJjIP2b1/RxAAuYLWkU2Bn2h3Oiop5K9uUiP9dCQyrmInpBKWD7JADWgERq0S9GvPEZ5QTSvA2fOQUR4drPOBV1xvOSkToWeQgWo/bzpG2IiYOb2BbNRkDHGFOX9Uui3krl1GuMgIhZ8ewCgiARcHkxCgCAsu1B8YeVvbXc2WDuY2zTqDrrqxcSAKXYR+jWVvJsaz9K0j3M8JLyYILFi1YJo1GFGw2wRssHhIc1asauOXxonf5jYR2HLWAIsYwLF2uNKR5pH9zkGSeiCjtEYAAdwWNOuQBQUDIiYwkCD8QFAuOuc1PdRRxgn4zX/ItMU/XbG3TYV/8ovtjiqmtcn8AJqch/xiidEBJso7vBIBm1R5g1rGFjO70JkXXolJgbk2X2/K36IxKwRwBhEpdHXYMfNomXqsYFoFv2YFhYAokEByD6QFGQn8Qv3ph881EVRw4vmy2gnHTwIL2xXSp51jFw532UdIMWE8AxxPs8CUMQjiZkzAq86CMSYOw0QAhdMt4h1QmdNdn64cOY+PIUvgKloJGAEyWPfRCkOUUF9BJDVJpcxw67eDF6XI3ocmZDCkRUrsOnw2i2OeWKNU0VkSmZUWisGbQwzK2Zm1gY0G4LCIxIWdmACUBBahJZlicIZzKZlwyNvm2KMIZLGwNJjZnd2JUdybkJYAAQiONjnGZbgqqVLxdzOnJtLUTwppd3WngxGR92sirVVPNBwoNAGyzVgHCY/PGuODnBK4R7DiyxEBBP//8l77zg7r+J8fGbOecvt26Vd9S43We4N22Bs3LBpppkvoTpAgCS0QAgQElpIQgKhB7CB0IsJ2IBtcO9VtmVbxepttX1vfds5M78/3ntXu9KquUJ+53M/0u7d9773PW3OlGeeQRMT1tkpoUTK3O6MnxT1vgBs5TnobCvQ1cQ+MAPzYVQie0pf97QyjSfzLR7K10181/QoIJnuzWev/4f+Fc/XwSMibm+bO7sYbxumLgeASJiRAVifulTNyNsmtl2IfabI3f0zqj+AAtKUtEYQ2JITEoSQLJ9jttTVYzul6ArpgNg3Ci1FrLI5tbUq//6H5Beb5qCXk7wrC2cSeuqJzVxtWAsvOCXw8wqqOvZCUQpIDAsxeu35fHc7GwvNpN9pB0oYULcyghmfIinPvtn5SIII2PpWA6hFFBIiE+DEFzGCgmmIKUigkTAAoMBoZAGgw1MA0OVrV6GnyKV9rY1DawdXlKZWTRKZOBmZ2bIYllisscIMVthaa5jTj8kUPUn2iuylWClNqI31tHYdx8F06x2wYPefnuif3ERk0cJZXZ2l4fGt7PlgETWOlmNkJWy7u2nhXOf+3eV8d48GXSjlhwfHGtWk2K5is8d/LRSDgyAGoIgUAqMVUYyihcoWdojMd8UiCoC1SAxUQFvT5sYkPkrIEWaAQ1ZgDjvblgGImRElDJNvf/2aSrn+5isu7u1rO6yBOmzQDjK2iMIO/SOpEvV01ox+Cp/5P6P+S6rfYVP07Ifep+lGidj6bz3Ojg+bNVVQOSYNbkUdmXNec4RJIhBXUAlEREpHA7pyP0rA7CFKmlooFiiIJULT296oW/fOrQ66IKJRsXjoCgFlHfXz9fWvP95zX2NmiaqMFW/+PMz0YpLUNz9eQCoU9dlL0dbrmlCMEs3lwAyXHW1jXcg6hazYRJAJCDilwEIG1HswoQgATNBMsRGyzXcnsDjTjAEKqFSd3zsHMD3eEIFJQKHQZMbPJicoWWS36TOE1qcgvRIFgIQEQDV156BF1D4QGwIZjhMH0SfQBC6RQ6IJHERHkaP3GK/T1nvaQwk5AVuCfUogCTGzEbBsjYgVZhEjbIUTYRG0zGnWe0qeiIjUio4xymT/VhoUmTD/0/8YgEFiK4mJIQoz2il4GYDmsUTPhFmz3+NQJq3ep9UmckWBxRKQ76pF87vXrNkKkljUAlQeC9n4mq0P7vL5hbs2hQ47QCa3IDvQ7+yq29C2tRvbaHBSc5IYHnsSR7e0v/2UxtE9a7gWC2t0WEQJgwGWSiJj4JYSZkHOo2F2IgQi+4QKVpvcWSS1Jvfi5ATG/fnBWRhAkGxL21FpOguCmBgRgeyePgoAMqnEGFMsdfzXvz7w/W9vyGRp944/fvHblz0HZ/OU6N0hHwaSbiaRQ7cDJpSVA3EBTesIeg56/nSuOcyWSv9UDB5IGxYREI0dM7IfviS56367cRNppeYvd05cKdmiiBGsCRCCixppfB2FWwXc5jMrRlZgmGrG9OQ4pzP3DrsNxVllBQjE8Y0o5/7N9avWZW6snwidJ/e2bavufFDCJFnely/lnSdWqaGgZuzKucGsDgI0BoBEEfLAuFeJGQGyXSVyFcQG9nATtrRaAJXWQ2qt9EMsVgBN6d9kQ0SZukBToQ2SABpgxQggTlrCBtCgBMyI6KMyBFoQgGmq4pY+xoENEctSb0pymxoBCgWAUfaY5DTNomWSKe+kapJqfiHssUKQpg2MN/mFEQkQCVMipdTKgVaIe8pATTpm9txk6lg1jG2YWmcmqxSJSUgfkmYq+/DM7DURB163z+CuaaYOaVqwoBctMgiyoFC1am0Uu5JAjCcdQ9++MZGRAZo5kwqe29EWhW55sHN3EAhTNRpr60pChT94LL7hMfXKFSe/4/SBudmNYKPYZERbchBipoqVbKuuqgHAEKiE0O807jT5lYfrvCQAFtACuOVJWHUXDO1kFOnooRPOgwXLGMZSUHQ6pWhVHDI5udgEHXPquhDGklXFp5Sf9/T44yaj8Pe959TCarC/MTnoMxy2BfB/Rv2fKOSyV/WJ6VtKr5MI5tv8Cy8SkwAyCYhlSawoQHQxrZ6kicLNlJSt1ogExADAxqqaA8ozeQ92G7U9ZDdLREw8HsKD6+gXG83Daj7NPL/T6QkDadg225MPq7FeOAfrw7hmnWNzoVN58QlQKigTaQIjiKScoTGnEegEbLa7XbtOHMaoCGFvYcQITe6+6Twwk1saK574N5X+OEmdTBdac3OmKdAoCshBJEyxYsIsSOgpVM3STMiYZlJOyjw+5DahaB84aWwv3QWnvi+AiGgBppjMmGZKME5n90Ca7ix737+VKNRMuNvrIwQTQ918O/1vwoU1Ftbb/ayr9UFZFFPRz3ZfOb7n/s/Lfpw/b0YrdZYJuBY5QSAZUlCPTjzSmzdjuFweV505yxk907O7pB4liTiFvs73vu9NfV1uFFY3bn38oQfW/OC6+u+/rt5+Qua1Zw52FHZK3bUWABTUGBogngAjWAPA6NbBZFXyBJkRge50EA7lJLAIgmARcPNa/bNvaGbNoISj9RvswEZ56wek2IVmjzIhymrSgCas08suPd11461bdr3slac894N8yG0f2sf92AHTHgZPxQX0f6qJBvEAIAgqSovWWik1zZmJLECACphZGqgEgMASkAJSODkoz0jBTkiHO9VCE5SYIUhkZhYCrR+r67xllCe2utcM6Ds3tW3LFPtOPG2mt3j3eLUyNuDlnGUvXkGNvoc2PiGd7erBNfX121yvUHDNC47KAcckqR+CAJyhEd2IwIJb6O6AZsGvg3b54GcAtHT/1NWx9wXY7C0CojAgWWAUYJaUHY4EFENaToxFHJAJyg46HO5YadkHMsHX2Gr7yfafeMQ9X9N62D0H2BSpvf/n2Uu2plKYAahFN7/XN0uzj9PccApYSGg8aBSzWZ9of2fAhOhv9m6qxYFAIhNW/N5Z+pNa+rATfj1+pk6L3r4uAEABEkawkXCYxJA1cdToLuVe+UL8t5+NdNecJFyuS040MKiwoXLO2O5tD969asZbX1isOys7zzz51FOHXlm95dYHP3f12u9/w3zsnOz5SzZBmqMYgVSb2bpiAECJTlAUxRXkUaHOQ3zOiRNZCVN5RIkBtKxYgFWXlvFBGRyEjvlixmHCok0LUgopIQ691170UgDdiBO2hsk8u06gfcIV+zL47qP+Q1MROZR9P50pcHgHwP8h9R9EEMUB5cDuJ/GJP/pDuwDj5MRLotnHu6RIGWwCXlscIJh6dElYIRCgsS2/eKphplOggjI2dgs6qeKKiGwBEuQM2qzobZF28OGRzisf6bxxQLUvP+q8t5/8piNm3vBw/10PbiDMlnp7el7UVerqgvqCRbOO27J7df2m23sxu70Kpx2hjpo1YhMfxKIkAAqQ+0fBWgseFmd2H1Kvm8J/+vxeSgvr7VknhITCCIhaKc/zACCOQ2Zj2ZqWk90mzCDAqAhUS/lWYtPbZhX6hH5LAWEkAH720HyImOr1EzCtKR3c37DsI4dbedOwr649aRfsK8EP6XgToHLQ8HPZ6ScIwNq92VynON8mvz/tCLTiNMxsDLMAIimlAe3TcWRPpAL09nUVCxmwDAq1hkrYqIc5yDEA2Hr8trN6C8Xtm0cG1vgduyrFLQagki0UfV8H1/7wpsGBXS9/z8vbMpmhhurqzb71DRdfeMHx1/3mvg9874471wYff22YtUNsSlwtg4OQRUEhFoxZ3FhMFuwA0JLWyB+KEcCTSBub9L0WEYREGcq1kYmTSRenSFMUYAQkW44ZIEIBoeehkPW+eJxDT/3dlwzm4BbAMwX0PNzPHjzj9Fk4eBARDEC9nx64EofXKHLRyXh3XNl46TzJzxBESJ3DU01vQIuI0qSimnw+NxUHjIbQVAEASZgEmtVHhdrzNgIdl+/d0f7Jm44aXTLn/e8/+cSls1bvqP/kt2sfXTPaib5a0tV9Rpvje/WgFrtRkvHg5/flyhw6Fkbrr31dmPPabRSBoIhDpICd/hFBFCfjZTvb9gQh9wkAitg0/jlNPcjmBaKRkBCJkCXd54yoSCvfUcoZGhsdW7OhsrV/wakrnaxrrTEgRKSJRMQKKATLwMjUPBBRREigAZLySYYkGQWewGHR/8hkAtrJMzFFi5/03xTXC+910V7l/+jQSJP2GsypUocOUehP6RQCAsSW3X2pKBmYn1aVQhF55JGND9y/6owXHrd02XztOQQEANaANUhoD6Va3IFbb19nqeBXKw0h0FkwIdUqIJ0OiFEoxUz09tP6QNRwffumCv7+jMXX3zu4+WFPdH5Gvm/1r58Y2DTy6r++bMnS2bVqAJ4qZEtXvOXiF517xKe/cO36/773628u9DgJW4BEwLSm0QKSFh2rYBU7px9iGADTVB0gS8ClLkCtGciCI1CpDajjjlUzu6wNEZXsYfyf8OzxBMrr/yoxyUG4gCYuOtybPt/9OuSmXRBDlZ3geSigJEE/4zTGTb57/33ApkKxD74QU6xLshNNBbDlKWYAEOXrSCVeYsb6s1++/wxzzPLv/POye9b7f/+FR7ds25FRTkE5PDvTcU6nAbDMAFJUnbsf3Tj+aCguz8rs+ptLo9ct7oBywzoC4CggEA1CA6OkkLyMn+koPQXlLtUIiCgF0ogVsJYFyXV13jfGDm/ZseOBx3av2bjl/seqOwaScuUdv/p6aeEsdhQAIIpgWjq8SQ+Xqp4EDCAkTWaWkCUGcQUTkZnKBXke8lkPKxzaMiBkX8qj6VqLLXHK2drypDV/2fvmAhAau9cBEFt+RsK237vqui9/9RfzF/YuWzrv9LOWn3vOcccdt8R3M2gR4OCxh4M23/dm9hXGhqvooWHJ+JGrfcSGUBJbAmCkkIC7sk5nzj/Z99917AU/6H/g179a/8TDHYXcjNFHt33t77553usuOe3Sk00UznS9qMrHLlr2/a/O+8CHvff8+Lpv/ZXJJQgMYgSUkDAYBIPgGeDBfSdr/3FOUtyC981dquYvlfWrYmQmhpPnqIvfnBhXnsHcyD/D9v+7GMDEdDMCcmC0o/J9OLjBVUVqDEfHnGZnLUYxAAoEm8lTU2/Qkv5NRVBEFKBMMGjKOKiGBaNJA5KgRQLQ1sUcj8O9q2bdHba/7Y09v3uo9j9fva1UzHdpt2ESm3F6X9Cncn4cBhLbnOcODY6OXP+7o+c9+Jpjw5f0ePOLs7lRtq7RyhgBIgFgATM0TgTazYlbLJgkORzlriWaWICa/kflaFQOMo4PDm+//vH1t9675b5Hh3f2myh0c16uq33WCctVwXVdxTZhNghTSgczSlqNGpFS9yU2D0wEAAsITDsl6XUODf5y+O1ZUj72PQb253pgaE5Aq/cHErWBSXytJs6A2B7Am3+QthfF44UXnLxm+31bN9Zvv+3RP97w2FdLvz9qxaxXvOKUCy46aeHChdAK9TMzABEBQroIDmkoRMD33a7evDyCfYs6GhzN9+Z1lBh4BzIhKCSxbFE4AVeoZqv35TB3xfKLLvmb0391z03f+OlmFzvjWu23X/rl49af+aJ5M7jcXud19w297NQlL//bN3z+tSPf+PWOD758LQBAgqkmjsJg6mg9UE3utiYwWQjQYssRu1cjAQHilEuajL30UrrJKofoyJVqzgkWtbWhIClQz0Ki4Z9H03vZtvtrLWL5A7WnptU9i5t2n0bpzmz5u0XibGlBfOx5yWPbRNfAny3LTiKniEkiEIsIpmUQJ/t8m6VgJobKAiYWADnrYAGFnGQbaKWzIMaiOEgCmABhglatN9dumZeZ26sld80P12azRdBghVmstzyHXZ1RXdBBN5/Ru2pyw1f/8Yhdr53X5ko7QQ2icuQCxGQTT2c1KNo9OuO3t8WD5UFftzmZNsx4YlKG6UNySqT4ccXUDGWSzpTy4VB52yOPPPLH25+8/ZGxjaOY1HNz9NyzZ889fsniBS/oWDA739OeLWQtJ2nUCZslXyYBXZqYyyYrELbmIpVQFiQBrIvNE1ET3kPThoWxVdF0AuI5OYNs8tROJAGkujNN0sObAb2Je04NQbeATHt+3qMLpqBPQNgHcInU5DuaqLhNrZj5dEuODhxvn8gegOlslANvjVY8cG/EF4Kcd8FJp7zw64O7B1ateuTmOx+6/bZ1d927+s4713z1K9ddeunKv3jzxUcfs8SaNJplAEgorXW0v0jylK8FQEDp65tZb6yO/DkzXndx/8773vDrB994fPENRzlOtIvFtZCggFCC7LkaoHHLQI1K/nlXnHXxws6N//zN64NAdxVg17V/SOa/fmfJjG4Z3PWHXQay51y48NhLTrnqG+ZFK4ZOXrjLcJZQRDEgiLG2UtNZZUudLLHAqBKNqC3Y9Fia5tFbZXFRQFuCTDdc/JeT8QuanGYUHbAJfktH9RmSSfvO4EGAofvmLe4TL2vuu33LA0zaCIf+PP+/swBwUplpJDeJxrHvNNW5XJQWJwcAGI7BxCiT2nvIkEFSerPU6Z9FcFjI2jiJH1DRXV5wP/iJSMzkpYhHAQLRbhis3T3/rrHuhWdlNq2v1auULVliMCwslJvdQ452ojqCX6gk7l0//fD80WNm5DXHBnYhCIrjJWg0iioQVrbunPfaH46sWz82s30WWPTaPE0AiaDCCejDpNyvvVsqI1HAgkXHy7i5cv/Qg7+6/tHrb95x/9ZgdDwzMzvvgt4jzz522Yozu+fNyGR7DYgRBmuTKE6p4REVpuQ/sje8JC3JrabK0+b7StUYcyrdgVPm5ZBdLs/AGji0a56WN2ZCoExecjCxP3HvJ3k6EbjJe94KIGIpU+hYXFy+eMFrXnXR1q1br7vx9t9df9+D9277ry9e99Mf33bRy0995ztfeuwRyyw4DbAOKgenFyvTfhcSzuntIaJGIxht87MLLwmXr3z/L6+5ZdPAN87r8eMx0BkRVmwFmyXIO3fdW565cFD3XXzi8jUD9W9++W6jld21mbYM8HG9Lrk5z9+9rTJWN9l5XfWc9+M7O09e0q9YieHUnhJUgDoZfMhEn+KOSzGzwhMhHRqglCP0qWXEYgt4s9enD4tc4c+3Pc8HwHMc/p1AhIBYwVb6ESny2yUluztASxcKGkAWVkJ1UXk0QvX1KrzHDR9wzXaiEGwKBPdIRCAEtCAE4kE5/P227JAOjpuht64Zdz1JFDlGkLX2ldtWsrFVTC65hXt/97bO9SvaTWw5AesxIVlRbBWCKAirsdf9n4/0PLqFOnMYMSaRaevqyWodRDEcWhMRJkSNGb8QDoze/YsfPHz1TaObR6zCzqNyZ5zzyhWnnD1r8XwodIQSxSaJorpiQCQCVK4DAJhCFJEhtTr2ma9Updp3Pl1GFrQILrWum6709LRPve9bampA+ymIgANzYT2Dbe+6C3tKoe1tJTzlk2BCfAtYQYiShJk9x58za/k73rL88ssuu/POu7937XU3Xfvkld+48Q/XPXDZG8985xWXzZ/Vm1hKBBwFhIYPQftFga6OkqeZalVbr9VI+V3zl77sZT/+9v903AP/cVJZW0f0qOCeDBvPjGYqD1d7lu2K4gtOOfZXP103NlJBCcINm72j57ikfN8f2ljZXQ4yS7ukq3DnmuK2EW9uFxijwIqjGIXJigtDunadGbol6Tkr7LgI7XFKlGRqslc24XRRuoMP4D7qxyFiBP6k2mEloD3DB8Azu3OelX2ITRUG0LRIkhFJ4UFlEBoRRHEBGFVgTTs1+p3oaqf8IJvhlAYUDQFVmSwlgKBFACxi4EOQGR6yv988muvuZKVGdwXaM7HJWQjQkGoj5WW4YR2tk9Hho2tPnrgoAIaMSQQBCAGBmQl8EobCjJ+NL7h1ly75oaaC51lTi52S6ysKDtb31HPNSErAZjN2PLjnl1c/9KNrB1Ztczv8RRcuO/HiM+Yee7Y7sycC3h2yH1UAmEBpQ4REDgEwW2mFO5kYBdKshCmOiPS/vaJrmBaVFAYBY0Q5SjCl0zn4LNNkIopp35TUWfSntVn3Eh9TzgCh1Hk0kZWNrSlqWkv7O5xaBtwBCbsUW0LxCSBJmqdNqdRxwQUXnXvBKXf8v4e+ftXPrr9655c/e8Nvf3Pnu//6DVe88SUgmYTFUYRMoGJhZ785CiKI2NFeUuTEgzXaXoaV7UG9Vuic0dvXdcMa9cCR4Un+qDVd4JQnPmKsrxrr0Y6HVOhqzy44snvkxiHHywQDg17YAGDwnGigNjrUyM0oFvvaxnc4924qzO1IIAZSrk3tT2211o7jO6gzu28Nxu8P218Qt12KskxjFQAEuTXgqfF9GDO1168Hyq/9s2p7UVTt1fQBPvPcPNlT++tTv21a9RbBCBABSRpNSq3yaSkJWmYDIwILxaC0YJGiNZmx/1DBNs74CESiGELECFkJGoSMmJwQ0piRnSHmh254oHvtdpmxoD1qZBJTd5WrpMYKiK3KZkiTgYZQwWzZtTxbAWMtacVKEAwRilYJg4ZRN/etO+p3WRVvq2WCGV4hMTwGyE7OC+302xWFhRBBAaJ2nKQRKpdU3t9y8913f+fnm+98nLJ22ZuOOuMVL5219FST67BxNQxDFMgAMAmJEhYBZcRQ1ETZg1bK1To1BVAQQIEQC7JFwxqQiABRCBGRiFARsFhrxdgqh92OV0BEDiX1v4JSwgdbDIcw788HnONwv7MJ1RUgIo0kpACAAVFYISAqVOkgIwMBAIOEURjHxlprrSUQrbVLKTpXK71n/6Zcda2CD6m1Cq29L8wSMyOA5rYXn3HOiStO/tmLf37Vd2989ObaP/zV12//48Of+uzrF85dWgvR8WKX3VTd2RfkOhE4mTmjw827NgiCdZs7jz61bIaizjbTvnjovlWPPMEL54tiEu0gKlLKddAhAQZV284dixLMz5o98277cIYyZmSQgjq6WvuaExndNlpctKgwu7DtVr1hVxakrAQoAbAkSokQoFiIRTG7SSYeyQxcG5UfCdpOldnvFrECjTT/koRsmrTXymM/0KS0VtdIYtLYWLvTHNj0QG4RhT0PqQBPrR26EXCQmsCHRdHzpwD/bD7MZOtvn/plWqmEJUoAAPKuchRaa6dHQYjdw6hDDMoCMGCnM/QHf+xf0dTFBWIgDZBEgMKK2ApFmThWgA3qj2WXC+LGbu7mNU6snc6ZHWEFgATZdWwUuoJilesIg7C17JXK9W7ZCWytCIMhEScmJArd3G7T/bHfZm+5OynOqI6NbCXsSEImJ0YiP1MwcqDVmQ5LEsV+qRCWq7d98XurvnttbOtzz158+l+8fMGJL7CF3HhQzwYjVikAUKjshHuU0Ar7flY5WkhsnETVamNgqD48Nj4wWBsajqpBbWQ8rFVNGBljUummlNKu47qu9ty2zg4vm8kWC3OPWnzkcUe6whAlgFqIERkEJI3O4mGkqk6qUA8ok6uF/3k0RHSUJiJrjbUCwJmMV66UVz/aPzQ8snXH9l39A0Mjo6PjtfFyo1EPkyRJoliheJ7n+34+mysUc5lMZlZf9/x5M+bP650zq6evr6utLQ8ilg0RiaBpcu43v9OCJAhStRkve8Xrr7jkRed94atX/fB7d/76R7c+8fiTn//Xd77kJacmRocAbhqhn25RpUiv9lJOHFGRsQ8+OjA2Utf1tqOXZbwkP49zJ565ul4NeNAPwlwYaVNxqVbyyZda3Rtt5E8OtRSKniUjIjRSw0asS3k34wRgBzYMzXvJEao3y6Q27MokYR2MgFgiQQFlJYlilRHysxozlgTQKtOfH/1NwjuTGe9k7JIsgElRuZSSFR50IkaMWVUJV5VDAPAIBWCGr48r+QsyzgRn+J+dI+gQ24HI4J7O+wdth6r+T4jyQyhhOOX6PX/YK8GaEfW6nZV7nhzJZ9xXnDhbkAHTlAgSsWAnEX9PfkbUAB4YoPgRXf0CuLE4WYKEJQFJqeQELENUYBoxDQM7KFtvA9ChDgd3+av6IZf3sqVOG0Rk0SoE0EoIJCZ0OdEmNKjqVAbXzYATqKTOjieuYo0Nait0zv3Wr+Dnt4wtWlGac3rv8t7e4V217T/bkXEwMNzX6cz0vO0Nk46DkkmQDtwzmH4xv+vBx//4uW/2P/yE15s763WvOfG1r5JieyWxMBK6pEMfURgsMLLjOMpzEZHjxEbJ7s3bRrfsHHxyy/CGzaPb+6vDw1G1buKEjSEmSuuQKE1EoEhIGFlQGIGImjnAiemeO+uz//OZWXN6dcaLYxVECYsgikopNvbjfZ7s6nlqy+m5bHsY9/YP7wEAhagUEoGg1i4QQCDmP7989Ze/8iNEpcRl69iE2Viwaa5/SlNqUtLHJoURIrNxXPI8p7OrOGtW1/wFvUcduWTpknnHHrtkZk8p47sAECdgrUUEhaABwFUgbBPumTH/Xz/1sdNP+eMn/+3rG+4YfssbP/Phj1/+3ne9UVEUWc8BIEy5BacZ20w+4+YyY0HF3bk9GOv3XrKybfl8BL0AM5e87BXhuB2O6lXTqNfG46GRYGSbCsczlbXl8djrcx0TOFkH0JKANGKuWen2JVdj0iP91bASYUe+lEu2D2YqVaeQsWk8HowQKZcciZkYmKw4zG6MwgSOP3yHireGff9oG8s4EwEEAIDiHLhCPCIOG/ObwepgbAGBBCwCAPRHZtdQbXnOObcz34RJ72cR/smeC4doBOjJH8B9bnHgL3j2O3GYNtchXI+IjSBat7M6OB6P120QccZTYaPhONKq3LL/k8YQwqAz/AW0CUmGVQACKGwRSCmIIawS4Fau6dzWXowItGGOHKQndgbbal5HT5akvZEEyIKIjEyMCSohkpg4EKBMEmPkZKr+zOFSb83pqwaFndWeLeFc3Dpw87o/FIs7uj5y6ewXnpbHTOF/H1n3vS/7GQ2kX7B4qcr5O8eqgmpSnRNO69kDKbAiJI9efcOdX7pqbNvgglNXvODv3tS+bElFFNcDxaBdJSAYMrkO5TRpbRrh6NpNux5Zu2vVmvGtu4a37KgOj5ooJl87nqsyji5mc4VsJptFTeQZUsJsTBIlUWSMyYwXTRwbY2xiREQpRZ6KxmsfeMvfz+jrWnnSyjNfeNKixQsczwvjpF6tuK5LCkGIkUkYQGGLtQenOvebEKbJZYcVQAuwsb8QJj0LFuqhnEwTK1OaeeUoIoSU2kmAYAzfftujt978wAMPrFu/cZvvzmabsETaM/k85rsK+fZsNudmMpm2QtFxFCIKszEmCBpRFDXKYXkkGhutlccaO+5fd9stj7nezZmMN7uvffmR80479egzzzj+qKMXZ7Oaha1BbqbWagCjjCCqS1567rErj/mnT372Vz9+4lMf+cnmjbv+5V/+WlOUGKWUahbAm+L9IBH0s353Lr9r96DyM2421/2ql5d6e7GRPHbdrQ88sXPpvO5SPduWo1xnMemdNzK64M5hVdt6X/9AeERYKCpHTAnZQRYLEIcCSKwBHT9oNBojdcpmE6JKQPWG6igKJM3sXBECRrRWbEDkIikQF4BUAJDJOWM7jP2Y7f2I0BHgExgB5P0jOgkRBeE3g/WBRAhV+hZPeCMFHqzElaT2qhnFSbjf57ztV6btjwb88MIW+w0CP6vy/bnW11pGAIOAJc9zKC8Vr3FsrpTPutDEEUuTF3oKFij9mQEEMVG24YxcqYO1gq6oCACFlAggamaxjUhJ1dndmYwSRjEoASQAUJnM2m1Wi0eOK06ZnBhBiQgrRKMTy9E41ldvMTsGqLxajQ7vOuqU/929aPfQfKAKqCpAONN7pAueLPfX7cwZybIXrBWdGRgZ/tWNng+JsJP13Q5/jopXa6cqVqOk6PVWHi4RepDDu/7tqlU/+AVLcvI7LzntL95cb++s1SvKBSJCQREC18eCE42MjzyxbvNDj22+b9XAY08mw2PETJ26c7Y799iZ+e7e0uw5xd45hZ5elSt4+WwmkyECQCcdQ2OMtZaNNY1yMDpQHR6IRgZ2b90YjIyH/VFtrA4bgp2ra1tvWv+r//nVomMXXHzpeWeeeWYpXwqSqjG+VhNALTWhefKkNB9qlhkAbpW3RJQpnJ0yGcDXvBtBS2WWfbK6noWVODlNbBK6HBGVQIICSnuFglMeLv/oV7//2e/vXPvQltGBBkOc61SLFs5avHTWUcsXLD5iycyZM9vaO71MzvO8nOdpAEQgAhFghoStsRYAwqhRHhsfHhjcumXzts1b1j755LbNW/q3bd109Y5rfvZQV9evjz529otfcsJ555+28thFAJywIIsIGAEUUgnN6p39lS//R3vf53789Xuu/O8bhwdGv/q1jxXbCpEFbua2tUA1QgIiDF7G6+nuiFY/XvKzlXKlY+dQ2NHR1t7m+f5V//mDs196HJUbVnugHVdZBb6H+epYbXhgZiWkof743tsfZmYQAjbJfY/5pRx7xbJfd2r56lgZs5DosUrIm2s4FyxrYBtCWpBBMF3WKAlGosgRJZYSiANUyjH9auy/Yv6sddoUGhQroKeVoGkay8PVYCCxExlOsTAC+NgMzheQNgfJzSP1czvzf2qq/v5F6B7Ff3L4d3/XP59B4MPv29P9CCKyoFh77uLeJV2F7lynQ5wYo5WStGj73o0ADKBFcMHmqP5rVbtXpISqCsYhBwRBmEQB1wwa5lFXRtG1JEhIAgwoJAwbaoDoAXlsfDAaqCEiRC4gBvUNcn+dHiZu1K3LlTgL87yVbTva597X4Yz1uKNtKlIqGQn1Nxqd3vxjox0jfNOGxm/uDlZv1g7F1rS3Zd1M1ghnEGoteaYEBcUQISCJ3PnJrzz00597M7pe8I4rjr7s4tEoksaoclyOrFKoC1lANbRp65abb1t7690Dj200I+NtnfkZCzrbzlk0Z+Xy3kXLvJ4FbjanszlQBKgQ0SbGsGXmBJul3hkBwEtNSRc7vYWLulAj2+WxwSQxlbH60NC2tXfuXLuq/HBNDeqdN+z80u1X/vToX138ygteesnFlPPDYMxhJHJEhNBBYQE7eT7SGOfk0CvtM2utw2BKzhfKU8+z3bftG/vdq8RCK02MSUjQYJM2CSxjsZSLw+Qb37rmhz+57tFHt0QN47fBkS/sPvWUlWedctqSRUvz7QWtfNLKWpuwtdbWoqgRRohIgGmqsabmclVIvpctzsounDv3BaedjAhRFNcq1fWb16167MG773po65rhu++57+YbH/zyf/7m+FOWX/qyUy+84KS+3k5rdFoDRxQJgNb63z7+sd7eb3/ts7+/5perGsk/fO/KT+XyxYRhLw8WIgkDaenozLmCmtlLTLx1Bxy/vGEj95SFm/7tB+f2hYtnBxLmkBKtWKHj54JyDm5ZP/qD3VsHNj1Q3lkp5DoYEhSsPnRjeesD2aUn9Op5DYVdPe3lOiG3h8nYrtEYQAwsldww8qgOY2FG0QDMzBDFJIQZxY6yImTqpGdAZZ2CH3LmPZCLJTkIynEgsQJgQVSL1VEAGlYyrYqkOcJ19WhR1l3sqWfEBDgwJue5b3ryY+3784G78XSG4BCue0b9PyliXZriwdd4RE87AgqYA5+QAABCIBkV9Tuj14BtgJMF0AAELKKYWXHdYBxBgjSUkUghITezUhhFh5Z2VazyQLvK1N247iC4JgmC0cFwbLeplYnIgo+OVjENB6O6GF64ULgRAibAGoxHGX5shzdsE66Pj3/ul7Bth6vZZj3iiIMg05YT1zUW8hqGDbKAUkRGGJ2IIGPhtk//58M/vbo4t/Osf3jnzPPP3zUStGk3dhKJY10oGqV2Pvzopv+9YdsNd1YHhtye7NxjZi467Zz5K47pW3KEW+y25MWKYxZOjBErYWwtM1tEnbJlNQvQTzBZplTGnPpOI0RFROT7Oju70Dv3hGNPPLpaHdn25PZ7/rjjrrtkE4w86ly17nu33vjgFR+4/KTlR4f1RiIsQIasPlgMb5L6PzH7TerjyevtGZT+hwf7kRbxDjJb5TpusZi5845V//GFrz5w95P1mm2flTnilYsvPuf8M044pWtGX4RUqwcRc2BCDlghadSKtKMUgEyUk1SIViQNexux1nKMjAJEmJ4zbj5/6nGnvvj40+3/Czdt23Dvo4/cfe/q+25bd9MNt958zeorT/jdRZcd/+qXv2Tp0j4AjhKD5KJWzPbD73pHe3v7pz/0vet/teod/qeu/PbntHKsCNJeWCBAkI7uPIvEwAgcb9iRY46jqDB3zgaXk3Dg5KPyFAUCIakESAOp0HErW+/ePOBpKhRUByTWiGIEVxdpMEiGrse829Y2K7k+aqeZpCyBHhhBYETYJdIBosTsQFIAe6J0HAcEHoGO2hbp0e2k6qTzevQ3kltm3XOFkqn6w5TGIjuCJhNoSu6YsiUyQt0KAOQJAaBuZVM9XpyWcvs/1w4pD+CgJBCH3p5P22JqNFjEAlBiDBGxCExPwsUABKjQRnr4amV3s/ZAVSUpkIqAQRilnkCUkLYw4FDogEtiJ5wMJECcEMeKjWcTNlE1aQTVkcej8mgUGqUQlAOIUBVwOCEE9hzHY9MQGwMSgAEQQLVxhBpupjfYFQw7lMtEmDBHLiprrZ/LgFKJsQWlyCaQ1qBBQgBH8J4vfv/Rn1/dPb/vrE9/uHDSitHhsk/Z0HLey0je61/9+JofXr3pD7fXayO9Jy464a9evey4k2bMW+bm2kOGhsR1EyVJRHFKzZ7ymiKRBlEpDxzARKmsZlOpgd5aM5JWiGGIrUQiNUbUmF26bMXyY5Zc8Bfr77l2020315/wN9258ZOPfeblbz7vTX/xOgKPqYEWGR1Cmbzhp5nV1tJsCf699YDDqkDwTC85wwAuOnHMHe169+6xz37qx7/8+e/GR9npyJx56dLXvf7iU448EZ18LYHd9UgRICGK0uQAQVp32oJtsly0pD8A6MmkT9jirUBgkJgtsI2SZJQkQ7pv9vLL5x91+ctlS/+OO+6/6/o/XHf3Dev+/RObv//N37/8stPf8MZXrDhqPiBUg0C7XpDwW1732o6c+ru/+c7VP7i3I/+lf/vy+xQJW5yEs2qGPtq7SgliRIIiwdZdTmRBA5U6oW1eY3g8AnatIUyYEhIBriJ3+MV8NAKOGwIrAWIVJ2QtKNcnQt9GSWPHlvu/sUG7BDonkB+vZg3HKqgjREAuWg370DJzHJGItPmcn0P1NQQZJOHhH3HuNJvL72/2m2xIgKZVO5SmJ0rfIwieyXXxlEo/PuXvOsBX6IN++ND7c4ip5M9nQ57I/BYQY5Jcwe3vH3eplC9Ni3hDBSKkKNqoxu9L8j5SSJwhiMAAeI6ULVQT7IxhRGFNKyQrlJYgtagQCAA1J0Cuoqg6NvLEzb8ySQPYkMq4Og/iIiprLGrFxghxYkJHW+Fqi42CAESMs2YnCauYM+SKw8QizGnyI7bNaLNKm9hmFSpACymLoikUi4/94Dervv/jzNyesz770a5jT25UGnnymI206V1PPLHmx9c+ee0NiTSWnX/GcReeu/DYU/xcVyRJA3g0HGdmLcpB7aIShIStTTPyU7KUplO7ac9OpxenwUYCAQYhFkFkIKtERGxiAwihq3DEZVcseeErnrzrmm3/+4dkQ/jj//jFQ6vWfuAf/mbxgllDQ+OuY0AdBMUBAAfYnhMB5OdF8xBGTcTMXZ35e+5Z/U//+C+PPTZqWS8/Lf//3vb/zjzrAgJ3zDTExBpQgwYmRARhRgsAAtwqPsMTcHYLoFpbusn+PVHqGEUmGF5RCNmglCGuW+Ua3d018/KLXvXqcy+67/L7fnXNTdf/76qvfeG6a37ywOve/KK3vPOy3t42Y6xlAMFXXPLqWqI+/tf//d0rr5/Z2/7RT7wpxdTv0Z9QAKCrM4dIDKIUcf9QMFqmWTN8V3lzZm3cvjGDcxMoI6ASAkEwGcczHW4SV0zc53hRFgJrkqoRUhqNymRU0dEojmGMGSI2DjA2opg50QIQhuzUyQkEc5NT65r/mUjYlWIWxi1CiK6vwk125I+Yex1AY9qpoVbNu5TxcdrWsJIaAV3enxPK+LAygdWHP/ShPSwlrc9Pvlfrp72/Y99fD7rDDoX4Yb9ozgPe/nCSgPb0KJ/P33XnEx94939v3jj8whcfMe3zkInEzbnbf07RRvQRwaCN0HqgIrGODFpUMeYZdylKXCQtSClJMgCqFOLoyS8e8ftjrRQ7pDXm0OZNrCOOAye0eTE+mrwLsWETl1Tw5pMyba4FNqlZIoKg3B894G4Yc31fk1gCYjDMsSJromjpqcuWnXEcRAYAd7MVwTi2fikz+OBjN33o8263f8G/fqJw3ImVcuAhesVsozz48Fe+dd8nrxza8tiKy86+9MPvPe2ll/UsPiYkrJt6YgxZ66LrigYiRLFijViRNF+uWescIWXPOtC0cproi80Me2EEFoJICVjMiLIgcZyEiUdtS4+de9xJid4Z7h7c8Vh85+33tM3Jrzx2cVgDgGTPqtgzhU3eN0WU5mzuCbruNX3pX/e/8KbSqE1ah1P/uif9GA/wcdz35o7Wnpf93lW/+PCHPrtxU+SX5PXvPON9H/67JUtOHg+juq35jqcZGDhNRxQUACYQBCGwAE1S+sllPmlqmfuJayCVaIAIBEBaPMUOsYNMRsCijQTZ8ZbNWfjSc08/89xjcn2VRzet/f3/3veHX9+byehjjlvoaG0SsBZOOvpIt9vcesOqxx7ecMTRC5YsmScCk4kRkWT79qFrf32v8rRGJaFRpxyjFs0S1wm2DjgP3/Pa0ztZxc1HBTHCKmPvfcQ+tIHbHRVwzR5V0if2rDxJZ2fGSa5c1qPlcHi8Wo5C41illPI4nlWqXLhSQ6aRCKIlBBeb5EKTGcUZADg7E3ym6kZiD4TJ0RyOc9fZ+6v1rYAEgAGeDBJJU9IFSRDSnP6WWesieUhntOWy1BrfZ7rhpPaM3G/ar9jf1YdUFP7/aoui6IdX3b59Sz2obdz05PAxx/XVa3vT6bCbo/oOPfyo+BbDOgiBSoQ9QSW1BEKLrsJRgJAERcCCBQZQWoEDlUgaxt76hLch1Fpn4yiq21AyVs/U2VntpcVH5Ppm1QcL4zvKNqhK9GQwHqo2LBUabrYMZg+PSpDI1lF0dFqkBRRAQgDIaSnbtp7O2DCyaAQCJCLP87AW3fLp/wLHnPcf/9h5/HH1sbqTd8TT637+64e/8u04rhz11hOPv+ANM+YfZZHKUU3Vx7WlDCkmsiKxjQEmlTlDTDNYWTAlfBZJnaXpxjnAGDerEsoE6sQ4jAxUJeMaJBZJQKxt2L7isr/8cOcRNz/2kx+OrA0/97f/Nfi3429+2yuqVZNWp9mrHXS7tLTiacicn8sWJ/jP//iZn//0uijOLziq8x0feP2Z51wwVjVjUtUueuwYKwhAkirTaWa1QAuJ2JT4zSoLezSkPYIYsenva/7e/I8AaU90RFRa4wpYWMogrlZHLT7m+Pcd8/ZXrv/h1df84Ie3/eVf/tfVv7z7wx+7/LTTj7IslYZ5zxvfvG7tk9/67B8//+nvHX/CEZ1d7ZMon9iK6mjvclwgi+JoDsJkS78587jAgjevdyBMRkawc5YCABABYSEGwXm96IiBhkNLc97rLo6C/JtOmnHRnO6dI2O7a6MbNm/bsnXrmq3bn1i/vbYlCKT9tg1LX/v12unLes47enj5zLKjArF+8xmEhPYUOMPKTtQZ0TkxFtGDRJSsxfpqyZ0wMVwTenHq7RGRY4veA9VwIG4m0DDCXq7ghpXzO3NdjhZJ4Ploh6XOP4X2zHABtajwD9KTg3b12enj9KweKTgdwcllO6IQhgamNxURraoPYDgGKkBOALVIDhAg1GAiBKtqSgjYWhSL4hk0rk+7I+eXD3l/eAI37YRtwx46utQxUljaMXf50uKSxfnZ892OmeDkOMH7b368Cg2XNCUgCbr1QmU32QEXACYE32aWoQqpFnE8g2UQIXEAASDXVrTWWgZUqJFiA77n3vKZr/Y/8MglX/lg50knjw6N+t2laOfwHZ/9zrY/Xn/Uy0458x2Xz1iwMkrielgFUp52hFmAI7EgbCdN5KT66YiYZpWlSxKFyLZo79NmW86WtEYCgKBQEwfJ0gTKIAOyCFoxzGgQ0AIKo7VlJ8ydc/4pRy5cfeXXB3+3+/uf+cH48NB7P/i2Wq0G+6RTkUwWe3vP8RTp/7y297z7fXffsc6IPuuCxR/4xPsL3XOGayFqUAJNJmiJKeUYF2kZsiiAqclEzULEQgKchgGEmuzHE4nTTWfgZPVUCBlBQE3ECvYcG9baKMEETECqb95R//gPx7zutS/79pVX/c93brz4Jbe9/4Nv/8BHLs9lvUo9/vwnPiRj3ne+ft2vfnHLX77rVVNIFQQ6u9pVRsQCIySJpYExtqATm2svDQPsbECh0QnM1lpmjtn6XOvuQBJb96sdL34jz1xQG+q/dmjwnEW9Mzo7CsXOY3uXumfZkaQxVq6v2vHQXQ8+/uh99bvXZx74ff77dxTPWzn2mjOGT+qqpAsuJV1UzWlnqmwTXQLlgGPBxKh9sGWq3Au5E0QESFpkjgwALFohA5ICuKSn+O0d4wAg3GQ6mbzSji/6KwvPXfj3GYkNHNYH9QStORzQybLnpG3pJk+hS4fyfqsT+6Qz7MdR13qwA7KuowAwiJ7SRxYkKhRzSZJoravV6j73JABQrGXk8QQj1+SFo2aRdCUAsfIJsmiHjXI90lYSTGJ0S/SLdTM+eW1t60CvaYDfR8vOdY9YeUzPkSdAR3vQnmmAUw+TRKxgUA7KvLbfJLEGlEgsiOeO/25torlB1lMCYjBTdHbbziFhh7AJgQZGEUwLGmrl5nKB5dgkiRVSbjajwt3rtm665px/ftuCl14WDpuejs7Nv7/3ps/9p9dmX/nNvz/6jBeaCgW1OgC4qEEArBEkUKSBjLVTrMBWdcIUdy97/ITAJAwINq2NTNDi5hQEpZRlFgHLwmxatbFSfi6LjCAkaDm1JFJRh4QGYluB0ozj3/P5tR1f2/Cje3/6X78II/77j7y9EVUjzgEERAiExKlriQFxoogrNI8BnprzRQD83KTyT7B7iuVc3hsfq7/nrz581z2Pu7770le/5B3v/yvwMmP1SBTptMwEiBUhaHrXlAiIKKVaMywgwMIK0SHF2OyfhdYBLUDABKioBY9tdXvP5kFuVaqfCHCyIqVQGBxAiThOajhz5uLPferfLr3k3i994Qef+/TXb7/1wc994V0rj18GNv+FL/2d5cY9dz/89ne8aq/+ak2Oo8KESazje2OPrM+PN2oFv9RTGsl13/7Q7njIjwNAS8IO2VgXRrv87tkz8v3VWqmjNEqemys9vLV/5MhwWVehDZmNFXH6oDCrrXj0vIsvP/WC0dePrlq16sYH7rzxruDbt+VueKTrr1/85OWXDmfGhUkj1sj6IASIrhLhRJRqqiQi2hZU5Z565+tRFwGVCChEmyooaG2TFxFn+fC6Xve6sXAwFi3iJG2IEVAAGJ1cUi/u6ACYlKS+j1zCwwQrHrp03iuN/FmyA/7s6wEcfG+nUDy0gAlwZgJSIiJElM05IokINurTm3ho6lzZCioGCcCmqcIKQISRjZCPKqMgAGHVMJQvxb9/Mvf+XwyXa3M654+f/8oj/t+LLp61aN5G8h6L/YFqtR5GgqYtQx46mULbg+t2FefwipNX7Ljroa0PlQG4r6D/9qySmDpJAixgCErqC7ejYXEUAaACFGEFqXi15DpUyNXYarFWEFAYo2z37Hdf+VuDTh2Vysgdn/7RI9f/zxlvv+TsV79RkVupi3JihVOyZkla/iUiFGGcnD/SpDZoDkiKu7TMTKjIyfiO4wAQsiRBaOKEEwsADpFCAt8xOmOIhJmCSBKOWRIEy5YBGYURhJCJBMm2XB+jLhzxtnc6vlr3gwd+9d9Xd+fwL9/zZhOSZaXQCGjCveu4Py/s7ftWQUjfcZ3M0O76+/7mYw8+uMnLOK9/22vf9I63VqPIJgaJSJiaNUhSpKxOUTUWEFisGFdr33e1VooAGaIojuNQkdIKtdaeVkopREjPB2ttFETW2il+5NRvBCCMgpJS8olIEw4LFjCtw4OtoZNKvXHC8Sd/53tH/+Y3137uU9+++Lz3fu5fP/Tmt12olf7iFz/z39/83sjwcEdn556+E/i+5/vZerWhLVmlbbVmh0ez2V4/n6POPp2PV5zUG9Vix/MMaQBQTkOy+Y5r1+8YsomKUWNRQ62erNk2dERPgZmIZNJ6A6XUzJkzL7zwwgvOv3jrrtU/+NkNP/zZlk/9clmt6rzrFTslQZJOwHFADaJZuSgClpsLNV29QYPMGLgdDBZRswgAsxAKNa0ZKwKwwil1d7rr4mBDEobBgK9wQcZZmi116yIcVPJOMiwmBcmfMdAQTgr4TyyzAzzM4Z4T+nm3kZ9+EwQ8AP03sgiGW2634ZDTsdjvPmHSn0ypVGBmZu7vHxNwAGIAmKxUQnkEgx3kxCwMBsCigEVAqTKMAzuCBtECWcp78siI+9HfZKoNfexZ3uc/cMUpK04Q17GQbBmqhiPsKzUj41uClBHfoWR0486V5x0zZ+XiwXvu5oQJeV6JUGwUR4hChkVQh7hz1LAFRAG0ICxgBSym93EcyfiBoAtpcXYGJgEKSJSbiUdGf/+xb1i17a1f/9yCFSuHKxVMxCNgVLx/fCS1nDwAzWTiKaMtkpCGfFahwPBYdXP/6OYdY1t3NYbH6mPlsFzjODHC+XyelNI53+/qLC6a2750fra3x2svStaXOGYWFrYCFkAALTYZyywYERFVGZLsojf8ZYS04/s3XvXvPy51z3rdGy4Yb7hiQRHTfmsyPgMNDxIxPugG4/HR5L3v+eijj6wp5PMvv+LSy9/25vFGFIMosE5azTMdSdApvkcBGmMcx8lmc4hQrda3bd28ac2mLU9uGh4aGh0eq49UmFkIPc/LFbKFQqGnp2fRokXz5s1bfGRPR2dBKRVHJo7jVNYrRBHbkoSpqynFF7U8efv0jNAJgsDznde89pVnnnXyJz/21Xe/4x/XPLHpU597t++p9/7NGxr1vQfcz+hMxmOupSefrdaSwVGaN8P6rtvbMTr4kBvWYXyYIEJhZBRBlS0tL+QeD8Ngxw7n6BWMfpLgtv4RgIWEFqkp/Zm5GTZK1yPAgrnHfOKDy884/sb3/ePVX7955vJZyYWnVbgG4HjAyKqCkkUWINucoNRyjROMd0txOQKjADFYhIQI/TYxQRNfhiaGcAbQXK94ummzJRQUwFRN3C8/1d5N9LZ63B+GANDrO3NzXusOz34T2vOMh7I8p7bnhwrimR+EA58B4pjxwWjHrbhYSc8JEx8RQsd3DCQIanf/KEjKBydTuj46DPUhaEMwAFbECgYoIMBKYoEIkIgFEBQq87X72jcNOCtPnfmrL3+qozMfmUQS56ah+oOhqmSNYkqzCkIw4GCtNhpVBjNdJ1cGa+NPDqMAM3dnCCRGMCSohAFI2FQaQqQmFdKdgL4jEIqjEmCUJhYEWaxl18uNbtv8229+4ajTFq585Wck2757pO5qjWSAlO+4cXzw6jECFglTX7UACSEoBzSF5crAA6t33bV6+IE18c7hqFoFAFJO6kJFrZTW1aEKWRQLVtYz3s2uyvZ25WfP7DxpReepy9yedmRH4lgEGYDJMNtmrFgQrJtAvJVo/uvfhQ298Qc3ffmz3+6d2/GiF5w63mBrI1KAJHiYtCfPfiMRJsD3/+0/rHrosWzOeeObL7ng7W/ZXamRoxUoApSUW0GwCdkkq5ksYrFYHB8fX7t27c3X3bLp0U1b1m1pjNQwsVoIPc+KEBEAiRFOq5yjVkoRUXH+zCOOWnD6qUeeee7xCxb1ibH1WhiZ2PM8TWkOHKcHehq9319DYoVkrXCgurvmfv1b/3z2i373ob/50rZNO77+7Y+1dziub0FwMmW64yjP80QEFKGADcN4cCwPLDbx2rpHVidSS6hqtFLApFFHYUimMrfbidA0tu4uxgZZtRXyG/vHg4hdJUrBZMzuBMZXxFomBOdF55z3iVrjIx+57qu3dJ10dNRVDKTBqFwgd8+ubTotDQiCSSDYCRrApIQciKhQqHLHmsq1t2eOWtj52jMQHMtkJUnQgrKQqj7NmOahLDANwKvHG/1B05tejpNyYo9pd5+pVbWXC2jKr5Ol/1Nqf/YuoIl2gDMAdZJddpIqxplF58OeOrFMRJmsBgAiGh0dazQaxsRa66azlBBQyc4NGNVFUAxhWp3OYLrogS0SilBi2MvCQztzN63NuTn84PvenOtqj5J4a4I3V4afbFhQWWA2TeiBAIvSzvCmyMOcW8pUNo5Wd/Rrp5bEVPKcJGYCUSIEFgiMVTUDpIAIGKRVvTvFDSI6xKSEUZCsCLAACjMT4oYH7z7zksuXn3X66OioVEf9jMsJAzCjCsMQcZrENxIQaXKuIABDWhRZhIgFyPfq2we3//HujdffUd+wjYxvXQ9c5bTlFSAAuSwgGghT37NoBEIHQQFasDw6NjY8MnjHam9mqfP05TPOPdtfulS0TeJAbJrpRCkVq4gorRyhuqkveMP/GxuuDfz2js9/5CtLfjynZ25fWItpIsP2T6U1g9CO9t/3nn++5857vWL+5W+57KIr3j5QqZFW1CwMmfr8090rImI1ZfOZ2s7hP/zi+luuuXHH/etDY0Rp0E420259SFASSIBEESgAQlCgwIo1kPJoD28duH3tzpuvvbv4pZ+cfc6xr3ndi088+ShUul5LBEkplXqHUofngagxU8QuWIY6J6Rs9o1/cdnK45e8442ff92rPvi/v/1KLudau+fzzKIddF1XRNJ6D2xMvHMwFtTgYGf3UB0QkDG2QiJsFbACFOprUyrXBVvG2pOGm9fenM5tqwYajdBv02KVtPbvPouTAZQYdeH5F/3sJ+seum/jDY97rz8lCo31HUXsAHIaEk6rAwsLMoAwBoMCDEBMmAhr3zN3rRv+wHc7pFPfN1wtN9r/6iy2kCoiSBYEKa3id6gmJpdj6Q+wpX4LAPYHODuv2h17aHd46u3Qpf/+0ETP/AHwbOOWDjwc058BjCqzILtoHkytEq4APd9BFCIaGa7Wa2FHR8EY07RAPR/XrcONa9TMHJmyRAmJI0xiSJAlFiQESkt5OEByzbr8SNVZenLPqaeu5MQ8WDN/KNsqulnXJAmYJlclIwowo3aG123Ot+eEMrvXb4hGh7VOvER3uI6D0oiJRYgRFVRjGKyksPeWctOKzYpYpRwAEgErkMZULQI6ysSNky98uWUul8tEhEjMTApQSMQSHpKFR9pPGqFF1J4bjFc2f/eaTb++vb5riNwMUofVDGLiJIrRikKL4AorAW1SN7QGygA6rmgG1I7HSsizuZyGBpeveXDolnvzpx7V++rX5hYuDKqDSgO4GoQAbKu8KwNA1XOXvuPyZGRs9x8f/vu/+7dvXvUZrUmsgODzUgFmf0PFSaHYDv/08S/ccstN2Yx/4WvOe9073tpfq6GbgmaBWVBUC63EbEw+n4+j5Jorr/nDd38ztnEAHQV+ThMbZX20M924z3M6yZ8Bbd2YdR3HVeQqEJJI8xAEO011yDS2h2qo5pXrWBuQ3//o4et+89AZLzzyLW976WkvOCaOTBRFCpGZFRIiEu7PR0zNOBkwggNIgEkc41FHHnv9zd/8u7/7+2989bt/+4G3Tv5kCqJznLQoUIoHxnj7riSOwPV0Z9t4hGEUOzpVWYisdUGhhTk58T1NAyM03tBzZ3f44ZowGR6vdrZ32kkex0nPmY6ZCwhInFP+xReecNNtG294JPPKU+o64yWYuKxFpwS4U3onItAYAmtAFAAwG+Xkok391Bj3Fy+uDA/nh+qIOYB6mrcurFCoxQoBciiufFHlJApsAgAgOqPTPJlnXvTvFQPYn5g9gPid9k/PChnc8+g+2s8ZwAAamPZ1zJVKBa211ro8Fu3YPtJe6hAGYQMgGCf06KMwFmNHQcw4GBImYJUa02TTovAIAEQ0VpVbN2aE8KKzVnZ7dO9w7dp6ld1SMaK6UCyGAFEYQbEIKgUWRrftmnn0kSzu2KZd0oggn1WUdPsEIIq1iLAFRRTFGDGoyeglSFIu+InEHGRkBmmCA8GSxCwAdoIy89AbIwMACTEDGAt+Bl1n840PPPbln46t30rFrOpqi6LIRGNFj9vz7goNHeDNRF1AnQHFiIxkkQZsPMDRbomGBIYSGksIIg+sxlwiniVXFbEYX/f4xnv+qXjhmT2vfDlkixyUAQ04OIlPk+O4Qt2dK//qTXf1Dz90++qv/ct3PvhPf1uv1/6UpD8AQKkDfvjd3/34B9doVTrtopWX//U7BqMGKUJGQJv60BAEgAGFAXKlwuMPPf6jf79q293rc15eCn4gFd/hk7Klk7BthepZxG1tknFsHKsIVMLKiheiihQZpUm0Fzt+TLqicYjw3mTojoHyk7vdkbJ/22/XPnjHugsvPfU9H3z1rNk9jWojrUHGzIj7y4pIY5gKUaexLxFOEoiiwPPVN//7C7ffdsfu3btmzOxr7rLUfUWg9R4KRfSdZNewX65gJlMo5KpIQYyepsiCBwqMi1QH8HsLknNrlToGgzvUglIgjvWcLQOjyxd078eqS+u2pgYPkIIXnLpiRvevH90QbhpSR86QOAYARtv0CKZoznQrgFgIAjAxqiJLmHUdDDh/xhHDC7PJlhHnWC/3hhVGzBTswBQRQZP+3U9DC5AiTdLPphi05yRzWOhwuWz3PQMOUhHsT7A1AX9prSpugvymDMv0Z4ABnDDrUvlCAJDPeo4SBaoR4cbNAzP65jha53IMAFgep82bUTq4PKjzWoFYViKADAhKWsX3AIAUrN7mbR5VflbOPeXYJ0VuqkE5yvbEHJgkQM9DYkyafkUEa21Sa9SGRrPd7VG1Xt6ygwCFtYdRTwbjQFxSyCyEqChOcDwCcFKGncnFxAEAKMV5p/iG1vgo3os185B461MLViFYAQBSSOx50fjYg1/86dbf3wlK686iRYmiaGEuOLnHOUPnl8S5Hs6myc9M1pMEwSJaACCVQ2xDVGXhnV78OFXvl9HHpfFkPacbnuu1RdxQnb6b1Ks/+FV498Mz339F7pijTGU3aieFRSKiBQRSUa2cX7p4yV++Zs2/fPMXP7hx+YoVl152Vj0ImQ+jgtgzvw6npkzec8fqz33mS4TuwiUd7/qHD1cdjGObtSgahUmEOC3LCc0IznVf+/mvv/jDxJBXLI7YSknbVxQ7LnK6eqXU09CKuZYZHc7XHSfyPetr6xKRRlSAzbw6C1YckbbQnRv7R2d7Ll88e/WRwU8Hd922pRGPZH78oxvvuuvxD3709RdfegYnJsW+CYqAHEA4CbSS0RAn4sZJrM4+61xrLe8pOi8CQERElDoMCUGUNpUq1+qWwG0vjGu3HlB7jhQLGiOSiNLMUXfRdGZkrOY1tgxmjj+6yomf9bcPjLUwVPupvNik81MsMH/BzONW9tx9XfDgk97SbkVpilZ6tjUpCHHCKScmADZASMKWBdn4C3rnfuSV5T/eNeMlF/DiJWFQ15Mh5nuLjoM6gmhuTveH4e6AQSgwBMALC/Ic+H+mn0FsZuYcoh1wqBXB4NAOhmmIHJ6hSN1UhN8ePz4ATFPPHff9LdVxmip7ehObcHtHNpPJmBBQ6wdWrTW2Y2ZP5pQzZqJYtW1Ij2a0cdj0gS/WGRNMSckJWVLlv4lU0LxqZ7ZR1/OPn1NcvviW4WCAbQdRTTEjIsdWEBDIopAIgJfNjqzfyUDOot7qjt1jG7a5btaytHnkA6EBIQ02MYaUwpEAIxGaZAK0bEAS4CZsHMiCBWkl5Qo31bhWpihMXciMgJNCqK2xRUIUNJ7KB0ksBb+yZudNH/9CZe1Avq1YT6wx8UK38eoSnS0z+4IuQIwBxnMjSjOSKBLrBk2oEgBZokST0RmrjrDqSJt7tbSR6Gv8bb93d6yulXcnnZQ4GQ/9tqLaPLb9I//a/abXdLzqQk5qYGNBbsa3UABgvDw646xTRp5YP/6jP3z9P7539IlHzOpti6amLDwzy2z/mfCtX/ewTjACCWulRoZqH/3gZ6Mw6eztePc/fTzJemGSiKBtFoJRabWpWDiTydSHx676+88/cNt9fV5b7HKoBl7Zln89LTq6MTMeh9gL64WqWwy6S3E2G2tCERKl2UEGK5KKFQGgLAgBWuCY63E0huPx0VA6veeIVTPsdzY/cd/WtvHh8B/e/W+rVz3+dx95i+9xGIvjZJMkmq7fkvIctKKvE14dQkARieJUL5Ym0rQlJX3fb42J1aSk0ogGRrylC8FXCTu1egx+TEzIhoFYHAZ2MS4VtRkMo127k6rVeYJcZv22fkQlaFuMGGkFLp4MrEQhECvKEnkrVy7+7XVbHtmqLj+zgNEYKCWQWsSAQCAAqJoVZISNScgFNgjAjHESiXPciV3HnWiBIQ48NUEvl5oadqJ3U1lm99cMAJ3SWVw93ugP45Ijvb47N5dJ8YTTLrDD8pDTJPlp9/IsIU9ZoPvUvj3AGQAtMaL3evegu+KpXfD0296JoKk/Bw8dDjgJrtv6SJIkbW2ZbMYbqSZZ7W9b1whHNpx15sIMZWKpNGhXMr+MbU62Zt3QSOJpJ0xrY4BMrhtGkeM9MZiPI1lyzDz0oH8gUYAhglgQQAKRtCaIQArhQK1Gd/T7nSXHdcd3DNiy9dCLIS65mCUSC9YwMxqDjsLxABt7JjqNV02o9sSQVmPcKxy0hxI5pXCYdh3vNXYoACLGJ66yLmD/bWtu++h/hJVasdRVMQl5Y6/KwRXUOzfqqTpx1a07PmVySd6PtGuVtoQMwK0RFgC2zGKZrTZxFEdsQ8EYX5r0vQwW3tk98HPZfktNlRtdJeVgyUpkBr75/WR4pOutrwGbgCZgRhItqNE1EgeOXva6lz/2+Jbt9zz+5X//3r984W+Ipq54mTS1h9wme5JwMh2QTNEi9i0o1gqVowbvnz76ya2bd3hF763v+8uZRy8ZqFfFkINkmroyp/EKz83ueGzDle/757Gtu/s6Z47HSZcTfaDQd0E0V4wzkhm1pbhUDDryoe9ZEBLGmFBcbFFmCFgF0AR+NG0+Ro9V1skqVzfCaHTbY0v8jq8sOuV7S8Lv3fJ4GPrf+8q1Ozft/o8vvT9byoZ11Hp/aGlpkTzBpL7y1FHZQwVILRqolLmimeYtYvvHCUSyTkLu2LiBtqwkKJwIWiERy47HnQXHQhIPDZpqANk8FgpbNm2IIyEnjVGljrIpqiS2fhZG1LBk2RzfU9t3OZUathGBIChsemNSIF8aDEZPGcMmJGFJU9GnKJL7XyyHobam4RNzTLs+RvzmoOGBIHbPVpR0r1yEfeBD+z4GpAfAgcX34Qn3Zy4DYt82+QwgAQDiVOg8JUg4IlprC0U/k3HZRIBJHOS2b6nSixuMCUXoLzzOX3YCWrK2ap+4PvPk75quPQEAmQxEqdT9jcNa+3jMiYt2J7YSsXYhsJawmfCfIiyQEARYRAFW+ocy3e3ac2s7hiWKxM8AS17rDBMkYoRECKzCRFVCiBi9SV0UsYxAqADICnCzEsu+rcV7KoJADEyHkDfHEUCvO3Dr2pv//tMmAq+tkITVHn/wY20zz8EZdeuNdpT9fNJWCrQXZBJtFJLi1r7ClholIqLAAlnRoach47PJozVQr/cnVf/0pHCGPuaXhZ1XqaHHKx0+IylHHD3w3Z+aoN77nrdaDgCtZYMomijROirXdKFj/lteXd/ef/tvbv/ti49/zWtfMjZWaSqtz0dEII7j3p6OL/3Ld2+/eVUm473o0vNOe+m5u4N6YlEDNg97BiKIw6jQXdp677ovv/cT0WilUCwOx7Xzc4W/oUWLGsV+Vcf2SncxzJfGtSYRtKCsRtEIJCiJ2KYPRJAF2YIBEvAAHCJSliG0hk2QxDqfK5mk3thy6xWdx5x87or3PfBofVPhxl8/+JeNT3/zO5/LZyF55uDpNOGBnJASlmWwrBmSnCuZ3K7RnbyIEraAgggglkEc5J4sIDnxWB3LdZiRd9vah2rR+Gi1Y0buoFlXAigCy+bP7e3KDIzxSKVR7PDYWEKDYBARRDUPLVEgjk0MJ5Eiaabv7KcjAE3X3CE5bvZIuVTm6lY6mGmKowNA0lvDdYhnAD/tmxyEDvrPRfpPNJkQ+kLNjK0pw3WohwEiMhvf9zxfWTFWBYnavOKk3uPPaE9sLJywq4TQj4wutsOKy5LGkLP9ttYzCAJYSilG7O5dye5xU2jLz1/cuzlIYmGPCRGNWLVXsmha3TuKKwPDbcccISLlrTsUJEgOMOSU8kSDIUBgIGBQQvUYWTUJYWTCuZm6eICsYWYWhIOae4hNv9n+zgARBlFOqaN8z5qbP/ivccOoQrYaJUcXg3/q7Dsh6BvM1ahU6colrhcDs4gY16R5RbJnqbS0U2k+aGu4yBMAEEdT7Nnxeg0azuVmwSlu9O9dj1494uZgJjK7PT2jv7mBfLfnnf+PozqwssoKWSUOJiaO6rkTVvScf9aOK//321/+4amnrii1F4Sfi1W376gKSEex4/471nzjK98HdHqXzHz1u968O6qGaRAdwablIBDZcKaU739k29f/+p9q9YZTzI6KfW++8OZovm64GzIDfT1hoR18L7EWE0RJK82lmUumWYTRihEnwQ6iGaI7cpDRmNeUcdDLCDmGxbB1R+vRxmq8VdRY566da44sL7jyjFM+UXj4gSeju+5e+9d/9clvfeeTe2ZbBPGpxyqbFZj3ImhhwVoAaNAlyWRHK2Ilk1hL2hIkLbVA2hxBck0QUb1uhf1ivt/K4PBY58w8t/D8e6fjTPoKsbJoQV93V/umh+PdZXdxN5oYMNXwIbVHtAiBOCAOGwSTHHiJTNYsZfq6IJN7PjVC0JT1LdeCaEBuRYMPtoQm7VkBUAKIaKYa81N/ecrTtd92oKf8E4wGiwgKATUsskUCIBobAkOT0f2tS6fr2iR4b7octUN+xgmjxkWXzv3PL13+4Q+9vqu9m41lJaBICMNMIWK2mU7sPRatar4MiIiDLpoO7eqHRzvK9XrP3E5nRmfdWEQ0DDwpFNPkUkCwIEKY1BpBtZaf1ROXG7Wdw47SqDSAypNyLXJCaBRZAqspccOYUJHClmk8tVkrcXIgrWVikaXlXKD1JNNONxLXN1Vu+MQXuVF2ssVyLMfl4Uu9i47XPSNzR/Kzqx3dDcdLk6WRFKQF7QHSDcCpfspg0x+AUDDdlQiITMhEbgbyeezqiP32cCgz0ufEn9Enf6I3E5kBzQyivbbu4e9fM/KL33DWJdHIaIQBOVU2oyRe8upL2o4/Yuva7d/51s9KxVySJM897FjEOqRqFfjsP3/VsKPb8fL3vUPNbA+siEFIy6K1iNqQdG2k/l8f/vTu8YrWWhL79/6sN9WXJSjj+eqcWY2OGY1MJrCSWC0WwSKAsoAGMGFmiQGzNrPc5s7k3Kk2s5icuUV3dkF35MnPkvKUl3FzbZm2Gdmjj2m/7IyeNx9VfGmpuCxTCZ6ccf/qT6847tQVs3Je9vabHvnYx7/iZtHYiJvZYSlymA/Y02kaTPIFTbqWUFEwMArGEGqVbx+tGMfGbU7iIAOhC5ADx2KYyQQgGIdJNDTEbJiE8/nB0XJLJjZrqE23RlnQMCTa0/Pn9NQTs3nQhSZJIoJoEA3ipqIfxAFxwSLYJiH5dI1FhIEQlKOpFkaCB8b87BtuTMPresIXlA7FoayiSTz81Dw8WCE6sc4xFQjbATqeESF8GHTQT/3uz4n6D00x6lvMoOjs43+ANdeYl3wcCp2tyLAA2JRo5WDTwEiiNZXasnEcH3XEkcuWLC2PV0hAoAkvUUxICSu2sfEq8Z7DAz1msHVwIQTtPLElNgLFGR3suVFgHCIjUwDJVgSbGbWgtQ7HxqJaIze7p7p7sL57RKFGVgAmT4iJi4nHSgBBDAKoakhCiCRWhCZlpqel0g3bJEn2ZwHsUf8nzKSpxmnTf0Ip2zACwF2f/+JY/45MsbMeyam++dIRfXOYxtVYWylEYqXEcRMRbY2IAKW34lTNnziHJkMAVDrQE19oQcALwaWCJwlKvSIQ97/bLJrZPfrxgZEw06FjhK7S7it/6cztVaed7NUZTUwkoJW1Ao0G9M2c8+qLxrbuuvbnf7jokhced+yR45Wy57iQOgYPd79MZbg84J/2BIGtlfaOzBc+85NVq9aJT694wyXLX3jyjtExh1xNJNg0gJjAGJtzM1d9+NPD67b1tLc3otp722a8RXWPJYY82zWjlsnHAMA2pYQWVhYA05qaKnLJM7QwovmxZGNRAqgFieIKgQ/kAqI4DJaaYYZGyKSglC2cdmR+aXXXLeuCGwa773/808cd/8HyQ49sUT/5n98uXzL7He9++dhYVTueNXsQ5U9N0Bgz1aOklRkZN42Gk2lTpcJND7n6NuxWjpdDZb18BnKcsMdrNxrtIzPEo+XEsitiMv7OkXFgC9Sq07I/EkkAw1aBXrBgRiOONg4oUB4pS+ACGAQF4IDo1nngCLh4QMZyRNQImrAemUe2jp22vOcw1YkJ58+h545N+XaRNMtPCajIKBuTXXML7F5jTZnbu91jzpXOWRjWRE3lsmx9fM8KPeBzH3Yi2J+g+j/RTw3ZKA78e7+b23BbvURYf1KKBRDdLNUL0NRJD3YmsQWtdXdPydokCII9fW+JAgEjVhxxJao0tt+ZnwQXMAC62ICk+5q7cvdtCoF095JZlnxOaihplu6U5dAMTAGAVrX+Ua+Ud/PZgZ3ruBG6bppNIwWH0IIYBwBBhJkBKQqRaJqOpJoYM0f7d+tOzhnZs8+bZ8AeEBMBAoKT8e/7zi8Gbr27MKPNROo4jz6zLLcgbweTXe3dxknIWhRBZtVUGSeCTmhT1BGlnPNpBStEJZD6Z7BF6iKAgGKtsBiTccgF3zVROTuUlF9uS9yrPjZaDijHgA7D6Nd+NmPRAmlvh1jEMmpAxESpcrncdfYLeu94cMvvb77qWz9f8aWPpulITz8xYB8IkEz7JwAoFDKPPrzxJz/+NWk999gFF//Fa/rDGmmHgFIWz9a4Qy5f/O3XfvToHQ+2FdvHkujyjhlXUO94EIo2uc56oS1ihWwI0ODkJChGBAWlWB0TqYWRRABMLXdaAlwXE6PjCWlAEQSLDoEmoxUw24aoGmaysy49frC0vn712s7H7WePO/av6nestW1f+eLPTzx5+THHLq7XIt/zjLXwNDb73geAp7kR2rGG09mm27MbaqUN94lnwBAoZAcMcnDsEc6mAUeUpiRplBvZKAHPGl9vHxwFUpjyZAGQ4LSRLQFIhD2A+fM7EWXbMEKSJ0oQNIAGARCnicoXB0QT+oDKNFl899tNInp489ADm4bPPLovSZ4C9f9TxzqmwUhlrfVyVN5JN3wlu2uDTtEdwPWta/nVH2Yvg2KfjdSXPzU2lUMYLwGTjHh3/pvqvyU4ZoU95x9k9qmTjl8GMC2AULM1aYr3uRUzE1FnVxEAZs+ebVq+lJT7BlApJNS+ZVc9fGOhfy2LAtEICoR0wdm4fcU7vl/61iO6rLsdT5e6OwPGKDHMvG8GlgAJgwURpau7R91CQfluY3zMNhIBSnMOS74GVsgKDBIraxQkTmgQ1UT5EwYUSNWk9LaWbcJywA28f5t94gJAxOENWx/8n1/rQo9FmoP2PQvomNntIYfZYgBimYQIiAARkASpiQjElOUgZZ1RQgQTJBMpNil1ZwuKoBWIBWKkUCmrrUWKva4w01VRTGUVnq8LHy0WMk6oCbP5Eu4Yr/3wBqrXRWk0KJZFkBVaa8uULHzFhW2z++696cG7736kmC+ko/0caC1sBQCsla996ZdDgw2/kH39m98guXxiWJOe8JA0RwBp/e2rbvjOTzPFUs3yce3672Fe0NDohaW+sUwxtEwiSMoCsmVGFi2ILCAWANRJAc2KpUZ7YLzIABbTiqC8J4NJScp5aJgsqQRAOKqZan/ni2e3veH4yK11PbHmoytWdhVhdGT885/6PqF4LkVh3IIRP9XR4CbSrJU6izYxph6AIGU8S9rP+yqXJd+nXLYcy4ol+X/92yXSSbFF4DAJGhAlJjK6WNg2Og6CE3VX+GAzOX9Be7HoDpSh0XBTZb8p+mUieyulH1eIqumO2wcuISJWxDAj4l3rB3eXGxMDckhpwM9QI6LQKdh6QDd/J7N7q+vlbN6zBUdlXBwfxvUPgOsiH0T8P7WaYjTtXZ7KRhKa/nWYDQ+hOZh15pwCL/6n+NSPQttC5JQLN63qZlPZBK1XysGCLAZUw3WqLlUfXB9cfbdjEIXY2BXHl044q3zycZ0Bg4KUnjjlplE2Non1zI5H7aM/aZDLFo1hETRe6bu/n/e27+9efMGR7/nwa8tJBbRkezsbkfD0MUlMOXYASBxnaPeQ317SCGbbANq4mXwL4giCQTGIRkHs54M8RLlhmwimeZep9OcmAgosI7CxSSPab1XT5ndP/RWaYLuUQMIK1MUU3Mx93/2FVGJxTTHU57dlX7y8UFM7qb2S8TUJpcB8UYwo6dASISgBJailGe5MbW1CVADKWmJWwgiW0hcDCZAguURgNAOhVaLbbXZORZFlsK+BwtscTyiJLEPBLf/xd8nWHT4qZmYGEVFMACBRkjlySd8FZ5l643++/b/1ekBEBMj7UFykGKxD5XScOmIklL4UqJZAIREplXJ33ProHbc+4JCcdO7pi04/sRYZZXFii4qItTaO44L1fnPVT6URAVE+l7xfz8sIWifMlCDTESonBjTIFoEFGUkALWorKjYS4jEV6UpAW+UmRKAUKi1EQMqwqgPVAUOABrIBG6O1xBZtQhKDjZEtkdEKVaXSfrRuv2hWWNl1zkj5iuWLMvnM3bff//vf3JbLZJQmQiFE2g9QeNIYTjnY0sYW0pGH9KQHQkY2IQYG0RFXSEyUJI24TMrGkekuND5xRdTTM9juJSgEBDZoIACz8XKZwdFxnDR9IsL7vAAAUWlQCDBnzqxcPjNW9sZDhUjCWtgR1ul0C0PrmfNBI7GBA8prPjYCI1gQC8IIgKw0rt6x44nNux5dN/SpnzwYaQBloYm5glYc6+AehafTNIi3c73qX2N9YGRlgGJjk5w1NTM+QkTIz0pm2Z+fBQAAQiiLzoKOeZBMKuO1nxkSoFi8IN8ZW5dXbfP//Tr11Rto0yAXfERVr9dXrlz5la98BbpmY70uqKDprlFgWHl5LO/Wd3wfTaxAS0yOdsvc+64rK9/eOvDZb13+oY+8u+AVo1rDz/vZ7vY4jADAoGUQC2JFbJOlRwQgQRSEOIiT8brf1WHjJCrXWuVyBRE9cMUoThxOVKoJsZGYJwfpJvpIqQ8e2MTV0ApakcmvvUJ2zaFoGQF7p4MXspsffKz/Dw9r5VuwR5Jz/kpX9xp0m+SPrERIrEosxVYZcWJwE3FiUAmoBClBskgW2IrdY34xMigGx4JjUTEqEBJBBAVMCA6yYmBmJdjB0BHHcSgK315oPxO8Whyzb8s1HL36d4iIyknTWFPvsAgMcdh3ybldi2Y/cvea6353azGfExFDbJ/NgDADCGEUmCu/9Yu4Huc6M2e/7oJxFwIWK2QYDIMVRsTYJO3tHffffO+G+x9vb28PTHRZe98ZkVc3FSdvcp2tujrAgAmLtPQlAcXoMOaY5hulUywRQZOgmBFFCInSw9aKGDAJJQaTRIwBa8AaYAvWQGInXtlTs+q47qHNG19fKh7TOztm+d53ftOoJ57nMO9VXXLPD3vRT05eRZYTVFSpN6LQKqUmVD0R4SSxlRCVB76rgroLlFElU8tHcfDZK/yFc32ymZ6idoGVdqRei+PAQKxdv9aIg3qsCKBpEE+7lwEACNBaKbXlu2bkRgYbQzWHnHYRJayFtTAJg4gC0RaRVNVf/TPa/IiBIu9zz3Qv+I6/cXt9+67IcXO33FN+6IkRx6FJGaPPRUNE64TGxiyJgAWrBKxIYrnB5EDKDPNMN8Gn3cM/2VDBpMZxouSedeob16ov/ko/uUML6qPmgiIiShKrte7r64N6JQ2zQFNHtmgNADirb9C7n1RuQVmGrGys9r3+v0fHFrT99up/P/OFFwG6W6v1qFov9LRnSoUksZymCTS9HygIjGlgujlQSRQHYxWvvWitjUfH082cbjZXNMQkCaFRaAgsGaZ4H4k2OZ4jlpNGvFdKFLRwORNtChZon+ZH9omf3RqUxfqmj/TZc50VS7GmA5URdCTlABZlQTMoZmUMsgUjxKkFkL6EGJRFzagBXUsF43RFurPhdAWqo46FCDRLWgtRCTiIKKgYHEBrAW2uO8ZCFLDJsHqnV+xBU7ZJRy5bu++h+uNryXenWjnCcRLP7Gg/5wxOar/52S0jI2Vy0goKz/ABsNcKLxYLf7j+7kfuX8ecnHLJ2d1HLqnXAwYN6BhAQWAgw1a5jg3tH/73145InWhhwf8LmRNGwhmb64ydTAhAQAzEQihKmiasAkARI2pxonIAlkFxS7ORJhNI+gIGscAsEAvHwDHaGNgAG7AxSAScTLwQwtnndIZ+Obdj5IqOhYWezrseWn/7HY95njNhsJJM/5q2pYNsDcdxkpaa2fO3hG21AUjk+/W8G8ZRiIMdR23+zFvwJSe3MfvgBTPaMigshDasGWMNG+X55XrYaARN5ur9ANWaISsia6121Zy+XDkc31XVBoyIFUmRpkrYE+uzyYLJEyBB4j3yU9y2zpIW5ImeTbwSa+fM7LJxzoTtYRKMjscKvYmEu+emxU4d2mYor41CNMSxjlkyKJQkmcyiYxUm6D0z/NITNk3au+fVAkCe5vWMNBIAYCNsbWNrxfnaT/TXf+asXu8X8wGCKTjq1KXIlqiZyWLiEKcKDmEDrg871qjV12unQGxJuRurS/7iO8Pe8Ud/76r/au+dHYRoCCqDw3EUZTvbHM+V2MQollo4fREWsWnVWwQDwoRxI4gqNa+nPak1wvEqqj1T4AKxQTbECRorMbO13LB7L8NmdUBuxnWTIAQAaTrmacJZ0QQp78f7P9k+CDf377j9CcyQY+wxrrdyJWEhMhihtqQsorBi0SJaJFXeKaX/FIbmK1VO0RXKiCoIlYAKAXkJujG6MfiRykeUjyhTF5Kmx1oDKBKyohnBJI4p9DG7cVXkNM871/NVaKIcAED5+luApoQERayD0EiS7vPPyc7vWnXv4zfffJ/ju8Cs6Vlc0gQQ1oOf/Oj6KOTS7M5TX31eHRkt8kQFExEGSYQzfm79qsc3PPJYNudGSfjSbFdf3UaOzpd0thAZqIMSgCa+CxUCiWhIa1WJa9UcFm1FrMIWAxQCIEoLdCtgRAxyDDYQjoQjMHH6EpuASaT1YhNCPVEzTOGo9truXRfm8yf7nWEsv/3JjUliDysGsGcJCRFBvR5EYZL63prvI4MFrtURkXyfovHF88e/967sD05f+Io5s8APxBsH32nLe2wSBIdjCxIzG/ScwMS1WpO37lAEr6udvlk9ZcAnR/MovpiC2KLYrLBmFjZWJBEbOA2DNiIeUxvvBjuNDEWA2ERLFzqnn4yJevLI5Y1TVvRGkQLg5zK7MJNo6V4YnvmCAEPd8DJ1gtCtOP3u8SeonnkQO89I9Yt9j7Tn6QB4lh1qwIiIohBBud/8nTw+QE6b8jVIwhX2XnOGmpuTJFaIRADAdp+0EwQFcUiP3o5xgOg4trEpyL33u2O0sPe7//XefKbNWHY9QuAd2wfiOG6fNTOTyaRygG0Krm66hJGtIFiRFHwd1wOx7BVyYblmgmiy8u4LoUG2xIxihS1YJrv/VYgCJBA1glQLmxBAPBW9PXH9ZBcQpcWhLHtthc1/fCgYLSvNy4rZZX3ZmXMYdJgBq40AMLixaCOaQbNoQM2gCBSDAlaSgheBBF1GnWAuBr8Bup6GZFL7RqMGx1IxdLoD8AyEhpqsdgYRQbMlRhLMRU53pCCyCi/N5DsMhBADqtrDq5P+QTVJLChQVsSGYdLX03XO2WLqv/jpHyvVUGtCeQbW1b5ekbRls+7ttzx4/z2rHUed/qrzi4vnVcsVIk0t9kcRsSAGRWt9zx9uUzE0QDqzeKHqJo5Nh80XEsLIpBnl6dClYl0BKkElbITaAPNMBkjtybEANAyJiE3zLVJnIINBiZFD4UgkFA6BQ7Sp4h83X5aNMFOYO7JEbmzM4MUzZ5dcddf9q3btHHIctb++w9S44mSPEAIQQr0Rx1HLizBpO3M9ACBy/STKXrBwxhlzc7ncNv+Y7YwMoiEMunuAxQiSSUSsFRHSKkIYq1bg0AjHRARRurs7OKn111w4+o3B3LZG1sSxkbIrQR6MAkawjgWFRoBz2YFH3K2PInit21AarRIgZlaJ+w+vOf1r73zBP/7Fxd3ZjIX6c19uSIX17NLLnAvfEhxRrByRDY/v1OddkX/RewWNQBng6VIfTmvQPB8FYZ6j8DoBiYxWgdHNZA0ECbhmfMR75bHueSu4DIBkcXr4M5IG7eHGVbjhATS5REXjkv3Q7+JdOfrdf7+3rb09jmNABaisRDt2DjuOk2kvsrEWrUl59wEA0urdJNT8DkFARcF4RfmuW8iNDwxBEMOkA0ADAqMIICODAgBBmUp2OnXoCBExLteAea+iuCnmlFs+vgmg916IbyQyQbLtntWhMrkETlxamN+nO3IBc0xKiwBSKsgBQIAFKc2REABs1SQARBBgcBgdQYeRBECEmoHU9F9sDgg4ncY6yHUEEBQXlBWGtMa8i9Z0GB6NKwmdkPeOrDq3BCF5OhkdrT/0SOnSC7FRadVBQhBEGwdxNOO883bfeMcDd626+5aHL3752ZXxcaJny3QXC7/51U1BYPsWzzzpFS+uJ0axjtAqYEoz7RBIICEqD1c2P7A662RGOT63o/vIyB93BzoKCLkwJtFCogymwlMzEgDZlOBaLEjJgsNgEYFSv3cKE9jDgL0nr4IBE0BszrYoYUQAEdWKexMAKEAxkJ2na11UKw+cXepd5OceHR18+KEn58ydmSSHRn8wGXIOAEBj5UoQxagmyRAhAOIwEUb0PPCjKDsES9rb+opMdcI0kqna8w1FgoIoINYwiEWwCsfGawCEYA4MHmnpMdg9I49gd5YDs+DFbtfx0hjAgdt5y70wMIx+l7AgZLmVoMLMuPEhWbgSxO7TL8UMCM78mT0g3vMi/ZkNIAgqWnw+LT5/4n2DAXABLUlKRPxMt+fcAnguwVUA1FnAtpypNkRhMl5TF5zgX3auxABogerTIx8IRWmIQ3ribgzqGo3rd33xtvyqtdHHP3j+/AULrGGtdWo7R1EyNDju+X5xRpcxZnKm8Z5oJIsVEQQGQcRkvOYWc9p1kvFaEk6xABxpwqCFkVjSMqr7PqBMCuQS6Wi8aq2FZnb/pMtw7x/2mQpRvlt9cvvYtn5gnS+ZWce6bje7HrCQFUYlpKSpmaYxALKoGDSTMqhTp78Fl1ELZW1L+k8OQKRmUIodEoUCWaMWMc1K1RkWS0iEqJAsALi+dbuskQRIzmnLuLb56cba9cLNYmEAYIUtCBFhI8TZvTNefKaJGr/80e8rQaK1BjhIUsxTa5mMd/+9j99/5yOOSye+9Kz2Wb1BNdBOhgSY2bC1wqkF4GdyW9Zvqu0YVspxsnBufgYGQTbLqtRADIQQEdIKj0KCCoBYSNIIsPgWPAvIQBaAm9eQTAzspAApAxoBy5KAGJREIAGxwgmwQbEoFiVBSUSsWFZO6OcNNxpzGOcXOk3A99z9OD8NIo16PTLGNA+GSRKTowQASDmMrtIaHK2dEICZLIIFsD3tnCWrxLpswRgAssQRwsjYeLOY+6Hl8/X0tqt8147dlbjWgIyL3UfSkivw9A/zkaeapMqxw6YB1ohgk5BreBdUxxCc/ck9EWFsPC+lRlNs0t4vIAM5RiAMCJ6u5Jy2esCfGQoIUQEpIFe0RzqLypMDJgChIufsI+oQxw30Lz42/7pzOCGQBDBG9KZFTyIiJCEMbobND0OuRBnnmif1D1dVjj+77VWvfk1aubYJfwaJI1OvB67rFkrFVAqnpbgn/BCpUJ4QwahUODTmFnKu70XD49KIJscAdMoV13TloEh6nylzNFm0IaIQBuN1SPbs44NGrtI7MIKIKM+tbd5dLRu0asEcKswIKybGjEKtXGRSRrRBbdCx5AgqJsWoGRWDFtAWtaAWUAy+BTd16xlAK4qR0voLKCRCyGgYWbQVz2I7q3mApbQLAgkSChHEioSUagd0TWzM0qzTk0U2olwn3t5vh8YAmxXV0+2BShFA1Kj3nnd+aenMB+5+5L571vjZLDw7B4CIXP+7e8dG6x0z2o+/5MxqFLroJGwJkRG4BYUUIBedjavXJ/XIIsxSzgmBH2HD69KOCmJlFQuCYWRQQmnpMwWkUpMSmy41YCRuksygEWRBm+IbAaRFPpN+LZMwgAExKFbEAguIFdsEBaExlCQEoY0it0ijrnECc7LjutpZs367YduigN4bAjStcSxNUYoMMDpWacYA9rrGMjCAosSK1cQkIlYJNMuhiW3PiausEqPFSGKABUgZkLFyBQAE0x4dqKUZPG25QsHLNMq2VhMAEBMYijkzh075MJ3yOvSMRFkAspDuJwA2OLT1QFOclhKZ7v1nu8m0r9ZEP1Oumn3n9GkdAIdYIeCw2kGGSSyBBI+M7vj0tUPXb2uxWU2DXwAWFAAWOXVJ5pVHOxcvUK85o1WTxQIhAIk0WWumvEQUAG18VMWJBhkMcz+6H0KTvOYNL3UcbZtLkxBAATYaYRiGOuM5npcGACyzbRWLmVDJm54ZFlQUDZedXMZxIOwfwWQKo30z/IUpP4lYEJhK1DKR/TUBOddIca2RBBEiTtgck3V/nm6Km8TJKGh595rNcdQARSsWZx2gaiVC4lYekwAxOEBKFCIRik6B/xY0g2ZwLGgBLeAwoohmVsBKWAkra5GZBDUDiSCIYnFFZ4FiS07oLA2UK6SAAIkISQARwGov9H1mpqXKa4s8ASDSZlt/ODKWAkABQAGSAIMQgWXDnaXZ578kSOrX/vBatgpap+gUr8V0HC/N9LEJZM2kVU2CzSJuaRxEO8NDAzf+8Vbl0NIXHDtjzqwgCASBYaJMCgEAgwiCie3I+u3Wcy0kfZlcu/LJQ/QNkAhSqhAgIpCAskhCilERqHQADTNDOgVkRRlRDBMpFM09Is0omhCwIDBwIhCDGLQG2DTTAtgiG7AJWEYTq2HrewgkIeByv5DPZncPjI4Mj1PqvTocUZBGAUZHasbwdAeAoRZis0liKEIpEzMLWOtpcTQ2IRKJSVPaiahRC2JrrLWWQJAF7D6Q5UlJXgIzZnYVs+5YxdbjqiK3pYFZkwR22cvCla+p4m6wGgDEClhgY2mPw4r3faGwRYgVKdQOuArdQysJ8Ew0kX1fE80K8VS6lwlBt5f8mgzy2QvwI2nN8L22wHPRt2e0IeKur10df/++sa9ezzsPlrTNAgDeped6l57bTBAHbsGWp8zrJKCkNUmdNj+uxdGibt/k3LOrMn9JzzkvPtOmw0eI6QEDENSCSrWms64ueFamgNAnIy/3JNHEJhqrZDtKHEo0PK5gypmX7oTmxQIkoBhkb4ZantI7RUkQJrXGXn+bSiJIss9Ep2KLDDfGqgBAiufO8kfLyY4hhiwlDlpMQSko1Mz4RRIhYWVTES8aWAlrI04imhmtEIuyaWxTkEHZSScygiP4/3H33mGWZVd96G+tvfc554bK1d3VYXp6pqenJ2iCRmGUAwJEkpGQBc8mfQaEbQzPAeMPnJ55xphsDDa2wchYNgYkFMgoj6SRkDQ5p07TuSuHG07Ye633xz73VlV3dU/3aKRBb3/n6+921a17z9lnn73Sb/1+GcMO7HWqvLvihChVMkrM1hAbkJNGopbQJr46McrMzAgSOmvKJm7TRpCqrRTGGKqqAn77N3z92FXbvvTxLz700DPNZvvCha6qW9qAy0F6hBDSzHz8I1+am102zeYrv/5VhQGMjX1ngetijIAjhUPRLxZOz7KzHv6qtDkdLLcgzVzqVL1IfFQjVo00xknxQ8gwknodxqAqvn8D1+FQcaEGU6gGqFLwFApCTloieIQAqRA8VCEepchqoESdpSrouGXn7NJaZ2GpG5OZciWw98iSMTu3uKXHVhb92kcha4g4EElszQqsJF4zUznrg1KlQFWHLCZJ55ZXLRKrVEoIl5GbSptpq532ympluWuMq70tY4ktfGEOvsXd+jekskZAylwJqcK6S7jzRtEMNBbM0aL8nbkzH1xZrmvF+oIJW13RoA1CCFf2h+dhhjHwOS5Y8F9jBiB6QNn20RCcE6jpXHoWnt8I86fdwhzD5GX6l0ewki+95jX7pyYnAsKgwbj+6G631+v1smbDZqkErXQT8RniY4xaXYgUofJVt5+Oj6D0fqlD1mxMQw3AhOtpIFWtzqOUqPND6+GX7/TLTm/YHHDeYtFB+/uwPjAAcwgA8SFf7QDijN+53SytFgsdaEY6QmosnMJRTPrDilphC7JKFoMeYLARY5VYYrckGZCpm4HZUqxkA4oM3DBwNeIlgj1oZ6WpwsYKJ8hIZJtwCQBkAXssAyBjpSr90go253ZSoZKUDLx4TE/sNZVlhAAAgABJREFUfMubVlYXPvJHn2Q4azlq8Jw3dQPqrvrJuChH5AWrLu+Xf/En93iPaw/sOnDL/k4/j1UN2fxwCkGZ+t3u2tJKhKtPpU0rQqOSIJdYUDeI4Kjhgo4BI0VLYIKuqXhVW4vOxORQXTKhWO0f2gBdLzspa6SQCAIpoDlCiSAIXlmwVKFfcYJGAu/DtHWjSbrayZcWV40ZrJwY+VyyZWQ4IaqYm10xxl7Q8C9SFpCgQYiMZaNBIDrIkSkFTYy3JgRSIWjlIV41GJvMl9Jl0sA2WNr0sXUyceMJQDVNXbPZ6PfzhfnVdVOkquJVFb6wN3/LWuYoSMWsqCCEJCJBh6Kwm45A/GDp//vi0m/OzX2skx+pCsVXuyPsBRnnGbmhlOyFNuBr7MJivLn7H9+hP4Lp//s67Bp7/nOkerGfNJZnTe5B9OwSPdTlVmJf/vL9uoFdjgas93m36hWlaSacuUpCNUjYbCTuGALYiShUlfaKZKwtRRX6xXko7JhfIgxTQICo2TofKvFbDKjq5/lqh8z5fSsXeDoSNu53ygBERCoPGDbqkqIs0FnTkBGPMiVETsgJGSUSZmWjxMrxSTFCRsBBDcRgwPHANRE0alViig38TqlJmiJCg9QAVtUoxoTGvSqJ0Zp6pQ4ORFmZaIoJABlWH8Lq6qZ0GZDABpUYBJQmzLzlLe09U3f/+WcOHTmbJAku5MAYmIRhWHKp3C4NEzsyNt68957HnnjsmDXpG15/y+TUSF4WCJ5EeSPDNpNAwVT081DVHVLjnIkW1PAEqffxGI/VKa9BeD54QVFMboXIAJvj2xggnE97vh4c0MASBBUP9SoBWkEDeZHFCgyxooCvZJxMy5D3viz9xhzOpeOA9fknKks/e27BWLtpUZEQkZaeocF7KCfGskQviOCVhEhiVBlL+oRKRIRUiE23oC8U3fvKPiGL2V0ZZD1J1/8djjRLmq2s3yuOHT2ztblyDb/zABU2RFiUKKy72NUdKsv/tLj0n+bO/GV39biQs82EUVrPKl+lLNALN7b0fc+zAfH4GjMA0f81k/tv+sf/YvTrX2cq/5xlg+cx0s4yFHDpQ2fCSqfKEnfDwZsJHB3a2rEPAUDe70vl00ZGiQ0aKooe2SbodCTdicYjVD5U3qQJfKAg55U9qkHeLyaxSYRULtb/N6Q/kzLkSx2idb6a8+iYNgLIav6TzVMaE2Jk1qqKlhcAy27EmJQoYTiCI7JU41WcqlW2TIbIEBzgWA3UgkjV1kLhahgONYdyomgaOCU39GYVFnCKVGjaa+RuYhYz4NDPlFNyTE4G+HoR3YxWjMvXifGkliHe88z2sTtfcfTwkU9+9LNj7eZF8C3CG9pMLzNGZMbH//Le5aVuljW/8a2vzBIOJQhhy4IhEfmiLIpaerddMKF0LnCgumGCQAYwUFYxkQK6Pg8xSgpl1UUWEbW1Yz48nmMnEo0HicJ7Ch5BoIrVUnukrMJaChmFFcRq1RafcUkbMOzF9VWYX1y9sI+MFCpCilBWTJpaS17gVb3W/DsBrEwclMmAtPIaRMTDWCntqaAPVr1PV/1uQAJrlFTNhoReTErGM6Ekse125r088/Txi+0DY9e+qmNAqTex3mdMTMRRrdNRH3+02vu5uZUH+75HmTPOsvFGCg3CguAHbs3/H8Z5Ts/XpAHY2OL0wuI94qd1VvowLJo8Ms+9fjmxY+KqvbtJwecLIKHoFcGXaSMjg0qCQGWzjjOi4yZKQkQU8lIq79LEl5X4QJtJukPNeDZgaVOFoLkVjenwbOO67y4sDzm5sCHmqEtAWP8VBs1K8XWdiyARgU2CqJ89h9U+0QhL2yJVJAKr6hQJ4ECG2BKskFNYYQM2wkaYAQOimtMGBmyNsqoVyhhplA0QMipGlKCsalUFOhGQRkFvJSIYkIEm6lrKKZXxzIMQEWfppiIYQQmWrBdhkPXes0y88Q2auU98+FNn54osS4bvjy7cxqUfQeiXsxis41Mnz33h8w8DfPCGfS9/6U2d1b4lc96GMNyjlSlSQsWRKLFlo16ItE6RMQyTAVliQ2pBRGpVLYgFFkigq6QrvN60tAFZS2TAdL6YlwSogMKADTfU68grCsFSYLZQA9bFilJnuuL7VcGGksReaCm3tAEb67FEtLy8vLTYMWazQ61MRBzIKHxZEVHqDEQRIAFxcYtAyTFie4kRrxKp/oAOgZD1NXk879/V7Z/1wZEVrcvI5z1TqsrMjWZKpM8ePVuWW8vw2p3baMKZTu5NEJGwVdD3R6udP1nr1u8HGYnKMzJbVR5UgoPSVwEI9EKNSyzsYT1gOL4sGusX5fIutAEv+JBg1Jm8NMfWuAjlnqu3jY21Q4hCRXXYXpMo9AsKlKaJGpbYy3GxzwTA5L1XEWLWymvlhxjQuKAjX1ANlhCFKEOzDaXLTd2Y0XgYJqA3tzRE763PzMBvOu+cNnK8sDVpuwmqqoC8nzSavcVVOXVO0GaZAFkiA9gaxU80YHuOyuR1ur9+QZbi+8kARpQDZUQtqymIiAzFIufGmgeRUiY0GkSEDNd8okycaNIkytCNUjMhEDO3W/HCeUAVEOvkiZoY2FYIEzceHH/JjYcffurzX3w4y5rPtUS3/u2wYh//PMuSz9z14LPHzjYa6Td+02tajstClClQMnyQBtttjd7bOBal5zMHAGTIMBEhZs9M7ZLH3Z8MmEkNxxYB8SKnWLrn0xdvSZI8+FksNUXiQQGEKkKuWBbJQdYIu1DhdEWcuLNSzVd5s5lNTI6GcGGlZL0ecN6DNnyxvLy6utoxxlz4DJIyKUnlGZIajrwV5KGRJ9ADamIykJVi0ULFK7jHKAEnriXp2Uo/0cnP+iolEjUC0rpqXucxRMQYStOEWM/NLs+eW9r6Jqdp2+5urra1IIiGdWO3/lidqMJ6uEziOT4juuz5N0/NdtiwdSxfY77yxcbXdhF4q9W2CcN3hWMLdK2qttKsZO7nmC8oiN8xM2msepSIurxxMIFQ9MsQyKZJBIAOns+t1ezAFPpFCCFpZNLrqw9kDIChbnDdQxDFWpVjbrTBHAnmIhHMhU+jqvYWVmuXVvQSbRGbvJi6udSm420lEcHKUjo6VnVLOb0QkDJaBkxKRBwfiKCsakJkLquhQZtHzVJJysywipQoIzLDLVUDdCAfhtoDt0JjCnBACAhKkQhMjA1qkUOhrEGUyTQaJAG0nsKKL4yauiTuK7Tc9GvvXO6vfvpPP1sVdOH2VOfNnnOZ0fDNEkL4/KcfKIoiy7JX33kjM4hYaf0WnF9qJiRZGl8x0elitUwNlJUgJFqXMynWAGgI7mQdTKkCMGRlAZhbd/MvMGaD/CFDKfaLDfioY643Ptp9Qb9iUgRrKUGFWVFv7bz6ZR9GRloTk60LI4CNNmDjD+suvBCU6ezsubVOP8KXNi3zQWQlIZDCxAqHkCpiHKBCovV1MWgDi1INFZWAoMKgWe8/082XxKdEkEg5teH6RQyo0UgN0dJK5+yZxS1vZdUYO93e8Ycnzvb6DQw5GTezjV7lNsUxw0JHUH5ktfrQWhfS2FTWGxZ+vupapC/4eNEMgF5kPO/LsMJGrBH7dF8/s+o/2fWPlVqxrdhKFNIbfvUAG/tM3vnds6vzXs7DzJpt211zfGGVV0Uk9KenRqOeowBB87LMfYFyqeod/YP+2Y+QGGNsCCEMyOejG8+xsKfKOti3yajXQHCGnUCDIHEYyKkI0PHrwGcWhSqxZmw3skADNUn9kJ4eQO/MfNUpjLE0fJoQoIEGvULnzxcJ4q/ZJNPj4owXevJwdWAvw47dd88O9Ds0WlajzeA8TAqbsgMlAqtkVK0yq7IMCEEJhsCsRGoBZyjyfSYAS1QOWO/zYFXDyrHEESViCrUgViINhMAKFktlX+kp6lsYhglp2hgZZxEi5QFkO04qK1jrtg/v/dWvevnINVfd/ckvnHz2nHNGJLbuXfG6CqqKkDWSY0dPPvTFJ7LEXXfjtltvnGEwUxScYmzQGBkwfwcvkLF206UiMJh4em1x3gemFjMTGbUMw2BQFFVmBjMZ1OUlBTMbGCJjGk6PWTlugiefMgbRz6AfGOuJaUbgIFz4pAzsJagUilOMWYPKaBhXDaIFVf0Hzuzy+Wh7avxQmVdex6fs2NioQC/GwLM54Kilf6L+0LEjfQkMKGLrmQxQrVC1TKLol4akmQi8GrE1vFlASr4iCRErVotfhhA01I+hQH0QUm7ALXt8odddpsoYYpyPuQLQbKRspLPmnj19vDr6/vz0vcvdPjRlSmOYnvlqdXT3ry8c/N1lF7STciR6XgfmkeLmzK6TUSrHhjWjxoAarcaXusWH106KratrCoZlao+jNTpAln8lx0V0VjZUcWPDyhW4wl/DKCBsprEE1oUJFfxkXv32XOcPFrqfWss/vZr/wWL3PXOdz66Ws140ttVvXucTNgGwVJ2/qqrte3hi+4l+tUC54zA90SKwllJUZdCm7+W9Zz8pD/+MO3HXNu44dUaYlGU9b7AFgXMInoiqogRTYh2LqIhrZmRNrMUrUaFqQ43XjJAVUklYjQ6IZi6YCgQhony1VyysGWMutgI27oDDjpJAyEmmrt6HZsu0Jh5+fO3anfm2XWf/6j6dP2soSaQ9ppyiUVBawFIkgKMh5sfg/PY7E2IKSJ0hS0N9DzIMA7VMRMqqFmwUTBxxRKyxuoCB0JiAyWBV+XReWrJSiRsbTWcmSUJsTYszRioMEZJ6rogUQnumdt9208LZlU9/6gtZI4UyWCHPM4B3ztz/xSdXlrsi/jWvvWVivLWpDnFBKAaiEEI61m5Mjvm8sNYu+up/zPWfRULGRKg/aqUR0cgHN3ChzYBVjbTGfcpYwALTUcYCoTJECoNBHWrYvgQVkDAKx2uWVqyuMC2TmgCqIJaSVeIRXstQ6R8dXqtcQoae7nfUp9dfd22z1aguETJeUGyL8xygx0+cUyWCbGy5qPELhsWHaq1nDE1kFHJlgIQgRGKgSVFS5RMFExlRgpDGsoVhBSKbnldlUlE6VZpHV4qeFzYYUM8OHiuAiAypIBxdkAZOYv4T6en/tbJyT17mLO0AB+8nplsmGf/w2Z0P9meaScoYir8KtnSPBrsiMRiUMn2+Gxb8OikXWzt397EzHznC7oWhaH4Rx9eeAdhyCOGutfIPFnonqiAwQiYQCehEFT7Z6f/G3OpdndIzdLMNmHL8t3eOXtc834zL6G7dNn6y8L3CO0u7ZqagsKBQZP1Tn5Onfr1x4n1ZedTZPGtmap14tcwKG3kKhrx9G0E+JAomX1Vgcs6pBgS4JLHW1gRn4LVQu1yqIVJ/GEKD6j6hizGkG2Py1U5/aTVmPIZjkDiK57QBrYgBZpy5KIqx/dttO82sefQZU/XTt7xu7kuPrdz/wDZrezJiQ6PyCakzcKQJwalaUYvYBXaeAYj+rBramFqLOjBgqncKVriaAlPBECIhMhLhQ9ElVOOQJJ9d6SxVMMQhLxu7d7hWShoYwhCjQlprEzMihV5dO/Ej6fQdt8LLXR+/pyxzY1wtA3LljTyBEIL/7KceLCU0Gumb3nCrRreRN215g/aLQYZEKpPZsd07gggZ8sE92F39jeNlMC1yCbEZttfBcJ04Y9Yh33UtasgioMqQYRTGHLEya3XZaMnRDADQiqUk7ZKuGVkyWDayYkKHqEtaGRUjxICASqjR3C8tjX7yRLqn4SQUD5Ud8njJzdc5QD3BbErkXCwWH0KACHT8+CxQ5/E2GkIaiNyWvT5ZGk1JvEJAwZCQBnCwVamVOIKFMphEFAGoBM5IHQRwYHhFtAFn86pXBUOIfLobT4lIAfVaPXjWqlArrLT756aOfsie+q1q+bNJH2wsTbUaTT5Zjf15vhtUXcgFdMDZ27N6Kx+Ul1hVPVCpekVkWRo+QcXs0jP/7RNP/NJnOkfmbDP7snauF3t8dQ3ACwqlql0SQAlzHnet9QNxICscG+cjRwFHl/GTa/kTeaguj/y8GoEfm5r1LVTWMU1MjAE8Pz/vn/r57MjvttaOWMrVcCWaJCV70bKmDicM4WUbLrouz4IUUpUMMs5qEFU1WeLSJKZBSdH1VU2GFYk2SVS1RaDID6eIGgBDnom6FGZtvtLpzS9hA6ZINlT846YfakosrVvDlFkBXyRTI+N7dyiK1ar90bvC33xz2hxZet9HuVxt2GawrR1iU3JebcxXEAyjJq5hbD7UQp3GonHd/Tv0WIcV6eizxXqv0UjbG8uhMTFCRMpGrPuLxQVhG2dv9Mb9pp0aFQs1WtuAoSUAoIikGlL0e80bbhi/fs+Tjzz9yMOPjzaaAWBmuaK1JwrApvbsyYVHHngmMK6+ZuYlN15TBgGQ8RbLiIhEVZlU1SRuav9uaACkqDLjlz50Yu2T863hoh16BhEFMGzrU4pdEowIrYWFGgpGwLpk/Cknx5wcS+SMk3mLVYNFp8usy8xrRnqE0nAwCjv4BCNciYwVCxYeHzmUnujltzWmH1tcO9Ltp6Phtlv3qkc0q5fzbMbVQ6TdfnH61JxzDhsaDFEvXBZmrSrtVo2Emk6oMghEAkhk/KOy0CowDcisxIcQgpbeWFt3RZAEqEdtAzJLs6XvBeWaO+m8TYAU1XJFC9I0mfGWq7TIlg81T/xFmPtt35nLUjXGICSH+73V0AMgsOe5U3c00guvt1L0BStBX9agqQ2A197soqJUpaUHT1zBorqMYS6vM/EFHM/TAHxFIEDPS0M4psIf7/uOqDCHWhSYBSwEIZZBoe2z3UJwORaA+y5106881ekFr2nabDRaevQT9pl/N7byWKJragIgqgHSd0kvtcH3Sw5Kwhv9qE1dS8MHPggzG0MUPCCGnUmbg12bV31VRBifBorRveoII2YoA6sSaMsyr8jK6Vlmu8Fv20LPaGMcECK9syJpt/fcelMhFSfND33M7r/KvvXNi5/44sJdd2U27UqrZ00uDkhVEqjj+rBUS8RsOGCVTE0gQYY2TTYTmMQoIh5xeCYVaWFgajoEYWIDk9IXztJj89YQw1fUSCZvu8GxGCUTN7b4JaC4+xup6Z8Y4LKkXdvHX3JgaWnx83c9ahgcDMwVOx8ikqbugXueXF7uBJFX3HnTjunx2KnXviDxO5z12FsskJk7DppmEqjqsDpXZWbqlx5cXjFODIIScWmMi6AgHWgpa2x5YwJZgE3dHcCAYXVGnJXMlE3uNnixaRZavNgwaxn1U64cqbV1QFETeCtBiUVtWEt0qTizYt5zuLplsnVd0354/tjppc6+63bcftNNeRmGGeTLekZVjTGLCyunT80liT2/AC4E8sZZKXzVz5spNx0BjDAEthko+TIEYY6apsQhqHiRSqy1w9OIihFB4RWp4Y6XM7m/cEnHdhw2Yb4sT3eZURgtFK6bZaXrpqtP9E78oe0+mbVy4dXVNbdYBEMBKLDZ5r22kf3ktom3jbTeMIpXjMvNI+HWpn/ZiNw5rt81lXzT1ER7A3pt/MY9U3deU8ytFcv5FS2q5xzDtvCv2rjyDXdLGa9LHJc5Lr31X+QDo+MM4FBeygDtLoMKHjYQJwj4eBXOXRbzubQ0XZk7tdgnHyxMQ9f+ojz5+5N2bZg0VJKACiFpcpa6tOwW8EJDNrctr4CIYyqfiZlVBAAz2wECwSi6wXsVC+JByUxVx84jgbqApjH+ZPXEWUYNsoz5oq27/GJfmLISFJ6IvMqeV9ziW5ym7skTjU8/WH7Xt+Ua1v7nB0dnl1qldrTS0hqimIOObKBQixr9ueFQJmFVq3BY3/05AkBrfZgIegFAhqCMvkVFRPFvTeTi7nfG3vfM8VlSB18URbpzYvT6a7GWO0MO7MAp2GrkGyUTkUr1xHsjNrTTsZuuIw73fO7J1c5y4uhKfYtYP2Tgvnue7PaKrJG88pU3EihGMyPufAsQyz4SyRpYi7W1HTddO75ne9Xv97JElvLbdfGhzvSv3qNIHAKUxiNieLj7118qVJdGyQgbZge1EYEbl/cm5E+c3Y0+R10GjLWEQKTIW9XJIlP5o8PpfUvld+7eMVsUf7ayZNm85c0v2zHZ7oeKGIN+qMt4NkQSZ08cn52bXYliMhsXJxF5KGeZ5L7qFKOZNK1hbzWQKiHExmnpFVKJcUpiKOaLQghSeWstX2CKgqIfVIEzfV9eQPEUOdiN9UIy18sAZrEm+ES8qqmo5VYPuZWTmbWJz1Y6VffEKUZaBEd1qm19HHD2O0aaP9ja9vebO35sfOZHpnf+6OjMj7a2vz0Zm6nIbxDms62xdHJcqxLlFeipXc6oAh3rhLO9L/+TNo3zWeG+LEnIi1SlL3pc5gdebFxoRc43KuskIXLBnwweD1ZCR2jeX5af03vgfcef/r3VInjyNqEpPpuEQivEXCYogAtG4VTHDY+4pOrnofJ8qb7qmvAyblUMQvCkYLbWJmpstGRLXvqCSHhGKpETYsyoBTwFc/ECLxmz/Ozp/soau/UgYEtPIiZ/AEBtTNt7X267dd+OW6+Xoqu2/d/+MLv9NvOGl3e+8AD/3ofHWhNXi0uISEyoU/81GLQuA2w84BSOEd3YwRG3/kFYUDu5FBixMFiQlDVysPIjnFTP9s2/+uLjz9oMQGmTgDD9mltcu2VUU1DCnDDb+l9Y5qENiCNYLivfOrivMTX+xGNHnzp8fKzVulLWeyKyDmvLvfvvfYotT4yPvOKVNw6XU9tdUI0Hho+SAMzcmhrf9/qXFp0OcfI063X53C6tfutQ9vFnGtw0RtiAsaF3D8PNnSJIlMEUa8Q19IsZrJHw8WKnPajGEMgam4bC9R7X4OlLZ8b++zPu5aP0jpn0faeXn1jD9plt7/z2N5dRkt7EDoYrcDwPPXOiTgZtBBcEGGMEarJW2S18r5hoIrNOvJIYEkPK6gmKshT1SpBIOIggGkKovLProtwbL2vNa6GyXIXeBfexqioA1iFw89nVMc/wtg8Sp+pQkumKY9K56aySCgD3T34kP/sxlI0La79EJExVAk0oNewIYqgy8AwBeaxPvBTV1B0z3Oy29z9/Kpotx5lcPn9Ojq69YKnyjVz0w59sHH9tIoCLfddzjaHwVHxQehLymuM55EFUA4n2JbIdYHYr8aOIiiEi2FR9Wd7zu+axB9rluOckVOloQ9rpijgVLQh1QUhENCSAoJFrs+fLAB+I+FJxtGEGwXBMFBNqR5idJWs0CDOvCgoNTgEgxMKvhhGixiCxv5EZdCM8wzi7NrdYLK5Yuykqr5mxdVM6SAjDtlEPFfHpaHLrW1+rVsbG5aGnmh/8hPtH716zYw/8rz86/dEvODfRStFkCzCMZXIMB7IhNq9uOvi8Al0NCtfaqUVsdmUFQWoEXWFUWBEgjWbame2Nf89HDxfJGDBmOIVadW77G1+KSq21MV8Sj2hKNzQfRDAcwzB7Gdk7095/zdLCwv0PPBUFW867G1veqI3N0s6ZQ0+eOHlijoy54fq9e3dPK+pibzMyFOF8AfrhhhhUQHrwW16XTbZF8jMNczKVbzSnCjPybx+0x5abTIVQwOD5JK3DtboYQCaWQ4ZrHExbUhHUvccDggSKM2OYiH01WhzNVLz2Gr/weLlA5seumj69iv94+gnj+eWvvvmOW1+ytNq37DZ2hm+ajXqBsQ67CgaJzWeeORVwgWCAKIPArGlWdAp0w1RDLQEV6q0/sAiDuMitF0NeAoGwjlyIeVIekJVHsmMGglLHcx8KmPO2rBACERlDpTXn+glrYjUhIh/zpWqYbGL8VCNdq6Qq2JqV5sL77eJHB1NL8StIgxCz6P2fPdFbzUMI8JJWwagICZHaDaxEVdFt7W++9BffMvnqbb73QmaBtqX88m1mb+uFyQJdTvfyV7EI/AJWgC/4qP1ZAqAbBEFEpCAqyIhIQbYgHj7/G2hA6v/WBVWmghxWeumX3tM68TiDAZtXoiqTY2k7cyI+bscQhYiGABC8zyw1WlhdXilWuzyIiIeA3Jg3qTMVIDBZawExIGaOFIeOjU0TESHSBUIeNIGEqAwJVaVxoy0VIanbILdomGAyXHV6nTPzps6irrOMXWxEOv1Yf+4s0rY3vrR5567lTt6a3PMb/yMdm9zxr78nnz+d/9p/6T54eBvGUPYRjFWyTDZS2cAIGWJePyLuc5CmYGFSy2IovoA1ZAyIoB4EloAFUy05cKvSSc6KwwHf/6Fud3bbDdtwYnkFrEW/u+2VN+654UYNZWIiuLT+CiZyRAw1CkPMQ+SVQiuv1o1fu9ekyf1feqQsKvHexPQqUSlV7qsQgpKmCSeO4uEszAbKgVYju/evHiiKwpfly15+g0VSC00LjaZuxmlQienaDdxCQ24Z5L3+joP7bvim1+YLSyXRJ7PkgOl+K07e39F/+tFi3k86iEoWkAhVdW8dGeY6KUSxySNWmymCR4esnzQobiHaBuKKqKgbXUhhUeVp+aUkX+gYaf/Mw8UX+/j66d5bZnb99JFn14Jmtvy7f//top42ijmuc9BuWmCRPCoy+8VAtgp45KEjbI1QXQGO5xftnzPGu6S71tOi2tFmKBCYYFUcgqVgodTrk3qFamNiQtWoqgZwMNbaWNSpO+SIrBpTkhFbgfMicWKG7dbMLIKVlS4zh0aDjCz3yoqYaIAUUgIkpu1GWyWrFU9Qw8LNM79fHH9/FUr1DtyvlZZZi+Uza/mT7UYW76UwGSULAgQaiJRYmdRATZnuvPOWpNm60ozIADEngwM8bEIGW0PXj5td7Rc4s3SJ8WLDQF8Ylm25seGaRkmViAwoCioQ8QbHAticMF0/BUABU1bpo+/nlaOkmVNS7zp5UFQTI5IZIg9WCyGIQpVJLXFZlZlDu0Hd1Z5f7Wqil9hziYihNjEsyqLWEDMTDBlns4aIgKkI0tV6E1JVo6IaWoRxUED9jGHL/kMlqfzSsVMcdRc3PL0BKtCaUGVTPCgRD6SwlebUym5+1zt0jD0VC/nIv/nZzju+Ze87X7P0xceW/vXPV0+f3OlmUhPSHFxmJRyJZcsgq+y2PmAUsVzriBwhsUgsrBNlJREiLIzjyKjzo4F6LbP49KK8+8PhvlP9H3tluOeErJWOiWzKL33XW4RMolUCpGwjy5yLmjBEFjWXGoOiDSCACCFJR/btgXUnDp9ZWFjJ1ivtEJHRZjY12tw11to9NhKPPaMjV42N7hgbGWtlSWKdZV8V99/7VAhhZKT1ijsOGh6A3FXbjGsarggeG9TcZMDuzApDHGECr/yB7xi5yjVzv6r4aKV/Oyte05j/eKf1Dz/YPZqPuAazTyAjpRExZNXBVHXqDNC4aCNSlCyUiYwQK5tBfs0SmJAQmsAoYMlAXaKrk/mjjvK1rDnxC08UfzbbvnpU/9X1O//w2aMf666UZfm2t7/+Na9+SaeXW67JHkguHrrGlrOgUevCOXf61NyJE3PNZjbQxRus8MjZl6YK49dyU/S3twmBVJiCU7EUrAQDcWt9JwKQ8dZSZbwXCHGujg1LiO5LJb4TSptU7aZ2rF+mKk29oaBENeM6a6+bry2vMbM0Ry2VaxV3kYK8IbBsrGxLYsQK4CkIM4RUWuc+lp74PQqLlbSDUuCUpLTj+970lq8T9hRb6klQq72dN57/rhXFfaL9FqrFIUAblT6/quP5XMlXiQXo0hEDDZ16ATDt6DsnRzDIHvImqj8A6ErkybroQk8O3W0WH5GRcfhg1fRL6hQBCONNMexNCAytcSZK8C6EUHnJnIy2bJ7nq2fmDMjjolXm6LQa51QVGmxiyBrDbIzJmo14If1QLQrApCJMChJP2iLdxkKKgcpSjQ46zwwEr4vPnFQhskaodkrr1sqacJil7mdWQRgWgoRChWplcXnbS+/Y/643zOkz2Wj74w9c9YvvPfszP9N+7c1znz+88Pf/bedLj13HM41UQ5I3OKSOHEwaE/xDpqCNh5DEb2FmsoZqFiGoVVKDaqQ47kMpPS1TM/K5TvuH/th96Sj/xMv8s8vuC0dGQpoVve7Bt92667ab+r1O0xkLsIpVsgxDaiJxHJNlIpW6skJiBBYaRJpX7czGR2bPzh999mSapnG38irTzXTnWHO6lYw4YqlYKhOq+KLJuq2Z7hxtTo+0Oiudp546YYyZ2TF56+3X6SCPFMOcPQ2XMAUKIDOc4TjifTHMvignrp553bu/I19eTqF3ufJLofcvXHm96/x5N/t7H8A9Z5vJiDXGGpmoLPWzXuBaprROphERGWau02kwsQl5IIxKYBB7YhYnkuTgrH+0ce7+VS17ZZb9u7urD50ekQb/8q5W3i/+/YnVoMn+6/b8xD//291Of53I8yJO2HktYIP30lNPn5ydXzKJieRu5+8G1jGo6PZN1d0xlsJbqKowYKAp1ELd4hpYmAxL1iBvxCtVLCWcc8MemoByR6qvn0y/ZXvjFeNuR4K9TW45jXCpAGVGv5+vLHeY1GQtIl0rTF9c3PWHkahRgUpqA8F7D++FIAxNuZ3MftyceT8RKyca+iQZodhyKmjDv1/OEBH1KhVJkUrR0rItviEBUu8bL6Q7fpnsdS92BPDljIENiOnRGxrm28abUUa9dmqUVWjYOkiKGbf1rNjZx9zRTzAK6q2SFwNazZH7wKTtptiIGCNf8xuL7a2VEBKBsxgddUpu4fjZ5FJQCo3dqi5NSEFe0jS1lkGGmbMsU8MCLRiL4iER/xPin1joJDNBlC4lf0yGl4+eDJ3+OufFEPgfJSpJsF4U4oElUEDIwDYaeVnc+F3fsvv1ty30TrR22F//0PR7P5D+z585eMeBhftOzP3jn5/7nT9sy/hkmRXQAJgIZ6rTQY5gh4eBJY4HMzghtvXur6plI+/P6BPNotdaZTJV+oGnG9//fjq2hH/zWmv92PseaYRp7uWzO2+cueN7v79TeeZ1woColwnAUB02RyVdE21AbAlmDUFaV+1yU+2Vuc7hwycbDaNiAKTGbGs1Eg1WJOasYyRRHyrwpZWQGT397Lm1tZ5xfODgnumpsfXGcyIA2xIzk5oi+CFrEG94g6r6ogRR0em9/J3fdvX33dKZPZdkY79N1dPa/dVW57rmyiPB/9iHln7v3kpNM0PSLlMXRiDNCF/GgKg1Jn9iYFMHGfGKY6mArIeCfUBayjVLTzXk4dXtoX1siX/8i+FPFqYLKf7lrW53fu33fmH2nHUNs/zTP/fD22cmsLlL8VIP2aDNDYAAxuCBB55e6+QXY9cQa0FOO/1E+rvaqQYiOBFmSUgswYoms6tRFoIlyyDKFXER4JUyC9JIlTFu3e3t9rU2a1XmpWnjNSPtq5OGF7uxZr7a668sdw3INFuWOC/JB8NYj4AZ8azFGWHV4DUEjaqdkJKTcbf0heT471sJzDZ4AV+KM+TCX10+xQgRkQZmDj0pn/pY/oVfLu77peLQ/1HqCUjFvVCqv1c6vpYNAIAhHQoJoG8YdQMboDXOdwgHgjBkym694t2RT8GEQJbEAsxE811fhmBIWw2yFFQFUJCPH1ZVIQSCgEDtBgfB7LETpiiZL4VoYoVLEwAhBJNa4+oupyxt2iwB1INOe0/Kpm4rE1E1wG5DsYHrEkVmZl47PddfWIaxutlbUYJupEHcjA0QglFwJUyl1/TV7/4net3ulbWlxvTMP/9t84G/Kt77/17zTdfTobP9X/rttR/52ZHHzr4E09OBJO9Twa1gNRgK8QNrCbtIM8cwrGQoFn81AbIgbb+WdB9fXFlbLUJ6bHb3T36m9Q/+bG2kh1+4vqOzxX99QtAYpeXe6Ejj637qB4rWCJFJOLJlkCWOnn4EfVpGHQcQG4pwmahTwKpKrWZz1w4lfubp45UPcT8dz2xqmCBBpVJUCj84gkClNgMmhMNPnSzKsqrCbbcdqJu8Ir5WFaptY65uJBz8UKhk462p91ZVZg6gt/+jnxh51bbq7FLhJv5dbu6ril8btTe7ctZnP3c3fvTDa/eveoy3rcmEgwigVsWogpRZXU2jwZZjMZaNEoMcYAVWtVE2RlGMdO6Z0+OnzySNXzve+PEHd3zuXJa6pV+/ferNfu93P3HP4aRZduZ/4p+94+vf8jIJF88lXnwowTpTVvLAA8/Y1NYkbhe+z1oiyntFm2X7SEpiKHa1K0EdwN7z3EogCZqQNhISJc+Slwg+baVEGt2JA2l2beYEiM3fzYQ9haqmSRFWJjLzC6urnb41bLOGgfEV8rzcCHgQ1HlPIo0d+uIlArkBUXijkqx9yS58huykMzldPAlDMMwcKKsCldVKEWzhR+SyaaYiFRgA8/j/mHzkN7ef+cLMiUfG7vmwPvRnziSkDLmCe/FCDaUXyew897iyinEU0gKAN4xaUPanyz2ljaq/SoqWAalcGMi5wx83y8c0eBYrkqooEZ3rFpWKZdNsQEMQEUMcGaSYpJEaqYSshej4SJKkduH4rC537fSol4tkgZg0iEkcEcH7JElsfA1yztksDf3CG3NWvMDFdJNEkSfFNqsmx1AvZesJM9xfWVs+eXb71TuGPwwDxskYFoUNzKNYVxVgUmUJcKX6Zn+a3/wvfugj/+JXceJ0e2rHP/vN08eOr/z8P9j3n3734d+9d/zPPrv60BMr3/6Gxve9de+uHfPwi6IcCPFsAfBA2ErVMCugggCyrA0/b+dPl90zWdaZyfPJzx3n33hq/qFy8R0z+d+boU+dav/uyao/apLeGeKVd/zsT44cOJB3c2ECsRCCEVEKUFGoaqUkqOsdXBf9VECD/2pIkvaenWzds0fOFEVlmRRop67UEOuHddE4zp7WsB4IGKSERx8+IgKb2htv3mtQM3XHoq8BLNH+pnt6xc1JZYyL6m2bbgdREDGOy7Jop2Pf/dP/8r/+2D9LD61l4xO/LGvvXur/29Gx3293/jQ3nz6WnnxP+Q0vKb7l1fbgzgbIFFUI6klhjDIT4Ei5FgqnIdtzbA2H5dH8DPuHlzpL7U8v7frTY91Hy7zU6sbJ7Bev22kWmn/riUeeHJ3O+/M/+COv/ZF/8Le6nX6AGmMuHxobOY5U1SX2xKn5J596NssSUdo6oZpkohRWOxMNnW5bDSE2dQEm5ovykufWGFSRSyhNPQkrS+FFS9vOQJKwseov/PCEKayTuBGAE6fny9K3EtNoNFjUqFg+HyVbU8bCkCiLqg8IEiGsHFRtSvmSO3tXGLtFRvaQX6SLOHAVMsoX6dyfmtkHKe8qQXd/k9/1bYlZfc4JpKiDk4zgxJfs7Keo6cqqYrvirDbPfSHvvRVpA0x44dqAL1+94KtlAL7iejo1GQNI3jBityWtP1jsdgLXjAgkrLgqMTssLszS27knAcBYZaYeIIZIF/tlgDhyoy1WrVRYzQCCRlXa4pXFYEWhumOqYRPJF1YWjp0amdmW+z6waRXywK9QVY4C3D6kbUfGxD0occ420nzee5JTUoo2jcLXwquA6iQjdrwNtT23mGBrjDGzjx7a/trbmBkXcUyCqrkg8FcCKCispxC8mpkb3/wT//Dun/uPxen5kR3j/+lD5ZFTT/7rb939yutP/rs/nz10+urf+r30I5/qfdOrm298xdQNNy2MNMSwkhmqfpAEhjoyBpVQP1mbs6sn0/78SOg216pdjy3MfuD44bvPHt/dll+8YfsBjP2vU+VHZ1FN8mi3rFz5zl/8vqvueONsdzllCEFYPSgoBSUW8lw3yVVQAVnW4Q5lVERBbEilImpcNYPEzp9dWlvut0YaIaAKyiAQW44FIR5yeAAAkUQ4DPDYI0dEZGKsdctLrpUB2ZwBABYRZmxL3E2t1md6nZgFP1+FlYhAwStx0gnl5NXXfe8v/8SH/tl/7D++xNvMr6j/fHHy77a3vbIl73FrT/Sazz5gPvp4/rqbkjsOjtyxr5waK5mVuYIhFQmipGJcJFMFmwQJcUmdDs8dLc48kTy+NvOnq90TCx3f0fHR5W+5Lf1HzR1/8nT33889Pd8cpaWld/2t2//ZT/yT7qoYEuPsZe7+56UcmfDAA0/Pzi27LBUJtFX+gNPMe5/3iumWHUlNCCWUItaTwETqq7C05hFj28R6I4ZY8lIo2Ka1SqKaEl2Ycs84AkYDS93HePLEubKQ8WZis6ZUuUGVWuHzWKOj4QTiI6ShJpElVKqGRClU1DvmZj9VNt4JZLhIGU+KbvrIf2icvtvyOKSvrpEv/07hgWveQGRUn6PFlESUDa+conwR2RgoKJhYuFobcFO/OPIqV2wAvkoV4Cs9KwwI7gEABzPzd3eM/pdza50QE97sKZCSwzAsiKrQcIc+bpaPgagOhqTuUepWQaBENNJOVXsQgrFEXlVB3jKTJyHAVzMT49b0QxVmj56afv0rTdEHKGwlOKyoW2FNUGaK9TwM+oFJVYmXVMWw8aQkAiWIEW5yrYLyHJPPZu7QiVh3Dd5fjOP3PBsQPTkiDeKClZBrXq25Ww688qe++/7//FudJ7oTO6f+4qnJe59e+clvv/r3f0A+dM+5D9x/6vHFsaf+bOq9nzA3Xr3v5Qf9vp3Vjolq24hvZiG1AogvqFp1xTz8wmixNr1Yts5JOLx05ovznzk8t+ib5d+5fvyd2Y5HF5N/Ndt5PNDkaGVWQKMr7/z5H7zlld96cu10040JE6BOPIb1D64zMWDVoBUExAZEIjEMUWJSGJAGyfbssCPZ4kJnbnZlZKxVefR8aNmUUG2Z/CQiCcE5t7SyvLC0JiL7rp7ZsX3iwncKNCXc1M7uz7tLWiVkVIMO+oEV6yZfCYbtStmf2f/G7/3lyff/+3+/+iXZ6bLHuPFTC8vvTBr/Tzb9ZKv8cGPx0V556An3wYfkxhl78+70+u3ptdsxNRLaDZ9lohrAVJbUK9ArsLKMQ8f5+Al+tGye7q4dx0oo7Ijt/I3bzA9M3VD2pv7ve+7/y1wZI66/dMePHfixn/phpMYV61pGlzOUo0lUEhBDgL+6+9Hl1d7OkXZRVOc1gsXhk8yFyvTykTSkznuvJJEQXFQNWKpclwtYkBiCscJqwFJUbJA2MlJYkaRuTsbGbH5G1K9TLl45UcKZ03M9H5xzSdoovCdXOqsIYah8u743DE9VBlxbLKxGgwJGwXb2U2HytjBy/cUMQDL3UXP2kSpphrbjTk5sDTrNo3/Q2f1yk408p+8uLqFQythuokntdRJ2Rlp5nufX3MjNpohAAH4RtlZ7pRv6xdpdo6ONrZQrtn4/0eDPzvv8refyohQLF3b0Qaxiv2v91I72r5yZPRU4pUYA7U8yCw3gOi4kcv2qcfYRsgygkshNHpMunFcCgI003IZVrmQGcRpRIXAIYde4taqeMX/vIfMdKylpP8QHZ+PkKESJ1FmbNhtFtze9d7zdbhSrhTWZqjQazRVmw1j2mPVhZwRfA6QQxUus26a6ILVC7laVACZRcm7p6WflxLyZbgeAhvLEdGF7fSSbq2ccNUoVEuBVlVH2+vba29/4z//N/f/lt+c+fWYkGekmoz/4/jNvvkl+8uX7/+a+pY8/ferDz84/NGs+f2jy3sMTrRaPWm6ZNEmSRsKjaZpS6jStJAQp82r+WOex09351aJ7zcTkO67b843N6bU1/OqZuU/2VssGT5VWZ3n6ltXv/8kfn7jt1b1Op+FS1iBqPJSICSEQCPBgFgkg1PgTCqoECANCUYyh0kAgFZ+NtNKRVrnUmV9Y2n/j7pBjtvDTaXbeWhqy5hGTVEKkZ07PLS+vEtE11+xmToZiVKSsAuKgChCNN/PXT7g/mQ8BIYZr0QAIAGEMmDIDRFR7fqWx87of+pVf/bNf/60nfv+eFk+HRvN3itVPFqvvGhv/1+29Z5P5u1udzyx3718Jn1uglMy0sRMJRhwniSRMqlRWpips6U0RaEVDV8MKrTrrDzTxhv2Tbxvf6wp+//Fz7z369FpzOu3n6XTn23/0Xbe961uavjFhqISoKm3WRVyvB1y4FahqrYGt1vLystxz39MutSISk2a8WViTmGHTpFfk+cLVO1MyBh4Eo6xRlcEanF6zC6tZQv105NoO2QrBwfb7RbOdzGwbdVoJqCJzqui/XDNl5YhcA9Z85cAwQoAxDODI4RMma03w2uTq4bOTN7XblBrVEIbppo1XF2njgjDiwwhSjZ0dHFRRFbzwoE93k0u2hFrw6QcTBQXrV3pKVjQwT2q+ZM88oNe+8dIZDiWCskqJXbf4g9/oj32E80WTJbL3pfamt3tYJU8UF/iFG9z6J9NG4/1lAOg3btEvWApI6UWKYbY8GTG5VmNG//HOyd+aW3268Apcn2Ve+oOyhzLIrB6nfAkqIGIIw4iwCpWwnb4oCRvNnFLwZKBaKVShAAuYEq+BRN21M/0dU3Kyx6dP9bLuioxNLJdFZjdNbIw9lZFlmW2n3vvR0WZz1HXmctucFPHNxigbpMQLXueD7iavzEIAITAaTDNOzqqYgYbGRW4B5Su9xaMnd+6+NRRFfGxwudLnHLum1/WEVfPxXS/75//4+E2/d+bDn/GzyQ1Z65GH3Hc9+eRrr299746X/vItMjt3/O7Zhfu6s6dLN1/QMWuQt5NKSb2EoEEcCUnBRva22u/Yse2Wyf077EinaPze7LlPLM92THs8tbRIebpy5/e33/FDv5CN7+znkjCMGgFBpISUJEY5j+RyqoZQapRQAKnxkAoKJUcKQDREjgVScePjWXtk6cTZudlFY4wSq1IVJDUXe3jqNM/pswt5UVhr9+3dYTawagMAldAEVCk8SeOlLf9Uf+lQ1wRlhQjVSyR2UEUgcjS3on6tykfTke/4J3/vnju3/dXv/PHq/WEy2XPO9X6xqt6TP/YNvO3NzT1v3UZnKTyN/pM+P1WVx8uqKtR3NIAsLCtzQNCQOdnWCnsyevn2yYON5q3Z5Lnl/PceP/MX3bVZkcSOoLu0/1u3fc+7f3Ti4MGAMJlwBe9BjC1iU2z0kc//NVTVEKWp+cJfHX3yqWMjY+1QrdMyx3J3/dpYSyaURSirvdsSGFUSYgZBFQIha84sBgkwxmrCDK0Ff/r9ZMLt3NVq9joerksyUkN4NMa+K1U4U1Q3tlNPpIE4wezi0uzZXjNxe1KQtSTa1K6jEqKIki4ggJkC2ASF+KCWq8pBlIRUKSoYqSpBJSjNPcTjr8HYri2DgET7le0rjA0WagiiVoMpoHK+u7f1yqrfYW97t+55DTqnqb3bTl7vbarFPGwT5grrwCQbbcDzqOrX53Olf/A1MYRKBbEk26n9o9tbn+wuroRqmwuN0My5bt0W9W7pCUgB44SiELARzwA8TDevmNQYSgxx7P6KBTmJbb7iGl5W4Qs70pY9M3ryGawur1RHT7/lm/f8j0MlRJkJWocnxExKKiqGtt9+sGonljG9bfTZx44xc1Btps00y3xerCjPqRjWShUEJakITeIZR76US4VrqsYYn+fnHj961dff2e/3iS5FTvecQ1UrdETHrv32H5y56c5n/uJ/LnzybMtOmca1dx+Zvevkg1ePjn7ryK7b9u57i6/yfjUf+ivBdz0tKTqyYrnR1HTCZGPttJWZCTeyVNHjnbX3nHr20byn3JhojDaX/YpfOvC66l3f+T0ved23ddT0uqXJLAssCZQDFEoQFlZWRC6wAppAqxrqpJYA4QoSFAbkQEoQlSBsmlk2OlqW5cLCCkiUIKpFkPTiVx1n+Mzp+bKsrGvs2buNmVXDYOYjG0EFdYAFeVH7jeMjs9XyctkADBCgBlBQGR8u0jqyV5ik6TtlHjR7+dd9z/6bXvPZP//9xz/0KXtoZMLskdHsf9vi98Khg4W5kRu3m/YrzVg2SlUSihSFQaHkJRBXTSMtp6OmMcKNTBvnVunR+YXfWLn/0FpYMWNa0hhk7Ka1t33/t77ide+aa+m5tc7Ldo4mhv3lEWFtWgMACI4dKAD2859/ZK2fbx9pV0WEw4WN2vSqAdayVlWeG9/bv93A1E0hYBAQ1IvaM0uK0kvbmkYC8lmwhkKZ9yZHm9eiOWOz7gQf8QCvLfowZYmAJzv5M93q9VMNRbT7NoRw+tS5c6dX2kxXJ3rcpuQl09JqGTFvRDEIiHUzAmIbhym9ieV0VZJY9AFxrKv352TlmTC2a8upKDFqQwPk487rmaTqNXyzak5unIRLD5IQ0KXpG2nXK3y+TL6UUHIyBq0umvp4XuNilcILx/8/DQApgRBQ5RBL9utHxzLm0leeK1JWEoKlcpVXjm6gzySCkWBUUapZLRUAm5A5AMwaPIUaiQEFUGnz6HJ6SxIyW+zbSR9/pGq3OkfuOfp973rda7Y3H1jMEQNn4sAKFUNGiKuivOZNr9SgRRWmt030+k8IOIg4lzbaI/1+1Wdz1gexIoKE4JVVkaoeMGqFDEu4eAQAIgLPP33c9yuK6M4rGU2gA7DW0sREREg9r5wm3n7TTS+75lfPvvIvnv3YhxcfPpmE0fFyfGmh/LWVsynLeMr7bOsaOzpj3URDdyfaMCOOnZp0tbSHVqszq8WT3RPH826HMnCWIsNyWMmWdr8Mb/+2t73xdd+VTI8s5GuGdUfCedAABCWJGjrERBKpuKJ/bohKAREgYNJKjCUVNZEtI3JOB1AQVUOu1UDA6koXAIO8aj+E0YuwgqvWBuDsmYWiqLJGa3p6fIODu3GqQ01qTeWkTb5n2+R755ZXqgRqwIGVoYmwj5WLIVQ0aINMVaCzUNhs2zVv/6F//oo3vfOeT77/0Ec/13us3eSRJNtz2PhHtPg9XWn5hR257tV0Lyc7EjuaITUgoOfNqQpnffmMXzvh/WK/1xUj+VQS8sZU99qXj77prW94+RveVo2Nn5C+6fF0w904mnaKwFrzDF7k2remA2JmY4ywLK3I3Z9/uNFIQ4j78FZOL1ujkF4xQmHfZBOlJ3LERCpgEAURLK0aBCCxkjmF76emGcosLycO7Ho8lPeuLClleSiM2KVSdlgsF0oqb5xsjlpSqpP4xpjDz8wur6y1U72qRScTh0oS8gYIFLM8AxGOAYtGfOG9jSzotXRHzBSpIVbSyq48FPDGredn/+t1/ktG0pI5GN/w4JB2WzM6cbXBc5WAhx8SAd5aan+eycImkBKSq0bFpy8XlH+J9MDFxgtpAHQd8PIij2GLS0AgwIivBEwUVJUFymBDvVnuzyknICGpg0EJMEo+UJ4LmAyxI2ERiTldBUGgwsTLYfwj57Zft/14Sr1br26RKdnYxx8+sri09oaJdiXh3rVeGhwzRJlFlWrHA4YkSBL8zO6pSLSiBGNMe3RibnbBUzjpRZOESx+ULEkAMfRaZ4wGJntRrJiyBrBL5g+fXju10Ng96cueSkWXvaqIaIcxJ6QYpoEEYHWNoGvwq9qfeN3XT9/+6vnH7zt9912zDz7j58xot6Hk8h4/ZsODdsWbwCiML600SVkCeSNiBMoZJU4neSnkocpm6IbvGP+mr//WN7z0LcnE9HLo9EK34RLVQIasCsRYVRXyJETKrF5RMaxQSULCYIEomEqBI1RKhjXGAUZJSKwSSMBJOtIioqWllSjoJ6q5COlGEfAt9rL5uVVfSdZIpqIBOH+qotIWoCYGeeM2+d7to++dW12uEhIDCgrDYoU9rZfNlFFBhdRCXVGG3IeJvde/7bt+auVNx5547FOPf+aepSdOyDFkJjU2NTyyaHlB9b7Kh141xO0wBMoIVkOiksFkjVZv5NqlG171kle97vUHbn5ZOTJxWFeyfK0BV8HfPtoq8ooxKAdd4XOkIkVVtCYad9975MFHnmy2m1IqtpoUxBRQ4LxXXTNmto9aHyCxgQZWvagK1D5zugcNIbPUMIBYUdJQ9dbGxkfEu0Kzmm0cslhirZCDDff6iREAYQDfiFC6px951ks1SrpvXO8mQIMjYnBAYLiBfFfdwjZsqasCx85kJqG6FIiY5zKU0MohrrpqtxD5MpOv9gfeUR75QOJdWjQKCz+WpTe9o0hbRgq5gp2XCWLIxtYIMLFAI83hxqf5cj5tcxbo+Y2/1hEA9Y6jWtaxW6/0D1WVyFzImw8MiicSuDdLvqe2CSIEH3uLREjVlMLdqpbtdhzWm2lVoTVHy5KO3r2691280K4WD85Q5vJAjbOnZk+fW7x9b/M1zSx1uH9xzWuKygoMOBDViLQKYYwk3bWdvZdQwRpik7ZGjbHkq9OBvLOuKqtY5IQapT1OLCFczIMjASAi1rl8pXvy/icPXvU6ostL/m8eLkq3itT1Px3Mm7Wr3nOz0XzFW6674437Zs+uPXXP0qMPLx+b65/uaC83PWlIi9AUzkgCkxHrXFVpGRBssFpOdMdvSV7/2hve+dY3vfSa25UbZ3trHT9nJGlQA8wBSopKyTOCUghKIpH1phQYwBMIsARWskQ9FTCVQg4qtVfKAiUQcYAYkDetzDL38tJLDQAMl8y0EilAK8sdAM1mY3yirQMMKAZ6L1H0rVbsgQEp4Mdt9n3b+L1zy6tlCjVCAWBWlg0VeKpLZQIqACYxPc37xiV7rnvTLTe/6pt7y2cPHXnwr048dujsM8/mC0v5smiH2WdcsREgykamllPAFq1tdvu+Hde+ZM91N+8/sP/69vh4F/ZUUXJ/qRlcINvV6vaxbKZhC/VD2odLPzVbPEcA4Fe7+LX3/B/rOFSBYPUC1qtYkGfjTCjKXrFzukzgRKQKnkirilSZ2XU8nVko4FQzgyQhVSV4Lcsyb0+Oa1CSxJGQqihPJubN4+0pa2RYzYKoinUuhPD4408mQlel+b4d4NIzhaRGYLGgosgbShJpx0HGsQNxEBtpAoaySqQAKymJVqoV9edkdB9d4NOXtk83vN3ufqks3NcNq2y2uYlXle0DqmsiusHnfI69Oy6eOjOsAhrmCDd5Ic/Dl39+46+vAaCVh+nEBwHAjWtz75X97UVz5dFxY4SSO2fUuJogAUzEUA7BGqVCuArCZJnZUR0tUp2kk7gx9kN6wo+flZGry8Wrt/k9k+Fkl9d63afuP3L7wWvSbv817dYkm0dXunNrhdAmloiJzOw0ie7cMd7iPO+5sUwlJM3RNE3ybnEWphtklMgrjIojCkF2WjPDOHsh9cqGEQN2Ijr2ufv3vvF2N2JxmaHphvmZNMk8fBkgqqQbWW6UNNeAUitw4nbu3Lbn7Xtf/7bQWanmz/TOnFxaOJuvLoeVvu/4fr9niCUES2akOe7G2xMHZ77upde+7cA1127frp76aklk3GRFNbYslGteSe6DigAqVkmAYIw3FFQrJcsoRUoDI1QxWLmv2hTOVZkoB1xMDjCMIgg5YiEYJZelzNzrF17qJ9PrRYPUmsw5hNXVjqo2Gmmj8Vyq3zHbShaQcZN+37bxjy6tPN1LWFm4hLSYquEcstS7kmCAzxIH7nstZudDktrmthte8+2367eUeb7SXVlaWZjtzC9119aqfk+rwGxTm2bNkbHx6Ymp8bHp8VarxWlWsJkP1ZwXltKIEkzhChMwk7lr2tmX02DERCIyNjHy/j++//jc6q49M88ePpmkMSnGkbdnHanJFtZJKIzPD25HoxnQQ+IIDJcEVOMwODXfOT7fJ2eQshoGlLwwBar86FTbcWgQKWApyay8caI1bkm1hrHVnjpAJGfPLT9z9DgzXz9e7dzleDa3Rix5hh9oTw/aHLUGjDEzAAkb9v145iQIkRRLFKnpHAuj+y58LkiNkbRq3aatl7kgjKqyJbBWn9/GFXFFe/cLw4b5/MdfXwNw6fF8001MJKCEumfM2kk1CWkFMEIJ2xCoBgW5wnPhyYCY4SwQIhHApjr7Ws7Bu7UqS4UnGv72XXziCSHSB+8/9O3vevMqU6OQ2+zIzhH3xFj5wPIC8pEhtdaBdnMHmWpidHx7a7XXnTRNH9SmrTTNpLc2p9KtqikgVTWClCBBZpzdBT2F56g3qWrabJx78sjpB57Y/w2v0KoQqFUTeJ0Z8dITlBnKyJQ+1E71AMtIRNBGbKBXdEuhQuyaCLVSN3Zzsv/2qxSJ5IIiAdhXJCzBVoGtq14ynXzTROv6JBNo5akyknoGczCm6UJLUHDWKbhT+n5QoyQ1q3dwICGuVAqNApAaIleygAg5CIIeJIkYda4p6S2RV7EEZsBwZL0OKkFp617wDYOIQpCl5Y6Amq0kSTYZANKN8o9cz2ekZQaDwoSxf2t66hMrq3evekgrbkZGRcEgAVjgoFD2VPugAdKAMkjyqq/su92eBZFN3PY9M7uvdjWTnjWguP2pVCISQlVCc6+slSkK67UyngDlkDM5STLyt080m5Y7ZWXMFRmBwZtJICbLkvm58j2/88FXf90b73rvh+PuFt3djbtc3X9tmMQhLzjYh5/M5+fQKfN+7ju9ql8t5FW5UPlemcAorKm5rRRU+IZLsm3tUkuyrEwedLCZTNi4FmrXiQDW2nd+8qlnT51aymzz5h1+bFuWzVYUPFMgeGyV54qOUb2QI5wXg8J+jdFSgAkVrxzGrjdd+AFQE1gIXQMNFj6SUVFsP6+3o7Or1XhmsoR9UMN/TVumzhsvsAFQMD3nUlMOKpFbN72AnW39/2O3Mvpw06G5l87/Fgz7uVRx4a6oOC+ltvkbNHB/gcpVpkE+gBzIgDUoCKasxIsSkWWTDtiVGYIBslJVfel86Tq5w5gaKV93vfuTh4pGI33ysUPd5bWppBGUCqna1tzJjTvGdjyerR0t8tNleU2avbI12vH98ZHGzj27Zx+ed0lSlWXm7MT0trn5xfmS/hJ6u/CS0Jz4JV3rmBIhOe3GTDlO1N9qYRlFZDgQrcpWM3v8yNzkmcWx6XaV9230U+voYaPHsZUxEJ0Qbjq3yH7Ze6OGo+Zi9J6jplkgIRCpIYIiVN2osro+xdaygIK2ufiGafqO3RMAPKK6CJLKMMUCHVgYQBaUEmeNSStf+FCE4IkDS6RJjOxolmGUCigLVSwQAquAmsI9FaWoc6ku7ltKAmRsnDNepQxFGNQAzuvRqzXla2EWAQAmglUBs00Te7H1vCXKQgkBeNP46K6s/POlzooXCiAYmJIlkbooLKJamyyKKSsB2IDgnYlNTAr1hQ/k63Zc4YHaAQDWGg/GZKBeFRUpKxKVBKbvQ5OL1+2cnLRc5X1yZuNWvaVzOuDzpxCCtWa12xlpZalLq9w3svQ//Op7elM7x7Ztmz+3mGXNQbIjuv9hmG4ltqxS9FZS8h+7f/npwyebbqrV7I2PdkfHiumR7VfvTf7iY7yWW5MVGK+1tBwb3+m3snTHzHYStcSBlFi2GWuhfsAjMVivrOoA+cLnH6u8nWC5cY+XJGhVKnJWAQKv97jE4J6gwXDdbRs5vSHCFNaTNgisrBRUVXx3mP/ZSPIaOVrXszfxD4VANUHY7z508nPHz3z9tTu+65arK9YrLbc8z4TPxcsAlwkE+msdAYSxO7f6sYDUKAIMaVLr9F6esSUiD2MA7s3Dd4RSwAMMm4FJoEFgiPuCMmr2GrJG60WzuYVSyLKF9wwKUoY7r2lPJfmqprOnFk4fnz14wzVVLyirZVaWzJqX2dFbGq1jZbHDOeec994wbr5p3z1feLZSFWPAmow2GnBr3vzF2VOPjIZpcm1ybaId5GZstpLy+6q+XvLq4qLtzS2Md8tjDxx+yZtvB6CqiVBFw+akwfuVL9SZir20GWiarAMv+hCJUwZfoQySmGG9+PpiJQMF975n19g3b5/sxT1UAYiBGc6kEUQKBzBZYNTaFvOa8d2SixAEkQQUnoiESlFAmVEQEGIdmMDaVwDcg7AKCAHswYrAYAMSXwJwzhlS2aD3conBzGScsgleQwiAG0wX4lVsdd3nT+P1WXL9zslPrnQfWeuuljaEpmFiroS7AIxyXUnWKDENRJpP3hBYXHSs/0o1DICOxKqitFgWU86+ZUd7zHKZF2wNX/bOQkTW2m7ed86xY19p2mg89tjJ3/6DT/79//YL9/7l51TJ2IvQSBArGw2gkE22T/+Hd4/dPD2pyB1vJ5PAOFQ52vonf3kuhGANI0lqLT4m6fcnpto7psa9egaVwacqE44D1Ejc4+qrVoKxqAI+f/eDxtI29tdehdVSfcXC3sPF2oQibKCCV5A4DgQlJfEBVUAFWMEgmol3IbJP+P48S/DsGDXz42Cqt8i+sgHIBLEGYXaxOHsum5tOyDITkX9x3P8rLR68GAaAxFDcsWk1x2h25R9AFEzKlOrTj/DZhwHIK7+ViNTY4RsuNUGh4M4JCiWMBZlBDCFE5EFWTVmJCrGyY5NYsLKQDon444dXyDg1a96AvJZ69Ta9fab82HHve9WD9z11+x0HVld7xqVEJEG8ahQCuy5tAPBlRURVieuu2+W9V++sMRxCo9VAUzXPb5rY86+yKEUEy1yopMZOJ/QRXy7b5wQdq1cJp2c7N+07+9Cxq+68pr/Wodxr5uiCrWtLGxCvNGGasMYwFn2olKxE3V0d0msL9GIKOEF1tSzevbP9zTPjXi3BD2II1ODyzYgHAJGlyTCPOpcwrVVU+FBJMIaJVEFKghAB5QJmCAsplJRVBCkoJ1iVBBQIyiyBjPdSVSDjMnf58fi6vHAIwyapK16jAICvG2vd0jT3rfUO91ZXvCmDc6EJE4AA8kDkjo29WUI8vBGX/rpNsCVWASkHQG3f969qpndONVIiXxZsryz9H8EO3vvR8TEfhILNEvqZX3nvVa9/7TX7Z/7g/iestcysIkPqm0EWJeIsDcRXVZjZTjfssVr2WLynEtLnAAE7cacWBACShBpZjH6I1Pd7k1OjoyPp6moJUgNqgTJDMtjOY9dxjPuZ3SMPnzz09KlWamayzuQMHVlCB4m11mviwRphoEMaeCKIGCqBTJVCCPBBAwE+ii7oeTNQLJHPkbgt5+e8lSABCg8uhdNvvHWXGzn0rTc1Sawpqxc7t3+548U8zaJ6Ps+VEOeklR0xR562D/0pPX0PBQ9j1djnrAqoKkNMvky9Wdi6H4hgiEggYIr6WXlABQ/AGrVORUSgtfyd1IqPBZKQZr2QQQIFSRvFqw6o+kI13HfPk2UejDGWRRFiL4wZlBCG9aiqqq7eN5M0fZnnCTkRNLJ2I+HAklcCx33rO7bomU5weUX5zrRoJ2V47ieasmZj6fDR5sT0ySePV7NrZCyNt4ylLYWf6OJL1TImDO9wpslkmYCaOVmV4rH5vsT4oP6Kd82Y79qxLa9cYDHG8IZxMSb6YZyRshlNbGpNQsYZtkwJkyNyhgzBEDlWR3CEqEPsWCw0JViASW3UImOQhGp1TaCtkWakiRdswYV3wWmQSwwReX+lYvJbfNSMa3zz1Lbv2Tn1jh3pvlbOvFqECiFBNQbfhFiCEDzBk4IGqspaKzSGQYArUrcuxVGLHamSqiFvfKDK92+ZyN64ozXlWFXlyvL+ICIRyfM8SRJLiZV0bMz8xV/e8/n7jv6Nf/g3544uLBw7eV5FZPOfGyKCaFn0rhrPUmNVe8xsQAZKLMbK4mp5dgmZsyZNTKNBUcCeKHR7o6NtQ3BqEiUWNM1FvRxm3HXXg4vnuol31+4WM4E5b30jy5ppKakXqyR16mY4XSTMniEUVX2CwEd6jk2KN/W/5ZpKoTTQ49w8zneu4wXAQvQlU+M/9rI797amO2VPLZ4XBO9FGC98BPCV7gZgRcNM09PPLD/0kcZ1VyXjr8HU/kGS4jLolDRQ9wyXy8qOgldyIKYQMbkq0KAofRQ7UmMMs0KYBEwASRgsggIJZ0kfKTwxgFDeeR23P9Evk+nHHz5y7uz81PREUXpWAsjXzg4NLwEgqWT7jsnde8dWiqWxsbESyDgZTdtLneIIyg6jUQFMIgmYctYZlVuzxrHO1hv2OlWBgpl78wvV6Tm+fu+jf3b3S7/vbavdpYZzFxOUuUgcAAY5poy5QZqb0AvaF61EA1RUmcigLiqQSsS1MIkvw3WZ/bszuys1bEVR+/5DAYILgoBYG1iPJwLUEI0nrqPkSUkh0IQYQWKzbYRfStDAkopRhZIKJGFSYSHyhBDIsam6XRFxmcNA1SS5DHe+1WoQUVEUZVkCjee9VuMWThImKZ1M033TrTNFcaifH+53lgO8MNRqMDbquCuIQ2x+Vo1Sd0QD0h0AUd0o5s0k0laLlgJL5Z4W3zia7kqaDUK3ElKQ1uDEyzxPQL33qtpMGkY1Ie33/M/+7G++7u+88aY92z7/uU8XS8s2adb44I2LJwpAk4WyhMCi+7ZZYs9KigISVwiZhl9YTuZW2RmWNOEsqbVYIVW/NzLeYAGrMMMCrYs8xyLS65Yf/9iXxkbGbc63HBA0ZFUbYpuNRqsSDQBTxALXabWoDOzI12FTEATRQDAau7Q3qZ6JoughdJh2qfot/eONcUAsJqsSEBQhIgyNid1eXy0D8OV1A7yYNYDUaeqezx8WzzxUHHtw+2vfXm6bEJNSEMjlptxU1aw8SxLUWDXJgH9DVKOqk6iSr5mHgzUVR+i4UuSix7oBcOKsRwohsA9VuPGq7Mbtet+8P3tm7rGHj379N20v8gosIGXZdAJcE09KmvHBfbs/cv/cVFSvY221RuzcwplO78xUut+owgiIVSL9+oFEEsGlL1VJGWSLsPTYk/u/6f86fP9DZ+57atvLDhS9NWf4oo0EF7EBAJi0ZahhTNuiFM1FuyGUEkMBBcQGNgoheNZSZY9z754Zq9TACRMP+MQ2fNcFvCUUST21pt03oNiN3Ei48kJMUtuImiFPgKBqia1qoGBIDTSDxnKoA3klYUiouksryjQ2MSZQL0iYEvMcOTQCjU+MEGm/V3Y7OU2N12f7fJ9oJQgEQJPM/kZ7T9a4ZaQooefK6nRencqrbkAISRA2zGxisEhQFt2UwFcVBSpUtk6NiECvb/OBlp1JzAilnrBWBh7I0VzBGaqG4FW10WgwtOh3J8fbv/pLH+wa83Xf9Y7OanXogcfKvHIZq2whXVtjbIiCCEtxcHcKCVCrKqAAeEBE0vlF28kNM2uWwQ0rKyp5MToxahlODYGcUvMiBiBN0y89ePj+h56cSMZHwtJtBw0IPWlVVZqCgpCqmCh7IfU2HWeeKVaUVFXhBUIQD43cWrRxHuArkR6Y2QMQuaw+yo0TIl8jrn89XjQDcKVl8ggzMMQLx59MQj7xpu/oWJ95iJRXNOHkc156Wo0FiXJKKiqBYALUwghYoF5FYqc/I2oQEvEAgFFjAwJM21IgLsEE4kpbafi6m/m+T0qVV5/99H1v+caXiQgrD2ic14szEbAf2YVuvHbPh+46UkIcQZQxOsJq53vF4cC3pH41xBpYnCp+RRpGiJcuPbEEJnbG9A4fqdY62976msf+5O43H9iXOKeX7AtgGKV1/442dHsyKQPWUKZoK4+LqSB50CJIRRQMBUYW0KxgA71lsnXbtkYZhIlxvhN68dBwkBGOJU0CKdSCyWgAOSWIRAYHUoaIEglrApYQhFhVA4ljhEACtVAh6nU6/eVV4+zk5PhQHDS5jChxamrMgPr9otvtX8niutRNGYQ34tTsSltQ7EsgbXjV5aqa8/mZopotyq6abtC1ECrhxGhiWIUHmrFIGQkkYzOT8vbU7HBm0qapJqHyHfGeAhMNUytXcHqqImKMcc5pkKzVePrwud/4Px/6gX/zT61Jyl51/PEj7BoEhAuTYmqZmdkKQBIarrhuBhoKRYgLSIUBZmtPnqN+SZkTdjauf0BUSMpiasdUrPOwgVE07AWkFRpxtPiTD34mLyQ3vZtvXblqt0OhK2Xa71PaKNSpoiJIzalAgEpE/RHHzK2KSGQD1RCLwHU1ckAfFBjqpcfMdXXwa3lcDhDoxTEAoqRC9grJamJdLh3f3m6PVqrWkweUhJ47AhqCicH9Be7PI0lUPAZwMWHigGGZsoILBFY18Eb9hlonU93Xz145qaVURFStEkRff4v91c8aydy9X3xq9vRCe3JUo5I4EzY9k3UCkhnXHNiteacMJZi9iBkZJddcktXTAhgCiVZkyApUifZbzUhEojm6KPwrSDBpVp0+s3LkxOgdNzZvvPapD3/m1u/+xn61VvOjAFsmiEk3pZLOm3yjBNTSi6oGBiL15AcWMpQ6cYQ3bm+ClM1z4IHP79PGQHGFa7C2AgqxjEwZVtiDpCa2EFASJ5EgzD6KiwgpxJEEMnkIDNPtrVXdvnNmfKItIiIgQ+4yNsbJ8RHDXObVWqc2AAwCXRmZ/vqlnd81K0FVwI7YQi3TjElmkNzYRF+Chy8llIIK0hdR1UrrE0iZEqYm2QwmYY5xgA8hD6WCYAw/F8zpYr9l5qryaZrGNW4S81P/z2/c+Nqbr3vtS/MQFs4snH32rLXuwpKI6ia8taruGOftE5WvCiIiicu+Rk4en60AdkxVZGNVBgIB4svx6ckQBEFgjAFlzFucOWFxeemjH/mrRqOBPH/Fa6U5YdDjwrgycFkUOqIkgWqu5wjXGtLA1T1rWhOyqIgQRfAv1XLL6gkgL9Aq/hXRuuEZ3ru4dll5ADN9IUncXpBxRUCgr0gRWC/jY4uy1MH0bTwuMUREEbJW28dcfezO2nr3F1ofCiawgoxSak99Qq2qVgAgFdW+VZ0IIq4XRz07BoyNlTfU3rBwDZkQgrKFITIazMtn/Fuu6QjsiWfnP/mJh1sjNlReFRsLAPUUqRLRykpnz56dY5mWvV4wVKjaRsrOBph7lrqLmWHLYogNyJI3NJOO3J5UpSoRSALVdSxVVV4nOCMAQiL9svfwIe0VY6+66TCKI196KknTni9h2BhDRFE3Y32WYrA8FN0l2eiGRXlHFmFRFnUKp0iJLatlTZScQJRuaLlxZyJiCCSE9ePSPWikIIgisIJVWOv3k8IAsSmPAQOyxIbYEEx8wTA0VKEnwzAkRKbZSFtnVsq1PGubHTt3iBdVdcTtzWnHoW++4Vpl5+5JUi2K4uSJWYFCNlYornicpxgch415F5UgIR6E0GSMsp226a4kvTppHEzbN2QjtzRGbs7aN6TNfTbbxekYbKJAkEJ8Id4D2BBp8UC6UrcaF30Yi7KRZvG+t5rJ+99392cff/BbfvgHlrpdB3P0gSdWlzsUJTMvHEygekqrbti32++yRS0YUE8xQ1lKe2quAgBnbGsEAETJcDm/4ixNTo2HykcLm0IzNjUTFcADlgXr0j98318dOTk7Ctq9vf+2m1CsrYC53wvdbn91rdfr9UCiEGgV6+cKYVISaTfYWUAkSAWAIKQ85MrdVASuSu6cqasTm7j468fE0PrirDcN4MLjiseXAxv6MvQWXxwUkKom6ZUFH6qq4s9fyhdd01tfF68cNotPDvDXqBdK3HJIYISYA9SXVUQIJxYcgdrxS4VqnXkFiYLEw0CibEvtX3z7LUWCUgkf+MDdvb5mjeg3MW9waupLIAEwPjl2YO/2lYX5kNgcimajMdEWmCP9crliY4w1BCJLVi2D8JqRVKpSayjORR9pRmA1vYeeqqq8q376G1957P4n/JHZ8dFxnxdBAGJZd05rJZ+NJO/DgvGlNz6uFZdABEe4uZ2lBhpT/1c+ohmoP3mgVENEg2/ZNLjuwY216AEdjQpQ444Wjp/uLq1s2zk9sX0yhADlhuX0IhikjWP3rqlWI62K8sjRMxsTd8/bBmBgBuLBz2uL2LK3kQazNLxfdPEL3PKmFEXZzBpukJRfmCt/9ld/860/8D0je2fyypsgRx54jMRs/ZlMzByQelgiqgr/+msTCLGsP91Rprkoq9OzCjJqYEZaHkoBbJxfWtkxNTkx3g4hGEMU/JhBkyUSZIJEYs8P08Jc9b9/92ONpl3q9t/5hrB9UhkCw6INAURT8QEAw5NGYJUQvNFAwWfcS6nQ2K2oyhFIEPt7VIdzCAAa/aqLJkvrloH1PoMXbgt9MaCjXyNo1YuP5/RugOiDWAD29McQt/AaFaCgEP+rJEQBJqhQhEMoseWaSwqiJLGHcHBEgR5hkihVWhuAN91i7tjeswiPP/n0h97/+ZGxBkTZaNBgtio/Nhruxhuv6S0vK7hk1iRNpycNN2ZLOl0GIjLGlODAMGQD9KXtZIZ9JSQ1w+1Wl0tEpGRc/6kT+ZmzAqGxRustt33hk/dOLYWJrOW99yAyZkvPYaOUEmK74+V1Ku5JeVdihxHoZVbDNn7doMF1E4Nj/IlhtgzD8TUMwTIswxA5ovrnEI6RAZQlnHv2JERmds80RpqRsSFjfm58nurOXVPT28bLsjp86GT48vb9r8IY3il7yRO92O7faDSYmVQModGwv/DL79Hp1mu+4+3La/2s0egvrhx+8CmbNchgoEcPDHunYZibYPWmCCG0d2YHZ4wPOqDPWucR6fZwekEJEEPcasbufWWqljs7tk+2R5vwgUkp+LbjBCQM4ZIUCuqHip358PvuPvLUMw7JVdtX3/5qRV73B8RqXUDivSdVUmEEkEICqUArhDIzheWKEWDiFMn6nEgYPNQCqMqWcqEbmu+IFDYQx+O8XZu/zHzQV90GfKW+79JZIMOw/NyO2AsxZAiaNnMP2MVHgXVs9boZgIKCGmFmgaqXWIp0RrnmUQjxqoZpRGhsRorGYD34Gx+Rv/0ydqE7kuF//c6Hj51YGGk1C19BaUjWtvH8bILb7jjQW5iFqDpbEGUz46nN5rw83feJMyDDzMJEBoGxJ+XbmhzUkLEbW9VjOn5oDoMSaRX6/ereQw1nabWf7Nme37DnY3/0kQnbGLcJVEUpMhFEWtr4ORtP7zxLcLHBA9Dzje2sbSG1GOULMFhhoEwas0BEGrNABhQzA3UQMHzBDMAYo+Kp9HNHjsP7vfuvSrJGEcQwGua5T0wEu3dN79o5nSXuyKFT3X5OG2gY/hoag03d3QP3ny4Z6MRFEnf/GpTF1Giln/3cM+//xCf+9o//Q++4LMuGS44//vTSubkkSQba5cMDRMTsYNhYtqEoms1de92e0QssrCiYFlfs/Jq3FkhTZFmEk1ol7Xevvma3NUAgAzKMEWMstOTKq4dacMWWjhxd+O+/9T5rWmtr/rveUO3d5oveem5WCQoTQhgIgwtrVAXwpIIgqfGJiQS3HIGhg56Y4YcMYKDkkU1pvUtcOHEWarUmMYIO2uEH6evnyHNe1nh+z87zzQK9mBFATLWvFPKBh5c+8PBSr7pkBy/M8IhZxXgMEwLn/8GmeWQo27n7opgXKABaW4KBGSBSwAupqsZ0gYAMgyWQKuP8O6uqpOJUSGi47Ypq3i/fdmdy584OysbJoyd//T/8MVlniRWb8onD12trft+Bq8dbpre6wllSAjTearbbFewTXQHZQAzDzAwmEI05c1s7ceStCRuv/fwaAxExYGzv3ieT0ls2ea8/defNpxvmgQ9/eqY1MmIMSQisRGrofHgor3/Ope6gobohS4BRgwMNaxhDOYEXaq9UApMShIkMaawoMDNDBxULNdBoGCwxBWmkydqZcyun51ujzf0Hr9UgeYAlbtrLimbSxN16+/6gOHFy7tDTJ4ZcU1tm878640LDbDZQEF96u9/yklWRZVlszQMTG7vYCT/zK//tde9828zNB/u9TsImYzz+V/dXfQ+zxScQkTUJkSFStpxcvWd7q79nnGsk0sbvYnr2nO9L4lhCZoMhFgWr5KX2O/uu36sUYlEkJTQiEkBIxYmI+jyR5q/8zO8fPnNGddvNV/V+8K0iJRLjOTob5BE5+TRIQF1yim10QTQIVBIKUepXIyErMLBnsW4utdYTCRqjGN0gCjZE2dO6KwmAukd17lM69ymUpVKq8OC6CK8aqam+jPFl+08bOhWe451fQQNwiSAgZgmKAABzneojTyx/7KnV+W7VSC5LXG1jIvgyzoMBmPn77NKjANbd/3iO69FA5GxWD6oi6l7JcBRypBgkbhxCYFILFREVqg81FJL2uP+BVzeycnGiPfnHH/z4e997V7vZJiXv/YUQ+G7e3zGzfd++qZX5eXZJUJis0Zgec5Yf74auoO6eNaxEJRGRefV4NsY+lnAveeXCjLVnns2PnkLLFVJVq9193/D6L5049sRn7rmqMTIaQoOIv7y1GhPTQXXa8lhiLqf+f0UjuvnDf9cLAKSGYEgNqSFiApNGOxF8mTbTs08d6cwvTU5PXnvTgarwpVxuBACAgNteesA5u7rSuefep4Yi6n8dIN60uTI/KNlHpEHkaNJLPEUR46AKY0zEAsSfG0f/9bf/aN7iDd/9nWvdjjEmAXrzK4ceeMylLXCMdDc5MUwJmxRM3vvG9ddmI42rk14roZi+p/U6nQI4fo76YoiE2w1xDEAtirUuQnX19VcFKRmGgMwlTrWS4EJKQmXVSbOR97/3rg9+8ONZe6Tff/YffFt3vOWqKhANAk0qYvdvHZ0HqKw/q6QBoiyVYQa4CDWiGqgzVBtuqkBUJ2e0tWMDD5wM3x9fUOe4eeLfm8f+jTv6Hnf0PXj0J7D0RWiQIc7wBVkkz8MGPK8g4CsbAWgssG4+oBHoR5klAHvGku+8Y+qfft3M3nHXr7VGL7i0oUFjPe94rumoL9Ad/3MAG2v3G2wABrGbj1QQIrWgohvg4mPAqKokSrHgi8CqFgOhr3q1wZDrr1Tf/Mr2N9/wbF50JtvN//gffvfuu54cHWn6C2gcFFDVVsrX33R1f21ZRCwbUnLbxy27U1U4W2JIn6AEQ1qo3tZqHUy05/15TtlmLFBkzNGy21174CmyxhibV9USh8l3vOnPP/n52aePXzc6NaGUKUjr2PlKV0NQij0TAKYSWKYgz2dFXaIMgMETZerGe2XAsTHY5ATE/7ICypZYiurYQ4/7wu+94cD2malQVgASptRcVnVaVW+9ff+27WNl6T9714Pe+79umZ/zbP/lZ1MjdG64+w/H/Y+e+d9/+pHv/PEfKxMOUJIw2mydPnL07NGTSdbYovuXyJo08iXItol0/zWUL966jQcA/8E7B6+Pn5UQKjHKrQaRQoiYu4vL23ZNTM9MFP3cMgA0LBkmr6qeAUkaY48+dubnfuF/taZGw1rnnW/p/M1XVyg8wUcdFSWAqgHNa6jRWrGKG3OhUGjQ4JkhMFVlnmOZT1+laRsStqoVMZTMs3/Aq08aVPHIZM6c/gBXaywaBru2+TK0uDfcqq+GDXgRUkBKm66t4fibbhi7aaZ5CQZtFRIRIrO2Wnzyow/OnVs17FToUimgDcPM32Pyc9HfH9zW4QnUHgFBFUEBLwN6RsBGJHMtJbZpQbB6CwWZsAG8GtSLVo4Mm/APvnl6Gx0pcibp/eRP/OrnH3x6enKkqqqNreRCIANrcdOt+6tux3sPa5Q4nRprsD1b+uNFmViObEIMUiEJOuKSl7WMBqlDbd26GhzJ2yzT6hcel7xMXJOzrB8q3jY29e3f8H8+9KfF2eWrstEp4+TL6CavtLYcI8/VYfu8BxGBDJOyrmeBmJQRqYGYavQnExETOed6y6vPPvaUtfbgHS9ptjJfVRZoMNnLey5V6br9u/cf2BOC3HvvU88eO4vnTdj7gg6+VI50Czu64YoGPgpg2RhjdHMR7l/+2//8ird9Q3v/3l6vF4k5UqYHv3hfKEGOQwjnnwgnYkwgCPP4zdf2EUhWDkwyxJ/vlTER0YnZyhnLzqLdDOpJAcP9ztr0zMTE1Ij6ICQgajI5gq+E2AOm28WP/9NfO7m63Cur/dtW/9E7U3hX5bmN9M51BOA3XuPwdQ1rVkCURQxIwV42gYBJ614prSVuWCd3QnmjIliUgYuhLXef5dWnGEIqrMHAW/Rs9wiWH2e1G8Pf5xMHXLh9f+Vrwi9aDWCI349w6KoKl8I1kqhSmrpjR858+AOfeeC+p4kolhB0kILf/AeysSBj5+4d8C8OsF+x9K9KoaIQKFTxhgVFpRpUwAzAmlj7jU7NeolVVaGBID7GNOuzSYAXBAnVwV0jP/HWKemdmaCk7IV/8aP/+eGHjo5NjPhKYhljmCvvVf7WWw5OIeSdNbUMIB2bbG/bUeThkV5Qs94WyaTKAVrd0U5TLRWssZVPmQa+/+YgAMy2PHSqenSuyJyHJoJqpUNXTZibbvvt3/kASzVGdBBj48ZVPCyKxD4IxiCXqeDY01OzNugm8BUpNEjGNgbOdTX8y06X0yY+dmBD6u+8ey0kSjAghrHGJc3WsfseWX323NjMyMte99JOtydMRjGa1IHUcw5VtZa/+ZvvNAYry90//tNP16gVhK88yZdceHCsXQ3SlcQhVq2I9Lwi0Hm7/4WeATM7E/d+kyRWRJLM/twv/a5PzMu/++39vBu7P8iaM/3+6S88bmwqFOLiA5vBQRHSVmVm4rYDNrHUK3fq0tU7mtFPorpDUyBqrT23ZI/NIbUkqdWmFRERSQJkuXvTLfuSlEmZFYqywQAZApirsjI//MP/7+fv+atGQ21R/PS7cbBRIRTGGFaNeR6qpTrUCJyAByA9EmVRE1t6huQrMCKupifSDQCeDWvCVdukGgUnullKrYZWoARyEs8SGMISKLQZRZIfMRQDGxaCDAnpLn8wgQhRAfWrOF7MIvB5PVyX9rDYSFmWN96890f+4be//M4bRP0A0HmxqGewaa4+YxcfxWYmRRokc6CDFaMg0aDwCi8Sn6qEY9umXnh6RoOF+uhknNdrQ1UphZbhu187/n2vKo4tnR23WJhd/NEf/qWH7z88Mtrq94ug4iWEoADWuvmOmfFrr5tZPjfPmQ1KlLR594yHPrrWFzALIi2Flbr/8NqGuyZzQcXwhljmgg5AJSI2kpfd+x/iKtTSZkSquu0NNy5ds+v3fuMP2mlLuL9DzHZusFELgQ57FjaF81veIIqtcQpLTPwVzihe5NHYAIE3LGrZHP7s/eXS2k2vvGH3vumi7JeWGTTmDF22Y0bK3/jWV2zfPgrQhz541+z8inEWwFceE8oDstUtiq5bXvv65Q/etg7hXddrHA54Q8pkFL1emTaTj3z8sQ98+u43/9QPy4D+WkJwabJ04szZJ55NWjW+/rwzEaYykfH9V3WmWoYF3eqGJN89WoL1/Ka/1D674M8usSFQ6qTBJALxoV9xp3fT7deHyqfGqepEyzWJ8zIkzWSlY/7uD/7rT3zs8zum9uTL9C//Tu/rbvJFl1SVJGhQDkpaaRASy0KJwAQ1gpihhapG3reYrYUyM8BBDEJAtB1KKkT1EZO/wJN/Ikc+PBCmXy8YDFi4PSi6kgohhQ1chVChtZ2dfjkNWRu+6Ks6XuQ+gMtgcRi8EybSlRy8Yd/ExEjwymT1MuysnX9wWPHn4QOjHLd+EqLhA6cUBJXC126UJqb+q5jnGXbeQhQaSCVcIDAbHyGDUKDoF6s//W3j33Hr8on5M6PNVmep+2Pv/qW7P/3QtpkxZaLEKjio816yhnvFqw70F5alUiGjNsjVu5rt1uNLnSUfLDFEoexZmG3fy9VpekvT9cUnG4pU6wU9Wm/DUSZNqPPFB2W5S2Q0xA44ma+6u972qkfS5of/+wd2Tox77u8IPIU0ZesGzDNKIGUNAnmOfTPWYPH8eiCfa8R4q64eRVmoTUsIpGBhhgHIufTEo08d+uKDWbPxqje/2qa29BoUCdNoYsJlP6Eisveqba973UtEwuFD5z78x5+uVIYtr1/RMbiPF2lmjF1vV5hiqCvnzLFjwggYkmXu+PHuv/r5//ymH/q/RnZsr/JCvRJzqLxL0kOfvqcoCrZmU1tvJAWxSZ9l5OC+ZHq8Pqle96ZpuDTfDJmHgmH46Fld8jYlodaIpmxL4tTkc8s7p9vXHtijlSfl1IaRiqiQRsMePn7ue77/n/zlxz+XTbQXT5X/6J29v/e6QucNskDkhlAc1RjQGfbCgrj7Q2MLsHLs1oxFO1Y2BKYqQEPs6alb1GOdWD0QgABeOYdD76v6C4abm24BFSCP1jVh8vWqDdFMNVWxVU+DGZOxOy+Dp/2rOi4TCPQiG4DFxcXLtwFXOgP1Fa48MfyRxFSGEv4/6v47zq6rOhvHn7X2PuWW6dJIGnXJsty7cQEXbGN6J/QQCBBCSAGSF0KSN4UkJN+EN2/amwKEJCQhJEDoBuMY27jh3m25SbK6NKOpt51z9l7r98c+986o4k5+m/vhMxrfufecfXZZe62nCJWRQo/Y5aFCTtkpvJRSuqlVAF4VUH+gkhpDDCFCTioK33uhuwcwuch0EpN//i1rf+qsHTMTM321anO2/Ylf+eu/+rOv2tjAmtlOB1SWMS665GTrW539czmpUqc2Mtg/MrC3nT/UEjUxK0AO7AEUKimbU2oVo060EDoIfdxdrXurdpq2t2/v3LvJJCmREUPwWskx2+yMveWi709OfPOz/7Wqf1CjfIwGBhDHzAYePTEp/vHQGSLKn0MJcKBLxD1cuo8jWEsGgBFEcXzzN6+c2jO5/pSNZ5x9RjNzUCtOh1ITPzkI0MKbeuObLyUuSPv+/u++NL63fdB/fa5u83AnrUPJw909QAAxXTwb4YBjce+jAqOQrFFjrRJDC8ZcS37l4388fMq6Yy+5oDkx5QshIhWJkjhrZ5tvvY+TVETCETcMJw2cdsODa1aZxaMtkbhQ8abSmT52VEULCLqjUQF4EASbdnrPxhjj6xVwrMayMa2pvcduXDa2fKkrQKJ9xvbFcb0WX/3fd/3UG377ph9tHhpalk003vr2+z7x+nbRIiXH4ouFdhRCJevY03zdtYfaCD6hgdIJNcRQFs86n+kEwOSCFBBDCMYqV5LZLdh1y4EnPSaJABYu9Nh36OhxahtimmLasrhCx71XzIgWnWf25OWgxPXz036SG8DevXuvvPLKJ/vuXsLnoNdR78tM3G7a491fhuDXzJ/spMv+6EYEouRCDQAANLFHPNaRApAKdUw3D9vNT0upaSOehEQc0czf/dTK1529c2LXPpvUjad//KP/ev97f/uRh58YGq6RaZKR6am5dccsO2nj0pm9k2mtmndsVE0HN67e793Nc22NYgPjNTISG+GwDJ5ZjQdJMh8k7UQJ5XFGlYhslBB1MRii8GjefBd7aJKoQBmeVEUaPj/xZ99w5WNb/+Pz3xgbGGrJTD9oNIpjG1ympIe1t2qOsuRFhFl3NKnR564tKAxwXKtsefjRu//7RhPFL3z1xQOLlrTbHhqlXpfV7VONmiF08cVnXXrpuWz8tq3tP/2TzxEjzx262bbnhcl48M1iwWZArAsTPodeT/n+Lv2wREwpMu9sbD/16S9ubk6+9lc/1OxkJorBpAJysGll5/2P7bxnk6lGzYQ0jgEJ52Y28C6Lli9Lli4pHLEnQyQFhtE4dgl7DZU5AUpEvofmBR7fpWxcYYwO1B24UbRUXD47efZ5J0QUJdbXYz9crbms85t//k8/887f3b5nR60eNSbm3v/W8b989RIzl1olsBh1RntAwaDKZaCGQwDn0AvD1JcRfeCNGCpTQKoEz9QjEvkei5NL8oFqBWS3XVf4haq7AiqCUQU08es+7E78PXfSb7lTfpPXf1qrFyurp6cITz/gOQUigp+nIzztbNJT/MOf5AawZMmSl770pc/Vp6sF2O67YwGSt7QugQh1I5qA7qcwgJRF2YmEhI8hjWy3CtorAyxAfQLo46bpcYkPeSm8aAFygPur1y5990X7mhOPOiS1scVbfrTjQ+/8/T/71L/s3Dlj00paT2HseWcdN/HIzk4jz2uDhQyk607hgcU37Z+ZdYW1pDCkhkEWlCnWpva41OTzatiloXmw5OHaIBkDQAleClPra927qdg5zlFc1kuJlJSdznq/7v0/9f1b7v32335t1cgAs6SgFSZZZCIxSqyJqlo4c7SBRUT7Ow7PWet1+GEy46IiEIGCCsW3/uE/mvvnlh636kUvvbDZ6oCsqh+EH4yfVMLwoC9NI/tLH3mHTRrDg8u/+KVvf+Ob16WVxHtlZu/9878BPJlW6pYzh5zPQgs2EmWPXKRSr/zjv1z9pSu/8Y7f+TiSSJ1Xw0wGgIiwMU/cdFe70ZY4sbU+iisliZ3VtxvJilXJqvUSxbHnCKpE0s5XVdvL+gojUeDM9/ixDJpq4ZHdGhtXRJoYRJmvWmsahVV/4pkbUaBm+ut24Lpr7nzXu3/7b//wu3Glz/Cwzma/+f4df/ySIZ2udPVayok8T7sRC7GklkoAaMnSn+fDd0vRpMFUh8SHvL8pzxBaflr4eBGFFwjFE4/KzOMH9qsBDMrDg5HKSZqeqfELfLJUjFeVZ+SCpQfKCik/b5oQP+EU0PDw8NHf8DR31O6tUacb/s/36QK1PlHMlxDD/k8CkoAiZj1QsJoP7C4mSJ1zo4d58N3PDDRjL1wQWp9+5frffJ3z2NnZj8G+0Rh69Vev/+h7/uBTn/j7W298NG/zJZecUs33T9xyt9u3z23fJxmGBkYenm2Oe48EjnIlHz68UBmJzDn1KGCegfmdPygmm4ERjksrK/EgwzLbaN58V3DyFYIwMYhVRSTvr532a+/72i13/uvffnnxSF20sNAlHI2ZyAJixAS966P1NU1kfnuzeNZHiGrADEIouMSwAKrzYB4hGBs5QXWwfs3Xv/PAtTdXotq5L79wZPXiRtZhhTXFiv4ojozgKefNvZPzz97wM+9+zcTkE5XK4l//2P+5557tUWzz3BGR956f47r3k2897bz53xy0+hOpaqeT16vxDT985P/7y79/3Uc/OLBmbHJ2LsCjmQKQ1uSt7PEb74zrVY4sp4s0cywKEpUsXrmyctwJ3W9xVjVRimZmTluUVSrdClM366yqNuLH98jEjNqKekOYnvVbdvtte3bdct+Ja47dsHHjrt3jV37vhx/5hd/51Xd/6q7bn0gX2eacWzr68P/72NaPXLy4yCzFrVB0LVlu0kttE8DwJpBG9AiNxKoag2BZaYKAODQ4XHDXsKw8ELCyFuTbhWlM2fZs6dgMLFiabfl+EuFMTFN5BgD7wWfE/2JimxKlcFYLg+fxLP18+wGEo3rQ9qSu1Bd0fv0SghUWlL/pGbA81aZgM7PFtPcqWKVUZMaCKB4lPkxKrIuClX2gc2mZ7gxGIwGBcwiJiwEkJqeDHtfCI5iyiAv6YyRWi8kPn7J4w8i+//OjG+7bclxdlw0sjhpT4zddcc+N37/zlDPW/9wvX/SSi1d/+8u30o7Nzpg2qK8zUye6qyMbKokheBKrZBQRrCou7o+/uJ/2wld6AHcySg5MplbNbQQAohQZnxVsormbbosuPxcxKavtqoFGgG9n24ftkt/4mW/9/uc6bf+OD792fLoJqyNRVFFMubxgdr0Ua7Cr6sFLyseqjUIemeuMVerBVe1pbNkLY/yjQcKUARBIuhWXwhVprfbAPZu+9Q//MRz11VaMvuxNr5iY2udNEneKRYNm+aJBkac6qwRBrUT8Rz7ygfsfePSWGyfajeTnP/CbX/7K342NVYu8Y4xxzgVA5E+WJdBlwwUTypLc7QkkGlZ1IQ1OKX1DtXse2POLv/Z7L3rTq0685EX7p6eTKDIKkdLzLKqm4w8+Nvn4dltNkcYS15AF/LQzA32V404AWEXYoSCNDFccfLN98hJAxXsfxNZUJVyTsXhir0w2ddGSPlGfbZto+KxKnLb87PjMr/36Jx65fffMzsLkiONqRDwzPXPOedv/z+vt8fVjO7MzxhBIPZRVehznEqoEZc9QqOAoIAVVNfMQid5q7rW8XUbAPBtW9eQUkXF21LT32TwrqOduy/Pzv+sQoESAIWFoDGo/1WBatbQUiOvVzuSM29XivsQMVWzNFlmL9dmsBBzFGYaDFtiTfy1UxDxUhero854WUq+53X0YB3yCMBFMROwjhfUE//T6wpoqz271Uu4fBIEqOZR+Sd3amHgqi0ZgFc58bcaQKoNJYWxwpuoWZ3pbkap6oX7B0rhVcLZQ9b4Hy1Mmj5KQSA7qCu+yPJ++dCT+1gWnfOSy3fHSTfu3zcQ2rVbqdTO86c7xj/3ylzbd81itVqFWnswlfU21+cAcbdg+2fKUJDZNUiKyCkOAihxn+05IdWzdSmuda8biKiJQD2YmY2ojo7En8pJEtnbKBs+usW2Xue+xqJL2OEFd9qzU25JE6bGf/IXv3X3v//v0l4eH+gxzp8jqcbQkrQ1EcQqNSZlEVQ4yBgnISB/xbbPtO6daRp/ygngIpZkAFiUf0nFCouRBCnilADN0IGEqjI1yjm2yvTX3r3/418n+bFo7F7/t0sHhIZf1Vzp+6SCftXgweVqmHWHJ8N4P9umffPrjYyvU2v7HNo9/4Oc+1s6LAI8JbyjzHodrT+NLD9tw4BQLAnxBPZtJmcgwiDUoIvig9tBtToWZm0VmU/vEns7bPvjrS8456YKfftNMq22tJeWgLBtcIS2bh6/+UaeVcZyY1SeZRrPIWmDigb7+U8+KohjqUcowiBpbNNvLkr3HLCuC5wrR/MasYlwkN22JbCVxDqREohW1DkQp79iy/fb/2trY3ui3Ra3qpztFJ971G2+d+Mo7l55Y62easYSQ26EStVlGbiV/S0k8h6EoIpAg2FWuS2EOsoLhFmg7d4N9CfjDngzKPNyZnJhOU0Roeq+1Ft1q34HjNYgEWxILGECE3UFx6pOJgLxqQbWJf7t38n1f6nzw83Pv/Zvpj39p9rsPQxM1JJofumo/g4zI4dvzd4AlIiITzlwRR4yaqBPtiCyQNFBrxYKkY5FxtdBBh8rTvEjf4bktCh9M6ruUJSUVVVUBB/yvWvgIPhIlVTOb21yMkzDCg2eZYB5m002zaGDhZnWZi9zhOWgknjW4upMIw80vc0l9+jeOXf7dVyx5xyseKHjaZ7NtakcJZA/vfUKz2FIKSeeKxHdSzePi+oab8VM+6/hGKi4SF8GLSFG18YmViu2rrz77TF3iPU9K0SHHkJpvZB1rW1XDTL7TNnE9XbY4KqR53W1oOwUFMo6KeKiIeO9FRDyd8ps/f8/9j/7L736pv15JOOp4F5NWnVuURCOxHYyjvtjWIxNzT4FZgwlhxOpIH27lc87RU7QkxAGBP6N73ioP8Rrg2lAlATy0gCuQWzZxx0za9JZ26wt/+g+7N23t1Oza0zdc9OrLs0aeuk5Y/VPyTys/awEuo3sn61eOfu7zv71oxd5adcmNP7rnk7/zd8ZGYCUY74tDrdKf/yYihddcUKg60gJCXpRisE2SuN3uVE1lx0T2off+RmXVkjf8xkdmxHXHqwrUGCMizNSZbTx+zW3MnI4uidac7qf3wXV4cLB68llI0xACkmEYzyQg32y2Vw3p0n7RXkJMWRWsrIimG+l9W3wSeVKIiIcHeaMuIqlEdjCO6iZttdCUmUvOe+R7H218/IJBm3c61HQlDoPJB3+gMlkPZRUTJDmD/C2Xt+9KxGfguiiTMsMocmgBlZDuFyUNBfzy3MCktiwOgwkg9SQKijCzI3AOfjws50g4kaNHw0RSs52/urr1qSuwY1pEqA1/0+bWb/xn6x+uJ9NneEifPGz56bbnbwMoVxwlEBWGi7gqaUQJm4h7yRkR8SJtzq2pFF/fWjywhVPvhJ1/Eo/hwM5FPoO5rYEfW+IyQ+AvSoqQ2w/jCSASViXxpl1EmSAs6cQSRwu0o0u9rWBI7oUzMFWoA+4cFsJVfimDigjellaH6onUm6xD+1dV9/3qqetqtqHGSVZk2dzA0v2o7tV2e242bs9W06apORpVesj5O+cKJTMnjTmZaaORizqXVCL7kmo/7Zvw6fJlp102tPG0ZNWojIob6kgli+K4YvpZvDYLMzg0cNkFJjGtTY9lD2yx1qocJmIlRqNmN/zOh66LdnkWAACAAElEQVTds+0fP/FP1VpSs0mz06mmaY1t1di6NQORHYyjxWm8NE2WV5IlaTIc2/7I1qxZFEcN0Xsanc7TWg0PSgFpeXzyALwEtRcKKh0GJsLgeE7XyNSVNH7lf37t4e/eWBlZxC1+xdtfWa1XUjd90ogJq//TGq29pIFYNsw2b7dPPmHsM//wG8NLx2uVtV/4l+9+4xs32CjNZdba9HmYRwtXk4WQnjBrcvGZUC4otyJRBlFkAXEGzUanUqlMebz3Pb/xhJt7x+9+LIO47qkoTAfvPVuTDNYfu/aW6S27TSUZPO1ULgo/vdf296ennKp9fb4oxHmKCD5XLwbEmWtP5SevQByzBwHsCZ4oaOXHqX1kZ7R9QquRiS3y3Oa5BSA+yTvSbGTTc7Mz9cnzL9z5mQ+1v/Cm/jOGEu8cIjU+YT2MzVa44XIWizLAnsIeoCIcRJ4DCk9LhQeoh8qCQwAtyOxDRFUYAg0rgCqUhRjqaWo7itaRB+uTUxU86h6Q37G9+dVbkj5wTBBlJ7Ya29R2Pndbces26rPxcy9B9XyWsFispYrNphtTNzzc+OFe14ypqLKPTVe9gMgYZ9G3OH9g8+SffaF5zf02tmwKY36chNOhX9bYimIGCLhgDkYRWkoDaiABcln9D5hiqGrHRwVRBmFSQ1ot2X0lpIcXxBgrB7MThhp12wxqI4fF8Cq8MtRZdZEKh1WRIYzM+hbb1p72bKNRF60aE6HQ37to4G9fk7zhrPHjT3xw7dj9IyO3Rn135uaRhsH3JnJjKwmnkSYREsMCyrTI1tTSvmJqrvCWo75lG0fXnLti7UVLl581MLQ6WTRiF/eFGgY6fvCi86Kli3RirnnTnezLffGgJiLczGdiv+G3f+761tRf/uJfiRbD/YNZUbjuadkQADWlqrYQETOYYRlKcMAjrWJrJwtv/rF110NSJeEcHyDkgX0vTksESE9ZzKnc1J64cmbPdjHFfZPbvnRjra9/bnpi42vOOOPFF7Yb48etrJ0w0Jfw066m9R4lExnAJalRR2eedP4f/9HvwuwCKn/4qb/btXs6iusgMhw957qKCzqqJ0chUC/oeGReg1tesGazDIY4553NOnNZnCYTs533/Mzvb88m3/XXf1DU42anSaJEB0wrY4xr5w9/94fG++rYkqFTT8ZjD0pnNlm7husDPusUpcyDEQaxTSgqZv0gsuOWihev5JwUXqHEICNKFEU3PYTJhlSjCtvJ44/ZsmzJzkplqlrbvXxs/LRT9r37p7d9/+daX33N2KuX1FJFnqto00qw2SA90ku7gv8LiQ7iQz5TVUkIerArEXXlfHudSaJB5UV6TNAuh4A4wtw+zO1TWwsOw0+7HWUPaN/wKOe5Wta2JxcJJUwxDKvvZLduAjs1z3mN9pl+wVGN5w9SUhWO45lv3NP67A083aK53L71LP29l2CmkPlu8mDMfe6mHV+7oeJoaNUKyi1zVIhnPMWcQmMrJA+FmjKPQELaq9WLUeopuJKClJS5460j8ioOFEEqsQ/2jyULvOQfKqE4Y6i1Ot28LBt3UmEcplKtGshkJETqYbyyBqtcZUVO5GP4aQbAyspaeB3V5MxVq18xuDIT22i3GDObGtnPfH1/2h9dNTH5rqGhU2ggiz3IebQF0gGGTO24Ytf1WTOuVbwvnPG+HgHwcGCm4TGzdTMMZY9vsdVq5bTjW4/s7tz+gN81aZf2Oz0YuKmizJxm4lEc85Gfeejvvvbp9/6/D37qXX1jixt5y0aGQKreEAPeIKgDCSmH+pqDgFSUbp7KVemk/gpE5UDf8Cd5kuvOUFJVryrKuYiBqSjf28lvbM3MOC5gYiS3fPP7WWuOkqhvbOTl73yDtGdOHR3aaGv+WVBv7gIEgmU9Ioi/8IKzX/O6y77yHz/ctq35T//8lU/8+vsU7nkDU3SniSqh8Oo9ivldgahUCCcBiABfcDMd6cfuaXn3u/9gj5/44J//cR7HReYsWS2BkOUcUC82jsc3bd5x14OmaldddJ5NK61Nd5r+wXjxUngnIgZG2LCSIQuhuTnvWm5Ff3HsKDFMUwyph9eYyRBHxqixP3ywQ0QujxO3/6/fu3S0X3fPTpqIB2r9QzGnMuhotpAJlHAPgjfheHP4YdIlm5cu7geSwhkUSGIBskRKIAEx+fB8FnB6lEMaiDUwQzXkiEBGw97PETUmaGq7jp5AnTwsHc/kqR02Qyj7m5FEWYdSE6lCHYSdckcj7zZP+EKMPiuyokdrz98JwBjTuunx/FNXJ3vnarHpc8pb2jJpcqoIzV9GPrFv8zeuSLdNmWioubZaUOE1esqrP4DZx7XEPvvyTj0gjjSHOoRKQGBeiKqqEXiQR+RZQrqeWNJkoX1YSdAgCBENZhPH0jZLXgzE0AGq4l2/pEDBIhJ4oz5wPUq6ZuJN4uM5V7CGSpR6dXO+AZr0dncU71rUPzdYi85eMrRhUZT6uED6yc3b/2Xf/h815vZm8G4k8csqMpJy3zrUdf8MNIam5CIjlr1lF5MkJhm01Toz5zt25PvG6+edQfUYE9OtG+5ijg/ts15WgVSoKNb/yk/tP3P1n370b/Zu2ZvW6q25jkrPi5hxiCelAUXdEXXDVPuWqZYheJCXH7/oaxd/FR5MycdWhRpW64QHKHVC32vMfqcxs98h9yaKq7Pbdu++80Gq2I64Uy+/cM26JaeO9m2MaiWP+VkY3tIzlSMiUsQW73znG2o1E0d93/nOdXv2TimRf1YxG4dthhFZtoZUtXBo59IuXOZDubcM/KnUhwsMLCjioQGzZ1/xjrd/dA/NvevPPmkG+4/S/2TMoz/4UXtmLl4xeOwlL565/8H25C6zaIxq/d57NhHZiNj6whVN5xoZq4vibGSg0Z/mZFxa96bPpoN9tn9ghvo2TSZ//s3ivm063Gf3N7NqFcsWzfbZ6WOX8IYBLNEmF3s7OuF1ge5IeSXoAvoPeZWVANM9ChwgVFWO3gUGTSogX8I9CYD4LvgwNFZ4Ug/xqhTYJESGAKWIshb2PtRTSn+G7bDngNrKwVa7MERSkHiv0hYqtGBtR7x6CVg9Zc/1uHruIpeDe81a27rzIWo10qEqcm8TK+OTrZ/9kv3AebUXjiLAUYgqS5af9+8f+tGvfC52xXEnLvFZQWCCUX0KWkuRm0VnPGQTiBjiSrZWiJ2UgqrPQmXIMJgcWI0GGAOxr9rDf2MuarPtcJGjlFMHJ4c7BwkpwUGt8z6IllCQE3KAWmFoxDmoAHmohUZTrcQ7dV5iS2ryXG3F+JduxG9fv/3k+thD+f4HJrZG0+hjO2yjtWm8PBo4tn/AJTWe2FMsXQHLGkUIeCctwFZTjRYtzudmkOXZA1v6Lzt7/5oxc9djc9ffUrvkbDtcPfQQMN8h5Jut2bU/+6rdiwf/7Jf/4m2/9aZTLzy31ZgDAqy165KoeigCmohi5dun29OFv3C45kF08Dmg7PMDa7/lhPZQFVJFoSQCQ3aAzB2d1pWN2d25pBQZEBlEaTJ+zyOYa0oEs6R2+qXnHFOLNkbV5xRF7Qt/5mnHHn/8yrvv3rVly8w11976tre81LnM8nOlht3tLCviC/VZ4TMvPlSYQAvqAfPDmYA8p8WD5o7H9rzrPb9VW73ovX/wq1ky2Gi1InN4XHWUxK3p2QevuI6Zl190djQyuuuGG9WChkfFEwf7UMB3RHNHQgwyxrRacvbJlSjC3v3pzka0Z4of3Du+fTy//4n2E/uKVnNRrlEf82Rz34dfwQOxNBsFQCAlAyULsFU6dK0ghS6MCnstyM0qdSEdCu1K5ZKGzJiWKd9gkQoi09XvE12A2FYh5dIRjAEvgbzJAjAxqVeb8I7bpTGucfKsPMBDzwG1yzbu+6dbosyBYxJWqKjXQqxG6TkrKACbnmNswbOwARw1CxSaBFZKNKjtmrSdjxFrrLxjP7L99LV+unBpMGEJGFvRgZM+/BZQocTsyZOCfckr7LbyUNbF5B78fSJGfCkIBe1admqpARceR3dHAIkKVI1RgXIZoisxyJow1uYFMkmhgIWYqNP2s0wVct0sQUkaNihBR1wK2LBAHalSkG/pZaKc9ENJxaszRFBu5uolFynUw+XEhnwh7z1+xZWP3f/QrsHRpNZm5wueUt2r/r5GS3ynku4WLhh1Gl/JQ8OcpsqkUsB7IrVEZnSMtm/xRdF68NHaZWemp5/YfGhbsW1v597Hq5ecrq44Qo6SSREpT05OD7/qhZ2hyj/+zqdf9rNvu/wdb8jabVVPnsBkEOaNCs0fxoVgRBWImR9q5LNOLhqpjiZR4QEIKwlCEqnM9at28cRByEJJwQJRVVEfU7Xh6TvN2ZvajVx0gBOv5FUceevy6Ue2ChvvW4vWbtywbuVJadXLEVM/PVPf+YXyqc8uFRcn5tzzT73jzi2Gq3fctulNr7+8cM4k5hlnnLpfcTgaRdsXrbwovEfXJQ1dUGAIaRgEFe3miJYMpt/8wQO/8vFPrrr0pNd+7CONlovyLIoihUD9od9o4+SR7980+di2dLBv7cUXT27eOvPYE1G93wwtEmJynnxOzvlWR02V45TJag5p690Pz73/1olHdrbH59CZM5lvG2MSjtlGSWRI4+mGHLOi+dYLDJoVGGO1SSIMBG8uWsDLXNDJB6uZlv8MHgCqGsIOZQgbVem+s2fcVA4rFQaj6x1F0uX/k0CZtKxRdeMQAwipKFS9Kie07xG09iNZSVoc8TR5hCUIgUh04N5GRPM3RM4ct3Tk4+eP/8ZVQzISRVFRpDI3zbXJ+q+9oHLRmDaMkD3i2vosoc6e29wlAV3jTas0lxTVzng9Gos0d54SG9uoldnjhhEcc5XLiqXk6cpRAM6jyyshhck4EY6s5pFmpIZQWuEd+I1G4f3slqixl4L4l/guz6vbdRLOmSWfw5eUdbGFi0hmJGbxLD4iTQxBfPfJh4VbSQECeU7jlJwnJepmgEJaicogpVev8/XBtD2VmS6KAUoKhUg9pr6kmHJelPpSt77PGOdEBUoxWVFHKqkM/+UFx/3STY/d+8RYHXWOJbUh/x4JiTg2XFUS/9CPWkmq/YvTwRVJ3yKf9AuTY+FKLmwANDbv65+e6TvrxOx7N3Wm9jVuvbd6/kmwZVzem2ndcElDxoOJ8slZPmHtut//7S/9/l/veWj3az729noSe2eMDwQH7pmA9WKcsISRUpV5ItPv7W2ur5n1NRqKSDUhJQld3xUwLj2CNCCjhdW4CCTRkNAN4q4bb+xsuYSiiKigMhsYeKEz07NQyovqkvWrTxuNrKjwQhPXBQNDSz3fZ9KUYCLLwKrlKwhGwHv2TBbeFYV6nxtjYsPGGKbeSjwPDz28ac9Rp3EwvchF88JnrgiJRQ6dzN3lk6hUxic2xuR5nnAyUIv+4p+u/uTffu4F73jti97xxtZci8Eh4UlAV7kVVJoGkRKT6J3fvabTyte/4sw1J5xw9d98Neq068OjTdfkyaYTGyEi7Wc7QN77VkGTO6U1Y2f3X/Vgu1BmaxIjSeIrGhuyTc/tTjSbZ0k6ecyKmT95kx3zsdfcMlEpYS4mcDzLlffgxoEmdVD/lOeeMpIPwj4MUlo4gFUlKJMvXNxBypDSRKQcIRoOnYWIQCKBgoRYyjQRMWcWOx7UZSfY9pQ/7CqvQSdPwSpIJWtIZx/VV5KrIOpYDkNcDmA78TzkwU12hl7/Yk3c1Neu4M2WB3yytjr0qkv5BS/2TQG1QhD5zMbsj2nPzgZAh9Yqup5XrAyNwXNFUU9evybafmf7P2ZqvCxh2/Dj9vUji3/mRHcAke+AjvaqRKRC4Hp8173tzQ8Xw2PxBRcaansuQC6AeQ/8ZsNzm7GQd6YLF+igKayl/pIKAQJSFS/FqvqkaBFrZr2rGl+Pe0Ow3MzLERuEkrEQs977eg9lhe9mNMEkappaSjSHGjAIgEhfzEOJTBa+keOFY+7MMUviCcLeKlzwJYbZuqZ/0b9ffM4Xtm759vZdj+6qtFr1qsagnCKCURFmY7x625ih2als50NZmkhtgOqL6pV+09efRvVcWn7PTvfEPj7tGD5mhd60s3Hv/f3jU7x8sQZ1xPJyD4Gxlv8wumbZ+f/nN+/59D/s+sAfvel3P7h2wwptdJyqWjFEgBEIK5TJeAWRIHABKAKaHvfO+n0ZHVs3qxNNg5l3cNgj8ooieD0qdQSe2AoGhLc69++tzv37cwOtWcqlxPURSIkY2ul0ZmdnAXjS5WNLVtg0YxgBH26uKsFRd6zq/GngMO8s97DD2McrUBRFvZaMDA+oGgI1Gm2ARVk8cu8L9saINRybsAYZmueOHPAVZcL6kG8PWZ3gS+q8dpxve6eqHCL+8FEH7SVERJkUvsjTSj0tVD/8yc9+9sqr3/KxX9hw8Tn7Z2arNjYLHuZBX6eAicy+R7Y8ceu9VO8/5dWXUo5dN97GzHPDKxKfeKdSSF60TD4edRqaTflOp5N50pgkqiaVRHNFUTg4h0LFUafa545d03zhMZ1LVg2eOzpmPcNPCCkXAoq052yzkF57wB2VgfpBPUQAlL0qK0FIxcBZoyJKqo6AUtWRy5M6wKpe1fQoJCSgcJpXdsih3D0zwQgDDG4CIGZSwGW8/R495RXKBkeoY5GQjyIg1b2bces/0exWX+nTY1+fHHfekaxdwuMTIYL6ucbwq1/ed/bpsmeSK6ntGzH91Ux6qtqC57gK/ByjF9R6YmUHVGKv1dqq2i+9f9+yq/bffAdPFPVLj6m9+41FFId83RE/I0zCH/wg+9aXq+mwa12XoW0vvsRQ+6C80Hxrz3v40YGfQ+gNjjCewmLuoRDV85bs3Mj64MPC4tNI0qPKv5MCRIecxUpUBbSrPqyspA4+Lv8rhW9VaH+ERRV9eE5YzXCKiKAKViixkCg7uJTdMLg9EOOX1696/2rcvH/qe9NTd+7P945z1uxjikDeqIFPcjJF3Las5Ds6men+8RYxcWQQWxsX05PNB7bWzz++/+Kz2nfemzcbsz+6d/QtL2+2m9Zy76x2mHsEWNFpNH1/dMIffnDrP33rr97/v1/3q++67E0vzec8Oi3vCxOLkBWEnBu6szd8aHlY25PpVOHuj4r11XhlahbFhikgrxHDFIpMpQImrxlwdZ5dO9OebrqgagaimOcvUULGV7tCLhDOpEJcqIiASJk5nB29QqSUgQjiaFry+I+Y/+kqfWqQ0un9XgReBU4ATO+fcc5ZExubCgDlcKZxAifee18wh22gJ0FNh5vJ5pBEt4g40cxLxxWuyy87ihMkiOIoaTa4FsWVPrl3y55f//2/3dyYef//+WR13dLxZqMvrVJxNKttJzKYxDdf8d9uz9Qx559+8gUnP3zbA82te3xU4yZxY49k0yab0qzFYrwkYANYQlRyJUTb4MwjjttDw+0Na+TStfGZi3l9OjoYDQBNwayYOFCTeyzmAyS55mfN/KWVpisHPiRRIlUWKBTKXihSYir9f8M7QvlYUZamBF3PVlGUIl+hgCxgqJJReDDCH5GHMBFUiIiUY9r9MFpTXKkd0XYqMkTC2SSu+Zt4x6ao2i+ze/3Uv+Wja3R07CirBzMHTRw3M0eVmlnfD1EPeN95Ltb8IyXqnw/4GgtA4tgX7KkaD37gFfXXnOsm9ldWH8NJJKGgdVSYj+7e7a75dj2tEWZQTztf/5ofGcLJJzO3DrG8MxCPojn/tyWkoPw5DBUSVa8QEijEACAURKhFE/1JGscKSGwLYw83c7oZ6zLJUG4Avf/XcpWnBbkI5SRl31HulSNURSUiM5iId5RaHW9QEN31gBEYGPjIQ5WbKmnhYbHXsL54ePjSgeHGGrOD/Edv3PvgXqSGTJTNdvZkeRq3+wz3g1U5Iy6I4eDV56zw1s4+8PhIszlw4WmtL6+Y2Pxo54Z7i5depHVDpVyGHPbIGSZSxIYyneR87AOvjdcs+eqn/nXT9Y+88+Pv6e/vQ9FxWYdib4jIszMU+FqqKt0cnUAtUQ5t5n5P3kqZR2Ieje1IZPojTkgiMapUsG717trZxr1zuYXExhiGyIJdvBsDO++jatrfX58AA7LrsT1z6oeUYOAEcw3XaLhOLklE/f12oB4BUPjCuRyGSA0oAhmFgycyBx0IiKjdcfv2z+7cOzvTzNM4Wrqotmy0NtCfVpIYwJVX3OKd2ISHhoZ6/dTbQZ0AImEbMEwGaoyJLDNIusUomrd2Yag68SLoJnxcrn6h/ENvJPd+6CbuAJF2a65WS9TQ3//7D//mP7+19Jzjf/ptb5RK2nRFhY14d5RJToo0jsc377z3ypuR2DMuPXXpaN93br27k3e4Fif7HmI4q6RKnlJnrGWT+NiCnLpCYRk5tZeMZuev8S9bVT2pPjwSDxhyoNxhtvB7lQ0KgAtopCwlaUa7euy99f3gxYnBOYJNV9m3YRhR0H0j5RK879lADSgU/NBNELEGZ+8AJKPg/ae+K1YdDqDKIRNc4otUESIYKnO1sDFm92Jym646Ge6wS4FIltnqKN//Nd1+O1WraqfJjpismezZmo8uh/LRV/PgI1mazhKefz+A53gDCKc8kpDkp8ITwbc8Dw4kQwMCEu2KjHWLV0ei2CXTTd9fUa2RIHZJccvDOPVkPkKF5IBy/8LkYHcDgJdQnQ1iYkTEYA8Q5wyTGFVwGjljSzYqEMboj6l2k3I4bPakKgEArOxMykWnxFAyc3c/Nn2JAjDMhRMvBiIQcVAL1sDWpVREIIVHrCI5WmQy43Bc2rfCVu/RjpXk8lF+09iSa+f23drcv6Xhmw2bNyucJ6mkFqykLmpx5GTz49n+/bXj1w+/+PSJRza5rdtm73ukcslpaObdfetwFfUy20wQjTxnk27RpRcvWrv6gT/47Kfe/b/f8L/ec+YFp9SyuFO0oHkeOxWr4g24FBpCUPEsI7GIjAIO2Jtjb+4MvBCYqaIwoAmXP5xnAPcTgNiT6BHCXw+XWDN80vrdt9xXrfXdf+2df3X96RsqA5se3PvE45sf3zs+rtxp52kzGzF2sFp7wWnrzzhxzRmnrlk6WrUMQEWlCOBeIjYAxCvv2d+68ca7b7zujhsffXRvIVIdiAcWpWldgFqttqa65LyNfa1t27///ZtrA0ONRvOEE9ZUUzPTKYi0F9KGAROYUWEoErmIDTOZeXlOVRUAXkREnXZpSmQAYrLz6H6QqvaGdFj9uzxzUpV6X/8jT4z/3p//2+17dp333jdtPPvclmtTnlfAEVFXrPAw00pVvZdqXLvhv2+YfHz34OqxF736pfu3tx+/9e407oiSyZVsQmyIxHqLtingmslMlLaW9MmO8YGYq4Xjj2xc9JYTakK5M9OiuxwEgAF5EESICOqDlAeEQAsdFudH2fwkCskxNvM8DA1SDcG0lVgIRKqlGlLEyiXgp4QWcEAViJYpwx6HTkR9YIEy1IsEhid3kSFG1cOHIQEJpIq8xbs20ZozgcOfojiODHL/yMOcxRyPoNHQeuZnm2yNggn+KFXi3v0G+nJPFFoJz9s28NyfAEgQFhGhgNyi4K8dUulPGt+fM6ORpVXrZrWVOD4+TbRg36fUOPTNhiPM53wCXOzAAAqAqIcEmUSSLhZMCbaImUVQjzSJuKciefAFzwsELZS4OxymoVTq9wHtFTiKyh5CUB2IQylKAXScJgHJofBd4qKEy+udJxa02OROnZJ/ZI7PTjZemK5uDLl90ngg239fNvFAa3JLqzXdrE41I+RJ7Ae0Mdt6YOvQSev7zz/R/udgNpvlN91XP/cEPIn6KImChElIuTU5WV+54gV/8YlH//lLn/1ff3L/yy9+7S++ec1w/75mg4tCkcEmhZKIxCF1HWKbBbkyc2AviWhH0YI8lueRmqDzCCULIwpBQGYEUWgowasom1Y7Hzv/lPv/6zt+lnOd/fSv/HtaX4yxZrRuXXzWmTQ6QoZdq7Nr776tO3Zee/UPo3/+2gj47JNPPefCk88445gTN44NVckQtVr5lm3jt9/26NVX3/6jBx7cX5Xq2tGhF563Zu0JVKs4EpaiDZ1ute6Zat70XzfuveZ7ozX2kg/21y697KysU1Kv5vvqANmGUmisEH9oHy+sMcyTMA40dj+0UGzZdrICQLViHcef+Y8f/v1/fn/g9GNe98G3mMGhvc2JkaQWeRsRoHKkCFRVCWStzfbPPPSDGzsil73wlOM2rvrmV++d3LynYlPrIggXuRTcNlHu0mzJEt4wlJ450Hd2/8iNk/y3e1uevYrpiIOdbhdNQwawIb/ve5E+lbXnUtxhPohaOJ4XdE0o0PoURCBRIaC7HYqnQC8PwAMhgUYshoWUmObdO6jElinUBPIKiYg4Us/KqiQiivJ/VG4wZSUzXK0hduLIWJrefShuqtci0yKf4KRzioduiKYabHM/U9DyZX7NiV0VYtCP3QNCGbzk8Mlz7zu9YCw9b9909HZY6Fuv0bJl7XPWDt60RWc7raUZv/W11eNexB6g9mE32CDjh57484Jv6bFKAoZdtVQvDnBgViYUsVqI1qwm1kgnL/EcIkQ/JlV19FtkayBKAUkUslKqi2vde1SIZ88og8N5jvsBa0SXG8gAllTIC2KmJ+b0cd59bKXP57ROquuioVdXjsGQn3TNcc7va+16qN35wta5VkPbdz5CL31hZd3KodNP3HH1rcW9m/Kte5LVYwuwFYe7dBIBFMKehTRNo3aj6WqVNR96e/2EdTd/9tsPX3/n5b/2tksvu4CdbxazIBgIE3JRIorCFS/oukPT723BI3knQiQqgY0PQIQy9Zlq5rQjIl1sEpEyQaQ1MLZs/SsuePCfr67XEp15LFo1uvgXP2KG+52VwjUJmhgby7EmL/zUTL5j1/SdD1y3act3/vRHddDQYN+iwT6RotGZnZydnItssvGYkbe9+qT1J6R9I5nJFS1lKTTyRZLD1euV4UUjT1x7e6Xqq9XK7t3t973vwtNOXtloFJaNV7dwAHvtLuJPUbtRDjv5aYGmhnK7I9W0Xonph3dt/vQ/fO3RrH32+185dvKJDY/O7ExCUSdzFbYIJI/eNRy4kRCRd76/3vfA9T8cv+eRvrHRN7/5sjjCbd/9gZkjP1DNzPhAPVsyhBMHKmcO1s+oLF1Dw4OmFqWERL70+DaPXBmeEmKjcLkzsZrI9MQzuQySVEmNkhIfKKp84NUsGG2lchcoLlfDgKqA7wo8EBREUICVUtYEGtJ6BkRKJmzHop5MgH1AVOFL0E65voa4n6n3CxINOsAoT12srGBM79K8BToCz4P6hXM59sX6im3tB76O3GHtKXz2+7hvkPPcl9CPI6z+vU4I4d2zwTh7qu25LgIzSEoYzwIe9mFv9eiQuKVv+cDU6ivc9K7q2ZfzklWOPLEjRVnUm28CwBjjAYADtXz7br7rofjyF/Zb3sNKpETioCq9IrGqiFOwCEBiUHjRlCgBCiFwLxEZ9uenrHavqsourUau4U2ICpQJBNBgIqQSik5ONT4Q+hCGeznoD+or9auqFSgI2nb88ISetLTS8a2mbcLMeWWjkY3NxnbfMbUz37RIdkzf+J/tLNq03W8ZtyevGbzo9ImbHtBOa+6O+5LVY0e//hAiqUIYDPYeZE3RKbhZG7nggqG1qx/5x69/4df+772X3fzSX3jz+mNWkcu8FIC3UA8qVMz8Qqha3hG4DAcNlLcWjVitIVJjLVlx0lTJlJoeuYpXGIZBz3ieyEZaYLrdOeF1L9/9yP3N63abPm0+dIP//5qDxx0Xjy5J08REzIy4Xo2Hama4Lz9xQ/WEDXmjUYxPNXfvntq9e//0DFNUrS8aXb1q3aqlpr8qqs5JQ2ZqGhc723M7J6LIJKrsZoqsveWRzZM33LSI+8f3TZ9x9vG/+uvv7GSdsC9Tl5NVQsrnq5dHGyr+MDnPI5AYiLREL/DiwXT7nsZffPGqa25/YMnFp15+2Yu0OjDZnE0M1+NURTreeWuNKgX8O4RCXNEbjWBSiCHT8bd//SoPPeu8E8554dn33rfzodvu4Rqxn/upDbV3bVi1XlYMMgx5iDgVMY0OFSpu11zbEFmO6rFZVo9IJCWId46IS6CNlkDtLuS0G2D05utBe8C8ak8p2gwGefQSsFQGbyFNH442HpqwGJauzEpZfQohJUMVpqwCi9fuBlAKCgUEgQiEYQSiPaML0tIERJWoyKD+SBuA8x5gWBed+35af6kxka2tUJaiKBRgiF9AchaSuNonzmvhVPLymg9uzz37a0GzzxZ75eDWHdYKCzVkFNrL2AuEuxKbT7a12CTnvzpw8lRggpaPMoi4PKAJABWFifO+lRZ3O0lIOIqK7ZuXf+ar2c6JHe9+pVQ0Vg9oOAJqN63PJCpwCgUZkCsgixZ7cgIxYsQIxsezaiXtH/Ciaoh6h80u6GceXNRjRR1EVRfqbSQ9FppaQwaFR0oK9mqgUsoS9j5Bu/8fin5UEsp8cWK/DMY+F1Oo3Dfn37i8oEK4CCr/SlQozFyihierJrpwdPTbu7e5fdMz9zxWO2HdyMnH7V492ti8p3XdbYsuOa9YPEiOOJyCD8k1he8WgScyTKRKJuRd57JmbJcvP/ET75k8/cZH/vl7m95583nveNWL3/XaRcN102zlIsylN6zRcqVUmSeOOdFJKfb6PBarZT4UmSsK1Vnvp9THagUGfHAQJQIhEUVW67vggx+8pvkXjVt29ifLs3seGr//IZ+3NKbgtERJFA/UB86/uO+ic5JlIyRJumxFunL1oi5rgUWpyIu8nbcbiYmsi5pTZvyq/9h5693Z/v0xR5qRz42QixKukJkraPHakd//67cvHhhQlXCki2CDqAgWbANAOb6OhDc9gBlUDg46rIKeAt77iJO+KP7id+7+zDeuohWLX/yxn5GhvgJK2UyV1XnxTgVgg9lOZ6QSIYS0XafoMo8JEERA1b76Yzc+9MSND6iN3/y684dS3PbDO6anJ5f0jxiij68+flTJmcaceAJZyxwEI3ySSTTZdAknhWfDcytiRi6RmEw9PCsRwRMFDGN3HViY/wN6EAk6gJ5T3ikQwrrwzg66qVVVBBuVUF4SwDtdnrYyyY3rW97XJvUaDuu9lBrIwHjloBVKCgRIbakuJl1vyBIzBGYIlIINjVElNJ078ooc5iYRibQxsswDOToAjCAYV4QiaHhzheLvP7z7Bw8++IZTz37BiqiTdcFLIQHV02c98Lk/p+05TwE5jRWQHTt0y2aamiIFbTyONmyMWVQ7B22ARMRdSn2Qjz7KJx8eOUqixFJb45MqWgUrqY/iZHqguvShhyvtF+2o1R288XCk1DuVsIbjZMD6ceEEcH0xoL6XtZyb5koFC6k9Zd6w1+aJ24cL2BHYB1p6diigpB7L+iQicURe2CisIC//qLezMBDKVuXSrKoQaOFXVMzilLa3BaBHWlle+Jg5bGwLOlZVtSj85UPDv2+faDVc445N+SsvtitG15xz4kNbdie79s/c+6B9+YtiYSnCUzg4V0CsIiJKRSYUURIbDmYdDKacM+ujvoHXXnb8Kav3/vOVd/3TD7ZcufVlH3jJaZecBeNiViHkQW4FSlLiIoi0ozrhddariHUg081ttaGTXjLRGFYO6czuXXnDRWrTRpZVRkcu//UP3fvV/9h6681m5xp4Z6MqmYiD+V+buOD9X7+iccsdI296Te3ME307Q+GCJ0K4wUhMpLaIa62JrHn77ft/cBWPT8aKSKraJnBMEbmsQSJ5nPe9KP7t3/3wpRvPaxWFBGEMKDP1AswDnvsRI6yyFExd/6DenxzEbArNi0uieHY6+72vXXHT9j3HveVVoxtXN4s2qTARiToBlwB2JS9eYRH42kGBxFsKEBxL5K3nhpEq8Z1fu3Lf1P5LX37eSy48Y26ude13rk9r8WzRefuqwdG0C0INKRdF4HcIyb7cz+WImFpe1tTMUGrgCgIMsapRCMK5mdAT1tagvtm98/kgw4c5axdkCKQbzBmQU/iuCGOwOw2BtQnFJecwVps8d3HyvV2DHKmGIq+GFVkoRITKYDCFjYMC/wTgUCBhhQhp7wQg8wsCFCqMqKLmiIHykfDTXfroAf9pd7P9B1++d8se3bnz/s/8zMmE51g+5Em053wDELHm+uvtLbfGvpzN7Qe3to9/rP+ll3fSVKSz0FVVVb343bt3R1EURVF/f/9T/TpSB8m0eoyvD0czW0E19elgXTkupltu524zckwDGkM7qjFgQple4SkoasGEULccYhq0pUgVk/vM6DIsuFTqIWcOBBph4SIwTwRVhPkIDdJUygoSWlLTeowJr4kVCIfUI3QeLQoopCt+IgQhFqiQIx2KaGWVH29IGtG2drE7K5bGpsySaDBqCfpz1FFZnCTnDS76brupDzzRuX9zcuGxgxedXv3ujZ25bO76OxZfcAbZRBcIsxywNytTaaShnRxEEluigKsXsPdF4ZySXbFu42/93PQd9zz29e99/Xtfrp49NjI0EHfgYhMxFwjndzFgBhqqe720RVhRoXL2kyJTbYlkIgUQHRm/LGDWyOdFnNhmnsvAulPe82urXnTv9od/MPfY/s7uWTczBfV+VlwjNrwoqvYX+6b3fu5f+x48p+/CF8SjiwDYlOCJsiLPm03XLm7eNfuj27Nt29QTEbl8um9VfzIYiS9MZJL+ob7RgfpJq152zqvefsJGzQpwOMcQetf/FHKDBKDnOa3dbhfioGe5cMEhhUE0m/H/vXvTzlVjL3rpJYWlWd9WKi1OADCR7zLeCRiIIgCWypSbJUZX25pAxKjW4n33PHDnVdfGw/WffucrVo0Mf/2/79uyaVs1TbXIXjHWX9LaVUnZkJAoQIXX1PBEu5h1klh46OKKGYhYhAUgthIid0a4NuVu4UpC8B70PkKI0gt4S7KEzHdMGP6sStqNwIi5S64PsmEEwItWdeAPT06WpPeePDhL8IAl9aI+ZJ5JScUQjFEhL6yAGtIFk6vrHRB6PxxSw6QDKTs4a4kjPEveLEP9fu+UjWNJbJK73mf+BLL/oT3nG0B8443xLbeyQAzaMQBEgtoDj40TL778kqyaqOS6oEI4Ozs7Ozu7Zs2aVqv1ZD6fDleg97af66sgW4hUcl021Fw0Ej+2rTrbsiQqXohYJJBVu2G7KoUN3yN3SoQ00sAdZ1EFGjPzGxUvWN8DtuGgavPhL5W0VBcWImZVFZFVA3TSqPvWVprNiLU0H+3KImrXtxrlDyE8VCUQhCKj6/r42n0SM21vuT2ZX5lEmTp0Yy5D7ANnBqTen7944L+2780atbnbHjBnrKwfu27kzON2XXuXe3Sbu+dRe94ZKLKDsIzzF89kIzKMvNBWx/uI44RJhIjZqA2apoW2xfSdcuY5Z56OTmd3pbY5b6+jZKmaumpEVIAU7IAZJzNeO6pMnDKDNXdiQR2RKS9zIiBEevA1LGwcTDrZiwfBeO3sV7HrTj1u3emStVynXeReXSHcmrj/1p1XXNF+qBaNDMCamauum7v19nT1mB1eRJFlZW3n+cz+vDHDu8e9iQtYacwNr4tOefs7l593uudYJTWcqHeGoUn2mpVLGGjbAB5Y+HzpKdWHVOfFM3p/xSogpoBk7+4CCnZa+cLeHbMb161Ma1mrLc5ziUuDYQtQWKAZZBiGZThJc3UW4koEFxHA5A08weXWjHD8re9c1Zieu+Cll1920Xm54lvfuDpr58bGG2p44fCASBuiSswAKRUCIoSDxdZGUQhXmNn5NbUkZZMXShwF1exA2CJv1HiSbmlEDs4Fze8HQalRiYmkzOt2uVzK2oONhuOazu8bLANGMtK2ddMfH0tmbMW5lueC4akbjZGQCsRJFE5X8/7xCx+EJ1nwW4UnYngF1AuSARh+VjaAZbXKL75q+X1b5168cU3h/XPN8n0y7bndALjZxm23e2vDIm3CsDbIDKqPPlGcvo/WrhCvxFa7vJjBwcGhoSEiqlQqT9NpTz2R8fX1JDcpDDro09FLTnE/ehDTrqMigBHpkcJ8V62IQAT1UCMeFhSFED/UixRFHlZmJi3pA2VackFG6BDlkgOAp0oCtVKig4MiDnHOP39Rcv3eyUf3jzxe+BMjQcClSvlHpRGZarCU0ZAk8MSkSrSxPwhSaKFyx0z7nP7Yg4I1sQTdCVBAtzacnjFaW5SixTC3bxp81Qt049iyl7xgzzV3VQttXHNb5exTPDMLjhSPEBFHHEMyRVaIE0SGlBWWmMoUgSfNVAtHcVSZbemAqcxWqJUXI9YMsUmYnGKfdx0Pp2JLLRt4ATO3nJ91Mud9QRQRDs2PL2xduTCjXonYqWMYMdkc4Ouk9SoRGZARXbtq/fB5L9v6L3++98rNcbpUKxXXabce2ayyhSERLFNUsPUgTvrtbEPzfce88vjj3vdzI8uW7G77VPPMFqYQKsQVnU8uHVtTTRWFJasosz4ATBChoa5jBB2aAzxkugcW+oEikaQhTcbaXSsNUUT4r5nJzZRUPDWaTSYyXY4hkyUIoEIUkhh9xgzGqcIFZgIvoGUbEJPAm0rVzD6+7bYrb6rX07f+1BlLFyd3P7DpB9+7IU2q053269YPVJmbLiBwJAILkSoHJAATdjSKQinQr1b1GwLUcynaErY179WAvCmJVd0J0t3pKMi9UXDJk2BwLMzgXs2grK8xwKU2XNdvsnyDMFHLUqGuxi7ysAzjJCRYKdTkuuI/zMoGCvVMYqR0Ei4NAoNPB0BC0LJAUFb0bKSu0LSPECmOqJv75FsBd9nKEy5doc458XqANvVPAgKE59oPgCdno1xsIcYJhZcXW0iUi7Y7Mj0TEqDa1SMLQbH33jn3DH1WqbJCUNPCIIuzBl64oTj/WLd1T1yS7kQhXiVXcSqFSqHelZwvEedAitRSSAeVr970JS1p5V0AWfmB4Zb1AJMKHBBKiwTH0jKVT6qaO5xb9X/9Elmy5FGv6oO1/MKn06NNAgCJ12BqVniI6JoqJwwHEsHjrVyEDMoYyaB0U+n17UlJ/ZyRQYeG3zOV3bVJW0X9pGMWnb6BfV48uDl76HFKKrLQ4b5UltdwSV5VBCbiaoXZcuF9VkjukRWSefWiouoUuSAXtD2Nd2Qq1zkv06JbcrfdFeNO9uSu46k8ODBn0I6oOohg2sus9wKy3fTXUfyvQ+cHLEep3gPf5fsoVOFFnReRdtZJKpXTf/G3j/nIa/zS/b49aZoxcqsE2MgZ21HyWQetZruxuzi2ffpvvu70X/uVaHhwstNmZEpqxIqoyYp3LR/aMNCXcwHlkAA7yLrddC1rD/o9E/XeOj9EuStMdNRDQ535gSy/P9OECEAMsuXnMXUB8rloIT4yNBTZemSZlIgMlSsud7W7VYUVFry0OnT1F7+x7/G9Z55/8qsuP9UrvvnV22b25CaKl6ed1ywb6bhCJSpteKW0X1elBAyhrXMdIjIMQ7K+zwbRWxVSiShQmpQo5C2Fe69SsFkY3pBy147bQI0IiTfeGe9YhFQYWvalStBzNqWBqzKUWQwJw0VeqoWkzkceIDIigDj1oh7iNDhde++jQiKCavDm9ioHCT3JQWOpnHHKBIv+pUdS9XmqTQR5nhdFoarETxlM+Fy0Z3oCWChBfthGQp5REBiwUqZ0S1muqPz2ZxOJFOr3bLQy6KiK3Nk8zZoy0Nf3rnPtfXtmAKgUGux5dcHzlhAHKDxxiSFVBCZNOKF2uYjz3yWqBCO9QFXpcJDNA7sjLG0h0egdwVufFfkrx/ovfPFgUikwn19auDcH47DAXikRmaRqlZZVqC+ipsIwtreKWeeC4lDJcQdRV/zUMiUFX76k/8pdm9tpbeKW+4YvPrOyePGKV5y3+55Ho7lW87rbh49dH6BAh6cEiwiQGubIpPA5sSjlzqthq71srwLsA+DJyx7bSZ0lIgvdU2hhOA4624ASilDvgHYEcyItIQTd8IDRetLTgw78mbt4ivBz0H+ec+1jXv4zy064YOcD/73/0fs6Wxt+hop2g2DiWqU6Wk2Hk6WnvGjsrIuTRSvbRQNwwXfceFKnUrRfO9r/yqWLcvaR2IWkrVBvxIEFAF6gYdAbEgH7tBDjK11kbHfkdOFkXfY1Ay3xN7c7k0LDzA5qQb6rBaEqQnDiU6LYckocBXkZ33uCGsQowxTzypGir1bbff/mO674UbUav/3tL1u+aPSxLZP/9ZUb0np/7htvXN2/tlJv+0JBqkZVPVigCg6c7bbze9ouNrZwGEloWcVo4UhAYDD7UMuXEg6lTF3cbjfZFYL6+WliVLrwsFD+Dd3EpaRKr/oVclHdv2KARIKpABSFaoUUXsWIGuEg5uSgrNZ4y5YsoCgMe5KgGNX9pBBzlbUSMEjKygyrksR17V/0TOzA/oe3Z7QB/FjCmgz3t2O1gkQZEOWyok8AVVIztvi5O/aQjZQjOIWLyZtsxh87yIvTQa/7AceQUsZ+Yf2HvWikqs4rl1rQpWaYiIhnAQPMUsLGtNSlAuYzm3rEU0s485JqoHqTQJhFAbYquW8lfZF42xto82nKslTloSQEiAesJ4BQiI6ktDilqaakbLa0iunCj0W2CCwqml9TVOEELetfOLJ4dbJ9r87NPLS18eiOdGRg6MzjB49f1bp/h9zykF6+W9eMosgWyrSUl99d43KPGBLF1ljJM595V3hDZCEwZT6kYGFSLkBRp5CEjYmIYKFtVQUSqFc1ShFIiTqqLab9nbbliG0UNjlSBXUdTp5ifFCuEDp/aCMiqJ2dm6DRgfVj7z32hYXmM8g6rlkQgarW1qumlnKciLSLfCqk1wv2kRpFhGzm5QPpa1cPOWu4J7m/8BsXQD8PDOt6qDBo6ZxzxKWkV0KYH0IkBNrh3EOdYhFXMhUiOChT2EfIMKoGNZMA8Kqm1KY6YO/sHbJJxZA6RT2Nvv3l7008uv/Frzjn1S8/W5z9zy9/d9v27fVFg2k289a1p7NEIhk0AgVDPVUwE1QlMrynk+9uuzhKnXdLEl6SmrzIWaDM6hiWFFTsSqIVzSDpgFC0Ve2CcEglyO0E/q0LjqIqQVedFaJeaKHfnHbNOLQLFi3HdZeUQwQFsQYcLoRVQGIJWgAqakVBTlUsufLwSCBR2JACQqjzqXDXSC5QGUjTPh1ZrvIs5H9wIDqwxCo9f4j/w7fndmeTWiU5YQ3NOBCpWI9IVX0W0aSNXrChGOr3Tns5mW4VxvdewYKxfD2JeyEypb45PDMXvJiKpHCWAwJCOdXFnFXgBUIqUQilVVgluMZTjxZY1vck8JVExYiQCLrvjFQiVhNGjyr3MiYHBQukTMpwrGoAhhqEbUBIhFSJxIiQdyo5B8Xabu4z3MlCPUqwBvCrkzJviSFjFkXwwsbE+3y8r2PZG+9UPHxwFhAmYagloXbh1traiYsG29rAXHv8h/dqI/cDg8svPR+VGDOzzevvVGIlCzU6r0lyoEAViaqKOGZU07ivliSRUe9UhIRYu16YBIGSNULGgESpgGkKOkoeGmpuTChUppybywvmWKDee5Rzo6yBPxNa/MJaPQBmsNdONtU0jVbFtIaq+YoBt2LIjdSL1GSSd9pzPvfiS918o0xe2o2pC0eid65dnkjFU8hElC8u7ReFw2MmXfibA5J5C1yje3+vTBQKrIzeD12/GgnKgET0SOYTtQ4OXSVyr2IU5P2aKF5vKyNEiSIittBQG2fyKHMu5c4kqsSaEPfXa9sfeOzar19d7zfve+8rR/rq+6aa3/jaDZxE7aJ92YrVJ8vwXJbBkwjUCwnlgrz0Tycm7Gm7WSdVcpnzqdGRGN6RqFFhUVYPCNt6eUgqlWBExEM15HlCTpXFB5ousRB5sBB5Fm/EW/GxivVwmgOuTi5CYeGjUvZTjIbkvhCrZbFh4htD1lsqjBaGikg9kTNxOzZtI3lEKpAiQgEWUibRYDAJzwh2TdLdwstDvxEPjevUN0xHXv/pCO1IQ7JgbmQ51AqxqheUr4ON77uvZ2MZPuocea6/ABe/oHNKtdFutXPSGch02ulMNM+zcsbpYIsif5KJsKdcDzApmQFpkzoVAcAiMBy5rC7C4hmeyFvyhoRIunqBgYTlQaSxRakjGPL1ZS5yAY6gdB+lEIj08pUL3mkhRj3DE5whYVbLJb6NyUfhE0SJpMwVlCoVJXHaAYAGsyfLRKRsEKlWRCseaSxGPI7rj1gAZVHdkRUqFKonpKxqvJqQ31QxXkVVf3rpsoQ4MvH0jQ9l2/blGo1edHa0ZMhYad54h983pXGs4ZxWVuHmcx3EaoBAu7cgw5pGUS2NqrFhdbnPnUIRK0deiRSVKLJmQfimKCCFgkGB5dlUtKQsVIQBWdJXw+sID93jKdg+0jwW/+DRvlBxM+T0mYP+tEKUnG20WpcNyc+uXG04zpLcHmFCLpz2vfF8SHmgDE6OukAccFWAEqElOuM9KZvuX3XEM3RtJeozSFgi4pQoUvXEXikixIAl7u3cIfCMydSM6Y+Tb37hy+OP77v4Zae96iVnMfCNK3748KN7FlUiS/KOJUsSE0ZgFOaFKomaoDvnlQDe3nK5FwCssqHfJgFs3FXwgWeopb6C0oKIjAEbr86qi9SZUozHszqCKDyrGNUFLzHqrXqrYmkkoiXgMTFnprw40sLCWfUp+VjFQhlqVBjeQg00sgzjwEWk3sAbeEPCQqIqpALyqj6iUmdChdG9QVUDIFwJeUPCCCIQjlGt6+DIs3UCIMjE310384l/bvzbHXo4U+7D/Y085ddTaU9/A3iSkZlPF6Wvf3v80lNlw0Rj40T7PB+97YzB175VBwbhCu1Zyz5rjQFmBZlUKovRJPHzlvLGGJcNiEvhFULqsbDcGcQ3tVuUk5JTLuSJFV4gnsKZgCTEsBRA/SHh2I2Vqfx9eHmlgtSxegmxY4g10KU1lkeK8ixCKmTKQ27PdZ2h1sAaTWJKY7apRWpcCpcBKtGqWpT5IpSHH285V6K9ucunJ6/kRTMoO9t2cs7A4Ol9Ay0/p9PNXf99pxE2I4vGLjmnkEL3z+RXXs9RjOjwTgghIDcgLg051ZCPDCppUkmjqmGjjnwHXgxpLUItpoU8DwCFoi0iUCY0RBriwwZBR02PPO02ry+gJTPpKMO23NZVVSnxzjUaFw+bd6w5JiHKrbcu6Wr8LPj8Bav5oXtA7/cLfxmKmwv/auGfL3xzqN+mxAdpCqdsRiI7mlgPdaoALCFWLQgGVCU2oIWHNs9IlfvJVqJoy0133vRfNw4uqfzCz7+urx7Pznb+9fNXWuNnqXjxyMAZ9WpTit7XUdfWzCoBIZGOrS3nBOLVqBw/kBpQEFwLcJ2ApSbjIKRC3rFkRlzqPXnH5WlbuNzpQzHMc+/F3RdiY9cOmOOWxRtX8chiqg/BpYoKNFJhFQtXgY/hjSJ0g2PbYRFxSgWHyIVYyRCxR7AdkoKpGzqEwE6sOsJ8GQ9CpYm8qNGO0+FlGkfPRJytjClVuV5p37/D/tsP0pu3d756Hcbnno/4+8e15xAGGvT6lAuNI3vRS6JTLyDpoBZJbSRrTgKA88RPoQsWoOtsiI5FRNUTkbWWOQAVVJWYvBjL/aNasEnmA0kiqOvToiKmyXKg1HgA5YT/U7WMxJR4hiDbKwJfxummi0EBqCzkaZdLAKVS7o0pZN9JLIXvkpI2qBIBQEgSoFxIS8oxK4I8fdANRYBwkBezu5lsm0v2N1KDaFnFralnI8YRYVWNhiJnSIRoR8erEis71ZipA7gSlcSsIHDhMWSj1y1ectv0JhuNjl/7wJJXnot1y1a+4twt37paJ1rF9bf7y1/ES4YPeIyQ7k9kQKxilE13MSVSo95GliLkhS8Kr+KN4XoaJYa8Ey2lKcrqYEeQEHvVJkGZYqW2yJFigEPjGX0q4f9hRxGILMpkcGlEHJ5HEIWFAmi0O5cNy9tWboyJPUskcEaNBAWxIwZZvZrwQoB/L7O/sFRwlHYQOWA04hVRNOVBwWRWsSw1S6yZK0RROmRaqDGmKa7fmJjQVLdwcbFKCaQKjq1+9x+/7Cayl77rBRe96EyBfOvrNz12/47KYJJx9valo1Wm2cIJdwUayhKuGiJWBknmaftcHkRuhiLaOBSLI1JGSe71qoC3kMCMIXiW3FIRBYwAepCneQbc4dmw2hYigu2A2sSEKsQxaUzsAJBYwJQEApAqgzOiNtQbSdCdhqUDJlgNGRKot2XEySARz8xexWpPcUA5CMQBUK9aCFZsYBORbz4j0q4oM2kr44FkYlT6t5vqsXGtWmmheCYj+Vlpz+EGMK8IqCxZBxUAKQA0p5WYiwJPZfXnIA4OVrCPbdHI/f136H23VccniczM4iXFsmXV814qI0Np1ozEC3kMDsGwwhNF85B8b8VVCSzqiEwJxi5xx6pQiIqSlLo0If8DAN7BOwBMwcEGpNoVvNVSO5DAXcEfVVV1RI7hVUWD8ln3cA10Y3+EkDoE06XQe8kvIuXCSZKYPc3kB48OP7yvnoEFNmZKbRYb+4J+f9ESPqHSrhjpqAPzo22Xq4mURB0RXJi3ACkbkIcWiszLZYsWfWaX3Ve0zLju/v4tK9/3injp4jUvu+DRL3yXxvdnV95Yfe8btdmmuCduESr3UkqoMgVzJu5mKkAldrOWxJ6dc65eTYL1RxlTE/VYr161Q9oiKlRCnYVIg8LQMwH+HqV1tbqlrFKrMtRJc0NNRhPcNRWrJn0RGspZLmSKZdXmmzeMXDy0zKuQdqEA6p9kOTrEIlR63B/8N4fmfw6qIfc2jPCblGlxzINBSotImVKIU7FEPagAERN0zJRZy1hJVX2gUBEiwqC1I/Xkh9+56ZZrbh9eQh943+srtjo+PffZz34HseuIPXeg78LB4cx7L5gPy8rqHJGSE42M6Tg3nrmUWb2MVqN19SR3hagxKDH+Io5ZyUCdIfYqrEVE4VTaVYdGKfxztOlPwoAzGqmoWicq4g0rwQJBZF8NyAMKtZCU4lnlDL5knJFwF7hnVeCUjYqqMlFg/Ze1JSH1rBIs6kv5N1YDwDsvST8tPyZM+2fSSt0KkWTl4mUfu3T64XuqF72UU8sLuAXPzcD/8e1pbgBP4Ux0OAQVBRnupwCDFVDAiFnHEfbsT77+OfPY/WqZxBuvyfg2vi/J774xe/3P+hNOFpdDlEYGpa9u207ElbmUMKRdXSnmsP2WooACJTGQbiLeMmILdMFhqhBvRKClk7D2dCkD4o3LIRUMKKCkEIYGCk1QiwlOr8HmyJT0FglxBZVmCQAMQSEIpWxOUzvdib58+6I9jSoiGqyqKxzAkCSXyo0T+e4MrxtLV1eThzKNDe/NtONRNdz2EOZQ+i6fgyqDWdERLI3T1yxf81cPPTGYrNj337cvfukZZu2SsVeev/3q24vJWffDW93LXmQXD8Fl0ODg0aOHqYC4a7Ba6h1rMPdWJjIqNjJJZFQ9Shpb+e3lIkxkiLxCRVnhVTy6ANonNfCkqy75NBszGa8dcecN9v3Smv4hpF9Mtn9/ev+USyPGYpu9uL/v8v4NcR1ehREEDbQryfRk05XM3EU9auB/P/nwHwdSyQQUEUVcpiWVyud4YLLpALiRIQLBdjt/QHigYrO5ma//9Vfbjfw9v3zZi859ARRf+vfr7r3v0cHFaTvz712yMgZ3RBi0wLpBAy4nsPwYNJP7PW1nGZnTNX3xkjRqZp5Yg3AbqzgxSApKFLkBFUQMjWGJxWhPcA0HsVsO/6BBwp61tBNgqFUIxCDsySgpnJAIvk7aIBV4a8SGnAs8qFQwIVuAoUGgv/cUSKA8vxmokIZ7D0ZrjnT5GoyuhPjy8PK02gKONwAMn3Xh8FkXkiJDthCo9pNqPzE/gKdKgpDu1GOI/f5/mIfvNpVEy4hHACcQMzMTfeXv/M99XFYu17xN/f1uaDCe3uctlWKIUMDDV8Bp1zwiREk0L7ipZQhmuBT8CRVQp6UvtEqZSQ5rXAk27w5oVgln35BOJgkxOKswCCQkZSIorP4LqV4o9QNZQ7hEbDzRVZuGdzeiJFEyppWFTxNCASCxyQNTGND49P7hu/ZNVDnuONrcdkO1UPhVe6DXcqhXeyIveMPomm8/vmW7nY32dSa/e0v60y81y0fXvvrCh//uK77dKb77Q/uO1/ZQsIFYAJAvZdihIAnMU9GISKSUnVcuTfCOHCJ0C7JsnSKq1gCgk+V558fWr/RpsyUppKjDRPct5Kf1px9eM5qS8YbePrb2nIGZba1Wn+HVldriuApiJQi8ewYiLb0RfpDkQ1kTZiKiTic/6P2HLjMJBeYEl2Y4NE9G6e1GvYcc7A4NFMqG1IIYOgDtT/lb/3LNY/dsOua44V94309bwfi0++IXvpvWk8LzpcP1l/YtypzvAGl52gtXLgjRj5JXRMRNJ7OZt0Y7ipOGKyokAkM2jHhhkDNk21z1zhHUEyJ4q6pHyvHRkQYK5RRijN4tBqKWOEI0f9/K7Fm0AIn3CmdABDVwCoCCjqJnKBuVUOeHQEQ1aJELke85lAX5DS7lm72TY06j2oDpTMmzkaw/YK0/IA32k2w/+SrEk71OtezYGEr2bkkevs1E7BkiAg/yIO/I51El5skdfP0V3kQQQpJqrS5OgkIgvIQiLflUfao+VmENeiPCJe5Kgy8rxYxK8DFRJiEiOJB4cFksCFHvPEhmQWeylghACl51Zf49oJbDui+mmw4KR4ryZ4iwmB4JCMozWfTQviobUyjlBYkvxemgMTT2jqoU75ip1Gyto54VOWR7W0OV2ndZyj3SrKoGJe7My0bqe/W65Q3Zb+No/xW3NLbtcaCVr7vYnrgWTvOrbvA7d8PY8sLKUzCrqgN51ULVqeYiufqOSCGaeefEi4h6CYQaokNnd7kEAwwy0nHbr7jyvk//5c5vXxXcnsK1+pIR9GxKZPWKfID0W37D0npfZCwoI9cSt7468OKRJWf2L15cqTUtGjZ3yOUZz9AuDXh+6S8vQuSJrXvuvfsxANVqcvSvGbScMnmoQEWVpWSvHOUsYkCWEQNVaJVkMI4mNu/62t9+Q2P54AdfdeLatUT6xX+9atNDT1RSazru7WOjqTe5aEQsYWzPcyRLaf6QDZrN/UzhAZDi2KGEiaCmx6EVgajx7Dj2SlwoqRotrHirCvEU5EwgCIE5HaCnywtf3Ucf0rEBGRyEFKMubhvqY5VUVRUO8MHnS1RFOMwydQYulJdNCFyEwjQ0LOHIEp6TsFoGiAwph5KKiujYWliAD4mSny4vTA/3+sk2ezCq4cldER14DH8eOM2qalTB1m95zDZaqMYqeU93gZSVxBU5scNjd9r9M1KJkItdtjq/7WFNQ4k1MHGIVOCWwG5fwLgpi0VGYcSqemZm8WFLUBdxCpDJnQfUK5sgjBvGgYd2pZvnER2B4uqBEjdPwQaMSsIx9Ugx81IngAplWR7HcQCtGNWJyUpWxMaSU2L1GghSaoJqvygikhmarRXDo+4JbySX/LFW08oSQFSDJAFITUmZUWOJ1QtAuXXvGDrma3v37c1mtJHu/N7NJ60eYxOf/PbX3vHQX0VNN/tv3x399fcW3gVt3W76g7vWSigC/UHhoaLEXT69EIyKVUMmhI/oWjWFzhABmYiam3c98pefn31wE/J0qnV3vnPL8l98v2+3u+S1XmcevAtQt2x7hDEXgn0E1aZQSQ8BHzHqzFWOV6T22HqfiDAbo2LYePUgwACqiZRw+8P7eR91pB8lwxMuW0SiKPrXf/mXj/3K36Z91bXrV1328vPf9a7XrFi+aGY258hyyCFCiYJ6uNZZF5Pskggq0t1LAAJxyTeetyMWq+HSw/nVpxINEkcpff6vv7J52/4LLz3tnW95M1R372x/9u//rZbUGp3mm8eWXDi4atK1AZCQlhalQsSlCycZVSU4rxx5X+WmR21dP23srzU7hSqJ56AX4kGmisogRFDpF7a2ucd6R8QEMmVJVgmKoMIIOFCpjCLdH8qejCI1pOSJiNSRYxWjBvDECHbBEdSAROFUI4XXYpG6QjhWLXo2AwFgHQoTTGTQAyCBweJEgq+8IGCZiIxXgmMzuk42nMidTuhwYhNQed0QpZS5PuwSrl0Z8MOOh97TOuBIwPpj04NPts0flEu+3FEC/Z/YCeCp3i0RiTgli5nJgEi23rN0pdwIABsQscXcjE6Plxmc/rqmUUkQ64bhUNUSisO9/goofnjDng2FOlLI8bB6ZpAazgulkO1RLqMkIXVGXQiTUbq4dxVUtIvzKWmFAUJaVh1w4NJWlmpZWZmEQMIGlDkCYFD6qpWWZEH0Bl5VnZfMiyU7WIkEBOWdedEStYhYDIWcUuAGKXdr6DBe86K1Lu5788jKQtq2Fs1dc9/kg9tnbZxeeMryS87IHWV3P5hdexeMZWvIJKoBDMWsjNIgTL2SaBc+K5SLNpw0nLS9d+IhZfpYVH03Sdbx3vbXZ+588P7f+pPpOx+haCQ+ZnjZ+07uv+iFRdZRY9VYmLITjpQh7WVLDjuGVNVDw9MAwEQxc93yoDX91gI4rhbX2DiQksR6sNR7maF5WrCPH0sFUlVjeNXq1avOG8yJ77p18x/9zmdf+6oP//Dah4f7q1EeGz3g00Q1Bq2qxBbCBAsy1JXHPNzNh/g5QA+HTJpCokr1tmtuue47t1VHKh/64JsW1/vB9Lef/Y+JPbNpPR2z5meXr67lXRnyUhSBFnqnIhBswe0iP2146PSR4cmieeay/mVUaWSkYsUbV0S+SH1ejYczWKGCSp8VF2lpgRHmCEOYhEgYniEGPjArzQJGDpEQrGFbJlqVVX1wJWVWi8DLkgo07vYTqxjyrGLFk4pVH6uPVSKBERioVVUDY4UDkDRMT1eQiBB7iAm48FDkgyt02TpOY/g8xHHbZmf3t9uPTU7ua8wtXLsCjOPQ19EGydMYWM9Z+0l6Ai+sdP3YRkSizrAaUJl8V4gJQWmpUuChaqz4QooOBxLvyAiqNco7ZbK9VEYTDjVRVZSCA0IIERdDNAgyRKLwgY8HBkwsnQIATODW9C7cQ7UEwQQ8GZVZcA2mZ+GUS2JUF6Zqu4pXIWVU1gsJAhQCy0ogMok90jbpelkdL4jVjFSSXQ0noM1F0QDXiSVgK4m6JxSh4Iuk8KwMbfjOB5Ye+/XxJ3aYTv+M3/nF61ccu44ju+Zdr99z96bKfjfxtSvGTtzgF0dFB8aUpXJ0XRDCptX19lLp5nsKFSfk4foUsbWhfNCN2cn09c/eu/uhT35ep8erq+qLX3Xy4le8JF2yYs4ZabcXMOWfkkWqHPJvVRElTdlUGQmhykgNh7eur0bP/yRUVWutc67d7lx88cW3vvisu27Z9rVrrvuvr3//8dv3/fzP/s5nvvKHZ55+bGcmj6PerFQhMsBIavs6+ZxXQTBiC3tAGf6XxSyap7wRSQpTJxNVNWvMfOEvvjU303zL21/0ypedRyT33bn7X77wjYG+von2zC9vOOZUOzjuWibqBiVlz5eVAIUH5YBNxCijqVoQ+qxcPDhsMmWNuoCFUqlErVcj4pVAIqxZmWkRZ0ItHBqquFwCOLt51K4dcjlHKAaZgPehEIQhZ8SkqhADTSAxKIdPAFIWaCK+gBrAqPpSWKLbMq/BSCMSA41VgxsVfBFWIfhCSvwuEwCC1Q2nw7tyEJJ8c9OmW3fsZOYPnHnmomoFC9C6YJJWpkp2IFFVaebgnq/V//T2E64BPPlzAAPKEPE8OOIZ5B0RqTrA99RuSD2sRRxz31DAa1J/nWqVef/P+S9mSNIllRhorF0qI2s4jJLxXh2HKBdO41S9P/DKw9HBs7oSSBD2D/iQZywvXLsx8vwfl1RhHHhVEgSw1DN5o16EMFSZ/0pRPw9mLQEVnkMBFlheT9qqhnl37va4wsDM3zUFIXWUVwgYIfbqve+LzTtWrml3pjrVuHPPI81r76GWw4rla159PlijvZOz//H9yFZBQRkiLKBhXWDt1s1QBuO0sHMK0bb3HVegJ7oFFWiUZ7u++sXmE9v6Tl5zyp/+wthr39LZafIdcxTFlERaOJ1PqS1AoxyhlcSKw7WYqWZ40NJgZIYiW7M2ApNiUWLWV+PA9fTBBfS52Q3mi8BUnjI7nU4lTdM0beadK6545N++cstHf+7dX/u3T1/y1uMf3bn3L37/M8jzyB68cqhqXxSdWEtAnssqL0r+JPkDmG6ABqikxyIbk5d6rfJvf/6lB+/YunL10Cc+8hYiuJz+6E8+28yRiz+jr/JTo2uauecgrFaGFF0dgtCYxVBIYvab5EdTjbtmp0/rr59ZGWo2vZFExXYZXqSqbs5SLAHeps5IOw68KhXD3pAYCoR5MaJGQ9ytPUa96ZaslBOBQVBdJRjNqOQJq1dfUZ8qMlVRn6iPVYOug1VhdUYKVrHqjXqjLhJvSC1Eg7B2OSsF4lWLUnVcFSFeUjjkTofHaMMJC0OQVx17bObdyzdseOHqVViA1i1m23s/c/MTn7hi5+9/f/9X7nWTbapGFP3/yfL/E98AnnzzKCwZ8RmvPMbHxhSuRNfOI9ZYVTVr0vAyjCwpkXvVKvcPwhXoYfnK+iJDY2jSe6lYlYDH78opK+DBQiJgT3FCmeNAG1i4LKlXlGQ/6pZbQxEzZIFUBV3GeQ9cEeq8emCls3sgKEoT9lY7W9rP68Ymp7LCUu7UUY+3jDKPZSFO3UiK4/vTjjgLnXD55k4esQkmzKqeFcbQnkWVnYtsVkEFnsgApmVdu9F8x+Dak4fSKd9IIrP7v66WiVbm2sve8qq+jYsISX7jrc0bHo7r9XK3W7gHBJQTWMEhcFoIe1fVQtHpUmxCusazRq49e+dcbfmS43/zff2nn7Pruqtvfs8v3/Urf/r4pz/buX+rjeOkWlXhovC5F4UXET2cM2g3O3SY/2RAKZv+iEci229tzZAhzr1LGG2n69JowJT2WKrK8w4jz35TQu4K7wu21kZI0mjHjom//n9fesNrP/zmt//mtT+6LaP8uGNW/cvffOotrz7l+qvu/+Et9wzUKws/gYiEgMIttWZDkgR55dCdCy87JPdIERuJmcdMErtieCC++5p7vvOV6+IKfu2X3njysesM40v/ec1V379lMOlv2OKXlq9dlMdNW7pVYD5OKmnkREEiJVZC5kURf3d8csYXL1m8tF9t08TqAM+EssikQtKJoTZkzX0e+bxUWSBBD/VQiiTJPDah98M8M7+iQFednxWFgQaVN6u+qgKFU2HAEkWEFN76nMQZdSYs/UExQsWyj41E8CCVpGs+RkTiSDyDS9Fp8QyQJLE2Cz3uXCxZuvBBjPX3feT8cy9bt8aJDzLApEBEez5zbf61O6N9M/axva3P3zr5lbufJN73+WjKPTWXI7WfZAroKTUSkiiCOL98JU56Ae76kZIxC+qEAiZil7X5lHOEmTyrKhtDtWpJuAUWFGAYGkEqgdipUJBV6qiKCjMcdVPuKlAQi0QxWhkQAq+FnRxSlrHv8kgPeQZdFlV5qSxUsBpRKYNDLaO60nMROSEGU0RMXHReu4Z3T0+PNxZXjaq64JukqgYcETnxTvLTh6KhqFJhIZWWk0daLRkYcoFXoGIRX79mzZXH9zvKV0xm77xn39KZmTmTxIWbTfKlSH9z5Lh3779rJunX7TvG//0HSz90aR6nG37xzbf/r39MOjT9D18fXTGsS/uAkCYLxdVwXO+V2rpGVguaQAOSZh4FLyiKwq6aWfumN6arVrS27V/58le0H57c+oVrpjZP7v3y7cPnHr/kVecPnHpc3F8lUtdpC3lWhMNXYB3MY2kI5pBZZgiWUDNct1RnYoIXUhULO1vIsDUXDtcCDkBVmBaiUJ7tEUvEpGkaC6TVat9y8wNXfe+2K75z0569s63Z9JiTR77wtx9cPMizTR3oG/jt3//wtXe/Z3L3/oM2NFb1oCBffGI1AfBoJ+cuTqYH8hWCITXKKhg0lDjUkrQ1Ofm5P/rXien89W846Wff+BIPTE7M/M1ffTFK6s2iuGR04LKBFW2XhcO1lnDV8tLR3eDBbNQY4jSSB5utGyanjqnVLx5Z2hDtGEpyMHU1x5kApVgAy0wUOb8/UhcRB8llo+VhHRrYESGYYj7sLs6VEEYF1BhJh2FYleDjAEKGt1AbfFrIJ0SJYRYfgiJDICUCSyD3kiHVJoOTOO5yrqzLCcG83gcfe6+BulAfxDkXkha9PKQCFnr22DIA5btFKaJ855x7YF+tEquAjYXV/K5dsq9pR6ryP0Dr/8m0/4kbwAGKuABCIYjAZFnVwZkXvkTuvRl5rpFF6VYKhniwXbXRnHqB6zSJLcDElirpgk9jzAsJGPUpSFQ8SJUYZFQLiFWdAcDKkJDIJIjaSGYPMansnl0Dz0AppDFLOUclmK6kmi5IrZZ2GQB6mfTy2rTEJguU4K32QZqLE33X8ek/b9oyNbM0NYkptYIEJF7ZiWwcxOp+xxKvTeJ9LR9DHmw0WuoCjMmQVY52VWt7a2M1oZuWdI4bzl/WnO24rN/GXLRnbOeywVWvW/TEv0/sHYkXT//3zdWzVg286ETeeNzan7po899fY3V69os/qH30tQBKMQIqbdF6+d8uXHvBU1P2ClC4hvmN0Zvaho9/ojY21GgVZE0S2ZM+8VMD6/1Df3aDRn1TN2yauv2Ryvr+vuOXL3rhubVV68wiS0kE54NyonZtgrqp4vkvDMkoY6SPbdVQQhQkYEi1UEQilujNY33L0wiq7pmojB6hhYOKMaX8kXMuy93ddz18ww33XvW92x5+bHtjLqr2K8ngqWfJZz770ROOP0HEsMkm237NxtGv/+ufjY2NZe3sMNNBBMSsOLFSMYRNnQwKVisLNjABIkYCjJCxkQ7Vk0//xXfuuPvhNWvH/tdH31IdqnjGn//plx97aFdluB/QX1myPsoxHXlzQNgSMnoh8c1QqKBQjpm8kW+Pb5/I83euOGbE1ua8Z1FlEq9QNdaGmcURCKyGQEazGM5QAvUMDkrwQvOO8HLw7rug8MNVhQ/hGgOKAmxIXdCRFqgBovL9yiBRnygH1r2BxkHrR7l0kWQJW46kMauHELMQvBAshf2VFQqG8dNtefElWLPaNBs4XAVOCaFeCGP8XEeaOUyZ8KFqpB7q5cmXNp+TNv9Af3xw8z9xAzi0haMoiWcyuWq8+rj81LOju26kNJbcE3lhwwq0mtHll8jiMe00gw6IGkYlLY9spW5IkKGcP+eGcnKJ0lSrwsGRg5RYOchcwRtmmmvPP1cu+V8gVp+HfhQi8t6XSl5d2Cdpz/jDgKRndEhCQR26xFuU5u8q4kmsgRHNCjEsflWl+ZETR67d3bxtamfeGoRUoVyINUgsyaVL00I7yyK7tpLsanRi8OPtVqZaMUbEezKJc6smJ+p5n6H+4SktWrlpxVwtRCAmYig6rY+uPvNHrat2Z65KNP5vV9ePWyHDg8vefPnEA7tnb3nY3XhfZ82i9A3nzSOnw/jqMdjKQjqDAnywROiIhwjYzlcgCvV2dLCR59YIidOWj52ufeP7qH/ggU9/y1DV2IrbPT31xJ6Jr95SWTo6uHFd/bS1lVPXJ2MjXEsDqDZkD9hr+U8A3bxeBFSYLIkHnBhRDe6eJ/Ul5w1W19Wittc4QHGfevZ/4fsPShyxMWqUQJ1WZ8vjux56cOutNz946+2PPLTp8dmZZl9/Na1VB0fS6anGC85P/t/ffHz9ivWtLCcrRCa2mjeTs888q5075/xB/lOhN7lE88lxlWTY2vta2VypI0BdAjD5SJcjGiCupnzb9Xf9++evLmL++Ede/oKTT8nhbr7ujn/+3PcHhkf3NcY/sHbdyfHitnZMKSfEqj0Plm6YIj5g64h0tkDm5L/3711ajS9YtKRTQEmNBGyecgjYQmaye/FEJIVVNWXIJQG7aTR49HRxEK1GbixHsTITM4IOLhFRKiirxlBH0mEVBKgkKUNt98YtwOAcquoMCak3QcGCSKGhHMfU5SFHlkWEtSz2WVPuOCoodWHSxXLuBaxtISFhPRRrFRSYDGsuZqiig4mbzj2xcZ68ykgFA6lzwodEsc9Te4ochZ/8BqCqYAI5wEOTotAk4e6Cgt7xUNmU8vDqcxhz2VuzR+8z7WYCeENE2mk0+eRTzfkXaIlk9mG8uEoV9VSZnfNGyqW2VIQpwTe9tcCohuAC3aqUlGF9YSsVc8dj/PhUsqqeZ+25hG2IKYzhPGcrPuAGD9n8uftIetU6AUQPW7mkAEVQlAGqeLKiAtEKFS9flrx82bK7pzpb2rNth7qlxVF8TC1dlphcUKXissFF109sqxi7vePvbjXPr9c9MYML8mfuHt/+AH9z9THD+3e/eGJ8OlVDVIiwWEN+v3WrTfSp5Wf97EP3uWRR9ugTE/967eIPvrpl6MSff/Mt438TbZlsf/uK+uqV8bmnz7XGTcQ99K1pF40tuwY2LCcqGZTaRY+rKhOHFUGp63bLQJ7HRJ5LLZssoqzVWHP5W5PBlXf/0Rf8hC9MPnD6umgoat2+ae9V+3ZfdSPX0mTlaG3N8srqxfW1Y8nYoqi/Fg31RWkS7IiJNEriKOV6nFS1SIgiQh8Vy43ZYM1qjgeTBRjzntrl/G96P3ktmVvoLoVBYjco2YkqGTbdkxyyzE+MT+7du/eJHTsfeujxRx/ZtvnhJ3Y8OjE12ehoRjGvWrf2xS875e7bHmk3dW6q+epXH//Hf/ahxQNj7TwLsJMw1Nlos8h4wQKK3tLe4xB0T1mLLZ9XT3a6fEdRtEykmRZFMVgxy6xZBoVipu3/7A/+cWbPjre/7+KffvMbOp28yOWTv/2vBr6DudV9tV8cPo5EOxyQOwHbrCSkC7IxRFYJJMjgRuPaZ3c/tn1u9kPHHbtB+qfRZiIQel4uSiAhjoSTQlWh7HOjBSn7EgC68MympODgWpfEMZEQGKoinsFe4Pp8f38sPgOg6i2RtlISUYj64Cbfy1UFm42aYsaTJ4m6FLaQpAxCWwRhOGNYKgEhpqTtSkxOED5OhVTFZK28cu5pbu06iA9g74UPguYfRjnO46Fa5Zw12Ze21+PYcpQV04veOZYMVPNGp9RJOexy95wso09NVbP38/+IDUBFydhWsz7bmFm6rNJ1/eEDMyRAz1RPhJatNi9+nfvGZ6meqIt8o4PVS+zrPyB2kRbTylGwZdWsMMeu8z+6RWeaXK3oVJOiXlUkzGHfXaxCiYqCvKggTLieaBRXLB7c6z/8n/izNxbrqql4QHw4mIhYV1AUdHF8D6VOh6e5c4neUwHUkxrqilCAlA35AsgdEhuyLBps6MkTMqg5Y9CeNRB3k78BDyIJoxA+bwhVyyzoaH5vo/3Cvr6gQuOZAbz20T2n7kLVzaDMKoQYTJ0yWDriLxgYfPvoks9PPLG0tmL/lXfVz9pQedGZtKxy0ntefteffp6cn/jsP42tHquuWtyZnYDhwN3JJ2fz6TklExRkAkOOgt+SqjGWuQcVBRaqIgsFxYXw76nmxJIXXvDCPxn60Z/9ZXSH79zx2NDrLl3z9+/c9+jt+SM7s3u2uW2Nmevvnvi+VybUknigmgxV08FaPJCmQ/V4sC/uqyXD/SM2KQh15pjtQJQUCW2vYI8la2IT2TiO49jGiY1jG0VRZKy11hAxB4Neb4I8Zcni8STkoUVRdJrtZiOba7YnJ2fG901NTOzfu2f/7l0Tu3eN7941MT4+NTPd8NoQuKhaH1tTP/+SY8446ZRzzzxn6cplf/V/vz47Y5na7/2F4/73b3wsSgbarWYURUFbLkSKvSW+5w2J7gPGgSf5kPKoMK+LKos5yRS+QpxWUmZWF0WUVNM//l+fve+WRzecuex///rPE4lN49/65OfuvWNzbaRSFJ2Prjt5qUlnfGeBwkFgjx+UuyAoHAsV/hE0/nvfnpX9yWv71relAEMDnkK62U+nCnCqJin5gJpZzSJmhgs8TXTJLr27IULoeM8IiopeDdRptEgQe+oQrAfINyNkRh2ICRo8KdA7vgd+FjEzsaiFt6oOZDhw4dWysBbkcxtz1seiChVL5KSdoco6n4kiTiv+pZcHR82j+AAvlOxe/rYTtzXv2rMpj4d46cXH9F90hk43KYYSPU9Gks/sW37yGwARxUm8fVfzD/75m3Pt5psvOPs1l27o5iIX3BstjE1Iiw6f9zK/+Q5/9x1U9Xzykvg1H9X+lSJNkZiohCVA1YwM+5VjMvUwi8IcvbNCBMSWrGoedJVFPcMAmhD3J6M7p4q/ua75R6+YikClizCgQj43HExxIQvqzKoSOPTd7EFAi5Kq596ML7Ocpc4mMVufi7EaICDK4d6LQP4UjQS2XAfKkgYBMM6sr+lJdXPzVFa35oeTUx9YtsyrX6jrv6a5p8uEKCmCQexHVTMv1tBHVq25M9t9f6sxIvTo33/r1LXri+G079yTjnnbRVv/4Qrq5Lv+4m/W/O7HUR3qtKcNc+xl/xO7+1cvAyBg7oXM4dmp2h9nfoKyVwT/P/L+O96Wq6wfx9/Ps9aamV1OP+f2npseEkKA0EKoiiCCCEhVigiCfgCBACIdEUFAQAFBURGxUFSkSJEihFACpPd2c3s9bbeZWet5vn+smX3OufcmJEAI/n7rtV83N/ueM3v2zJq1nvIuMPOzR5obNz3mda//6nv/bPHzB3b929c7OVb/0TPMw6CDeb93d757d77rwOCWPfnew7y/v7h355Fr81BET1kKKhoEDDhiS8wQNgqrUrAECyTOWWuNIWOMMcY5k6TWGIYGZjEgNtENpj4tUQrqSymLougPikGe5/ncfDfPvY+tQdasRWNTo6tPmLjXpi0bN09u37rtzJNPOvXEbdMzk0lz4uBB//znvuHCb/5gcqLx0tc87FnPfLblRL2kSUsRCGHFWr+yaEC3UUMY8pOZdMIQEdkkC3mRMHVzdiONf/vXr/zTRz5NE3jX616wfctaIXzxsxd/5IOfn5hsHChnf21i2xNbGw6FIuoX1p9V02RWONQTgFKxyjb+e2HvTYP5V55welMafe4YZNAQta2i9W80VwF7SlTFEFHw7HNLrCrRXAhKlRdeddOV40Mi0SdSQ9Tu0QJmSkCCKOVmKHSs9EwU9qloKPXSHxUISSDBavBQglhWAoIyEaJLGzSQL7XpzJjVIOyFXa+sJKxJhEjBoa+N33pC2LqNFxdhjdCPX1iV2LbXbP3dF5U79/DYjFu/pvQdFZHgDfHxqXo/k1FxmH4G4+7fAAAkznzrspsPHmpkzenvXrbv1x5+YvU1dbh81K0ecLRT8SpkyP7as8t0ljafZc76Tc3GgywQmmCAAkEQAMPC5E4/Jb95twxyNqwSlmQWqxZT7PQiQIySKjGzQCVUuV4klBLrgA4lrdEr96R7FrC5WUmUEEFZg2eHUJ8z4up/XNIfkYoRhGgSecwPsBJBFT4PJrNAbSMuKiqVwEO1wqLOkAhACKHVSB8zZb9xZHGMmjd2Fi5e7Ny7lYZQax/Gs63/BOoCbsUbFQ+edvaV6+7zu9d+ZdFQut/s/JtPbnjlby8Ojmx50mPyHQd3/c9FuHbH/g/809oXPrtIGlz0EnA2PZGumdIqpWGGKPGQnXSnumEMI30z224+/NVvunDir27+z6vdp7+0Y+c1617+AnfCBp4w7Y0nTyhRb4Ben2cX89nZwYF9vb17+nv354eOlHMd38n9Qm58goK1YNGoPZoiCdZ4YqioKMT7Qsuu1I6ysaUgqiLR6odExQfxRRk0qIcjlzqXOddIt29ZtXrt6Lq1YxvWr1m7ftXG9Rs2rF+7dvXkyGgjtZlB7eUAvug71730ZW+58kfza9eOveUvHv34X31q3hVKCeR1GO2v9AGOmHS6Y+VjVfUE1VD0F4m130d7dPTyy255x1s/3gv5G172zF9+zEOkl+862HvNqz8ykmUl55tt9sdrT++XHhYGhFqydLlW21Ef3VAcYP7qgb0Pm57+5daJJQpjDHujFOoGlpISnGhgImVLkoNSDYcT6RvbUC1NFCShuHBVjx7XCRDXUuwUw2Z4MhNReZFBBkZCh1EyEkLk9y0pCNXNMwhp9NiwJARYhbIYaFGBS0VD0LHUtAjBs8k5UEIQHRRoJAqUA7WnncbnPSwUhTjHx5ZoqQ5rUOmIxjXES4kkNdu3AFKWswCYYJmkth4bjrtd+BPHK0D9QmwAqmHrhjYozHW6j7nPhvrdwGBwipDTnkvLI9fjhIdyazogapQwSGlsc/Lk9yBizFESMq0tPiIFNj7MOOkEc+pO/c4PottghXquPiXOYiZVo0SRLsscdQ6i4RdAYGblUtul6GIoDsybzc26B8dqE41qacSgWisUSreVnREHqdZxgyBEShHvV7mVGClVVKMBoVQ0AkTbAMLQGDu2XmNDmwQBpfzSzPj7dx1ZKGRB8q8cPnB2a0tkTQ/vfS2EW22tWtF5RUCqmgf9pYmZ31t9wtsP7JhoTCxefM2B//jyuqecf0Rpw0ufPXfgUP8HO3rf/NHBtetW/9bjZvOuGDuybWPdD6DhHlBrh4VGI409wJUtU6nXu/pbaMWeHqQ+88kCmfu+9IKJTR+95oNf8d9fuPlVH1z1wieOnn9m2ev02cNI2jK2PZFuWd3EGasEVHju97TX0yLvHTrgjxzq7ds7ODLr53fn++cXDvukbxc7gxBURCTocLWNu5WlKBmj1pFtwiScZjwy3h4dyWamJtatmtqwft2mdavXrl4zNTG6efPGJLVsrbVcpU9QA4I3oSwL6bhkrAR/4XPffe0r37nz2nLL1ua7P/zsh5z/S+XAW0uQBFwQTIQpDlf/o8DjR20Mx59FRASUoom1UvpmM+3n/rWv/psbrtrxxGc+9GXPf7ovBkTmbW/4u1t3HhybcZ1B722bz5vWpOek0p8LovUtGGauR2UAmeKiTmdXf/HFG85pSLJgBxSsaoBSFLWqzsWzBOKpQWVxoaq5gxjAV+IUsfBZ4aGXYqNIIpahtUtJ5GDGtf4ngCgcMYBEA2VAYnN22epR6x8RkVTkwVj/JzJRWlAVPuhkI82YtHRSgoVBHkgUHAaeslbyzKcGOKgnitnHMmIjQERWFPCeoVrxySrDkCpGq3xm4q9wJXC0tJHEd1TDT7gT3DUFpV+ADYCknw/uf+aG//fsuVsPHHz8uafU7xtlQ0w4cAP/4B8ac7v9kR3yoD8IzhqKRcCjn41lBpMMkuhbgjIgSe39711cdTX6XQpDkUeuw4dKmzXSr1jYGCNKEiuBQSNALMrmBUKv5MM9Q1QOlSyIVEurGiLPhQi4fYA5C5YqRUd/CTYQIhEJpUSCfoV7XKIUoIbZaF2qVEO8WPQ3t1tPXNV+181zY0nr64f3/sbqNSewOzYDiMckhWUVJSYw1AsVkK4//MKNZ327c+Bb3d3rks2z//qFye3b5NytA4uTXvmSy1/+Vt3fOfKp/xzduGbi4ed25w5pjW2NHjFxD1ANhihNbAQELd9wj8e6iohSBXsrCJSIEVOW257wtGTLtiv/4iODq+Z2vfkjE9c/at0zH22SvnQHJnFBpJ/nLD1DaowxIwm3W86Y0W1bHMEFsYL1vveIVdmqfHZu/tD8/PxCZ7C40O90unlehhAkIISQZVkjNY0sbTbSdrs9PtIcHRlpN5ozMzOJM9YkzjlmHlKdVUgIUfkySiBr7BXYXPPM2lFf+n/80Nfe9tYPHz7UOfv+E+/54AvPOO1+vgzWCdSKCCSpxTCXVoelPQk/fulfPpyxIYgl00qT113wwa9+5bv3vd9p737z8xPSxGXv+dAn/+PfvzUync12Dz57zam/3t4877ssKoSgIEUUTVOtARHHfG7X8qf33PjwmXWnpGvnynkWS956E5TJyJCzLaJMQmY016BqBMH4ngMrPENIWSqeYDTAqBfOWv4BpDXixsNMCY9ExcHKbijMmaE8aAWJ0qUMoK4RqJAyAmCqamvcF8CI5vbBTGbWGQoDi1CH802n5LWRpS98lq4auy15KQIEVpspwNrPuUq+45mv5DFoJTcS3/Vkh6RPq8K/GHnA8vELsAEoS5BS8ZBT7497DDRAtVwWAQUOAwxmbTqqGiCFSUYQVdRvY0vUKlqOTEZAREtvpqfs+fcr/vsr9pg7HMEPXE1LoVrzL2o/IwDEECJlJmXiQjEobbRJquymSYNn8QRLEF3GbeHjTKgVQUFUB6V6PxAQwIGIEEQLQVXC1+oXq2+24stWqJsgqhq8Pmn16k/vm58LYVdRfOnw/hdMr19+WaqFpsZy1vXXCs9PQh3FpA1vOPVBv3P5/+4J+1dJ+5b3//v0mmfaqfHGzMTWVz3vure8p3HQ3/Khj53kmva+p+TF4crmPpooR0wOjCNpZClJANFt1kJrhVGQr7T+NVMaqKCj7EIxc+Z9HvpnU99+99/Mff1A/28/d+O1125+wZNmTl7fW1g0KjBKUapXNKAUKkMgBBglK2oEhxo4pWXPm95qNp4Aiu3w484ZqS8xC1Db+4AAUYhCQpT90EpvXwExcd5UUHRxITdpg3sd/8bX/+Xff+QLCHjcUza88c0XbN50cj4QNiF6mDCJcgRZrlgJjmsKdswPHHMdlUVEBM2J5l++/z/+5kOf3rpp6gN/9f/WrZ4m1a9+/XvvetPHszGm/uL9mlMXTJ7V931vKS3gXR1DSH17qvj06Azge4tHDuSdP9h6qnrGEPNZ0XZre0dWFebRgrMggYm9CsnAEi3r+EaOfW0RWL1DS6UnjoUgT+lq4YZqDrIEA+lR6CglBWAAAzBX/jDR74hITRVv0RBxh6j/GJdcUSZFUDuaJpZC8A6lj1YCUCu9kP724/m07boyAzvqSuc7Zvd9/eZk7dTYA07i5tFcjWOf8QAQueKmA/NfuSw7Yd3Eo87WbjeQ/3FtyGOfkbu2k/zzk4K4LYlEJQZYBIWfLXpFWeb1bRDVkkl1Zrue8kvdRPQej+P2ai4W78hJD1dGVYUPocjd/c6xa9fFI1cP8/Hlxpbl41XBsk4ZWIjUVIrKUFUNrEpsVAJryVqoeqY64q5WxqE/zFAogaLI1JJpKQGMSq9UKUJeEaQUH6KSZlXJIQFUECosaf0F40isHeTl9nb78esmDw8WEtf6jwO7dwSNGqhGotZ7NLoMlZYEouopqUaVPbWwc1KeVTRfvulk5b1zTt3h2X1/8V8oG91ut3H6pu1/+DtFIkk/XP+Rj/HVO8glsC4aromqiAYpxRfGUJYaEbkjkSwJc7AsXHJRkgLMRAoKIWRrT3/Em19+6gvOLpJD4etX3PLyd9z4sf+SIiuC9YULYhGYlK26VKxT68gwMxmG4XbBX92z7zudLinysvCig6KMrzLI8OU9e8/Bc/BAIApQUREJlQOcIMLKA1EwFBwFM9zShGL9EFlDr7j8+t96xpvf954vUNL5/Vee+8G/fveG1SeGEmnGKzeeagVkhcHRu+OSovjx/OWPvXAktGq89elPfOOPXv2B5pj98IdffK8zt5Si1+3Yf8GL3y8m0ZA3Q/najQ/KghYcTNCBrS0rluWgS80hVVUNCgtSpf8+uOd+E9MnZTOLoWMlDdDAQkpVczUWYxnESs2SrI8dAS1ICyWiql01VBlSUjGq0Fr2J1p0aIAEkLIG2AllF7WNFKzSI+krUQB5RQGyAGuUVgyMEGGgFmpZbNwhKqEqtQQHtUSWhUVd0zETqThFosZw2tK+Jo95lH3wg1QdiaXbnqr7//orN73yU9c992P7/uJ/78hypwQZFAsf+srg4xcOPvYtc6hn00SYVqQLP/dx7CJ8l28vDIkvRRAEsAoCW2JL4CrapugdQoZMLPqAIDF8V1XYTO75VHveK8LMyaHsGnHKSsteIDn2FQOsAF0qghvH9z01akZIzSeiagKuaI9UXNNIFRAF4JXHmi4xomIMKUsULakWX+IAUH+x4QsjJQGwRBy1iao1Oj4wQ4PGAJbIaRm6vy5FHxBjhVRUVbQQ8RJUK1MbjqpDMvwVqQRNay9yHRT9p6+b2tRucqC9efLRvbe2M41i/fXXS2s/GiUNJMoKBJhYBAvBlDJPvUe31/7uqo1Hwj423lx708EP/KsJXHRozTlnbXvREztp3813bnrPPzaunwVbIgrUi865zNJocqudhFDG2RbFmZd9x4qFF4WSNFoGRM8fmNgM4BqmtFgsZKPrf/kFr3rM237PnVH6XXv2v+vfb3jdW/TaXY3RVaxJyEtjVMh7FVbEIxARmErmTjnyiQP9nlFNkkDMNrEmsSaNS0b9WlZQrkXQ6gdG6/lJNdoQYPISmOEFhtRZZoN/+LsvPv2pr/6vz37+tLPTD/7ty175igucbbLxitJ7P3z2otA009LUJda4DRx3P6inBACNtgr1DK3G6Fj2ta9e/fIXv9uZ3jv+/FkPf8i9JXf9nrzkBR+4+aY9nOYQff2mB57hm72k2p+tRNIyqxgiq2KjMKIEQ4gSUuyhlt13Fg/c3O8+bGSz9AsQa8wWeLiIRCsLEhDImJHAbEGG2BQDEzoJ6TBO58oaLwgC4ONfIgq/+sJGWQJ0JJEN0OBR9eakPJBS0aKQsLLKqIoJUa06eisFhBCJgayhId5JMPEVhERZgrHBDXrJITbTqSa5leDEGuVEywkqNw/aJ1NqqFQNgeoHf4gFiE8HK8rcjvZbjWSETxpdsVCQKMLRL1VVtZbT06zbPtc6f5waxvtiCVo6nHJLpOjbWrPluK9q/hwzKjGBymjqx1MdzQUXXHDMVLuj46ho5bYmbvx7UAkKJhSiN+xfmOv6yVZ6nPOno5LfWlysNT381Ns6jeOfg4KIY4CtBw/QNdezJahAyphoR6PzGPtAxRn6+oHy0kP5U7ZjTUM0CIyFQqz9wk06W1gEeeiGwckzIlXXFgQU3UyVmNVadalyTANC7AlXGLtl5y8IBmJZGBKpmPWfSkZBhDInBTGDEMW2TLRVH2be0YRRI6MYqGWRCMCqZuNIP1w0tziZptd150+wUydn6aIfEGdEpJRzRW05Sm8jQneWsorzWxt+2Nt7Tb+zzsz0b9rT75fNc05bGPRGT900mbi5i68e6WDusktHTtmeTzYRCBpSx62Gazhmo1S3dpfObEk0YtnNjdz66ifZQEnr4Je4wY2GMXPF4bHtW08//7x+Y/bA7uvTS+jgxd8v5nZlG7Y0Vm30PSXD7IQBAwbDKNVXVTtevzffXZ/a1amrg96qn1i9CLXIUFQb0vod1AmaVi8GWDyFYExv0SdsEmuuueaG1/3x+97z7k/uP7T/8b956vve98r73+shDhlRIXAUCQbHeVIrVdVYvFj2KIFW+iTG04q9e1DVe43UxSzLrrhix7Of+kf79u96/Vue9qLn/naZG070gle8+7+/8N3GyGS3mHvphq1PbJxRNEjgI/JGUR8BLKL9fhgUZX9Q+iCWEwLHE3DMIjSSJfdsTxmqM1SA48xDNFglJSHDSsi2zrtmEciSCeWupsylbOrLVzOnjnqoa7o8ETOJQBlj0njwYoRnRiLN4JJGOOAosoiFSaKHuyEQ1LCHGmYiAoUyoq6p3t6qICeBmy/Kz+zsPGi6edIIdUs1FtZY+ERcqs3UPWCLFjEhIoEce7uINNns9h761vj5Iye86JcVy5Kn499cjldm5IwTGydvGn3ouaAgTIClquxJlaM9eJmfz50fxy7wd/JIP78NAEzWGGd595HuJ79z8479C/c9cfXxjvmTXIfb2QOqHJVhlLB3N669gZxR8VT6qv4cYg00NkjFWfP1A/klhwdPO5HWpBoCERlSUWu/cBMfKhjiH7yhOGXKa+UtwyAddBpSGpt6l3ljFID6mJ/SktfrcNqQqiQVdHoJ6hqnRcwLmCKAQpiNJcNkogUNqq2ianARQKSVmRDVE6Iowunj7QsX5w/0ykDZNd2DjxqfSQFPQmyIStbjb6KxGVjhWBWB9GHZ6os6h3dJd01jfP7qW7zB2L1P6fQ7M/c9vVmU+6+9Avmg//1rxk45VVdNWYRWaluJNabqBVR+bVj+50qqUYWwWJpIw8UvujA1GlZVHJyWBlnzhPvcf83J6/eEK7s3Hskv3nPk8m9r3h1Zt7k1MiVe+2XPOWeUaHi9lQjaDfLt2X4R9IyRlI47y1b8/woe1vIXFCqqXjJjs8zOzfU+9KF/esUr3vnlL106vRZ/+Opfe+ub3jAzvtHGVoImSgEUfuxTpUf/gJLG/WspZyeiuiLpAAuERpYd3Dv320//w6uuu/YPX/Krr/2jV+a5Txv2ne/69/e9+x9GJ6YX884TxsZfvvZhsH5AJZWsPMTIVd9vbrGYWygLj8JLr5Ci1Cw1zrIlI4pxl55rxli5r6EkeCIBmSh9FbNXARkVbzgJrZNmY8SinvKb2uptjdupvlNNAtNlHOd496u4NeTGnVQ279XRHhEzWWiO3rdHqCAIQ0lKo4FJLJRVGcIsmC+FSJ1xwUu931DdfiACW+WDef7lPd1Hrmmtb6DwgZUIRuwoOnk49/T01Cn1w/z7OAs6EY+tXr/q4Q+decD9cmN4OUXguBsABZCQGtLUTayDpgKjUb67cp6juqVRB4hL1+TOjP9DG4CgUhsxzHtme6vG2ievGzveMe/0Rbj9cwAAMBGTtXLZFbR7H1mjoUQZG35RmVArQIPCWf7ageKyw8XTttOqLIhXww4akNj/vpn2F6ziH7KhPGXSSwUEVZCGfqJKLitd6o1VEQ2esayltqK/JMxiUBqS+DPDq1XvASTERsrAQdkyZZbUxCAQUtl+DPeKCDvi4WUAWHXU8Zos/dz+w003vaeYZfUPGVvrQ8kaLLFqWNnuWxpLKsNEOefTPHrPbPKL3WsOAE3X6Fx+HbebE/c8faHbnbzPdinnepftQu7nL792zSlnjG9oEhOpRMUXKK1c+uOfRy92R02k5f9smR2zIkQhBgTtFeX4hhPOvP+D3Vrdt3CTXO27F1+z+4df7x051Fy7Pp2ccupRP8YEEihRZSh+Q6/43nxvzJj12ZIhTIShx+B6iB4cxq1xG6piWGJSZRbrXH8gn/jUF195wdv/8UPfmJstHvbYze97/2ue/IQnODRVWCCx9YOla3B745gNICZ3xywtStGuFuSzLNm/b/7Zz37F9y7+/rOe/ZB3vvMtZUCauH//zHf++I//crQx0+kvPrBBb9/0a4nofDNP8riv0/IFqwxmsetV2bARtkFoUJapMY3ExtKXQLoWQhARE9RVdUJSqtgKAMhpyE26utfYuBg8G7JhPil3tcE1ErquSmB4gZf2gLiPcGRKCii7Ty/ZMKA+k2Uk6vfY/sUtUkvEEoxWbjBGlUUYCqu8s+dFeTwxIVSbJpQrXxciKCfgW7qdiw70H79hbIRDhfeDU7UKq5Oj9pwNSzWY4y3oAVpI6TLnrRqjkZJWN82Pe0dNhOcRFeBCuVCK5Q8DEGtkPlZAPq7pbf8/uAHEfDO+Ko9VgbPmzA1TJ68fv41j3umLcOz5HPMPTExG2H/j66bXIwstAkpfYchiWCJCMKohcfy1A8UlR/KnbceaNGjgCO9nY750K+8cGJLyIev9qRMBwtCg4CoIYk2ahUtCpYLjueZAEiLpMrpgKxhGAfasEgWolgmCAohxGhEEFJStQ5IQQGUsE1XQz3r1r3YCBVMFVOUAlEU4vTUyT/LNxSNTZubK7sHNLjk9nQjSB3GAIUPHT17rdwNByRSmnEnpNNv64uIOtY0RMzL3gxvdmqnGyVKEIuEAAIAASURBVBsW8t6Ge90jL490LrvVDTB/5VXtB52RrJ4oen3DFWXhDmwA1Q2olqcamRvX3ozZVrjBCq/OhkUHpcGWU++9/V5n08zikYN75Ib+kSuu3fndb+b7DhiToDk6PjbRtE0OolAoGRgmS4YXS3/J4tw1Ra9p0zXWshv69sSyxzLod51gBdEg0YOLjOVDhzv/8qmvvPa17/rw+/7zlusHa0/KXvLyh7/rda/Zuu0UlFbRJ1NAHcGBPFADVG536NEA/OrtWLhc+qcoYUdllmX793ae++yXfuNr33jC0x/2kfe9lUwzy8xFF9/4O8/5k4x5gYrTGuZ9ax65xo7uzxZaJavaiPyskVdQocJLfxCFT0QQiETVEiWNVgV4UlAUDCGJpSlmVKbFNIxcWAFqbpm3Y7l6o1bKW0fCoZTYYNlWSkuoCl2+BxCqeDoE5ba2HrjAaQCIyMBqfnlaXtOEYRjWkiGGhEhZiQ2MF7TIXL9QMmNtK/WemKo2BkeSMIyqaRt7yZHZGzr5r6+bNAhBVMmqGoUTGMka6UO2IyxVpY69QQyCQRSJoWgJSPWUVjlOnb0K9kFVmG8AVqpQJ0Qq7JWDsoC04gcAd8sG8HOFgdaSkHflRxwrJY04i1kOH6IDhzWC3oUowpAVOEq+VdVUdyJ2cdlEeSmVsQbpXGVcR2qhPkIFjcK5oFasiw3naIHkhIas42XfOsohsoBD/N9h15kipj6qIRI5l/hBUfY8s1Bi1Qi8sDIhxrUUYiZeBy9DyR0DcmQGRfni9Wuu6i18//DAysSf7rp569bmCUmzp91AY076x2INlw+jYALYq+p5I1OvKre+bXZPD2bUTuz/y0+tG0nMfU46sjjY9qynMzX2f+x7uHVx9+v/fuPbfsdONMt+kfJPsZNX90GJlIMSESuIiZioIgRh0Q/suo3nPvP3t5935dX/+7WdF/4oXDU49NFv7vryN9euXbv7XieOn37KzLYTRmcmGuMT6kNZ9IxqaRLRkcvnBtcuHj5jJHtIu3HPVobqnlFc9oUQCMbCVpRuBlCU/uLvXvPFL33vC5//+k1X3uILZyfMk56x+SXP++17n/XAUoMPylwCTpXBXqHQpHKvve2JSrUpjeiKPaD+J2HlqCQrlQVD2cjMvj0LL37hO77+te8+9nH3/8C73kpJ29ny1h3FC577pnzQ9YnZhv7bNz1yPU3vwZ40HwMHQikaA9caGkfKzCJS+qAMJSEiZ7WRBArpUluSFKLxmtNSzMAqQqzKisCmVbjJQSgssWph/aEUYF1Jpq03VFnC/i7DIQkgJdv1OU8GLZgNw6gOON/RBJhKqxT1+SPY2HCkICgM235BiY3WqqJLBMdqHRA1UNrfL9dnpkHGe/JKlgwpl4ao54kbWvw4ZA4FQogwU1VSosCVBCEpafBHz/UK7sErL0HNmQCrNkQtAIYXhKg7f5c5U9ze+AXgAfxchqqGm28RH0xqSYSkZgtHqrAhXZbNVV035VAh2FSVWLF2hMI+NkClOCgAERPEG2M9IpNA4koScX5Dx5SKCqnDCiUFsIuq5RUbeUgFABNgVV0KIcaAGAKXhtSSx6DTj+GwaHWw5d9RFUbByiUbgjR9ePum7U9evKaTT8+F5IJbrv/bE88a40YJL8eUgIbkAFRRnYiHBiqIPIpnzpwwV4Z3zu7zY9mqXnbo3Z+eedlT7T02zQ1k27OfDOV9H7tocMu+na/5yPrXPzNZPYa8/OnvWkRPsoKJSJSZSdUQhRAEZeGlK043n3TW07ad8aB9uy77zu4f/GDPNYPBdXOLV190oP3D61c325tXtbdsWbV1/ciG1WPT443RtqaEZjNnvZJwc9dvxeEz2+17ptnqWDciUcBCogrowUOzl19643cuvPLCb1563TU7D+yfTcnwdOsBD5l6/tN+5dcf+gRKGwtlh6xLONapLRB7zAIqfhYou7gHVLFe1mju2zP3khe9+bOf/+qvPvYhH/3on4w0JpSKw4eLpz/3tXt2z2YjGM97bznhIWfo9KHmwawcd6X02Bn1RqNt9RIvw1pOUxMk8ppIIY2UR1p2Oci1olUeL9aUELV7YMdz0yh931HDl7sb0k0if2XIyV36D3jFHlBJiBBBJLDdUJhMsEAwgNNwwIadCRmjChSsSiShss0AADiyAPU9mVwhRiVQ9HmL7BYhInLEqrSnm29uOhWSwCm7XIgVIJVGS/YsFrt7yfrm7S4fDtqCTbQzwOF5AmCQM9LRjByveIwiL6TiOsiKCEAtSKBWYXyuxYVXynwve/Q9XVI7fNwd427cACqq1E8gy36nRhVliOqu3ZarfFODRGaKMmplpYrVBTCTKiEArCxKLCRgEjPZRGAGMZGJDr4CQE2IGTKrVJVkRXTQXQqCdEklrWa+w5SwlkobwWTRukjFlN4Ej7zw3UJzON/DYt49knR7jsXradMjp7o0xARcakMoEGkUr+Wg8CICSwoVP6Pjb9i84WU33trAul2+/+Kbr/zzbWe2TIfIVNRdqu7FsPc7HEYRNbz6DqUf/P6qE/eYwT8v3nIk2ZAupvvf888bXvFUc+qG2YGe/HuPb7TDjo/8aHDdrt1v/McNb3qmq1wkfxzK7TYGK0YzwyogG3VzTOQaELMKs7GqhQZPfZ+7w151zfj6LU/Y+oBHzu267sZrrjhw8XWdnX2/p7t4083zgyv3t6XIfGP1WHNsot0YTUcmkonWyMQoLO0y7kLm8Zbb2HYbUtsOMhgUc53uzp27d9y0+/rrbt2753C3M1DVsfH2phOmN54/9twnPfqxD3x4akeKkCN0GyZVZY64Y/IgD7V3ZOk/KgnAkBe77F/j1Ysk2STL9u/pPPe3X/31r1/02Mee+/cfe0eWZt4X/Vye+ztvuOriq4vpNJ1feMeJj3wIr73FdrIyYy8FvFIRxJqlYKSSEmPWqYnUGc19UBVrzfRY07ERCRUsbikoqVBqWitJMUfgscBwurorwhAmUr+zAWWicJSP5zEQoJqdDjBrKJlGg91Yige72CukYneqvYRT1oKEGYHUSCWxVulQQ5TzELgEajdjEJOIgoOKUWJDEmj/INxnMgNYhDJnerkhGkAMKXGu+S2LR20AlaJJlLmOmLsOlddc6q+4RA/tSwJACBY6M9E99ZTWvc6qn+vlLLparnEoH4SY/TMR9f7lc4OPfhlAuOaKsVc/k4julvAfd9cGoHW+U/W/l+0BP3O97OoBCyIHZgGAWT0QFFGOOCiCRJsrRaVIZSrEh1WhSFJTIin1xBGMJiRiHHkSEq2YWyzDFmwgUzuARYPT6v0IbRz+WIzVRbiAtkCDyAEOQt/cPXdk4LtlWYiPar25Relsf6HbajRdmqxpbyVxrKZuQceTpkodpaI0MNRD4Qkk/YePz7xka/iTa4+souzSovOaW696y6ZtM0olhxB9KIc8oJg/VxzX6sQBbZTcI00pf/30SX2+4r+O7M7sxvah/Kq/+LcTXvbUxsnr9i+GE57+FLLm6vd/C1cf3P/aj65+828lo20TKR2SEBVR2WhJPuaYFufwb6wwzJFET9F/QzQy/G3dSVTAMKzPAoI1plAczHM3kqWn3+ekM+696eEHFm658fDV18xde1PnVu/nCpnnwWyvL4uHpFD1xCESPQCoeBKVUKoPIZTRhbiEjDRGMDqKtY2ZdRtG1m6fPnHzfU9f84r7nzk1NQWAVIwxgENcHCs6twJueR32Ts1nAhRccSdiIdyYsizLctBsjO68Zf/vv+BN3/7fi37zKQ/4yw+8tdVwUPWFe9YLXve1r17RaCZ+ce4vT3zk+bTxZl5oBMMCEVEQlwZUieQo01LXWQmKsZFmvDVMBJFC/HLwDomG6KArIBIiUlE2UfRQEWw6vZiMDbRgNkHmW5IbUCFCrKhV27ieSKhUEqhSx1WAoCokom5jYaa9eluDpJFf2ZDSsoNAlQNCouqEAyrlImYlGHM4FE2KvsasWkP5VTlC5tQc7Hm/eGS92aBBoU59PMaIkOQGQQm7uun+vlvTGJrLxmlIJCyUN8aLHXvpfz6W7tyZBKVWkzmoalqWuns2u/rW7mXXhEc+orn5RPguNEAB8tXXXHF3BcoEcSYzlx9s8oy31L/6wNh8ThOJyN2zA9xdGQBrLUQMElopb/Cz/iSogqUu1DFV5DBlKEiFhFQibj9G/mSYoRFHbIZBvSJsSqmV0N4uOzYQQjDEQaPjBKACGFIuUYmVaFRYq/CVQBX1KIkqMZEJgCXqDulRDHP++lVMSew1JcqsFmwDse8NUlg4BuCdhpJL8YYsEEOe6kMIHLeyaNKqYG88i3ne6Cl7Nl/2kZ2H15fjP1yYf+0tN751/daZxCyIZAQxJBKpxSAyy5fmemNmVe2rpkxvmzzjSHnFNw7vmWxuH9/v9731s+v+6FezU9fu6xYbnvzk9ujUVe/57OKVBzpv/thpr3ouJh0AcB9q6uz4OBkfrZTMUEXCUfIlCIkljtvG0I3ZMkDEyqnDYuDSKxQmACYMivng1TUnJu/54Ol7PrhYnO0d3l3MH5m7+YbBgdnO/tni8GK5ONCyYJVQ5AgSdV+Na9mGc62GbSScumzLpokNW7QxNbN2gx9dlTfw6Bnzu+vGOHHLrswwzF+mAX7nxzI1UFUVIhINqmqtVVERGh8fvfbqvc995psvueQHT37Gg97zvrdm6YgEJfEvef7bvv7pb0+unljUxY9ufPjDaeOtbrZp21LGKucySuMQt3JM44d12Bvmyq1omVqIKBsb0iaIpeghPhEUfR5E3URBnqEwDe3c0kC9bdcyQUddEB4q+1bHFyNWVDU9Mbejgj6hBBzCYev3JrWcg69qa5WEBnHlngcoL/oyQBEshQCQIijBRGwpMwfa010kmIk0CwIo5x4IpQDKGTiRQH7HItm1y05RBCxgMok4pu9/P/vMZ4kGZAw5prwgCTFOUiYzTu1bbyr+9u97j/nVxv3ORdE55u7K8r9HM+HWIzfN3XBp//Bc4wmP4DWj0j/mt35e427cAIxADaKK5l33MdVfPB/F9aXKLjTiZ0JVB4mZrK2K7BaBNagKlK1C1zqct0o/esj0A1Fg1aBiCLU2t5CyIRqIwkflE8FKIEzEQAzZVgQTlBhiDKyAHQVwSQiRwBICQziwK5mMQa/XC55MMzNJy4sYx/CI5FQlQq1OseL7CynMACq6/1VTp87nV3x6z9wqmfx+b/4Pb73pbZtO2NRI56U0QgxSZUD0eIJYw57dIEiD+V0TZ/5xuOazi7eMuc3NI52d7/j0xlc9rnHihl1zixsf/dCz07FL3vfZ/uW3XP+n7z3pVf+PJpqClKlPHBVU7tBmb2IZnQnV4gVSstEcgYhUDSEhm2toM4iJgw5UtYRyQhkFLctyVkQ0pWTL1sycPHnvB/sihEGhZaF5qaHUMmgIIhIxjbDGpI6yjF0SnHONFkpFrnu7xfpk7g8204Omx4xtqPd35PxvZyzHKawUglYAxlJRFJXylGpRhGYzu+aqXc96+msuvfTyZz3nMe987+vS1HkfJJgXvfBN//HZ74yumeh2j1yw/T6PwuYdZrZp26aMQfYdCiprrUCu7cCoUj8hZYX3wgx4bkwGFU5GqHuAoKzqNbAd8XakDIVhF4q5pDiU1uo/XM+aePDoyLj8+JX1o4KkIGpJekpOniGqYLJS7sr8kYZpAEFBTAKh6H7BrAAMFEEFJAMfGERiIKZmZhKYoUrElu2OzsJ0IxuzmdcCYJHKbF5VS1ivnG4ZdZva2qskA6jqALEnh6/8j/3Sl22aSGKJoKIIZWzi2ZgdhdJlGYHLL/w7j7TkzDPQnSNnRY4v+xZQysLh9q88Aslic7GXPOJxoewQebpL6+C3PX5eGwCJgqNIi+8NitlF65XG2tJswBgDgoajfqMs1CU/7UWpCrMKGFYNAhgiEUIs9ysAQwJirQoggaM0cRQtgRgJgaNtNEAFfmmNfO4GItUYNiuRCg/L6FXoHwUBNag6Pp6Wk8RqgVeIks1VrARWogJRlY6JGMqsBDUCY9ilqev3FzSIKQ1btb5UqGgSfGwv83IiSS1moFBmhZFQOEBm37LqDJHLPr7n0KYw8aNe7zk3X/v+bSee3mp3pPQCIi9ChOPbpatq5CwORMbT5HWrTxnIZV/t3pCPrGnOju360//c+sontk5eu2suX/cr5567un3x2/9l4ZK5q9/w7tNf/yKeHAGsQqwa1fBjkb7MZJdafVpLfEeMsJJSVVRAcARVjFk4xXyBRa/KbNQoM2sg1gAUeQD6qgMwiVNOrY40wBHbaBA1lVRVtVCVKE5ARTrQcrYsyt4jNhTPWTezqTHurUgZiPin6dctsbpuYw8QEWut9x5q8sKPjDYuv/T6Zz31zVddc9VLXv6kP3nrBaUXIc1L+f3nvf4z//ntycnJ7sKhP9p+7vOT0/fIQsu2uUABH2ioG7F0B+PnHRUlDDmAlS3MUMtSSUibU30/YN/j7gFqrZKyzwgEE1NcclMD0wgxXcj3NjQ3VOk/Dz81YhyrxsHK47NCYDjk3Di170a9FAmJwCnA+Y0JcsNZtW3ESckKiCrFaIRIWIWCSilBAquwkqgYVlYbtxkmYFdnYUtzPLNuYVBaQhADTVQ0JBoIJbmRbe1hplvhMgyrQK+8mr/ydbJGpTS+8piKevGVOIiSklEOBGlTP3zly7JtixgyPlBlsLzyIQKILVLJg2899AmJQc8PGIGOqxr5cxl3MQ+gasYrAGJX9nXwg8vlk58x3/5O8rXvmYsu10By8olGltT1ht0QY35mW2KVXV99HXcWTGK0lNAtSCrDmaiVRmIgFJQa1l48X1x4qP+kLY31tiyDGqFAzLAU1DTct/foudPlCY0QRBSkyioVoR/EbEpobI+RBkdx+6lE0rl6AaQGADkFBKWDmHrlNfVzCjUWYJBlOBFla61zsFAiUYbYEHeboTSukFbeGgBAwqxxZzBGtDRqMHhoe8thLFw0N5hO27NF/7u9w/u4+NrCbF7KqWmjgAr88a8gQQjRQ7uvfiQ15zUmbir2XdfJKU2yRdpxya6Re2xozLQX9h8OJ2yYudepizdd073s0OEf/HDmfmfaibHQC2RZEMArVEyO0kogDamlxJhhwSeKTRviBMIgQ8QVUIsMlBCYyievGX3EqmSA+V2DslNSQs5x9bPMTGyICKpWQQFGhEIQH8QHBOGgFMh45RJGAwKcb5S9xXUjnd85qfWUmfXjzZaYwhZcOGPrCXVbz8JP88hEJQoJILKqNDKSXfitS5799Nddd/2Nb3jrU17z6her2iyxvYG+6AVv/dp/fGN8Zl3fH3nxptN/t3nWQepbVhWVWDO/LUOr2+JsrhABrbpCQhhblbC1xWJCoHTciKfBLKuqCSkbaW7skhGCYmDyXU2E5YyW5X4YNMx7VxDBlJRZTRj5pQUzAlZFydSAdGznyxPac2xIjKrUTw0UygQiNVG4l4m+euBQwvZBkzOlF65VyWMbzpIVxZd33nL6xOS29lgeAqkJEkQUwmXSLG1aJHbisVvdSKJVZqACI4lFp+s+/kk7N68m6rFwZD8wMUGZKgWkIUUFlNj5A/mqsWTbichzJXtsmyvugnGnL8mLehN5PfqTbgA/NQ/grhWDq9yTATIwZM1FFyX/+onWkfnWILjUsHr7iS+ZS2+4S8+hWg6ZsHqqPiutVv+oxBAIwaiQhFgGQpxGKgaBolsUw0SpnAnRCdVeLqoMMSKs1cvEFyorierPqpcgRMteHAx7JrEcDEmFMwXigaIimALgLKGRDNZIKGOGIiJaCkqx6hCluSgQ67GcrtgVgABBPXmvYK85q+X5P1l99lM2ZrOD7ginezvuY9cd/sgN+9+56+Zb0DUm3M5CZjXKhZJRnxfd6UTfsfqUh7Qo7+wr7fz0voXdb/rn7o0HMb26N5uHjdOn/OkLZx51avfG3hWv/+vBrbtduxmFNTDcEI/5KFZYpdS4YVhORNGfx1Dl71Wv/tUEs9BtLt3qGhspfd6qta/fPPqAqbmS9h/JPUpDwZOUkAAqDQvYkGFwIAogARUqA4hHiBefizLpl76V7HnGicWfnjrxqFazYYULTco0t8ZpCfy0JaDjPCbLrrkvxRhHxM2m++/Pf+e3fvP1e3YfeO8HX/zqV7+MlV3C3fnB7z7rTZ/7zDfTtWML5b4XrznlJaPnzXHHcpXQ4HZ3Iz1mVO8LDaOT4bLAgrkd6B0AO6+qi7fq4BBsGoxR9WrHC05VPWtAMZuGvlFWWk5LB4YoPAzv+tLxGYB4ddsHdo2iYPJCHADO92X+oKEkgjKGJt5L8rdQJW9UtZRQhKCqUBtRQNE6XpWMWFJeHOSdotjYGsuDkFhVEjWqVDCJawRJ3FprpzKpQUsCVmJlwz+8knbu1dRG7AIzMzORAdgLFx6lR7+U0rMEIiULQlHQtdeEfAA2dNvNf9UV9R6+iwWfb3/8PMSmyTCxRbfDF36rSUkWjItxWSPhlOnK6+7qLxmDRd60virLKZMyB4IoqwUzxaaPAEKoAQzRPJrFRWEpEhNURiCnttQOw22hCm8gICVWxM0gYkJixsrHSQUJsCTRnAzD5azGS4DJkUnJJZwklABE6qGlhU81d8hZfAEKQGDjYYIaGR5CteYWCgAEEJckHFTJecrB5A6/ccP2Z5yOwzo/X3YnJspnnD12oI0bC7Rrkd4lqdHqcYpQcY1bo1FYkbnQbzf4natPeVi7LDq7xM6a+fkDb/mn4ro91B5ZmCuL5qqNL3vWluffs3/r3ktf8p7+ddebpFWWJVeXhCthyeVPiobEGXOMnV51lYbhcw0hU0IgbBppjTRN18GndGJr9GVrT37l+jUPmpwr6GAntyibzaBOtZSgGCRUWoCotFI6b11osLCUKArbLzuT6b7nbSree/Lap02un06mi0abTWCbexusFqx3XbuqmgDOOe+LJKV//ecvPvvpry/L4sMffc3vPP+Jg4Jslhzcv/DM57zpa1+8aGz9yHy/+/QNJ/1+496Hw0GHxCnFAOLOKsgv06w9alSRiSqrWKiDJtAU0oK0TCrpeA5PWrD2rT/iAJBniRK5QkNd1dsdRGnITsspAcAIIIWIza9tasnGBkj1UOhy7UvlyutDNQi8SlzxK3ZOFHWsv9T187Op4dVZu4i0SyEVgiY6OiaOpeiPP24Lt+zS4xenWm/Al1zLZSDrACg4L6T0kSzEibUNZ9upHUtdZowPJi+k0BLG0uEjKAoskwDJ8zzPb88/4C4lxv7YcZf3ACIIJ/S6NLuoqpJaX+Qwwki51/NWuDe3YgVQLUsmyE/cAOCqI7viTSKiVTMCVHG/Rt4/axAIV5oVokSKwAwToZBxQsQKTyD4Uk2Ch6wKjRGRYCGGTYgamhX/UFSCI+tjdruMo7Wk91YPASpPkaOGqqqhrD1ShKDBwxnTJD/nJS/ZpEQNVSX1LjMIBZMhAybpzNY5v3I0q6kvBgnUeBsqy9VQkDZC/qbmI0846ZJvdG9+xsi2h2UnPGt1Z9SUs9onMVhO4qVa0EY14ncifE8NOUGvzGecefuaE19qrvj63M6ZZK2fyw++5R9W//EzsH3jwuJcZsLG335ma2LDTR/+90te+VenvuV5a+91Rq/bNXK85FXUEjtjIRJvIuvS3jkkjFDFvwQgXiUBbXNpXoSmaqmcgyzL/cdHzm6N/mhs9n8X536wGI7kWSItBy5VetCEySItlQpVEZ9LMZXmp4z488dH7jO2cdK0ggqBS0WionAK5p81OhnHYa0zIF5sktr3v/df/viPPrhpy8x7//Ll5z/k3p3FvD1SXH9j93d/+403/uiqyZnJwwcPvXTjSS9295rVnIlYfSlBiM0yvglBFFZIVrgXVHOP9cdUC+ogfVi6qam18fButExHvc+ZrA89Vyw6Y1hXbj9HNTYroJFGMQWKKTVPhOS0Qe3NIWpZOqZ/bdO0AmCUVKJ9qYS6eLV8cpKqCoabA1UK1QxBVKKly48c3NwezazpFaWhqtEtUHXTg0O3NM9bPXruZikrogNqMDRm57Bnv7QaJCoibGLgr4ZwpBeuP5wvDrwxHBRrGrxt2o20yJPCMHxJZYnELA9s0vRY2eNflHHXbgBRFJFVU+t0pOlhREuCMVoIrLKIUfgV26OCFxc7WZY6l6w4Ft1e542XRdD1O0MPuVjODDwzU6wdo/1dpph2RWUeIWEN0bqCEOBLHfEcZyPinxUIWh2bclDeYxREiZYQIqjTSr4TUBUyCCkZoSBZwxQDoYi7rh/0qgAilQIiACIXjCdyGggQZhEFE5USjU/FwAiRbZnSe1VVLiCEApqIMawkxKSCpMFhQSHMYaitw6gg08wCkChZQJRsQZzLrie5U548fgrMoUNh3wmNhNUW0shRxhoHLdMoi70FRBPb+L0jrFDLOZ4fbzTeue70NyU3/ffBPS073Tzkdr/lH1f94W9mZ2/vdQ7n/e6qJz1021T7qnf9yw9e8t77vukFqx96Tu/IIiwbYtUyKh3ErMWaaLdQf24lpB1SpijJFN+I84GVgmB7O5tOEUKwDEhEgqAjIIszR8fOHh0/7PPLOwtXLC7sHYTDpQ+KUgFg2tGqxI6nfGqrdWprbFMji9MvIIBYESKpV8FggUY5GNQynXd03H41ZmlKqHrvmTlheudrPv6mt334vg/b+oEPvvqkE0/pdUN7pHXpj3Y869lv3Ldj9+j46EI+/6p1p/xecvYsC8SrkFS4+Mhv1a7KYRlsThtQJs2IupFhwBh4BkISbM8ER3DLTk+q50iP/QommmqoqkZDDBMaEwMZWAYQssHhpePUOgy0MrJd0TlXIZAYl4U+Rs8+khiPwopC1aij8kbQgSCJrQBgQYQN1QD/uIlVzw7rYo5ZX2zgVhXyR9NhjXbgCCHsw8KvrT6NyAClamRZWArBd3c3HzA+/pwHF0FcZERW6YbCkpnrmW4RUoUPFEnzRBrCZ6/tXnPQDwJVNksEluLEVeFp93USglmR6lfNuTRpLL+kdLy6/U8+lq+KVXMRw0ekevt2P+4uzwAIRlWU2Y20/cyo3HyQkpIKhQY1Tr2nydEVP68YGW0m9mfJDIh5LGxqtpxAOy6RhIZdF4rWLjF2UGVoCNq0FFUH6uoHx2eUKDo+kiqJKMFFY5mK10ZQKBxgoKpCsqxkUUfnoYa2AGAlMoqgXIIz9VwDHkBwdZ3EqCcicIMpl7JXOk2CQLzYHvEIk1aRmWmEsGDUa7QypipFZkR551gXUlVmFgQEUgR7gBUePlWrwl9dnC1ADx1vFSKmRlrEUzKKqm8CMaQCsYLAYggluIvZNab1tsltKd/0yT17JtK1bl//8Dv/eeplTzVnbi+6B/fOdRrnnXPOxPjV7/7nH7z8vff80xeuecS5/dkFTTkmXsoQgiV2zqkuFdmJKkeBlG2l707VrgaKIA9dm1kmLQkKAxZWyEpl3SnnHjo+9bAp5EE6XgciADLmtqWM2TAzMXSoBxz/E5ataBVp8WeL01sqvtfllzRN8zx/xQs++Jd//4lff+YD3vv2V6yaGC9zabb0S1++4mUv/JO5uYWRVrvjOxesOel5rbMX4SsVmmo3Xqqx7xF/Rcg3YMQgGJ4LxApDKF1IbM5N1+wPbGk1zt5jGeBHnaeIsKlwZUTkFWPj6hL4nJBI2bO+R8ZChZZyxHi9ZAkSShRTOAEYJYN8GJRuY56e2UcJlACpWhal/OpWtZmpIkIjgmpd3iEdGu4iAe8c+Ft6nXtNTNZVy9rPh9gqeQnnnXjiKh3xpRoiL8JsojajO2Nk5gUPDhPtordI1ulwwkRxltQqkRWoB0MDyHP410tmbzjim2mSOaMwSgxlUblir1y+G/fdmpRF72c5RX4u46fqARw1iY/zA7HXB5SKAkL3WB0GIqHleUxM2wtr05p7b1n+K0TUyGxi79yJCd2m23Ll8yEKX/IJJ2hiIl+LlDkqYumK2R8ETccu6o4IAbY2oa6gb7EsLiIy1BSK1hNiIdUyhWqVkqoPvLLhtuKklQ1b5TAkjrOCDUiF4Am+khNhNRkzyPchXpjJD9T3hBOIQAEOyplIqDnnqiq3E3tCEcQn6hMOSoG92D8/cMur9970mV53HJzUy+Hw4hDEiRiFamCVQJ7gWSXVENA4aAvXKP58Yuv/25AcLG8U6pt9cwff8U9yyXVZOgZ13U6vPPPkc9/ywlXnn/3D1/z17i9+LxkdCXmIfUtSZQmpNbxCjrrijiZRA06X9No42hUgNAxtypKooOBl+DMrJwAMyJDajJOZNNvYaG5sNGfSrGFSIidKXoar/897xFkhgiRJOou95z/rbR/71L+++I8f+7EP/snqmamSTZLg43//v7/73AsWu/12kvV8581rTnt+elaPQgFhUaMrW64KKO+QIgvBqQAG6pxI5qWZN9OysccX/3X4hiNmIZh+bGjffpEekNpTr4qjkjQ0RrQsoKphwINZy0y3M9mWf9NKGZgDOaNSZPfssIMGKwRSBlN5OBlc2oRFzewF1FTPlFoVU3cmVFWN2H1F3ilcoW74plRmd6qqQfXEjVusZfFBQqUQF9eD7IGn8ZoJ7pdpRfupL6BhCl5bGaWplF4AqyYxra9c17vxsDStZeYi0MCj55GXwmwNzKEOQcwdXE7v3qL/UePn1IDWKIJ3n1+yj98i2T5JDntzSKdz97zH8eZ7HvXDElD4JXWaKMehqnIH9MWWZ9yyXI5EVMXzqtUykUTOFLBE1ViSbCBSpbYxmYFX4TA0CFy5B9QWjzFUqTLTaP4VaknnGDYeu+4vvyxag4U5iEhdFGaoYU1YMgqp0ZSVtYBxhhIKqiQUcxLf1ZBXAb4YNQ0hjmghVaFjP1dVeV0mlqQbQsmCXkk9UStqUjVPGDthoOmf3Xzkg3ML6phLtb4qtgwvIquQIkBYpe4281gRskJzDf2k86qZU9+1fp23t/RkoTnb7777E/471yTJeComn1+cXTN11h89d8tvPOLS139452e+mYy2pCjFkKoaY4wxy8+5csJSdVxt4krw0QMNCAiitD6z444LFYPbZtKQrLD4W/n6+cz/250AsJZ37dz/5Me95ktfufjP/uq5b3/j7zlnJJSO8dY3feLlf/inaZ55oqLsvn7NqU9NTjlkytJ7EzQaqS+XsifFddI3ikePTAVtRTg6lVOmnLwsn/tI97r37rnhf2Z3BUmbYYTEDa8Elr2GBmixzEGABiGFeDWsI5NxfkMKHsxalRWFCIrsegSIAlY1LtlDTgcpAUagAzvTTbdmKBlqBAQmyTD4fjssGACVmYxytRNUcRUvf6XGzWnpZMxxU8Rr5WZkKKaVqh6SJBkziyDCeGrogckPsfoGyJA1EWZWnSGTiqCZYnIUpSrYwByc633/1n4zcR6m8Ozr/qASvBhhY2A0sFQOyT8nStdtht2326866l/v2hIQVbkzkyKowibu4c9YOO18c8t1abPkbfeh0XVSDkABtFTziYsmMyuBQEmadA/NXvJP3z7n2efd/scJIMYQkRZ9x2SCV06WH5ZHxu26U/2+H7lWpgsdYQUoQIYdrjhGLLUM+RBZsawa2QysWv0JoDJ7CQAzaxW4kpJCIrOsPicCkdZbEa1AZwvAGuIc8+xUAxOTMpX9bshzAWySWNfQWvXTNoyWJH1Vr8ykHn5e3SRUKma+aUlYiGYVlc7oCmoACHMlBVDCKkQcZQjhjXgtf3diukPl3x84+Hf7O3vL/JXTq5NBXphQMqx4KAkxa+1KGrcpDSZI34JUTKCSk0PFwadOrlrX5JfuumX/3GKbZvTD33DzxeivnBXUd2YX0lbzxJc9lVePXvmOj7lBseFpDx90uhDbTlOmGseytPr7hGop0IiSB8eHL9pxbspcwshDtBoVd9sBTQUbvUun+50fzGytvfbqW5/y66/13n/i02867/yzpCNlq5See8WL/vzf/u0r41NTC6E/6fM/2XD24909d8phE0QpAhWgJBohMQArFjRcVvQf40YhqeE5E5qi4z/wB77SObivR4l3/Xz09PGxGSQ9WSQYPh4xe3lmX+/C8ZFE0labehEoyOcsPi7UVEnZSJSNDkSkamWJpIL6IVKNFczSNe7HZtUAAxMSQcEhJb8zKy5qq4kePRotKWLSR0u95aVb7EUV9iDPJ421wxOOeUrckjyI+znyADI1ArCeWf/zo9lNDfOAmXZpI0xbNUSRIw6KJAkb19BNt2iAGFx7YK7wJrVGI/FGKMLPhKj0AQhbxphC8N5zY0RdFt22b2cZvqsVMO/4+Hkwgal+pAUovDRn1tOqDcqqErRcVFiC05XsykooEcTWDDrdK//rG5vPO41Td/sfJFAKXos+zS9Ku4EkPeoia/CYnkCpMjWCTldDgBCpIlRamgCEMEKmzRwUUYZMiSol8noPQN0uUyaEEDeqWGdSX7d5l05ruQTF8lkxZMQQ1AqXEaccUW7BRx06EgVM7EGpTYxPPAoiIRUoayjBC8QtVQjY2JZKj+qUnaEiUpVi4wMsA48yPl7RVAABAMoBpCh6L5xZc7N0L5wtvzyXzuc7X7F2y1blxWKh1BHYHqkIgVUhrOQZ8ERE7HyIYo2phpC4Dvcenk18YGPr2Qu7FvsHeR+aH7d2djDy2LPhJhbyuZyK7c/55damkUvf9rG8t3jK7zz58OyCMQQJw6nCzApxbBwP6wYkpLWafVDilsWGLPH1xGGNMNX/A0NEhknPN776o+f99p+efMqmD/7dBevWTvcXymzUHdnX+X9/8KZvfvmyselkbrCwTfPXr3/wQ2nTzbjB2IkoYz5MW4fSbQsaPl/On+1abbaKknzzsn7+xe7OWwtv/KgRI9Tf3j7wa5PbCEwIqnZY+64Q2ytb1lo1xwBCWVBjNDTaoiWUJASSQQ3PF670zmMARHVZaQn9UJlzxW1AmO0kGmdCJQcbBFaLcNB2Pz6tXWcbUoX8lf4o3RawtSzzE5P2SGNuVTuvK0xDWS1V1YBQzC02vDKRVnIUEXxK2YFB751fMHO/bH/pxMR3raOiVFU1IBJVZ3Dipu7Xv90OFCwO5BLUKFUsQE8sQtE6YkG628aS9aO2KFnCgkxMUpJwr+ct3Vk87t0yfiom8PIZcweZkEDthFaZWFmBpSrbPM4JENA7Mj9x0qapjTM/ds/UZpt/8L/2Mx/jH15YBGu3n0TDHgATiRKzFLleeq1JUhrkoShNpeNWmZVGs2tL9PnDnXOmzPZMyggQinEOxTMiquTJaj3fyh1JOSIUWyXFzLk0KCxVHqrR/ZOp5sYMvW9VOXbXSLLqsGQMDBOMtTaxCiJWIkPxt0uEAiAlQwCCV7ZgS5WfuKrkXF276OqkQrpkTKyBUONPYjRtACIJlln8fczIxX62U5gjYeTCor++Sds5KfSQaEKRQUeoCcYhfg2Gi4qdTsFSQjk3OmPxuQPlob7J+CAVh/zurhym1klrJpNWkZehLFbf46TJs0+++gOfkp2zJzzgPsq+Mn4FItUe0MRaBzUKS9VVjh8tDFWdSs19RxsAHJiJKpmzmkcdj8D1xKTju279+Il9lw1mpk/881f/4Hff9cSnPPS9f/3S6enxovRpM7n8yluf/cw3fv+H109MJouHynMn6a2rH3y/cv2u9qEmRhMRqiTdiBVGlcUwsKjhc+XCJNt72xFhFDb9r8Xev8328tymZYMky10xPT73gtbq1WjnLqiSURrOxuM+y9F7WkSh6hK0xoJJoB4hQHLyJdiQVr5JlVs1iyEqCCriovNd/ASuQihikJZZ87zDzTNLlE3vcp135Y3Z4POj5aGEM62S5qqfy8cso/UpqxJj2ro8DM5oj6/jdimosHi14FThOGjIBmzVVKwbjQEMBcNGTfK9W3vc5DPHqQzWJHEVIIUaomaWX3FtOt93qb30sOyZp9RxKaxgD1Jw1MQrwE+9R2PtWPCUixDOOotOOIGLUphufzWloxe7n74zQHfq7WoW3hVT+44MJa6V9vt628ZJItKcGm+Pj61oMikrGMdOjmKge3boLdfq3GEkCfFK8BlBg+j61dpuol9oqzFE4K0Qo1ZqGHKIJnGxoB9LENEspPqxOrRZVpRUElQNqLpQccy3Xs6BEY2Vyqp5oBwzegZIRERCCFL6UJSkiNAYETEO7LQS0qodN8qekGeQkIFtK1hJKmNJ1M9zRQ32FfAjeq3Ea4LCh0FBIkHDOuI/ntmStbpCYf8gvGbPrs+UvoX1LmJwEI8kMd2iijRXGhXrIw7EmqAIcISZxIOc0LgvNd/5nfmv/uuBf/zcwesONPKWNVP7d/fG7nHmA97/ml3XXPXtt/9lvF6sloiITKwBsgpHwTAiIdQYUDEKr9jacCmx1Pfirl+yf4IhK4WDZHiqxtB73/mJN7/uI3/+vt9/27te2Gik/X7uUvu5z1331Ce85uorb2in7YPz/cetG/nr8Udul5mDIwdG+w0RKaOhc8yDoBrg1HQlfL6Yn2T7sHTUG5SMfz0w/9XZQaIhsM+t+GTuxKT3PLd2jMbzxHPa9WlmrSUFSZyslVBJbYtRvawBk7Kh5pgYi5ArlIsu+XyJlwdVUoYQiVGNk1cqHfWqJTvklEEFbuOR5r253DXZ+xH3/3Mq/+hk+ckxOdjQ1EdYRORIatX+va32NJUKx/kzxs/EYkLCJGEIagoqRVF0et1EzJBVHk+WucZ9MAaJ8Ce+0vnUj3LTDGVGCiIjMe+fGR85aWvICwMKkoihIBDREiKCAI2Mt4ds07PWaKlsbBPWYHxcgw/W/p8I//HTZwD4iZIAADU+CABHq9Nqx4yKwcteSiulDiqDhSWQ+rKgINjVU73eRVjXSu7zm2hmpEs6vUSsJDw+EvYd9jt2cyNjMqHXU1Ie5qcgVRlh/lZncW2qZzRtWfVpI4dseFI8PMuYKMfaZzQYMI0BWQqACrhIuYIwHz8ioMqMvMaDqLGw0bEy9j29BMtWCcSsqkysZLQEfKgE15Urc3lHUGVmAms+RFAIkRXAGANRCVopj1BFUICoiFeujn/EhfXOnuD4f+ZnG0jhzdcWF3spnZMkNoRgpIBaDbHnGvdPsJBQRcCMmtKKBvMP+/4HHU2MgYDQQBiUN9xYdPrd9kYZCWNjDd8hrG6f+LB73/DtH+399DdW3+u0dGqyK56VlHUyWCI1qkSqBFZQ5ddOgHrVB7Qb09aUWsu6YmleHJsBMPHx5Xd0+QRaekGPH5LdyW1G6wap0XoqWmuZ+IKX/dUXPnfh3/3za85/2Nn9wcA665z7mw994WUvfWOvWGyPjhVh8blrR97SPo+5dcQezMqWUsVxZYAJUZvSeLPbFJ/lzjQlj6aZgfFk7KfmDn5rXlI4UukGdgb3HuFnjo5PaKPrjBpMzhiaGvBiEbyNs9ewWgsIo6ZJxgwXkoBCc6RMWqSCoGUouCwMYphOhMqonVisasTgN0UyrbU6ak9wIpiYvaSGZYcvLrT+eqv7xJchWCdoQizE1vkEi9Sb/or7VZtHQ6GwkuwPvSv73TOao15rCwKCgVnQsAuDje0J6XtnjBquqtFVYSmAiSGk1l16AE7lnBmUXqL3MdgyodvVy25IEntjX2+YJWcpiCjTANo0PBtkek3v9+/RiL1nISlSax74IGq1Y331DqyBy5eEO5cBHK/TS8d/n27vt+62DWDlhy67zcdXUDrmjWPMxUFiFCZptk95bHryL6HRGOoFxO8eO/xBYGYmwsVXkLOcphoERQnBMt1+ypiv7OfjqZ7eSEoJUAJCVboa7lMQaHxp5WReaScwW9VGgAKw1DMMUoTbvrQmWrsTURA/6NrMWRVH1fWsXOvJMJgpqKiahBA0FNVvRcKWeCYCMamQSRAGLKVlIqmQfJAyBChVHuuqpCTRtSwIlC0TkTI5TcpyfhuNTY0lX1rY3zQuUHJDT66lztmtbFKpGwIrOZVoILJ012jZtVBtMN8w8N9aKA2xJVLVwOgpaNeN1F+YnZqWnNvNLCm116ITH3r/7s6DV3/s8yMnb5zevLbXW5hJswyBNZrxLFOBqNhpNGLpvPFWJasdicpVhY4AMNfbQK1+dlSV445MeDreP9/JSR4/uwQMwfqSklS73fxFv/PnBw8f+Nt/fM327Zu7nZCmab9X/NEr3v+X7/6nVjZmUhvoyAWr11xADwtJ2aHDLC3Vpb2qGsoEDkqX2e56aTyYxhezuVRHvjg3+7le3tSWpYW+OpeWvz5W/oodd2T7Ccj4zARCnqAs+lZLQ8pE6gxZQ6QIwVBlRh+7UOXIRGIyESmNgUpWDEAmgJSZBEqBoQZC0IRAqqaus7NqDeYZ8sMAgprCYNHCKiWihiBGgpNQ+6fKsEyM5d+4KvBrdUACkcAxHfJhT16c1RwtEFSUiAKQsT1YDrqQGduEF2tYV4BzglIE87EFqWF76QFtGH/KdDQVMERsSMs8fP/qBLrfm0sOUJNMCVFwwuX+QT45Hl557lRCXgjCKHoLtGG9fdD5d4428pNuALd/rDs6xX9RNoDlv/hjUbKkoJg9HKX2EIUCFMQ+4slJo494hSGMP+4Dj48xsf7oasoyThP1oj4gBOXqGAmbA74gCic3XBmGfVqt7KajbltVhoUyEYMycKJsEcQwO6Ig1vOYpb6jHoh9rLQf9zVk3Lq06HUTG+Ur2VTXBhBRcpaItXLyNTAkpWhZZx4ABOKZkxgfM1uEAVRARojVZERGXcKuxQTREOKWZEbJOOvzwlgXL57zwbuk1PxeNs1S+vqgk0iWKnb2cUXITyXaDB6wSuCGSFURrTTfo+pEZSuWGuwv/NcWCibiiJYy6Ij+0kn6+KRz4WWLfvr0rvWmkbSo0YOfPv+eLO6qD31qbGTVujNPSAaeKJSVpx+G9NvherCt6c5qZYWAiaP0HdPSUm9qTbK4qzMxxyXj2Ej/9ufaMY/EnZ/kBNjoE5mktHdX/gcv+LM1G8x7Pviy0bGRXje02smuW48877fe9tnP/O/ExIj3A+fw5oltz8ZZi41u35cmtE2wBnRMTkKB1Ttdp3arGZ1N5pMw9q3F2U8uzifInJQL3JppHnx6m+/Dq4PBgEmoj9DUUoueDDpAqGguRAoNMb0QlWgLQSwgSRvKqTdQggThkDM0kIk2SQoxGgzEEiwqZ7naCjimiLXsH6NC6pKqHS/ZqMamrIeUTtRqFVNRnYjXB6k3AwBQNjAUd3YFBA1jdhb54dA/I50cwBuBMITQgr2qP5ewGeXUAoYITMsKQRK7cSxgIjVMovj+nnDCpNs8jiBxA5DuQC++MvHS9fbCg0VpimB4EHBk0BidLC54cLI2oQIapWSCz8059+Yt24bqoHdkoiybh/9/1wM4vh7kjx2sGIIFl/+6kUpNN7AoiXIABVApJFKZ0zKiNIOIuf/ZumYqzC8qEU+NUSuDsQiIMkFe/frEJGJ8rfGpwqrDv5uIT9LCqnemTXYVm1Emx0iY0wB11G2xMtpMU04D4Cvq2fFedQ9BWUSdC50O2egXP0RSBNHCa6QvRPm5BLZpyKx0ufEa+kqiIKFEbVNU1TBsapLMuqZxTZNkxjbYZAwXuCHcIJjouxLBc0E5kJfS6mK/+zQ3/VuTq/tmvqB+A60rZnHB4uw3pJ8V7IhnLRUmBBqaSQFSaWtDVEU2JGbCkmUQkWVJmA30nLZ98T02nbNw8cH//Ztkb+fAjt6hQ72pXqr7yrW/ft7pL3veNz73uUs/9U3TaJRwpHQsQ9WLANjaTIhgSI/Ormr4Oip9mZ8W6f9T03YYaqAJeHDJxbuf/5zX/cqv3fMtb/tDXxpfapLif778/cf9yksv/v4VU1NTBNchfiBP/AadM2fLQZGTkMAH5EH9MUXwYKEjQdUk/dQ3w8T3O4c/3pk1SBMfDpOuS/e+qLHqHrRmgQc9LpQ6LlgbDDRhSdknEioMqKqqmOBZAmMJTMkAshYIA0AUjaJrvB+wo0qER0hDpYMrodJZiwCnlVQyYEXbDChVPFAAHhAmOBWnoQJHLTWulGohxWGnDcsPywCDeqV3YIk+20IqiLoRB8tinFuhCFW766jqR1QiUrAoi8IaaSfy4YuL/YvLfqQ6mTFjWsGHwlmfDkqeXLf3Zee3ppKRnveeghACA+1Rc8oZP7tp83Mad88GoCRKXkkil0p/IkysEiucUlYW3A9ZdGkUYmWjbAiWYAOMkBWygSzUKjHBaBBtZPaRD9bgRQSirtWiVqaGESQgFILVzrWIfSAEVuVqDxBWYahR7zRwkZRYI7ZBAaH0EXrJlhMKBiGjfkrByjoOCUFcpY942y+v4guXNopBjn4/kHKQyHhlUmhe6qCovngAhCghky0DcZMQqRRD3w+xbWGrSmqSigwVpPRlyU45g2tbTlkHIQw8Y9hqIwGDyvaASmd7YfA7Ln3S+FiPcyIZY3uo5952qPyUlmVCq1RJhUW5RmwMm5wAgsp6aycdQiziMwicsm6eGivQe+E5M+sOHFn49MfGb771SN68cv9hHwIOdMfO3vLAVz/nxr03fPGz/23IEScAKgMYVJilCA0Zd3dCn+2n7A//FA9zPPFgmL7wH9e8/e1vf/lrfv0Zv/Vr4pNG1g6e3vPOf3nuM984Nzc3PtESUZXECgAUyZxS4Mo8K4B8ZD4cdXQR6ViwojWgHw4O/OPsnnbelDzMUXG/9vxLs3UzSBdp4CEuwJWJqgZaCOjmthdMHvsTR10cIgJlhMQ6ao+CoIlNVbXoiAa11iqiZbxBMBKqBi9J7NxGo4sVdK0KFoHKAtbYZcBoAQWrMvwZXiIdDEfE6Nfzc/krXoF5XzSZRYSUPTSAWHS+LOZCMZ3YqIwy1Aeth1FAlAK0VBXRAGXv08XC/Msl3Ezz4CFE+3eEEBYTnp7AmtVzh93BfdnOe5y2588etG4zGVfmhTWBXSCUvQVz7rm8arXQHcosf3HG3VMCUjJAEnqGckumDS6BWjnnxz1tsXQnxAHWU9L9+wt3/PXng2uOnrqBgicl0qgnZgVWKJEIlovZf6yoawDYrJ1Bv5BLrkIzJWMjDTWUHiFaeVEhmHAMqRuMVAE0q35y7nVbxpPO9AJKiFoORNGTKBg2hgLEMTYx5mAWbPSFP+5L62InM6z1oeDuQqM9oqQxpQGxiVQyTpxUlwBsCYDmFdVGI9SVoEJsVcEgtgzv1To7jGViG1lEmI0UIcwLfNVoiPVzUXViSvaiXJhe0/hzaHwH+0uLRTLUDI0QzHd7+eVhMJ3ytoHzzgMwqJ7IuuknrDxq3f8s5jcUyAwHKNgmlD//zHR10pgKC7doa/fcFK7+EakMNmydVy3F2MV+c2rV6pO371/o7Fmc3Tq92Wo/+oijTpa9yljK5441OcapVBWdlk+/WO+lulHE/NOyM4e1oDvbBFYFwXzkQ1/4zve+/uY/ffEpp23rd6XRdHv2Hnzpi979jx/5wsTkKLMNXo1hIs3DYHvS/JXWqhBJvsQqSsOSyDEjGDTIfTdf+MDCES1mAucjZH99ih7LM8aVfVMkSom4WO8gIfF5a1xWrzZjk9zvkqqJGVxtCExKMCzGSZIE51ShouxzF6QwCQmRKCtBA6O08VmLyraoG+dHlaoqoVwg1kWSxDMPLw6pT0WNClWWxVKDlRUAU8X+JYLRlb0/0spl5rsLi2uSdK3NiogWEyTg3XlvNoR7tqcHQZLYgwJFCudQYqQSgIsJh1ZlpnL3rJ41k66d1O4gfPFbONwxqmTt1pmxTWPm0dtHf3Xt5kYQz9JPAsgEDqG7YO/3oOThj1pR0rjTQe3/2R4A7vweQNDu7gP73/O14qaDpkU0NiUoRDyW8Bu391nEVtQETjrv+cLgK1eaI/2FvfOrH3VPLQtOG2Aj/RILg+JbV/W+eokaovUTWsUnUfiNFQJr7cknyJ4DunOvYQvDzIy4B6g6EEMbjiFa9xG1ltg0UCbH5syWNUT7BMospGoQLAVF6ZgLaCJCut6zaZh9td1QJANUV5pqC7oK28KGFOIsOgsNYk4ThFCTh3W4BFpWjr6IHDPxUgAiA3Yam8BRCo5IwMJIiYgMiMFkMJQJEpJCpR/iLqPLniuIBjYJF0xUBGdt/ohsLG/6a7r9gYTMcVLw/o5+Kfc3GrPZhAlGpERQfZ5EyiDL7spB7wd9GCbPSjBTJn/+fVppKBI/WBhpfnkXjbq2v+r74aYd4yecNj9BR1BoMd922cTm1X3wrd35Tc00oshBFeE1qKxtulNaWc1DUHMMxn/5BrCih/xTjKrFfGeOZAwtzvt3vO3vk0b/1a99Xrs1rmLThn75Cz/6vef+2Q8vvmZ6ZjzPPZNlU93dPOTbk+ZjmqtCTeMAYpQQ21gr2hggjCluHMjfHNnX9TOFz9fZ7vPG7IPc+j7EsxpOHJGwULWsMqCj42mrbb1H1qTBInN0XqaK401GE+uNEyJRBEfGDxACnGXioFWLU1C2IVwZTNYN+uEavfxVaa0j+mqpdUNQn4bcSEiDahShOGoN5BV+2sTx62sdFCkBVKpcOD93cqs1bTKvMdlUp3xF58hko7GpMZJraYlI44nrypUq/j2+GXMNkn4ZMozc/8T+7oP6PxfF7mFikkmbnDjSnMhS7zq5I86c9RnPFnlL7XkPTh/xKBwlR3ZXbgB6/OSXjv8+3d5v3V2m8Oj+YLfft5iXtvON68rZ+bEzT2q0uW4u3d6QADCCNf0vX1V8+4as0Whn2WB+Mew6YLZM5DfsHNyyI3T7yb4FOdxRRv+jN+CjnD7mXu4R5yxdZFH4IMrZMx6Xv//jYcdeaiRsLLcyhtrFnFWahlVAbCChavhWgYkCRCblyYwOiHgmQxw0kKFACqMW4gNMQxcgnZ5ZNQLrUVZ3qGaT1bBFreIhEZHgwGXiyvb4YL6TjbRMkKjGwhX4oVSCwDCJKikTm4xDrgga9YABhVffDbZlTQIyMKmRvFSvGsCszBxEIpGNUyMOFESWaTgKgjCMiCc2ICX1wkqdF/PkGdP0sYW5mzr9gkYmkpG0L18pymniPxj3BVBoAGAr9AciRvWEzIAKARkogJSYso3f2rn/5s6GtSe1NofB3rm9BXXLS748v/fmNb/5DH3QOYeL3kLIJ7p2pDGR5/3vHuifu6px1BwYWakatHx+VySyqLiNu4EfsBzpv+OG7t/9/cfu94B7POrRDxoMBmRLEL/jLZ/6q/d9gizGJ9q9QZFYZpZhFVSGxrwaQHIMnPyoQra5oZ/8+2DPfGhIevjk1Dx/ZMOU0mHpeiar1gqJIhiOamqGB6pm0NNGU9LEzM/66LGrCiJjbLBOjVWCVSE2AYEKDxElViUlNTBAgAYO3jIEKFWGAB3obV5tiv0Ym4ShcJCqeomq7RV0q/rigEKICRK/vtTYToIsSfZE2LdXdH2RsTUgVWWioMrgWe83JmkIwZoKba6q0X1xmApXcgMR9kqxAe6TxPYu2S+dXA4vmm6JxJGxhfF5EoQNK9i3EimlF/a2B60HtLMHPIlXrb6bJaV+inG3bQADW1pK2rkxgyl3dRP5PD1yzGuwqkMK1Qr4f2wYKANqm4m/dFfvE98FTAgqCCOdYv9HvjTxnAfI4U5r9Ra3esybYKYa4chc95Jryv2z7XttY2jEuiOuqRKAEDLm335s/wMfSw/2pGGNS9DiEkh6eSIq4rkSGWMVQOoUkgQpi1ERgdckWoZVQpZGQUY5qHJhkt1j5p6F35CEqwMnUY+wxrECtWIPwMTKAZ7UBqHW+MJCJ5vtDEYbpJJKAAMUGZKlkAFV+pjKzDaRMFARhSd2DEMMljwwWzKwycB7hDI2mSvn+spgqQginsFcZSFAXYGjqFOkEYKkUJ3F/KMw9qCR0a+NHviGn9tVLi4Kj1B+TpoyOQmqYIJoVQMVwOR5forJVlF/VtQYI6y3dLMjC4sXH+n82Y9u2XhDszMgqBOy3Nho5/r73//BiVsfPfbEX11M7GEU48FPuOYC+KKD+bkzDQvL0EBBQKmpsqeqcEFLsdedNu26M8Wh2/3R2P+I2RAR0WWX3Pz5/7zwyU951Emnber180Yj27Vr/2te8ddf/u/vj421S4nbVS16AoAECqWEXEIQDpHtBVUIYEByzH6wKyz8ZWdPq1x938xvSdIH6lRLqGt1QMGpAUiiPrNEQTUoMiYd9HX2sLSyorNgl5o/RMbCujgHAlhEWBUSlI0yQmRfUmAEaAhEC6oWYoClaJe1ZuIeM4wKGzEkrCIQIvI+i3YaMbSKwnaguC7XSH8KUFNfX1DFageDvWoDdm9ZqOUxOK9RSl0taFfZWyS71jWK4GujjoqLULP947Q5WqNFRApl3ufLQ/O8Yw8PDJlEE0uacM/bovCcD0bKzmQvOX3r6EnnjKzanif2NuLuO1nSuW057mPe4mNnoqr+ZEWku20DOPH87QfW0fzlexqHbm30pqitkjbRUTJWl8UIy9iG1dQ3RP7gfH7tPpSAqBpWQiBun7wu2zZNW1cbsQA7MqJiJiZHH/qAZUeojrzCuGFqLHvOkwYf+WR6sC9Z09hEm1oASbdkESEfVclRgaNjEMLBBpMwbCxvtxUB8KBAcaVWhwASyAEyJfGWQNeRBgIrIFCLuL2RkFqNfh6I3jGkrKQ80sz3zpvJVhqESqkEiEjIB0/OsuPY14LCZFZ8iYIkVyJly0oquXqIa5oAdQlpgHrlKN8ggCUM/bboKCJVDMGYFZWrJSDEFu5IdjAL5lfyyYfrmrlsfpZyHxobnJQhtgUrwQwgAExCorTRubXOHiy8ijGEIHq459q2pWWnKDMOJjCgDBOIDInu++QnF3bduuo5v2nWTQ7yzizLSNro5vSdg/m5Mw0QQUNdaR1SEKql8zgYf63rP3c9JEOHdrWAMea7F135vYuu/p0XPm58cjR4bTTSz33moj95wz/cfOOeyalRryCSoAAjLE1sBUlCZpocKIiGCrys1c0SwlG2SOs4PdONzGa7nmVPW11M7x+ZH4SCRFOyyoxY99AlvTdiYWb16C1Sf8Ea6w1BNRCRc8GaygCjgnRJVDpkIokJqgqJsqiRYKs5zEE1RG0zWtJzlONdH2JTwwQIquRLE6W9RaFS30HlZZCyCvI/FNYlGFbKVSyrKjm2s74MCKMmDaESqkrBB4pifZpZgmgExd3Gxi0EYhWpHwECWQHBS/G1S/3NV1NuUA7gQJnpNAbYaGjTRHry9slNJ5n2tEUyUFIpie/66XWXjZ/NBrC8x3iHMm6SvDk2de8Hjp/aHezaVfbz5j3H0WdjsHL2sNYPthKgMBBAZLbjJhsovBFG4Yvgac341JPOJWGpKoey7KEfppa3maiZdauSZz1x7v3/NNHLC2OI2DabBXpJTzQQKKL4pd4GIsNMTeLgLAVS7g5FIxQGCqlsJq3MBT0MnhFaZWRvTGx5mC5DXZU2U/RQEiUmEQAzY/mhTnP/nF07igI5CEHZijJI81LIgg1EVYgM2SxRn4soCgYrM8FZLVRZyFKpMBlEEIr6ZpXQIGU/kKU7poUvCjF5OycsZl2muZGSJnxGJhF0eqIMBaJWqAI2+gd71VHD2zJ7aeGjiqISds6Gtm24YMs8UaroHCocoBBpNUcH3//B7sP71j77qa173aPXX/CST7rmIgbfPdg/d03GiqAIK6fYLwjkLgbyxtB3vn3Fjpv3Pf/3H2+tBVFRFH/yho9/5K//K0nt1PS49z6yvI8K2UJseJJvMyMqedTVj0j2sLUpyjDEzoh+OzsloMc+7Gvs48IVpknUJUil1LTsEsWzi1RH5qhka4GQGGXjk8yKQATMUcsBKszMVaZJrEIRDA2NDYNQX/roFbrcjK/+0LoopBA2UsMeSFQkVJBTALrkyITqKVNTqUNq7NzGLx7hQGzJQCIYjHaVvYSMY7MYSgsMRCzpwTK/x9goVY5dilo0ZVj2wZAeGKkLVWhIUCZVCYXMdpL7r+dTS4BhDVI7ecJWTK2RRtvahLgstAiSGxiF/t+t/+DuygAUDEbwBdukecJmAaM0oBDX7ppLhDqh5tqSAiISS+Z21TgXBmo0Cfl8f+pZ97ATI7JYgiEQkCfS5VXFZZ+tOB74tbFlnbzg6Z2//bexRSpIiUyaNXPALPro6EI1diHecaPk2HrjNKi6EmoruIKoqCENKrVoxD7l1Wo2Wt1dwgNVNUuVawCQUkx6qi4qM4BSy43j/vr9+WTDGeJoZBwgUbtcikBueD4BhkyWoCeqqgFkwZaCquSKAJORlOAGAPiekHLwWube2Dta/TBSNeRI0ShdIFcQepkwugJVpUp0m7gm7bAqgsBZOjlNBHlCQkrEsvNI58Sp1CIfwKZkQQRYKKkqWxsg3EzD7t03vvnPNjz1yese+5jD0j/M+ViWdXL+9qHeA6ZdqLttkYsXIwO+u/V1SVmhxtC1N3VyDb/2Gw/2Qa2jH/zgxje86kMXf+/aqakJZRUvQWGDGsd50Fz1906239rvr5wVR0SkVmmSTYxXCGCIKoUliptGyyAhqNJAAN7FoVUkJSkr+UyP5OyUAh89ydlUpmEAReV6AtRaWKNEpF6hZJiGxojMBJKiKFym4p0PKcHAqHVlc8wLod/zRU9RpmQTw06lspepFtnhIxxVq2tBFxGAEfxy+feqGVs97JVr77ADbCJvHRrFhXydamipcmvZn7SpjVpDYMtmznslbMiyUiWqVB+3RKMVq1jrmhUBolSABbnYk05Of3W7dnpwKbFVJXhGURDygEUJGTSDEiivTJ/+z46759SpzunUQiqsdIlhSRcgoqzZMDZJ0pSYS19XP4WKvR1qtqjV9JqIpsVCP7vfprHHn1V2/LKGN0MTqK0VruLL1sv00UNVvfetrRuy5z55fkQzIVIYsmnWttOTUZ4NACuTKIkhISqIlNk4JaZihMqUPJEXDbHk6pg5KhSHvUw9yzNAAi1j30lJiDwjAEERncWEIKRiEAyEisK2G36skd9yJDSNU1XDAg2kIK868FpUCnpx/rJV42BAXBK8ksKYSspdfF3HaRA7Cl61FI56OnfMCksrrrEKgkeFqU4COKTGO1ZmrWu4ogggYRFYEAJOyVzGII3RJW4+tDidIUUOU4gOREoRL2VpCGoQWJSIXdJgu+/DH7359X82ebA32hgrPYS4ROO7B31JemTQNjaGzDGKZoYhMlHJK9Y0apC7/vRcsDswnxlsALn+hrn+YOHse98zSVKoef97/uMpT7jg2mv3TYxPQnSQx0nu77XKrB1vddMGJ+4eMyNtCSKRZkJMaFbdfBFoiJZw6qEBldunqCpCjMdJpAkSlsgzV4UzAhaxCkvOkjNEHJSULdRCjcJAjYJEE1bHZIxhZlIYQii41yE/qNxXFJZNIxTtsswkQATq4SwlSdLIRsfGRqbXjCUNUhUpPNRKQBQxJBJ4qJjo5GzYM3kAEs85uOBZteKO1TeIl7l9xRaPBTim7tWRQarEgpgh9UO4uehstJlIld8nqn2V00dGvYTbWPePfZOXHMXVwTfhUzWsuQ85h4H3eS/0Fn2xEBCEINpUjTKgOZaa9v9Xx9129lRlZmFZcWap9J+03EWf/c5rH/3GT7/339mWqWsQfMyIKU15qiUEdZR3OzKdrXrhAwBo1DnGUQTj4/hIHOdkiAD4UMQ9oGc0ZSuONUjimnZ8nI2pFrhK/NZooSpGrPWWFaUiDHtpzGzIMlsYCzCOODlg0DRmvSNPLFaWnQxFBcY49+MeEIBgDHG/kA2TxSDPFwdqiGNiNOz2aCEI0Yuygp1wyjAQL6GsGJWUMDOHgVb0miCmFdttPJR7POZ1/BHvVEXN0cqLikQJbKIUjECFRFgCJICUjZoiYFPmphLONagGw9gx259I7OqUAYJI8L450UrbzhBMpOqVASU5Shvtif7VV9/wqjcsfumbCSdtkxjhvreXHsHN/dnBvDZFTa3GF9XiWMXgjhUhf6aDGX3f+94Nnf1letLWNanB5Vfc8synvvl1r/lb1QaiSjdKa6XQwWjqHjZ5yq1dITJNZ9oWfQ8T8Z0KC50w0YRdSKOugYK8UkA0LRFS5aAktQXmsnsWQ1k1CpeQcUXaCiOrtTlhSFRRACqBRWAYrYwayVLZ1lj4kssCUZiWKKpnEJR97cZVM3VjIbZgJ5z51rQBFSEfkOs3JrUxoc1xso5DAQkR5SBDIK4EUkHwSx5hiJzcmLpW2QAjkv2DatB6k7CxXBEnmqoapTlfHCoGG20TItHbFUCuOuYsbtfl+NhRcc3EKwbUUrN5CkUCSyqipYCZ2KISFMCw2/HjfDD/D4xfrO1LowM1c94pPv2u/7r10sbn/mLnJV/Z69LqihMRWk4QJJE8n/e2N/my8926sehUJTwEmXH9J0Md1A2p5Lcv0xr3AHrcffLeIHgh4lCWrWzEjo+rYY3YS2VS+BKijNRxKzObR6ltABBbYiZyNT1SNaiIht1ArrSWNFReN7WWdS3lo7V2St31UkUIYmyYGfU75nJLPDQAj+5LKqJ5KT4MeZUMMo6YiTyoAKkaUhhwyqGH6qMD7Chx9pNUzY8h01cMe5JYVbOkxBKZQaxCAJei08ZsSp2ALMiw7hl4IZw+mehAAZXSu2xk8oRtIR9AQ2JTCmS8qg+G2Tg3mJvd8bZ37/uLD5gDc1mWIUl6wV24p//Jvu82ubSwkQ3AKiS3Yw19Fw1DTEQ3zQ/++6pe3ydnnTiSI/zNh/7rSY993Te/8aOZVWPgEhT1BJttbgx08HsnnBwE+/oKYCyhsYTmCyWq5Ius0tjSBlbXzVkIvkIIKAc1Ektv1Rq5QnSBlaBGyTFbm5XZ1Jxr95hUfao+ISLDSB3SBMYoE0mAeBr02BdggyxFkpK1NrqyiFD8rNghUCURhVSO2eoDO8pGuTljmjO2uYobk8ZlLMGoZyZVBDYCBpGJi3vwJniuCPC6Yieov3RdAKuekWrpH37H+JcUvKNYdMQjZAtflUZLwBkec7ZU+Jpzc1xpClSYpeFCASMwMJp7c8q02dSSkNcaYgaa/GRqBb/4425DAd3WiFL11vL6k9ftuXywZtvk1Pp28HW5A6AEQkITNPrEE5tbx5Jz1sODIQGiIGanPoAJavIbDnW+e33/2n0ARu57wtiv3gtUVkTF2zaD9aFoP/yeh/bPN751bUM4sOZ5nriGmTKDQ0dC6Q1ZES8eQYlSy1lGo6u4NxcG86KBlVSFIrdXQCJkSHazbGZqK8+w5AZ+OBGVUBvgAaRL61fMNnyJ1WNhrlMc6marR0xRloLoQBktuYNJmRLmuE6oRnQQ9Um8EJNxRCbWjSGlAAwGgdIR430h/rj4hSXN+n7SbzabrNzr9UwgBOa6DwkKsWnGw3J89a6yMkWapQCBRgxvy+x35vrRnmFOfc/7Uybtf+0vszEYctrX6a1nHdx5s/ZylcKmDfFBfR/qmShJ0tCgvV/40uzVV2982rMmHniPIkulZ/7tFn9wgFesc0YRgMBwoSpgU10tRw2r+jFTbrnW+O0+5ssxDtHbZE+3uPRAf+diMZ61TzzVXvHDG9/3zn/40mcubTaz0bExH1SVmS2pBhoshv4ZY61nbTrl9394qSEl0YahzGIxyPCwjjBOJhbS6yaxVNI40QROjETBgYontjyUXkK8hLxHLiFJdRC0TIC2sV58MByyxDgboVNMpAjsBUUuaVKTDpVUIAFBIaHiIC4tvkICEW+M4aJXskNjtGGc9b7wfW9Y80VTLDJbJRJ2QpW1F6mqCkug20Dq1obbGLZqY4RUCUKwEhTWkEgAISW6NR+0iMfJlioAB/huIdNNG0H9lbSjrkABRaDqcDFZpjOCKv0tyd57A1op4oxlB0CkqEj5SxX//9ul/+H4mW0AdxoIdLxRs62gSr9xwa/K1k+cd96JW06e6nR6zhmNaGFmIzDcXvOUB6sqSihCUK7Q0mAQClN03vft4m+/5LxpKgAUn7nkwCcvTv/oCe7M6ayfGyFwTDmPAgsBgPfN1gPO4m/dqBogypZDUCLbmJgMvUExyFU9CUkpNk2CQubmfN5nNbLkbFapJaphQKkgvfX/Y+/PoyzLrvJA/Nv7nDu8KeaInDMrqyqz5nmQVJJKEkJIgADRDEaAMcjYBjxAIwz8zLKN3XSDsQ3Gdq9uDGJohBmMkARGE5pLJakklUpVqnnOrJwjY3rjvfecs/fvj3Pfi4jMrAmVQPTqs96qiox47747nLPPHr79fYavdLxo/P0ejYmyDAWSTRoMRK7+qKRHRCKBBdg3H+49O+ykTTZjylwwgYQ1OIlaKTXvqWFKlSoOlbLjQMQEeOUECBCnnABQTSWbS6oVd34NYBPOmMrMvmluJhrQ7rEGJgMISVWqVH4IGUKhJtI/gwAhNcQ1DNwoFEQCHso1khhLDqqESunJE/Ka1u5fCp8DdjGRFdGK9h645vSXPuVNajgnAydB1FvNQGQ97NQ0VrtHf/nfTX/dqxe+77vyPbswGtx5srtc8Pfvbb86z8VTnyoYJKKA0cgNqogk1ZtW+3xQteom2jVuxs9J+RBju4R8FfTJob3vxHClF+ampvfsyn73Nz70e7/8jhPHV+bndgAIYSx3YYz1UmqVcPVvDr68zBa+KGdz0lCGhV1cqeu6ikyTQEKSMuccY01MNoEaKQ/yFLE4Jsq/TVpmYlIxQnIAkKoQG6/9jarXteqJqQy+TKwkScIURJVA6lWCkUASYK0lA+bIM0IaNCi8YLNBpMZAs/MqgYOEcuAsGxEh50NwxhgVMiAW1gjnZjEcqHbDg9ZVXHPe/Z/AGYgAlhgWb2KEaNzjSgAHihc7VPn8cPmiZCqlpAglKflADG6CQgg8ZqeiWucDE+zdFlMjiMg7AkzksQ3IyVyzA0FkfKITf6iml4/wp/qPXGuq/q0dX3MRACLkuJKlpaV//I//MYCyLJNknHSLpGcTkpc4IkxOWaHkRFIe/cod1f/1ETPT5pRJVNOUSif3Hx/+o99o/cp34rbD6PbFnJMl3L6lJ5bSVKpBgHDkUjAEk3Lb2CTxfYU4LQQdVmHpOS2AELEom8qkNUGuGgBywtD+wAcCHU2kKDDmSNnS3l9/Jv6PsZmtahhdyOXL68X1szYy/kgwYCU1IvCVWgWsGGMigoqbkKBSgVRUiaOUsgEx1AMmUgkh35FWK971faQVEq9kIu7WUBqyhcxYE+uO3E44qt0DHHJII2lxsTyqepXZspxjXBKRskaNUQok4ulAYtugDfIpuFL7eG/whqWZQ3l+IpAhGpajwodsx658YXd3+RRZD7AxRqrgY2/U+PjUyFc/+LH+vQ/Mf+e3Hvimbx7OtR7trvz7Rzfu3ll8y0K6X9iS9QxHqiq2rkub2IU87vqvIz8au3+RYE7qZr9oEnizurx9MDOrc6IPdfmhVTq5PsjTxp5d+erplV/78V/9+Lvfb/KpuYX5yN0vBCOwbL26hKzz/DOXHn75jhse7J5Z9kjJ9F3YPWVWK+fEpJYUNpCbNtQUgCMxQyxms6FA7GCclhpiXBOjgSiDSyAKkfAhXh9FgU5h+JSYUiK2ng2s9UwJkapwCNDSBg8isGG2xJF7UDUElbp7avPaYxrfO/UlF0OxuRgb60nR9QBEGGJgyMAYNWb8magAqyoiEqwK6r5eZdnsh0eNGtUJhdwm3+/WvI1XYQWBTrvirHc3NjLDrIFVyTtKUzJEwQeQGSeMxpOz7nAcb+1jCguNOCAikIYymFfuNZfOy9Axs1B9ghT9mZpROAUwJpr9Ww0BBb42N4DnGM8bW1CW+LufLn737qTZoRIKDQBcgRgd9IbD/+1djd/8EbtvBsP+eZCAeg+IZGtqE4EFnAYoizE2vsGmCXWm3MYGjxSJgbJulECAGIl16E1/cwvWbWDleGIuUj7A8sgLvl6NOTE9PFvdcTI8M8S+RkYwRBRi1UvhnVoKYA4xHSNERCY3AQohGSlAZIlIyUChIoGjKSOk8xZAKMYo2+AAIWs4MUnTeu8QiAxHLvU44YNTLUFeCcaYrWD2zXQq1ApEFYEQgu5NkyXmDRIrsGwf2ehOH5i7dbr9rr5YosoNxVUwPHPNTcNPfDRIKWSJc2KV2LkwpvoRIeRJsbx8/L/8evfez+3+7jcvXH3LCHjP0TNfOjN8zWJ+2ywtJaZjiA0CpCIyoomSRvJ33bbNypY0oJH6zBksxKTAheBDqvpIl+47PXxmwzPnO+anU8Wn3v3hP/tv7zx75GTeXuA8Fdn0XsVEdxFrfvSWnc3vnXnlqCf3kx8M1zvoFOL3z7ROFiMnWYMZMIKwmNkmISDU3S8ajbrWia5EU/JV1dBgVIlY6sZWVaUQ6REQi84UlCBiSQwlsAkSa4msKiSweJKK1BMnAhM1EgUgCeS15h3fYjPra1dlNhBBf51bM5LmpCCOLB917tIUQ+meRt60nOpYCRsqJBpCiMLxCkTuiy3MaXXsMlZUrdMzPFmhY30xisjOjMyRajgMfpdtiIgyOR+EKLHwIsSscoHIPj74cbZyCzGcqELJAmVIXrYfrQQbhRomugBqqDp9DEC6c/cLXcNf2+Nv2QYwGVs7O7b9PqPqLx/T3ojaOepGjxpCqiSkkHuPD9712ezt38TPovlXH6c3EpFaY5yIiEWk1oQUgmGClRElSaqpkVKQGCiN080X2qUC5HhKHTUX+7LL9miQFtjFd5sLnMq4M0ChrJol/opZuXsZU5zPpUaVoh/PFFKCrzzE2JSRjJO4lpMmu2GQCtJXzmFyIlEimIS1QtAQHf90nkMPxVoVpfCIjEjASEM1QmqByKuvIqJBtGIZknolw7CJSYNW5bPdQ4ESaxmwn3lHYh6pKgObWvPI+sAavn22/T/W+0maDKtBcCOgwWl7+tLLVh74IidKJieTSHBbYOKiRNRpWSCMRoNP3/fIFx9ae/0tl7z5WxYvvWwY8O4TvY+cHtw0Y182l17SMvOJbQFqMIIYicFZpB+PFXfZ8mQmdBD1PMEW1kkAQTDw4cmN8rHV6kRfK80Wpqealp6+574P/86f3HfH57JGM222Kw8unE0aijG5kiplyVpv/Q0zrX++71vOlmZ4VedYY23wIW1NiWrYN81PHg2QLHKxKnhv2khjb1U9b8cWUAwAIrFZAaAscw0mptsMKYCggYiYxaaJtSlMEK2CaCBvrTVReEJs8CQeUhEAkyqMkvUEA5AInJ5v8S689Abr8C3kLQKUrKgq1JKitw4igZFYtKg716J4wOYtlzEv1rgIXGc+N7t/VCa+xTY26fipljFPFL2R+j1JXorE7cSyJoa8jPkTYzVr+xZyTsd4bUYIaggqvLuT3LAbRYgJn+33ggEB+dGjnwOQ7vqmcbDy/6WAvuJx/iN57rH1PVLz8xhVJSYUTk6sIYk5TgaElYGoCQMFc55X9x6hUaizvudWciTCKKQ3IucRrXPkJ4nBbP24mWyCDZFGQkmq3sJAFZAxIdD4omo8dZyIPZXjFm00rshW15wZlm1W4eePIh0wLMNiA5fPJPes9N64Z74UeLDVoJGKOUTyNa9kyZBCmVRYKQEJQkUYAgG2AUqhQWGUwDIuAJgO50iLtcokiaiB11BWfhRsM4Oobi5cRlAplTlVr2QIRMIXKKjHexCZLwIBAVdl6UdcFVSVeMOFp4fVLbOdhaODviiL42oQmq3Q6zV27G6snxo8c8w0c3DCTBCN5BteQmtuV2f+QOlH/dWjHtZW5cqffnL5o1/Y/w2vuviNr1267EqTT923VjzZC9PSvaTDh2byfc1kLqEskUhQOqbi0LBllpna2ptxAsUA5EVGwa+5cKzvjnXDcq8qCg5JOpU3FyydfOih//lnH/j8h+7ob/Tb022vRXOm7SotBp6NUgQjqTFwo9HpV3fmfn7P1ydJcv9Mtfh3ZsMnn1AnLvh2EnY3w8c2nCIXCqwwgr0mT0QqU0MIJnFVzQVCAiW2LlX1VRZcqghelWAAJgNia9KgCExkrGVwxhytWY0PrtLgiI1QAmIhi5gHD7E7N7rhEyTC5D/njRBo1FMVzZpk0jSEIN4HJ8SctwyTkAbGmMofGqUix+u33l4n0JoJiKD+5wQLMe6PrBP6AEAWVEl4shpMcTrNqdaIA0mTiBqCiNCY/n1SY5hsAGMyMIrZZI3QWmt06JJXXkL7p3V9BGvARGMlg62jcdk1L8K0fc2P85iMns/8/vWDrC84zs/eUOxvbKSUGu0PJW8wSew9jC8lCIFc8MtdXR9Qs7ZQ543YVaKsWhew2AgzDJMGqZWH1JjErwdwotNN1R6I2IcAGuupxqh2wmpHahWsukyaGrOj/Lmn+5fB/fRF6cDZpMEA3GirHVXopmUlRcqmCry75VeH5gurGzfMTZGPVXEOCmOBIKEMrIrEkom8v6AUFoZUQ6V+BBiyBhGYAiCMfRfxmswaamTlmQrWU0IglpBExx8hRsjRAyW2kSUGUBaRZ7P+GGPzhZUFl+ep7UpBMCRD4fvXhm+eyfda/nIpVsWXfZPMUWq4kU3t2e+Wz4iUSgkRh3EeJs1bjekdSmRsOrt02bB1ZGPtaJq2cp898SefeOhDH917y+WHb/+Gg9ddNzM7laat094fP9lLpd9Kud2wC2m2O08XEtu2MBxSS2TVGFXU0nES4ANGTkbOVU6PFeH4KKwPSvHUsHk7n2on4kbFY5/67L0f+9jjd395sN7X1LZnO2nWaMwupK3pclTIiRMkRMJMQcGw67eb5r+cf81c2v7M/OiRl7f+2fUH/uj3P5yEYRXSPa0wbf2pXmAG2HAIRrEHiUqoeXCUYxkz/tNQrH8Km8AmAAy2ZCODihtnqD0xj0sDHLH8pOS9+pKCM6wwVikhMiGqbk2IH56XRm/roosWdtRDcMIYAUzIoSzsGUGhKkJUC4RJXa5mbIf/by3Kjo/PqPUPdEsBIErNQElYwcTPVMOjVX9v0miQ8RqFk0xmIZFPb0vNX58TqxNDCgapU7Ymue0A1UQE58MFBGCoTZcOAZEO4P+rAWwfLxwI5BUBakANhiXrIOGFyzs95yA29tZd9Be2DgKjVBxFwJywsiYJ0hRTDQ2j5yBxoqmmJNZWDiZy6xODFIYoKGJTK1PPYyi01EAgSKSwfTZ/XsCAgwrJcfZH5zrd0buXZ1/XLq7bue0T9GyUBpLGutM1c/azy8X9q3z99NRIIzMGISgsU4AWAZE2RhHzV5yTYZIgBMhQvRM7TaEKMMxbqCDEq8052Z8N+wNmhk99YPLCBLCp27+INCdmkn4gYTK1NNS504BqWRgdo/K9yL4kmSXTEzFGh+BHNwosZhen9p6RJEpVOejM537UF0fZ/GJr/8H1h+7ndhtMJBxDkMb0jrQxQ0TqCxXfbB1oNqaXV5/Y6G7MNFsk6dlPPHnizl/70s75A5ce3nP54d2HL53fvzudna1SOiuyMpLH+4UlSYHMIBUxkIQQ899OEYJUoo6MU6hw8JwnzRz5yA1Wl5eXn3j68bu/dOTBR08/8ZQvynR6SttNBRozs62ZJZN2QCajpklP+9KzYUMIZfc1ZfvH973RdNp3zbl3XzP/5lcfMt6cOF0FMi64PW1tseuPgmECFOSt0LwY8ZWSRe27MEhAjJocJ6Y1iIg4dSZxzU7DZKpGVFQqDY7E1c0iDBgGcVBvxScaDCuRJbYgA4BVRTyPCYKea12fuzpqClMW1argxLTYBHAF8hyReOMPqpJCVA3Ibk2Nsm5LncRWEtr6jTouaG1RzGVlhpDqw2X3jC9vaMzlZHoiRDCJEBl/btJm/Enl81zbCVyPFJDS2Wt30uF57VdxyUNfQDrsb//4a00BJcRrIRxz/oyX9arsGPvydrPB3rxEUQURSW+QvOES+9uzdEyUJDCERCRYhlEhYTnbNbe+LtKabxm8dTNnALMtsiYiG4mgHDENQsTEGqmBtKdaCM2nwmrECAK05hckrqk6J4mgiJuHwPepY/xPHDrwvYNj//bxxh9OD5MGu5EQUaSbFhrTKkwwEvF/ymDPJty8mH72hDtmy12ttAvkLIiqTEyqJGUwokitGgapMSQZrJIbBvWsDrIBk8IwxCtbYpOA6jaLQKY5M4sgIYQwHInLxUR6RgYMRJkUhr2VqBkeu0ZBQSjyZWOL3A2TBAGI2anuMzxveF3UkDLzY91CeOpgzlgvDSVVNVq8+Zpl/8Xy5MAmeXv37uHxoz5Uk2SEEjU6sxKiZJCJdEkG8/tnplaT42u9M1k1yhuNlDvDk+UjJ75474fvtJmdXpyf27Nz14F9C7uWZpd2dham23PT6DR8lpTWRGk5qkQqR561ClUVytGgGJRF5fqrq2eOH+keP736zPGVEyd6G2sSQClzK8lmWl4ka7Wmpncl+bQKqY+EPbHZtZDUas8fosHb2m9oNqa/fBF+9wqLq+S1F82rhmMbJw1zUF3ItGn8sFA2wkAgZII2EFQionnLiIRoIWq2qCQaqzCZmATMHNSQgBIkiRmtR7A7ETHXWQxhI5oARpmZTA01FiFEp5kgGhVhlEglEvJEpjTVMRPp5tBIZCWwxKAADSpCaoBcWcbdJYIoC6EmMgHWcxh1bXvifm1md+q+Qp7kfGokbCTgVYYqEwzRw6PuQNxFaWu8MsgYDqBzMhhR+69OQW0a/ElgMfZTG6muO3vjTp5roFeMb46cZ5YEkAgfx3Yw69/eYf96mBQnIhfHSvfp/jCyOR4rq0vzdE9qDIgmmWZ6oVGVYswfW4+6xJdOzSU/841rP/n7eXeq4Sy4oWyCLypfjexyeN3GwW+/FGFcnhqTLU7Is4hIvZjpTrE4lZzpUZIhgohpgiFjQyosXCXlINF9qVmc0uWBWEviYpvuBNm/ybJcQ9yQpFrAX2TdTx+c/dEvr//no83/36UbalpBHCsFiIpVuK1XKjXDGlh5ZDFrzdVT4e6za2yWdhtTJmOxi5j79zIaFJnkSSNXgngloiQlUusRxEOcEoIPktiMNAc8GSb2UANFCEFVTcKtTtPHrDEzs6pITSRGmrUSKdQNvQYBE9gkrYSnW6rqNvq+X3EIFEBIlYBQBZJdWWef4cdHhaQ5EX1hVKi09s9Mm5N9Y5JQVmjYpZsPH/3k4+tHVtjNNzqXuDMPDqwYEqehM7MzsQ0fM/cRpEMEQxWSztSeVj7bGy0Pu6uhHLBhSUzemVbV7nqvd2bl6bvvA0QQkqzVaOVZs5XkmUkTSiwllNpEikp85YvKlcNQFlXhXFWUpfPeRlrrJLNJu2WU4ZPApXIyNbOr2Zwjm6gaAwkSlJWZk7xd9tfV+ylH32Vvabd23bO/9cdX0bEd+ksHL5+h3AfvVrpgH9ReOpsvhjDSaJElqJlrDncAPmJ6dNwSMsYyaK0mFJ0VFglJ2iCDGgwKMiCy2poKgy4pEjKxNAYlsKlrYAQFggprkMjcTQalL9JdvnUod+t29OUJTyZAnjJCiAS1EyO9JY1TFxs2dRZBPJZzJKdwHtYaVR5vIdtz/VtT/1JXHOor1pg10vFvOO4k1pjT5eA+6c8l2R7KPTS2DJuYboqiFPVhtzT6bJFSiMcnikRwUBJfBW2Z1o37WMTxpPo7/ui2lTw5TvirNYJtpqRku+V94Yb4whZy0t12Ya6zZzvYSxwBnJ8FigkBqU9OAZQemQUAP76/k/yP0vOlIS9wYYE2vSXRADE8+6qrpn/rO0/90fvWvrQauqaqRmaxaN/Y2PPKG9OXfxu3W8GVGKtGAQBYat6p6N2wZqk9sLO6/6QBRXQ9QFDiuq+EQAEi6FZ6URP7GjgxCk3mgVMmRGaXsR/EykJCW+pdzFwGvGmh9Zad5Tue6V8zNf/Nc8NelaRGgEqpr2rPzaHVRWybBhqFjfm51l7BZ1dWv2nnDqkAAwYZCCsJMWwWRqJSJo2mhqBExmqSAgRfIDgJnoy0ghQSzrIzMA2T5CZVjp3SIICY2WbMws6FuCuokDFGmUmUDcQHVSKRZKpBUzksmDhdmLZZWW50ZWOEpEJqNTGALQ1f2ml+cGO9hYxI17w/XlY789wwgoC8mlD2Gc2D9oe+Y/edjzz84MebZ9dgakJ3bk0vxu0nYtNZApSFCYYAS9SesY1Oc743XBkVJ6i0XBCUQ2JoOgMADwTRIGVvUHb7kUaNIpl2VEwkBRPBkLHKlnnKNmABUICAleERqKK032rtb3aWrE2VIuern8xeNkna6KiQlP4qs3DZTOeJm3e8+yCebuqb9y993YFdlni9W/W6hZIYoouneK2QCgAZVqmUpg23rC1KtaKgbVHpGBc/QUZKMtUwuQ1au+sUsatewWjN6GBDjRUAMQsf1awJ0CCqJCIqUFUwVaPQWLLta5tq2La0us+zKGILsEjjomz0TL3EtqZMSaEamJUJtVhj3VsRAihRhtrKOxekYW0ZN68tFYTxckdNBC0T/I9u+4rzeL9TpXvD4Fgx2J02OkkiIajlBASpYRo65niOt+tci7HlFCJIhJTNICS37uDD81o6Q8/tgb4gbrG/ReOvIwW0CSog7M0So/AOAFqMWWu+co4NRaDNCxEIKZn86tsOHrrRHT0jvRUHTzOLrYOLzA0H7/yIyKgxNedO3XEuAhs5hTzUCPwlu4aN+9tCSpBATDGdySSx+ZUQoBtQm4QDU+azayQGmkgIMQQmz4ASGd1sI4wU58aDQGgb/Uf7O59ZDb/yZHJlGzu11EAu0SzAI1F2F7xSFeOplXp/w5TxA/Oh1TNfP71EYgPCWAiXksSW4kIRmCtKo9AxkQFbsjmIyJWiqBBYfOoR2I4kOPGWE+bUclQ0UAmizJymJgQJIWy21BoyTABCCMmURcqKoEGIGcZSM0m5JS3Llim1ajhBkghu0qns1HERNTBd5x8fut3t3BKKIO0gXoXgE83ecvXt33fD6z59zcP/4N77zMmha3ibtjnNgo8+IQUVClGAjSgYIRUmYUtoT7fzZmt+VG30h8sy6HFFtkyRmGAIzOAtfa2xLYAi+gdhwrqgAYCwmKhD4owTB1PYhm21ZprNJWOmlQw0QLyc51iZJCMiZ8sbuCOX3PzO3dRbsId2td961cWpt5roxnp/OCzYUMPQobZZH0kVLCURKiUzbFNOh5vNS+fZrwu7cue9TbjZkcigGb1yqIAQYZkSSESgpGIivpnYaMjVozrmpYyFHQaxMPlTfithZz0NN3sEDJFMXL6IsOIodqNcFtJMM+/VAOFZfNBxqnMMlgNv49vQLd64AoKBhLvdxkhld9KeMbkTUkKiXNcRxlWD7cnTTZKVzT1MN/cJEcc37KKpNKwXMTH4lZqkvz3jq74BxG18YuWblr55vv2JlX5CfP1U3rR1lBDfuWXvfnFD1DPV1xJTpaUGIeWL5nK72yZcsRs5NWVf2McSGIWoZFEvntGoNGxtEnP8QZXNJTv9fEvPFnUPinIgL6om4oDASpbXfKhUDkzxTIahU4qt9EQica5prXla843EmU3CyrRauava5kcPtP/Nk6u/eSz/F3sMRCAemgKe5EIuBolSMMIqqaPh9bOtwVrv4xvLb+zsLI2IwEI8SETSNPU+lP1RkmcmY2JAIoAEJiM2GkIQB4ApgjsDxFTsOSUSEztyYJkDAgC2BDYGJA5+5Ik0yazNWIxNO23nizBysAasqhUzJ+0W0IrdOKpapGSHcqjTXMzsGVdlxgbiu9eHVxycmUr4bGAJTn1pre1xeXTU229br7n86uuuOPiZU59NNG+1Z0VZRBQgYhKlCaMLBYIwjIeGhEnSnJOmnZrKl0bNtX6xUY76WlaokHCytRWMSD0BNRntpGrJBEPKGqjwBRvh1DdbrUZzb5bMGc7rhrgx/9r4UKQaSCDBmSS1WaPjRwvTF/35RcnZa4eXzCxdvzB1uDNVSEhA/V5RVZ6ZZ1K9pENP9riASWKnm2ABmQHFhmrFOYvh/PkQO2ZlS3Z7AqBUQBRKLNZQ8KSiMd7RSDUohhCT9cTGFGuuvHOVLYLzMk0SDHxKYiBc9QFT90ZPWNwxZjFkSMzfjmE8RAhQBszysGwlWUqp84ENzKStdnx+9TnX3J9Uo8bG+R9sJsDqJR7f/YQfPl50G4m9LGk3mR1pLahcv5W3f8/kW57VrKhqNUONa3bABWHaFoP8LRkvtoa/dfx1BzKk2JPZ798983d2TR1qpi9hBWIbrEBUEJRFDUZaVNUQhUMQtSBON7XrAtQrjJXjaxu/+f7hJx7w7XavLB1RUQybs9nMt70hoXZzOLKeWBIJLAEanArUE8jImQpDyFymS20MwWJiZK1KW/kORUhEJVDwCD5KKmlCXIj/3l2tVy7R7x/He7q2nTN768lYMF8oMgoEzyit81yWlGpSvHKmkaD6y+7TTW9Sr14gRpVFfWAmTmyoQjUIwcXkPiGwqhpjmIXNeNONunyOpJRRt3BDr55ISERqt6ru2RGYYJvMFm7kACRsXFGKBzypWBWrwhooeIVQiMLmQLNUT3Q4bR+Ymur7QGSMST6/VjXzdC4zlYj3Hs6lbKrgVQzIlE1cecUlZZWIGhWoGNU6JCJsomMhClENnkU5aFD1XrwEgm00lxbnrtq18+qFnQdml2a4bajhxQ49ek77QUqKuPcA9SQBXoNH6Xnok66k6615O7dzaXHHtTOd63O7h5AKQkCInKP1LBMv4pWMsonAGLZJ1ppaGLU2rphb/KHG7Tfe3M9aN+2dzm1UT8fK2e5g4ALR3gZmM1kdqRdDNepY5jiLbRe1Z/oinKGaPmFMS143TI1LVkwQBtWt4oFFACZmRiA25AbB9QnBthem5/e0lw7ks/usbVXgIUEobGGpjXpsIRZolRFZCaFBNAhUWdnA9EdVCGjaTIOSIAqR1oJgSqTM41dcKfES6mqwMpTjMpqwwfGYvPOBqrfi3HzSvDKbFrCwScSokhIDHGJJb/KaGIfJI6PN12Q6Ncy+2aVZEQhZTQxbql8GEyLr/7eOlz4COL8MMOFdeY5B+iKqIM/6vbxZ6qGYRN02oiTJ5jeKCDeb/t5nyj/+zEK/Wx19sOrMpa8+3BmFlZHeuz44OkWnX335ZScWbnjqmfkqG3JwMky0WXets+hKkI2g83nY0+L7NyJ2Q0VQayKNI4zNjh4AY7QQVMR0bPKT+3f+s/7y/3mULsqrm3OpAoOYL9CpzByScPgAbxR4ejmlTNkj0dd0Wh8ebHxwtPL6ZFpF08QERTAgCdYakPoq+IGY3MCOW78syJIhChD1iAIqqqQOCOSCEw/OmC1xwlRblnGmm1kTYkYwIThoFcSJsCEIGSYhMoDRiJNQVRLyCCLM0K+bm/30qS4Aa+3Dw7IHWUyzkS9bwamrkrwtpbjSEXFQ7Nu/FG+mioiIIkSDM76f0ePlcZtw4HGqbewEK1Ay27yxhMZSa0pES3WF85VzIx+qUFWinkApJ2SNMcZwakzGJrUmZ8oIKQMwTiPmqPbTaz5ujdqBInna1PEzJyKbNc007f3h6zsHrnv/o0/MpdkNs00nnokArK0WPpAYPthRAq0MSIktEYka6BxlGvGV29LfW+fx5m9dtzD5VJQWPt9tVRXARB3hMSlOqIn0x63VqkGEBJLMmZmdjbSTuGIkEojVNnlqV3N4dlCsEoBYahat+1OIUSt8kYyPXyfTQOwCVotiR2e69I6j7L3UBLmbZze5LooV2nFDkkaM3XmXPe4DeKjoEdE1yfS+tF0SUpCQemisqep2ON/mTayZAbfQP8REn6DKdXBozd11n4ZU2QonMEyWTCtp722bljUZkyU1/JVr/+oYQfsVHuclHC96AzgH469bsmzPMc75q5z3p5ckFKgFI5+P/nd8DspkUYm/+wn0RmG6Y4uN/AN3rjT8u7PZeze6pwdlAal2te/YubjniovefM99r3qyyrVVoIRYMlalwlDwzEj25rK3BWtilTjemLg2amyS8lbuARUBiwQLI90wuDFrfu/O1q89NfyVp/BfL2stqCMuXO391PzGOjnrh457gkkhWpDQiKiZ0KunO3f08Lmyd0PSDGWEYgdlUglgNgkHJ34kwYhJbWybZK77AAJUXd2TSWSgkAq+qthR0kwSsmRUxgE4RWFKYmbmLE1TFOSMD+KdMlFg1cBsU5N6CpGPRVUZHFQFdHNnei61hXBu7VpRfaHbW2okQAkvcCFLUg0YDR0A73HZFfvb7aYPI1WBBg6qZkLGOJ48HD3myTYg56ErauAWETNaNp3JavlKrevqdbZhYhOjEx21nwohYmGRza+tSSU1qKrzJUXlqUgmLEI2YZvsv/2mzrVXVKtnfeCbFhvzWTqSwKwMnDy5VnnlHBe3DDScGUGJLYIHG9IFk4yf87M2ME3gkQBC4dluN3nbpvgmUoXqFlhRZZHIDx4PFIzR9g6mLJQDb1KCIJQBECIzu7d9NriwJoZIYxaOYFgNwzKk5qQDbwJsyJr8ZH9jLmsxCIaCD8aYGkS0aTdowjLETFqL15sJ9HmrTfAYu//Aw7571I0sJzens22TbmjlFCAGeOwayBZI9yY+cHzvxhjl8WIcsKNrFg/8mxtlJWjfaiBHqinIEhElnYxTpqgx9ILRic9qcFaHADDTAhM4xiB/831kX1EE8KLqt1vjgEnSH1+56ddtXASqSlsgX8/zUVVKrdkz6x88yQOqGgY+/eP7z358P7cDq81TopZDaeXxTuu/vuaVj809+e13P9pwARZePQGoRM9USqyLORKjpOqViFX92GiP2Ug2t0oZU9GIqDCzaPkjO6Ye3Fj+0Ir89qnWz+xNbEHOFjXwVGPn/KSw5dJgoexM7C/mgdWmwyvzqU911x+R4ko0QoDNbGAJIA3KBJNQcKIVfBCTMEz9/WQj/6OoH98QIRAMJ3DwffFlkTRT2zAhVkejKyWiofa50kbu2GpZCQSklokTQ6xGxi04qrV6gcihZmM2SY46aTF31dy/MdiRZczD2HKcWktEZVkyo6rCvv07Z2Y7Z8+Oanz9uKxy7ryKKegXNAX9OE8Ym2Z5Mv8k6imMgYPRCyeyEUKjVBeJaaysFo8n4hG8qJ9cKRHBy+GrrzTWr0J3degb9nSi6xsEAqytbYiAlXc3GWTODr2AARUEIp22k2RI/K9ge/J6S3IcRFT0hu3pzqTGprGFZPOdQI0OxoSQYfJX1VjMDkmTkrb1RVAlXyoxkUkhokRVVSWMIAqrgBKrARmLmBphVU8M0TH1Agcyp1bXc2uyLINKFHcKod6HYu/n5ukhEFEEu7JugQKOV4pMfPZxeuAL1foJP7q6MXN1NlOIZ7ZeoyyaCsU+nQs89rqrZgJTqtG0CIShlcve+krOW2HBYzeLSEpbHFwhQag773ABz90IuhtHUtuyjWlKmoCHXgAeKgSsDEf/x8cBmNsOJq86SPNtorgN6N/sNmCfLR75SjJfz9ESfI7R/8odf1XzZ48+uaszfd3OvRl71go1SOe5zr+Wi2VR8XTTft54hj93tlHZ9+3fccfenUYwIlDkSGEOGqwTYvzFtYd6KX7wricStxEIRglEfHTgT478XFLuT5NHNjizdVZdY7fjVkr3eMYU2QpjgoiNEfgm2Z/af/Apv/y7Jwf7M/quXcTDphgHhdHgKWK9VcF2sreJxARIIuIYTdt/2UJ634o8OCz3WjtlyCSkpMoEEY49YiASChVMwhobpAlMBBqr0gORVkaDqCJ4gdNQDMQgbSVpq5EwBwmiE554FvE2JZs2aLN5UyCBlGSLuTGkTrQDc8NM48GVXsunLc+fP1NcO5NYNmVRiPPGGGI7rJwx8N7Pz89cemjPM8ePdshrqEJQ7NWaUgAAgABJREFUYwKQxNbSyF8WXOFdkTanngOdHfMfIgK1AYg0GJGmmCLRNwkBcQ8cLweO+BlWAMw6zuDptu5BqQrmup7EChGtihECsv0LQ1cGq69ayi7uNIIKg2KUsrLeCyyzuT1sMojplyOgIeQC0CCeh1UEIgoCVo1MGDSGr9SZFhk3Q6ga4f5aN8lSTiwZYiaVmv9kTLkMEdlMeLMBBzZOwUpgQ3BBRTUY9WHSNUBjbJz6YDwlIlpLb6ohGCFAJaKwCApRE4R85rITfe8y7Gy2S1cx17N2vMzZKCtJ3EPjnsHMWuOqlRH3AN62y9dJPyHgtJR3litM9PLOUq4oITIW0wsy5u4fK8tf2FZM+vSJAmk1Movfexi3tsteBQBVAJhguJ5ICOw0SmDW9ETbTdnJj+LIexYHXcmz6qof9/M3sZRc18B5K0dK2sjLY0c6p1YT2NEf3OU+cI+77RK84SqzdyGxoFCLrk1aoenFbAlfYULpbz2adVD5Z9aHH33y5H++8+F7Tqy+8PtCURyvKKjTyN/yBnPNFXct7Pqjyw/Uf6KaghiRLKzGfcpHrz70ycP7kqLiQEFFU0OnK3NkhIal3S0qsIXVlibk5sCk6gVWItFaX15ZAkS4J4PDSfLPd87khn7tWHrHcpuTSBPHngyEjXCkd1bhWGdmiXT/AYASSosG4aZZO2Q56nR1ENhxUqvniKoyk0kYzCQcnEqpoUQoSGoGyHFZzwixGhZrYAlG2FTWFizroTo9qtYLI2zUMCyR4Zp7VFWDIMoThpo6VOt1PklZeO+J6LrpmdRRCGLS5OigfLI/TK3VqDNDREk69HWoAYMrrt0fQvC+Eu/Eh6C+dnVrmmg4N9BQvpCAj2CYmcc1oHhiIThXjuJLnFcfECS+WGubO9ZcDPFWTyaGaPCjro4JlWpsTAjGmE6rvVqGRsK37pzD2MEzhhR0emNAluZyXZzy4v2qc4AXkJI0mPOYRYfZTpa8ZWyZUfV1CZV9X25UfuShNbC5hjfLxGkVlTgLYXNKWmrSYAgino3CqdvwEwr+CcApBglSCRuJRVVDE4EuVVUHk4gwAiDNcuqpoQ7z7r6sFYK3dec8T/x5KzBxRotqEPUqEsVTYz0lloJZt494jawM5Q+Pllc07E471+fzfkwcrWM6z5qXR1nBoiqqoixKouRhAsOTBqWgJOCg1C+DeXVz6h/cVnbdVqyRQgK8EIRkwuR4rjFhQzbnM5+h0Sk1zKMe90/FP4wTUNssuCtKXmxTw/jcp02d6hXz77k3/bfvde/45OCp1ZIzz40tRBgv2bjAmZ83/uopoK8Rjcx2Zn7y9qs++dTKO+461rLh5t3trdf/HHFMHRIbZpAofeCS+b+YzZ/lrbEgG1jEuuRjVxy65fGnm8WQ2UJJy0BPDvCqRbl8Rj98mtVGIuS68Ks1AHP8HAwgiO+BrVsMmQLzQHpv6Mz+yKL5xZMn/sszye6GucQaUimsZC54UFRKuuATFbAYsQEZ44o5++SarFYcxC1MsTEGzAKBB5FwAiGlEIW5QTEQ2d6fOTkqk4ICGBKxGT6EgR+NyrzRtHkOSNAADRdIVwfdqm1JY4lGEbmlMzerJ0uFtWajLB/b0MTYQZBQlWKUbdIvfYjUfYRbb7uG/5Mti1G76UgSqCciJhqFIjcNAG60wfysc3hiyEhUpETkpA8++MpXpQYn4kPkphyb9UlTYdZoAmhNzZ9zwFjVBBDKYXCFSdv1NCMl0hCCyS03G0XQw1OtuSytBEAsAMN7bKwPiWgho/mm8Y7WqpRNBpQCnSJujCdt5GlggHh7KXRSjB+rTiibvJmY1AAQaNAL8JipEkSCkIqwghmc0tg/F6j4XpHP5ufnT6QMWhEnJpa9tybxARg4hRhFXix+drjcarnDyUIp4dyJpAyoZyGtAOZAQaIGsgl+XOuImk6ik96weh7VPr05LcWdxZoQ39JcmIcdsgcM15hRTDBKYzNqtp7npAlfAa27FkCXNJZ+5lWKICGkZpPCS9WBdVNR7kKTyohTTqSxwMTkVtQs+R03g0rgwmZRS0eXLMgbL+Y//CK1OwU7N5+Sc/n77/Z3PV697HDxhutm9mfnVa++0vFCCs5fE3TQX9lFqgHtm2nO5MmO9rkW/Pw9QM79OEHhvP8MspWUzZZPbf0vEPnSWYVOtMzDe/fd+MDDyKw6hU3oWEUnCt3Xwp42LZfjMjCrRo6e7SuyPh/CJNYLMCHxFIaqP7TQerKyv3e6+xvLnf9tFxuExDvPZDynASVHmuvzboIyJCbokcNfOWOf7oa1ikLXzbXyJLMgVqsQgTpOTIAgkKpRH+EctP3esNbgJU91B4ESi4AQWEMYhQEXhUmbNm+o+sACwGxPkuqmsutm+iuEsNfkVzaad4+GQhnDnBmVoDRVFeeJQMb2KycCgVYe1153xcWX7DvyzCkVLwEIFElyXDnK01kA4kZqsgtOjMnJxNL8+vIyJMRmb2YmtrbRppj70vOc32cneZcxyWU16gGAeJJIH68EiHfZfKPKcxPoUKcVtqeM4KQcVgaYYdNOOkNfbYTSJC5WI6bBU/HuMyOMy5ibPDkXWMmBpdFugqOoXGymCqJj6gId65IqRCkmARWBYpw2zj6LCA/hW8rZNn4bKUNxsmBJyKaoKZwlpmjqLJMKKbvR1AeHT1/UyS438yKV2VppqM2xqKow1HJWwRv2IbBJiCjyEMX6QQywzqnycJ1NpQ8Vy2dVZk12e2u3FwRmM+EXGs/dWA0aS6SNCwkkQKQ/JyGJUR0R7fnXt6ZzCzIc2JQFDJHJylIlMjRRA7nQ3PIqji7+XvSe9kb93rcim1V4IoJawG83OAEJmYHizdfIJ54wq5QFSgry6oNt0HqhH/xS9YXHqm+8KX3zZXjpxgtMDf2t3wBAUgTe2W792G2XHpxuAx7wz5va0k2GQRBrgdDtdsENYFuhDFuXnRAxG++KRJ9ppzd4owngIRnrmtcHB/KGBblsFqdPxuRopC6ZiCJtMa91wy4AjSG/AmBL7Yqq3Pt/vbTv6dEj71otFmzyMzutKxJNAokUpCZsUmyec0EcIAyFJGCQ3ztrT26EcoRur9/Wdt5IwF7IS0RKWwI0eIl8/USbpBhRRZ5rHQ+jJAATRd5PIq1FY4NAQiHec5qYzDCziKBOzcc1ppEOQwgS6sUZRJfYXDvVurPoNUUScCBjQE5USgUTpaZflCQISqNhuTDffvnt1zz2u8d9WQhnGhKGKJGrRpERKISKVYK4SRvg1mc3fm4MYGbnHgAkATH/I2ECljfGcGwNIRXxdTKHkgtG5bGw6V3hyx6zHSeIlBAEQUNIpxplai7Ok50NExRbNSdGQzdY7yeCXc2OtaOTG8WZEklKQkTCDRgzDjI0yHkLOCaFJogwAWmj3QZDJ7hOqZNTkdYkVoxVxzRvShqUDENEtWaIjd8iDn7VJbP19ZrMhtKXp4bjfVtqsUyoFRebUayazGdPDPGgf/JQu3FJMl34vueE1UxAGTx2aQmqQmLEEK2VZZo0wEaihitNJMA41JS9my1wcTqdlvJT5Xogfnm+tDMkwyQomBQEFoRNWw8lmMDCWzYhUgUFhSNpMGUo1S+US//2hs7F+4aDQcIUVFQlqFibZ80clU8Nd4cjRUBs+d5iMeodAgQJZDt60y/6cZXPgKLaJcCyBY1aX6AQmm299ID/+OPcyCCBVMGGEtvI8s6J0cbnn3lpN4AXOP6KG8DXSP6nFgkWBrB/tvlCaifnn3ksRuF8079lA4iTrFXYfqMg0FOzUyG3BCJTC57oUwN189U1M/bOUyRQyyqiQWNDb2RPHiNBt4KCCIDRoICnkLB4Tw02P79j7z88vfyOM+UC44fnUqpUjEpwDKga0IWYCIWMKgkCixBZ+P1tPgPVwXSvOwpSZWmT0AAqjqS6LMbAO4WDKJgVNclmzRUTa4i1FDjH8mAMF7i2Q16CK9UFDqmMRZs3EVkao3eud7pNbAfdPtv+rZMeJqLpiSPYvwjEwZqkX4xEBODSl16zV95+wx+88yPFqJ80SD1UvMKEqoyKkxKcBBfKAefTz/XQVUmUiGAsM/N4YVP0gkWDeF8W3pUinm3CZLNm8mwelIj4siciEYWqMQIIQRHEh2Q284l/+VLHCvyWycaKjV5/2B1aMi3bUj94ppSANJFUEaWHYhsh2ETCyUiKMIaobvdGAKSd1jlztS4RR5590YkyZV3TiojNuj6gUgNaqYajBKpWK5snANzaKBQesIhMPwpSWIWwjBJhlUZQ69ufHayfxuptM3vmJBn5gTOpDYhpG9nCnxZJdBXacPZsVVGSCxuAGbWO0yTlw1rv1pNVwgQofWh49qz6GZN9fWOnsARVjrJHkeViEnqO5V+ipx/PIfNQ40ecN4L4QopLRnt/+tb8hn3DYT9JMu89QCE422yeOdX77Ps/dfLo6sHDu7/+226FhWo4384RkSLZ+pu6bwMc40vZ7n3G7SEQaLngY1Wz0xwx/MCRTZjVU3Bh6Ns+/abLn994vbDxosrCf5UNIGKqXqrT/YoHj5Gg45x7BGW/4Pq2ATXIYkt16/wNII5hIioCpKXNgyGqDBkgqLeKkyWeLHBourhsPvvyihiiyMtGcU0aYUUMGRDpl8fNngoPBojQp5BAuNT+FXbql5bKf3pi9I5T4UBevcFwn5GGRLB1tZ8zYgCM2EcU6eCX2ujrsCpp2A/S7CZJYjiDKpk+o0XERMEBImPm35jNHu+IEiCRykKFwOPUghgKAoEmKqweUvioRUaGYcZJM91kc4ynB4CIRlK9rN2+vtm4a1DkeYMDMZQ1hEoAoYQHlVclgRCS3qC89obLd+3ccfbk2ak0U88iwmSD80FKSBDxzNYVG8lzbgBEpHDBOT8ofDkU78ZCcqSq3lcATJKlWTPNWjbLI2XCs8w2cr6ohl3m2pjGmAAiql6DS9rJxXP5wYZVkRpREqcW88ra+mhUWmshTDp/97IXA6slYDygSkHFEDPbAB9v+bZvHpPCAtsoIbcoeHGs/8a3hkkJBOMmD+j5s6dmtfICwBfV+MvGBL5g8BBKGpKAEFDMmfnTvfbdgyeytntzdhEJNjBiZByYNCITEBfhBO3PQBA7cjQinrWNCITdkuqPqXzBJthpTN4g+pgb3FmuBMLL88Ud1ChYjDLVcOWJ1NcmulwhBA5jrrcqrRLbme3ZlVGf37Sx/8dekxzYa0uFSbz3AAwpWVuV4bd+/l1fuPOJvDX1F+/9wv0PHPnJf/XdgsHzWg9SsMKbbYnZ7aSWDBFpk3nvE+ZMdzDy1nFaNb0aTZBbDzeobtnLr79Y+9UFvuA5AQ5bt8/xrXxxhYSvVgroOZCgL+ngCBFjIGrXRtZkiX1/ijjLnjswUFVraHp6+vjaEAAkQt5YRUBxcdWd8ASvQpVhYaMVoCpVpCg0ulLwfRt61VRx067kwbMAw6tMBEhp4o6NS16TBUwKJcOVF5UQQCNRW4bRLcn8v5ob/NzZ7v9+tNhxsT1cWWgCTTXZGJ83b5E7rld21FKiEP32AKZmy1pLxciM+iy5pHlhkJB0mBkQZmQ5VCkEDZ7EReVdUQYbonF3zViSW6FaM3cTE5SNQhUh5hRidVRqLW3a2vmxaaE8qEPmLfPTHx+cdRHSRAINUjpVNYZGQxebW61Nq3Kwa/fi9Tcf/uB7z5JUvgykiEBJeB9kpErEqXO9Sci9he0dwJZkgrHWWpM10sZU8KUPlfog3pGxjTRP09ywhUFUyJokVc4fhsj50lVFkuYQH6FEJmm4kVjyqoFy+4pd06wSgkaKCIyx7b3+sPKltdYH/cgjp+8524NOExIFFKxCTsVyLOcCUFOjSi5wLnm7bi/YKlvI0buXMVXShTTNt/xG65ao8acvfMHkVViMevbN0J6tlu4anHqaHrlyasdVtGcjDAJZRiqkRsM4oh1jb7m20aRsxJ7QajafiXd34lxNEGjjpTAhAa2TXe/qH1sLbibLv665FKeiCRBWZyjd6qBvMcCqKmSYQMq2mhsNRhv7Vpe+Z2nhTa9Hs41eGRIeY5RZhbKmfeqBU4/ef2xmfsFwM20277rjoaNPLe892DxHKeQC1oMmQj3PyjfEzPL5IypD+YXXyNHToxNn/MYqNgbol640tkzMt12n7qUxki8cWB9nwrl9ABNj/ZUb7q17wLln+RxHVn7hkgAAalqqmLZVCMn4OUgtOSdgpklcthVjSzVunUhlX9t8eYVYQqyWxdVVd7gQFErMzooGEfUiEpPpFH0uIVDSf2B55uiucNWcX2qY4yNiS0oEAolqmNC6o86mxjlOBCVSq1QFA1GiVKCVhqQqvjVP+/PJLxyrfvah5D9dnB1kr7wJrzGqwmNyYK1bg1TVgDTq1wupEsEnGQBbcahKuMokqSQWSQJicJ3mpoTBBl5iyj7CN2lsvupQfRwYeSIDre08an6YKP8R2BpiIhoDfziSCW2KfxhFWWRvaxz+0lT/v3eLtmUDUbAvq6BiMlP1uF95EHuK+Bzc/Mor/uK9HyO2qqNy1M0bi8xcVcskLJwISIPrrh9ptJbIZIZZNcRZpOBYeojEoQqLwDBkbJLQFm8apFSXfSlyXajG1i/aDsxgkTOrT5FykkT8IgPw3lMlpT8jlR0MBjfvmb+IG0Gh5LeuJgNaXV0vSpelqUP6y4+dfZzmyY4lf9XcH9bO+pndNtMgtc+hBttqSDHOgE0TqXnpBLGzEGOqBgVRPW9J6vYl0THYcjO0DQCTSD25699sWYWTlUXqDAx4Bo2u858pH1KiN2SHmdGlksBGYuRZ3yvR8cMmJ8qaSAv5YCSPSW9/vhCBLkzANkc1hgtbME6CQap7RvxHxdqXfSrG3ZovLpnmwFVEHGKYKhBspXYYb2WqREYVQfNG2ezOHG1+Xeei73ytvXSXKyt4QWohNaI3WprU8GANg0HT5AvNZlGUvjM912oqUQlp4FkaS8dlelGKFKgqEz1wbPPciQjNBv0vtwRwsnMxcv9hWEze4DoGRbktaDjnUXzVxtdkH8Dzwrp17EcrR/3zca9g9Jwi2p6VEAiBWPC8YRSuX2oywJPdo24nGTNGg0SUAwFsgqRFGY8ZCEpMnpAmfJbD/QPsbsn+Geo7SuwF9rlNzzLi0phhrJB4TscnQ4rAGJEMtPwuXvrHe5v3Y+Mnnuo9rlmnqIwYEhZgZGC8JkJhHAVHvi2V2BsTi34SpFQNSVblzZA1AHBVmnLERTkIIahLEQwrA8zMacZpBpuocPAagpfgoVJLuU7IxcYQ7EBCE7y/lE4qJ86LD5D4DOqojESNwig4aCir0WjUG/j/1LzlzY2G1Pzt8NXIKThPK+ggBE+hEO8UGwN322tvXto91y9KVfV+KIGIyJWV86WxGdioWDfcKPrLGkLM7ui4KUFAqg2RNqQNTUACFpBEztbxa9vzkTHD0FZokKpK8MPhCimzim5FzbtCgw9BAalCNdNpJZawDcEZ3RI9u7pRCSjhIeUDmhdtK0ykUrOCxPOJwldReuG8XqCtyUmTmolbysqRdrBm0dmG4q//FavUW/9KouO9TRUhGu+tr83vhW9LkozyJ/trn/FP70uXXtW4NMkKqslux5nM8dFqRjZyHg2QyUuEYXoHzu7PF86/lvMzrnEQYVdI7xmN7hotZ1mjYZJXmx0cTDBUCxhDOda669kYPTwKRMEY5ZaFuGR5/fb79v4f117yY1/f2LuzPyw2+yc4ptdYyapxZVVccV3z6teEfnjo9MqwX/Tf9F3z+y7qMFqxd4TYPxsRUM0rR+cX7bc9O75oKb7dGe+Mc8a5jpm8XqR9/IrGOT0W9vw/v4RBwFdwms8SB0z2hufcJIwCoQEeCEG1QVTg+cbBqWxnw56pvJmUlbYm9SK3YmBGENV85FQp1IgXFiYGk2T+0b4deVyxgE+egERZ3jF8RrW2NDrJFzIgnx31b0vbXkqHAOVYM7VeheBgiHv/iHb2F/x/PT34uSe6v3p5a4dzBnAUkqAe6kkYlAhUSOo0Uw15BhC5FUVZBcZqmgVmrUqqKghazlVp2s9sCrXMRCwSiGDSjCmEEIKIhMAmKDOPC8K1GnjE9tFEQjuyNfigqjCiVtgYImZTF2TGKApLDUsUWlq9u//4iRABc0IQGY68wKamCmbk3JTNKhXLtnRh956ll91+/Z//8Z0dk6sP6lVVvfeTri6QEeVq2IWyzaYoywgkol5HbDw1NGnYJHFuTWSUk8mJ+QWGypu2SaUabhSDdYrg3i2zQoILbiM4qcSneXLlxXsBeBWTsJHaOhBZUqyf7YuISaGNzhAOoZ+mHZiR+joOWPGh1iNX3lpmY0Br919NYmGTWld7DJl5NusT28EgjIgF2nJRW354rjVuQ7ZeDk9gozL21XypEQx5Q4UgNV/5eV8tgaHSEDNKfVa5zp+Fx2/K9z7/fSbQ5HzUnqr83eXRPG+VQa9IZw5ya6Se2KjZkufWLbmEMQ+EBmXfW+nQ0o9fvnj7lVliR+pVR5nhLaXBGuUMiIqpqirJWj/z8z9+52feferk2qWHr335y94wGELVqRKxAwWoQu3fmD186cY5WZmvYRjo+XvAC2j4VFVjjIgcv+PpT73/gxXkm3/ke+cPZs/7waWmPTybHz/eM0mMJusqlo5ro6okpBAKjKl+oeNbFwhQkFc2iTs6TJ/pyrWLumcKJ4aSMYeYaRpzk4puyboC4DtLn6J4RZINfMjZxD95KKkkIqU1aej9XHqxWXrm3589+fZH0/94abKv0IYYx8LirJhgqALAY9B0pJ+jOhiaQEHEg0jTVIwRJpSFZW6MnFRJmWUupUQdsREiViFL1phEOXgjIYgXJal7oGhs0rc2SwMAE4LGbSM2xKoxNiSwMLCe1ICYlHwuSP73/mO/O+o6J2JIiVU19PoIMKkZioyczDQEQYXZEUvAN3zLq9733jsB9r4SEWOMaoiF3DpfT0aUi2LdVhkFJO0ERucu2r3/lmsai7NJMy2n2XVXVu9/6NRHv0R+TmEuAPDYLkGlBIJVdVApB93RsEuqkK02J257ZaXOgFzQ3fvmr7vqIOuk22P8UAwBurKy7oIaY7Jsev4Vl5780iOyYptzLphUA0oSNfbJ7uDiqdaWcxCoGaf7QWC2iaoaGjMbTCTqxiXBccy62Qwcg4Axm825mfcLLiIAIs4Yc8qNQkJ7sNQRU/KwNIG9JWUa04dsZQMVgnJpQssZn/ukdMkH9PhV2d6LaHpN/QW/i7Z0ikRFGQMmxUfXjy1i72d5o9T1V6aXKbGq0HmlGR3vAbLJfIQSnNywY/bNN9OoEK6YyJhU/DlCAaxqCULsVdKq8lmefOObvo+IghTeIYTKezFsDRpkKmLSF0PP/TU7ztmwzzOpETP8LO/eHOc1rV24cf0rJD59YZxum+euChG2dPQzj3/qJ//42Eefuf89D/7uv/69F/LZhPBNB6cMkSWGUE2isuVGKWKxU8nLbLcUxeQFNfAUCKZPYQWYSwaXTcnQCVRYIEqSGV+zuNQ6AWLgGZ6vsJ3fGawtq7RMgnGAVneOqjVB+5RtuPWfzJd+dnHPl9zox57qnjBpA4kDk1ojSLwmwhwizbnWa75WI1CFU0ShR5VAEshamzeSZpMUlUgIrjHsZ8PCB6p8nS6OGVJltgknCRvLINIQnIifsDvE28IYp9sERMxRWNNJcF4lGC+2amoAgmTI02L6SV/99PqXf+f0CvV7O/fkX/f6t+7Zf5DMGd/teucSTryiKF2kqyQPpygG1U03X33osr1l4TRAgmO2W8PY+gcmaFaFfnvOzO2abbWmMp4dlqwX713dv+Q6s7T3kkPf9v2X/9BbKltpZINVhcjkQRpjZGiqylIjacwe6MxdMnvJwc6+Ja+joiiMsZNayLZvF6+uMoaGRXnlVQf3zHcmVmmSv495+ZW1HrFmbAvH+/Z9y01vfEPrSh0MRYaUJtOVGS7N7qSs/f7yGea0GWaMBkVQsMQkCyFmJFQQWQ1UI1f/thV3Xgro3BzLc69KVfWkhWpBvFG5pprZkGZsigQqxL6+AwJ3zn0AYEBWEm96M476vvmn8syhdOqQXeia8LymgBSkREjm0L6jf2R/mOmyfRKDS1rN65LZAcW1U7M7KHjrK0QycyEl9szSajxx9Y6VIsnGPVnOhQmCrj5nCRjTewAwhoT8qOoPy17pXEAgoixL2BDIQflr0Pp/pdYVwLkbwIQgd/s28Dd6lS9uD9AgbM0TH3vAbGDv9KJZ7Kwvr6+urj7vB0uPQ7Pp6/a2e4WPhj7EztlJClgkQBGkWcjihouZx3H+Ub3CKAIorPZoMMpv392dy4wTn6hPvJhCTGSaJBIiGefolW6zbR/Mu0eDhBuxlUqV4JmDERPgk6xUZzCohj+e7P+JizpfLvEDR9fuBeYqrpg820QNBTZiWJnV1KRDdX6UWSwFSwISZmUSkooNaZK5TofSPIgOVLUqG4New1UonfMCUR/T6ACsTZMksza11qrWPv75k48VJGpAlpiZEVRGZVkMurTqdZSHZKUw/1c1+oFjj73ziXVK/eFXv/LG234sy+eKoiCYqtsNw8oYCsQbrqZnCQyAPTDdaX39N7ysKCoyHKRQ4fOsW4iMGLM7W3N7r2Ddm0wvVa3K7E4LdqEalFIJ9GTv+NRNt17yA98agpPgNIStHJm9frF4lX3ND199+w++6tC3ptMXl770rbmLFy6+OsnSELyMF8j2EVSDTVh8eP3X3WjrAuumvSCta8Vrq93EIDUmeHpy48h85+YbX/kD+7/hat13en14RkIrBd+6dOU1zb3/svfI741OWN/mYBzXPEtiVC3FDHgABdTJvW38P1u0W8YT95x6Bm2lEpqkj+rejljOERhFCrSSJG+kaWZVVX2QKMygIggTuqetM0FVu97PoLEu9C7/2DXpnut571laryIQYMuS2fIan6YSi21Lekf/mW4Z9iR7PsZPzJO+mnY1yEZm0XFtZBvlkSpImIREjcB2Rvb0FUsfnscfPfrUCLNeWJUywyGE8yQ8BcCzWHaJQGhm+X9B2mfydM5ftuan3v5T9UTYXuWI9CYT+PYFjnfeLy94ny742Rd5TyfsB89zqBj4suEkSx762B35aqffk8u/Y8crvvHVm+78hZK/qkrg1PDBmeRjx4eVr3OFUse2dZqVlAWyMNDXPng6905rnloT0zZWUDJlr5iyixl3rCwX2RNDq4ygNe4tLt8YzcdzFdqBlED/z3DlStucH2+6BASwgzVMnsRIIpxKuvHaMH9JO39Pf/Dxs72rZ+wlYkhQmpg3VqDOTwgRQSWKdYsFbK1Uo5ECE6psyDBMmpCxRsWLVCCSqiWh7l+OtHW82QlHdQYooqRU6qqG1igTDw2kDupUhJWJEseJNJpoDlz+3w3+Y/f0H518yq/x/quWXvHmbz2445Z+vzscdJdPPjbYWGZO5153Wz7dPHtq7fLd7f0zncoHgok6Jk2xS7tnP/iBz5R9ZGkWQhmCA40ndETZkhBo8eBNKrnnIr3UXPI9r7Y793g1DB+Lu8Sm78v5i/a5jY3eI0eTvKlbbPXhb5l6/du+e/7A4WzH4uKhyxYu2zdcW+6fPJ22264YjjZOpxlL2Eo4KkRMxMRJURR7di38i3/1A1NZ5sepVZ4gvghVUfz273zgzNmNXdPTORaGjRHPzXjTnF28+NKDV6PVP9t74IZy9vrO/l3tqU7a+PnVR63a25qLRdAkcDA2AWeSdlyaBEtqgCjweAFukPq2CG21/jULTp3B28bqw6hJBiXqNigsOCE2IA1wTraS+m0RyYrHi2ChmmN1mlpPDPQP8cRN6a6bec9x20skYWyhVDl3bU9SQDSFxheHpx8arn5X86b/4Z+4h92SmP8lOUDGKHQyt0E8XnqkIJBVQIgDMQuNprIPvGnXsXlaXVlZG/gbd2bW0MDBcvwu2vq9X/k4h3h0uKFJvnlzvqbGBe+/+ec/9VPjn7c9oW3P+G94A0C9B1xIMngLh8EYPKw0f3Bx+mY+VX1hemf/G3/mB9M8e27lGiKCUhXCjk6eWPr8yVHUMRrvigo1Y8yE7O7qKx89SSo18SdBFKQkYCXtfP0iT6dVUSV7s9W7VjAwPW2d0eYcOyjX+0kMQBUA+r68zLY+WfW/5KpvyPJYtgUzSS12SmBBhGOnjvV637h5OvtYGP73lY3pFt+YpaEUYYpM/aSsEUWopKBxu41qTWhMANfgwli8ZRhikxgmllAFGYloCA0NqQipelECMROJeFKABMYQGRqDCrX0dr5js8SWIYdpwTSFW2xbruWp+YDBO9Py3/c2/vT0xvETvUY7vOytN9z6iu/xhV/rHRl2q0F/ZTjods8eD6CF197WXJpZO3X2ovn2oYXpKoDAsb8tVNWOXQv3Hz3y0F3H05yyvIHIYmxqpCobCiFMTc8k8zsDwigML/qWV9NMq6o8qybgYNUGjRl5A2rMTq3d/XAYxiYSlkr3vWL3a3/w+0uxg7JSkrIoGq10et/imUdO+kJtnmwcP+l94E08MeqGCGPYZqP+6Du/67Vv+ZaXBScwURs6tuUpKYNl2B/8+m/82WhU7JxdGvXzkHEy1ynVUWqVWy8/9JqDN938xezh+548usfP3jJ3oDGb/tvlL+8aNa9LFzPkoqqUrMA+6MMjErpkOkinnXE2aE0ZTbLZ91CnaSYOvtaQ2ujpb/4AVSiJ1MJrcS3EEnkQcUFAkTJ8q90fc/AIADMuBdUbwJeGxf+QR78rve5QurhuRnkwKmZyw85f/lv02/n+4Zl7R6vf1rjmWNn/7/KMx+j2fM/1yWJJgQkkFJi3bBhbjsFQIRNYhb708rnP3dRpViXS/MhqNZXT1fMNkHqhMe/Qtu/9CgezqjBIhxvqSgBIcmKFfu1tABdMGY2LwM+W8BlTZf3Nx0GxsPnsYi/jRDCLSFm6i665fe/P3QKA2w0JwJZ5NrnYrTSWCgXTxrB6/a7Gg6v48JNoJuxrgbqIKySGpsYcXD+eld4ZTCJKAjTaliC9T3azN7WpOVtRs5+XGxTeVT1+atj/97iJ4GJllgKL+JhQLg2mOPxge+Hn14+9s0j+fmu2rEZMHDREvWtEvQtVFQkS1ixuDu3/e2rvr9KJnzuycmJ2/p/MTmVVVSV1P5xqbkIFyyw8ZiKKpnoL/gEgpRAiMxoZJpvZLLHeVy6whBJEIkIahMiXDqTWWkVEn5MhSrNW0UtX15eLt1473L1z8Bf3bQyPDxI7tOzZBMUxVA/40cNl7+wZaWx0gjm995bLb3/TN3UaB5aPHRv0R8Nh0l1fRWi2OnuytFVUlYxGxMaCVvsgThAQLMfkq2fb6/vv+46v/+xffEmkLVIqd9UntVuqNXyW8zYAdWVzvmkXp70EJlAIMDDCYwozlGVpd8w0L969fs/Tuc0VsKm58pteMXAeBDUqgDGmdC6fzZeuXnr648/YRtacme6vLWPTzxhbIvUImJlOvuf7XkO1bYpJlW21NBekGjVhVhP265U3oanKUrohDexU+3PrT9126cXf+LZf/pNb/+Bt7/7UG5449AMHrvuRK1v/9Z5PHPUnF2dmHt3YOKl0RHVZhQOB6ZJ06vXNXd9kZnZ3+tVgpIAhY2AmIiq6faUICW82zWyCm6ETmeMYLiDyicYHreenQGrRejVMAhOImDyrdLT9vu7ZO+jE9zWu22emNqTycX+JRCBRl62+GxK34RiUSVifMTueHPSeHC6/sXmZmuQdo4eSVjpTyWU8o3EXHftfsQ6sTBPVNCKoGiggenZ3456b50zpPFHw4NT+/gMbl8019nUsR8iaPl9m+8Wmvi2FI93BXz5jjp1dO/Pk1Ftfm772Bjc6q18FeuevxjiXQuvZMKDn7wF/HbvCGMoy/soX1CNWq1QA3G5c+B16QcX1zdjg+y89cO+pR1YHGTPABMnj34Jq6qrLdrYqqcQkvIWYwccOLGX/qWV5eMPetsQLua3mbBkqNzxT6qep+y3J7FkpvCpUeNyllgl1RW42rdc2pv54sHqzyV+ZZcu+II0aqPFWcxQHCyqiZdf6Q1XjF7IDszv1V1dPPlQNf25+177gI7NosN6xsd6mpAFOYQWAnoM13oSORBXFyACRJJlh9SaymtQquMYYIahaT8yqRoWD6x5bfnqmmPln3/y+cvq3fvH3u1oF6wEhtZ7ZMzLD1LeJmaaym+xee+03fs/ha24crutTjz7lBkNfSW+1qzDKpElis0ZYPVuurhMZo/Jkf/RAd7A3yYhr+l4C+aDXXHfotV9/y5/9yecW5qZClTNrCM7E4nkQZjZpi7yi8vnitGlkvuizRicNQC13E5+ySTPOU1AgS77wU7vmOrtmY/MXMyvHrhIxxjRm2uID1KTtJq1orYYFTAgoW1nj9OnTb/3eN15z1cHglCPKlwQThRyIZbPRHxXViLmtvjMMvQ5moGxUSXgwGjay7BOPPLpRFd997VsfvvgNH/7Eu9/30T+8ang15Yd/r3rMrVVBOwwyIAYrJd6H+zG6p3zgve3L/u7LX/XGuUI+8VDy5Eo7b1ublVKIXHCOb1KkqI7lLCc71qRbT2NeKAYU55NnKRSJkgEPTcWsC2HurMevFY8td/pvddfOp9PLWiRKqacRB0tM40LLOJNbc4UoQIHnaNfaev+z+sSr2pdc7OfeSc8cbVbNCjtN5yLbKUgmzBysGAut8JYLERUdWu6Q/cKrF47Mo1mqKhOgUKf6ew+s/sytOxny1ahqitHi7ProLz/W4mRXNtP7/JOjV+4XDhZ/rej+5x3PVjHm53jfOZ95SYrOL3RsrUJv/XkSB/zVBwN2MoEUrLBa/6YeB1rNn7h+R5NhVGq8k5IFyoFcMZdctbNZ+JhwZ6GoV8rQuj0qqHFnXfHe46Pfetx6mwZzOU9X4A8Wy8vek4cVNlEzSBCCiiAhFCG8rbljibJf7Z0+Kr4tti5wCavEnLtRJZLM+MSVumJGrZR/ka/4hfkDd+na9y0f/YT6HAZC3iVZaYilkqBqtvv+m1oi59QxY31PfFAIw58jasHKiZrMGQzcsNt7oLN64u8eOvT//MLnD7z6T9+1avdeKQ07Vc1mMm8w25KZuWqqNWrbLF3Fmf2v2v09b//JK2583emTG0eOHS+q5qBfrTyz7ANDE+EEmeGWQHy5tioEsvmZqnr3yeXPrnVXg0T2O0TbTfy2f/itc0syHBTWWhUyJhlXJhVk2CZa+eA8p8+Dbxbn3UYfgAQVJ1Ee2XvvvReChzpR9UrKVHiIkmjWakd8LXFsICNmNoarUZiett/3/W/YDAv4HN+IAfR6o54MTcOMyHKZbs50FRYelWVgfOHI0d996IvTrfZ3ftMP/Z1f/Jnj39xbaz7TqBY7yVyTXE6VQSUYBQGZ3Eie8czcjn1/8eUj79xoj372293bLj/dKJKRT9lY81wGSESD34IOEoXoBQculDRlQ5qiRMU+zA+m7xmM/sXgi4MGflRfsdvODMUFkBetgGTLWgNqjEMUbAlQFWIkZ3rFx4qnXpYeuiTZ9aDpfkxPZqbhWa9LlxJjlWSruta493P8L5DCENuZkd7/srkvXJ2bKvjx7CaVprUPr5YffKqbmSg/TC8twiWVVrJjkaY6ZXumNJlbGZgCCXdequM/23iprPFXvRP4Jds2tu4BePGR2tZT2vxh00xsPc9uNXjVjr0/dM300A1tzK0jGEly0W8+PD/DGkFtE5BFxFZsA9tJjMBD4HCDbe3Pswdd/7PFugQD4Um/LqlRpaGALM0H82PNpSfF/UZ3pVe3OltVqrcrJcSaqzAF67xdg9ug4Q/jwH+eva7F7idXnvjFqm95JhN1cPCagk2NcaQtr4ltp3NeYxmpya+iC8kAszCKsN7rPj1X9n7wist//V8vvv0f/M+n8t/5rUeyjt09e3jX3I3DlmgqhguyZUh8weVwtPbaV73y7337jzZnLnr02FNHjpaVb42G3bVTxykTJg8aGfKG22x3qlC5sgYw2SRjW4HuXFt/x5ETT41GtWNOobtRHDq89+//o28aFb3gGUBVFVsVU9gkErwG59b7YVTy9hwI1wEdALjuYHj0NAD4QESDMxujlT4oIU5FjTiIEwGHyq8/cZYBDTAwzHY7aISJuLe+8aZvvPHmWy+rnEwk0ibvCEoxyur2hoVjm+qIhhxJbGpMkQkhBK9GYK09cmzlPffdu94f2HLPP/u2f/MTP//305uH3bVTLjSCNpRz5RxUQgelH+zdvadp84a277rnqf/4jseOXP2q+V/+wSOvaq31hhI2Vw2JRrGV2kcJQcLkzvBz65CcY/0j5CkeJNWkLYvvDKf/ffWlN2SX/tPqlV7tmqlYNHdakQqTQCEqUAE5pRo2DRaJC9kMyuJTo8evnbl4j13qOvlLe3xdfe55OslvyneULGEcbclm/FIXNkJs/lJVDUf3ZX/+6qZzQZ2H29zNYp72L55cPzHwhl96L7Yqe8mSTfcsNXq8OjyZXD+XTLfhq7+KaSW5wOurPMZF4C3P+bxSMF3wT2Nae9r+iwtd1/nl4ufNHV2wUXOzCEwTFAC9uBvNVTNz6/3Rh+4e/skdo4/e6548JdNt3TljQxjbQQGRU3/11FRGo7tObBhuGIgU8vKd5q037179whODL60ZY2o7GfVx6wZ7JUTrz6qEwAGUqtU0//zorAi9gqfDWIgjIvKIiQxXRMGFg7ZhDP1Ob3mHzW+j9lC9kNGaoIKFSAlqRwpDkpAEJS0sX+071+ezT6F6V3f9UXVXZ60dmgQVTyYQAWZc/qW6wnye6d/6os13qgLGZjLSXtE/e1m78fdu3vdPv3/1xlf/z4fwzvee/uzdzwTf88O+D2WaNmZmDpxde4TVM1mvVVENL7/tstf//betqz78wCNrp8q5xV2D7vrGE0+Z1Bu2RJbYeu+bc4n3y+tHj+X79+x+1Sv6y2tJYuxMAiVlemzY3581FlJbhMCAeL3m2kvvvef+p59YbbVZNCKFot9tWnM7Ih9NcOXc9ZfDMpRVIETECbGFIHhgbsfZv/zC4DNfIpsqMRNVQydB9r36JvEIXsHMhm1mTt9z5OmPPQS2qqHodt1gGFW1mIkNJcQUTJ67X/6VH9uxtKgaW90QZUEUCLH8LsyGHnzgyd/7g/ctzu3XkTobGpew1dw7cJYKgRgMVpOkJu+t9852V+YWOkfKIab2fuNrXie7Tj/12ANplQrlZDyMU/ZTU7OXXny5qwKxMXnqXPjLjz68nk5f8YO39K5JR1/8cmu9lTXSUsESTPCqKWnksBovatUL9+9sX3VAnT5TBCJlWBFqus6jkvyye/gxWvuR1q236K7lfFgaMR5M5M9DkATdNBFRuZJBlVT39Z+6YfqyTqPZ8unn9Oz79Jk8tEcY3prtuFHnhlkY87KOU9ObFiBSD4KDjjrJx7993xMLyCqpmcd1UvFRYh04JdVrFhpEsaL57ObqRcqUq/e2Pe1xuu8em/7Gq2a+4RViSUVeHIcPybN+71eZef8CGwBwDrSGLvynzacw+dsLBQL9FTcAbN8DosF6cXUI4z73ePFz/53e/4XkiWP2mWV8/qnwmcftVfvN7pkow0TEzMwGpcjLdu1cd717TwzaZnY4OvO/vmzH/h2dYx9+pHq4a5La7sQql9Ty13XFCwEICKRCrGLmsub9fvXRqncd2gel4Wx9/gEISoZZvXpAVa/m5gkNHyy711iz32QjVYGScmQGUAIkEyZDwYYkaM6hGiTlxWH6Fel8YYfv6Z38aOGn086VJiFyBTIrE4aXGEaMg4nzTT9xXVGrdVbVZkm/u35qT9L+/lfN/PB3fHHh4B/cM/qD9x578IGNMCJbVaONdfHlxJ5kaTocrTCXKk4TvOXHfha2/cDdX/YbpnP4YpJq9csPJmyYEsCqknP95q78qu+4ddQ/c/yLDycL07tee9tgpcds0/k8CJh4EKqjRXmg0diT5R5Bg2RJ8+prdn/4g3eUIzKcCPoQS0RxAwAITK47gDFz1xwKwxIKNSbubapsWlPF0ydP/p+/J5VnmwclQwzC6lMnu6c3mtOzDOtHbuPYytMfffDJjz0kARKCVlW53oOEEByi9hM0SZKV5dUf/oev/+7v/gbxBKoV500N5FVRCqqiMJbvvvex//neO2YXZlx349Jbb7v0da8bUm+lv1wGZHlqbErESgYCa7IB5PipUxfvmtVg711Lbzjw6taO9gMP302iIM/E1mSXXXqNtYkXZcOcWLBpd6YffWDlzjs2Drzspit/8BVHjx8rHl2dDs2KXGW99clEsUTrDOPzOU9jJ5SVCCi0nCZrtdnzzd8Oy79Z3X+Vnf6Z7OU7fH660SMIiyHURJs0tgfjnuM6j6cEVrJkvIQjGycvasztbuxQL1Vwv6ePnSHbVptb92Z7acOYEF38uPCjHNGmoh4ZBSsC9DNv2PWZy5L20HtDPFmJkcMRbAlecLzvXr67NZcZkcA1dPvFWJ5ne7tJSSVdXOjcemPzqsuRWBlVL07g97nd/JdiA3iOuMf81NvfPob8bzmlF7AB1A9hu/39qm8A533Ji9oAwlOni599p1nt5tNNm9g0y7iRofTy4LHkDdfDbgEFKUDigBt3Tz3V7T58svjWw+ZbL19yls5+4mn36IZJDKiuzcb/xpogAjBuziElVrGG28pB9YtltxB3azoHhqqoEoEMIURmLiJSygNfn099sux91J29Lm3voizUzQiGANKENDVKpCYwAw5qU2fX00HL2deamcVW+xO+++eDtYesXpXMXiS2rJshN5VX64CAzt0AxgjVCYjFrHX74VtvmP7xv/fpfNdvfmjlLz+2fuKIa9gsVeHKhUE/jEbBuzoeAzrtHd6NqmpFBNPzu699zVvuv/e+7oiXLr6kKIfrn/li0e8lNgGskgZbzF2146Kvu3Z6766H3nff2jNHNOOdr3lFMZBKXD7XcKIpI2PueffgcHBlq50RW0PisWfv4sWHpv7iPZ9n5qAj0iRuAM3ZJULCzJw3es+c4tS2LtmnETqohBBMs1OeWj72H369Wl4jblKSqQACTk2S58tPHj31xUdOfOnR43c99vRnHt04tk7iiTlUzg9HUlRg47XyoQQREw36g8OHF37l1/5JM2urMhgGEUMpPuBU4UUQVDWoTe0Xvvjg+9/36ZnZHaNRN+10GnuunN2zuzXfklCsnjmdGJs3WhEdkDvjyQWyJ06Odi4m1+xJP73e76Z7B599MAwHzMIw+/YdmurMel8RGU5TayyRknLaSIbDcMcn7z2yrNf9yOuzG1rPPPFQ+5TMN2YGUkKj6vAmDerW1XF+bFh7CZoQBbauKY0NmXnPqPdLo4dPUPdHW9d9W3r5OvnltGsLQ2rduBWHaEJkTeOf6y8VERVW0dPDtbnG1FRzugzCLn1X9dhDUrR5egUrr04P3MRz/azW+QVqXl0ZY9UJAJMRVqLHLm1+4rULlfhg1DOMKG9xRWNrOxMPXMgNblxqSL26X6IIAARRNoaM1SAqoszgF4wyfd4kz1c7Avipt//UV3UD+Cv2AXwVNgAGRr/+AfPw08lsQyrSQCoQUtswdHpVr9qDfQvnNMMpJNX0kp2Np7qP/IMbDk1niTem+PSJ8rEVypLo+I//y6ogeIVSUB472ImwIyKvByh/wHW/7PqX5u3dZFUlhqmkyD1GBAuoUqmySOnFefNPy1OPuOLr0ilRJTWIQpfEoFh2II1YE6LKIHU8MsHD3qTt69LGKVt9dDT4YNmrUnOjJrWxV4bWwYTSBbwCigy7ipTZaTjlh+HHb19+1Zt+/c+PfvKTpwaDzBhKrSJ4eB9GVTXakLIUFQWYmJlEXTOZ3Vg/IaLErW63GioWL7lE+sMzd33R9fpJPkuwIRRoul03XbHzxtsF6Sf/23878oVPGE49wu7bb3NiSu+yhSaUjIGyMOBFP7Wx8XVz843cWNaqoOuuOzC/gA9+6M7ULDBDVZlNPr1IMFRzeWLt/qfdYJjNTnEjJzKoqv4X7z/5X95RndkgTgWWTQpRCYGU0pSNSQyn6oNUCmFrjNEQVGQ4DKMSWrc4BzeKmHgV+ne/8v03XnW180SkTBpvtAQsl/6pvqukVmpIUvO5ux/78Afunp5dLGW4cuLJI8fuS3iq3d6XNWaSNO+trlSubM9MedKhVRtSAcGYx46f3tOcumJf4+4vHDnxmU+losPULs7uWNqxS0QVakyS2JyYROF92WpmSzttNbS99TNTOzuzey7a/X03nzx2tP/QylSaePUxA2LHPVR1vgRA3e64tYU54qQZ5BUmhNlPVv6/lU+/R07cNjP9dn7NXtMZmXIETyEVNkOjloh10mkwOQjGIKw4zUwAusVgrjHVTJINSMu27qpOvT+cJckGVXdXbr89vxoJOROMQGnTmsdIggEQgiGAKoNPvHbhqTnAwNaoZ4VCt8oDxPlPGHm5camZW3ou+/IiNwCMPanNvNoEJTyhZwQAG2XDXvTXfbU3gJ9++0/FdiZS4lpeepMnV5/T2kYy8fiiZ9lS/6qNYM+Rp36xh6qHEMp33aUrXihldRAVCWTUq4gEvmxffsulWlbbaXFVSFvMb7hofytJKxWT2t69Z4YPnrV5GkJst49KcCDBzELbl56cRuvAASziGBSkQZyl+V391b4Pr0pnG0EcfFS1cwYaRZSUSWkUMBPMpXb2f1Rnzqp+XbLoQ1AiAStiRihG04qoqhpIlawAKJxif9n5FlnYmemjPHzvoHePH+xKWpdxi9RVBqG2/pu3eDPHCwiRctVI5k6tavd7X/e5S259x288sD6wnakpSKXO6aAvg8Gwuzrsn3FlqQgxR0XKpCmjUbmVjeGTIpnANKf3XXTZDej1Tnz+Pqizxgbjnes19k3vfNkN04euPPngfV94x68vf+HuVtJxBOdd+8YrTXuuGg6yxWYVyJOqCIiJqBL/xe76bQtzuaFGanrD8jUvu8HR6JMfvzvLUglqLOfTOwlMBFEl0oRteXR54/OP+ieeXL3nweUPfHH1Y/f7nlFvQFBTGlLLCK4voY8Q5Q+FgqqIFafDwais0B+Kj7LvIDYMlNWaKIaD9R/+kRt+9Ae/vyw8sVWG4YieVIU+3C17zhcq60FPloXrtO75zIN3fuSeqelp7yrDGQ/cyhMPdbvrOrVoEp8tzARX9fq9RqtFEGVVZlKkSfroMyefXHHFg58uNwaD7ulWo9WZnmIY7zXPOoabKoAGkIeQQtbP9PdduvSa1111/33H3vUnDzz6eHjlT7y+2yzXP3FyJ+UjK8qUBFZQjWUAT8ICJlgomA3BkiTkM+Sla93h3K/zxrvckTQzP5Bd/tby6lE28iaEetsAEVmtTcI5lG1bWkqjzDoFYNY2jDWDDFNqBsb8dnis9MaGQA359vyqi9EsE2Gtm6ihUVRyc8IKIYCtmqcX7Z03t6uEDeLi0E2XbJLMrJvgqBgObtrbXGikoaZNfLZC44sYBAXVPfF15SHWJhVClJjmA//3++79nfftuOFwPtciD/BmNzW9kAT2Bfjv9Hl/81zH2/7mr4gN9LlbAf56esdeeDsCNTOzZ0oefZqsJQEcgITYEHkloSwRHy54/K3/FGLTSmG5bvxSMnXepG4xsdY6dQxGBEsokYcKCtWb0plD6fQdYfXztv96NBFcIoipfz6vlP31dnajc8kvrTywg9J/kC6saTBEUmfnA5QRs6Ox6swiUEhTOHSzbiLp28IVr7X9P5h98l2D5R9ee+Sb87m/Z3bekLU8uYF6o1GrUM7nQZnF7MfPnn4XucUw/9nff2jp8rlLr1187CNHBstdcd5XDhqUHXMIoCAEabBSkGHlz1Lwq2uny0HTJmrTZP7g4XLQP/PQfaoBSh6AoHn13h2X3pin2dMfef9Df/bHqNKsMQfLrIqeH50+mywddEXpRKrKG1EhJlJVTZg3qvAfHnr6X155cW7gNe93w7/40bedXFn+49+8I0unQEEERBIEZIgswYBhRGT9qS4qD1+BXNC+IJhgSTKYtDcs2mknWFcUhXE+yTKkGScqChFhjNslUK/bQAgk6v2NNy28/Z/9iLgkSRNE/bX4NuDowK1X3hoKAogPoMHI9/pDy6wIJIaI4vxZe+hut7G2dO31dqpjGjmc766uJM28MTfVme4M11d94dJm69SXH6be0DbaST6TJXO+ytb9BsCjapBnnUY2laDBkhkOrvREBOWPfOSRteX+1HTz3i+d+LX/JLfcsvdd+nt/l699TT+VlvexN6KG56sBG4WQeDgmtRBo7iQZiLkL7v2y/GjaT8l9R+uiN+j+DrL15ijeE5GxVxuzKsoAzptUCsDUd5FV1YCHlpm0WVKeNj4weGa1oqZIP5FvSJYu5+muLUXBtbzrtgMKVMEBADF8WJ9rFBkb3Xoq2EZqEGVqSAAEwRNny8tm2+NH+jxqXy9qnHPVTFaN4WL51F98aP3h0PuuIzOHd7lhj/hri4DZ/PO3T6ggLmSy6bkigK2/eVGJ/pd2b3ihR0utnFjhjz9AnWnhPIRKc2hCrDCtPPlHb0SeXggSNyl6C4iQJNWpQe+up9la9YToMcQYSI3NudHKq41CvTCYJowAUAGmHM+m+Z3l2RMyvK090y6piPTPGjXpOUCjKHYgFL641rRdan+7e8wY+7K0XYhYENdSZ+cMNTUzjCFJK5ae3WiJvGY4/8p0qUzwvvL0e8LJp8Noj+ns9M3oJ1GM8bBJjq+Ej6+Vv9Q92r/qphPV9NIley562Z6pA+3VjeHGY2fFB7aGjGFOWVMVC7XObRTu1Gh4bNRfPnlyQ2V9doHWN3pTczvm91+18tRjrhwliYHX5vzM0mUX5/uvTBJ/9NPve+S9f56iTQk0IacOZFzl853zzcOXDta6+c4pKQWQoPBKsV/JEHedf6Q/unJmaje4z8Qpv+z6Qx/+wJdWVvtplmSdnWxqq6FSO4FEREwESDEKvZ54ZyRJ0Ry4/q785C0HTz617oahM6tUiBfvIULEEkLdSrt9hiu5suwHV/6n//D2qw4fdoA1GIslKIRWy/BwrygFCZMqe2jQkOWNez993/13PdzotIPztR1DAFCur4TeKJ2fC8EpEVvjRoU4Nrbd7OxM0uZwbXm0cUZdsJSUy2cazbwsMlekeSNxviyrwajcEFGmFFbUq81sd73rKk3TTIXy3PTWi0fv6z29tvHxjcd9M3kVLQYdSXQ8am4g8lAlbsB2JHPBPBnwUSl+W9c+4U9XeXm7XXqbXH0T7ZIkFEnJIrwlybLpJNXCQeb8wJ0im7rWDdLBJMRVEtL7g3tv9UheTfUVF7f8d9ENPg2eK2hNooftjroqRRUmBZPTJy5pPnJpgyXG0phAA8epiW3AFOf8wZns2h3tLSsoVjpkk1vopRgKeHEpKSd5MbuhF61e85a3qA+BiMz2AvFXPwX0HK1deAk3gPP/+tx2+a9/D1AfzN7F4d1f0iPD1HQycJq1dWi8Wzc/ejh5xSuovCBl+fjIcZEzSxU2PvKYhmSCRoCCwJGSfHbXbO/khvqJqh9ihMBK6mU3NVbZfbJYmVJ7QzpNpRNmUgYoIDatIkIwQUqVf0WycMLKnw7OXmYbV5i8GwKRPX91BbJRnYahgZWB3EOg3VT2V8nr7Y5bmnOj3H+4PP2n62dPK+2h9lwSYsunEosEp2gxHnDmp1eOpRe9enrmkMzkszceNJ0Gwcx1plcfPVNLQAYEL1VVjqrTRXl80D8+6p4dbgyrnn/Nm0Y/+69+oN1J7/jYg4u792tlwnBgE9IIkCQSH9LMLj/0wAPvflfWng4miIkxuxFSBK+E2ZffMlgfpPMtWBMEkQmTiAofSlUmPl25+zcG1y7NLBgaVX5paurDH7vviSeOZY006+zkLX0BFBFaLoC8P7EchiNrmJMsC43T7sTrl3q/enjuBxrXX1MN761OHRGTwhCzBKlGpbEMUmZz7hIAj4qziUn+/g/+ncXFthfPNMmbqyge7pbrlQDwdbOFBCKbpHd/5HOP3vd03mwE78c5uLg5cbnaVSCdmfJVIa5SQLwbrp1NmqmIX33qcSKqNkYsWq4+sbR76p/885v65fGzy+uj7gwRFL7yG8PRmWLIzVYqE+JEZSgHBBjKGp2ds/tXzp66vzjVhLk6dFzqIYy6jxEJJanm/ZB/RuSPQvdPdeUBszFl/MuzHd9hr3xlsdOq72U9lco4dUSi4wLrFlaMukJL54azSuDoccQcDmsiBDKlse8sHh9qMvK+mY3+nr1+yuZF2iWXT0TosAn9rAUPQi0AYFT0mf35U/uzCGna2uETFTygmNA5EhGLPzzfvG5na7sL9ZLZ/YktIhgmVmYFLVx26OArvhFZFkNI3p730ecWHD5P8/1Z3vNXH89KBRHHOTHSi6J/2CRL+aoONng+zC3XQSik3Zj6V393+Ft/MvjiE8CM9pftPsm/+/b0G95Ig5Hq9hLY+DLGP0XpQpfubtn5tDwhSWo2vwEAuOwJANtIXBWAMZ4mSoOrFiwcwlsaux6ouv+je/qWuenrJCs1ANhq/aPuhxIHRjeUP847uWV6GhMhF9Z+Yg0gAyAgCrRyaWBEc0fLqWt7f0vZvFaveLx94A9bJ/68e+Zd3ZVvH3b+bmvP4Ua7JwNVNsAxyf/d8pFsz9U7ds53R2dau6+jdmq50T8yOHXHPb4Yele5MoiTYbUxKI9U1RktMgxnN0b9K69f/ZF/+G1veuO3N6faf/qHX0DwIh6izGxEgwqByu5gsLK6sXxy5YnH8ukFoVJEoFnsPfYIxiTl2Y3Ryips4p1aa5g1iJByVKkXoBT14Ef78ruPH/2Zw7tEKQBpmrKChCh2mNaPhEiISMiXstxtqAoZJ6WWsiKP/ePL6V/O3xBsdf9D9yymq++Ymftvo+E7B5LyXCpKUrl+xanhlo0CtJvTwYv6YG1iuKalB2JPnwL84EaxXEgVraFqAmFYFa/galDyRMM5LiytW2T5/8/cf4ZZdh3noXBVrbXDSZ3z5BlMADAIJCIBMIlZzJREUhQl0zSVbMmW5M+yPsmPLX8Ony1b9/pKlnwl2ZYlU/kySBSjSDCTAAEiDcIAg8mhc598dlirqu6PfU53z0wPMm2tZ4Cn+/Q5++ywVtWqqrfeN8bO6eOl7bMUx8yA6AQSQF0+dgQAjQ2ZWQWJTBxPdpb4XW966/vf9OZ77n/wj7/9zSOfW/VL28NqnoLm2s5ca2Z6LrQjirkoExKpEYOOc18Odxy669QTX/ijzoUbq5WDvXISohXJVRvgTnh4wqwdMZ01yI0G+2H0Bpi8VoZjth3ktahLwEEW5canARsBq4oD/6FotE/7Q47IUyERoaRAqBYUAJgAteDwMaJsIK3oxKf8mUXJrC9J2PhQaf+MjPaiNvnQF65xK4PDxS4ESFCNKjhVkUKeUjbFJIM1BaSgDP0v38I2DMhmXrqWK1UFYCRUQFZBNgA5CBVY2oKib52x7xkP8jxef77HWR//2xJSLx2V0NZPji7znMX7wh3bgl/8e3LuuJw9DnEc7LsOZrcDqpfnFkaw0EgUXz2Vnl8ZvFRUkwgAcqfJSndoZnylcWGDrxxVBBShLCYnmXbRj4U7/q0+9Z+7Z/9Zdc9QVpysrlv/YqKi9rXGAOjnaZtFaGiOBryivZL4TrFsFASMgFEQgxh78cD1ICUKbmjXDptD749b3xpqfa278kudx380nXlLdTInY5H+tLn6SCU6NLc9B1I00EsqperSkeMXvvJdzDJmVkXvpN1ebPfOZpkLKXBt4Z2PfuSHD/3cB/7N2PhIlrosy5urHWsteVEWQhTZrFlCLodcUtYuqgUOAYVUFMGgBcOu0+2cXcTtu3zOJlZRpIJThYEQGCElZEQmONLMEmZCmxcAJyDQEGAgVVR0/aOid5plDNL1xkKvmbYmo3P//rr47bWXZ+1svnlhfPdw7eZD1Ov8/x7yt9RXfv3Cwkk/NR5Zp+wSh4hRrbJ5FXnOmBmDkC6mWiDU811/puuciio4FEPoVAhIABPn2432JgeweVaSohGR3spKedc2cL5fiwXoY+eNqghZowxBdbh94czKYnPvvulX3XXLK151+LvvfPqjH/vMVz6Vhm6cjHjn5hfOjo11a+UdZHJRIIyAicEbgGh8fHbXtU8/8dU/diu/GOz3mTsp7hHqPlpK5oO8BPEsDN8OIwdlaFYiI5KSb9ueC4RciTgSFITAaFAU0BQJ1Ar0ueQUSVB6iF0ABiSAEmhJpAJgoc9sVaiy9EhqVPtqevoL3SUwYa7195R27dNtWanlOSABNawApAWHeVFe2AgCFFEQUMEIhj0HA/bbzTWA9f8X97twBkkuM0PBFRb2S+kDYN0NrP9ecEO9hF/wAk/p0vFMmsDP8aAvWEP4xfuAgvet0BQURYZCxBMNgAUlVHNxNKqKrEhxLdp/Gx28C4AFek68qFWAK+k+b9w+JQUxxtRu29b+6gpA31jrOgE/UWuxOXnVTFiOfK8QalRGEFQrRlWMgLDcZsffEW77eHr6L3T178EY9IUDN6z/5pMWdKnJAcBqhGpxI9S9rITVVwcEQDYw4KRFYIyMiAXXiF3O4VUwckNv+KfiHU9Xu6nkdYFhoadQ/rzXmttxCG3NKZuQusfPn/XfWj160rCiR5Agc+1ue2GtfgJDhFLcaPnb35D98s/8o9tvfI0Hk+V5GEeNemfxwloYBiKCUiBZNtN4C0tPBVFjBUbs2xFGAgUi1CzpnZ2v7L6KU5GqFnylqIU4ATgCD8CkIpCIdJ2Ohv2HhgqkBlUVGMEUgszKXpIEehmyr5I7223fUFv67QN7d48NN33Pm9WxV03EO4YCJKU96bbeD5121z+58k+fPHF/clVsRZ2w9yqyUQYAEPEqQoBmUN4p/nVy/epSJyRUAF+Q9AswUKbiQELP7TzfaloVshNeQcV7zT0IKnrqpz4AAEgs+DzzaVwehUqt162fOb+4Z/9MKmht5fbrbrzl4DV/ds3nfvO/fjFbniGweZ4vLZ+FSaqVdpDNFZwCIRr23gBMbj+8tPjYVxv1d1G2LzNHg3ze4rUy9n1amtbhUYgEg5y0GeQEGYIaJuxFufXeqlUTFmrVZBkACQG4j3hGLILxISFFSgCZwAM4MKxC/SyLQRQAGMHw0Tz/fHbBgulp9tby3F24o2PbHuJA1BtPalUvJVRGRBEBGCjJkCrCcIPjRHvlfqg9YDotdCz6DmDdzoxXzOGZKxBEwkvvA65oRp75DZuYWV/k0Z4LsduzRABFVuTF3JVnTgS9sDTROqejqpapvOj4ZOpPZvmi45TBEAQIw8ZMBjQX6ajF2QH1FmIhqIReU9AmAIAaUAtY9HY+S2OkqiIhisYHJ21sNMN1QgdRUERjMOsmvuPGdk/OP3DSRiUAABQQZWSCojdYVeTDdtdJXPvT5pl4TH8kGV8/fpEp5T6nRPEqYV5VAiZGVBIt2BEV+yS5fQAf9T1HoROLCgpSMOBacQgBSxVB0GROkoZF68323KANekZJzBHfSjWarUyCI7EKKtJza4+eRBRwQBaTbnd17clOb8lQaLWUNFo/8r6r/tUv/3x1uCpqvQJSYAwlqVurt0zBRFbwOOp68z0AQJADiTp2aIhxffoJAKAhAuycmq+8EnP1JsuFKXVdFmEwGNigFCAaYAGRBLTHPDKoD6sqAInkZMLCB6CqMEPuvMsJ9FRz8Y3T6X/cf2AuqrR9q5TnOlWy1b3e5d4KZKtG4vZVN+6rzP/h8Plf/taFz/lxE1tbjoEKuMyGEHy/sHzxvud8kjdzniuHuUghAlDk61oBOi8mTxvNzsCEbR4iSIYCn+cAIGTAF5zbRlXRgLIoMrD20u7Y2DYJIlBq1NuMSmEABMwsGrz/ve8anxn51//sa+1mbigkwqW1852gNzm5HwzLYHqw9wmVayP7VuoPPJbm++yuW2H8Rg8WAQ160KZm6DNFIibVwCOREhgwalBAkD1tsK8omuKxWUDqU0krE5SMGgQAIsFINeiHyLI+OU/mvb9MTnU1dDa9o1J7FR5akrXIREZIiGmjXfEifhosqFBEB/kTdpaGO1zKda1KQQHhG1Tj15knBEBVLJCq3rCtOlML2G+uFvztGs+c9H+piIw2H8du+edLiKA3+4DLTfZzCQKe1Q08j9JC0adAxnmMwTyYNr/U5KO5oDURYERUVQwVnMByzsd6UkK9vmr2xVSzSCTYpxdXlAjQFQHl4Ax1y5Nb/7HQ3fJpFo9WK3dMNT5zgUohqCgAakEEhCYqry20tu2dKW0fzxYagbGkxOIAUaCfDs2Uwx7/rNvzm6XgE/VmMmI/nI+P5bSGrsA5XxwuEqBDBZQCcQrGqyAIKSMaBSMAA8OCmzArfSYWFYBCzsCBgmEQEBBwKJ4ElImNID7VFQ8Y2RJAU7TEAAQEalUFwWsuzdaTktSFbBzFnbT3yre+7Ff+6U9WqsMFv9x6q8/KSqPXy4EoLMVpmsZhZIwR8CogInmeWWRjzCaPUBQr+6aBKAiWLvQ6ibVVt8oe2qAhIAKKOlBgWyIgKVLxrGJECHEjtXLZNifvdgyzc/59c/xrh3ZRJA1eKpdqWiUklJNPdyfLI+VKHhgwLlxbA4ChHRP/9k06/8X57/qhaMCpuU7uX+C11qeiAomiUU3bro2QIzg0IgAsXYLEYs4MiJjkvSRDQ7gBM9sgOS+cPSKCd6xowBS7ClRQ8Q4wXVoNgyAoRxSFRMG5swsAYEzf7SGKsrzurtd88ron7vnmSu7r6MtotZ2vdNLG1OTBqFRZp5+yQRBXRhTw6XjN64xDdQSsBL64MBKDKoqoAFYLAG9/byQDSogi3gJBFQIqUi9UiN0pIhnAgNAAAagR9X0olRgF4OoJ6HzSnV2VDEBujmbfYvflkJZsCZQA+eI7g1DAKwnJ0gA2VTwPUWBPUO7hxDm3OFnyLunL4hXGBMVAoahU8LuYMMAPH560YjLdJIj2PdvyvwBjrc+FnOOlPoHn9H3FZoYufuUFlCme+U/P/ZYpkiqW0Hy5m/zfS/nRXIjQKghgBtpB7RIIbNiFbzb93Q2ez8UWXGioiAaAQANEKDRcnzt7XxF81F65LYMMlLwCKLKAIimSYJCl0ljtjU9NOmIAAM/oAb2gsmEEMaLYtTgRDH9Ad49b/Wy39e908QhklXQocGXjIKcAlQb/oPih4OxFkdRqZgEVyo4iZwMphb5ifKE3qbyuUlCo2SiKoqhqISsOYAaxTn/CiXqC1AQo2Gu3Ip0xHkGcR6/EAVlRra+dare6LfSRjZo9ntox9M9/8b2V0eFMCv4kIOiHI41m4lgAYHR0VFA6nVZxDt57BXZZoso2iJBIBUmhKBUW5VBBQLLa7ei5swIk4pFCJEJDwAZz1BQkYwAAQ24wW4jQ2kL6RpSlLxPe37jYoDbEWQ8k/3dX7ykRs5WaLfXZ4QCRtLbck3NrpfOreHZRl5e03Wj2WrVy9oPXjSSJs1hkHC6dAhvzYDCrW8wC0BLpqnYA6ohNhY5oz4sPbGO1kdcTY8wWkxxFWaBfSB7garxDYVZRQ5CJ1DuT+3dX949Jt8kGV1YapugE6Ysg9R/onXcebLfbqVtI8+Wks+x96rLO8spTzCoMwgBquvV6falloBKr8YNte584swh0pIgzUYsq7oDBQYv7MODzhEJxmhFZlCFjzYGErIAhoUgMgojRzEJuMTPg0VpXOeJO/UX68KJPvZGXl6feHu0Z3MMrbA2pr0VKRIjI/ZNlVRUAjyzsp2u55r3LbYhgH/5v0TZy995DtW2VcsZe1zXP/5bIngP0Reefr/75lS3wlRI+l3/qGdW1LnuRrvC2Z/i+Zz255/jBjfcgCINV/HYv+7NWjy14gjZoR6QtmID2ABoADZGWSKLQZRWgpxP5fN0fT4TJUD/dDoUPGGwH5Dl2hRQfHb56Lr626pO8WNXr3LMeVSlaXaiDw4kdc+20Z4FQAQTVKQgrUMDWEzUivcZVf9Yd2kHRPXn269T5rZG1o5ES1EZEQrCkBoWKf6SG1JBa0CD0QS03MYdrhN+h7u/DqcdomTFXVSg00wqy9cLo9913v2GdFPqWd4D/IwBUMuABoFtf5DwhDQ1gAJGBSBE7naXFlSedOsWKokk1/cmffPs1u3cnOfSYL9G9WFmpe+8BoFKZ3L17d6uz6LgDIKocGVMIjlMQEm3BVq+qEIbq1Z8+BUVzKxhFAO5LIgCDeBGviCpec1EkBYQwHNTFWdaNFLICIVVrEEUq8gfzbYrCuIuuHJLppxSIyFg0iOC9zTlMfJBDSSxCcO/pruZSpDY2OwCBoiBx6WxJQFPQtkhLtK6yCtJRSJ0yEgZx2ujmrd6WDoC0oIsGNFQQXKqyipc8IwJE5EZHGsm210yXdoxAqqy6uLCmF6dHiml52ytuGBkzoCVABwRZ3vUui+Ih5zIAwyyNtZNPn/hSo/Okq8AwlwEuAZVtbYW3LI0xaI5qwaAEaxaejvSc0Y6DpkjCnLEUfNQWMFAMJQh99Gk499F8vuEiA+777bYfoOuK6t3mtb/eICvYt/7FbfEqOfsiPy4oigIo7HMb+Ne/amKYcu2zBl28VBEV5UJXX7ur9COHJjveqZiXsPnrJRnPce/7HPfHz9wnvNX0e4nwRv/LBgmUwTye5n/U7AhBhpBR0aJJHtUhZig5aQ6aqnZB2gopqEHtsX5i1T+dAJOxUAS5AkCg63mw5+GBTaUy/Y6DrD2Ui2Ze4QOA7YWzK6NjU6PbpxJ2yAKCrOBEQRkUA2+MQjPUm3jm55IDt9jyOWl8I2n8Fiz9Blz4jGbnEwU2ERoLhGKBDbBBNQrlZSh9w5o/LfX+a7Tyl0H9FAV3ozmhjApSwC0GLIkMytrf+IuiKDqlwT/wCl7ACwBTxA4A8s7K+fP3djrnILeQ28CWup2VZvOcx1ACMpA1crrhxms+8O7XOg+IeTfpXDJLWs1eAfUgtLt3bK+UotXVZSIKTAiihCwiQVhCu7VcSYG5lAvnNEkQSYuG50Hgr04hVc0VGHKnfpCeCKP+81S5qJdbxQNAMDYJAP/p2NKfLntbq2nq+hQDBZ0wARhWi4zk1AIYFPNb361/8mgjtoMAbIv2mIvQ3Kyw5jlF6Yi2RDoiGUvOLKKcK4JZO7moqYLZYoINuFdx0MEgkuZqSEMrItLtpU+fqVw9O/3a66qjVe89YrC23GDeYnnu3jl29bW7kk7AnlRVRFzeTZNGGNTarflzp792/tw91musVedwp6mJsAzwiP0B3P+nDLDBSl/EBev3QUARDYLNgTxRyFRl0xL3pOmd1vSU4QXSBqFjC94CB0btV/Jzj8jZTiRROfuhaP9r7KEsWsuNFyjoRPr7r0JtYN1CS7+4W1wLsxZyFQX8lIgRt9FNL5962/5xAGARXVex0L7bamfxXbvdL9+8P2HmghhR7bPt9jYkY/X52ITvxdh4MltNmxc/LMAVE/TPF/X/zBKSL/jIl4+el082u07JIrk+11PRaKIeQABRoQdqkWyhHKrAhCmABf1aPSmB3RMTgCCQDB7289IVQDSe87HXHFj5i8fTx1MbhTCIpkHAIgmSd7p8YW3b9p2LLJ0LK0YBICjElwgUgCyjU1kyrTmNfyLfc0+0cg+1FsXfZ+lBrdeqq9shmJR4VMgaVdUMxCnNB9JW30VOvA5nJggqFHrhrurwJSUMGtTB4PJ+QxTtS9oIgCjYq0w1N/UYw1arlfG5sLyEFiMaarXne702ogIh4Viv3fjwB149VI7aPkMHZM1mvitVcI6JgBDFt6zGh/Yd/tb9X+pWxivlUdYUQPM8qZRHwqCcOrf1vTUkC0u6vIK7dypnqCJekPo8eJoV9ho0Z+/7zy4IguKicMAGXxDHiBKomtqQqQ1pQ3/lvjN6++4f3jPe7i7F1iggoQizoaA46wAMMP32keXfeLgF5XK5Fgp5VHuZKAoSkd3EHZs6WfMiBnoCXhmUbIERQnSADLB0/ExROZbL1m3fbRsCsqAF+lERCK1VztLT523EMz/xek/T5WGnYacaxqtrnW4nGRouX3IoY/T22/d+6Qv3WRuLCCKgNa3mguev9Ho9zaVEE9Zzw8idUfXGvNYOFaTAsakQyqCxfTD6MurrcBwBcJYAIPKkigToQRnUAI7mOoahIiy6oGd50aQeeRrK01Q6Q8174eytWP2F4FV/yfdfZ3ftwvHEtBxWEBNFsy4YCQMrJKIC/X5eGxnvIXcs/QQ/ABgAEBSXU/Vllbhcfv+h+JvzR46uAkoAJIVcQ55yj7M37LW/fPPNQbScS4waARZYrK0Xe7FkBElRjFhGItBMQQADBPM9KB0/dxjP92hcJIn1rEZZVeElagR7MT7gkW52LtfQYg9Uob8+148moCrSRgpRy6CCgKChIiJmgN1Mv9r0M5G1WIBzX9g5CHrAWmX6B/affOJBHeSRCgSCeCVrfO4by61SKZrasR1y315pWdECasrFxlPUAHiMm9CrinlXZ88rg+ypYP44tU9LmKk/J/lR6XoFVTWAAQIiMmCJbAV0GHW0mu/U8ICvbpN4GJRJilRI0Wxu+zU0AQAzWNdcXK8SgsBgI+w5uStw+/LsnKOqHeVer5s3BEhpkTkTBEBjKDyzfO4DP3TL+959WytnsjZPxASb9bgAEXrd1BgDiD7TrNeZnpjbs2PfiTNHt227thoPKS7lWbdUqoZRJUvaIny50DRgoEmXT52h3buBQUSQseBAVREAoIzEqKaa5mILYmDa9PHBDzroxlIWMzKW97IyhL90/+mFdv0f7d9LppH63FKAlKcCBiFAbPXgn90z/5fn2xDH1ZERW45RSAfd+Jslc621Ybgh65h67XpVxBwFlCyAqhpEMdZa6rZ75x85BqFdRxABwLoNQgRgNqE1xgALogWL4hk0d4vLsroy+w/fUbt5d1rnIU95mpdL1Xar22p1L3cAInDXHTeOT3whTTySMyZXMcQ27/QsBmiFoLdm9Rbrfjq5nYJLICebdm8bQEQqmHQcESkETEGxhy6cQz9pvd7ZpEZoW8hKJtGSqrSNfDuaz0Fem+3ZE4WK3XfryxkkCRIAE7B4iTdvIPpMngBIhKq1oTgqhyvLHedFRPrZsmJ9F6aadOr2qYTC4VL+j18x+xOfP5+nGGo1B5eY+vhI9+9eXf6BnXuCoO54KKTMI8sgjX2lZY9KAFYBVZQwM6SrLv7mqe4PHrhCA8GLGAPkwhXjwu/J1108nqUT+G/nOJFJj6FqsAsaXeF8vQEvmgnEiKH2u8ItACo90tHrKvqyapH+6kMpnm9FSK1Irzfx2kMrnzyRPjkIIxCRUEWdc1aI0M6fWQppZmrnDoFz3ZW2VQQwAszsDZFVBHICQUbsgtWY4ZZ04haYzEgaNmtD1kWfqs8RPBRVIo4EY2sqimUxMxJXHJRYMiveeBw8vcL0B4qK6wzqA9gv9gVVFUGwz1+MgZmE8i9V7a/kT7U6VClNWMhtZHPNcrJZ3hLC5lrjHe+c/M1f+2mUwJMLIWj2uqNDkZGNfZFzurJSDwIrokmnJ66Vd+iqPTcuN841WhdiWw5t3OXVNOkEUYzWQL4F+x4QIhh//MngttuxID9VRY9qBBlVtQjaONc808IkUJ/cEYq65SW0XMLOlkp+bCxt1Ms68p+ebBxvnvi3111dKs2nXlRNJSAif99C71e/ufpQW8xQPDZeo2BYwz7t0mURgBpjrN1YO6njjhcIiv4DYAQgUFHyrOX4wv2PzT91IipNimzJNQJoiIwBQvGqBMBOIc/Or7hT8xM/cNf4u1+lnbw8pCsPHMsXenE1YtDCIF6Sx0DU8YnKgQPbjj55or1mDcYmACWnpAZYrUuC5A41P9+4pUJhE8X0gccGYN3qEyAQYFDQmiIgBCTGs3pUB9K14FBDhnCgnjEwxYAARKAkXlxMuFqi5cDv8UM70woJt0MIveFSz5NYF5JSZhIAgxJuvrF97geVMAwrw3Gvm7FXZr2Y1KcP46ldG83dOJOJz3x2w9js//dW94ePn1ZYnK3a6ycqr9917bbyWAoOwSi5VCxBBhgD+CvZOCm2ROojljwwVQks2kVP8wsML7UDeDGl0CvVaJ/voVT1WRrB/na6hDXPMRGDlq5gtgvwFyIIQg7gAVkBSY1ASbXN/K0W3lRD1hfoaVUVraUkDYZHd/7Y9U/9ykMAIAAGsODHN8YUiGUSPHv2wvTOmcldexXOdVfqgfaFVxRASEkMKhpBJPIoWcgAYkVGFKegbEEDRAJkLCpaIIqUizei6I14H7omifWkCCcgN4goRAhBsXYFrdgQAKCPZ6SiWxhVEQRFCAC0K24RGsNk/oO95tcqT5wzWrXbTCHGJKhpPUma7/yJqf/rF35tJBzqEgRomKHZk6naRXNjZbm+ttqO4zjPudu7kPdexsxA9sZrXv+te/96xTw2MXJ1feWsy7rl8oihyJNDLahjNjC4yB7KJTm/wBfO4fad4NM+zN9pnxvYgwpzLp4VQQrIfP8M1gEqANBHdwkCMnNYrSbss8baEIx8+qw70rzvXx4+8JpZm2lwupv/zuMLHz++6imOh8vBSBniEaVAQUguw6dQn82mSOgX5DcZQy6CYgCNAjABIwRAhoUQn/jUl10qQcCbfZMqIyIq9T2WIURkVmWPVt1aPTl5eurdd8789Fs1FZAAW3z+898Ek4s1URRFoSnydwSE4IsrNkjtziqFZ377D97zuSPfOfqdo09/s9mYH6pVpzBOR0k+RFfdXt/bK3PiU2IUACFCls0ESqCUqbQBMlABTaC7gnkLtGd5TX0H8zmpXiPVnRQV7kdwYP21DzHoRGYlkgDpQFYp5ZiDY4MhkxGyLkYDCN6KBBKllmhTo9ZmU2PCYP5Ci1lZ+KJWwn54hwhQeuVQdVut3UxMQF3I3nVw500jE6qJNTA3VPWIDc2tgAKJCKEiWIWLfPDm8igiEtqyD3rGtkzSY/tw7kpJ1z9y9JZTa/XhqcrOmXB0+DJbQIobKOH/XeMFRwzPqQ9g87PBTSWaQQPORT9fHtS/JC5k8zrsChEpasEUTJvf0I/WoWB2RzXgRBHAERpVsJgQE+FZl53Jo21WUaXg+MXni8FiAcJerxe+bGf19fMLnzg3PDaizvc7ihmBkIsEjNC5U0s7ds5u37u7NRytnj/PXTVURgRSUeB+e5koAJIwIgoqAiXAiAjIA8IZGKRlFQSgTyscoxdGTwr7tJarbwKvGc7Qt4FT4BQlAZ+p88goCsqoVADYLdgRhZrClNjZoDwuOJQHv23v+rd6/F5pGmmJk3Ot+sxh+CcffNOH3/Ujam0T2KBRxSyXpYaf25WUPFlFi/iNRvKJZR+++Y3l+067vLW8srC8Mj9W2028WtLy7Ydf/+DRLzXg6drQ3MraiSAcKpeGne+gEGIhhyBS7OLRsAAo50eOhvsOKucoCgIqXMhVoAqASVN/YrUje4dEYN1+qSoU7cfKMGglQkRSBcTq0FCqvtteLNUq55P85777xCt2DaUCjx9vLvRsOFSFwAbVahBXlYgQn3lJFfVBFF1jfarVShkCQSUVVadKRA7EBTZ/4NjZrzwQxnFRWUUomMMRAQIiQHDOgSE7VZXIUkppyHBhOZs/vfc9Nw9/6C2ZDodpa2R2pP6H31h5+PHaRHV1pfN9r79mdnraiQe0WZZWStZzXwPesQ/sjpuvvev2/a93b80ePPbdP/nsf/vLP/sGrOwYrkarbDqhQwYPEiAqUE7aKEMD8za5ZXAd4ba6DCAHccSKAmoRxKKrajgJpetlcrvWRk3o1W/OpCuAEApA24IRmumhUSDweREfsEHxisjqSYp3CiOBbG24GLTV7mhBBQF00e4fCFEQjZSWd7/z1jz3xGpCqq+1j68s7Nk3471VyOvaJC0FYBW4wA4hCKhF3DjtfuiCgEoeUVUjwIfEP5kmF5yvs4QAt3/9gUNPnVQLfPeFRgD22qvsTddVhiIaAAm1T1hN32z3UtZbK/GoMajg8eLo9nLz8kJN9rNCLp8XEOi5cgFttuMvJYv2M37RlQYCRGhyUN3E9NBHU2z6tWgcoX5YpwUTrSqEhutOljK/zRpWJXy2tb7lEAWyRZvVzh89tHbP6ayeWiOERhQVRVFJFAhRwIDOnz2XtWtj0zsnS2Nr8yfyRlt8JEyAOdrAqwIrggENgRQA2fTp5BCQAUgLbklSlILIuVCD0cKWqBVAQIg0nAHexmqw35wpoE7BD9iKjAABIWIndjFnIQsRGjLOq5dsjXo1CT1zyyyOtsyCPfmOj7zsFz/wE1Pb59rWEtpggLRZbeeZ8xN2Ik/dkU767UbvvkZqDI7tm5195U3tj30RQnvi7NOjB/dxLyTjxuzknVe/+runvp6rIAVpb2mkNBfiSIYtkEyAitQPAAAhiYq1fOyoLtwBwyVV15d9H5AJgzAothLXdVwKwRhTlCuFWZUNhex8/1BEIoKoIKho4uExAuFeOzKlTGqfPQakEgTD0Zh4m4aluSCuGhupqqgHuGKFqOiEUoWeQsPpQuKzLKNKzJ4VwVZiTnMxSGH48Me/4FNnw0iAi7KwAgChpdD1UhOJgtOwZKIR5RJzq/T4WocW5376NaV3vLOXQZSnleFR98CJx/7nn0NAPo/ULr/v/beBgFcxBAzoWYrLBEDvwFZLANTgNAjNy6+/49Yb73j/mz/7q7/+0Xu+0n588tvL/roP6lWJChhURBUYEluiYJzjaVCnkgJ76DMUOtRYsYTBkIYVCGMlq4bRieSwaemtkxcoQtgvqyFtSp2hshbzccDbIX0kz5YWAPoSdlv8kRCMWuEsm33b/vE9I2kzp8C4zP/M3/3T2gj/9u9/xPk0sDFqAOQAElQCJOqvJLmk/KtYcMiRqp518kCaPu01UwWAAGGi2dy+WE8CUatkkGzgHjkqi/X4/d+HuAENUIQ687KX85l/MnFvGa7sjwf5opeuset7NOyWBvdZ9/LU77He+rMvcsv/rEcogzpmMP3uxP4JP/fvRExUlnIPFaP4Ejyh8u6d+37y1hP//yMKgQLqFpIYRgVXlpvNxqOzM3u37bi5MXKmMX+KO8hpQF7RamBAIUclUANgoGhXgXXiC+o342DRgFoQlyjBRYGX78fKxVwfVET7OEo2qGpIEBkhVDZQEBmzM3kmaUmDMSn9jp75uqn7ZhJc7379g7/wmrteuVYZWWY/Yi2xiIozGgSmveZ94u5bad+91D3Zc4lIaMkptQBm33zrufse7CyvtOpHTxyt7d97W+KXDEAJZm7a8dqn26fzdLXTzELI0BpyIVOOBXLnkrvWaLijj9pX3Np3DQwgHmm9doqrPU5yjipqLCEpgIr4AT1G4T5t/84IQJ9N1URDE4kmWdIVk9jQWg0li4hMuTaOQUxUFIx4yy3BQDu1uLfiGVa8X3HoFBxqRFBw3vskAwAsRfP3Hjn2xXtMFF2CH0FEAU9lcmIFJKqORJVqvnqmfa45tocO/Njbwle8Pm2r9YmdivPjp47+m9/StVUcqtZX6n/3p+98xStewSqYWzWQik9SnCgFAOA9CFKS+ZwQCHOUVDJVuOXGN/zZb97yS//m1z79xyc+Ony0ZOx7cV8XvVMBNOApIhsjDiMSoMGCSAcUSQCUUAYsO4zs1asqKgHIJUFzwV5kZAujV6SJiona70hedwY4gM/1GdEB+kJF6/W5TV9BLJBpnplauvuDN7vMi4gx1K2n8wtH3/+hHzImMuSICEDFR6pKKEhblZoACgh4QRz9jV5yby9jQCVjAIs6mclSyruIBpXRe3WKaGRleeX82uz22b4qK4gADJugbHIBIYCP1zt3VkuvqEYv3rBcPl7a7T+sw0BfgMl+Fqbo9eT8C/KBz3xKIxY0Fdwc+A9+uCQCgE1WsPjJA1oQAiwwhLqJWegFj7TbnXzT7t6pU+d+v1WuhAig/UCgwJAUZJWGYNilfPrUsdpQaWZqV23/y9vNM+2VlbSZaR7mFBpjkRiRAd2g/74Q0kAZ+AAa3BnpMyj072+RmSv+dMnGSgutiyJX2X/qCIreqigGHKKDyNVS1D/hxd+BtcVW8u4ffNnf/fGP1IZGj2NljLhkrQcFgtArMlCun338zOMrC6PD2ztYDiyUMPAiCNTqtIfnxna869X3/8afbotGT64+CkO4c/za3CXO+AAmDsfDo9tHjkb3rq2eLpmKp5w1CtBr/0IHJ+0FAPjhh8yBvTg8DOtGY3D5hrCRsBNhRTSGCsAiO/Gewqj/fmElA4PmgCJLKWRK47t7zVVtN43LBFOJ1FbGw2hEkFQZ9Er2og/Kln4/G+YAddaOF0XxRN5aVBYRFQVrXC9//Pc/5XNXqlTzXgq0IW4rmqsoQuBdLx4uDY3PpSfqSXZm5s03Tn3g7Tw70240I1uKRkf03keO/fvfolPn7NT21Qbf9KbRX/rpDzNrohRAjqgtB6xcDkxMEASWFNdWO73M99sPEQThTDcLzOh//Jf/opH9q6985sk/qZ7bJaO3Z1PNiHM0IVsvTkktgCf0hA6LbhKvCAIUKiIgAYEoKfkBHc+WCxsVaLBvgct0sgqjcPGfdPC5i5rbBFT6Ui1CYtc/bsD2Wuk1v3j10NWznaVWWImYuToS/fFf/fzw8HCWZWEYF63CCnmWZ+X4yuxvfdl6+9FG42TuEIm1AP9owW9KYhlyAgrUFBx/CgpMwcIybJ+9aGIM8s8CKEDf7GRPOveuofKIsZuu+6KJ9Axz7AX86QUPu/nQz5q+v+SVLVQ1C7v/kiT9r+wDZgNbSlwOUujYbWDwn9twjBZ0NHjJojNETVKa/bt39HpfTP4ox6EqSIIQALIokKKqOgaSzBoUidqNLOkcGx8ZrY3Phdsns8lm0ljKmm3JkTRGpEIaoOjnpSKkkL72mGDfohtA6dM0FSCYjZugsAmaA5s9Mfbja0SSrMfhVFD5ui78def0BUxXyT/pfFniD3/klR/4h/9oQcIAk/FquxJERcGwzX6qEi6sJP/9q9/54un29FS1aqvgnVej6hGNoiBis5dUX/mynQ8/sXb3capET559yOblbRMHmOsJzBOGM7StNvqGs7UHT6+d4JYxaL01RjcoF4qsvZKRpWU5ftzefBt4ZxSkyH2RAQBESRyzgIjY9a0AC3tPA8K1wgcMbsvGLkE8l6OqkCa9JgZhVKpZG7P6DVKireZeYU+LLmsB9aBrnpdztmhyRDEFplgFlIWjkaGn//iziw88USqXXJbjQAulT1IPgIjeSVSFgCZ7Z04F+7I9b//Bse+7awV0uElgRziC+qe/uvyfP4rdjMf3dC8kL3/lxP/1qz+H1ZgFAAHJAkvbZQCwmvFwYEYDEIdp13cTZ7EAy5OqgqrDpA74y//0Hz754K+sXCj/WfXs/nA6ZpsG4EyCGxZWVdRAn06kj2YyaAab8UKdV6Uo3WyxPHFdBuNSKcfBNNzKMejg0QzeU3D6cjHhC8ZXVQXGrN6e/WHd88PXtdfaFFjnMkJU0PHRCYAiCBTs757wStafFKSg6Vb6RH31tEcCU1w4Q78RDgBaYQRqwWdqQiAEVUEAJCZA2ign0wB80BMto1EEUTjr9DdX26+ulF9Vib7HWfMrDtp0b+EKZ/Bi9QA2rgw3WHNfKijRlT64s0ymKaRghdgAX/apzT9cEgEAgHMsOeyIbXHmL14OSJXJqHPhvn/w+oXJey/83nycz/loBZECjw41ZGtI2Dr2aDQiitQlS0tLa/WV2vhwZWJ8KB51w+2suZg067kD0siYoM8V3NeSGNQAVIo0MkN/oQ6ILIo6HAJc7pb7WaN1eDeidBhnbPyX2fK/dMeXicoyYnJE73ZcO/l3/tGHnQmutRBriUzJc09FEaKSDT/+yYf/6p4jF3aUh4enEkAvoIUKOhDrRRR2hz/4jm/M/x4/US+HwZPn78nzdM/4YWLH1PTYq5WjA+620fGdp+MnFteWyMVqdJDIBhjs1o0x7t576cBhKsUKVhFUGNAgqiFJnGQMAggF6zQAijqXWa2uJxbWJwMBaxHLF4hCa0w4XCkPiaoHL8oARAPr/wxzrx8EEOYoq7l0mYeAuihgrQCqqBJpaBun5o/90edttQRS7MQ3bZsUAMgGRCTaHOOpM1M/eGjqLR/Umbl27iqZtCscJtL49T9of/puGhnm0mR9qf2KH4j/yz//mdmx6QwARGKDasxSnbteDNFK6hm0VIo8oPOaeXAb34iIlog6WT49N/e+D775N/71px6T+NN84v16MKS8R6Ua97k0N9bCZlpBLbQcBwccEP9dmnQdTD3cZOK3LKJs8aeLW3nWaXGQBNAgkYr3uUAeDr/fX/PLb+mmxZR2BHilpMcz2Jwiw0RAX2t1Tibi7AaQRDeBXFaicHF0fNv8fCPiIW+BoCj8h+UY+8xzfetBAKRU6N2AkvZBKPDVbtoTeXPtGaKQ5zqebzPw5dvbLcWkXmwfgKoS6npD+QvWBniG419+nLk42BnSCYVAIDGXvv/yu7PZxBuFLJPrSsFsYLXgzQflK2SBdMC0bGy/U19E2Bco7Ev1kG2gLNHcB15d3vfQ6d85gg/NULXXjbJyUkIQK8ZI4EHEeANKiFbLCNJZrLcuLIW1Urk2YsLp6siYS5tpuqYQrJ/8oHSFhRHXTVyasJHCEgAQYESUTQwfhUQAbcqwqyoIbg/nPiZH/3F+rGLmpuJYs9QbX6uWV9fMP//F35m95kZYOvnkqaXrrrnun/zSW6M4rq/Af/vtT3/hU/dOv/nq0tB0nlMZiIFwi4QJAoBM77jxI++/79f+h13CcAienv+2+mS6dqgS1ThstjSPYGgm2D1cnV4MTp9uPd7upMWtXvcBBZefrDT9dx8IX/cGcB1URopAPJBB5G4uvcxfNOuAxefs8oKPmqC/letD1NQXxqmAVVFBpybekAFjlSOFdPM0uHQfgwMWAgAMbcZ+FYRVmdUTKAvnjtkLEoXBib/4Yvv0vJ0chvzSiVUslmzN4NDaxOsm5977M9HBw708yLu5QorxmH/saP0/f7T9+IlorNrtaqZnPvzz1/7qj/9sXBrtqHEhBOitd+3cnMiaOVujnDGIiAn9WponoNlABW9degqYwZildvLGt33/x/7r186sZp8tLdwS7by6iybwig7AAGzNz3FpOn4r3bzNl4ZXNv3r7wG69M5uwhMaVEBAgwISCJJ4cVkk3J15z8q+X3gDBFXG3AC9GIUVg3g29/d02oTRRuypAKhU6GgCdILo8X17dq5kk900tXnE1OY83T02u3cHDSoW/e0/AioQQCLQpzXUok7y0mz8ny8REF32St+UrWfhrqQH8MI277RF3fMlG5ecg4COhubOWul0IxlEjgCwRRF4SwU4UhKvh0tR1VJ3kB2+UhmADIgTAABHf/zRz62ttn7qZ99NZIu94uab2/cBlkhx+qZbhv/dnqf+6Bsrf5GO8IiQS40PWAKPgYgoesSgSAh4EimH1nIvr7eXbYxxbFEBtAQIqKQoioTgpTDluDm3U9TWirKwoK7XXfqBTUEHBKJoSEUVQBCs9j3Bb+VHfi9tBXbCU4cpLs2NlUvlnHNM6MQD5rFvPJDV76530vbTKf6Tt6+sye/+ztfvufuJ4e1T+c6JPPNqwkzA585YACkItjceE4N2s3p0zc7bf+ld9/8ff5md1qGp0RO9R5f05L7aTWOyMwCfUSM3gcFghz04TjNnp44uLy/3ej3nXJ/aoT9DrX/gAZqatrv39XdaCiqAhInjxImqglEEFfEg4HOn7K0JGbyobqAVNj0vo6YoYIoiMIJmCB5xazb2S9qAAYRUjEEH3BEmAC/KCEGtauIYxAGZ5vFz5+/+jh2qYcE2otJvtto0Rt5itr/5Z2s3XJ9jpd0jT7mxQL7W/IO/6Pw/f5OLq43NLcwv73y5/uqv/NjbX/GGtkQeCBRCdgGSYrS01s5dxMgiCgBtkbL4hXrLIzsRYxCUZGBYSUlIEWB0svbat13/P3/va0uR+eTofGP4UMml012Ii/1DH4m7PruKp8lWQ91ky7Zc7Ot2f8u/bmCA+lP0onZo2OQRFATIgOmKVhjbSlG2VNGh+W3vDff99Gs0GmljWstADCIRgC8k1RSuWLnZcgRAj/RaXskCFuarODkuqjxKqipG7zuw3XNy1dnF4dZShr40ObX/dbcGcbC+TZH+ZWhHBm5EoXAPqABIt5df7Pb/BXR4PfcDPu8U0GUuQQpFjst9wEvYRKaqheZtEZyvibthonTEZd9tJsNcW4tBkKFo416fpYOp1X8q/fyEtvLm7JB504ztcA4AiiqDyBdxY5svAkisQqpci6uf+eQDH/vv95ogeu0rl298xe40T7SvB7V+hkVDk6hSD9Noauy6n3nH0r4jZz7/YHqvm+1u61XRhC6zmeTOehQiEqNIZDVHB6iGIhXpJYIKBiwKyKZiLhYLsr84adDr1i8MQJGcXT+ZooMLTeiVEbTfMoSsEihFjL8bzf8Hv4A4aa1OTe6Mo3IYltFI1Es9RhI0UnyKK37vnrde85qrn8jan/t68/FlMaz5aIRRBB7VgiPxXowJjIpXBQQjJmBNSLpGhyJbCYL4uptu/tXgif/zr/13k2B4eLVbT7pf2zfyspnw2jgaz6HhMM8hi0rB1fKy/SP5+aGnz6fHO73cJQJqkMASgmu6z3/cVWrB9K5g39Uwt4uj2NhaN0tWaZjFdDodNFTUN5hd2u2RmDAog3ovXDxZUVYFBS/CyIPgoHjwuXCf/oyKFl8iwiLzoArSJ+dHBRFJkiwOx40JT+NEFFol9TVM7z55/NgRtdA7d6Z3YaF59GnXyQiMOgJSBMHMaEp5XI/34NT1h3be8TZz7eFWUG2ni+i7eRz7agj3L7T++/9Injo5HMbe+4XVI+/6e7f90j/4yL65/S0PBKCiRGKZurE5udxeZc+oWuRqBD07UXP/A0dVfalMSaoArCIKpIoKyEAknEl+66tv/ouPftFI6RvdlS8F98eRH8HggB26nkZvWauO59SJk8RCyLYfGWNBLESbtKqoaEvcDPHoW78BZ1wBzF1fjQU2FACx2GZvTGyCPrCtz4UHAICSY1WQ4+6YT5h2nzn043O7335z04wacRGDKRvvDAAEoclSZ60pOCsu38f1ewAuGy2L59hkRQ5VYN29SXEJ2k8HgecHDuz97v49w43euyerh2rBcBTkhS7NenYZAQFmanASnDj0XnIBBYoMXRMFk4HJC0zaBpXI8yjzvlSG/krjeTeCbfnK4CEXNIEXv1N1c7/Ys45n5g5CACSyoKzyjslaPZejOVcVWxbQDxSei++S9e15MQWKfZABgA9ODG3+ukHk6RWIuS8ujqTqkRWMNTnnO/cM7dhXHZscnt1TTVzqRFU9AV7cwYiq6oSJTC6sxBPvub72qu0r9zw+/5VH+NuBXaqVzIghFcN5gGI9YIakRgURPQiBFuftEVSVWA2LAKIaK4DE/fWGfQkW7OMiBreofxJ2cMPYB0oAkEM/Vw/gVP6TnvrvzbZKbWS6snP/bb6X18YWwJS6beGcIF9bXb3HObd99vur2/aGtbGvf6nVWU3zc2fVJzi1DYMISIy1QJI7jqLIgkHATLghLgNhQk8YMk5YSj3M7r9z6F+Nfud3P5p8dW3IjqSaPrF0b2vo6e3RK6p2jyk3cuzmmCYRVsNgb3Zot712oXxsPj++ljSTnlfvKRHtAACAAElEQVSxyuWoa6DZ5XP3J0fu1VpZx0aiXfsgGDvyYDrHe9vdLlgDooIIKC5vdLmbBCEgCnCB2ymS9yCiqgSFdjwV/0ewfcZsVCIyBo2lwMZhUA0oRGMZnGOX5e0szxU7mUu6Xbz/mw96RysL8wtnT9z3he/ki3UFK2RFBAhMKQZC53JxQoDBRG/o8Mj4da+dPviqeNtVPc2W0ySs5xJHLozhbMKf+ET3K59jtbGUFput6f29f//PfuI9r32rSjVFCIwAq1gEAEVzcrm9mnqHBFiU9VVRw7i6eCH5+pcf2rVtDyGAMCsgGkDq9RKrFAyVVbXTzfZes++qgztOPaQpBG58rDIX92TlSxdWv+pXD47JG9Ptr+zsGcmzXthxREJQZmE0CG4dxVRsfoqq1CWLV/s+CRUuClYBBPsymrROQiyF9yq2bYZBCSFAtShY7lnp2tbMyaH3Nl/+/lfHO/Yv5o2I2kwYhqXHTiz9xke/tmv78E++947haoV9irh1V8GVhhdt5qyKggWJ4AbhHahAwUeNwCqeBQBGavaOyUpImIh4hsLNrYN/FOSQDXaUy54oM+ANfG0p63L+ytpIT73d0HCF7101+BkQos+ABMWFc+cvP9aWVngLXMQmf7vBxYYXv1MJrmzWtzrmlYKGjeMoQiZasbTk+E+aK8e6JaOlethVF/Yvb33bD4AggYCqpoJeoveM+feOVy4/ehCYqASqmificgOsACpGAQ2IxgE2l1tIOjI+kkuR7lBzsWNbLzmyKuccR1GepHEYQYCpd+njT67ec7J+dNWdUZy3UWaMC1GiPjGDaqFmRyRACAbAiFKGqFFfRcBD34GxkDeA0C8vKvapb9dltdigAPuwHMa7htlTdqyluWBIXau/lj35B636yMzsDbcd3L778Pmn1phWp6evbqystuvp2tMn2mfuR5K53Yd27L21U4ZdN+4K4/Hm8snHPn4vBHnw7ltwdlpFTGgAdXRidKRWJaVMOVHfVZ8VAl0GLMpIHEyUYgMm9qFxa/d/7M/Pfey70pwyVk3YFWiMleemgpfVzDYbCIYtJmcwDMAEEkFuGzI/nx9r5vUV3+xlKbogVhuAFZGcvSojsS1DqRr0ej3fqUSBJQ36/EaXTTQpWn4GBV5a37r2mf37yR+EgMgSWQrIGFQUJ04KNjL2zA4NgQZZ3gtLoctI8gyQ41JVyKEB0EAZOM0ZO1j1dgiq+7aPX3PV1MFX2MmDzpYz6va0Y9WTCTQe4W6afO1brY991syvUbmS1Bv50OLr3/Gyf/ELv7Bn51UeQBQ9qAMl1lCBjX18rV133g36V1CVkEVRXfmPf+9jn//LL775La/7J7/y3kYn8aCIhoh63aw+v7Z9/5w4D8pjQ7X/8u9+97O//ZhOxG52t24bvfP1s9rtfeuv701Wy0OR7ub6e/KZ29NtKbI3YJVyslY9ACCYfvdsXyXw4jwroaLIZeWxzU1hilLQUalRQAQyxBYYxSN4FBFfVGF3rkzfbna/4WD5qn1QLquqgk8ME+fO2Z//N19ZWmtlTn/sndf/6LsOpXkSXCGZcaXUdFvNfzrTXAEM0CiC9pXt+yZLVRk8q3rq67XdWcYPTVWJsdhLbKz6waeouKCiaKh0RrNc9Kq41PJZ2L8167D1Z8IZP+srz/o2vUy8a/PPl/ifre/ac+zw2rLqS3rF+s+LGX2mVlADKAARoRcdNfThie1/KkuPpKuBG8kHmxJdryMqAFhkarMEtvUj0923D81efnBUWDqVr55pl2rx9N7q8JQB0CxxWc5ePRFlrOXxEgonWY+IvAoV8pLrchyIgP1UGOcMKGjAVko5KAgGFETXXz9y/fWYZnmjma6ttS808nbP17tZJ+OeSsLaFe3k1BJp567j4lYtllJAZQ56HHkjIQgqpKiCgAJiAItWFC3yX6CDiAS9MIlEY4amwNoKn8+dOGX9x/DQ55brO6677gc+/ANjMzd+7f/5gvO9XQeuOd8CZ6L6ue+0zjxSKtW2775mbsdhJ1waL2E0kmZ88tEzWXslPDQDk0OQCxlCJURFQQ+YiG9ilqOEamqe2GAKnBBQL6/ZUhxQG91IOPGGv/MTD419ovXQ35x4qJ0szFSC2aV8ZdX+zWhl2wTuGZLtsa1q2M0x9TY11gzz6Ehwe152GXbqcKGeLSz1Vtq9rnfO2pKB2IgzWdzJWcSGiN5riKpBUQ8B1AI9SOs4jfU+IyQl0fWoH9EKgAKrKkCuBbgpExVkFlVVQiTLoIoGRFUdhcbG1gSWhUAdOMCe9Zz6KJdKXtkzNrn3wPiua0Z27S9Nzkg57Nq0l/aYcxWJJM5MOKRRdvdDi5/6i+5TJ4I46IFqoz7+6uxXfuLnfvDVb4RoNGFCYRMKq00AaugB7dPL7QXJaV1LGQXVkSLxyH/9vY/e/61HqrXh4Ykhj9YpiAKiiGoQBY8fPTm9bYysEZGeTw9dt/9L9kGyQbN9JrmQf/kv6//4Vz6y5+r9d//Fp08/tnq0VPu/8fz92vwAXj3TqixVmyU2vAH0eKZ1igqEoABKXtGQoiAIsfZJqNCKtRKgxCYLUE2vmwtwTgnUHEzm4YyMXR1U94YzN95enZ7TOPLeo3AhZ1d1SJXRv/nusafPtHZNzV5Y6aga9khQEdiaXVw3+N4vtWa5iAc0hor9PhR5VRHuk7YSgAr0W0yviWxVqSPqWU0h3I2qtGknAcAIgorKSDKLoao2OIv6tQ/Zuij5v3u8WBjolgNFL40DXvRYr6fLQP8IAAxAzecfnhw96tPPNZdPdEY7opkIK5AUax4AOMXewZr/4PjYjfFkV3tb9GUgIKSNleUjX1tureRDYyO7Ds/svXFycleVIhav3uegKkhoSMmYvt3fQA2KDFKgqBRQGFoRD4QGjFJBc8sKAHEQzk7G26ZHr+8rH6kiM4sIMWrmpJPlnV7e6SVPnaifXFw9csIejcoLI8GQQtzzWYBhCkV72LrKdlFuAiyAocDAYIwDoNGwNKkXDEE3s/6X+PG7lxs33H77+37xB8vx7s/+wd90Vs4cuP3l85lSBvUj31l+9IHx0e2Hrjk4vW0PBpWFZieqzuYucGsrybGTQZrz4e3Z1EjZBxYJLHjgVgQtnwgYQasomYHcEKCggCg2DVbSbNYEln3HdGxcMZWrfvZtV03/VPDvfv+/fefL87i2LSjbFW3W3QOxeWy2vH1Gd8VmWI1ndAnmNgwCiSpanpQdvmSTatKCxdX8XKO31MkbSe7TpMU5GiGlkCgUBZMXbQ4WUBRFkJFQtM+aUTxuUnWUFyh5AIBCcROIiiIwqwIIGY8gBgv2fwITSSAioKyC4J1LksznYnNbBls29trJyZk9E7O7xnZdHU3u5PJQL4A2ZIlPpdcWEWMJI43DmjaT+rFH2p/5eOPIeQCIZHil0Z26Kv/hH7jtF37kJ4dmptiKUzaWCIz3AsxlMCjmSLu1LBJgxH1fBaBIRBHUfvM3/uC+7zxYC6fqvdWJuZFM0SES9DWPquXo9JkL505OHzx8cK29Spmd2T0bVYVTtKYzjN3kfOtjf/2FN3/gla/6yA899d3Hj3z8O43e3BfLvYXOPX/PXD+Txz5IlcuAHvttKFeC+DCQCpBaLvKobCgUY9JK6EvCysxifc5dqPWglocjQLNQnYurM9XKzERp23A0NUxxjHHIKrkCuAyApPDdiLkBzf1Ve0Zed9fYyQvnd1Th1a8YZvUAVpH6HNUXrWva3BZZELcUGdSyoVpAix4LiexBIa3/ORiwSaJiDBQg7EXLAJ6L7Lcp8v4lJEDJCkXPPtAOi4wQMANIvIG7GSC5X/perhc1vicOAABIRfvdGFKEVC9lQRgAAAoStwIYc9BE14xsf6raeyjJTuZcFzZOWWA0wG0xvqxUORgPjxiTaZdQZKsIZXzn0Nz+SRFZOll/4tunjj/y1NMPPVWdGJqcndxzYHJ6e8VEQoFHA2gICBnXAzpdT/4UPzCzWmIVlaLlh/reH6VgpWaWi66FCMmAJYxjGI4iHYpAopvmJn2mjW79u0807n48uRdwrWLLCQqpcgFb4n6sh+tlNwEAtKjoVVtn1+qNRpiIxfK/zR78TPfs4dtufP/P/73h0dpX//wbS+eP77z1xnrXAYb5yfuXjzw4Nbnjqquumdu2p1odWu4maYjlKAbHjdNnemsrpfFafPMhMz4WqSUFB14590RJloblisWy6RDkHiInEbAAGWD2PeDcuiBQBWWCYKj06Py5d7z5bb/3z3fd/d6v/smnPnXPZ9eitX1BWOKgeaJ99Fxweqw2OhrtG7Pbw8AIpgllXcrFQAhxhMEczOyM9nCEXqXLjbpf6PBKJ2t2fDPJe45z57XQZAcpqjl9tWcEIjCIRbUwsBpsCD8p9uVwN9UMETQQ71zuNGNksppbBQNBOYIAgrKtjg9Xp2Zr0zuqk9uj6mg0M45RVYgYNNecfRszLYmIJTXGVoZCLgXnmsmRe9ce+XbnqUfDdpCIb0O64/DJv/P2V/3cm35+5/7JHEpNYBJKvF1MkoU8Ya+74/JOE9dDbDJmiIHK5ux6HI18/QvffeD+J6pDw5xLEIZTM5MpZ+uKP6qA1mRZdu/XH776xmtYRUTGJieGhsO18254ZGix2Y3j8NiX79m2Y27m8N5Dd70ynhr95h9+xszLY5XJ/5Td90/NK2ocMzpCtDrI7+uAs2d9YSIwkkcXD/m4WlWJsJnrWpAa6VQbwb7T8VRYmooq01E8PhSP10pjtXAkjiohhqRB4JVYA1UV1YInfHCRg4QJq4Ii9baNV/7Fj79+ca0BANNjI16c18RQoEiXrGwjlLS6QbVMoVXvRcGgoigAJKKtnC0N0jYb/TM4wJooIwSITfbXl0vjcZgzMqgdfEtAeKGbJs5vr8UwsOwD67QZ4/Q93/hfkhGiZ3zbJT1pFkT7AiKXvftFmuzvKTa0GOuEfIwiFvfb8oGoLICZgAcTookNBKheJRVZ5RTQWzUFhuGSQ4nnbt5B5bHt8ff92A3O+fp8uznfOvbYqfvueeLwjfucOGZNU0EMAmOJAEnjOCxVSkEcAEBUCqNqRJExxhTKJQhc0KdeCRvXVxcXIZCCz7HfNITeKCoMBePjk6+aHb3rtu7Ro2v/9aHsS5ZGPSD2oSkFK+gGQLv4L1MAU0ZxKiu+HI78Lp77RNft3nHje37hJ8ujE/d8/r4Hvv6dsZuva6Wec5b20ql7vzQ2On3DdbdPTU8HpVJkg4WFk2bHdvHMxtXPnXF5Wr762mDblM8145yIlBTJKnKlXKIgzNrN+f/+u5Vbbx65/TXSy4xFQDBIqfimzyfDUA15ERsHF9puQaVta6+/4R2vO/Dmb77h23/4V3/27W89wae3l0sTuUkvtC4s2XPVqDoazI0H20t2tGznjHFq2oxpF5xCj0AJgxiCvXa/1UNakRy9V8+kPb+Q+F7KWeK7ifYS30l8lnHCzCq5856Zoa+JsEmJBPvys8YEhf64iawp2UoYRpXpuFyr1MbDeDgqD8e1UVuuhiMj0fAolkKHmnOectZl4TQTcooiZNCQWgIgK6bUs9mjJ1Yef7D12MNuZT7pivEjHVqbubb3C+967Y+88QPbDu4UH/z5lx+64ba9PaU6y5p3XW8R4gCh0ekdM72QDFEYeWXaADgAQLeTfusbDxpbYcYk6wyPlMemJjOfFIABkT6LuI3o21956Af+zjuJIMuyUimY3T29+uSJCMdAsxyo0qXH7r4Hp0YhLZUntt3yoXcf+Z+fy86snpkY/5OlR37WvFZtw4sVFWO2bhdIw/bYruEhnXVJ7NrLfs3k5djevrztlvGpq66y+8ZstWTLZQxCQlRlBedyzlhBATwDMBZi1SZAixs4t80WSQklAGEv+VitBADOZYjGQKQFcmczAiU26UPz7f/xVbNjYvQjb8AoACRRZxSNwIludqyVz0yUs4tEoXDT/1UKTnWgO2uxJXQstk+fBQCw2Mv+z4eeqlrzSzcffEms2feC6eFZv/GljAAu9hmkCgT/i/oDCkK4IslrESLCGHIAQMEcCQACJECjSrAJ1r2hINonsEBA6x24PEXEkcnhyW0jB2/Zycw+A/WaJ5AmOTtW5zl3q4v11cVVzjmIg9GZEVOm7hO9uFaa3T9jS4EKkBpENESgwGZQIti4gH5gpOJ18PiNggIUKAOk1PvcRIbSePhlt8X/eu/8tZ/1/7MBABSAOCiKHJcgoFUQCEUpRtIQjqr//exceXzkhg//SDi2++H7jt39V9+a3r0nR5s0E7Gufu/XDMoNN948MTbrRUOIzp8/32p2xvaX826CeZ426qqMN+42xopkxpoi+1XINJqAqBq2v/TV7J4nMYlKB2+A0UrquMxIBLlox8skoUVkVBPSuaUGAnHkzjGFYXDH7W94xcvvfPD4/R//7F/ffffjrePVON8WjUCb20144hweGwqHa+HYWLi9bKYqtoYoSKokAk4g65lUQ9OX7hW1SJPhrIkJlIBQEYSBQUU8G6+hQAQa9Pn6C7IzIARrTGAhIhuGFAXWWrLGWhsGJbARESGFBeW0Y2lb543PjbSl69N6HzKvDAyKVsEimNCWA8+8tJLOz9dPnmg/+Vjr/Jkgh9QHXQ6wvLLz5vwDP3jHh9/8kZGZKSOBKix2Fk6dP32Ir61nPM+sJigZ5Tx1omjCDCHJ0i99/tPf/+a3bKIUIqPy1NHzjz9+wgTEPswzndhXGx2PXSqiiioKIiLKgqgnjp1dWVkbmoizJI+DcGRy3POTkUtGJuzSWteGVuYXn77v4daO3Qd27cyHhm/6ybc89Ud/1T5qHyqlx7PzB2GkKAOISAGY3rzdthOwb9/uwJWXTq7myVKWU+3Wzp73zU69/HVUqnDforIT1m5HUAqyhnXNd6AAAMCRdj23E8lUucCXAxrCEKhkqEQSoVgFIoIAwSIqGe1rVqoqbkRGmLL77FPZnxwBcNmFU6vy+eGffCMaRhBVUcCxgF43Wz3GmsnGnn0zwzMixoCZ8K44uKUas08u2ROXrXnZ5OjNUyPfKwP3v2RYRbiSid6y6tu/vwPq3nWnVSCCLoOQFsyCRW12Aya0aVyp+fB5DNSLnpwWHdkaqKrvg4KkoE1bB6TqpiR+n+NF+rVckQLRD85nzvWVwhARLAQ1DWuEaABLRDR3eMogISIrMDPn6FSMAoByobVLpnt2fvW+J3yaVXpqymV1sSSoKQZTQ+MfPExEF0MC+lAEhKLJBbDgtwmIOcGh6txP/tBS+5P5n57GagyEIIPmgEvan0VVNQCrjH8kT80nvZtf9/o9+w+ceaD99f/55ZHt25O5UUidCUJcXTHn1vYdfOVQdc7lbCpxV9wTjzxq9+41QUyMebOZNldlIor3bLNe/YBigVANApDppFkUxum55bBadhcW8yeertx5E0oqBKpGAZtp1k7taDkUr/H0cNrhldVutRZZVgZZ4xQM7T5w669cc+vff/+Zz37ps5/92jeOP9Kg5bFQR0sjcTNp1e3aaXqsEo6NhLPD4dxQNBuZmjVqCQhUs0xRisZRFM3QC6qaoh4uaAiAhEAQDMSRrcaVIQgtG1QM0AAagFAgADKiBsQIBliUHDNMATMQKnCk/XKfoJAppH4CNX0tHzWGBUB86tLV5da5k90TTzdOn+DVujpPaL0rNbVZmW6++o4d7/n+H/z+V79pfGiEgb2IerbGnJ3vemtsRRMn5IRZGAHRhKagwydG/NynHpqZ2Peq77uh282A2GdUGy7ff893nc/i8pB3lObJnmv2YGjzbjKgP+pT16nzrtudPzU/On1AXKqEpdGhAEzcS7swA1HTobgsbTfaHXeqk3V27Jut1Wp73vuW47/7GX9cjtruQRkmRACjWtR5TSigzK7C1T3h9K6R9hleO7HkqGVcvO2asf3/4tps1DgAkLxYeoACqmiNASxYeIv6OhaKEEr1bx7tfuLRoBcYZmUBKJSolSxCgCYgNQShxWqk1RgqEZQsRgEEBg0AIRBB7lFZE6/HVvj0mhgNMIrL1eThup4+Dnt3AAIDKcDucvxzI5V72vmvn1+rGeupvx1URRY0qIiYiZQN/uRIZdS7NhfFx/WiMkSkP7BnZj19su421tfyZjO4bqk20/RuMqxbp22eFQK0ufX3ufCAymWvv2QRwLrp3+QD6JLXBwZ7k4cAxot9wPNKPV3ikAZpONSLHwBsALAuBksVVGsIngqgIGi/zV0veSrFB/3gF1CRQm/q4oFQEJ2LqiAiGqnuni7PjqnXfL6hmeN2Kz+z0ju64B6FsWQPlMsKjIPU45UZrTeuZeIfvGX57F+4B5uAGmApJxY2pmh3XT8NRFU0iE9q7xt5Z2piauzA/rW17JFPfj6slGB2VDtpYdLSk2cmpraPz+3IfB4HIVi7eOxY1mkNT8xqDhDYtNP13W40PVqaGnVZjgRevQEEY5SQVRRsocklWcq59I48WX3FzQCghDCgxm6kbqQUGafRWA0AFhYb+0amVXhjTwDa86Y2d9VHfvRnf/zdH3rk+MOfu/erX/nWIytP5Z3VMJTJchzmrnchffosHiOAqqkORVNj5bnhaKxmhiKMLAVKeYE/8eBFwKMnRUFW9QAgVgGFjcmtATKMwAgElhTQC2LBljGo6hsLxoAhVAI0RBERFa2I1qAYAksopCzi2bVWe/WV7vyF3oX5xvkTWWMhT3pGwwAi5qiVt4OxbPcheddbb33ba99yaNfNQVhV4DRL43LkGdAAEJw9vRKXqyayCl4AFPsdroBSkOl3Oj2X6ze/9vAtrzgAQKwYxXF9pfnEE09GJZvnuaG4OhrvvfaqjrBDhb4DIAB0XnrtFLwunF48fNtBZUHE8lhVjZokCXO1lUDbPTtaY0Rkd/zY8WZjZe++Xbt27ehMbTt7pF4fwriLedSfXagCkOdCvuRnDw8NbxtdfLzZezqlaAgTLe/gmV/eyeNxEaUCbCIK28BkbSzbwarkyvhIZw0AjPGFwIUAADGRkhKagc6bYBeg3QdxDfZnakgtSdFjEICSUskQWvEm6/Xw2rFwxx6PDgAUyQE78ZzgHkPXVIJHUjeilgF8sV0VDMCKap39h8bKM2HeUGcgvmRN0rMQ0F8ExdxkRv52VYG/J0XgQafY/+6Lu8JYjwMYQUALEBhRgf1/Th8HLFr7ZatuOAVAA0YLmCSAiUMFKB+aBWsK9NmY8/m5BhgA9AWT2satK77iyt9O41MjP3Jn64m7s67LrCPRdVbWTZBcIAVUPSLtlRRm9+ytDE0+cve99Xp9+GUHWsCWjDXguz1erc9sO2CBfJY7Y/JGc+Hpo+HwmC2VXNIL7bDPUs8uHhnRKHRJAsYYRQIUBO+9GBREZcEoYOehXE6fPuVXG2Ys2shTK7UdJ05qAlSqxEPV4yfnDxzelhQcmQPnRyDe50sEVC1de8urbnrZK//+B1fvfeTb3/nuAw8//MSxx3vp2ijlVUOiFtqhb+Wnz7aPEVGZKpGtVcLacGmyHI0EFMS2HJswpJIFi9RXUBBQoMCY2GIFjFUkISUbKCkaUKtqBSwgqhoQBCUwNjTWorWskjmXZl123iVJ0m5l7XbSanTrC+2leddtpUmbsxxyF1FkfcWlYWZ6bnhh3/Ujt95005vufOUdL7u9WhtBA6zAIqgYxQEAEIAxCApPHzu7/45rvdPUay7rkEExqkpIQKtrrTzPz59bbrXTWq3qmSsxPPX0+flzy3E5JrJZ2pvZO7ntqh2ttGcACQHUqLI1lOd5Y7mJRIvnlrz3IsCstdEKkoM8KjV7wzuG3Nh4aWpCwoARoijq1LsPfeeR1YVlYc0jqx4SuzFLRYCwJNXe+K0jtUq1+Ui9vsAmjq22bcSzP3195erpPHXP2wDsjng673RbQUUslEiKPghCJRTtS2wRigEkEqNQoJGLzZ84UCVvQMA6Ao/EBkQUjYY69K79PCrQ7QspGyQkTVhHLP7MzNB/uNB4qpNXLAEGgJZB6poIpj81Wb6jggAYQdlfBjF65pE7TXP3zaMLO6eGrtk+DH3C65dyPHPN4Dk2gtkrHeiy7fwLGJtYea/ML7Sewl4PBV4YJ93z+ogiMQKj9YRGKFAhka3pRLaIzlCBTZ+dAS//2wCTQ/1tWJF0ElHnsSC0MDbaM4VaJGovaprb1Op7hXvaa1VePpdfUzJHtemaNo2YpNB6KaDL/U52AFU9KamE1tf2LJ9qto88PX7oqlXyKKygbMk1WyUMSmEp6/Y0IHJZp1HvdruV6R15mhlAEO/ShC3F4+O5shgEVVP0Hog4BRZVVJYsmJlGQxhG+dJycvJcdfpqzdz6BEgd1zu9cjWyROVdU6fOrpCCYw6MWV8TomoUQkExvp4xAETx8GvvfPvr7nxzs1s/deHsdx+5//6HHjp2bGX+hNPuCOVBxGVB6cWuq0urfhFbx41HYwKKwyAIgyAIbCmkOMTQUBSaUhzHJTcU9UoUWiEDhowxiKroxSCQKKmiFEF6p9twLvNpkrvEZXkvaXVbrSTt5r0cUq+co+bWoKFQOQQfKYeZ+JZZq82sHbp24q7bbn3jna85fNXBWrkG1rCKKIPfQIqIrifRqd3N1prJ1NR4knPHs+vLoQAiCaoRCVXXVpsuB8e+1elVh4ckV0F57NFjPmcqIQBnkh08fFVUjhrNdhxFUnD+KRhE732vmRljWvWOd6BCLFAux0qsjqJepxpOu6t2CKFPewrWoCGDBs3ihbX43JqLuKKGuH/iRc4GavWpl88N1SrNJ5utNW+MURRqhGPvimpv3u16rIUO91YWYYOqDFFUTX/lSlyrzP7UraY0TKNVdQWBkiII9UnV+/GZALKqFGxaqgCEooHzkDrOcs0S8bl0etrocqvHF1bLB/cOHdy11u5GFK4v0oCVjfaUy2p/eWb0d9da93ezXHKRLEW4Pg5+dHT86ijMoajPccFQ/twtTDkKHzix8iffPHnHwenCAbwk40rn8AxtwM88XmAE8Fw6xV5C6OdLNQoIlBCoAC80e198WBSDQ9vtnYcwL7DVz96oraoA5C/euUM/MhADOqhCbAiebpBniAIUBKRe8NIosnBL0Acgy5ZfbYGkVIvedzP91nfH8ri32KKeqHJBY6SqrEoKgYIHmQBbCglWn1h6fNXPTKzFAbocAAQJxUirUaaIgFREhcTJysI8h0FQG0U06pzvJJI7RaBaBdCwOEukiKzKor4gPwYrDOHuHRDHwAIpZ8dPVO+6AbKsOGcBNYhraTYc2aqXyv6Zc1962CfOXJL6Q2AAo2q8KCIQ5uRzJxYwCMdu2D96+8Hr+T24slw/cf74o48fOXbqwpEnT549vZasAq+FXkxQCsCoZWcyn7i2AfQoIuLVC7AigCCZgFADIAAiIIvEoEVvZyFZpcoK4phFvUifjYnIEhpjAmMMKQAz56Raa/o81SwaSoan6MC+yV27xm6/5U23Xnvd/r37KtUKgHhVBkFV5ECFlBjAIxlAA4ggfTX2R588Z2vl0fGRpdylAnl/tigohKIMEAk2Gh0BzL3LcvGggjbNekefOGmMQTBZnlMJ9x0+mOXFBp8LKK6KhBi3Oqvt1a4Jg9XVepaKKmapj8oxBFFPGhHD8HxzYccsloNQOLNKYNiErDJS7+X1nlG3j8uFFKeKiKot2fEbRyrDUXKs1T7rJIoCYSQpzwXT77+eXarkgIWKYLg/DdZprMCJJN20MloDBlSWAfxSFOze3QAApIokQIpQCTFjWelx4oQIIkPDFVsLyDtlVsNg+9ueQcJr0P+vm0bPZRHZdcqvPjoWVUGcy0rIH5kYfV2VT3USQ8muINobVoc9Ow9ooWBRRGF9NkBnmqZx3IeEssremZEfesXe2w7MbDYCL2Y8w0b+Sm971k99r/oAnulEL5aS33jnpnrACwsCLj/m5aPoDuNGq/dfPoXnGwERf+2RJIbg+j261cb7crF4RDSASNivX20aLCLqlfiShg9EBKWNCLBwAwqbgWuqmDnfBh2txpDzliISRfo14zx6+a7sqocrjzu6qsIrvtvssCPIjYioFtUJ6oJcA5UJXEzn6z2i8t4bXB4oKJCqJUw4X6uPVmdEREVCH/nOWq/ZljDSIACvBgxnqUsTFsFatThta4lVcxBfEMRrnzDLzkwFc9PZqTUsl7Jzi9pLN91wFNCu57VeMuIqI7unj7R6a6vtyljZi9sIsArQzuAZIahlMCiIKCBNJy3E0JZqs5N3bJ+85aaXuSzL83y1vnLs5OnHjz351PHTp04tzV9YyzNN2up7xjtUsYiIpgQACMZYNaBE/Z5pUcwB+mpCoL5PGUSqqGJAAwQSEVX2KKqimggKhPnQRFAZMRPjtH1u6tr9ew5fdfX+vfump0amxofQhgpBzpCkntQYsv2bBIDGE/Wl6qGo34sWsLAjT54enRujMGz2kq6XPu1Vn9FKCUystLrcUkEwIAieEckuLS6eP7cQlAK0QZpk2w/MTu6eaXRSg5g7R4jKiKwc6dpio9fshWHUaXZc6lTRZT4qxVDxO8OxHdGsa4WVR548t39HZ2ys4iUnYAMVRjj6lOt0rqmN7W9GWeQNoPMSlIPpw+OlWq339FprJaUw5q6nchBQPvmuanxgKEk7FIoFu769KXYzTshGmC71/uw/fub4ubX9L9/9gX/wljAcFK+U1iNfBmQBIF3tus8d7T62mKwkPvVqDFpCS7hnNLple+X6mbIlTbwbfNNF66VfEbysE7hwCRkJKYW2hBFm3gdZcrU1141VjBnOSzZ1+UriA1TL0O8Tfj7K4QX37NRw9PZbdkERQLzU+Z+Lr/Q5HXvLKvGzO4DnW5W9nDbub88QAHKMccynlvz8WjRcI1Zt9/iep/CGvc/6ceelElsA6Kb+1Hz61HxzvpEUf5odKR2YHb5m+6gNbOJ7xkqhB/ncB6LefWR+lf0HXrnfOwnsFtsNRfAoRoHGasHrD/lH7wnzCgzXqFTp1ptJs6eFBLYii3jQPVC6jctfiFaGV9qNdLk8fa0Zm+NKRbK0zV3h3lypajJtIzPxSmuti4kJRwCJvbdIwOx6PY8a1KqoZNEKkEPxoAV4DBFBQURMHFVuOJwe+yJWh9zCkm91bS286NRt0GRe63WvGhoKRyuPHTt7x51X+3RjXahoAcq0AEbBAgphRoAIBtACEbBKLwVqOSC1xlTDCm4bm9hz6NDb3vomBGjXO81mZ63VXlhZXlheWVxdXa63VputRrPV7SZ57tOuzxOfZ+xy9V4dq2cFEGtA1YcWEDWOQkSoRKExWCmXylE4PFKpVUtjYyO1ajw8MrRr+7bp6emZ6fFqrVIKo8AWWBtQAIfAHoggMErGqgAzqCqSQ1ICAxgV3AJFn7yqV9A0lyeOnbvjXXd1cl9PXduhQQgMIbCqWkUSzhQaa21UUlUTBN5LEIRHnzjZ7SZRpZwLQEg3vPKmgp9VqJCGlggBWQR08exi2nMUUJKk7D0RiRMThaYUmdCOD1VONps7LiA1jp/bWU+vOqggJm1HDzxB8/XZcvzD6bbIYIocM9oSTV47bCLsnF1NznqJQixhGFiALJoyY6+/mqlnLYFYRV03TEUfDKKGEX3lr+7/zpeO4di2L/7ZkR3bx974gducW2dx2EBpZ6oPnu1++enWas8RkYCSRVHNRTPFBy50H77Qe9lM6X03jg2FJs0lRGMK4tKLFpVsaXcRjUCgLXBPrUEY4u4RLSNH6nKXna3zSqf31RPZI/Mjr903+v4bHSgoFKzBz7yEi+3/JmPzPMbzMpWXbOrxyse5JAlx+esvfQSw9e5eFQfBoMpF5cqLg4CXQFLmGT5IAGgNsgiSkvGsYgltUMIA0MAWNYB+H2mRUw+sVcEHT6185oEzK42L3vfUhfZXH186MDvyQ6/cN1aLhXNGh2CeywWwSoAkAE+cbyYWnjjXuGl6JON866uDkCCX3I3eed3y146aR1KN2kOK4Ui1Vq322r12q5c5VogITA3s+2DuO/bhDk8MddiljyQLT8jUTprch1l7SqOru+SQL8SyRr6XdlHBhGUwVkSUiJ13WYrGQGiJiAmcMg8imX5eC0BQ1HP5mkP1yr2KSCKadwE2HIAiEFHb+8Vm+0BpZNu+mYePnnrtq65NAQpe9SITUjD0C4CjApIl1qOqCEJuDVGJkK33lrBf4APMc3Q59ZBCgqBWnRutboOZG3S/9EkQCgyygAJ773LmnH3OIsIszkOaeyiogYiIyBiNgsBaE4RoDAbGEhHZfqhXqJYIqKgRAAWjAM4DM4tna20QUWCFAXkgjkDGA5BKiAAqrDhoGQcRwGJuPfXU2Uz8xLaJTi/tcZ5LaJEAODCGhRFUgDxo0uqqarkS2NB6ljDWk8fOMHAUVlqt9tyB2atfdn0zaUcaoUchj6rFRoBVGstN730UGgeMOVNEwmyQTHWi1V3bFsUy3D2VubiDo0+cr9frfraKp+ezen2oUv1QMLM3CQUlFs28zuwbR6XOSpa00ERBSeMOJxjlEfPI6/aVDpRbiQ9DFHaqLGr6tWxCVSUBK+AJclOqVMZlqeGsGmM2OYCN8fWT7U8fbVjCMLQZM/SxzX1K4ChAVX3wQm+hlf/MXTPVyKAoF9A7kIurj6BbdP6LiLZ/9x748kk01k9Xda5aOzyHZ5rJN55Qx9RzgZH6x5PSWw6a0RJuglpcNHCDjVeV101c8RUb73pGcrSCMnnr16/863N5z3MpGDwnB/C3MJv/YoZ6Fxycxqt38oPzUVzJuz1zYG7zfn0zc7eCEhpAMCG6JP7zb5/41pMLRNYGSEQqAgB9E6FwfjX9zY8/+OHvP7Rve7mT5DQgGAAAwCtQAGpNtRWXg4dPrF7o+rhSbSeOVLSQf7n0zUBgCQCcywNT+9BdvX/5Fe1SL1QECYJgshKNT432unm31/TdrNvuXpWN/Hyy/z/UFh0Nk6/UPLWPz1c77W6YH8pKE6QOfC2F1bR93CckvLnPk10mwEiqFhyqB2Uu+JMHLWwAigyIzC68ek/54Lb8/iczjVy7EU5NMvMAcFWoG5slB08sr1T2zTz++Ueb7UwQC1oOKXSKpd+0UVhJZozCPvkrgCgmSIShNUQIxiAYhMBAWHgO2pjKjIqqAgb6MlcGESAISgHgBg/s5ntLm+/wFR7T+v0Hwg3tHSWw1kBkACBNuZs4RRfHcWwJifviusU9wAENJPa/koEN0P33nJnav12jqJfka94yGlUB1TzLLRlEo6qtXtKut1BheLiSxKbr0zB1Tz3+NKHtdjq+qq/5kddmhJ7JsEJhKwvXAZCLzJ9YRFQtZhWzCILHCCiuxY2l0Kb+sB/ZTv542H7EmJXldvVcNwn9jmjyndn0wbScxBx5UAdhJaqODGvKmfNqNXTEKEAQJ8OVA277O/fUxQXovSda1wwYzH4ABeQ8SW/7/us/9dWvLSx+cfddc7e+ZneadAGg36ODAKIYmC+f6X7mySYiegXOHaAZaA6CopL21WM0hDOp++NHVn/8uolKCdruMsQ5XGz9Ny0ou9jlbz6lMQYuD8734PxSdt8JRTCkYhBq1pIthQitBMYiATF4hQKAOlVVILqYG/hyo983oRdvi5/jxv+5ZP9fGB3097wGcDnvwuZfL/65MD2bGyhe4iCAEUQ9CpTKof3gtfW5td7Scm3v1SM370o9XynHhyRkqJP6T3z76e8cWxqvho6VRUXEEK2na4EQFXKnn/ibYz/2zgOjI5FPnz0MRGqD94lrHTnbEYFdU3zr3tGc0y3jTVIAyAoOdfVKV22Pfublya99nc0kmDxwPvcCKsND0cj4XJJkzneazfqbmuUlrv6hrHiY8GEQx1GjmVSofb3sdJQWYsIx20w6YmTzd6V5XmhZeFALhU1REu1LnxZmTVFJPRnJsqG7blh46CGDQT7fGDpgnHOFOymEyYrDPuLT/eVKO7VPPL1yzXVzeZIAgME+pqr4ZhFABBa5+7F2o970mc+TnJ1HUYOEIAYwjmylbEqxiSMTh1gOTRSHcRjYUMtxEEVRFAdRQMYYQ1LUCanf81fMOly3+yqCBrSA5CMM9I0py5yIJplj5jRz3kuW5Xnm09RnaZ7nPstclnKW5Umq19ywbXpujJlL5VAdA2BoRAGJNqDffcAigCqiCBioN/PHTs1f/8HbWxl7pLpDAyBIThmRQAtBXs1c3m70CGB4eoJtJGxay2tpI0UKNex+/4++rTR9VTNpoVdBMYpqCBHZYKxRL9P5Y4tBFBMxgqS5Cy2J54oJAqSGSCZSEqwpXmeGJ1E/b+aPhc3DPPwh3TVJUWbRCntL7GWqFmvPdZM8yDjycTdKBH0tjbKxxfF/cLsfr2DaKlbBJXJJhcQjgnEqw5PVf/UffmJlubVr93S5Uso9bzYRiLja47ufamysZaB1semCg78QKJaB7OVDS72/Ot74wLXDBIiX4ozgSi4dRyKzc4SfWjWlkNn368MKIoVkDUinZ2pDOByBXNEKCVNx8qagvXl+Sd8XC+lZ5/aB52z9cZM/LO7UFR3A335IzwsYRiHAQJV9xjS0feZt70enMFx1IiBb7NAREUARySB856n2IyeXJ2pRoUNLROubZUEw0N+rlsvl1U7v3oeX3vzqnQD5czgpMhSD8OlGu1zC7zuwzWroFHAreltBIQVVW8QrmIi9+arop/Lktx4BjtMSRoHGbF3G0G7FFMR2eHR2THf5v7826RYe/JhbmwtGyGOQ4W6cmMKwp2wIYqF63mN2l5TBsyx1LmN2DjwxaAGPV1LdADgBIggqeLG2dPPt8aFvNR86KsuJohEgBBLwmwvaeaYXApK9e+954OnrXr5LkhT6XeKqAxIuRGRD33m6ff+J9lSl8u1Pf/LYffeVVJDFecgFZFNrZSFAgKiIaAyZgKy1NqAgMGFkwtBGURSGNoxsWEBDrTXGEBmi4oPovVcF750qZHnOrGmaO+eSXlYYfe99ngmzOufYizCjF/Es3jN7ZWHmd/zQG//Vr/1EljkDVjwLgaJR2nrbWJh2oeBbD5yU6XJl+1ijIx604XjE9tWMTaHkxhIY26w3k05qLNd2T7UwD01pdbmxvLxYHZt51fu+b+fhW9Y6qyGVDFhRsMAIACzsNA6D+fMLy+frZEOVTMF4L8giXjWmGG3OPvdMFCaciYEdQrdqeEZbb7R7JsV2A7ZAxoFjsaWgVi1n3SzJXaTEUa4RjXZH2rXVvf/wwNi1O1ZcJzLmGRDMimjBiMrI+Mj4+CgiCmsR4iiwAqlgNbSPn27Ot1wUbCIOWGeY14ICkryoJQDEACFj+PK5zqt3lmcqwXOXhdThKLhjJz+8IKFR5fVInRAHjIBod46Ysbjf/7mV8UtEns5ZDc130zvHR2vPab0/D/z+s775eR1/yyPbK717vVvqBSflB+8vOD3MZa9f/jM/FxGCFzMEAA2xcxIaACAijK1nzyqofUzeJZ9ANIjaSvw9R9fQUC5qLBUosr6S8IBTonD/HiCqls8sJt0eRM/OAygAQICIdnq6e3W1dGCyxt4DgiDRFkjQQpZPQEFRjLDrVuybb4qnpPmf76ksxEGpkmKGwGiB0ZmMfd5UqNRo4u/P3Hpu4Rvns8aBfHIXTuZoGEkYAgyY4Jyvg5AVxYLdQxQMeO8LqmpWYebNuLqNCxBBRGBQdbml7T/0+mzhcUMLBaqnSKH1JcwQFCgkSlhKVx+457NfeevSYjUuS4GGLHhmCsFAowvN/Fwzn5mMSyxPPvHo0skzk+WRoKiPoikCr4JgFQBQXKFEoYgZaq8PFS8mMMnAryiAwuAyoK+hECChIRSz0dNPfcamwv1TQSmhg7Z2GaBzio5zMQpiLB49O/+1bz06MTk8NVMrRaGlMAgCQhlkrS9eXKSimIl+7YEze+7akxrsBSZJOpn0lRGLqyJRFg7DsNVpuySIq2Zkdq7luUx+cW1p8vDOV73jneP79y9kbQBAYFYNVAGUgEDUOw9WV88t1But0lDVZwbUCgNzH/FqFHKW1DsTxqhAIIqyU4L34Y6DppaRt0KmSPeJH6oN23LYa6fGGEeGDdeaw63S+V3/ZNfQHVcvc3vIhs6xANMzdrQXN5AH9TalDeAfAKZen1xOVVXWzQIO1knxK/RFBrnPso9E2nb60HLvrbVhfu6VV8TwtXvdJ4/yWm/zwlfVgh9TVc22IYxD7VzRrKvqPfP1BolJ+VWV4cuahbf+yKZTeB5Sic9wnOcOCd38enHNzy8F9L2IAza7mf8FcYaqKvZrU4wA6gUK3PmV6DjYkj21lC41XalEAop9koN+XbAIT9czGIpqADup63TyaOhZT6cQdQcV/OHrbwIAdn7wB3jmVnNUYFBrEmmD3X94+v8zsvbH9/l7OxU75SjPIQkYGFOSgCTL9WwlKN9hp/40XUwEAUtkJQWwAkZojfJ57ilAJJSBF2Yin9+A3YaIsAGDEhQOoP+8lArgPAAUmds+uaayXHV45lf/j5IJekmChTpXv2/aAIBXRVVmbY9av2P8uw+fedNrb2x1OiAsA8SGIiCjIl6zo9zJuNfr/fCHXn/q2EzeafjcKZvcKQuwE/EMTlSVBH3uxEnu1QnmjN6zePUOgJUZhAmleELWApmBho+qOvBYdE6TqHJxVUFowUBkjbFoo4AIgsCQgTC0ocUopiDEuGTKtXh8dGhstDY0XLrx8NU798wNV2s2LBtARDQqRLRlXlEUDZgHnuqeHJK79u9f6xoGWOS4m/iUCIgrDpwxiBR6246D9OR83lib3Tc3smOykbFTX9t17et+6joRWe2kSqgKKTAJSLHhKpSQCZoVe/boCUFSFFICNQKoXlGRcxbPIpKKAEAg5IokEdpZGGYkRao64wmYtFKJR4ZidjEaVpTchmHddKbmd/7i7vHrb8rSTgmA1eMmprorLkA0tEnJdDN/iYgmuV/peij2OP17VXxq430AoKBSSJGjKmKI+uRa9tZnx/FtOg0nwa6x8LV7kj97BINN2SoBFAVWcWKGYhQFZaCtN8qRoQPD0aN58uqRkeH4CpI0z2c8qz94wW+4ksPY2gG8oOTPVrBFXSeJ40uCgMu/6Epf9xIHAcWOtb+5LlpTnol5QcQj6rmV1FggKoDhCtBnFC7kz3DgA4qr8qA5CD5nDSBBANkCwvysNxw3EebauR3T/3hu7UvfWvnsQ5X54ZoOeUw0MMqaMRqJAuPiIIi8MAkDBqpOPWGQAq9wd5mbKMIkUc9zlrK1+bZJuqWbHb9gdlaCA6NukwPYPMdoUAUhIgRyBsLxqlclQNa+SPdAPtUCGAYh8NBydnrHI4+devUrDsH/S917x+l1VPfD58zMbU/dvtpdVatLtiT3bmOwsTGY3gyYXlNoCZ0fhJYECAkhIYReQzOYblwwBtu4W7YlW7237eVpt83MOe8fz+5qJe2udiUZeI+fj3z3lin3zpwzc8r3CJEaPepow4IQmMF3sLPJB5SIxfOWXuuIqyTVkfLqOiiEeigXEAKRsUjMRGwMk0Ema60xJk3TKEpqUVyr1WrVOKzFYZwkcaq1Ti3UP6WU0nFQKuE7ynFlLpfJZbKNDflMxi/kMq5yMr6jpPR911HC932lFCIKAYgIAhEkynoOT7Bk2RIjIUiuc3+c3MEDAEpG/37rgYWLW0zGu3fr/j1JGGkBaUZLkVViIE1rWuecXFF4DmcPHKxxDE0L5kC+EA8OR7oKTEo4zAQggAQAWAsSGYjGQISYLXM5GtjXx6P5lIgEM2Fs2BVYi02aaolCk0UGiwgsJIEk5HocO0IkSAAqV2WKTUo4iemtkYxTxw2j+OLBpa9Z3Tx/dU2XhRCje9Pj5QsbHzUTh//omAcSQgmG1BBMXPLj4X9pHKdrDOdoDKENSomZxfIfgIwVVrqXLoxu3HjEgOZRVC3ZlVdPPw0tTTMXFcLlLYULZcEzkIA+bA48RXRcdZA4oeX/EV2YYTv+DAvzk3cAnU19R7PmSYbk+CFyaoyqp4o6smGER8iAOmkwBRczrnrqEkAf251YCLTY8pxrC6efPnTvPb337fV3FfJJE4IjZDlxwwwHWV9J0NKmUlpLIFmQI/tQH7Sh0eyxSCUam8ooNMUMu1m7blU2c4M/p43zHZRqgMNeFnWbR51pj69z2RITpAiMwmhyghwA2Frobg3jPQPV2jBmMTe/02lp5GLWb8pv3nfosX3Di7saJCisx5XV3+coONioH2cKYMABNIgIiCwQkCSiRHSFkkJ6PkoByKAAHARHKk8KqUBKFGMuNzMBJj8Cp+zYbze29eG6jw0z1E1/BgHNeJRpPYcgCgYk5ikXF/v2lrePlHItmR9s3rVjII0ZHQmBY4YZmF3ruUY4UTU9kJYakuFo1wE3gKaV7bW4ZlNLbCxCHGtHKgdxHFCWEZlBAWtgYGG1tahtJrCplMpnZTmRiQJNloQySRLFqZKSCQ+rFgEYrRXASIBAEpihmM27nqqwZcypqi/d4eBFteUvf7bTkq9EoVR13KeTGOpj+CcSwfekq0YTKI2v+nmCenDihyRgYFYoADGybJhmxzeYMeOyHPVrHoWpY2AAgSiKgezI1wehAJimh87YhZPk/sfl1yesMnpKvIBOwCQw3o/jFnKS5odTSHUVpedgYqzvwNgcn+IziLrDN7meo5w/XxAcgwWwQmISjqiu1tbnvzS9pL+26bGBBzdkH3ecoQY/aZOOaYNM6Ds6Zo2CgRyQsRAHRXqQYyZHAEqC2GpMY4gNaIgbHOess4k4SUyd+3PdXiZAScj4juu6RrO2SERYD3dEkOhaYVk2xdsPVO57oPbw425poClwA9cJLQ/UGp3mnFi3VJ5zNvsL7tpYwtbmapqu8QSMhjqDAgYAgUhsEVFK60lwpRASsL7PQpQohBBKsoPg1FVNiMggAZWs7zuZSBJA3VeXBSKNpiiqy6txYUaju5p6RjCq6/XrGAZ1sFisBwCMai1wTD9RB6ClCeoKgCMjRo/hCId9VB7cE/UX1c4oTcuBRM9z0lThALrtO2vZvfvTUo90TKGxiZfOtZHcvbsn05hrXNxVqtZ0jNJ1CCWSNGA1W4GjcNcMRtbDDRCAWSc6qemlz3lGrXvH4OY+CGnR5QsTAakGZtDapEY7461HZNIsGEG7BAJNLITLkjPsFl2ROJAGZarC3N2L3rCo5dwrDXIYxlkrQ4cknMRQH1uKEdfBkmlOwX1iMBIggA2AqKvjaUzXCkdqjQDq0V4i1jQBVuj4hEDSV6a/MuqiO/q9bB3FBQRTb9VuHlCrWhElsACY3MA8jkUvZrrhP4lXdWRUl5j6BpjZ8h+mSQoPxyiC4EgRdKyVeAqa6VsZdS0/cisAfy7zwDQLGCLqavIUoxCKqB5mgsw8GuU1YYsKwBJAW2wqZJVTVxaNrSh5qvdwCjo1+mYYjFKGrYHEn9tYnHuFf+mFvGVr7ZFHo43bwz1uQCqnueyalK2yECEdEFE/h5aIBRMDoEx1leIYRkqqFLnNORNFWrAnpRJAyCTIdd0m3/MDxwVIDRGyGsudTchGSiskDIv+n363fPvNrVI+96rTV511Xi5XMBq7K4Pbtpcf/P2e8g8egwceMedexPNbF0YRM96bpmsbcm2uX0miUJcLDkilCko2ZYNmN+tKUefUx3RdAByd4nPU3MuC655d4+MHwHGZQSBTaiA0pqKT2GjHczNC5R2sh3YwOUh1xxSEOowoEwDJuoZjNIEgTfMt6pbsSVDfmQFJsHpsV//vy7Vq0WXl+mQNaY0uDlJw22+qd67fWinHjTJoCHJGhX4mKORs/5CzqKngdmnhJzKSTALqUQVCKGBDFlAwSSGZME2NtdZaEvVEKQjnvPZvDz76R8kwf+3lO4TJSnBcdGtWJylJrGNgSAaNgCytI2WSkbbR8UJpMRM3h3G2kh1xl25rPr84/5mX+12L4jhmSAVgKkHy4dQa047RwzfQRKD1wxANoydXzPF+vNt0WMcKEHWYfhY0xnbGgPIA6y6NxJKwZkxH0ZdiFgzYsSAscW+NtWElcHyvJhNkAeTqpFb9/eamtR2aDDLV4zgm/dyHXdwOY/1NIxKPbOTMPHZgxgx9epoEC4in6BVMIQaeUpzOcS3zX5XLqbawrDOzoM3fOWQ9J627n0wV40sERLCkI1AO6vQk94RiOlzQY6semxtKKWMMAAjfl2ef5a1d5/QPOrsPVh7eIb/ycOz4VTAFK0c8HpBJlEQJxywMkWHlZNygqkNlshCZqiTJjFKig5qt76jGIMh7jhAiMZQCKGAGW58ciBBby26GDvb3/dO/Fc3Qy978rD13bW3ZOziwpb97KIlinXg2W8xe1tVyL/aXe7YXbxnSF585cM6SXBsJL/Ozux5cODjy4he9ADPYHIicdByplARmsjzVe5gk0TbCmGF6gtZHMgnAQ9V0YynaWUv6kjTUGFrLIECqLGADmjmBmFfwFxb9rkwmQCQLGpjBQt1+akEgj63vJ7FdHff7MJHj+pVeuGeTGcyLgFVkmCUk2pWby/qrP6Y9mxsuW3TWmvPn5Tu18Fq94oo58k8P3P8fmzedFsuf/M3HlzzreU1L1skuKwJBFkEAWpTgMhGRSVIDdeAiZkRJwIJBMmgJXRdfYwWUk5pnQDIgiLB3xGhtlDVMxJxYg6gIMr2JHg73tAWNteqIO8c37XvbzmjoPHt+8/KL3EITSrJRCUkAjroBnIjeY3xUT5AE9SlPRJd0ZS7pyt3Xn7SQZzBBFnWv/zHmcPjDI5ECNEyV2JzdHrgoU56pIyhJRG3D/YOcGvI8WTdXsQTrAwsBBORUHq34A6koKCESQYhTcMtZKb+eOnScGXp/HkWnGAvoBEqYdBsx6SN/KcFARBlPvuDCli//YVsSZ4UgRMETwD4nkrXU3uCtnp8x+lR86VnKgKOftkYb1qlxmtoznfM7lyzI3fSH7oFKKUDrca9nKmmY6jAlLcB4ypENBekGIwMDnNZkOURiMMRABNjalMu6IudIFmgsoWCqu/KxkmMWb+UH6fbeoc98IV8ZWrmsKO/d+rySWuZhE7W2NmYQqGSizYeGByF90dpLv1De9OiWKP7jg3vPWDrv2WsR0HeLH/uXT2Fo3vP+lyBrQRI4NQRHRtjPiOpcKSQquAIAyindO1i7f2DkQJhqFgzoCqee4wURBYoKwCA52yvkVsLmvlqjHLqoo/GcpnyW0ICIwSIhIBkUknBSz56ZjEyBKqzpz33uv/fMP8eu6nRTqEgbCsBDh2qf/rHnlp/+hldk3Ma+Heu7oy2tib9fi2jRgnu37+pI4VNnXvOFTQ/e9b3v+O0Pr33vy1UQgMNgrWAQLKw1ZLW1FokRUeKoah8ADJFlG0WprTvOa4oQHBQjA4PaGHKFYdJAiFIAbjN7HzK7++nAogVtl129pnlxY/OS+Zm2RqE8sGQFk2VCBjnD1BkzHLqHxYBlIMK/P7M1vv/AYzXbZD0L2gpjj/GmZQQGtASV1C5vCs5qy9gxvOgZTQ0FaazD3YOskDUxAxMgkF6Wqr3oa88hqw/10cbezNMWcZJYUHByjptPBc2K6U9qUn7KM9ZP2o5j3cn/Kl5rHQv+qB8AAFQjWtDivejCtsCP09TlseRgAICEdT1g/dZY01VnNuYCR5wqWcUn9Y0Q2fUkoo6SajC3bcnTV1YoDv2ox9EDNqroOLGpY1gIIbP55ob2bKYRhdVJVffWIptIxa05b2FzvjWQWU+ygJTYMElgiXXQm/oyUCALOZSWvvwjf9/AvLXLTz8tc03iX958Wod3Oru5cr6q28vBafKKi7sWz3X33Lv104WLz1vSMBzFe3/yBz5grFHNLe0LuxZ/8Zs3PvTgJhcYWZ+Y8DPA9Yi2nBLDif3V/sqHH+35+sHKk4lMVAYcT7oeS8GIjEiCE2FTNFJYT7IUomrFwYR/ur33C0/uu3e4ogF9iyykFnVFwQnLY4GK/nT3Y1/8n6/107CRGLkIAtGa8ldvyrSULnnDi8pb9ns3//D1iXhfy5nvbF/99mWrFnH1V0/c09IUqEHx9s5nrC20hod6zNaS0iQNipRtbOJanEaGUhqPUbDWWnbG/JLriY9QkvA1G4AYWFsa6R+yDIDSoJsIZ8iYJ+Khe2v9wzoo1eZsY3nmG6/rvOhCZ87cGspqGteMSSxpnvGAPNGFi7G2JfDedX7n2jz3cypYWeEQMKEg4PqPGYGsRIistQSvWNHYklF2xqYIBhBCUKqT7opVAK6y2vKCTPDxtV2feR52NKboJFLGChJltQQLzoQJdTxgnxO6OitmKGbMuI8rIeQ/vOtdx16eJHRlQqz2sffMZPlzWLM/dUVT/TnbumZ+29jdNP1Wtq73ndvc2tUMB0sH+oZ8yVmBwqtDTxnXWsUWwjh9/tMyazubHVFHARb1iPhpmjKzduKMd9rHlsaAtv5z3exQGqzfOCyURxrLKYdRtWqrngfF1rZ8wwJLjahsJRqJdQJB49wL5j9/ScfCgi+YQzCaLAIGUrgoLbOxTIwMCBZIk8rnB7//q+S+30M22zJQfqU+oytbZIZYmpausGkuFZo5yGqnIVm42HOQ7rl/yzPXLVxvzN6DvW2tuY4zVkgTHrx/02D3oEmrz3nWJUikBQoeTdE8Q6rjwiuUUuBj5ehLu/tuG6hErmywUgGQFEI5wnXdIAhyWT+T9TKu6yvXdx0/K92sEIoFG8Hs+AMpPVaqba9FRdfrch2XKBJWjgHRnABJ4fzoew88fP+B9mdd5zRl4jRJPVG78R7e9OjTr35x92/uurjU/6pzLy36GU26BElsTQfk17U1rGloPi2/4P+23V/yuTkT9G/b7dhcSKEb+CYFIEQehV8YxRolySirFR3VIsVSSEXE0tbnvTAIbgrd9z4x1N0nHLUg24oET1Z79qahCVS+M+Nks9v3bTz/Geu65jWZNBUMQiIKWQ/7nsy6cewwnBn3x3H36dFf3RXMsm7IFM9tL4wkI1tK/XEtr6Qr2VggIAssmARrN4l9kkN/f27xso4WgTyzXcnoJGGFvLk8eONOt5LH7EjwgsbWv78iWHshZApOQ5DctVvYnOxobHrVSpAMnEGcsOabQEeMvRnw95N344GTNhvOGgxuqlKOstbCbNnujLU6T63yZwaDFRE1WZOUV3a2tD+t5b6dW9bv3zs4ooZrgasARcmSWdyZvXRVy6rWpozrMbMFe0oMvGOv4CR0QeNLNhnOXVgsLGytDkYGqkNptw10U6GtkJ1PmIktoagBg+d5mKR6YHiN9BZm/Sg2TTm5O6EaUWg4ZS1RKBYkACxaImKWQTbesi++/Y/K94nMVZ3rGnJ5YJ3q6py52NqOzDUG63g+SBe0Pe+shji1m7f3Pntu5svdQ6WHtsDzLmtsz2ZyARJu3Ly/f7DSUgysEGqWnUYWLiBa+Hnf4A96hhKCxmzGCFVCrXzP8zw3MnxgqLqn++ChvmpYo0R7UmDGy3S0Fed3FNub3LwnAq9UCz0nJ0FuisI9u/uvKeSvaW/I+1QjgZKPlw92iu8Aet++AzIIyE0cVzngcpT2Pr7r3DUv3H3XPefqQy+76AVxmhxG2iBGCU9rWFFUuZ/sePKPyYN/c947BsrVb22/tbznAPYVdL7bdLbl8p6b99FRqIQSIk1NWEu0Ki9xeq5Y19VXqd2yz2/wFFliIBYIKGrDldLgMAuPQffSUMg0UkQO5gTZrky2E/2+3bv7779r1wVnr0tgpB4RDQwIR7tBPxUkhQAQsY4zLr5z3eKLOhp/1bd9Qw8PVpyAc4IcAAsiAoxXLqI3LD7t9EIhNjpBcMQs9DMEnDaEI3P24sWFuS88r/ms82rgJ6YkWLhXzXOjef1f/23jK56FbY0QohAjxN5T3fHRQXI88y9Phm466QZiJruKScwaR+m5jnLCOeUAbcd247ibrD+/JaDuisYM1UgXcuKq05ddsXjp7qHSoVqpRtqVufmF4qKmxrzyUtbMbI/JF3YK6OTsAQCQJtjRns34QcUoqzjXPN/3WqXIpmliuIxSAQVERkpXAOpytToUgSJrre/haSKoGTuAZkCbmElI9KQAAJNSfUk0fMvv3DAuZ4NlgTvPb2QSqTYNeWhtAoQU0QNkMNJorQJlQjp/XePDNw+s1KYx4IGDAzjSt3jZslzOZSmGBiv7DvQ0NiySVjGaWX1saXDQ2m8e6HugEjmOn41FLSGdx3xQqO052P2njUN3PV7deTANo1TrJEmkk0Hrgqsw4xrXOC3ZrjUrTjtv7bxzVsUBhjZx3Gxs6abB0vZq+JqFnY05G1t0JQuQM7f/1cGjkjTt7h1gF53AjYSRnit3dDeM6KjQkw5uf9mlz2GTaJ0iIqJwUDCKVOtA+ncOPPmz4W1vP/fVZLGxte20nlzP4EHlNqoyyfLQiEyNR37RBSeTJKa9jS86w7l4XsOF857W4DVWErNxeGN/KfEQDQEzO74XDZTDUiRddBwvyuRrkr3CQunngSnSI66rXNfd9uRWq8dsqienh5wljcZ/GItK0kWdjZe1Xbh5fnljaXhnrRTrCIBOK+TPau1cmilmIEgEaVVSiQcz90Zl4aUymLtwzcfe7DVlbTEbpaxEFcAnUaUwKD79yvz550FB2Tg00gXISjCTbsJPPnb3hB+ciaL/2JMnHgdwrAw4JVG7x+4eJi3/BEr2PA8AkrHchCdJo+D+aMkwg3QDdfrc1rXUISwIIazQFRuVddVRahIJjQSCmWQ1YV+JR3rMmlbRGKAGSWYiAtK4UyNN7jZ6AjJgDLgYUbKOi4XMwtbC9kefDNyiGzRbqxMzIFgyucxIFCI6ACABdRof6hsBS54lwYItAQvX83Ku26/1YEqM4LsqDbUFsKVSuGmr8FydxIsb5wtg5UTSmtYmiZKMRgABaJANCoSYlCsU87Kc3NVjOjN0MK7J2khLIIt5l1BXq7Z/YBjEaZJmtIkiOLwk7zP6S7u7NybGE36aSM5JQkr2j/T85PeDf3wk3t9nmThwg4Z8wWQKTX7gYBSXqjUdDntp2mi7nb279m25dWfz0j+ee8PVTReu0NZYnXI++5gOq3u737K4pdUXmkdRAmG0gTP6KHEKI0OJdHzlOlKTzLph72DGdfbtf/KShq4Oi+WobBClcoXAhAiABKvQJvcObrnmnOe72NFLAyrRc5vW7Nv6sNe6ZEgI18SKlWPc2qAJa4NXX9b6zletXNje4EHGkNAAQUa96syGT9/R7SpAEsaA54mkHKVxqJTIBEW3cSn7+ZhjhRVBqLhQi0rlakiSWM4O3YCxHoolEI7wF6ex1BGT0rHzlOvQ2SgIICWrGZfkvRW5eQzzQSIIBhDMVoMpQyQYMqlj0TLPmD8gabbImF3eyalhZCNIkGTUyNJISqUQxTwyIBt5NHL4uMP/DNPHzuYFHk9TNI7hc9xaZnhydl5AM5EBMyxqhncefgQPZ+ThibuEKdYmwyPRnX98ePGSBeeetTBNatNWNt3qZhwgc8wXBS0BABEYDQCQjuowLQlEocadL46uAtEi4Bd/tcGCF7Hc1J57+to584uMx7wTHIXPPCGaWjwws2bIOX6hId5/4N72OWsbSILMoCMJGGRiyRUAlo2QDkghiau9w1qIICM1g4eIiC5AhkWB3ayjh5mQ0bpKIydbeuzgCAklDQTCsUyWWQH4DgHX04MDgAQgZCRmYVNQblOTuH87ZvMZTcJPaLWEXN4DJqNhoLeEKEejlKYdMqPBFshCwGCiv7Z/YFMlcbNFnRqdExTpnh/8tvzDP1ZK1diB1g7vrMbshc0rVmcbTlvc5Z/RJbNI0vQN9e45uPfRbU88uH73of1zRpK25LHgd90/7bhqzlmvvUG5ro2s8QtPJLUv7Nz/7mVzGpTPALaOB8GMIHgKB8SJw7gWJuVqBT0HlVQEeSujajwSVZ3UOJlCgJyAV+YkYMG2nu6cAEQP29PnXixQ1kwPCKWJ88JjndhwUMkmm6Kn4iSkOAr/5vplb3nRBYGbIUhSFoDIgpHhyjmdv+0YfGJfJSMzwlg2dvBQL1tAl71MUeRyaVz2FbJpANbaVg8d2iHdWq6xyOwzxpObn6YYaXWQPItIUiELyYBkR53mJuOYCP5tv9kgRebyqxYRmTGfAkCQBAyEBIxgNUpdz+DJh0OysJ6pHcGiALb1OO1Japiq8SxMmgCI0XTzKEaBzxEkm/qjdU3caL/q1bMCqOfqmE6qwUms/WdCM9fzTH/nnykj2AwfPGXKH4E//s6ffvP9x9s7g09+8TXzFjWl8QnvA8S0fx4+TwzTIGEpFoiqfxg27i21NTU8sOlg73D0kRev1mk42rs6XBkraX1AY0+xlkswCEtCoCPRJnFDJe0pY09z0NVoVhuBiQgFRIQekVXCQRcx5PK2IVYZm/QDeK5Aj21MhkA2K8ezIkt22GoJFDs4FJUpNpgVksFRyiBHKbuMOgW0VtSjNevQeRbridmAINec2/ZYT+Kzm5KjhACQCoEYBNSqMRDPZFOPiBIEgSXAnx6obkwocLImxrQxl27Zu/8z39CPHxrIDjQtzr0m0/ViZ8WS3CoP2Vs8B97cTksa68uJNhanAzwrGRnZOPzYbff+4he/uvVgRldX1W468PD+b61+/6td3+GEKSg+WY2/uq/8viU+W8B6aoSZGEUBADCOKE6NyLiopGTJltKwpqMwQga0yILksB9na8Z4UjhKaARjZU64TY7otZSyNYQM1rHKs4BpWWAglA2rruuNfPxvV77kigvRBKnVgt06d6wD9inhXdzS/ujWMmcIBZsoqe7tlo4C0ChdIKtkwMTIca3c29O/LYp7jKV52SaXIKRZ6P0lg2GywJaDZEeP3rMXM17h/DN9HwxMMgFd37v9V498+kO3ubKpOnTpC165Kkrio+4RgDCFH/C4tAAAmJVdhsWEe8dDSYjrW7opP6cAIBi1BotJs3Yf1baZ00z09TN3MZq5zfnEsYBOeBMww/E0vSJo+kqFEELpOnAYypNRAQmAybYIY3qVmRdkRCpYxGxQQUWbIKPu29G9pa9zSXMw9pEUI6HSQiopAhtGJ9HsKYjYaFq67DTBVVlucT3ujg8Meb0N/ry8WgLgaZki+UqG5ACgLu/aWz5YOqvD3zmYKs9RAgJhY8sJWg+gSTOnxjATudqT6EnJkCKk1kiCGgmPeaiCLb7wBAEjy3p+NMGWoZ60qyp602hEExULHU05ARC4Tl1OlEq1mU8hZiul/G1f9c6h2PW9mNG0eulDe7a/99+jgcGk1Tyv6fS38IoVdn4ibSXca/MtuKrVWdJm6xnYBQMwkwRsajir6cpz5i997oqXfv97/+/Gu58Qp9GT+x/55DfO+cRb/LyjoyjIFB6uJD/cX7q+M888ilIwGvw7XQsZEGpRGqax21IQjov1PVmSggCheDDFhMoNMuv6UrAODRvrCJkBK4wF5XFKlBCkwCCJkJApDVPBAkDP6ah88M2XXrL2DCAFyIErNdHElCw/vGn9nVv6gqyKo9RznLRaTQZLiMhklXLTNGQyiDg8sL/n4CbPlbaKbe2tT3vhhWBmp28kBEUIQkU3/hpve9BLmMM4vnSzeNv1wqdJ79/xQK8XN+cy7Y/9ft8zX7hwIjLzbC3tJ7/iRobjqJHYARCOp3SSTpXj7yla+E/P309sHwAnoGqYqvSj/PqneREnoN2YrXATIF/+6qe/7qPL//7Tly9YND+NTxColRHGsr5g9d696e4RoSRMh+swJSEpnXJYS0lbtiKJxeAg/uTO7gkjniQqMv6ju6ObHz903D7OvjNWCB1FlauvueBjX3immbPx0NBIY7iAo9xg9eCB8l1DvNcxjOyyLPikXeiJS7s3P7xhXVuhM8Naa2Kh0FOIjrXSYEBOBtBhbLSYz2SF70oGi1CJQ0kiAtCEw1XU6Tik3miPuI6qb2HbUIkclpYLrcXVCzslQiGbqTe2XKqJGUf2C4Hba8nNfbVi1rcCTKtXfWLvhv/3uSiKaE7u3Q1nfs67aI7KH5D9Zafki0I6yE/u27Xh4T01MFJKgUqAdBFdwSDNW97zvdd/6Fu84rLffPCyZzVtN05Z7+x94t++p601CiMg13Vu7q1uDROSlgQpArTHh4FEhnIlCuNU5TzhOoJBoUApNGml5I6werDmETmhijzP5pQC6xAnyJXU1gZTTEhqi4asJstoLSSpDgHEyEj6smvOvWztGWlKgCQkGBaI0mhGxP6B8B/e9Mv1dz24crVf7a/amNNKEh0aRqqnQfY9r4CI1Wrf7l1/HBp4Mq+CcNh2LLX/+91XrjttYbncP3lwzNSaRq2yuK3Pvfk+h4g9KZuz8OB689AGFUzuRbPm2g6et7dXPXzmc33X92auxv+LkOO5w4eiB3/1ZBKZcRSgU0vTs28xG55wytBAjy33JD2CpoHFsVPDw01eF9KxK3QiKhaCV7zwRQCQRDFMEbV7RDGTFY5M2lowjXTHI5kbb8IGR773LTinFSkxswwIUiiFVIGHlbSWYMzCtDZp1yOAJYfvAd7bW/v0/z3YPVSpvuiMV166ZKiqFcwS43DqDiIig42jyitf8IZzV1/65R9+7eZfrff7ljtBJzWWqkP7qt7efGZ+XhYFp8SpH/NDt/8puuGyC1oy9/eXDhjyIZsRTimppIm1whNEinTCpqmpIe8FlXAEEbdFI2c0tC1O/EgqX7ubDlZXtKpsYIEdiQpEGSjPVlWS6MbesL8BQcOZ87KLuxoVQGMhQEKWUKnU6uDbM+kaAfyiuxIDGikUAQ9Utn7mK85INcnCu4vrXifX7hVlzkEh5ZT4Jn3wl9G9u79F+ifqK9/958vPOE0TIQqQ8KNfbt4zWN2yJ9n6qPP8jff+59+e9t2PXHH9R//0k0qGHt2++xcPznv5RRjGKRkU6sb+wfcV56I1BlCMapCP09pKOUx06uYyynV0mKCSyveE40VMoQl/Pnjw7dnlCo0kkQEhgSqpdQAkiiHNg2lEKIwQbHQ5EZYFIicmKebdc5ctkPW0mqwJPWBIUh34sGlz5ZMf+vW6M9X73vXKH6/fMTxyoAF9I8DGxGyZ2XH8JD50qHuPTXtV2hgNNVYLPde+Lv/+t3xk5fwzq3HZ+nWE1lmQcAiqFTBWBIFjBFgAizAUTnqziZLLLj6r7X8y5XJ13bp1OjHjCpjZj/mZZwM7IcLEUS0P/mLb3T+9v9Rfrg7rp99wljYDSEcIthMOBDuB+09++Q+n1AZQN5XAcXH/ZwYhN3rnpEhERx8cIwOIDACEYXjcKo7fqqEk/r/viB3b3QaHhpL49rvd11xtSU6vATyWYqLAT9/+gvmP7u7taCnmg2BuY35OPkNkxnAlwRBJTFPiWpIZqSXMdahaAbPFuZ2WEBHBnL78tC998N/ved4dX7/txrvueLKytbNBNmUbSPOAzCCYOMXmjMLuhzZ993t3vee1l507B+zA4IEYtfUThKqDlKZ+SlahjXVQyKrWgu7rd/zgYFrdVBtOco1d4DlWgWlaP5C25ZL5SkpyXVGQHpSS8PPbBh9PK9ms15/GVz3trIwSAqA5n63HWZVGZqECemAk2hNZksqCgIy/6ws/qe3YHTQ1vNTvera/bEda0jIohiI29se1J39afWKwnIrCnFo5/4e791x+xiIL6En47R2b3/H+m7QV73zreS94/tKP/ecj//jf27s+NOfrH7xy7yfWP1GjvtvvaL10XdCirJHo8WM1+9BA//kNjYkkl+T0EcL13EGl4aohdrKBcD0IEyIKWhqkAsEspPvzob2Lct6zisstRZoiwaLAXtV4u0nuQus4gpEsgUUarg6TkIHIlYf5rHX5xfNzWqNUCCyRgA1kHXnnrQe++N+/eOUb1z7vuZeIVOza0Gf2DbCTS4BZG2YG1o5wSgM7ucw2bA2d3mVXDPzNDc978VWvQOFWOUXH5cRKNTue5UCadshUKH/EQZkCGmvAXd041WSJomjZsmUA4hhvvcnvr6eQPFVzYRbEAYgIZLXUXwaAXBOAiICDo3KYT/n0n73NM9GUMPNMBQDPdmH+Z+znpDLgpEqbQNIC9hyEsIa5gD2DzVkrPKYU5Sy4PyOAEcTigoWLL1i4wlpIiS0lyFaP58ZDALDz5mRfe137fTu3PvvMhVFKRKQEnvLoG2IZGxAUP/2say86/emPXbf+Ozf/5A93benZ1Nrlt0JqTGotiiQjc4nzhY9/mcPh9731eZcX+RGubbPxSCXJYC5lCh0CssKyUKp98YLeJ7ZLKWOdPjx4IHCXDKuRvTZdplqyOj9cNnsoCYAJsMLDNw8cuntgSBeDUjnuXNjxrCvPq/v+FfK5egtLI9Uk0VLiTBRB9w6FKbISInDdQ49u677lj8opXgDZF/qn99kIMtJPOUV9rzz4w/71IcYveu1ZB4bc3/zmYKgjI4hJItAvb3ukZmutucY9u8pffteze8PBr342/vDnt9/+pTM/cV3j9d/bafvEwd/9asn1L0UkEjIh965S5Zx8gxKAZEFM+Y3G/UdGSlVrrcq6UikEsFHStGjuoWzWlHsdUaiY7Cf3bdhR9FcFuTm+lwL1JcmuxB5UHgc+KQAGAiIBfSO7lcOQkvSGr7/mnFzghil66LAlAeBI+MFPH/rBt3734X963lnnLGfkb/3wzq9+9otO61Ld0WoEgCWDLJjDUiUO+7yWaN012Wdf8cyXXv3yYqYpSkIDCQtEAqVcniUgB8cgu1Z4N5yX3HmrGSFWJvOCZ+TOWBJHU6phkyQ5VilAjOMR1ylxbExk2JDN+05WKCUPGwVP7dSYZtLohM67bjmofgA471nLdWImXj7l3H/mzp0nUOB0XkAzjNiaykP/zy8SnlIZIJszsrVIe4ZZaLk8wMvX2hqiSpHVNPrKejAdjyE4IIOTETpJykliDYCS1qISKACIuc7jGIFZWYsvOnPddavWGDbWWiWekjeJYNCxiZA9UPUcsWb12f+x+ry9rzr4499+/6bvPm6TuQnoDNRibuaghUTls5/4erlc/tgHb7hC5k5n+r3Rd67fsWzJmjDqlugiWseYFWev3Xb7n4xCYUW/Yx+ubr24YfGIcu+WvYGJi1GLp5sjkezXg7uH+3bUSp7vZGPu1cn1V53d3lIksiAw47v1lx+GcZqmQTBl+KUAJGApYFMl2RYmjuvXoWC6f3h7GuumfP6K4ll+qiuBDGKwUKuivKn8ZFn2vvdNL3nnP7z7Hz74PZs8Hta0BSKQaZpu3rmfa2FVBdt6KiM1/sSrn7P9vn13/CTz45/1vO7as59+Z3LzoYq6Z19yddnJOQjg+ZmNSTJsqU0p5CkVEOMAtwBQrcTWWum5UjqSKdG2Y35n55rlu+4sO5mEMULd+f2+vS2iqSkoKOlJi66j3LyVnCrjoHQQeVffzv5wRDr5MB58+gtXPefSVWSUEvVEtoLBfv0793/zxnv+5wvPWbNkFTN/+cu/+NSHv+O7bcq66dCgKOTqQ0ojZ4qVl7xq8ctf/MIzFq3OZxtqaVy1MSlbdyACEAAGcHZOyQxKUCV/zdX2okt41zbZ1A6Lliajrm6HzV2Tvqi6x68AZGZX+dWEDoXxjlJ1byUcjlMphCeFL/XCQubc9kZfKYUnDstxYqQTOu+apwOAHvdWOkVsZ0bvdkKkw6zCfaehsQxHR1pxpzk5aWWjhj0QBKKOlz/+m/TZaejYyLLRZ1kACyasHxAjgyDGIxtqGexoWk+EWf2mfEHKepeudJ7ZgC/sVK+/XmW7XDBqDAj32B8IrP8I2FUOCBwcoN6etL87CjJFFo4KHJRKOqKO0jXeR6xn6gZdjaOUkyn1S7MdbSwm+QEgOZ4B35Ag1lqHutbSXPzHv3nvheefVSn3MVsGkUsVWFcG+WDO6s//5+8++KHv2yzkIH35os6zC+a27/2mGYuoNTODpQXLF3adP88d5sZMgUEdqB28Z3hH7KiMt0TJ1RWnpdtTfdLfzNGAqzNZB9iJEnf+go7XvOoZQoxKStd167YKY8gann75LwCBxRNV7RQCN+Pm89lk14H96zdK1zk919UpnIpkC6wBLfJ6O7hraP8zLr30b//+nSmY/YMDrvJqSVqJhA1HBmtJFBIbnUZpHFXBgvKc17zoUllMbn1sP6Sll1zQ6GJNDh5KduxWGZ8BCCnRmQ3VCEaF93QLQEMWAEbKFWZGVyGQAqvRujK84U1PT1qcNM4SklEJeXHFGe7XI4NRnEoPVZ65AU3Bxi1Jgjv7d20/uD2DQamiOha3fOoNr7DkGmPJGGNjkPBf/3nLN7/xi6//9ytXnLZGG/jS13/7iQ98t6C6XJUXAjIOrlm95Kw1qxhNlEZPe9p5n/3Xfz9r1fnsByM6MsBUF2R19ya2PHvFOqGxKDQD5bO89kwzr9OYGlpEFsiArJCPgDKbyGWY66OAkHh3tfSH/b2/3tp7357y/mETahkaMZxAT9m5/4D+webBfaWaRMtsAYhnjAI9g/liR3/EE3/jE9wksUniw/P95Cs8ksceM8hHfzghBGzmXp5T1Th+PGsbwERd+ald7CNOt9Wc1AAw/Z0nTwLIWpBnni3PPBvAAADbCigAnhKgGBHryWYdx9n6UOlH3/nFwT1VQxYDc+Vzzn75a5+uTcx1nf6xQdSjvvLH/QYniwkx5jQtAOohl6MO95Jhwfz5t9bul56fWpsWIDLdIm7wXbe1vf1/v/6LnG8/9qEbRmL999ect/fO/77l8//1yv/3j3sHhlJKpQ/Pe+6zv7j5i8kgN2T8VGBP1HPH/uGWoKExWxQCwjQaqVZqaZimKQAIISI9/PH3vWRxR7uxUE/eWM/YLAQmsU5TLaW0dgpnOxQCOGHuTYxNU+VK6cqdf3gwLYWFQu50t821wFzH9CdgXJ/2h2iff+1znIyKkqQyPGKjRDD0oPYpcJVqKKDWWqaAFDnIgGLV6Ys6uvJ9PQN93SOXr2ibn9nVU4mS/gEEIgQHgBD2x5qmW0DUP5MEAECoJYlC4TiOoCTSBl3hCnz1mUtK73/ORz/wg/Zwrs4Ms0AyUYwV5P5q3BjYgk8Zx3FZyN7ygb5Kdyaf7R5JF67gr//z21pa8rVaItBzs1AN4f3v/t5tt97xk5s/tHDBXCb4n6/84vMf/WZDQ0sqNGRU55LOxetWzl88d9+e/SQsmSQTeJIhNoQK6+mLcQwhmI4YJ7MgFJNF7tXDQAAADCAdCWd5mJcRsiuQDOwvpw/0VQ6UdUrseoKxnu2SmbkOxT4UmRu3jrxkecPSRp/pFEJundBU+jNUMstl/swFw4xaf2qN13WyzEftFY7L0k5S7p0A1fc0VhgrjEVlUdWPaer3xsxEpJTavWP4k+/+9uaHB2wkKVbxsPjBV//w65/e5/v+KZBPowv5qd/chMX+rKizrRHYKuFYrrVfKi764Plzzot1eZgR2ud0/u//3vKZf/tZNnCGUvXJT77ZDJZ++cXvLupoUL5II5i7fPVL3vqqER9spaCEl3dyCaXdtZ4nDj352L6Nm/t2HIp6R6IRcNgAD1fKf/Pup7342S+TQqAYdfdxXRcAAGWcJnGa8PG+dc3wkLbCskCGMO5+dDM7ssVrWAjZmG2CrBlSwRp5XzSSybfM6WgFQTq1YS2SJIyhqBaWtI0CueKyRYECsKa1Ne97CCCCwGtsceOIu7tHWpq9uQ1uWK2lPX2SQTJIAkI4mJppBcDo+o4AiKEWaSWldIRkdl2lAF0WZWPe8YLrPv2v14zkt8dDKK2n2AfIaHSGqHqwtn/30I5t/U9u7Xt0QB90vGJvNy5Zl37n39+2ZMniWmil5wmfhofp7978lR/96Gdf/e67liw6TQj4j6/8/N8+8q3GYqdWTK3OkgtXrbjwzGxLo2ZIWTOA0bZQyCGiMUYIcarmFE9KNB7MrwHspCMWEZUAKWAgsg/1hjsrukosVH0zDUREBPWYDRSjTb1zX2280lPS+JPp8jRXp392VsfTPDs9e5xpHMDJ8HqcokFH0Ux4/azbcCS/O5kBcYTaAQ0jMQgGwWgYzdjxlK7Q1lpEdBznl9/4o9Y6CAKttRIq4wSFoOEXN/6pXEpQnvSqYbQBYuawJDN8kx1dRRTa6GpTq5h7xuXZ3MXnvPGtHVcICGsu5AttXZ/84rd/8P1bAw8sZL/5vQ9uvOMPv/3ad1c0Ngrp9Fdql55x2Vve9bJS02A1BeLAEwGCI6TruIHyPNfxvCBbqnBC6Ts/cuY73v42YchYyyjq6k0hBCIKIbQ2cZQet8ERkWVUSvlK6sHhyr5DKpNpyTfkGCxwgmCRLbNFEZpYkrKOa0FUbRqS9vLZUhw+2K8ercDWkj1tzVn5gm8gXbBwjucpMpimJorLKJ3hSs242JDzNFqu1JBBEggGQgjpuAnRBbBARMNQC2NHSMdxBHHKFi07iKhEVUevf/4rfv219y+/dqSc9CQ1TDVaAeCg8j30kB3XYjapFJJ438vfqn72P+9dtnJ1bAxIwQxpKj7w3i//+je3/8vnrz//vOUSxf999xef+fD/FJs6RgB0Q+u5lzxzwap1fq7IKVWHyqQB2AGNjU05HFtZn5Lxc7zhJQAkTYKVMkEjRFjRZm85SYmtgJggJbYMVM/yVk8NP1ZCX2i2DiXTq3D/snRqvUJPvpwTdwOdxtI78fgo10g+Mu6XmXmWqcGmoXoOaQAAVihdJnMyfJBxVHsjBIYVNoYKDZKBkcZGZ71dhwMypiQp5eDg4M4tA67rpmkqpWRr2QKiGjyI3Yf6Fy1tP6UTblwGjLVqBgv/Y4Me691vbWnK+EFYiRpXrAvmtZZsQpQ5663veqDni9GGku7MtPrt7//A19vntDztijPndrZ++0cff+7l72lwGq98/bOHD4UlWXvhMy9ZspC+8qVfbV/fk6Um1/OlImNjTDFhTPTI6Rcm73zXC557xQ3IhEawIEEg8bCxFBGNpiiaaQi38tzAc8v9A2m5JouNWS8PEQBJQMFYx5BCAVLH3F8aJoB8ptCU74qjyv4tpe39Nt8CkfUHtUu6KJy+Ky/ussYIBT29/aJmAAC1RRVkXA+QKY7FBOXvcZOQjLInFqk2tVoMQgmlkIGIkBAZFUqJZA2fseasm7/4f9+66Uc33Xbzk+uH4qEmm2aRCVCzKGcb+s6/es7rX/LKay+5mhwv0QSCEclx5ec+9Zsf/uD2t77jaa+4/rmGxR233P3/PvDVrjnzKGK3s/C0l59bxJWh0kRGoqqUI50AgQLhNjTmAEAIYYxBlDCpJv0UqTiMMb7vA4jEaBST5BBmZrZgBTGhsUxSAINhBpiQDoJhNBfkaO4D3jwUL2k4EaDmKZnmLGXJKVn7w9Qr9BlG105//7FPnawXEEwtA6ahmWE7zpQYQZKra1blPBQGwI71qo7ThLMPOqZ6Uvq7f7+7tT174eWdYThB2T+bmWCMsdbWNdrMHMeJBCkcv1CoFrMZoKdiwSWOsg2kaTqqUZmCJsqAejuNMQ1NxXw+3z9U8ZraUhSdgaccp5jLXvKWl/72Q1+UoSu9nLThO97xpZ/87JNLFs05/+zlH/rkWz/63i+sOK1z7oVn1kbKpSo+c9UzLv7n83/wp5/c9tA9fdvjuCp8XzTko6XLm5552dOe94znNQSNnKQoBUqBKJhGFwa+79fbYy3H8fF3AIEQEtmVyveVLlUwNeB4yqSjudtBINfTh4Mv3Cg1O7bsh6efG7j66Zd33nbLnYd2J49+M3/2dU/bg/13futnQ4N9l18398oL18aJZpD33353lpPQ2dNeWCYhB1Yik63PKAQAEAwKcNqEP6q+F5YgqzoNa6lQUiof2CIRWUkEZMXEbOZveunLXvbsqzft3nL/k48dPNA7ODikHLejs/PKc1991uIzC7nW1BIRWauVUp4nf/PrRz7/b9+98KIV73jXqwW4Tzy5+33v/VJQ8Cum4i2c+w9vff5Vl5zxwKH4j4/sh1RHVRPWdGolgPSU29RcHB2i9bXZUzAox4YX+b5fKtW2b+k+fc3iSYO26iOQGC2T4dGpO+k8MRMSRB+snGCQ//8v6KiPMqle6LgKounvVNM8PGm+m+n3Acx1B+Jpu3QSCM9HUfjL74em1PzcGwgKSB7IMa81FidgoScCKUVYS0oj0dz5DTq1RDRbbY0Qwlrb1ta27KziHTdua21tTdOUiTxH9Q30XHphW9fcTCU2M8c5mB2NyYCtW7dWq9Wzzz57+ttH4RnGPgIR5Qq5XHOD3bEvTS2HyA4eALtvMLxgzdKzb7j83v/+Xb6p08/lR4Yqb3vzf/zkpx8XDfL1r7/6Z9+8+zMf+sqnvvnhBYuaBXF3ahqLwYde87fvfeXrDvaXrOWsL/J5kQkcz8kROYyj/zEzjsa3H94sIqJhG6cpTBgkk6ZjzSpscmSvEJ6rIEmA2QFldcJKMY+mba5nZpjrFrer8t2/f+KNr3lusWDe+PrrNmx94sbvbO///q0P//K+JIoxidae0/ovH3lTxndS5W78w+Y//fD+vuHyimKmo30O1+xIGEoGN5erK/0ZQDC0O1IwTL0sIwQkQAEQpToKU5DCcTxgIRCJmTSlsXEyhx/QBgKv6YLVl16w+tLRtwH15JXCGE6IDDIgOMIRAnbv7vnnT3yvmHc/+vEbOloa+wfiD77ni+WwQo5/2unN73nvq5fl5zngXTlPbbsvfuJQWWRcI4TRFoBcTzY35u3M02id3LAkoiRJHn5oY0NTsOC0jonXDo9GRIFTxhvVb0VG5sNuV6MedH/RUKSpWjvzSzPn5tMcz6ScY6/O2vhz3C0JH4lYfURlJ/g+JyezbYvduzvZP5Qe7JcZlzE8vK9EOjGYIyEhCnW+4K04vY0IBKqpPOHGNY9HqSCVkMjAlq5/yxUdq031kJW1nJMUh3prXcuqb/i7q4zOnkqvtUlaNtrxxYsXz/CJ0WAFRGb2PM/L5pg5rYa9lfT+vcP7YtuUDcJqcvENL+26an5SGrSWssWGJ5/c+8H3fz01silD17/j5aFs/87n/wciKwTEBkKmg9XEisz8rvYlCzo6O9ryuRaBDcY6hpmYCc3E/Up9nIyMjCADITCAIWsBYDR37+RMwWFu9xQAKAFgDRM6cVpRJBlhDEKDmQl4Wb4l5wePb9j3vZ/eqUTW9/3/+vz7/uNLN1zwssULzhYXPLvp7f9+1Q9//IG1i9rQ5W3b933nXz4XxKZmKhd2zS8Wm6KRaLBUkQROY4GRuZ4egWGup46z0mDBjAJEnJo4MkI66ApdT0MOZIyp+0QdBXqhrR3/pZZSi6GxCRCjlQhIbK3W2v7XZ3+8afP+t7/n2vMvWAYA//vf33r0sSdYBB1dTZ/88Nu7vKYyVA8ObNt44OCB/kHJ1gIbrS0QADguZrMZtjRDvI1ZD8MjvxgRdXS0PveFF1Zrw0ffWf+NmSI8CTlHjqFhAzAyHf53LCfw6HbfAv61cf9Zv6gTTSlzAkbgY+09CqZY78Pso3+P8NQEgAneouPH9dCnozcBRzCCSRj3NN+YrIZAcR2cfxy7HyRPpWaZOrQKEaVwDh7c3bWQ/YDTlBElA/CRO9EJjSGWjKyO/BKIKI1N29obP/wvN/zfN3+1Y+v2IPBWXECvu+YtXfOWDEb9UrkTdKAnNHyPp49avnz5WPFT4LZPJiCZ2RGys2segEir1UKak5JNxSxY6PfZxNPyire89Tf7Pk37IVXQ1t70y1/cs+bM+e9523Oe/eLl9z76tF98+6bvfffnf/OPb4grYZgYP0ASLltLyAhCoEIERhoN30Gs92KCmlLs3NVDqVYFB0BKlQMYm9+IzBZGV/NjLx8Fk3leo9cTDvgCi4FExFTYEHg4rfgYCCQGRkBmONed93Dzrgf7Br/7mdsbc+4LX3hR0Wt4/Wue++ZXX5fGoSDh+z5JwQD3/emJz37qqyO7B0uRXuj7z77wDBC4fUDvKJXRldkFc6SUQGzBejZdlm2BUQ/mSVQodWEWE8QKhqtxHAvpACgnJWZmL6N6nujf4QdnndNBYCd8j6Ogq4QFO87n6u7nQeD/7Kd//PEP7r/0qiWvfu1zAeRtdzz0ja/9RgZ50dL6+r99WUdz6533Pexk8o2NHU/srvV2g9PgR6HB5W7/odCJdabFa2jMWGupjs/NU4yTKbjPsVOSiDzP++6/3vngr9Zf87orrnrt2qMU/Ukatbe3tra3jGU9Gu0djKVAAgABUMz4Gaj0kZZSWWZmFqQAgAQxWzFqLCAAsEYWXDHp1vAvRTNh1lOdn5SDz2SNf9zjGdkATngndQI2g2POn0C1oJatoMH+hmxNtWRIp4wOHvYwkydQICImiQagxUvnwvG+mSP9/m6TzQg/m07UetVhiMiCAJg/b+EHPvL35eGy68hCLg8CIxO7jn8ivf1zkWBqbsoLsnygzymVso3FPZXo5wcHcx5uOVC+at3CVW+67uF/udHTwrIt5vyv/vut51+w6pyzFr3pdWc98fCW39740MUXrD7rvHPjGIiQGaGu7EJRn/OjCWbhaBnGzFrbO3/3EAAQy2wm097ZUksThcIFFoIQYQweblxsWJTKk+oVsr1HYneOXCFdwhKYaH6gtrLKAQAQMCJrW35+9vSRguob1p9/16/vvmXbZVefdcl5y+fMybtuLrV2oBRt3bzv1l/f97tf3k/Gr9r2GA784xldS1qK7NC923dXajo3t5hd1GniCJi0phUZd2HgEgAgiMlU6IwCCWNrKhZS5SSyIqCRpFf3hMlms1vv/dm37s6e/t23u0oCjcdjHMVeWcL4iloAkuup4aHKN7/ygJNx3/Km5xbymb6h6uf+7YeglONnXvj8y+d1tT66dYM7p2lwl9m0fWD3wZonFRaMeWZL+cxFyX/eJSvhkpVdhWJWa42IU3H/WZHruiMjIxv/b1NlT8fdX9t8zSvPJ3UkGBcLngxbbtRHFBAALEDGgfacu3sYDBGzIWKCFFEKIgsamAgFkwDg0FB7oOpBlH/RWIATpKOY9dGREccezyb6dxobwJSBYMfy6Gk2BxPPHxulNWmB9T/r03c07AvHIeRO5AN6l1wecBPbKlANJQArAIWIgAaAT8yBYfHSuUHgJclxjEuZonvfd+5eclrredesK5VKox0cUwohA7EgEIKh2NiKglOwzNYC84kgHf75SLJZtqxVZVRtaMg9uNspru3AoGdnrZTNUFhe3NTbdN5FwfP2p9+5x1WNIuuF/eEnPvF/3/7qe9ad0faqNzzj0x/Y/P2v/vT0NWc6KrBaWAsgJQoQYlTDP9VaTUq5f0/vQ+s3+8Xs4LC57Dmr5i9sisOEHQYhHSaFo36iEzUWzJYYmoRoYrk33wiuAoDEwYbnLkj/c+/49CECZNMVFl8erPyGfWgwVHfdvnH9HVu+1losdARu0WWdVgZLPQf7aiORG0DC/S35+N1LF9yw6MJSHMtQ/HF7LyWQWz7HbW9LI8OkfKkvLAY5BSmhnFINRIyiBtRdrclCYcmlXXd/e72HgUFFMmvj1B0Y3LCx5+GHtl1yyTI2ZkbeASykNLfd8viDD+192tUrLjx/hSH44n///LHHt3rZwrrz1q07azkRDNWchL09/ZXuPeVYc2ZFI10+r7Q05xxgd+MBlJDryuWUE+lEKBzNqnlypLXO5XKd1+Z2//ixi9/yHKfJJuWZDTmoxyLWPygrhAsX5jdFB4dCbnCDBCi1KZEGdgQEDAmhYWIADKRa2ujDX82Eml6/P83547oAnbwNYPQMi1Gddv1zH/ZxPF5znwoSQGLUr/7wb3ZkjbWHGKuMchQeBg2gObEYqDpNgz8zTp7n3f6tLb/90aG77xncsX1wUr9+RmI0JIzGOOVEszHAf/0rlVSKhafNyTRkSKd618EoIetErbak+oez5O7cUxk+EHVecrVYuwyjAWPRb3E3PrTnBz+9D5R75TMXnHHe6scf23frr3/vOb5OhIEEpUZmZqj/CA//xggBAIX8+jd+OTBcFk7G9YKXXH851FXhhhNmQ4JYjsUKHG5tPSVjPdtwW2dj5DtaQqk3LJze1HB2KwAwga17bZJKKF6qg3/InLu6SahiEhVMf+nQjg07n7xn46YHdh7YPqQT32nIOiq6rL3x39uvfE3hOVVNOZjz8P2Vx3YPu1m35fwz0fNBsySn04NLm4PjRqFahIR4IIkGaiOv+5vrl76gbagoPGvACpOEopSnWP34G7dOSC4ipviNGmlQiiiOfvnTB5Swz73u3JbGwu/veOLG7/+u2JArdLYvP/f04Zq2Gd96xSceOnRof5lLcTDP4+sW98zLDz4y2HvLTrunL8RkSVebcp1TyDqJSAjxto+85LO/fuszr78krZjpC5/qqgXsLKrrVza3ZKCkU8OkBAtMLJQJKsSaiLS1tRTO78ysbP4z7ad5CjolhYtpLZYzVCvN0AIMMGHzzUIct9wZlTj7MN3Z+rdOXggIrkOLHGlOPAEMk9nSztKuXRtrt3yx+7Fb+hw5upGqJ5ZDpvq+dixd+Hjom6inZjxqYv/1EDLEcTx/QXtraytrXTm0JdN3SKSO9VzkkYZADNV4047+2MimFz9dL2nheMiQdhR87zu/3b17oLU1//yXXsGycPvNd5q4ooTQRkl2CJiZidgwgwWi0V/9o9dqoRD4hzsf/sY3ft3Y0j7QF11/w6XnnLdiZMRKKRhElHJiWCAC8bgMqEMGjb1VIObTFs9bsaiRKDRpsnfD4NI3LR/oYWsZQDApssBgU2GbjfsP+rxXicULEANP2GKUNCZJY5Q0JoVi/xU58Y/Nl7zLecECWjHs7A8sjhwof+7eu6smbl7W1bDu0rBUcxVaPfSaBj8nkIjEtNkmUoJDSVxzinuHwnbV9r73fHxhlxdzKZOvtnlmv1eKwLnjV4/903u/gyRAAiEdNZUm2pyISEpc//C+9Q/tWLSgeMH5ZwyMRF//5i06BVTZVRee3RvSzu7y5h1D6x/f13NwJOqupEWfrlo6qETv7bvDx4fDLftwoCSFXbCwDVGCQDxFUYT1qBflyq6ly4REAj3pNBzfLAkCJqxYfLKc/q5n+KaDfT890Ht3f+lQmEYGlze0vWx5V3vOlNOaNgps1pJjgS2j0V6Y4qLG5NpFRQE4PVrFbBn3qWX0s/XqOe6zU52cfg9xxNUJ0bLMLN/1jndO8pEmzY4yhcSeeH7S46OTno/+OQXGPU5nBD78yHjoGU518xTD4lQseay1Z5290Gs7VFw5/II3nu66GbLjueMn5OIbbQbyWFACgwBAgONbTWYECjQTmlI7gZOeIm3yDfnHH92z6fGtnqeMl/c656euDCzXhmoe5E01NrKaUXklGmrbdwpj3Yzfs3ugsalw3iWnNzT6Gzbse+KhzWesm3fa0gWsbZDBccQ+JMb6v8RAzAQowA3c2259+B3v+jTLpuFyevb58z/5z28EcAFISNWXxpAQKOFJKYVgHv+GE98xEqCjnO7uwbvv2CEC9pT35rddufXArnhnLQuYioiQhEVkBiGMgC7OnS3bznPbF4viGrf1PGi7hFqeI5ZfKBe3qVxVRlIdcmSrSr2PPnHHneUBI/1VL3+Od+bZjq7FxrywPX9te95OHO1TfK8d5XCvpmFyS9Wo4KlO3z+9mG/P++fMaV+UcS9d1+Qt3duzuXzXnVseXb9v+aqutrZmzxVSCiGE4wil6jhgyEzWkhBCKfGl/7zlwQd3Pu2a01/86st/eOPdN910L6Ccv2qp39ZajqwJYcf2vvKBiowhzSi+bkmpKRi8exS7JogAAGNDSURBVL/ZE1k/8DdvE7v3usq+4Q3Xdna0GpuOZbOc3Xib3J6HwiKgiCUbARJZ8mTDjwANMQBurcS/OtT7RCnujbAcu/2R3FVNtlermyvlnPJXNOUWFv2eKDxQCVMiRBlrTI2TYPX8LvfVKxc0+DI99W6s4wU+VQkpJ96JswH4nInYmLpWMWmP5Dvf/g6Y7HPO5AxMydyPOJ7iHj4lAuDYZKxPtQCorz2FpbWrll5y0SrpCpogVydluAiglJOkhohcTykpq5VYOdMt/ydlKFs39Q/2V1tac7Np7iwFAMsg4w1Xar/7/QNKuYY5aOmgIEiQi1XNB/pdFTdESTQcBZ4voooeLIMSnnB27z102TXntc1tGhg09935eKV88BlPv7ShGBRyVirlKKGUkGP/1n+xsd3dQ1/8r5/+yye+QwJDoxYt7/j8f721udAca4vKOtK7p384GdHzmnORIZTCFTjZyEchhU31wnltt9/9h6GhFmP0i154ZnFN6223bZhXyo9GayEIAmQiAZErEGXRqE7ILLD5edzYgS2B8lOPUpk4oCXl0hQ/deC2X9b2hpG75ryl177xhaEZsRZe0pF/eWeDYTHRwjX+vYRQiKP6kN6h8pOaB1gkhOWkMs/PCWQlRaNyMyyj2Jxz2oorzljdXzFRJDZt3PPbX929/oFNGx7ftX9v/+BAqVpJ4thEUcLMiBwEnuOIPbt7/u1TP02suu7Vl7Yv7PjCf/5s587ulvlzu1avrKYsU8SY0hQy4CaVRFywAJbP7f7jIduvvYKHtYr34PpqeXjR6a1vfOPzARkPL9JPVgBorRFYgAPgGqmtmDJNJiJ4Sjw5ktx8qBJbJYUQSASEaB2BzCIy8snBEgqxrDF77pxMQzZJuGw4KXpwWlv07IVd1y6cixJiY1x5Iu4e09IJCoBJCprBEh5n9tRsa5nsEk4qP9TEv6eH9Z/UIDyNC9BxvYNOJoLjZOo9JaSliBUgetIqoOM7Mo2MjDQ0NgtH1WrRV7/wJ1eJt7//0iTUU0XijOcSABCWU4nujd9ef+vNWxsb/M9++XlPWbcEIKSxPv+iVe3z2wf7UjnYrXfs9hsalUTyhBIVeQjLXg4cHUmZX7DWdlfiyhAHum8o/tkvb193wZUGgoUrOp98fMfb3vzu9rbGliY363dmAy+X893AM8gsMI6Tarm2a9uhrVv2HTo00JDPDA85yy9o+NfPv6W9aW61UmNPaHZQp48MjuQHzcUr5vTXQglSuOBJJAYx6hg6RpaVkEsWzf30Z17+ytf/sLs7WP/4wasuPf2Mvz39f//l7ud5S+bUDCMZoSQbJJuJLCImAoViFJSKRCNKpsCgJxyQ6mCovpH84V7oU5HvnqY++6lXLlzY9MdSaYmTWZ7NECOKOnbC4VVb3Q3BElWjuCEXPLpp1//deu+q17worhELU9G6Yo0nVRSlzcLfEvYtaGgeMmFBNqw9++K7797p5iBJ6Xe/ezi92RBRJuP7viuECDJuIZcpFIPGluL8RXN69veVSqWm9s78nJab79mza1tPQ1uua/m8shaCQdRSEzupgdTWnGUtxWUdh/500DmoawVHMTd2j1SrgwbMBRetamtu7B/s8T3nKHDmEx46rusCEkMIAMp6k/ofUz1SkXEgNr/rqUhkIrSjykCecBso9P54sFRL7TXzG67oXHBBa0eqAVl4jsy5OrRllySIv1B2sGNotnpvccxTJ2xAnln7plxrqiOvja9nTlAtOCnznYIjT55S8Yj90QQvI5gQC1pPbgujwYE4yQ5jmvdDY0XNTEZMsooZVUOAYgAwdQTn8WbjZGr9OI6/+O+3LVyyfN7C7E0/uXv9g3s7O1ovv2rBqtVdU8EdExGkriQAL2W0tVrt1l/d+cQDyaXPWkyTdW88mOuY1k7+7SftPSMICUS0dNG8K69a+7Uv/6416Ar3bW1aNJeaiigEZ/OGEmmtBAGIxivYhQui9QOe4zoSbvn1oXs33SdIN8xfXuo5sHvb0NYNBxGR6XEgBJSIghUqqKN3AqMIAqdlTjZKhp75mgve+bdv7yo2JWyF72swinB7qKtB7rGH/7jGVq59zkWVUpRIV6JUoj4SJsQEMAMIq83TLrj66582b3rHjYNVDQjPv+biO+4cet/PfvqO9vPOFXNyVkaSmAgRFKNBBs0MKAR4CK70XVTDNtqtq98w98Q6FsNu29rw6//2vrOWrmWG5xYz9ZFjecyuwwIABI6mhEHEJEr9ANIU/+kj/+PP71ruebVyzZHCCBEZ0g74jv9gby3MOut8r4mdxiahXL19+/bmbCtx7AeFIEMAAlEQUZqYKLIjJS37QtxuHrhvBM2gUH5+fseGXr1v+/64ErYu7JJeJ1SjxGpNAHHkgopyQX5+88Edw2H3iFIKANyIkq070lqSLZqrnnGBpUSMrZ5HbfSzoWN50L6dNDAwsO78VmQQwPWgrcPjra69Y4mCFOOGIR0ZgSgB6uAaEsZB3hgZIZEgUd41XCsE4sJm34D0FRMRAtVSQAyA+ch4gqkaOqtuPYU0k6X6jJfzs6iOj3E9mViUfNfb33nUkziKboLAWI8ROYoLHlc7dOyfU9yAxxY20U94qmKPW93M3lC9sqP1yUd37Xjnj7ph0tp37Ngxb2HL1770h9/8Yv3ggM0X2oYGan19I1c+c+VUn9XEkXvb/XLHHjuvyfH8jJe58PJF7tz1L7nhyo45c44VGzhtA2ZKiABgrJWEXXNbb775nkT7bJOE0lz7fDRaSWkNkI4RrVBCKkbl2koJoooy7BYag7Y5Alm6stbbTVb72bwXZLyM52U9P+d6WccPXC/j+0HGD1zHVyhlVE2f/sK/WXPD8+c2e02IwxjnHDc1lDDf3l8bsMpW0h994j/OOeey005rTGIDzI4jjvSYHNViEzNbWr58+brV+Xnt2fY5c5RSF583595H7v/JY1s28QF23GbT4DvooXRROqhcVA4qB5VEt0Rmgx25Ld19S7glrlF1xJx3Xcs3Pvfh1SvPC8NYSgkTYHPGHfZHI9UkMgMRekKydD/2T1/64fduuuQtr/KXLSiHhoUsVcOCdNqD3P5S8nBv6YzmOQ/89Pff/+YPbOz88ie3H9zZ4yEIJgEI7BIiAVm2IIQlau6Y39IxN5Nv8qRj0xCl17ZyWUwmKqX9W7Y4mXxQaCMDOgyBFTMBGLWoy2Sd8r6yYwUII5VUveVk84O1sHrltav/9rUvGSoNeY4zOnZO2gfU9/3Pve/n//fVnz37+gt9V/ExjHfUCRiEQC5pur27lo7lHIDxtEhj35IQgNECaqKytotybqBGX/2RNr+ZJM+YbVdmrQKa1eIdjln+z9yR/9g/ZyQVpv248p1//47pGTqK43D/Sc8fawyY+oYjrhwVKHJcC/NM/jwu4Tik17Em5VkVNEXVuVxuzbq5fYMjmzaUMwUhBCahyBWjq5915lRNdSPr/+lhp1JRq1ZiYz4KKx3F5kvOeWZLS0ucxpPUO0UDZrVwYKjrspCM7ZrTuWv/9gce3portEbRcN5vDJqLTBYF6UoVmJRCsClm8lIYGhziVKsg67e2CxAqmzWlgWhkCBmt1WSBLLMVZIEYDJNhsiyAHWBAodII9MI5gw6vavU5pZRYKTwQ2scrcVWzP6fp0H1P3PaNmy582jnz5jcnNQ0ASsgJ65KxrzfGjhctWtTW1laH5i4UcpddsjY03Q9t2LehO3zIdO8S0SEb9UDcr9I9UNskKhugtAGGbkl33FHdsXmgP0mSttW197/7qo+//yOtLV31OJWJvhb1fD4Td6jMgCBIaxDq0//6f//x+a/Mv/jctW982QhSrMECjtTCArmeVHftHzmtkEu27PvKpz6/c8u+u29/8NC+IQHZVFtiNAyawLKxpMkaEAKRg1yupf00QhuVRtBo8pym5ctQqmS4OrxnV5Dvkk7OJjFZRQSaY2wqOJ1Npf5QVYiEkwouAJUeuSvsOyi92ic/8vbOrpYkjaVUY9xf1BnfsaNlhlNJKZVpK89f5Z61bs0U8wIAgBilgIM1engwqmdzZEAAtHWPPhQAgup+E1j3fOWR1DZ4Ym7GmUwAzGhMT05IU6T0O3ZKTVv87NOz4ORPETONgWLQOEDGrDjQ5DJjDDl10sbId07YAUzOYev7gFluAmZyZlIZcEoEAJyADBjbCRwlCU6JAFBKpam7bEXnnb9/fLBfRGHa2NrzgY88a27XQmvNpOWQ66RJRbcV8bRFVRgWQsVsyxxp1mIyLdOpMXqgQBSIjCCYYdFpc3/7u9vD2PFVQCPlTNsc6SiERLCyFQvAIBGsCHJB2ttDYSQD121oQuU4rkdheeTAPiFQKAWCpAKSmlADE2siTZSyIYHCUY7sObApU9JixVonJ9ZknBFSCsTjlbCk9WBENVe0tDRuv/WPv7/98RUrF65a0RlVE891xvemk84SHCMibm5seM4V55994bKoadO+Uu+O4XhTue/+yqEHqz0PVXseGTn06NChDYPdA3oE/KEV5zgve8vaz3/4g5dfeq0Q8igvwGO3s/WTxhhwnTgx7/zop7/2799tauu6+ON/RwvaS1GNQDJTOYxaVb6nHFdTnhNkbvzXfxvpGWwoNrjSr8SRzMpMq6cKxm+U2WZVaM4Wm5tc16+VhwWKXFNrrtgRhkPhQL9Ja15jY2beXAaGSq3UezDbvJgJyGqJksjYjHQ7usJ4hKvSl35oK46XqW59RO/bHFX5JS+/6PWveO5IpeQoOdaRuiZoppAPk5IxZtGiRWvWrDHGTFEOAAAzSgFbS+nuqh4v2QLXPefq+D48qsFFrI9FBgm4tiGo880ZCoAJKtmphvpxGfcJLqQmXbCLCbxlDNTkCF4/9Xp/dhXVPQ5H5epoHyboWyYc1H9TRgIfdXyU086kJuLpjcZTBRWPXZ0c1IlPFD10+uqOe/8pyfZ5uHCEJI1amxo/8omr3vsf/3LWitWvf9HbTlu4KE1TxsnrQmS45AIGSIEV5QAIETzAabJRnjyNjp5RxCZevWLp297y/I988sdKrTAcl5/c3HzuGZI8mRW2ZpI4cRwpjcGcAqGAUXou2RQsGSa/odlxfUEWEImN5wVnnPusVFcqcTVlbYwmY4d7+sMhi6hyxaatf/yTOmPp75suPiPrz/HcfXHUl2pXQopGGMSLzlj66uu2fvPmv3vLpz780de96hVXU8qJTpXnMrOEifk1DxuWxqPTtbaI3tMuOe9pF5+7Z+/+jRu2bd+2r693sK9vIDY6JVtsbOjq6FwyL3f+mcsWzF0YNLYwojE0k4FUz4Pt+N7mnYc+8v/++0+/fKShZc6FH3mdWLesNwwd4URgHBQEom+k2m148byuu7594+4N25uammpRmFg687LFHXNOj0tKoTtqG2MJoPb3beo/dBCEdFwfhdJxBGwZhcpl08QoEBKlcBSxkeAiYpqGIh+4rU0GNUbSZxNTOecX4r7u6tYttizmL8+8822vjXUMQIgSAE5hRsM4jk/gKUJgFlRngZOwFEiJe6KUYNzparqZecJs+s9GzHY8gcdsY6fqe6DDbqOTdWcUJ3WiToWPuPnImoQ6LGKOwXI4guHW3UiPgW+cXirAJIIEpvlzVvz6qKphsll6YmJgVo/MkBAxiqKzV53xw0//V2OuAAJrcQxyRjlXxzO1AjzVkcREIASgACBKw9C86bWvWr9h189/tqWldVHt0F5/RyEzfzmSdpsD3RcntSib8W2lxHGKUriNeZn1bULC2iDX5BYak96D0gkAhE5TLzu/ISi2jXZEIEN52f4HfndTUi0rkVXNTXt++svcsq6Hs2e8YBEMJBxbjqxlRwIQ19KmFz97oenf+4NH3ve+b2zevO8DH3hNNuvFhpCZgaWQAJNHko9/SmMIERcsmL9gYddY0gg6HKEHElhYKxmM4QRIjcffTvmyQBCAIPYV/uqmuz/yb9/cv+Fg6zJv1Qdenbn08tLIkFQeMRogIciC6BmuNM/tGn5s06Yf/TqTz8dpSkQXX33FmjPX7dneSyJJdMQIDIKEBaCwVkGQUijXDVLWaZgACCtddHPWokg0C5cB0nDE8QMiIiQnF0g/qJbLaASgICGwlFY3PwKxZjXwzx/7UOfc5mp1xFEKAID/cqGISIBAIBiBxlb9PGYMqLetHjmCiHY02qvuOjA5/XW6A40v/8f+rJvuaOKdk+r0j83OUOf+E+9EOAyLfZjo6BQCCDguNg7LD67jQE+U/xMaNFXjjvuWj2sPmUkY3kzKnPTmqQo/gYi+kwn/O5aQQQnJzJU09nPZCGxEBqXAU73VOBVNpTpbZGatNRr454+8a92qhrR8gLUZ3rotHNivtUYU6BCmBJbjgQGbaBDKyWe8liajNSUWHRU0tKTWGJNK8OKoWh7ZLf1qbPprdqBmB8o84Lpz1l56jZOV2iZSytpw6cCvbnmwr7ahYsqGBGJton6MxfxXvHXRS891bPyd//3dc274p9/f+0ROiSwKREzY2plYBJmtJWvQWrRWWKsMqZRVSkpbNBYZCFkAu5NyRkSsJ3IgFpoFEHsI2/YdeMN7P/7Gd/7r3if3N5zfsOaf3+Gef2nfyBCja5kSMrGx9V8isz7Dhm//JEkiKaXWetUF56259ILBIVOq2lgjobCoLDoWPAanWqoKoYRwPS+fphUTJQBggJQTSCakGKQAPxeHAyYJ09TIQk7mCyYxmBpBNiKD2hnZtSE+dChKe9/7gRddfsnFIyNDE1wv/jLcv82fsIvl0fB4ruffZqwn4iZEC2wIBLArkIAnVb7BqZ6qp5Cm4XvT8ElmPor782hmi0ken557TGk95sNZAMRRT8AxrP9Ie4KYstAZ9G2G7+IkP+f0j5+AGDglI2w0/nXCb+rsyPSXHdMTt0FJkrQ3Nv3Hv78712XigdCE1b6tDxgCHQsJ0nE8G8dmeATq6Xyl4xXznBobRWTQzTdz4AIhsGVS4XCNkqKAnC+zLjqOkMRJLr9gzQXPQxlTYoJisfeuJ7vve+y+4TAhdgVEFsdnhQWuUdj2lrfOe8fV4rTKlj9uesvrP/OW9//P/Xv2gSMkgUztUfOBiAjraUaOYhwCWAErAoWsJClllbJCkpAEdWZ0OGIeYDzQr56tkEkoAZ4DPSPVj/33N294xXtu/vrdgqNFrz73rC98orLkjCQ2nuOFbCILqSFtTEqcsnDyxe47Htj72OPZfE6nSceiBWsvuzAKw3I1JIuMrmGfGIW0AqhWi+JqqS5ylHLTaFinUZJEyneUpygN2+c1E5Kba4lrAyaJkUFkC8J1rDZSeNJ6jrJh79b44KZyVHnpKy9+82tviKq1wHdHkxGdOuXP2DudVp6MQbYwc8sEAWCBLVpCsGI0tUb9Z4kI2DIMpwQAyPTXyeVHO3cMl+BRjJrRbEcTJzsfs9SecIBHvcXp2eOJuZYe4Qb6jr97e/3oCOk6mcPl6DFOrlSZiR/OTMKG+Xg3z8reO0OfpROg2ZZ8rJfRqMIdD1v8hUDlIFlkrmdBgXFn1UnM08eUf8qpXqFOo8Zi/tyz1v7897+MhyXYhIZG/LbOVHHKEob213YeqEMXFE5b4BQb495hwa6SMotY3b8FUSBLTNnN5Vq7FhGQENICC0QAspZzxRYV5HsObjNE1hXVvd355aurblPRzR2KaykAETIqRraANtX+yjNyi5Yncbc9eHDzvftvveVPuw71d7S3zJlTkMggwAClBoy1op63C+SYx85ERejoq5R1A93hN4xjfxMASCkA0TBpIuJ6bi+ULuzbP/iNb9/0kU994baf3VMbTJpXtK/+x1c3v+o1VvoijZlRW8PMxAKAiVMSThrLfE/0+A9+5ISRsUb53uUvvi6TLyahWx2uJpGGeliJIEYmFkPdB0qDhwCFny02tc4bHupNK5Y5VtkmP7cw08AffffFD20eKh2qRKVDzJ6bzYuWQqJjIItoUs7RQLn25P2Dg+VLn9P6mY+/W5BAQCKqW/jH3sP4b3T0HkUzHy31RGlTT0UazUCK0hXYn+jBhIiJUVpBxGgZiEd9QK0lS4SMzJRqWlt01xYDQoIxNchRauTpx/AUNDsj8JSlTL3exSNumKG6f/J+4ZElH3GMR5yfzMXoSC8gOqJf8p1//44j7j0Wa+GogwmrrGnccqY6eVz3TZ7i6sm4/cwK2miGNGvRggQ4cYlzrNsZDA6ED9+3v7kl47pi6uZN7hn2lJkGRqN0Fs6be+FFc2/5009re31D1WhgB0KjqtrSxocoTPwgL4STX75AuE46UmYbK+m4Wb+3bwcZYgk6MMJRc+esQ6VjSJAVACAKidKQLTQ1CnQHenYGmUJp6JDjF1oXzfMc6EtiDcJWauD6JIhBADAa7Xa1zzvnAmgEHe5NDkQbHtrxi9v+8NDGPTUddbS0Nrme57NyGBHACGbBElDU09AcRiKp/3CicB13m6jfwdYYQ8Y4wvWVcBSa1Dy8/smvfPOmT3zyS7f//KFKd+p1tc174WUr/u4NcOY6qpQ4rLGU9UhErAcmAAASOy5FIrpnw4E77/KVqCbRhddeuWDFcqs5raUjAyNWWxQIzICMIKylnt2bdRIhikJjW77Q3juwjchoW8u2FpUjV545/4LL5/3p4V0Du6pAUa06kG1o57wAy2wFG4cq+ytP/L6vJz7/8uJX/+ujBa8AAMQ024CvmdNXv3HvLbc+csa6hYE7WaJZHJcxAgA6Ms7DQ5EUCCw0gCZKrCULlpgsW2LDViBqIgn42sUNWQVEk3Oe6empFgBHFzrRYezwnwQwpULmKL3/pBICp3n8qI5MchseWdcRMkZNaZhlPsosPHbpiNKnd/KZ3lA86VWY+ubprb7T2G8nvTQrm/Ofh9LE7Ng6MH9RQ2NzS5qYqW+cRcLL2W6cJ30nBFAtlS85/YrvfP6rb37v+7s3AldjPHTTkHQdazKNnWQT5eXcIGPCmGIhKEhUGjhNOaczLO2WnoueVylVy3GpIBvZhhRYtgAGGBnQktULl19YGent797h+4UDd923+Jw1hUwnW2srtvLwhvyVlwKrug8CIUASjzhqzvNf1XrBFT3339pz1z0j28Pf3nT373/zwOcX/njNBSufcenZ569cvmBuixswALEBJespW0ZlQF2nJMYcJPCYNyAEji5IWAyXquuf2PSnhx//4933b3/sUK038TKeu9BruXhZ1zOvCpavLbHjVauAiJ6HWPfpq792AUAoFRiLFgYfeyIgkRjbuXDBinPOtikwg3ChuaORrBzpL8VhBAKlckeGDiVR1fUydS/h4YFdYY9GckB4aDJJJV8aEUOQOkHeWhvkWquVoagy4JcXMKXSl/HgHr334d7uytOuy/3XJz/YEDTEcey6rhCCT0Xul0mpr69v7969MxiQFkAUXXlJW+aevtBFSSiNBIkWQIx+EWYkJIbBxL5iXkNX4GiykxX116sUOrJ5YiJsyQytvkfcyVOVfNzaxRHcfwIUaP1gciygUeZ4jAwAACbEWcL289RZYsbrPTF2fFy/o6ea+GjoOjqZiud05p/9wpUNjUES6+N14USSHp94N5mVA+Va5YIzV/76e//1qvd/qmdDkCl4EJU95XlBTvdUnECJjDLdZTIG2TPa6dm7Z2Bwi20YZutSJUDw1z/ws1XrrmxommvTyKBGcJFZCAnMgHrZGVfUyv1GJ9HAUO/G7V3L5qIWVAnjJ3b4q1a6izspTcYVqZ5rKrUe1dSy4Lo3tZ33vKHH7xp+6I7hzUMH9/Uc3Nb32+/fVejIL1owZ+3qJWeeftqyxXObW3Otra1BEIxpghABgUeLYwBRz0XMLJkBYP/+vn0H+rfu2venhzdu3rJ737b90VDIIbktTuNZzR2XnN92yaXukuWp4FjHDjCBACQk5vqnYQVo6kYIAEAiGKmafQc8zwsxOfvSS8iKNE6ko4Ks7/mZJLR9+/uIqC6MSgM9zCClBIChvr3GpN6ZNtPYCsKU+zcUqkn3gfwDjwwpla2j6gaZxnKlF4cesyx0eTAZ7E6jvhe9avnnPvYxz/HTJFVK1cPi8ClLoPjh9z+/t7e3MTcTgH4CgItbfQD60+CIsYFnfSZBYOvDnhDKqY2JLmrJXtWZT+kp3LicDE2ljsejz9P09x/2zZlxePDhP49akR/PCnu0cmnXlh1H/D0N7ubhMzS98ufEDACj+4wZ2AmOW9fMbz5xNDqsox0eIwBQTp5gb6rcvEd/LgVgZtyww7VP5Q9wSnYAY1WwECJTyK/fsOvVr/28U1icQColQlij0nCms7Xl0vPLuwZN2QjPNbGpZHd3XDZvzrwlcTzcf/CJ3j9sqt5XwYy76qzLOzrPAyAtQ8EuosMQIrjScQcP7Xj8wV94qd++atWVH3jdgTTpHar2//Tn3ulLi9c9XScxC1tPHyuEcKS0FKcavcDN+Fk9kugdj+975P7q9q3p9j4xAqYmjJCaoXVOY7GQmdvV1tZebGwpFArZXD4TBJ5yHSWkRJHqOIqisFIdGBjY172/t69veCDp66mlVWNGYnQgaM/kFjc2rZrbfu7Z+dVrqaU5BAhTrVgigKT6ZsEyMwi2KEgrG0n0QyRga0XGH7l1/eBnf5Iq27Kw85pXvJRGs+CxTtMgW9i/eX//gSFGByWkurb98fvBxEq5UZi2nqMveN7zWxaeE0kuhVWH8fE7bhve6Hadd4YXJX1P7KXaiI6jSlJKalU2iWQbVcqve/O6//ehD+q4BCDqlmQeCxT6yxAeid0xNsr2hPr+UuXxUliuArM3Pvj8QvlZzc3PaWkGgGQCqP2km/7pqp1qXhw3ZQgfxxgL03DVo89PJwBmwv3He3FsCeNvcvz7Hvm44Alv71gvnqO1dRMVPtPwAp59fNb0+4CpNgEnUNERr2PG2KWzImZmsIggJQKztZoIHCGllBYszxBnboyODG6Z1Q79z7cPqIMfWOZapXrGmvnXX3/+l79+f0PbfKO7hQbBjpJ5sK6NAZ2srmi3aWDla1+UnTfHqWHRFfPXXGQuG979x4d2fOcXm+7/lTzfnTP/PGnZiBiZpJAANk2qzXMWtXctHdp9oNo/lJYrgR8gmMJZ64YfW585fx0Uc8BAKADJAlkDAA5KYxNTjSrkkzr9jLVnnR8N9FcP7qzs2VTdvSvc0xceGCmVDg2PiJ1btpFBYBRKskKUwiIxs7TMYMlYNCQZXIGOVFhUmKPcwmx24fzikkVtK04vzl0YtMyJXa9sdKqZmV1QYjSCCRiYCBCBnaw5EPb+7/cL163LnbncpIRAYCjdsFPrJHXV6nPORs+hMBFCSCmCXHZkYGhkcAgAmNFRsr9nAJHB43LUf+4Nq9dc93LONkdhagQwu6GhjuuuK/XcNrilv6mhCK6LsXAcz4cspQkjCUIietpllxcybl+NhbCI6q9WW7I4Gyzws5c16O1JMhSVI8OeFK2+WJtf1Oq4ABwRAJMQ4q9NYTsV8RTz/7jeiVNdmpT7T7w6STTAkcVO5dYPdQEwDWuu/w3HEwnHKWGWtz2ldPKVMgohFEpJICphKJGLhbxAjmthmhp0FM6+lnG75F8NjQYrHtHIOrICGzD6Na95xq03P9DdvUe5FjDDJED6NrRstVCMMi0+YyU05XSpFEgEz480+dnCmpdcs+SMFfd+9ttP3n+LprTztAsdgwQ1HI0FtQw0f8mZw/uHkpFaNDDiz3cEyMwZK62gyoOPFa+70iYxMAAiMBAaUfeQYsOSWUOM1Gtj1eC6zWe1rDm/3RiMS7rUV963R1cqaXdfOjhsyyGF2qaGDRNRHVROKSE8BwPXyWdzzcVssRC0z8l2zXOaW0Rjs3WVlRhZW9OGY4NSKrAWj1jfpbGWxYIZKNd+/2jPF3/lzc3mVnRyQgKJlcMjtWTr/ghNS1fHvKXLImN8JQFJKLTa9u3pieNUsi8k6DSulYaJNdvkwtddfvrzXlzBTJKUPF8hoZsNqmGofShc2NX/yz2ZTIZ9hytSCPBlIHNFnVR0VCsWi80NjUlCnucxz3pF8uckzSQQFnvOYtfDQlPd2x+QALUhm9SxH/AvFK32lNE0qv8ZiuqptUmz4yJqXETMli2eEq39URuOuj5kVsVOutI/yUZOSogIQjJb14eRgeinN+946MGNtZEqk54zp+GZzzzrmmvPTRLNXDvhXTb+GWXAOATFUZx+LAxl1HdtYqTy+Ksul8L2pjmf+ewNN9zwMYVrQEREVSF1MlLjVBgTuW0ali0Lw4QJbEsmB9jRUPS0EyVJYfWZz/rnub/85CeevPc3bhA0dSy2FsDUUb2lMWmQa8x3dgxv3jG8d39LRx6AbK3iLZqPYVj6/d2ircVfulh4PhtLVgNbBjDC0GiOAEQC1kKbKjMbgZAJ3OLyxnkrFUiFAgyx1awNkQFiQAJiCSgEOI6DrmIpwBEgkARqoMSkkrUiYg3A7IAgBCawCILJHoZXEQRQ/t2G8m8eCR97snBOR+c/vtrzmo2uGmtF4OiRqhkYJEWLVy4HV0mdkAJXSW2p1Ds80j+i3ByxApa1Sk8UjmgTXvHiZ3e9+MperXM2yfhZwSSZpZQgapUh43Ys5Ny+KExRIjFIBiGE57pJTadGtzc3t7e3a62ttYdRH06QxPF3pXjiOeUlAyPVECSTxbQeLFB30frr2bVMw2Fn64n/Z+vUWEU47dUj8gEc4QpRD9kYx3ASYweAWE/qcGyJJ7m6rz8iAODIZ49s1iR0Mm4NR5hupm0wM5OBTD7YvHX/xz7x653bhpVwpHKUlHt29tz9x5/d98CBf/jACyXVfAANKMZE2tjzU1j5kSeaQGDcfjDVQDl6pvER/5sVCZSj9lCsz3JmJsBRF0YGAMFivHxmZomCCR2patXyheddcPXVZ/zk+wfnzGs30qZR2SUtBFhCNXduYHk40kaAW4obGjM5Bws5K6yMqpXqwtYXf+IjP3jHp/fe+yf/spzb3k7GElgY8wBZMHdBedvuSs9QuxACGEEIBJnNWUsD3/k1KLdwycWZdYvcjjYSiGk1tQYEokRgwbKu3HUYWNSR+20cMQsGARIAUAp2EdEd9fYB0IcHkWVjwBIyO4xCCEdJlA4jEBMg2DHsOWXRAoIjyVHJ/lrloU3p7x+tbD6gA9P1hkvbnv/0xILRoRRAlqSQyZaD1bASNGQ7Fy2yCCiAGRPNrnQO7DrA5AB7xmrlcKnUGw4Nzbt2zdxXPHs4LLnooCAJSgghAVIDUWjISGL0laSoJlwrEBEx4wWDfUMmjqrV8qtvuKy1rcnopP6ZD4/wWY8SwcyIo4riXN41mrS2UkpEVg4AcJKkUWgRSUop5CRa5rHxc8S4ndgSZJBAjCCZCOruMqMgHKNZLqaYQxPn19SJ745Gr5l6Kh3T5qN5PR7LbMSRZ8b1P8xcXxYgH7YUHuuFOXnDjizwCMfSI2s56nj8PU9aUZ3bjB2Mdl9NrOlIbfuULYIplPInrAiC2UR2HH4bY4/UoctOfhNw3DsdzxkYrH3sw7fu3NefyzWMQ/Rk8hmpsr/4+T1BznvPey+15RTEjNZcUkqphJQiTe2fOfoXUdYdSIiILRGwFA4JrHMTxfUwLdBEhAQAAkd3A/U4UsFcLo189MPv2bzpLbu21PINAaSGrJUu2kiKwIksR1VdUKqaRHvCtMN3F2WKniE/H/RRzSzOv/hjr/3uG/9992P3zrvkyqyf5fSwsjLb3Ow1FEb29JqYEQyhYxGtAGdue/ubXjH4y9/1f+9G+GUhe/bizJol/tJFbmsDUFL3KyWjAQxIIQSgEIgSRR32khgYRr10gBkQUDAwSuQ65nl9JhMACQCWghQAWzApACALQDQgABUJixnXDulo457q+o2VhzfXtg9gQLmnL1793Gvs4iURpIGOUiWJhCBGlOGmvWYkbFm+uKG1lYyRggCU52b2PLmzMlhx/MZUk+OpkYH9lT37cgs6lr7iWWVIXD8jmZBAkJUoSDl7u3uSFEhTEqVAqHSIJCUgIkelShoNactzWhuuv/48sgmROXlwQ2ttoeglsd25bXDrpt6D+0rlUmKtdn1ubiksX9m1YnVH+5y2MCppkyDLE95u12fTkYbXI26oh8/8VUGnHFfdfxSnhsmOZ1vj8a5OnvpxKgvz1GighFiHY6o7Zo1vAkZ7NboJOK4MqB/MlgXPdgMhpl0Cz3x3Mn29rqt+8oNHd+8cKrbkkpigjtnJiIKsxqbm1tt+u+ElL12ztLNYS8xM4kiIqDQQb3myb81ZHX6gjv/AKSVEJAYppeMqIUSq7UCpWk40KNeRriuw6LnFjFeNalIpRmKwMCat617Cvuf89xf+9bWv/6fhAU1lJ0gJpQAAM5yYmnYt6FSTgjhO12/vX5jxmjJZaZO5GWVq4qFcU8cLn73/Oz/ytj6+YN0FMGG0CNcvtLZXekZqA1U3cFJEA2ARKNVYzLe+/qW5i3aX7/ht+fbHyrds8hY1+Ks7g1VLglXLVS5A6YIUQluyBrUFRBR150Kq77MmdL8eAWDHfCnGtswsCZgIRGwsCokSXVc4EoVQQpRGRuIDg7XHtlTWb4y2HzK9sShC5vzGtmde2XzRuRFKkYSSbOQqScKiUI5nesN0bz+62LFgkfKDNKwJJQBEeSjct2kPKM/UcbXj6tCh7VqYtovX5ebMAQZkW1/HWWBCsa+7d6CijTGgZTpQM+VUuZ7VWqEko6ulPmaOYv2P77561dKVIyPlwz09caZJuVzuycd7fv6jJ558vKdaSTNZhYj1Zb4x/bf+anNre/D0a5Y889p1uXw+SfQReTpPHQkh9lVqJGlekJ/hnv+oENxZ0RR8lmb1CE17dSaXnmpi5im9gABgNH/nMTIAZyMDJj15rGA4lvXP6r3U3ZvpyDKP24CZ3DmRkkQ/eO9u5SBT3VlzFFFPp8bzPACMo+TxRw6tXtRUmy6M6zAFGe+733z4Vz964u/ff+mzrl1ZjU4EUPeESCADoGAEg1gqm58/uPuOjft391VSSpQn8hl3+eLFy1uD1S3+BWcsFjYBRgvMSOMm7roMOH31sje9+Tkf+fD3ioEFbcERAGCGQlkzDmBKbAgkwMGB6k2P7b14WceZGbl/SN92aGjT5qHc6cuaV64a3Lkt39TS1H4a15fpIIBFrqX14N59YX9JzW2xo4gNyAhoNKVRsHJhw6LXh9s3jfzp4eqT3QPbevnXT4g5WX9le27pAm9uh9fe4s1pQjeDQGANpUaQQJBHQuhCfQ9Uh9pmVKMDCSUACUnCdSRIilNTDpPhUmXn/tru7tq2jfG+waS7ZlF4nUHjCxa0XnRB0+nnaklpVaDHVlgjwCEWTIlSOKTLd22M9/bKfKZr0QIiQAES2ZC3/dGHrEEpHZBKoB06sK802JNfvVgv7oxG4rbWfBRFju8jQxSnBw7sixOII4iYMhbjg4Mi1Jj3bDkCJ9VRmSiqhXjxxe2ve911tZFEAJ6S9fKPvrP+NzdtjiOdK3hNXjA2RywAeSCM8Yf6+fvfWP/Qvfvf+LZrT1vhJYkmO7pNPFXkoBhJzXcf31PS+h8uWtniOsd95PjcY2r9z/Qen8d9ZOKxmM3NJ9CpY4oSU1+a/KSatJpxFsxHojOMK5bG2LY44ezB09R7wjS9uerY8qdRUtUPjrrafXC4t2dEOZAkmicY1qQrDbFSIjH24P4RnU7eiiDjRWFy1MlVaxs3DToLTiumKSEdfpuzjbabJRGiGyc21+Dd+dD+f7npsb39VUQMfMWsUi2qFe7p2dG/ous+rv7uoU3vfcGzG5rZhDEgkRAC5LgMKJerz332ld/+1i17dxvZc39+wXnSFzysy93DblcL6QigvpUUh/qjG/t33TgGB+0FLitoOm9NefOe7s2PC8dtalukU8tgLZNfyDleduDRHa2L5jOytYl1XEZByCAVxXEslDr9zNblywsHD4w8uany2C67byA6MFi5bZPMee6cvNvRGMxp9rva3JYW1Vr0ggB9JQMPpRhHuUEeXTrU/Q/IWEoSG6dWk+0uJQNDSXdvrbsnOdQX947oSmwqse+kTqPTcml709mnF1ee7XUt044sRxUEqTxwNGnEgImFV1FCbN116Bs321Ckwjbkm/ONjUkYSdfRMtjxwMbhviEJHlpHMESVvqHu3SKbUcvP8KW7Y/cBpvnSUeUoCSvVodJIGgWJTiOdOtkgrYa8rdvzPAk2A6g4qUEYabehafCDH3qbRDfRqXAEnnTQ71e+cO89dxzK5b1cXom6QmCUJLOs6zeUAs9r3rqx+3P//H/v/dCr5i3xEqtnMxKn8F+sB9CNTcDQ6MBRC1ryx+X+J7agnu6pyUzcx62F6uaTY24+hVuBY+4XMy9kHBHoOGqHukHwSJEwiqkyjYf+VJuA0TJnoDI6YTrKkea4HH9WTkRaa2NSZst154WxTDvMxGQB2Zgkic1Uq58Nj+1sa28sFrPjZ6IwOffMpeeeuRQAjKanKkh/EhKxTnMNme/8dtPnf/hI6AQZ13OkgPpiGMACAsK2bd2trY1P7Ny5Yf3XPveul6xdmhuqDLOLIABt3YUI4yhqaS7+/duv/5s3/4/TLZzsrkzbOTYt1x7ZJXMZJ5+hMGJXTngl41CUIoxk+7qFbQ+2Dm6v9W1/gqUqNswDi1pbP5fPtDQP7+uXW/eYYlYsnkcmRRRct1UDMRswVjiut3hZ52lL8BnV2qHdw1t21rZvT3vLpqeabtpTJUQpVKBkU5YLgcr4MvCk7zrZAB0lPEcqF1naVNs0sUlka5W0UjWVqgljUda2qk1sUArAVAScWdBQWLQwt2ZZfunKbNdi8vIxmshEmLLrSGRKmVJB2UQZGcSOm9720NBPbgMXXOVZkzR0LRZeLo0TTwX7Ht7Ut7tbKk+iAwBpUhnavy2KKvlVy2Tj/9felwddklV1nnPuzcy3fGtVfVVda1d3093Q0IANCAgKitIgMoJgjLaDwGATgwMySDgiIIEYasS4MSDhjOKMqBOCwLiMOgyLsqrQ0NL0Ul3dXb3UXt9X3/bWXO49Z/7I9973lsx8+Zavlu468UXVe/lu3rw3M+/vrPec+VojVNo98tBJhXHwO4EFG9UjFtdxqBk17jiKVd/Zs2iDWlg/GzQCZrFy/Jd+6Sduedp3baytFT1lxIwdmYOIjot/9tFvffnzjyztXmSGMDDM6fk4rSzM71lfXv/Qb3/qA7/5GqegpmXWiBdgJLyr6L31uddLK1vShJ32i61DRztGFJCI0Ljn5rwzvV9xaMvEy+m0c7rAvRWf2Qf3YxiCLgzlCFtLvkdDBzw/7y3u9JorIQIBMUg7ClBIwBgbKMcc2D9PpFuhJb306+//45e89Dm3v+VVzWazc9B2L9Lt5wDt58KLC3N//vmjH/z4v1KhUCSNoIxliKG/HYtkWU6eWC57O0+cXnvbe3/vo7/xs9ccnqmEgVggRcKGBVyXGvX6K17xfbe+4stf/PRdapa8HftBz5HY2jeOlZ5x2N0zz34InVqfrXWBjOBI5LgLfOggHrtXIuf8Q0fgMO7cdW1oGsr1vNm52vJKtFw5849fW7z1xTPf9YyGqQEwoAEhhUqAkW3ENgDBUtm9+ZYnPfkZG2HTrG5Ey2ej5VPh8rI9u2rWq7ay4Z9tNoKQg0iYY0XWWguxTxtRwAJbUEAaySFylTdX0Hu82d27C/v3lPbvKx4+VFza7e5cCrUXCa+GDTIVRxwHURwVCjpMBeZQc10X4VSj8em/rd55RBUWBH1EspGZ2XUoErRCD/3T3ecfPFEqzoZKcYSuZyrnzzTWzzteoXDgUGgh2GwWVKlBcVIEAbDIQgIukSPQ/M4xPL3ulT2lsf7guVrlrIezlc2V9777JT/+qleur627HhiQSbI9ux4duefc5/7uwYXFkjEsjETEnLqVnUVQYLa86+EHTv6fT979725/dr05ihKQj5SATOLP6Kl9QnklZZHu2KNBBMe+xgAAYIdt7h3KCfIcaR9PGF6277c7IWiqBtBBcBTo1MTGdoZimIAH5PcHDH7N+ZmwxeLzm31gOBug3VfNPOd7DvzZn35rfmcp5Fg3YgTNEomINZFyzS3P2RcEQeIze8Ptr9i3fwnSqaX2brNPKL4DD5xc+29/cac4igeqrAoAEKIAEjFq40fl0uyp5fV3fuCjv/8775idCa0Va0EpAmFEtEY8z773fa+748jX/RNra/KNXU/9IfE8bAT1O45GV+8pXr8X4uLjW/UsiYRnLZy+8761UrlYIKWFo+LyA/c54pQWlzgCt1QGWHHqvGPX3hMf/V97Xrnq/ODz4kAkQEsAceAnIAMhAIfV6jooxykW9i/IwWuwoNgGYEL2G6ZagY2maTRtw7dByKHhMOLIcBSCskpr1IpcxykWVamgy2Vd9NTMrF6cp1IRSIOrDUrQDGr1JqmQlNKOC4oMozYgFpQxkdbgzOiGaX7j26t/9Q+ybqi4aKwvgY2iUHnOwq6r62v1U98+0lyrul7RWEFSLGIjf235Mbfg+ailWLahlZpt+Bt6bsGbLQuAJRAncC2TAf/rD0QnzxQXSoWS5x951F/b8MqL62dP/6e3PfvNb3xTpcpOoYY0aw2i8GgSWLyEuVXx5vN//0BrzTO2ob+vt61lGxsEoiiaLe/44mePvfTf3FieK0xLBJQ4sZ6AxAUJR60KPzYjRO7LnLy1nNtw1zE4dK90204QNh76D/dAcLdKkQv9M0hDF/ANRfBUHoDJp4waBTRF6tEDujW+LuafxwHQnhEBgN+g237y1q9+9TsnH2uWF4uhNWKBdKRRRVbWz1ff/rabb7xxr19rUCtctick64dufS4ANBqN3uvZjrOuR5pISSs36o3sUw1ZkABnZt3PfuaxtbpImRiJWouEAEBBHJBvUQQsu5FFayJrds7OP3Bk9ROf/Ozb3/ryarUOwAAKhQUQCBq15vXX3fBb7//l29/8AdwsVB++Qz3pqYqcyA+iY8fq6+ulpX2lXbu4IKSVQuJGo7lRXTt+UqKg6HqRFtNoluYKxqoTD9+3tO/a/QcOm9L8OqK/7i/uXVpBb+2v/nH2rm8VXvoD+panCyGDT/E4Uem4RoXjGOFQAsMGBblqQZE4iOUSzc+qw+LE965tjsI4q6G4fWU5RUTEMkgI1goD+9IUEYuIMqMscsRGs+OK8oQjC8xsXA1O0T5yqvqXn6nfdUKJR56DGIhYx/M8Yijvr6xvnL/vjIBVqNiiIKBlAFk/f44jY5RSqINAwLMKUepNrlUCBaSUo11QhGc2assVEpjZuZeDytkHvwOVall2ry+v/cztT33H23/ab7igDNG8WIPxPp5R3hNsZ41XGtfXg/vvXQd0OK5X3iuXdPwAAAC2FVMLAHHA8Or5yn13n3zxrTdXqvUeN9aIYs2gGNQ60jutwdUw1KQ8BBbbjDBN8Jf2hpXE3hiIQDKuMqkqwB1wT2ZOw81ZffUAfu5nfw6GknSXzGgHAnbf615OkT9r29AMcRnth37uCvvrFu1HyCjX+SnmBWHk714qPPkpu+6888sbJ8SLilo52pRNBTY3z7329Xve+7M/1QgMpnRrrY3NDv2XGP4Acg015YSebyKgCJu++fAnj6w0QnIUoUsAhEiCBKiEyRq0EZsQw1D5oWoaiSIxVolsnN289danawdEhIikvV2TSEVB8NSbblja73zms5+TJkbhOi4eIKdgI3Irvlo5H66u4EbTLlf8E2cbx083zy4TAKCgdnl12Ww0S7NzlhkBG5UNjkzBK9c2Vi3r2asWaudXOAqoGkZfv8seP4U7ZuYWd1oqRICEhCgoaJkBgYiQSKhdmkSYCNGyhEZ8g4EF38R/7EcSGBMGUdQwYTP+s5HPJrDGWLbWQqtkQHwRJA2kjeew61LI7NuIAJB0wTQi/y++eP6P/rb+6HksuuI4BOJbPyrADTd+d2NjRUR7BQ9boWEoCIgkbP3G5sbqaQKONyfoA9cgaYpEh9ZpkqpZrNRhvQLna6YWueXS/NxssHaidvK+0oarNksV9egvvOvwL/7cOxsBG10BpZgJMMD+FNd53isBEGbwPPf4o5v/8JmHiDpBU1uxf927VZi5dYhZRJhZmI21S1eVn/mcQ0EY0UUyAo9PHfTPbNBzoCeNF6H0o39+H8Bwgb2H+Y3F56Q/TGiIEzhe59wjR7Zk6x4lAHrSRF9EB0AfEXCeBM3pxh8SAUQVi/OOwo312s1Pvf7DH/nF//FXf3DHHY+cX3YJm3ufXXvb933vbS//ad8QoElM/neJkIhoRz362PqJMxXtACOCFQIBNiJCwMxsbQSWVWgoAmEWBgIlZLXrrq42zp1bv+bwzjDJIlyvbbz+J37Cb9j3/NIfzh0nv/7FuetuKZTnLVFkrVQiW1kBElEEHmmtWARJSeCjYRAbhmGc9UUpVd1YBwvKKXLUEIPF+cXG6jK784LGfvtIcPSY/7Qb5l94S/H6w1FpJgBmCRVGjnaACBQhMAgKMAiJZSRC0kQ9UgICALIC6F9LAoIsQkBsW6EVTtzQikUKSSwELhTm2LWNM+ebX7uz/qWvyfnQ9RbLxR2R34iiuu86pT07rz/05LnZpdP3h15hzjQDIiQLABCPjNlUKytB2Cy5ypgAQfHKOdy5n+MqKRShVkppzZrYpYJIY3P14btNdbkcLVarfvnqRz/43h/7kRe9rlJviGZALRAhELIDyAB2vESBRHDuTMVacV1qP2QBQGGUVsXYlq5AQiwcb6mLtyAxsAmi1XN1Ybxo5eaHvf8JRzvWnuyk/NjvBsdeeRwhVX4fKtoPZwY8RKUYYnFqV4HvazN885G0C9VAu0AGtuOCpOd4D4ymxdsA5IoC6tnkPb4/gEXiNO3dN2KkHQAMyCKMJAKAhK6nTcC7dsy9503vWX91Y23tfLEou3csLJaWaj4YNX4ioAtGRLR8vhGGoWiBSAtHzLHNwwqLWFYGwLYysCuOnUDCTCAcmqheb6Ii6N3n0LaSqXq1cfsbfnxmR/iBd38iOrOjHn0d915L87uLhXlxoKl9LQxgrSXLoB0CpaFS4WoFAG0Y6EJJBKy1joag2XALjh9GQaU5t+cqYzYaqxUOBVURrLZ3PdK866hz3d7Z5z2j+IynwK4lo2YiU1c2wsgAACoARTHoCyAyd5shpFP4BRBAbT332PUKIADMFjFeOUYAWClErZSHpCMw/pETwT99o/HNO2m95jolooI1Qa3ZkIIq7p07vPe63bOHTagiv2mt9TxncDkwG79RVQhRFIGAANpHjoVULswU0JlnUYBNxYh+I2och/MrzfWKCUzRXnPCP/b8l1d+732/du3SjVUbOcVCaCJhCxhrn5Mib6MeBUHoFrx2sjsBlnSbJHYCRYh0vIhIwQUuWQGQmHE9hzMcc2zvQu7zG0s7FTOll0nPH/E5qiog7UwPedE/XRHJxwDacdMw4BPuUTV746ty6gFDm2W7bftySAyyHxHp8IC+W5AWq9pvUMKumyhkQZA5gGBmwVnYdRARIxuetzWlAUAuTcGnj4LIVJZXd816VsAKx1lzACAiUm2nFgkASzx1ay1a0A5hgK6XkOVCRABaQTV+I7rtlW/cO3vde973+yfvDd3wodLcGX9xkef2F8q7jbIWGcAoARvM8fKKOXoPN31Hec1GraQdQBLQ1c21+fmlYrEYWQ6r9fKOhaX9t5iljdWVB2qrKxQUSLSjZ8Kjy2eO/h3u/Gr5psPzz7x5/vrDwZymkiNiOYwgNLEkSkSkoMfW39YGbN/631oaiOgQIsR/reBnCh8+1Xzgseibd0X3H4eGeDMzWCrbKIo4jJx6af+O/btv2j3zJHDdJldAhRK19pdJ2zjQiqcUQYClpT3L504wgABqUNYoOnZv5GhwPVKKBWtBnYMah6EDToFLtWajedVX/vObnvv2n3i3KhbXTQ2QMTKx5hQnO+rMcLx3Q0SUQogtPK13vh1/01VPqjWFrnm1fmJ0PaVaKSHGiMgbiybYjZRh8Ok3/Q8chHSwHtvyM1T2z+/szWMaGrYPIBV5ezeIbSkEJMCjAvog7A6N1YEurO8+t2vLgu1ugwJCOHQkCceTJAhBFZtEoyiCtuJoEfrL2VySxMzzM4WSA9ba3uQrpAREJA46jCtLxNNUiEoxGFmYLy4szIjljM6JqNmsv+TFL7rhz6/7tY986O8/fX9wyvFWl3F+ub6wYMszDNo1nmtVuPZtCWoQRUp7VhBsFPlNcguktOsVvWJJBLUmDgIOLTm66O05NLuvuXvl/Pl7mmu1oOZr5ZVhxq6G9h/uPv/Fe5avWihfc8C94aB33b7C1Us4UwKNwsxsSSAxg2HLmUaxpweBEEHFOYhBK+WUpBnyRj06dbZ539HmsUftYyf53LoDji6XYE5HJjK2GWh/5+591191/a7S4YCgyhUMySUHsNAIqib0uchsDCGKjW3mDABKk2hnz959zcZmEATWsjUBWiRrqVkFBoiKiq2IFrsQ8tqae++Lf3TxXbf/wjNvetGmbfg2clzHGBEQlLgWwRTePmtlfrFARNbauIyMdJLCIoPQ1oaAtkugU4QkntqBQ/Nt29Glhf79gDgQ55PQuBPwM0r/Y8f+T4j+GddNo+E+gEGZursEQR/yxjygR2SOT5kwBf80+olr/qVNcOgdeNxQZPjgVbNzZV1tiOu2n1X7mSJLnDYtFlGFt6wAjUrz5qfv3r17wUYhpL9hzEzoNqqNq3ft/u/v/sDfvPALf/h3n/r2Vyv2eKl8ikFWwYXIhchtPxLlAqJDxMxBEDikZ0tzBa9MRFEUCYiNIg6Ndkg4MsBOYe9V+68Kdpxt1B6trq/6dd9GgEpr9LzNwP/mg7V/uh89R5ULzsGd3qHd+sAOZ/8OZ/cCOkQFl4ouKhWnjgYAaSW8jHc/sISGfR9CG6xXzKnV8NS56NxydPK8WV6DKGLDjlsozC1FElojZKUwT3uWDu9YvLrsHkD26rBuwHfJsQaNBc/xGpWTiEhKcww4XWRZkBHE8ZxFR7G1ptlsBmGTFAOUKpV10GccTyuX9hySZz5r98u+740ve87LyZ1dCyJCF6kVU9CXMhMgllpGzcnTil00ER84tFCecZtN63okItgV1c4cEevY6C8CAgws3PYMi8jsXOGZz94f+BZRjRz6cyFpKPon8ZVBNMcRne0ZHSYL7NjbuG3NxhQTUHq3yUnixtQAUOJyuDJofJfM+NG+y0+SSG5Ef0DLFpTYEWL/03784X6HmGHnzuJTrp/5529VyG1lgY5DQFrLmqWzGUwESQDQCgtbe8st+8vFwkbgZ772zFBHpRsCiPxjP/Cj33/L93/r2D9/6V+//i/feCSECCL3+P216jlY3LE7jBpIjCzWKgTlaD0/v6jcovZcG0WOdq3EGGQVKMsEGIFeIVEzM3Ozxeft2dGoBqcqjTPNuh/W2I9Ak+sqtGCl2mze/UjjzgcRRVyCgkszri4Xabaoih54DrkaHBREYAORtWEkjcDWmlxrcqMpTR8jy8ygtSiN5AIqccjH0JJfmi3tXNwxv3BgtnRQ06y1bFRodA2FHC4KswhYw416xQoXZhecgidAYaPe8jKjKKUQrMVYcwSl2XDTSkWoEti5iv/oq1538NYfevXe8pMWZnYc2FPauWOpGUnTIEogFFlGJXHQyVQjDZCttVftm73xpqU77zgL3VjDyHGit/YeGxAUsTEGdMrO3PC0pcPX72w0w8mAcQqUiol5jP7QVv27HL/Ifak9qQ+FB687ia0/f+M8V0xrgw/d+xCkU0aY5tbXlBLBLamqfbtzxoZmH8k1nq3PnNQhpQ1Gcnc+lLabeeRyriQ1YWZEVEp98Ssn3/Ebn92xA4114nC+WD6FtiwpIhpEkIBRxJKEKPDJj7324P4D8VaGlt9vcKHHshVJK+UcAADMF2YAYNOvNZtN13UffPDB3/rQB7/8eZ4rLkmhYcLI0TOl0q6ZmRksecaiYS5o5eiSsGM5Up52HM8pl6mgCVwRo9pRPPEwWKLAb/j1SjOo1OsrQVA3htkSsrigKZZRLYsVaC1q2ZppvI2ARBAFQZBja6ElRkRySClFnvbKTrFUmpu7qlReKpR3uG4JSJgNGysiiI5GYjYmtFEQhGEYBvFu2JBAiYmMCa0xHIVsrYSGrWEBUBqsAQrCoFGvrlu7YcISy/pb3vW973zj6wrRrE9BhGIMi2WFyNBKicwgBAo76d1zU1rjOISPmQGxXJ7/5h1Hf+19nysVFi1HCEohSpyqv53sk+KcTRyHGykAJtIb67Vf+d0XPvf5NzV8E++cGHs8o778uezg3R5KHtbJgPEnjvmR9JxrfUeGInhOVpH8E+NIJ0pK+ywGkDdyH/txNo0HwOiIn3rRlK+JPKD3OKX1IzkQ/5JiA9mXkGRtJw7bJw/xze/731//dm1mVhnTA4siogSEUZhBIlSCMrN+9uH3/+JNt912W2cjWyoDyCQiCoKgVCoFQfBHn/jgBz/yRT61Z3ZpXjl6bn6HV9xrmJFEUUFCF4BAsZBFZRytFTmgHfI8xyshKkImZQAtCAp7IB6KKyKIkeVGEK0F/pof1IIgigLDzBwZa21cBrKLLBAiMShClDhVHKEuFotuuVgqlr3yXLEwV/BmSJWANCoiImuDOPAJhRQoALCRMaEfBEEQBMZw7HgW4fgNJCIgJdawjTgKI7aWV6ApgW+s2EZl09gNtMH6abv/qZu/+qtvevl339o0oZWQwFFKxdY5Ow1ZP5sBiIgAWYOlOfrwb3/lC3//6NzCjDFGaSsW0GoRBEYUFhFgw1YzGyTRGleWa9//ivK7f/Wn/WY4+XiGUlqQYX//Saaw4egPPbI/STesZ113PPSHHMDd/9OgM4BHHpiIjKYBJB6MX50MBgAT84Cx1YJuT3X7OGX0k6gc5hnwSDdw6pSi0CS0bDEAQFfrk2fO3/7LnzhxypubL4ixbKy0bMoMAK1SZYiKy+dPrr7hNv/nf/7nBzsclQF0SAmU3dIdd33tF37nDx/8UlgozFEJvdL8bOmgh7PoGHIMijIgAqSUp7SHiAIhooAipQtIBe16SjmIgmQAfUArTAglQq21VkoREUsgbKy11kYsxlrDzMxGRGJfJSIprYm01lprF0kTEZFGKqAiALJgAYxQhCiISkSAlYiAZbFsjAE2QRCEoQFuF0toIXYK2gJQOCsUBP7Z5TP3BcFKuI4+157/WvdX3vruZ17z9EZ90wcr6DikoOVttWNj5eALkDCkmAGwEmQky6KiEH79V/7vA/dWywtoDYEFZgAWii3AUUG4BhgIF5TCzTW1//qTv/mR2xYWD1wYBtAaNmJ2PzkZQKKi0G386WqZugMrIywnv/jf32eS5N4OXUhG/5GsQFNjAJCE+5CbB8CIoA8j6AF9PIAyOsmI4rns2EBGSAgKMPNMcebhx86+60Mfu/+bmhytCy5oBdBS85GRAwrWfVU+/fLb9v7yG25P7GpsBgAAzDBbmmuub374T37vY//zG8H53cUiypw4M7vnvUMaC+JEQibOL+86M4QeK0SJGG08QaUQlNbKVY6jyCMiRFEaW3HKwoAhIhIBolLKicEdUYGgUltBkzbe29guKiEiACxgeWtraFziE2NhMMZ9GwVRFEWRZWZqFdZs+8xF4oAoQCbopNPZCotsNBrNysnV9QdU06mtmtnrl//DW1/w5pf+R3e20LSBAeVYILYRESMo4WntL0kFXGREFFYMFskiFjyvePLcqf/yux879q2lubkFtohSF2iCCFqXGMQ2QTw25Wp1/Zqbz7zn/T997bU3VGq16YxnStTPANLD9rtvhTACMklPA5FkZjOqsA+50R9GZwAj+wAeuPfBVhRBmr93KFh3mYBy8oCx/QGQBfQ5DUGUfZXsSM5J7EIXzKvctrxlthEAAIXIRj74yU995msnTh9RjtEKlIg1xrCN9OzaDc+y//ZVL37NC3484mpGP6OOrTM8JSCoANU//cvX/uvv//k3/7E65+xT5QbOS6G8s6QPEmkkSxodt0DoiiCCZiQAlpbzqWXBB0U6NhOhdhwv1gAQlUgEGCEixkYeRG7HsHVc/Z0iAZ3XGBFBNLAwixVmtrEWAWyMMXG9dREEwdZms66AiI5HFBERhTBOkYBoEaFgTK2ycXxt8x4ThGajHLrLP/jave9601ueduDZNViJGAmUQrBKiYiywmDjhItT4QGpknLrscQsihEVxxVz1pt/9KnPfu2OMxunygpmyxS56CAXxTaCergBG3jVY7f+8MHXv/onD+6+br2+rtRoo5ycAQz20KMW9O/zoGzA3YoOQk60/Exi2R/aQ8JPMpDlP9P4M5S19PsAHrj3wa0vMlYany5YT5PKB50BkA/xJ/cJd3YFtw9Tdp+cD6nHVgguXHBRvryJSsB1+MyZzX8+euyrD9yzvrYahuHcTGnPnj0vetr+51x9087Z/T6awJpEjjI2A+gjl5Qf1f7gLz/+8T/98vqRBc9dMLNNcaKdc08qFhe1LiAoVAAKkJGRQFBQEp8CIiJZIhAlihytSkiOUkophQqUUoiIfcW8oc0yWaBt87XWWjbGxOajlgUmjoIX7qTD6tmPkkAsAKjEicIw9Df9cLVSPR2urWOtVA03bnhh7a3/8Ude9YIfF/SqNiQiB0khWWHLDMhWhOLi4lOiYQyg5wgKKaWE8dzK8pe+fue9R0+cPrm5utYAC47LC0vOLU/f+crnf8+NB55W0ybQRnN7M1ruHJzbwQB6H2yq4zcZu9vlXwh4Qtk/D/pDCjR3Ekr35/TLbfrPaZ7aYgDdKzm/NtBxAnc3yOkQhnwC9Uh6AORTC7J/zckDhvY50olTp+4lnXk5RoCiU/bIDYMmxk5LYUQl6ARiQ4kASJAT9/VMhQEIgkUg9OZFPbZ6/IN/9sd/99f3NE/v0A45HjpeqVTaNbdwyNElBiuKoRWpCgiqayt6yxeFFKeoUl2xz21JH0naOwA68koL2eOkwxAnAuqslng7YWwsolg9RIwFckRhKxybd6g7n0T3fMEFto3g7Prm/ZW1E05TF4LSZtXqw6d/6ief9ZbX3H5g95M2o0qgGi6QiyUBiICZzVaOWJnmhtr8DCB+N7R2rdFlz0FuRIGpV7lRD400iGjXrj1Fx2NiX4fCIVswoBTKSOxqEgYwUhhl9q8JaoR0tv72o/+EQJ94pDssjdPcDIkSfQ4GkHIQoE8DgK71nAEZ/biZyQBge3hAfjQfmwdkj3DU4eU5a7rUt6ST77P0tLcIAEB9e4uwnfsvKbvAtDSA9gDIQ6cgcOTEkT/49Mc/89ljlQeUV3QLRYXazM5dWy4ddLw5IYyXSdyZgEUhIOnUGyAEgR6c7wT9MMaJnbYG01pB8WZgUp0pbUUSd8mz8dbprRXVno0IUlIikEp1eXXjkebmqULoqHC24jf0VWduffXud/7oO669/km+SD1seKgUtqKTGbC7rnqM/nDRGABo7QZhKCIGwqJyCsoBIGa2TEIIylcCLJ4giFiErN1VI41nkrMmgX7aOtLaB9PXbEKLf+rxtqTPaVFGaRJ9kv0nJ/oDAB69p8sENFBFOpf0nQTolw4PGC+gaMtglJrZYkvQGcl9kpO2XUUYTIyBDIxJ1+26GYPj3AYfnrVSLJYLjr7zO9/82Kf/+nP/8Mj5h5050ughlY1XLBVm983N7CvRTisUQAMwUCgKtaV2+VZ0oIXssZOg5TOLZ9eXFiJeQdzOCdF+gRMmFtv025CgAdosCKWzgEk0WGj69Vp9da16EpvntB/Z2vxmELp7Hnnpyw6//jX//nuf8awqb5WFEATFxNhaF9guQrUd9zY1CihFM0PEOCcECggyCrXVEQJCYAsACtEiATBCT13rScYzXvuhvQ012nS94pyO/t1hQll7AvIcTJP9e37NFyc6iPXZ6A99DABaboD+4Q4BzYHy5Zc4Dxjac+/XxN1kMbV4QDZYjwflF54BjEfbl/0UUWkCYHv02PE/+X9/+bkvfWvlgYJT9RxXeQVwZjyaKZcK+0vqgOOWWRmjA9ZB/GahaBACkdiWBeLE2A0AiMDEXbXJOvYfgDbkAQCkMH5EjM0/SFbEAiOyAiGFDqEbmaBSO7VeecSvnceg6TTdZr1UwdXyDWd++GU3/syrX3nz4Zc46DW4acXgBFUbOzStKJq0901we0vUTZEBjMobEplBKyEG42AwqEhiPrjUUuy5BH/oyfaTbPzJcBrnQ//egz0Xx/vvfgC6sXLLBJQw9GSgRM7G+rTjF9EfMMqJGQwA+vxzOe1meegKAwAAQRALs4UZ1zTPrm184h+/8Ldf+OyRb1fNmYWC8hzPxZlQZkm7CzPe/nlvqejOAgCTWBVFFBgQFoUABAYRCZSIxLBL3ALfzgrqLL3Oy0kdz3DfnQMEIBBFFNciI5Roo366Uj/h145zsw51T3zXj8KovHHDLfDKW2/9see/4vprlgKZ9aWJFEEcxjSVW7TNDGC7aVoMYBKzT/dX6sTe9O4ETkF/AKAxbT5dR1By2f0TRp7OAFLmiH3HWwxg6ztiNg+AQXzHBIgcaoW/9HlA+0hW6CoA5OcBQ38dr+WYdDkwgK2xKnJFlwpOs77y9e8c/dsv/c2/3HnioQcbfHp+BuagaMJ5X5d1yVkseXOuM+/SgqPmHMdxtbbIlphBmJmRGQwgWzHCiEJEfVFh1McAoM0DtpqJQgBrxA+qfrRSr68E/qqtN3RTqFZumCgqLO99Mj77+df+yEte+rybbtk3v2RQVyNfoAlSRLCgQhAH7TZu7Br5OV7ODGAktSAj7BKlK+V1f/5nTuoqyW6Wjx90W37iDdjJjUdkAPnF/9YA+hgA9G/taUVW9NymFB/ApakHjOcD6CLO0aY/8GFyVeAKA+geK7TeVyYirTU6an1l9avf+OZX/vWOO7/z8NmHfF4pQFAmD9Al5TK4Bj1SXlG5swU97+kZ1ymi0ooKSikgjYioACl2WiJIKysit+W+2LyLiCjWsm+MH9mGtVEYNYOwGvh109zkMNAhYqiafuBzw52RnVf7z3rWwR/4nhc876nfd+3+a0CZpmkIEgMBMIO0AoowRB5eiiMPXWEAk1h++hlA93aqHhNQX14g7oL+IT4AyMEAOCXMND6UNZfRGEBCQtAEBjC4GyDDK5CHAQx+nXB/wFCn6ygm/lwMIEezhOC3SdjAFQaQTR5QyfFA6VNrK/cdu+/Oe75zx913P/po8/TJTVNVtukqKTugXSXkIboKFRAxaiKtUXlKe4qKpFxsbSXr7NRFEAIgERthYKxvg7oJfBv5EoVimSzZBrARIxBQFcv+jv2F/dctPOvm65779Bu/+8Zn79t5qFAoNE2jwZFhdpD6btF0repPBAbQgqqk/Rajen0hBSIhjuPqWN279g8PMADuFfxTfQB5jselFBLF/477N2suozCAQfEfcjKATvhET7MO2nY5gfNj60g8YFQGMGoPmeCec/cyQZJVd2yL0BUGkE1MYBE0Q1E52vFQO7VarVrdPH7i1NFHHj1y7MGHjp89dXrj7HIzqjthRcQKYUGjRhRFBomBRCMxAgB38oICEAC1HMgWxMZFkq2xYoRFpDAfzi7ZpX3FQ4cWn3LddU++5oan3XDTroXFhfkdSqm6DQMTCLIScAQJ0ApPJYlbGj0uGcAYsJ6zWfpG2XZ4WPx1gAGksY1EH8DQQXYzgJzWf0hkfgP7hNNdwZg4BTzynaP9aJi0FSArNCglHXRSJ6mfR1ICRtijkLuH9JAhTmvZ+5USW48t6V9hAEOpnQ/FCoAgqfhPKe06WlTdr1er1c3K+vEzZ0+trJ45u3J+ZfPMufXVlVqlGvoNgdBEDRNYC0AdE1BcBRoAXFdrR8oz7vxCYWZOLy4WDh7ac2DfnqsPHjh04MCOuYWi5zmKlKNb2Z2FAYBhq0JLa5Ail1QUTRpdFAYwqj1nwgaZORi24oOT8HRqDGAwBEiSdAhJci8kDCxHReJhDOCu7n0ALSUr0cIDLRdxzyYaAMhIBz3K5wQGkLaXdXIGkH9sQ6+S/dPYNSJzKj2jtrnoNB5gZW8fA2BslzUWEWYT8wNHaVe5SilNDgAYYyIbGmOq1Woj8Jth0AjCyA9NxFEUGWMAQGvtOI52qDhTKha9YtErFouFQsFxHK1dpVTU9FGgGTRyjnxsBrBNT3PUqpGjDn7U58vDqob1G9DGNbakHUzwA8fj6grzz2if80h2M5TBS1CezjtKACRDf8JZ3adAX0WwlIv1GuC6eMAlTjJQYqwfndNrykM26AxywXxj2Ca6LKB/EsrYvoRb0dutI1q78Wcr3IiacWqF+EEgIhGVF2ZmcBYRUZGDSg28FVbiDA+tAu5ibBBGTa4xiEIiGiF+/yJqSE8cGlsNSpK7++vApMv+Ew1vupdI6irxYP9FdUYv2bCSAW15UE/6CzcO6SENrEe6tOSoVdl3lZjyz7TvSCdB8IR0YRjJZUc9L3RSg/imdTI/MwiDgEjcWoz4A3n2W7uF27l9Oj3EnbQDhK7QhabxdgBM3n5a40xtw9OZ10gX7XzW2SeMzQMyRtCL+53P8WLrHeLEkDfIKnJK94Ow3vmc+FOGqhErTKPagq4g/hjUH1nQIexvAHGwAyCgzq5okLit5gr10XTvDyZJr1O/brpDuPOZMmTzsR3RfTOVpJYjcBGcKP/SOMHI/XFsLU80ACSkhRg6lF7oxD4ekAGsiYIbjA76ifacbP0GkthA9uljsIGhfeac4BOHZCsjf59ht/3hYo9wKF1eD3E7+GKfQXy8605DXUg19OX3M2c3wJ56A90nTstwMHxIIzOAPnNNGip1IGkQXjP0AOhVBVBAIKvxwMBGs/hDJugPtSYNPR0Gfbnt6+bPOJ0xxyuUh67cse2gqUC/iHTz5HZQ/ETX7WtAvT/hwOe+cPtRxfBJpz/WHHMQ5mQhOsfF+gVtEQFJBvRYGenoAQOG/lRr+wBYI6J05dqVafGAzizSToEBXtV3SvYVIZ8m0VGastPJDfUx5PzpCl3idBk9uG2CxaGC/3i/ZphuUgIoU/dkDR1GRphpwok8/duYHgOaOmyaeo8AkGaT6nOg9X0euF8I6aXOJjTAjRrX1bloYuOhD34SlXYk4+MVU/XlSJcR+k9/7tL6y6CMFZS2Kju/pvXT/WEQlyaXzbMwgQU49XKSGaibzzfQ37in/15wHjMhSewGyBLM2+n0ht6mkawuQ30AeaT+wd5GchuM5wPI43zOb+IfOw7qcUytIjbpDUYNgd/e0V6ez2hy6/xI7ccAYunK6Y9JjUcV/iZ39mbE/Ix0uxJHPlo5+AHRfHhEc4dBdX1IHVMPX2UEIWHMLsU5TFEauRZ2trCQcWRCWXvIRFLGMNKvY8/0CsGlFJJ/maL/BaZRVxCKoPTXWBjJYjMV9J/EPiG9aSH6KF+fPT1noz+MrwGIICSLz4lqQYZvIPFrb4dbUUdD5eicN30Ub8RognkeOb3nWSb9Gjta0k7MHxp0CQLN5EOahLd1im1dRvO9dOhSliowhVskfs0jqw3vLcbTXjvHSFLawBEcetaoV+kZahLlZQDSFWCXZmwZbDw4jpw8oJ+4xyfcV8l2sIeh2JdmTcoIW4LcfuD8LCRjeJDJP57I5qAJZ3ThecAVGoPyMxvMgbB5PufvAVIgNY9tA7f2FiTEK496ZwaMK1sNBm1EiTR+UnLBVrBOz/QGZf9xMWjwxA7uM04B1/IwCcgtbm8f5XE5DD29Q48/fjAGXeEBlyn1vcyUAqA5BfzpKjQ5Ldt52E+eScGA9T8n+g/ew5FnmGHwGu4j4lQ1Zxg37tnDCSyDwQMjjWRw8LnGP9YLN/mrNp7L4Qql0aXjD3h80Eh26jy9ZR+kOLnl6Isx/wizWnY7GoRiT2f8YetvlOlkDzjZOZHi+01sk9HPaGWpe3y8Y2lVQ2eb+bVfCp7KazfqG5PHWZTzrFHHOdSJnYeBTeu+Xe50hQdcdBoDjild8IdtQ/9sT/LgGhwPD3PKo4NhNZAk/ndziIwxTKcu3eBMut2Y/TbrLk9A2rlpX8cYRs6WMKJ5ZKitP+fVEzlwRvzsqO6Nad2ixyVl8IArNqJtovGU7KlfNxvTxxthPh8AyjDxse9gxraq9oetr4Ponz2XiRgAg1BKLFDnYGKC5QxvMGQiaV+yIADoZCKKSxcMuiJgYsN3qk87RxRQRlK5rCt2fc7jBB51z8HYjZ84lMc/9ESgCQ3ok8D9SJaTi05T9AH0tx+UU4TGQP8E8Bw3F1Ai+nT/20bk9OCcPh4AmRud+ngA9OYN7WqTPMhRp5Y2HhgdjseD11gt4PQe8mgbV5B9+yhjQ2KrwSUKU5cNXbJAn3vwfcXit7INTTh3EQERQAahLD9FD6fBvg/QhtCxsoGm54MbyUAxuDkAMiP0oW9zwChC7nj8AJKQt337hmQQysk/RrnnU7A4jTTZK5STHgdwnwY6k7wQFwvEu8Xn2Bbd+TD0xGyVvf0VBy+UNuVRVahEFaG/McZVa3qadYv/XSdmpB5AGNUJnNBL+gvSGhACgwhC/JdwT0fZJzxkMBlxu9N+F8fwA+c5q5uo/TfJFUed1GUteV14QgEC7NDFHs4FojwvySRtEo9TOlp1u16TLe85Hk3i6SPNaPIYjZzU9gNL3GuesaXRBDuBc2ymlS7do/U/YedrTlWg+2uCgaU/AdE2An2e3KKDXyHdYtCXvH7oazqGHvAEd/NuKz0OBP8xaHIvbhq+Z8Q+UI7eJgkBGuncPEL6eMJZrp77I+m7qr33iv95aGwncNcgcIRoCuw6mA1LGa7XsXeWwcRpJKYLpokOA2hvSO781L028hjZOp30Hck5/ckNVllE4/a5DelzJ6HEd36ob+BxT2OjP7Tf85Fk8KlovRlHsk1AU7lE9nXTYoG6GrQyyo9aFyym6YSBbiUGSppVmrlcMvWAjMZZOkFmfNEUZpoEpkMF/1EhtVutG0MtSBxVxvgTaZv0hvGl5hw23AtJ2XLP45ImMY9ktOk2cmKKkzQRQ3OOJ2fgzUgn5rc2T8dcJkNqhI2H/rBN+wByUqIekL1L4FKmbTW2dBZJopo8RS93368wbU4wUXz90GXSp25e1PcosTjlZUoj2U+m3oMMuDIz0H8q0A+QIINvfZ0q+meMpPWhK+gzdWxxTrqBlkPpQjCAoeE9/VJqLw8Yagsa1CQuDAsZzyIff5juTgWYgP1cTk4CwjRDUCJfeQIK6UNpVICYHPqzm2U7RjPwNDGqZ2x2mwf9x2YhEw2yP7/1aKfHsZ4ZsUCTRgFNTp3ooEn7mTjqZnKaJMoz/8AyXqzx5jt0kV/iYuzF2rX7BN8tPDn65zwxJ0hNKyguP5KMGnaYZymNgQNDz0CUtLIq+oLteEyTNFHGjzXuiwLa0gm22ROQNqn818oIEJowjCdb38o5kUuXepWArQzhKZpWqhJA6a6RkeQzHPmUxwdNKFhMEQfTqE9FmK5FbpIQo6FD3aaukjbPoh7aHSQFk4xEg8jSc4RQepdQnwEnA5hw5HJh06Qh80oZ+YRYnB0tNwllX3dapqopUBd2p42mh/+BxG9JC6yHPpTRpzioCjy+WcJ2a4Rj9L8dQxrbhjOVwYhIO89NlkbS8yPySN5gRLmYTuBtpcvXmTyd6Q/bnJx21iUB8VMlxFaM2oWc2BZLmMb9zAqzvlStcxOGDA09K08ng+Jwmh6QKDinSdN9x7fDDwyQYP3PQ6MqOiMwgAFoyHWNoWJy/6+5xX8YMAFlNJt6XZdtEv9z0thhP5PnxZvuRK5QHrqkDE0TmjvGbtCtxuU8Jd0YMlFI8STnJu7OSYs4muQqObu6+E7gKzRIl6xYd4We4HSx0H/qwfXZhuXsnjO2+112K/cim4BGEiQThe7L6H5fkZovI0rLrnoR6UpU63RpQj3gEqecm9L/PzeCQqj69mUlAAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDI0LTEwLTMxVDEyOjQ3OjEyKzAwOjAwPMsp0AAAACV0RVh0ZGF0ZTptb2RpZnkAMjAyNC0xMC0zMVQxMjo0NzoxMiswMDowME2WkWwAAAAodEVYdGRhdGU6dGltZXN0YW1wADIwMjQtMTAtMzFUMTI6NDc6MTIrMDA6MDAag7CzAAAAAElFTkSuQmCC";

const ChatActions = ({
  handleGenerateChatBot,
  isEditMode,
  loadingState,
  handleResetToServerState,
  isUpdatePending,
  isDraftSaved,
  isDraft,
  setModalData,
  chatBotList,
  chatBotInputValues,
  context,
  handleUndoReset,
  t,
  handleClearFields,
  DuplicateModalView
}) => {
  const mainPopoverRef = useRef();
  const [mainAnchorEl, setMainAnchorEl] = useState(null);
  const [secondaryAnchorEl, setSecondaryAnchorEl] = useState(null);
  const handleOpenMainPopover = (event) => {
    setMainAnchorEl(event.currentTarget);
  };
  const handleCloseMainPopover = () => {
    setMainAnchorEl(null);
    setSecondaryAnchorEl(null);
  };
  const handleOpenSecondaryPopover = (event) => {
    setSecondaryAnchorEl(event.currentTarget);
  };
  const handleCloseSecondaryPopover = (e) => {
    setSecondaryAnchorEl(null);
    if (!mainPopoverRef.current) return;
    const { top, left, bottom, right } = mainPopoverRef.current.getBoundingClientRect();
    if (e) {
      const { clientX, clientY } = e;
      if (!(clientX >= left && clientX <= right && clientY >= top && clientY <= bottom))
        setMainAnchorEl(null);
    }
  };
  const isMainPopoverOpen = Boolean(mainAnchorEl);
  const isSecondaryPopoverOpen = Boolean(secondaryAnchorEl);
  const popoverId = isMainPopoverOpen ? "templates" : void 0;
  function showDuplicateDraftModal(originalChatBotId) {
    handleCloseMainPopover();
    context.modal.show({
      children: /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(
        DuplicateModalView,
        {
          originalChatBotId,
          handleDuplicateChatBot: (params, newName) => {
            context.modal.hide();
            handleGenerateChatBot(true, true, params.newName || newName);
          }
        }
      ) })
    });
  }
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      Microbutton,
      {
        variant: "transparent-light",
        type: "large-font",
        className: "h-[40px] w-[40px] min-w-0 truncate uppercase",
        onClick: handleOpenMainPopover,
        "data-tooltip-id": "chatBotPanel-clear",
        icon: /* @__PURE__ */ jsx(MoreVert, { fontSize: "inherit" })
      }
    ),
    /* @__PURE__ */ jsx(
      Popover,
      {
        id: popoverId,
        open: isMainPopoverOpen,
        anchorEl: mainAnchorEl,
        onClose: handleCloseMainPopover,
        anchorOrigin: {
          vertical: "top",
          horizontal: "left"
        },
        transformOrigin: {
          vertical: "bottom",
          horizontal: "left"
        },
        children: /* @__PURE__ */ jsxs(
          "div",
          {
            ref: mainPopoverRef,
            className: "bg-brand-accent-flat border-brand-form-accent space-y-[6px] rounded-[4px] border p-2 pb-[10px]",
            children: [
              /* @__PURE__ */ jsx(
                ListPosition,
                {
                  text: t("eleo-chatbot-reset", "Reset changes"),
                  disabled: !isUpdatePending || isDraftSaved,
                  onClick: () => {
                    successToast(
                      /* @__PURE__ */ jsxs("div", { children: [
                        /* @__PURE__ */ jsx("div", { className: "mb-2 text-[13px] font-semibold", children: t("eleo-chatbot-changes-reset", "Changes have been reset") }),
                        /* @__PURE__ */ jsx(
                          "div",
                          {
                            className: "-m-2 p-2 text-[12px] font-light underline",
                            onClick: handleUndoReset,
                            children: t("eleo-undo", "undo")
                          }
                        )
                      ] })
                    );
                    isEditMode ? handleResetToServerState() : handleClearFields();
                    handleCloseMainPopover();
                  }
                }
              ),
              /* @__PURE__ */ jsx(
                ListPosition,
                {
                  text: t("eleo-chatbot-duplicate-as-draft", "Duplicate as draft"),
                  onClick: () => isDraft ? showDuplicateDraftModal() : handleGenerateChatBot(true, true)
                }
              ),
              /* @__PURE__ */ jsx(
                ListPosition,
                {
                  text: t("eleo-chatbot-convert-to-draft", "Convert to draft"),
                  onClick: () => handleGenerateChatBot(true),
                  disabled: isDraft
                }
              ),
              !isDraft && Boolean(
                chatBotList.filter(
                  (bot) => bot.type !== "draft" && bot.id !== chatBotInputValues.selectedChatBot
                )?.length
              ) && /* @__PURE__ */ jsxs(Fragment, { children: [
                /* @__PURE__ */ jsx("div", { className: "border-brand-form-accent-light border-b" }),
                /* @__PURE__ */ jsx(
                  ListPosition,
                  {
                    icon: /* @__PURE__ */ jsx(KeyboardArrowRight, { fontSize: "inherit" }),
                    text: t("eleo-chatbot-overwrite with", "Overwrite with"),
                    onClick: handleOpenSecondaryPopover
                  }
                ),
                /* @__PURE__ */ jsx(
                  Popover,
                  {
                    id: "secondary-popover",
                    open: isSecondaryPopoverOpen,
                    anchorEl: secondaryAnchorEl,
                    onClose: handleCloseSecondaryPopover,
                    anchorOrigin: {
                      vertical: "top",
                      horizontal: "right"
                    },
                    transformOrigin: {
                      vertical: "top",
                      horizontal: "left"
                    },
                    children: /* @__PURE__ */ jsxs("div", { className: "bg-brand-accent-flat border-brand-form-accent roudned-[4px] max-h-[300px] min-w-32 overflow-y-auto rounded-[4px] border p-2 pb-[10px]", children: [
                      /* @__PURE__ */ jsx("div", { className: "body-small mb-2 max-w-[150px]", children: /* @__PURE__ */ jsx(T, { keyName: "eleo-chatbot-override-desc", children: "Change this conversation to the selected one. The conversation link will remain the same." }) }),
                      chatBotList.filter(
                        (bot) => (
                          // bot.type !== 'draft' &&
                          bot.id !== chatBotInputValues.selectedChatBot
                        )
                      ).map((bot) => /* @__PURE__ */ jsx(
                        ListPosition,
                        {
                          text: bot.name,
                          iconPlacement: "left",
                          icon: /* @__PURE__ */ jsx(
                            "img",
                            {
                              src: bot.avatar?.length ? bot.avatar : FallbackImage,
                              alt: "",
                              className: "size-4"
                            }
                          ),
                          onClick: () => {
                            handleCloseMainPopover();
                            handleCloseSecondaryPopover();
                            setModalData({
                              isVisible: true,
                              title: t(
                                "eleo-chatbot-modal-override-title",
                                "Overwrite {name1} with {name2}",
                                { name1: chatBotInputValues.name, name2: bot.name }
                              ),
                              subtitle: /* @__PURE__ */ jsxs("div", { children: [
                                /* @__PURE__ */ jsx("div", { children: t(
                                  "eleo-chatbot-override-desc-1",
                                  "All of the chatbot settings, including publishing settings, will be overriden by {name}.",
                                  { name: bot.name }
                                ) }),
                                /* @__PURE__ */ jsx("div", { children: t(
                                  "eleo-chatbot-override-desc-2",
                                  "You will still be able to reset changes to your form until you save or publish them."
                                ) })
                              ] }),
                              acceptLabel: t("eleo-override", "Override"),
                              type: "override",
                              context: { id: bot.id }
                            });
                          }
                        },
                        bot.id
                      ))
                    ] })
                  }
                )
              ] })
            ]
          }
        )
      }
    ),
    (!isEditMode || isDraft) && /* @__PURE__ */ jsx(
      Microbutton,
      {
        variant: isDraft ? "solid" : "transparent-light",
        type: "large-font",
        className: classNames(
          "h-[40px] min-w-[100px] flex-1 uppercase",
          loadingState.publish && "opacity-70",
          isDraftSaved && isEditMode && "!bg-brand-green-secondary hover:!bg-brand-green-secondary/80 !text-brand-text-primary"
        ),
        onClick: () => handleGenerateChatBot(true),
        "data-tooltip-id": "chatBotPanel-clear",
        disabled: !isUpdatePending || loadingState.publish || isDraftSaved,
        icon: isDraftSaved && isEditMode && /* @__PURE__ */ jsx(Check, { fontSize: "inherit" }),
        iconSize: 18,
        children: /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-[6px] truncate", children: [
          /* @__PURE__ */ jsx("div", { className: "truncate", children: isDraftSaved && isEditMode ? t("eleo-chatbot-draft-saved", "Draft up to date") : isDraft ? t("eleo-chatbot-update-draft", "Update draft") : t("eleo-chatbot-save-draft", "Save as draft") }),
          loadingState.draft && /* @__PURE__ */ jsx(CircularProgress, { size: 14, sx: { animationDuration: "1000ms" }, color: "inherit" })
        ] })
      }
    ),
    /* @__PURE__ */ jsx(
      Microbutton,
      {
        variant: "solid",
        type: "large-font",
        className: classNames(
          "h-[40px] min-w-[80px] flex-1 uppercase",
          loadingState.draft && "opacity-70",
          isEditMode && !isUpdatePending && !isDraft && "!bg-brand-green-secondary"
        ),
        onClick: () => handleGenerateChatBot(),
        "data-tooltip-id": "chatBotPanel-clear",
        disabled: loadingState.draft || isEditMode && !isUpdatePending && !isDraft,
        icon: isEditMode && !isUpdatePending && !isDraft && /* @__PURE__ */ jsx(Check, { fontSize: "inherit" }),
        iconSize: 18,
        children: /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-[6px] truncate", children: [
          /* @__PURE__ */ jsx("div", { className: "truncate", children: isEditMode && !isDraft ? isUpdatePending ? t("eleo-chatbot-publish-changes", "Publish changes") : t("eleo-chatbot-published", "Published") : t("eleo-chatbot-publish", "Publish") }),
          loadingState.publish && /* @__PURE__ */ jsx(CircularProgress, { size: 14, sx: { animationDuration: "1000ms" }, color: "inherit" })
        ] })
      }
    )
  ] });
};

const iconMap$2 = {
  story: /* @__PURE__ */ jsx(ArticleOutlined, { fontSize: "inherit" }),
  document: /* @__PURE__ */ jsx(DescriptionOutlined, { fontSize: "inherit" }),
  template: /* @__PURE__ */ jsx(DesignServicesOutlined, { fontSize: "inherit" }),
  website: /* @__PURE__ */ jsx(WebAssetOutlined, { fontSize: "inherit" }),
  database: /* @__PURE__ */ jsx(DataObjectSharp, { fontSize: "inherit" })
};
function ContextField({
  documentContext,
  onlyStory = false,
  noLabel = false,
  noIcon = false,
  classes,
  t,
  placeholder
}) {
  const items = [...documentContext.docContext, ...documentContext.databases];
  return /* @__PURE__ */ jsxs("div", { id: "context-field", className: "!w-full space-y-[5px]", children: [
    !noLabel && /* @__PURE__ */ jsx("div", { className: "body-small text-brand-gray-dark pl-[2px]", children: t("eleo-context-title", "Context") }),
    /* @__PURE__ */ jsxs(
      "div",
      {
        className: classNames(
          classes,
          "border-brand-gray-light flex w-full flex-wrap items-center gap-[4px] rounded-[4px] border bg-white px-[6px]",
          items.length ? "p-[4px]" : "cursor-pointer py-[4px] pl-[14px] pr-3"
        ),
        onClick: () => !items.length && documentContext.openModal(),
        children: [
          items?.map((entry) => /* @__PURE__ */ jsxs(
            "div",
            {
              className: "text-brand-violet bg-brand-form-accent-light group relative flex h-[26px] select-none items-center gap-[5px] rounded-[4px] px-[5px] py-[3px] text-[14px] ",
              title: entry.label || entry.name,
              children: [
                iconMap$2[entry.type],
                /* @__PURE__ */ jsx("div", { className: "min-w-[16px] max-w-[100px] truncate text-[12px] font-medium", children: entry.label || entry.name }),
                /* @__PURE__ */ jsx("div", { className: "absolute right-0 h-full w-[30px] rounded-[4px] bg-white opacity-0 transition-opacity group-hover:opacity-100", children: /* @__PURE__ */ jsx(
                  "button",
                  {
                    type: "button",
                    className: "text-brand-violet bg-brand-form-accent-light hover:bg-brand-violet  hover:text-brand-text-primary flex  h-full w-full items-center justify-center rounded-[4px] text-[18px] transition-opacity",
                    onClick: () => {
                      if (entry.type === "database") documentContext.removeDatabase(entry.id);
                      else documentContext.removeDocument(entry.id);
                    },
                    children: /* @__PURE__ */ jsx(Close, { fontSize: "inherit" })
                  }
                ) })
              ]
            },
            entry.id
          )),
          items.length ? /* @__PURE__ */ jsx(
            Microbutton,
            {
              iconPlacement: "right",
              text: t("eleo-context-add", "add"),
              variant: "plain",
              icon: /* @__PURE__ */ jsx(AddOutlined, { fontSize: "inherit" }),
              className: "bg-brand-form-accent hover:bg-brand-violet-light text-brand-violet hover:text-brand-text-primary h-[26px] uppercase",
              textClasses: "!px-[1px]",
              onClick: () => documentContext.openModal()
            }
          ) : /* @__PURE__ */ jsxs("div", { className: "flex h-[26px] w-full items-center justify-between", children: [
            /* @__PURE__ */ jsx("div", { className: "body-secondary select-none truncate opacity-60 ", children: placeholder ?? t("eleo-context-add-empty", "Add Your Story", {
              onlyStory
            }) }),
            !noIcon && /* @__PURE__ */ jsx("div", { className: "text-brand-gray text-[18px]", children: /* @__PURE__ */ jsx(AddOutlined, { fontSize: "inherit" }) })
          ] })
        ]
      }
    )
  ] });
}

function ChatOptions({
  isCreatorTour = false,
  isShowAdvanced,
  setIsShowAdvanced,
  isShowPublishing,
  setIsShowPublishing,
  handleFileUpload,
  documentContext,
  publishState,
  setPublishState,
  chatbotServerState,
  chatbotDraftServerState,
  setModalData,
  isUpdatePending,
  isDraftSaved,
  handleGenerateChatBot,
  chatBotInputValues,
  context,
  handleDispatchFieldValue,
  handleDispatchTutorValue,
  handleDispatchTranslatorValue,
  t,
  voices,
  isPanelLarge,
  useLanguages,
  ImageDropZone,
  aiController,
  ChatbotPublishing,
  ContextMenu,
  isLimited = false,
  translations = {},
  isMaster = false,
  enhanceInstructionsCallback,
  isUploadLoading,
  chatbotLevels
}) {
  const { defaultToolOutPutLanguage, languages } = useLanguages({ filterSupportsSpeech: true });
  const ttsPreviewAudioRef = useRef(null);
  const ttsPreviewObjectUrlRef = useRef(null);
  const [baseImage, setBaseImage] = useState(chatBotInputValues.avatar);
  const [isNameUnique, setIsNameUnique] = useState(true);
  const [enhanceData, setEnhanceData] = useState({ intro: false, instructions: false });
  const [debouncedName] = useDebounce(chatBotInputValues.name, 500);
  useEffect(() => {
    const checkNameUniqueness = async () => {
      try {
        const res = await axios.post("/api/chat-bot/checkName", {
          name: debouncedName,
          id: chatBotInputValues.selectedChatBot
        });
        setIsNameUnique(res.data.isUnique);
      } catch (err) {
        context.handleError(err);
      }
    };
    if (debouncedName?.length) checkNameUniqueness();
  }, [debouncedName, chatBotInputValues.selectedChatBot]);
  useEffect(() => {
    return () => {
      if (ttsPreviewObjectUrlRef.current) {
        URL.revokeObjectURL(ttsPreviewObjectUrlRef.current);
      }
    };
  }, []);
  const handleTTS = async () => {
    const selectedVoice = voices.data.voices.find(
      (voice) => voice.value === (chatBotInputValues.voice || "Danielle")
    );
    const data = {
      input: chatBotInputValues.intro || introMessagesByLanguage[selectedVoice.raw.LanguageCode],
      voiceId: chatBotInputValues.voice
    };
    const res = await fetch(axios.defaults.baseURL + "/api/utility/tts", {
      method: "POST",
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json",
        Authorization: String(axios.defaults.headers.common["Authorization"])
      }
    });
    if (!res.ok) {
      const data2 = await res.json();
      if (data2.code === "TEXT_TOO_LONG")
        return errorToast(
          t("eleo-error-tts-tool-long", "This message is too long. Try a shorter message.")
        );
      return errorToast(
        t("eleo-error-tts", "Text to speech is currently unavailable. Try again later.")
      );
    }
    const blob = await res.blob();
    const url = URL.createObjectURL(blob);
    if (ttsPreviewObjectUrlRef.current) {
      URL.revokeObjectURL(ttsPreviewObjectUrlRef.current);
    }
    ttsPreviewObjectUrlRef.current = url;
    const audio = ttsPreviewAudioRef.current;
    if (!audio) return;
    audio.src = url;
    audio.play().catch(
      () => errorToast(t("eleo-error-tts", "Text to speech is currently unavailable. Try again later."))
    );
  };
  const handleSetAvatar = (image) => {
    handleDispatchFieldValue({ field: "avatar", value: image });
    return null;
  };
  useEffect(() => {
    setBaseImage(chatBotInputValues.avatar);
  }, [chatBotInputValues.avatar]);
  const chatModes = [
    { value: "text", label: t("eleo-chat-mode-text", "Text chat") },
    { value: "read", label: t("eleo-chat-mode-read", "Read answers aloud") },
    { value: "voice", label: t("eleo-chat-mode-voice", "Voice chat") },
    { value: "push", label: t("eleo-chat-mode-push", "Push to speak") }
  ];
  const ToneInputData = [
    {
      value: "friendly",
      label: t("eleo-select-option-friendly", "Friendly")
    },
    { value: "luxury", label: t("eleo-select-option-luxury", "Luxury") },
    {
      value: "relaxed",
      label: t("eleo-select-option-relaxed", "Relaxed")
    },
    {
      value: "professional",
      label: t("eleo-select-option-professional", "Professional")
    },
    { value: "bold", label: t("eleo-select-option-bold", "Bold") },
    {
      value: "adventurous",
      label: t("eleo-select-option-adventurous", "Adventurous")
    },
    { value: "witty", label: t("eleo-select-option-witty", "Witty") },
    {
      value: "persuasive",
      label: t("eleo-select-option-persuasive", "Persuasive")
    },
    {
      value: "empathetic",
      label: t("eleo-select-option-empathetic", "Empathetic")
    }
  ];
  const tutorLanguageOptions = [
    {
      label: t("red-parrot-language-option-student-native-language", "Student's native language"),
      value: "native",
      rawValue: "native",
      lookup: "native,natywny"
    },
    ...languages
  ];
  return /* @__PURE__ */ jsxs("div", { className: classNames("bg-brand-grey-bg relative flex flex-col break-words pb-6"), children: [
    /* @__PURE__ */ jsxs(
      "div",
      {
        id: "tour-creator-basics",
        className: "grid-cols-[auto_1fr_1fr] items-start gap-5 space-y-[14px] pb-5 lg:grid lg:space-y-0",
        children: [
          /* @__PURE__ */ jsx("div", { className: "row-span-2", children: /* @__PURE__ */ jsx(
            ImageDropZone,
            {
              baseImage,
              setBaseImage: (img) => {
                setBaseImage(img);
                handleDispatchFieldValue({ field: "avatar", value: img });
              },
              handleFileUpload: (e) => {
                handleFileUpload(e, handleSetAvatar);
                setModalData({
                  isVisible: false,
                  title: "",
                  acceptLabel: "",
                  cancelLabel: "",
                  type: "",
                  context: {}
                });
              },
              classes: "!size-[136px] !min-w-[130px] !m-0",
              ctaText: translations.avatar ?? t("eleo-upload-avatar", "Upload<br></br>avatar", { br: /* @__PURE__ */ jsx("br", {}) }),
              id: "avatar-upload",
              handleOverrideUpload: () => {
                setModalData({
                  isVisible: true,
                  title: t("eleo-your-story-select-gallery-image-modal-title", "Select image"),
                  subtitle: t(
                    "eleo-your-story-select-gallery-image-modal-subtitle",
                    "Select one of the images from your gallery"
                  ),
                  type: "submit-image",
                  cancelLabel: t("eleo-go-back", "Go back"),
                  context: {
                    documentUploadId: "avatar-upload",
                    onSelect: (image) => handleDispatchFieldValue({ field: "avatar", value: image })
                  }
                });
              },
              isLoading: isUploadLoading
            }
          ) }),
          /* @__PURE__ */ jsxs(
            "div",
            {
              className: classNames("space-y-[6px]", !isPanelLarge && "col-span-2"),
              "data-tooltip-id": "chatBotPanel-yourChatBotName",
              children: [
                /* @__PURE__ */ jsxs("div", { className: "body-small text-brand-gray-dark flex justify-between gap-2 pl-[2px]", children: [
                  t("eleo-chat-bot-name-label", "Name"),
                  !isNameUnique && chatBotInputValues.name?.length && /* @__PURE__ */ jsx("span", { className: "text-brand-pink", children: t("eleo-must-be-unique", "Must be unique") })
                ] }),
                /* @__PURE__ */ jsx(
                  Input,
                  {
                    className: classNames(
                      "h-[36px] w-full text-[13px]",
                      !isNameUnique && "!border-brand-pink"
                    ),
                    value: chatBotInputValues.name,
                    placeholder: t("eleo-chat-bot-name-placeholder", "Chatbot name"),
                    onChange: async (name) => handleDispatchFieldValue({ field: "name", value: name })
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "div",
            {
              className: classNames("space-y-[6px]", !isPanelLarge && "col-span-2"),
              "data-tooltip-id": "chatBotPanel-language",
              children: [
                /* @__PURE__ */ jsx("div", { className: "body-small text-brand-gray-dark pl-[2px]", children: translations.language ?? t("eleo-write-text-language", "language") }),
                /* @__PURE__ */ jsx("div", { className: "h-[36px]", children: /* @__PURE__ */ jsx(
                  ReactSelect,
                  {
                    menuPlacement: DropDownMenuPlacementEnum.BOTTOM,
                    options: languages,
                    setSelectedValue: ({ value }) => {
                      handleDispatchFieldValue({ field: "language", value });
                    },
                    placeHolder: t("eleo-select-drop-down-placeholder", "Select"),
                    value: transformSelectOptionValue(
                      languages,
                      chatBotInputValues.language,
                      defaultToolOutPutLanguage
                    )
                  }
                ) })
              ]
            }
          ),
          chatBotInputValues.level && /* @__PURE__ */ jsxs("div", { className: classNames("space-y-[6px]", isPanelLarge ? "col-span-2" : "col-span-3"), children: [
            /* @__PURE__ */ jsx("div", { className: "body-small text-brand-gray-dark pl-[2px]", children: t("red-parrot-chatbot-level", "Chatbot level") }),
            /* @__PURE__ */ jsx(
              ReactSelect,
              {
                options: chatbotLevels.map((level) => ({
                  value: level.value,
                  label: /* @__PURE__ */ jsxs(Fragment, { children: [
                    level.symbol,
                    " - ",
                    level.label
                  ] })
                })),
                setSelectedValue: ({ value }) => handleDispatchFieldValue({ field: "level", value }),
                placeHolder: t("red-parrot-chatbot-level-default", "begginer"),
                value: transformSelectOptionValue(
                  chatbotLevels.map((level) => ({
                    value: level.value,
                    label: /* @__PURE__ */ jsxs(Fragment, { children: [
                      level.symbol,
                      " - ",
                      level.label
                    ] })
                  })),
                  chatBotInputValues.level,
                  chatbotLevels[0]
                ),
                menuPlacement: DropDownMenuPlacementEnum.BOTTOM,
                portalToBody: true
              }
            )
          ] }),
          /* @__PURE__ */ jsxs(
            "div",
            {
              className: classNames(
                "relative space-y-[6px]",
                chatBotInputValues.level || !isPanelLarge ? "col-span-3" : "col-span-2"
              ),
              children: [
                /* @__PURE__ */ jsx("div", { className: "body-small text-brand-gray-dark pl-[2px]", children: t("eleo-chat-bot-intro-label", "Intro") }),
                /* @__PURE__ */ jsx(
                  Input,
                  {
                    className: "min-h-[36px] w-full pr-28 text-[13px]",
                    value: chatBotInputValues.intro,
                    isTextArea: true,
                    placeholder: t(
                      "eleo-chatbot-intro-placeholder",
                      "What the chatbot will say to open the conversation"
                    ),
                    onChange: (intro) => handleDispatchFieldValue({
                      field: "intro",
                      value: intro
                    })
                  }
                ),
                /* @__PURE__ */ jsx(
                  Microbutton,
                  {
                    iconPlacement: "left",
                    variant: "transparent-light",
                    icon: /* @__PURE__ */ jsx(AutoAwesome, { fontSize: "small" }),
                    text: t("eleo-enhance", "Enhance"),
                    className: classNames("!absolute bottom-1 right-1 !m-0 h-[28px]"),
                    onClick: () => setEnhanceData((prev) => ({ ...prev, intro: true }))
                  }
                ),
                enhanceData.intro && /* @__PURE__ */ jsx("div", { className: "absolute bottom-0 right-1 z-50  translate-y-full", children: /* @__PURE__ */ jsx(
                  ContextMenu,
                  {
                    noHeader: true,
                    selectedText: `
Chatbot name: ${chatBotInputValues.name}
Current intro: ${chatBotInputValues.intro}
${chatBotInputValues.instructions ? "Chatbots instructions: " + chatBotInputValues.instructions : ""}`,
                    tools: ["rephrase"],
                    forceNotSynonyms: true,
                    regenerateUrl: "/api/ai/enhance_prompt",
                    type: "chatbot-intro",
                    language: chatBotInputValues.language,
                    handleChangeSelectedText: (newText) => {
                      handleDispatchFieldValue({
                        field: "intro",
                        value: newText
                      });
                      setEnhanceData((prev) => ({ ...prev, intro: false }));
                    },
                    onClose: () => setEnhanceData((prev) => ({ ...prev, intro: false }))
                  }
                ) })
              ]
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ jsxs("div", { id: "tour-creator-instructions", className: "space-y-[5px] pb-5", children: [
      /* @__PURE__ */ jsx("div", { className: "body-small text-brand-gray-dark pl-[2px]", children: t("eleo-chatbot-instructions-and-context", "Instructions and context") }),
      /* @__PURE__ */ jsxs("div", { className: "border-brand-gray-light rounded-md border bg-white", children: [
        /* @__PURE__ */ jsxs("div", { className: "relative", "data-tooltip-id": "chatBotPanel-instructions", children: [
          /* @__PURE__ */ jsx(
            "textarea",
            {
              spellCheck: false,
              className: "placeholder:text-brand-gray-dark/70 max-h-72 min-h-[68px] w-full resize-none rounded-t-md px-[14px] py-[10px] indent-[22px] text-[13px] placeholder:opacity-70",
              placeholder: translations.instructionsPlaceholder ?? t("eleo-chatbot-instructions-placeholder", "Add instructions for your chatbot"),
              style: { fieldSizing: "content" },
              value: chatBotInputValues.instructions,
              onChange: (e) => handleDispatchFieldValue({
                field: "instructions",
                value: e.target.value
              })
            }
          ),
          /* @__PURE__ */ jsx(
            "div",
            {
              className: "text-brand-form-accent absolute left-1 top-1 flex cursor-pointer p-[6px] text-[20px]",
              "data-tooltip-id": "image-description-tooltip",
              children: /* @__PURE__ */ jsx(Article, { fontSize: "inherit" })
            }
          ),
          /* @__PURE__ */ jsxs("div", { className: "absolute bottom-1 right-1 !m-0 flex gap-2", children: [
            /* @__PURE__ */ jsx(
              Microbutton,
              {
                iconPlacement: "left",
                variant: "frosted",
                icon: /* @__PURE__ */ jsx(AutoAwesome, { fontSize: "small" }),
                text: t("eleo-enhance", "Enhance"),
                className: classNames("h-[28px]"),
                onClick: () => {
                  setEnhanceData((prev) => ({ ...prev, instructions: true }));
                }
              }
            ),
            enhanceInstructionsCallback && /* @__PURE__ */ jsx(
              Microbutton,
              {
                variant: "frosted",
                text: t("redparrot-instructions-generator", "Instructions generator"),
                className: classNames("h-[28px]"),
                onClick: () => {
                  enhanceInstructionsCallback();
                }
              }
            )
          ] }),
          enhanceData.instructions && /* @__PURE__ */ jsx("div", { className: "absolute bottom-0 right-1 z-50  translate-y-full", children: /* @__PURE__ */ jsx(
            ContextMenu,
            {
              noHeader: true,
              selectedText: `
Chatbot name: ${chatBotInputValues.name}
Chatbot introduction message: ${chatBotInputValues.intro}
${chatBotInputValues.instructions ? "Current Chatbot instructions: " + chatBotInputValues.instructions : ""}
${chatBotInputValues.tone ? "Chatbot tone: " + chatBotInputValues.tone : ""}
`,
              tools: ["rephrase"],
              forceNotSynonyms: true,
              regenerateUrl: "/api/ai/enhance_prompt",
              type: enhanceInstructionsCallback ? "foreign-language-tutor" : "chatbot-instructions",
              language: chatBotInputValues.language,
              handleChangeSelectedText: (newText) => {
                handleDispatchFieldValue({
                  field: "instructions",
                  value: newText
                });
                setEnhanceData((prev) => ({ ...prev, instructions: false }));
              },
              onClose: () => setEnhanceData((prev) => ({ ...prev, instructions: false }))
            }
          ) })
        ] }),
        /* @__PURE__ */ jsxs("div", { className: "relative", children: [
          /* @__PURE__ */ jsx(
            ContextField,
            {
              documentContext,
              noLabel: true,
              classes: classNames(
                "rounded-t-none border-b-0 border-x-0 border-brand-gray-light",
                !documentContext.docContext.length && "pl-[36px]"
              ),
              noIcon: true,
              t,
              placeholder: translations.contextPlaceholder
            }
          ),
          !documentContext.docContext.length && /* @__PURE__ */ jsx(
            "div",
            {
              className: "text-brand-form-accent pointer-events-none absolute left-1 top-1/2 flex -translate-y-1/2 p-[6px] text-[20px]",
              "data-tooltip-id": "image-description-tooltip",
              children: /* @__PURE__ */ jsx(Add, { fontSize: "inherit" })
            }
          )
        ] })
      ] })
    ] }),
    /* @__PURE__ */ jsxs(
      "div",
      {
        id: "tour-creator-advanced",
        onClick: () => setIsShowAdvanced((prev) => !prev),
        className: "text-brand-violet bg-brand-gray-light -mx-7 flex cursor-pointer select-none items-center justify-between px-[30px] py-[10px] text-[20px]",
        children: [
          /* @__PURE__ */ jsx("span", { className: "body-secondary text-brand-violet font-medium", children: t("eleo-chatbot-advanced-settings", "Advanced settings") }),
          /* @__PURE__ */ jsx(
            KeyboardArrowDown,
            {
              fontSize: "inherit",
              className: classNames("!transition-all", isShowAdvanced && "rotate-180")
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ jsx(
      "div",
      {
        id: "advanced",
        className: classNames(
          "-mx-2 grid overflow-hidden px-2 transition-all duration-300",
          isShowAdvanced && "pb-5 pt-2"
        ),
        style: {
          gridTemplateRows: isShowAdvanced ? "1fr" : "0fr"
        },
        children: /* @__PURE__ */ jsxs(
          "div",
          {
            className: classNames(
              "min-h-0",
              isPanelLarge ? "grid grid-cols-1 gap-[14px] lg:grid-cols-2 lg:gap-4" : "space-y-4"
            ),
            children: [
              (!isLimited || isMaster) && /* @__PURE__ */ jsxs("div", { className: "space-y-[6px]", children: [
                /* @__PURE__ */ jsx("div", { className: "body-small text-brand-gray-dark pl-[2px]", children: t("eleo-chat-settings-model", "Model") }),
                /* @__PURE__ */ jsx("div", { className: "h-[36px]", children: /* @__PURE__ */ jsx(
                  ReactSelect,
                  {
                    portalToBody: true,
                    options: aiController.getSupportedTextModels(),
                    setSelectedValue: ({ value }) => {
                      handleDispatchFieldValue({ field: "modelId", value });
                    },
                    value: {
                      ...aiController.getTextModel(chatBotInputValues.modelId) || aiController.getDefaultTextModel(),
                      description: void 0
                    },
                    menuPlacement: DropDownMenuPlacementEnum.BOTTOM
                  }
                ) })
              ] }),
              /* @__PURE__ */ jsxs("div", { className: "space-y-[6px]", "data-tooltip-id": "chatBotPanel-tone", children: [
                /* @__PURE__ */ jsx("div", { className: "body-small text-brand-gray-dark pl-[2px]", children: t("eleo-write-text-tone", "Tone") }),
                /* @__PURE__ */ jsx(
                  ReactSelect,
                  {
                    options: ToneInputData,
                    isClearable: true,
                    placeHolder: t("eleo-select-drop-down-placeholder", "Select"),
                    setSelectedValue: ({ value }) => handleDispatchFieldValue({ field: "tone", value }),
                    value: transformSelectOptionValue(ToneInputData, chatBotInputValues.tone, null),
                    menuPlacement: DropDownMenuPlacementEnum.BOTTOM,
                    portalToBody: true
                  }
                )
              ] }),
              /* @__PURE__ */ jsx("div", { className: "col-span-full -mt-2 space-y-[6px]", children: /* @__PURE__ */ jsx(
                MuiTooltip,
                {
                  title: t(
                    "eleo-chatbot-options-allow-duplicate-tooltip-title",
                    "Allow duplicating this chatbot"
                  ),
                  content: t(
                    "eleo-chatbot-options-allow-duplicate-tooltip-content",
                    "Other users will be able to duplicate this chatbot and create their own version of it."
                  ),
                  placement: "top-end",
                  children: /* @__PURE__ */ jsxs(
                    "label",
                    {
                      htmlFor: "allow-duplicate-checkbox",
                      className: "flex gap-[4px] pl-[2px] pt-[5px]",
                      children: [
                        /* @__PURE__ */ jsx(
                          CheckBox,
                          {
                            containerClasses: "!block pt-[3px]",
                            id: "allow-duplicate-checkbox",
                            checkBoxValue: chatBotInputValues.isAllowedToBeDuplicated,
                            setChecked: ({ checked }) => handleDispatchFieldValue({ field: "isAllowedToBeDuplicated", value: checked })
                          }
                        ),
                        /* @__PURE__ */ jsx("span", { className: "body-secondary text-brand-gray-dark select-none", children: t("eleo-chatbot-options-allow-duplicate", "Allow duplicating this chatbot") })
                      ]
                    }
                  )
                }
              ) }),
              /* @__PURE__ */ jsxs("div", { className: "col-span-2 space-y-[6px]", children: [
                /* @__PURE__ */ jsx("div", { className: "text-brand-violet-light pl-[13px] text-[12px] font-medium", children: t("chatbot-text-mode-label", "VOICE/TEXT MODE") }),
                /* @__PURE__ */ jsxs("div", { className: "col-span-2 flex flex-wrap gap-[10px] rounded-[4px] border border-[#D9D9D9] bg-[#FFFFFF30] p-4", children: [
                  /* @__PURE__ */ jsxs(
                    "div",
                    {
                      className: "min-w-[230px] flex-1 space-y-[6px] lg:col-span-2",
                      "data-tooltip-id": "chatBotPanel-default-mode",
                      children: [
                        /* @__PURE__ */ jsx("div", { className: "body-small text-brand-gray-dark pl-[2px]", children: t("eleo-chatbot-mode", "Chat starting mode") }),
                        /* @__PURE__ */ jsx(
                          ReactSelect,
                          {
                            options: chatModes,
                            setSelectedValue: ({ value }) => handleDispatchFieldValue({ field: "defaultMode", value }),
                            placeHolder: t("eleo-chat-settings-model-default", "Default"),
                            value: transformSelectOptionValue(chatModes, chatBotInputValues.defaultMode, {
                              value: "text",
                              label: t("eleo-chat-mode-text", "Text chat")
                            }),
                            menuPlacement: DropDownMenuPlacementEnum.TOP,
                            portalToBody: true
                          }
                        ),
                        /* @__PURE__ */ jsxs("label", { htmlFor: "mode-checkbox", className: "flex gap-[4px] pt-[5px]", children: [
                          /* @__PURE__ */ jsx(
                            CheckBox,
                            {
                              containerClasses: "!block pt-[3px]",
                              id: "mode-checkbox",
                              checkBoxValue: chatBotInputValues.allowModeChange,
                              setChecked: ({ checked }) => handleDispatchFieldValue({ field: "allowModeChange", value: checked })
                            }
                          ),
                          /* @__PURE__ */ jsx("span", { className: "body-secondary text-brand-gray-dark select-none", children: t("eleo-chatbot-options-mode-allow", "Allow the user to set chat mode") })
                        ] })
                      ]
                    }
                  ),
                  /* @__PURE__ */ jsxs(
                    "div",
                    {
                      className: "min-w-[230px] flex-1 space-y-[6px] lg:col-span-2",
                      "data-tooltip-id": "chatBotPanel-voice",
                      children: [
                        /* @__PURE__ */ jsx("div", { className: "body-small text-brand-gray-dark pl-[2px]", children: t("eleo-chatbot-voice", "Voice") }),
                        /* @__PURE__ */ jsxs("div", { className: "flex gap-1", children: [
                          /* @__PURE__ */ jsx(
                            ReactSelect,
                            {
                              options: voices.data?.voices,
                              setSelectedValue: ({ value }) => handleDispatchFieldValue({ field: "voice", value }),
                              placeHolder: t("eleo-chat-settings-model-default", "Default"),
                              value: transformSelectOptionValue(
                                voices.data?.voices,
                                chatBotInputValues.voice,
                                void 0
                              ),
                              menuPlacement: DropDownMenuPlacementEnum.TOP,
                              isClearable: true,
                              portalToBody: true,
                              className: "flex-1"
                            }
                          ),
                          /* @__PURE__ */ jsx(
                            Microbutton,
                            {
                              className: "min-w-[44px]",
                              iconPlacement: "left",
                              variant: "solid",
                              icon: /* @__PURE__ */ jsx(VolumeUp, { fontSize: "inherit" }),
                              disabled: false,
                              onClick: handleTTS
                            }
                          )
                        ] }),
                        Object.hasOwn(chatBotInputValues, "isMultilingual") && /* @__PURE__ */ jsxs("label", { htmlFor: "multilingual-checkbox", className: "flex gap-[4px] pt-[5px]", children: [
                          /* @__PURE__ */ jsx(
                            CheckBox,
                            {
                              containerClasses: "!block pt-[3px]",
                              id: "multilingual-checkbox",
                              checkBoxValue: chatBotInputValues.isMultilingual,
                              setChecked: ({ checked }) => handleDispatchFieldValue({ field: "isMultilingual", value: checked })
                            }
                          ),
                          /* @__PURE__ */ jsx("span", { className: "body-secondary text-brand-gray-dark select-none", children: t("eleo-chatbot-options-multilingual", "Multilingual conversation") })
                        ] }),
                        /* @__PURE__ */ jsx("audio", { ref: ttsPreviewAudioRef, className: "hidden" })
                      ]
                    }
                  )
                ] })
              ] }),
              (!isLimited || isMaster) && /* @__PURE__ */ jsxs("div", { className: "col-span-2 space-y-[6px]", children: [
                /* @__PURE__ */ jsxs("div", { className: "text-brand-violet-light  pl-[13px] text-[12px] font-medium", children: [
                  t("chatbot-web-browsing-label", "WEB BROWSING"),
                  " ",
                  isMaster && "(MASTER SETTING)"
                ] }),
                /* @__PURE__ */ jsxs("div", { className: "col-span-2 gap-[10px] space-y-[6px] rounded-[4px] border border-[#D9D9D9] bg-[#FFFFFF30] p-4", children: [
                  /* @__PURE__ */ jsxs("label", { htmlFor: "www-default-checkbox", className: "flex items-center gap-[4px]", children: [
                    /* @__PURE__ */ jsx(
                      CheckBox,
                      {
                        id: "www-default-checkbox",
                        checkBoxValue: chatBotInputValues.isStartWithWebSearch,
                        setChecked: ({ checked }) => handleDispatchFieldValue({ field: "isStartWithWebSearch", value: checked })
                      }
                    ),
                    /* @__PURE__ */ jsx("span", { className: "body-secondary text-brand-gray-dark select-none", children: t("eleo-chatbot-options-www-default", "Enable web browsing by default") })
                  ] }),
                  /* @__PURE__ */ jsxs("label", { htmlFor: "www-allow-checkbox", className: "flex items-center gap-[4px]", children: [
                    /* @__PURE__ */ jsx(
                      CheckBox,
                      {
                        id: "www-allow-checkbox",
                        checkBoxValue: chatBotInputValues.allowWebSearch,
                        setChecked: ({ checked }) => handleDispatchFieldValue({ field: "allowWebSearch", value: checked })
                      }
                    ),
                    /* @__PURE__ */ jsx("span", { className: "body-secondary text-brand-gray-dark select-none", children: t("eleo-chatbot-options-www-allow", "Allow the user to enable web browsing") })
                  ] })
                ] })
              ] }),
              !isLimited && /* @__PURE__ */ jsxs("div", { className: "col-span-2 space-y-[6px]", children: [
                /* @__PURE__ */ jsx("div", { className: "text-brand-violet-light pl-[13px] text-[12px] font-medium", children: t("chatbot-allow-user-label", "ALLOW USER TO") }),
                /* @__PURE__ */ jsxs("div", { className: "col-span-2 gap-[10px] space-y-[6px] rounded-[4px] border border-[#D9D9D9] bg-[#FFFFFF30] p-4", children: [
                  /* @__PURE__ */ jsxs("label", { htmlFor: "language-checkbox", className: "flex items-center gap-[4px]", children: [
                    /* @__PURE__ */ jsx(
                      CheckBox,
                      {
                        id: "language-checkbox",
                        checkBoxValue: chatBotInputValues.allowLanguageChange,
                        setChecked: ({ checked }) => handleDispatchFieldValue({ field: "allowLanguageChange", value: checked })
                      }
                    ),
                    /* @__PURE__ */ jsx("span", { className: "body-secondary text-brand-gray-dark select-none", children: t("eleo-chatbot-options-language-allow", "Allow the user to set language") })
                  ] }),
                  /* @__PURE__ */ jsxs("label", { htmlFor: "context-checkbox", className: "flex items-center gap-[4px]", children: [
                    /* @__PURE__ */ jsx(
                      CheckBox,
                      {
                        id: "context-checkbox",
                        checkBoxValue: chatBotInputValues.allowContext,
                        setChecked: ({ checked }) => handleDispatchFieldValue({ field: "allowContext", value: checked })
                      }
                    ),
                    /* @__PURE__ */ jsx("span", { className: "body-secondary text-brand-gray-dark select-none", children: translations.allowContext ?? t(
                      "eleo-chatbot-options-context-allow",
                      "Allow the user to add custom context"
                    ) })
                  ] }),
                  /* @__PURE__ */ jsxs("label", { htmlFor: "databases-checkbox", className: "flex items-center gap-[4px]", children: [
                    /* @__PURE__ */ jsx(
                      CheckBox,
                      {
                        id: "databases-checkbox",
                        checkBoxValue: chatBotInputValues.allowDatabases,
                        setChecked: ({ checked }) => handleDispatchFieldValue({ field: "allowDatabases", value: checked })
                      }
                    ),
                    /* @__PURE__ */ jsx("span", { className: "body-secondary text-brand-gray-dark select-none", children: t("eleo-chatbot-options-databases-allow", "Add custom databases to context") })
                  ] })
                ] })
              ] }),
              chatBotInputValues.tutor && /* @__PURE__ */ jsxs("div", { className: "col-span-2 space-y-[6px]", children: [
                /* @__PURE__ */ jsx("div", { className: "text-brand-violet-light pl-[13px] text-[12px] font-medium uppercase", children: t("chatbot-tutor-label", "tutor") }),
                /* @__PURE__ */ jsxs("div", { className: "col-span-2 gap-[10px] rounded-[4px] border border-[#D9D9D9] bg-[#FFFFFF30] p-4", children: [
                  /* @__PURE__ */ jsxs(
                    "div",
                    {
                      className: "w-full min-w-[230px] flex-1 space-y-[6px] lg:col-span-2",
                      "data-tooltip-id": "chatBotPanel-tutor",
                      children: [
                        /* @__PURE__ */ jsxs("label", { htmlFor: "tutor-checkbox", className: "flex gap-[4px] pt-[5px]", children: [
                          /* @__PURE__ */ jsx(
                            CheckBox,
                            {
                              containerClasses: "!block pt-[3px]",
                              id: "tutor-checkbox",
                              checkBoxValue: chatBotInputValues.tutor.isEnabled,
                              setChecked: ({ checked }) => handleDispatchTutorValue({ field: "isEnabled", value: checked })
                            }
                          ),
                          /* @__PURE__ */ jsx("span", { className: "body-secondary text-brand-gray-dark select-none", children: t(
                            "red-parrot-chatbot-options-enable-tutor",
                            "Add tutor to the conversation"
                          ) })
                        ] }),
                        /* @__PURE__ */ jsx("div", { className: "body-small text-brand-gray-dark mt-2 pl-[2px]", children: t("eleo-chatbot-instructions-and-context", "Instructions and context") }),
                        /* @__PURE__ */ jsx(
                          "textarea",
                          {
                            spellCheck: false,
                            className: "placeholder:text-brand-gray-dark/70 max-h-72 min-h-[68px] w-full resize-none rounded-md border px-[14px] py-[10px] text-[13px] placeholder:opacity-70",
                            placeholder: translations.instructionsPlaceholder ?? t(
                              "eleo-chatbot-instructions-placeholder",
                              "Add instructions for your chatbot"
                            ),
                            style: { fieldSizing: "content" },
                            value: chatBotInputValues.tutor.instructions,
                            onChange: (e) => handleDispatchTutorValue({
                              field: "instructions",
                              value: e.target.value
                            })
                          }
                        )
                      ]
                    }
                  ),
                  /* @__PURE__ */ jsxs("div", { className: "w-1/2 min-w-[230px] space-y-[6px] lg:col-span-2", children: [
                    /* @__PURE__ */ jsx("div", { className: "body-small text-brand-gray-dark pl-[2px]", children: t("red-parrot-chatbot-tutor-language", "Tutor language") }),
                    /* @__PURE__ */ jsx("div", { className: "flex gap-1", children: /* @__PURE__ */ jsx(
                      ReactSelect,
                      {
                        options: tutorLanguageOptions,
                        setSelectedValue: ({ value }) => handleDispatchTutorValue({ field: "language", value }),
                        placeHolder: t("eleo-chat-settings-model-default", "Default"),
                        value: transformSelectOptionValue(
                          tutorLanguageOptions,
                          chatBotInputValues.tutor.language,
                          void 0
                        ),
                        menuPlacement: DropDownMenuPlacementEnum.TOP,
                        portalToBody: true
                      }
                    ) })
                  ] })
                ] })
              ] }),
              chatBotInputValues.translator && /* @__PURE__ */ jsxs("div", { className: "col-span-2 space-y-[6px]", children: [
                /* @__PURE__ */ jsx("div", { className: "text-brand-violet-light pl-[13px] text-[12px] font-medium uppercase", children: t("chatbot-translator-label", "translator") }),
                /* @__PURE__ */ jsxs("div", { className: "col-span-2 gap-[10px] rounded-[4px] border border-[#D9D9D9] bg-[#FFFFFF30] p-4", children: [
                  /* @__PURE__ */ jsx(
                    "div",
                    {
                      className: "mb-2 w-full min-w-[230px] flex-1 space-y-[6px] lg:col-span-2",
                      "data-tooltip-id": "chatBotPanel-translator",
                      children: /* @__PURE__ */ jsxs("label", { htmlFor: "translator-checkbox", className: "flex gap-[4px] pt-[5px]", children: [
                        /* @__PURE__ */ jsx(
                          CheckBox,
                          {
                            containerClasses: "!block pt-[3px]",
                            id: "translator-checkbox",
                            checkBoxValue: chatBotInputValues.translator.isEnabled,
                            setChecked: ({ checked }) => handleDispatchTranslatorValue({ field: "isEnabled", value: checked })
                          }
                        ),
                        /* @__PURE__ */ jsx("span", { className: "body-secondary text-brand-gray-dark select-none", children: t(
                          "red-parrot-chatbot-options-enable-translator",
                          "Add translator to the conversation"
                        ) })
                      ] })
                    }
                  ),
                  /* @__PURE__ */ jsxs("div", { className: "w-1/2 min-w-[230px] space-y-[6px] lg:col-span-2", children: [
                    /* @__PURE__ */ jsx("div", { className: "body-small text-brand-gray-dark pl-[2px]", children: t("eleo-chatbot-translator-language", "Translator language") }),
                    /* @__PURE__ */ jsx("div", { className: "flex gap-1", children: /* @__PURE__ */ jsx(
                      ReactSelect,
                      {
                        options: tutorLanguageOptions,
                        setSelectedValue: ({ value }) => handleDispatchTranslatorValue({ field: "language", value }),
                        placeHolder: t("eleo-chat-settings-model-default", "Default"),
                        value: transformSelectOptionValue(
                          tutorLanguageOptions,
                          chatBotInputValues.translator.language,
                          void 0
                        ),
                        menuPlacement: DropDownMenuPlacementEnum.TOP,
                        portalToBody: true
                      }
                    ) })
                  ] })
                ] })
              ] })
            ]
          }
        )
      }
    ),
    ChatbotPublishing && /* @__PURE__ */ jsxs("div", { className: classNames(isCreatorTour ? "block" : "hidden lg:block"), children: [
      /* @__PURE__ */ jsxs(
        "div",
        {
          onClick: () => setIsShowPublishing((prev) => !prev),
          className: classNames(
            "text-brand-violet border-brand-form-accent -mx-7 flex cursor-pointer select-none items-center justify-between border-t px-[30px] py-[10px] text-[20px]"
          ),
          children: [
            /* @__PURE__ */ jsx("span", { className: "body-secondary text-brand-violet font-medium", children: t("eleo-chatbot-publishing", "Publishing") }),
            /* @__PURE__ */ jsx(
              KeyboardArrowDown,
              {
                fontSize: "inherit",
                className: classNames("!transition-all", isShowPublishing && "rotate-180")
              }
            )
          ]
        }
      ),
      /* @__PURE__ */ jsx(
        ChatbotPublishing,
        {
          isPanelLarge,
          isShowPublishing,
          publishState,
          setPublishState,
          chatbotServerState,
          chatbotDraftServerState,
          handleFileUpload,
          setModalData,
          isUpdatePending,
          isDraftSaved,
          handleGenerateChatBot
        }
      )
    ] }),
    /* @__PURE__ */ jsx("div", { className: "border-brand-form-accent -mx-7 border-b" })
  ] });
}
const introMessagesByLanguage = {
  "ar-AE": "مرحباً، كيف يمكنني مساعدتك اليوم؟",
  // Gulf Arabic
  "ca-ES": "Hola, com puc ajudar-te avui?",
  // Catalan
  "cmn-CN": "你好，今天我能为您做些什么？",
  // Chinese Mandarin
  "cs-CZ": "Ahoj, jak vám mohu dnes pomoci?",
  // Czech
  "da-DK": "Hej, hvordan kan jeg hjælpe dig i dag?",
  // Danish
  "de-AT": "Hallo, wie kann ich Ihnen heute helfen?",
  // Austrian German
  "de-CH": "Hallo, wie kann ich Ihnen heute helfen?",
  // Swiss Standard German
  "de-DE": "Hallo, wie kann ich Ihnen heute helfen?",
  // German
  "en-AU": "G'day, how can I help you today?",
  // Australian English
  "en-GB": "Hello, how can I help you today?",
  // British English
  "en-IE": "Hello, how can I help you today?",
  // Irish English
  "en-IN": "Hello, how can I help you today?",
  // Indian English
  "en-NZ": "Kia ora, how can I help you today?",
  // New Zealand English
  "en-SG": "Hello, how can I help you today?",
  // Singaporean English
  "en-US": "Hello, how can I help you today?",
  // US English
  "en-ZA": "Hello, how can I help you today?",
  // South African English
  "es-ES": "Hola, ¿cómo puedo ayudarte hoy?",
  // Castilian Spanish
  "es-MX": "Hola, ¿cómo puedo ayudarte hoy?",
  // Mexican Spanish
  "es-US": "Hola, ¿cómo puedo ayudarte hoy?",
  // US Spanish
  "fi-FI": "Hei, miten voin auttaa sinua tänään?",
  // Finnish
  "fr-BE": "Bonjour, comment puis-je vous aider aujourd'hui?",
  // Belgian French
  "fr-CA": "Bonjour, comment puis-je vous aider aujourd'hui?",
  // Canadian French
  "fr-FR": "Bonjour, comment puis-je vous aider aujourd'hui?",
  // French
  "it-IT": "Ciao, come posso aiutarti oggi?",
  // Italian
  "ja-JP": "こんにちは、今日はどのようにお手伝いできますか？",
  // Japanese
  "ko-KR": "안녕하세요, 오늘 어떻게 도와드릴까요?",
  // Korean
  "nb-NO": "Hei, hvordan kan jeg hjelpe deg i dag?",
  // Norwegian
  "nl-BE": "Hallo, hoe kan ik u vandaag helpen?",
  // Belgian Dutch
  "nl-NL": "Hallo, hoe kan ik u vandaag helpen?",
  // Dutch
  "pl-PL": "Cześć, jak mogę Ci dzisiaj pomóc?",
  // Polish
  "pt-BR": "Olá, como posso ajudá-lo hoje?",
  // Brazilian Portuguese
  "pt-PT": "Olá, como posso ajudá-lo hoje?",
  // Portuguese
  "sv-SE": "Hej, hur kan jag hjälpa dig idag?",
  // Swedish
  "tr-TR": "Merhaba, bugün size nasıl yardımcı olabilirim?",
  // Turkish
  "yue-CN": "你好，今日我可以點樣幫到你？"
  // Cantonese
};

function PublishItem({
  text,
  state = "unpublished",
  isActive = false,
  setIsActive,
  url,
  handleSettings,
  t
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);
  const popoverId = open ? "save-template" : void 0;
  const chatbotStates = {
    active: {
      styles: { background: "#00C19C" },
      text: t("eleo-chatbot-state-active-cta", "up to date")
    },
    pending: {
      styles: { background: "#F38F2B" },
      text: t("eleo-chatbot-state-pending-cta", "Publish to update changes")
    },
    disabled: {
      styles: { background: "transparent", border: "1px solid #D9D9D9", color: "#363636" },
      text: t("eleo-chatbot-state-disabled-cta", "Disabled")
    },
    unpublished: {
      styles: { background: "#FB427C" },
      text: t("eleo-chatbot-state-unpublished-cta", "Publish to activate")
    }
  };
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: classNames(
        "text-brand-text-primary box-border h-[90px] max-h-[100px] min-w-[200px] flex-1 select-none rounded-[4px] shadow-sm transition-colors duration-300",
        handleSettings ? "cursor-pointer" : "cursor-default"
      ),
      style: chatbotStates[isActive ? state : "disabled"].styles,
      onClick: () => setIsActive?.(!isActive),
      children: [
        /* @__PURE__ */ jsxs(
          "div",
          {
            className: classNames(
              "flex h-[43px] justify-between border-b p-[7px] pl-3",
              isActive ? "border-white/20" : "border-[#D9D9D9]"
            ),
            children: [
              /* @__PURE__ */ jsxs("label", { className: "pointer-events-none flex items-center gap-1", children: [
                /* @__PURE__ */ jsx(
                  CheckBox,
                  {
                    checkBoxValue: isActive,
                    classes: "checked:!border-white checked:!bg-white checked:before:!bg-brand-white ",
                    checkColor: chatbotStates[state].styles.background
                  }
                ),
                /* @__PURE__ */ jsx("div", { className: "text-[13px] leading-[1.5em]", children: text })
              ] }),
              /* @__PURE__ */ jsxs("div", { className: "flex", onClick: (e) => e.stopPropagation(), children: [
                handleSettings && /* @__PURE__ */ jsx(
                  Microbutton,
                  {
                    variant: "plain",
                    className: "hover:bg-brand-violet",
                    icon: /* @__PURE__ */ jsx(Settings, { fontSize: "inherit" }),
                    onClick: handleSettings
                  }
                ),
                url && /* @__PURE__ */ jsxs(Fragment, { children: [
                  /* @__PURE__ */ jsx(
                    Microbutton,
                    {
                      variant: "plain",
                      className: "hover:bg-brand-violet",
                      icon: /* @__PURE__ */ jsx(MoreVert, { fontSize: "inherit" }),
                      onClick: handleClick
                    }
                  ),
                  /* @__PURE__ */ jsx(
                    Popover,
                    {
                      id: popoverId,
                      open,
                      anchorEl,
                      onClose: handleClose,
                      anchorOrigin: {
                        vertical: "top",
                        horizontal: "left"
                      },
                      transformOrigin: {
                        vertical: "bottom",
                        horizontal: "left"
                      },
                      children: /* @__PURE__ */ jsxs("div", { className: "p-2 pb-[10px]", children: [
                        /* @__PURE__ */ jsx(
                          ListPosition,
                          {
                            text: t("eleo-open-in-new", "Open in new window"),
                            icon: /* @__PURE__ */ jsx(OpenInNew, { fontSize: "inherit" }),
                            onClick: () => {
                              window.open(url, "_blank");
                              handleClose();
                            }
                          }
                        ),
                        /* @__PURE__ */ jsx(
                          ListPosition,
                          {
                            text: t("eleo-copy-link", "Copy link"),
                            icon: /* @__PURE__ */ jsx(ContentCopy, { fontSize: "inherit" }),
                            onClick: () => {
                              CopyToClipBoard(url);
                              handleClose();
                            }
                          }
                        )
                      ] })
                    }
                  )
                ] })
              ] })
            ]
          }
        ),
        /* @__PURE__ */ jsx(
          "div",
          {
            className: classNames(
              "flex items-center justify-center text-nowrap px-[14px] py-3 text-[13px] font-bold uppercase",
              !isActive && "opacity-50"
            ),
            children: chatbotStates[isActive ? state : "disabled"].text
          }
        )
      ]
    }
  );
}

const docTypes = [
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'text/plain',
  'text/csv',
  // 'audio/mpeg',
];

function MessageLoader({ usesContext, t }) {
  return /* @__PURE__ */ jsxs("div", { className: "text-brand-text-secondary flex items-center gap-2", children: [
    /* @__PURE__ */ jsx(
      CircularProgress,
      {
        disableShrink: true,
        size: 18,
        sx: { animationDuration: "1000ms" },
        color: "inherit"
      }
    ),
    usesContext && /* @__PURE__ */ jsx("div", { className: "opacity-90", children: t("eleo-chat-loader", "Searching... This could take a few minutes.") })
  ] });
}

const iconMap$1 = {
  story: /* @__PURE__ */ jsx(Article, { fontSize: "inherit" }),
  document: /* @__PURE__ */ jsx(Description, { fontSize: "inherit" }),
  website: /* @__PURE__ */ jsx(WebAsset, { fontSize: "inherit" })
};
const fileTypeMap = {
  "application/pdf": "pdf",
  "application/msword": "doc",
  "text/plain": "txt",
  "text/csv": "csv",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": "docx",
  "image/png": "png",
  "image/jpg": "jpg",
  "image/jpeg": "jpeg",
  "image/webp": "webp"
};
const MessageContextItem = ({
  item,
  messageContext,
  isEditable = true,
  setImagePreviewData
}) => {
  return item.type === "image" ? /* @__PURE__ */ jsx("div", { className: "relative h-[40px]", children: item.content ? /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      "img",
      {
        alt: item.label,
        src: item.content,
        className: "h-[40px] cursor-pointer rounded-[4px] object-contain",
        onClick: () => setImagePreviewData?.({
          target: item.content,
          isMobile: false,
          isVisible: true
        })
      }
    ),
    isEditable && /* @__PURE__ */ jsx(
      Microbutton,
      {
        variant: "plain",
        iconPlacement: "left",
        icon: /* @__PURE__ */ jsx(Close, { fontSize: "inherit" }),
        className: classNames(
          "hover:text-brand-text-primary absolute bottom-1/2 left-1/2 size-[28px] -translate-x-1/2 -translate-y-1/2 text-transparent hover:bg-[#6363E6]"
        ),
        onClick: () => messageContext.removeDocument(item.id)
      }
    )
  ] }) : /* @__PURE__ */ jsx("div", { className: "flex size-[40px] items-center justify-center", children: /* @__PURE__ */ jsx(
    CircularProgress,
    {
      disableShrink: true,
      size: 24,
      sx: { animationDuration: "1000ms" },
      color: "inherit"
    }
  ) }) }) : /* @__PURE__ */ jsxs(
    "div",
    {
      title: item.label,
      className: "text-brand-text-secondary group relative flex h-[40px] max-w-[100px] items-center gap-[6px] rounded-[4px] bg-black/5 p-2 pr-3 text-[12px]",
      children: [
        /* @__PURE__ */ jsx("div", { className: "flex text-[24px]", children: iconMap$1[item.type] }),
        /* @__PURE__ */ jsxs("div", { className: "truncate", children: [
          /* @__PURE__ */ jsx("div", { className: "min-w-0 max-w-[130px] truncate", children: item.label }),
          /* @__PURE__ */ jsx("div", { className: "min-w-0 max-w-[130px] text-[11px] font-light uppercase opacity-50", children: fileTypeMap[item.metadata?.type ?? ""] ?? "" })
        ] }),
        isEditable && /* @__PURE__ */ jsxs("div", { className: "text-brand-violet bg-brand-gray-light absolute right-[6px] flex rounded-[8px] opacity-0 shadow-sm transition-all group-hover:opacity-100", children: [
          ["image", "document"].includes(item.type) && /* @__PURE__ */ jsx(
            Microbutton,
            {
              variant: "plain",
              iconPlacement: "left",
              icon: /* @__PURE__ */ jsx(Download, { fontSize: "inherit" }),
              className: "hover:text-brand-text-primary flex rounded-r-none !p-1 hover:bg-[#6363E6]",
              onClick: () => item.content && downloadFile(item.content)
            }
          ),
          /* @__PURE__ */ jsx(
            Microbutton,
            {
              variant: "plain",
              iconPlacement: "left",
              icon: /* @__PURE__ */ jsx(Close, { fontSize: "inherit" }),
              className: classNames(
                "hover:text-brand-text-primary !p-1 hover:bg-[#6363E6]",
                ["image", "document"].includes(item.type) && "rounded-l-none"
              ),
              onClick: () => messageContext.removeDocument(item.id)
            }
          )
        ] })
      ]
    }
  );
};

function Story({ items, setItems, messageContext, t }) {
  const navigate = useNavigate();
  const handleCheck = (data) => {
    if (data.checked && !items.some((item) => item.id === data.checkBoxName)) {
      const checkedStory = messageContext.stories.data.find(
        (story) => story.id === data.checkBoxName
      );
      setItems((prev) => [
        ...prev,
        {
          label: checkedStory.label,
          content: checkedStory.content,
          id: checkedStory.id,
          isValid: true
        }
      ]);
    } else {
      setItems((prev) => prev.filter((item) => item.id !== data.checkBoxName));
    }
  };
  return /* @__PURE__ */ jsx("div", { className: "xs:px-[26px] space-y-[6px] px-3 py-5", children: /* @__PURE__ */ jsxs("div", { className: "text-brand-violet text-[13px]", children: [
    messageContext.stories.data?.map((story) => /* @__PURE__ */ jsxs(
      "label",
      {
        className: classNames(
          "hover:bg-brand-violet/10 group flex h-[32px] items-center gap-x-[10px] truncate rounded-[4px] bg-white py-2 pl-3 pr-3 transition-all duration-300"
        ),
        children: [
          /* @__PURE__ */ jsx(
            CheckBox,
            {
              checkBoxName: story.id,
              checkBoxValue: items.some((item) => item.id === story.id),
              setChecked: (data) => handleCheck(data),
              classes: "border-brand-violet"
            }
          ),
          /* @__PURE__ */ jsx(
            "div",
            {
              className: classNames(items.some((item) => item.id === story.id) && "font-medium"),
              children: story.label
            }
          )
        ]
      },
      story.id
    )),
    messageContext.stories?.length && /* @__PURE__ */ jsx("div", { className: "border-brand-violet/20 mx-[14px] my-[6px] border-b" }),
    /* @__PURE__ */ jsx(
      Microbutton,
      {
        iconPlacement: "left",
        variant: "plain",
        icon: /* @__PURE__ */ jsx(Add, { fontSize: "inherit" }),
        text: t("eleo-context-modal-create-story", "Create new story"),
        onClick: () => navigate("/account/your-story"),
        className: "hover:bg-brand-violet/10 !justify-start",
        iconSize: 14
      }
    )
  ] }) });
}

function Website({ items, setItems, t }) {
  return /* @__PURE__ */ jsx("div", { className: "xs:px-[26px] space-y-[6px] px-3 py-5", children: /* @__PURE__ */ jsx("div", { className: "text-brand-violet text-[13px]", children: /* @__PURE__ */ jsxs(
    "label",
    {
      htmlFor: "url-input",
      className: classNames(
        "hover:bg-brand-violet/10 group flex items-center gap-x-[10px] truncate rounded-[4px] bg-white py-2 pl-3 pr-3 transition-all duration-300"
      ),
      children: [
        /* @__PURE__ */ jsx("span", { className: "text-brad-violet flex text-[14px]", children: /* @__PURE__ */ jsx(WebAsset, { fontSize: "inherit" }) }),
        /* @__PURE__ */ jsx(
          "input",
          {
            id: "url-input",
            autoFocus: true,
            type: "url",
            placeholder: t("eleo-context-modal-url-input-placeholder", "Enter a website address"),
            value: items[0]?.label ?? "",
            onChange: (e) => {
              setItems([
                {
                  label: e.target.value,
                  content: e.target.value,
                  isValid: isValidUrl(e.target.value)
                }
              ]);
            },
            className: "caret-brand-violet w-full bg-transparent"
          }
        ),
        items[0] && !items[0].isValid && /* @__PURE__ */ jsxs("div", { className: "text-brand-pink flex items-center gap-1 text-nowrap", children: [
          /* @__PURE__ */ jsx(Error$1, { className: "text-[14px]", fontSize: "inherit" }),
          t("eleo-context-modal-invalid-url", "Enter a valid url")
        ] })
      ]
    }
  ) }) });
}

const contentMap = {
  website: Website,
  story: Story
};
function MessageContextModal({
  modal,
  setModal,
  messageContext,
  t
}) {
  const [items, setItems] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const handleCloseModal = (e) => {
    e.stopPropagation();
    if (e.target === e.currentTarget) {
      setModal({ visible: false, content: "" });
    }
  };
  const Content = modal.content ? contentMap[modal.content] : null;
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: "fixed bottom-0 left-0 right-0 top-0 z-[9999] bg-white/80",
      onClick: handleCloseModal,
      children: /* @__PURE__ */ jsxs("div", { className: "xs:border absolute left-1/2 top-1/2 flex max-h-[90dvh] w-[min(500px,100vw)] -translate-x-1/2 -translate-y-1/2 flex-col rounded-[4px] border-[#D9D9D9] bg-white shadow-[0_0_20px_#00000020]", children: [
        /* @__PURE__ */ jsxs("div", { className: "bg-brand-violet text-brand-text-primary space-y-1 rounded-t-[3px] pb-[50px] pl-[24px] pr-[16px] pt-[14px]", children: [
          /* @__PURE__ */ jsxs("div", { className: "flex items-center justify-between", children: [
            /* @__PURE__ */ jsx("div", { className: "text-[14px] font-medium", children: t(`eleo-chat-message-context-modal-title-${modal.content}`) }),
            /* @__PURE__ */ jsx(
              "button",
              {
                type: "button",
                className: "size-[28px] cursor-pointer text-[18px]",
                onClick: () => setModal({ visible: false, content: "" }),
                children: /* @__PURE__ */ jsx(Close, { fontSize: "inherit" })
              }
            )
          ] }),
          /* @__PURE__ */ jsx("div", { className: "text-brand-text-primary/70 text-[12px] leading-[1.3em]", children: t(`eleo-chat-message-context-modal-info-${modal.content}`) })
        ] }),
        /* @__PURE__ */ jsx("div", { className: "overflow-y-auto", children: Content && /* @__PURE__ */ jsx(
          Content,
          {
            items,
            setItems,
            messageContext,
            isLoading,
            setIsLoading,
            t
          }
        ) }),
        /* @__PURE__ */ jsx("div", { className: "border-b" }),
        /* @__PURE__ */ jsxs("div", { className: "flex gap-[14px] px-[24px] py-[14px] text-[13px] capitalize", children: [
          /* @__PURE__ */ jsx(
            "button",
            {
              type: "button",
              className: "bg-brand-violet/10 hover:bg-brand-violet/20 hover:text-brand-violet text-brand-violet-light h-[40px] w-full rounded-[4px] font-bold uppercase transition-colors",
              onClick: () => setModal({ visible: false, content: "" }),
              children: t("eleo-modal-cancel-button", "Cancel")
            }
          ),
          /* @__PURE__ */ jsx(
            "button",
            {
              type: "button",
              disabled: isLoading || items.some((item) => !item.isValid),
              className: classNames(
                "bg-brand-violet hover:bg-brand-violet-light text-brand-text-primary h-[40px] w-full rounded-[4px] font-bold transition-colors",
                items.some((item) => !item.isValid) && "opacity-70"
              ),
              onClick: () => {
                items.forEach(
                  (item) => messageContext.addDocument({
                    label: item.label,
                    type: modal.content,
                    content: item.content,
                    id: item.id ?? v4()
                  })
                );
                setModal({ visible: false, content: "" });
              },
              children: "OK"
            }
          )
        ] })
      ] })
    }
  );
}

function ChatTextInput({
  state,
  dispatch,
  handleSubmit,
  messageContext,
  isGenerating,
  setShowWebCam,
  handleStopRequest,
  enableEnhance = true,
  isChatbot = false,
  t,
  useTranscribe,
  ContextMenu,
  audioStream,
  setAudioStream,
  chatId
}) {
  const { width } = useWindowDimensions();
  const changeWritingDirection = detectRtlDirection(state.language.value);
  const [params] = useSearchParams();
  const isEmbed = params.get("embed");
  const textAreaRef = useRef(null);
  const [modal, setModal] = useState({ visible: false, content: "" });
  const [isEnhance, setIsEnhance] = useState(false);
  const [hasCamera, setHasCamera] = useState(false);
  const [previousInput, setPreviousInput] = useState("");
  const {
    toggleTranscribe,
    stopTranscribe,
    isLoading: isTranscriptionLoading,
    isTranscribing: isRecording
  } = useTranscribe({
    callback: useCallback(
      (text) => {
        console.log(text);
        if (previousInput?.length)
          dispatch({ type: "SET_INPUT", payload: previousInput + " " + text });
        else dispatch({ type: "SET_INPUT", payload: text });
      },
      [dispatch, previousInput]
    ),
    isChatbot,
    chatId
  });
  useEffect(() => {
    detectCamera();
  }, []);
  useEffect(() => {
    if (!state.model?.supportsImages) messageContext?.removeDocumentsOfType("image");
  }, [state.model]);
  useEffect(() => {
    if (!state.inputValue.length) setPreviousInput("");
  }, [state.inputValue]);
  useEffect(() => {
    if (isEmbed) return () => {
    };
    const timeout = setTimeout(() => {
      if (width > 460) textAreaRef.current?.focus();
    }, 50);
    return () => clearTimeout(timeout);
  }, [width]);
  useEffect(() => {
    function handlePaste(e) {
      if (!e.clipboardData) return;
      const items = e.clipboardData.items;
      for (let i = 0; i < items.length; i++) {
        if (items[i].type.indexOf("image") !== -1 && state.model?.supportsImages) {
          const file = items[i].getAsFile();
          if (file) {
            handleImageUpload({ preventDefault: () => {
            }, target: { files: [file] } });
          }
          break;
        }
      }
    }
    if (state.model) document.addEventListener("paste", handlePaste);
    return () => {
      document.removeEventListener("paste", handlePaste);
    };
  }, [state.model]);
  async function handleImageUpload(e) {
    if (!messageContext) return;
    e.preventDefault();
    let file;
    if ("dataTransfer" in e && e.dataTransfer?.files?.length) {
      file = e.dataTransfer.files[0];
    } else if ("target" in e && e.target?.files?.length) {
      file = e.target.files[0];
    }
    if (!file) return;
    messageContext.removeDocumentsOfType("image");
    const id = v4();
    messageContext.addDocument({
      id,
      label: file.name,
      content: null,
      type: "image",
      invalid: true,
      metadata: { type: file.type }
    });
    const options = {
      maxSizeMB: 1,
      maxWidthOrHeight: 1024,
      useWebWorker: true
    };
    try {
      const compressedFile = await imageCompression(file, options);
      const reader = new FileReader();
      reader.onload = () => {
        const imageBlob = new Blob([reader.result], { type: file.type });
        messageContext.setDocContext(
          (prev) => prev.map(
            (item) => item.id === id ? { ...item, content: URL.createObjectURL(imageBlob), invalid: false } : item
          )
        );
      };
      reader.onerror = function() {
        errorToast(t("eleo-error-image-upload", "Failed to upload your image"));
      };
      reader.readAsArrayBuffer(compressedFile);
    } catch (error) {
      console.log(error);
    } finally {
      if ("target" in e && e.target) {
        e.target.value = "";
      }
    }
  }
  async function handleDocumentUpload(e) {
    if (!messageContext) return;
    e.preventDefault();
    const files = e.target.files;
    if (!files?.length) return;
    for (const file of files) {
      if (!docTypes.includes(file.type)) {
        return errorToast(
          t("eleo-your-story-document-not-supported", "This document type is not supported")
        );
      }
      messageContext.addDocument({
        label: file.name,
        type: "document",
        id: v4(),
        content: file,
        isChunk: false,
        metadata: { type: file.type }
      });
    }
    e.target.value = "";
  }
  const handleKeyDown = (event) => {
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault();
      handleSubmit();
    }
  };
  const handleOpenModal = (type) => {
    setModal({ visible: true, content: type });
  };
  const detectCamera = async () => {
    try {
      const devices = await navigator.mediaDevices.enumerateDevices();
      const videoDevices = devices.filter((device) => device.kind === "videoinput");
      if (videoDevices.length > 0) {
        setHasCamera(true);
      }
    } catch (error) {
      errorToast(t("eleo-generic-error"));
    }
  };
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    isEnhance && /* @__PURE__ */ jsx("div", { className: "absolute left-1/2 top-0 z-50 -translate-x-2/3 -translate-y-[calc(100%-60px)]", children: /* @__PURE__ */ jsx(
      ContextMenu,
      {
        noHeader: true,
        selectedText: state.inputValue,
        getTextContext: () => state.inputValue,
        tools: ["rephrase"],
        forceNotSynonyms: true,
        regenerateUrl: "/api/ai/enhance_prompt",
        type: "chat",
        language: state.language.value,
        handleChangeSelectedText: (newText) => {
          dispatch({ type: "SET_INPUT", payload: newText });
          setIsEnhance(false);
        },
        onClose: () => setIsEnhance(false)
      }
    ) }),
    /* @__PURE__ */ jsxs(
      "div",
      {
        id: "chat-input",
        className: "xs:gap-2 xs:p-2 bg-brand-chat-backdrop relative flex w-full max-w-[1000px] overflow-x-hidden rounded-[4px] shadow-[0_0_50px_rgb(var(--chat-backdrop)/40%),0_0_10px_rgb(var(--chat-backdrop)/60%)]",
        children: [
          /* @__PURE__ */ jsxs("div", { className: "xs:rounded-[4px] flex flex-1 rounded-l-[4px] bg-white", children: [
            /* @__PURE__ */ jsxs("div", { className: "flex h-full w-full flex-1 flex-col", children: [
              isRecording && !state.inputValue.length ? /* @__PURE__ */ jsx("div", { className: "text-brand-violet xs:pl-4 xs:pt-5 h-full w-full pl-2 pt-3 text-[15px] font-medium leading-[1.2em]", children: t("eleo-chat-tts-placeholder", "Im listening... You can speak now.") }) : /* @__PURE__ */ jsx(
                "textarea",
                {
                  style: { fieldSizing: "content" },
                  ref: textAreaRef,
                  className: classNames(
                    "xs:p-[10px] max-h-[300px] flex-1 resize-none rounded-[4px] p-2 text-[15px] leading-[1.5em] transition-all",
                    (isGenerating || isTranscriptionLoading) && "bg-[#efefef40]",
                    Boolean(messageContext?.docContext.length) && "mb-[6px] h-[54px] pb-0"
                  ),
                  rows: 1,
                  spellCheck: false,
                  dir: changeWritingDirection ? "rtl" : "ltr",
                  placeholder: t("eleo-chat-input-placeholder", "Write a message..."),
                  value: state.inputValue,
                  onChange: (e) => dispatch({ type: "SET_INPUT", payload: e.target.value }),
                  onKeyDown: handleKeyDown
                }
              ),
              Boolean(messageContext?.docContext.length) && /* @__PURE__ */ jsx(
                "div",
                {
                  className: classNames(
                    "xs:p-[10px] flex flex-wrap items-center gap-x-2 gap-y-1 p-2 pt-0",
                    (isGenerating || isTranscriptionLoading) && "pointer-events-none bg-[#efefef40]"
                  ),
                  children: messageContext?.docContext.map((item) => /* @__PURE__ */ jsx(MessageContextItem, { item, messageContext }, item.id))
                }
              )
            ] }),
            /* @__PURE__ */ jsx(
              "div",
              {
                className: classNames(
                  "xs:flex-col xs:items-end xs:p-[10px] hidden items-start justify-start p-2 !pr-0 transition-all sm:flex"
                ),
                children: enableEnhance && /* @__PURE__ */ jsx(
                  Microbutton,
                  {
                    iconPlacement: "left",
                    variant: "transparent",
                    icon: /* @__PURE__ */ jsx(AutoAwesome, { fontSize: "small" }),
                    text: t("eleo-enhance", "Enhance"),
                    className: classNames(
                      "!text-brand-gray hover:!text-brand-text-primary h-[40px]",
                      !state.inputValue?.length && "pointer-events-none"
                    ),
                    onClick: () => setIsEnhance(true)
                  }
                )
              }
            ),
            /* @__PURE__ */ jsxs(
              "div",
              {
                className: classNames(
                  "xs:flex-col xs:items-end xs:p-[10px] flex items-start justify-start p-2 !pl-[6px] transition-all",
                  (isGenerating || isTranscriptionLoading) && "pointer-events-none bg-[#efefef40]"
                ),
                children: [
                  /* @__PURE__ */ jsxs(
                    "div",
                    {
                      id: "speech-to-text",
                      className: classNames(
                        "flex",
                        (isGenerating || isTranscriptionLoading) && "pointer-events-none opacity-40"
                      ),
                      onClick: () => {
                        if (state.inputValue?.length) setPreviousInput(state.inputValue);
                        if (audioStream && !isRecording) setAudioStream();
                        toggleTranscribe();
                      },
                      children: [
                        /* @__PURE__ */ jsx(
                          "div",
                          {
                            "data-tooltip-id": width >= 740 && `eleo-tooltip`,
                            "data-tooltip-keyname": "eleo-chat-tooltip-stt",
                            "data-tooltip-hidden": isRecording,
                            className: classNames(
                              "text-brand-gray relative flex size-[40px] cursor-pointer items-center justify-center rounded-[4px] bg-black/5 transition-colors ",
                              isRecording ? "rounded-r-none" : "hover:bg-brand-violet hover:text-brand-text-primary"
                            ),
                            children: isTranscriptionLoading ? /* @__PURE__ */ jsx(MessageLoader, { t, usesContext: false }) : isRecording ? /* @__PURE__ */ jsxs("div", { className: "text-brand-text-primary h-full w-full", children: [
                              /* @__PURE__ */ jsx(
                                "div",
                                {
                                  style: {
                                    animation: "myAnimation 1.5s infinite",
                                    animationTimingFunction: "ease-in-out"
                                  },
                                  className: "bg-brand-violet absolute left-1/4 top-1/4 size-5 rounded-full"
                                }
                              ),
                              /* @__PURE__ */ jsx(Mic, { className: "absolute left-1/2 top-1/2 size-5 -translate-x-1/2 -translate-y-1/2" })
                            ] }) : /* @__PURE__ */ jsx(Mic, {})
                          }
                        ),
                        /* @__PURE__ */ jsx(
                          "div",
                          {
                            className: classNames(
                              "text-brand-gray flex size-[40px] cursor-pointer items-center justify-center rounded-r-[4px] bg-black/5 transition-all",
                              isRecording ? "" : "w-0 opacity-0"
                            ),
                            children: /* @__PURE__ */ jsx(MicOff, {})
                          }
                        )
                      ]
                    }
                  ),
                  messageContext && /* @__PURE__ */ jsx(
                    MessageContext,
                    {
                      id: "message-context",
                      translations: {
                        header: t("eleo-chat-message-context-header", "Add context to this message"),
                        documentsLabel: t("eleo-chat-message-context-document", "Document"),
                        imagesLabel: t("eleo-chat-message-context-image", "Image"),
                        websitesLabel: t("eleo-chat-message-context-website", "Website"),
                        storiesLabel: t("eleo-feature-your-story", "Your Story"),
                        cameraLabel: t("eleo-feature-take-a-picture", "Take a picture")
                      },
                      tooltipId: width >= 740 && `eleo-tooltip`,
                      tooltipKeyname: `eleo-chat-tooltip-message-context`,
                      hideTooltip: modal.visible,
                      isDisabled: isGenerating || isTranscriptionLoading,
                      handleOpenModal,
                      enableImages: state.model?.supportsImages,
                      handleImageUpload,
                      handleDocumentUpload,
                      handleShowWebCam: () => setShowWebCam(true),
                      disableWebsites: messageContext.docContext?.filter((doc) => doc.type === "website").length >= 5,
                      showCameraContext: hasCamera
                    }
                  )
                ]
              }
            )
          ] }),
          /* @__PURE__ */ jsx(
            "button",
            {
              type: "button",
              title: t("eleo-chat-tooltip-send", "Send query"),
              disabled: isTranscriptionLoading,
              className: classNames(
                "bg-brand-violet xs:rounded-[4px] xs:w-[194px] text-brand-text-primary w-[56px] rounded-r-[4px] text-[15px] uppercase leading-[1.2em]",
                (isGenerating || isTranscriptionLoading) && "bg-opacity-50 opacity-80"
              ),
              onClick: () => {
                if (isGenerating) return handleStopRequest();
                if (isRecording) {
                  stopTranscribe();
                }
                handleSubmit();
              },
              children: isGenerating ? /* @__PURE__ */ jsxs(
                "div",
                {
                  className: "flex items-center justify-center gap-[6px] text-[18px]",
                  onClick: () => handleStopRequest(),
                  children: [
                    width >= 466 && /* @__PURE__ */ jsx("span", { className: "text-[15px]", children: t("eleo-chat-input-abort", "stop") }),
                    " ",
                    /* @__PURE__ */ jsx(StopCircle, { fontSize: "inherit" })
                  ]
                }
              ) : width < 466 ? /* @__PURE__ */ jsx("span", { className: "text-[22px]", children: /* @__PURE__ */ jsx(TransitEnterexit, { fontSize: "inherit", className: "rotate-[135deg]" }) }) : t("eleo-chat-input-submit", "send")
            }
          )
        ]
      }
    ),
    modal.visible && /* @__PURE__ */ jsx(
      MessageContextModal,
      {
        modal,
        setModal,
        messageContext,
        t
      }
    )
  ] });
}

const AUDIO_MIME_TYPES = [
  "audio/webm;codecs=opus",
  "audio/webm",
  "audio/mp4",
  "audio/ogg;codecs=opus"
];
const DEFAULT_AUDIO_MIME_TYPE = "audio/webm";
const getSupportedAudioMimeType = () => {
  if (typeof MediaRecorder === "undefined" || typeof MediaRecorder.isTypeSupported !== "function") {
    return "";
  }
  return AUDIO_MIME_TYPES.find((mimeType) => MediaRecorder.isTypeSupported(mimeType)) || "";
};
const getAudioFileExtension = (mimeType = "") => {
  if (mimeType.includes("ogg")) return "ogg";
  if (mimeType.includes("mp4")) return "mp4";
  if (mimeType.includes("mpeg") || mimeType.includes("mp3")) return "mp3";
  return "webm";
};
const getAudioFileName = (mimeType = "") => `audio.${getAudioFileExtension(mimeType)}`;
const createAudioRecorder = ({
  audioConstraints = true
} = {}) => {
  let chunks = [];
  let mediaRecorder = null;
  let mediaStream = null;
  let pendingStopPromise = null;
  let startTimestamp = 0;
  const clearState = () => {
    chunks = [];
    mediaRecorder = null;
    pendingStopPromise = null;
    startTimestamp = 0;
  };
  const stopTracks = () => {
    mediaStream?.getTracks().forEach((track) => track.stop());
    mediaStream = null;
  };
  const cleanup = () => {
    stopTracks();
    clearState();
  };
  return {
    async start() {
      if (mediaRecorder && mediaRecorder.state !== "inactive") return;
      cleanup();
      if (!navigator.mediaDevices?.getUserMedia || typeof MediaRecorder === "undefined") {
        throw new Error("Audio recording is not supported in this environment");
      }
      mediaStream = await navigator.mediaDevices.getUserMedia({ audio: audioConstraints });
      const supportedMimeType = getSupportedAudioMimeType();
      try {
        mediaRecorder = supportedMimeType ? new MediaRecorder(mediaStream, { mimeType: supportedMimeType }) : new MediaRecorder(mediaStream);
      } catch (error) {
        cleanup();
        throw error instanceof Error ? error : new Error(String(error));
      }
      chunks = [];
      startTimestamp = performance.now();
      await new Promise((resolve, reject) => {
        if (!mediaRecorder) {
          reject(new Error("Recorder was not created"));
          return;
        }
        const handleStart = () => resolve();
        const handleError = (event) => {
          const recorderError = event.error || new Error("Failed to start recording");
          cleanup();
          reject(recorderError);
        };
        mediaRecorder.addEventListener("dataavailable", (recordingEvent) => {
          if (recordingEvent.data?.size) {
            chunks.push(recordingEvent.data);
          }
        });
        mediaRecorder.addEventListener("start", handleStart, { once: true });
        mediaRecorder.addEventListener("error", handleError, { once: true });
        try {
          mediaRecorder.start();
        } catch (error) {
          cleanup();
          const recorderError = error instanceof Error ? error : new Error("Failed to start recording");
          reject(recorderError);
        }
      });
    },
    async stop() {
      const recorder = mediaRecorder;
      if (!recorder) return null;
      if (pendingStopPromise) return pendingStopPromise;
      if (recorder.state === "inactive") {
        cleanup();
        return null;
      }
      pendingStopPromise = new Promise((resolve, reject) => {
        const mimeType = recorder.mimeType || getSupportedAudioMimeType() || DEFAULT_AUDIO_MIME_TYPE;
        const handleStop = () => {
          const blob = new Blob(chunks, { type: mimeType });
          const resolvedMimeType = blob.type || mimeType;
          const result = {
            blob,
            durationMs: Math.max(0, performance.now() - startTimestamp),
            fileName: getAudioFileName(resolvedMimeType),
            mimeType: resolvedMimeType,
            size: blob.size
          };
          cleanup();
          resolve(result);
        };
        const handleError = (event) => {
          const recorderError = event.error || new Error("Failed to stop recording");
          cleanup();
          reject(recorderError);
        };
        recorder.addEventListener("stop", handleStop, { once: true });
        recorder.addEventListener("error", handleError, { once: true });
        recorder.stop();
      });
      return pendingStopPromise;
    },
    async cancel() {
      const recorder = mediaRecorder;
      if (!recorder) {
        cleanup();
        return;
      }
      if (pendingStopPromise) {
        try {
          await pendingStopPromise;
        } catch (_) {
        }
        return;
      }
      if (recorder.state === "inactive") {
        cleanup();
        return;
      }
      chunks = [];
      await new Promise((resolve) => {
        const finish = () => {
          cleanup();
          resolve();
        };
        recorder.addEventListener("stop", finish, { once: true });
        recorder.addEventListener("error", finish, { once: true });
        recorder.stop();
      });
    },
    getStream() {
      return mediaStream;
    },
    isRecording() {
      return mediaRecorder?.state === "recording";
    }
  };
};

const FilledPieLoader = ({ progress = 0, size = 100, fillColor = "rgb(82 82 158)" }) => {
  const center = size / 2;
  const radius = size / 2;
  const progressRadians = progress / 100 * 2 * Math.PI;
  const startAngle = -Math.PI / 2;
  const endAngle = startAngle - progressRadians;
  const largeArcFlag = progress > 50 ? 1 : 0;
  const startX = center + radius * Math.cos(startAngle);
  const startY = center + radius * Math.sin(startAngle);
  const endX = center + radius * Math.cos(endAngle);
  const endY = center + radius * Math.sin(endAngle);
  let path = "";
  if (progress === 0) {
    path = "";
  } else if (progress === 100) {
    path = `M ${center},${center} L ${startX},${startY} A ${radius},${radius} 0 1,0 ${startX - 1e-3},${startY} Z`;
  } else {
    path = `M ${center},${center} L ${startX},${startY} A ${radius},${radius} 0 ${largeArcFlag},0 ${endX},${endY} Z`;
  }
  return /* @__PURE__ */ jsxs("svg", { className: "h-full w-full", viewBox: `0 0 ${size} ${size}`, children: [
    progress === 100 && /* @__PURE__ */ jsx("circle", { cx: center, cy: center, r: radius, fill: fillColor }),
    progress > 0 && /* @__PURE__ */ jsx("path", { d: path, fill: fillColor })
  ] });
};

function AudioInputLayout({
  isRecording,
  speechVolume,
  isLoading,
  onMouseDown,
  onMouseUp,
  onClick,
  getStatusText,
  voiceDetectedTime,
  loader
}) {
  const [progress, setProgress] = useState(100);
  useEffect(() => {
    const interval = setInterval(() => {
      if (voiceDetectedTime) {
        const elapsedTime = performance.now() - voiceDetectedTime;
        setProgress(Math.max(0, 100 - (elapsedTime < 1e3 ? 0 : elapsedTime - 1e3) / 20));
      } else {
        setProgress(100);
        clearInterval(interval);
      }
    }, 50);
    return () => {
      clearInterval(interval);
    };
  }, [voiceDetectedTime]);
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsxs(
      "div",
      {
        className: classNames(
          "absolute left-1/2 top-0 -translate-x-1/2 -translate-y-1/2 select-none"
        ),
        children: [
          /* @__PURE__ */ jsx("div", { className: "absolute inset-0 -z-20 scale-[70%] rounded-full bg-white transition-all" }),
          /* @__PURE__ */ jsx(
            "div",
            {
              className: "absolute inset-0 -z-10 rounded-full transition-all",
              style: {
                ...isRecording && {
                  transform: `scaleX(${0.7 + speechVolume * 3}) scaleY(${0.7 + speechVolume * 3})`
                }
              },
              children: voiceDetectedTime ? /* @__PURE__ */ jsx(
                FilledPieLoader,
                {
                  progress: isRecording && !speechVolume ? progress : 100,
                  fillColor: "rgb(82 82 158)"
                }
              ) : /* @__PURE__ */ jsx(
                "div",
                {
                  className: classNames(
                    " h-full w-full rounded-full",
                    isLoading ? "bg-brand-form-accent" : "bg-brand-violet-light"
                  )
                }
              )
            }
          ),
          /* @__PURE__ */ jsx(
            "div",
            {
              className: classNames(
                "absolute inset-0 -z-10 rounded-full transition-all",
                isRecording || isLoading ? "bg-brand-form-accent" : "bg-brand-violet-light"
              ),
              style: {
                transition: "transform 0.45s cubic-bezier(0.25, 0.1, 0, 1.5)",
                ...isRecording && {
                  animation: "pulseAnimation 2s infinite"
                }
              }
            }
          ),
          /* @__PURE__ */ jsx(
            "div",
            {
              className: classNames(
                "pointer-events-none absolute inset-0 z-30 flex items-center justify-center",
                isRecording || isLoading ? "text-brand-text-primary" : "text-brand-text-primary"
              ),
              children: isLoading ? loader : /* @__PURE__ */ jsx(Mic, {})
            }
          ),
          /* @__PURE__ */ jsx(
            "div",
            {
              className: classNames("size-[60px] cursor-pointer select-none"),
              onMouseDown: (e) => {
                setProgress(100);
                if ("ontouchstart" in window || navigator.maxTouchPoints > 0) return;
                onMouseDown(e);
              },
              onMouseUp: (e) => {
                if ("ontouchstart" in window || navigator.maxTouchPoints > 0) return;
                onMouseUp(e);
              },
              onTouchStart: onMouseDown,
              onTouchEnd: onMouseUp,
              onClick,
              onContextMenu: (e) => e.preventDefault()
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ jsx("div", { className: "flex w-full gap-1 rounded-[4px] px-4 sm:mt-4 md:justify-center 2xl:mt-3", children: /* @__PURE__ */ jsx("span", { className: "text-brand-violet-light h-[30px] text-[12px] leading-[1.2em]", children: getStatusText() }) })
  ] });
}

function ChatPushToTalkInput({
  state,
  isGenerating,
  handleSubmit,
  handleStopRequest,
  audioStream,
  setAudioStream,
  isChatbot = false,
  t,
  T,
  useGetTranscription,
  lastMessage,
  loader,
  isFocused = true,
  chatId,
  showSignupModal,
  user,
  setSpeechStartTimestamp,
  recordingCallback
}) {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [isRecording, setIsRecording] = useState(false);
  const [speechVolume, setSpeechVolume] = useState(false);
  const [activationType, setActivationType] = useState();
  const getTranscription = useGetTranscription?.(isChatbot);
  const startMicRef = useRef();
  const animationFrameRef = useRef(null);
  const speakingTimeoutRef = useRef(null);
  const recorderRef = useRef(createAudioRecorder());
  const streamRef = useRef();
  const audioContextRef = useRef();
  const cleanupAudioMonitoring = useCallback(() => {
    if (animationFrameRef.current) {
      cancelAnimationFrame(animationFrameRef.current);
      animationFrameRef.current = null;
    }
    if (speakingTimeoutRef.current) {
      clearTimeout(speakingTimeoutRef.current);
      speakingTimeoutRef.current = null;
    }
    streamRef.current = null;
    if (audioContextRef.current) {
      audioContextRef.current.close().then(() => console.log("Context closed")).catch((err) => console.log(err));
      audioContextRef.current = null;
    }
    setSpeechVolume(0);
  }, []);
  const handleStopRecording = useCallback(
    async (isCancelRequest = false) => {
      cleanupAudioMonitoring();
      try {
        const recording = await recorderRef.current.stop();
        setIsRecording(false);
        if (!recording || recording.durationMs < 250 || recording.size < 1024 || isCancelRequest)
          return;
        if (recordingCallback) {
          const buffer = new Uint8Array(await recording.blob.arrayBuffer());
          recordingCallback?.(buffer, recording.blob);
        }
        if (getTranscription) {
          getTranscription({
            recordingBlob: recording.blob,
            setIsLoading,
            callback: async (text) => {
              await handleSubmit(null, text);
            },
            ...state.language.value !== "auto" && {
              language: state.language?.code || state.language
            },
            chatId,
            prompt: lastMessage
          });
        }
      } catch (err) {
        console.log(err);
        setIsRecording(false);
        setIsLoading(false);
      } finally {
        setActivationType();
      }
    },
    [
      cleanupAudioMonitoring,
      handleSubmit,
      getTranscription,
      state.language,
      recordingCallback,
      chatId,
      lastMessage
    ]
  );
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.hidden) {
        if (isRecording) handleStopRecording(true);
      }
    };
    document.addEventListener("visibilitychange", handleVisibilityChange);
    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [handleStopRecording, isRecording]);
  useEffect(() => {
    return () => {
      cleanupAudioMonitoring();
      recorderRef.current.cancel().catch(() => {
      });
    };
  }, [cleanupAudioMonitoring]);
  const handleStartRecording = useCallback(async () => {
    if (!user && showSignupModal) {
      return;
    }
    if (audioStream) setAudioStream();
    setSpeechStartTimestamp?.(performance.now());
    try {
      await recorderRef.current.cancel();
      await recorderRef.current.start();
      setIsRecording(true);
      const audioContext = new window.AudioContext();
      audioContextRef.current = audioContext;
      const stream = recorderRef.current.getStream();
      if (!stream) {
        throw new Error("No audio stream available");
      }
      streamRef.current = stream;
      const source = audioContext.createMediaStreamSource(stream);
      const analyser = audioContext.createAnalyser();
      analyser.minDecibels = -60;
      analyser.smoothingTimeConstant = 0.8;
      analyser.fftSize = 256;
      source.connect(analyser);
      const analyserData = new Uint8Array(analyser.frequencyBinCount);
      const checkAudioLevel = () => {
        analyser.getByteFrequencyData(analyserData);
        let sum = 0;
        for (let i = 0; i < analyserData.length; i++) {
          sum += analyserData[i];
        }
        const average = sum / analyserData.length;
        const threshold = 1;
        if (average > threshold) {
          if (speakingTimeoutRef.current) clearTimeout(speakingTimeoutRef.current);
          setSpeechVolume(Math.min(average / 10, 0.2));
          speakingTimeoutRef.current = setTimeout(() => {
            setSpeechVolume(0);
          }, 250);
        }
        animationFrameRef.current = requestAnimationFrame(checkAudioLevel);
      };
      checkAudioLevel();
    } catch (err) {
      if (err.name === "NotAllowedError")
        errorToast(
          /* @__PURE__ */ jsx(
            "div",
            {
              onClick: () => {
                navigate("/account/microphone");
              },
              children: /* @__PURE__ */ jsx(
                T,
                {
                  keyName: "eleo-error-microphone-permission",
                  params: { mic: /* @__PURE__ */ jsx(Mic, { fontSize: "inherit" }) }
                }
              )
            }
          ),
          "eleo-error-microphone-permission"
        );
      else {
        console.log(err);
        errorToast(t("eleo-error-generic"));
      }
    }
  }, [t, audioStream, setAudioStream, setSpeechStartTimestamp, user, showSignupModal, T, navigate]);
  useEffect(() => {
    function handleKeyDown(event) {
      if (event.code === "Escape") {
        handleStopRecording(true);
        if (isLoading) {
          handleStopRequest();
          setIsLoading(false);
        }
      }
      if (event.code !== "Space" || event.repeat) return;
      if (isLoading || isRecording) return;
      setActivationType("space");
      handleStartRecording();
      startMicRef.current = performance.now();
    }
    function handleKeyUp(event) {
      if (event.code !== "Space") return;
      if (isRecording && startMicRef.current && performance.now() - startMicRef.current > 1e3)
        handleStopRecording();
    }
    if (isFocused) {
      window.addEventListener("keydown", handleKeyDown);
      window.addEventListener("keyup", handleKeyUp);
    }
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      window.removeEventListener("keyup", handleKeyUp);
    };
  }, [
    isLoading,
    handleStopRecording,
    handleStartRecording,
    handleStopRequest,
    isFocused,
    isRecording
  ]);
  function handleChangeRecording() {
    if (isGenerating || isLoading) return;
    if (isRecording) {
      handleStopRecording();
    } else {
      handleStartRecording();
    }
  }
  const getStatusText = () => {
    if (isRecording) {
      switch (activationType) {
        case "hold":
          return t("eleo-chat-voice-status-listening-hold", "Listening");
        case "space":
          return /* @__PURE__ */ jsxs(Fragment, { children: [
            t("eleo-chat-voice-status-listening-space", "Listening, release SPACE to send"),
            /* @__PURE__ */ jsx("div", { className: "hidden justify-center opacity-50 md:flex", children: t("eleo-esc-to-abort", "ESC to abort") })
          ] });
        default:
          return /* @__PURE__ */ jsxs(Fragment, { children: [
            /* @__PURE__ */ jsxs("div", { className: "hidden md:block", children: [
              t("eleo-chat-voice-status-listening-click", "Listening, click to send"),
              /* @__PURE__ */ jsx("div", { className: "hidden justify-center opacity-50 md:flex", children: t("eleo-esc-to-abort", "ESC to abort") })
            ] }),
            /* @__PURE__ */ jsxs("div", { className: "block md:hidden", children: [
              t("eleo-chat-voice-status-listening-simple", "Listening..."),
              /* @__PURE__ */ jsx("div", { className: "flex items-center", children: /* @__PURE__ */ jsx(
                T,
                {
                  keyName: "eleo-chat-voice-status-listening-mobile",
                  defaultValue: "Tap <mic></mic> to send",
                  params: {
                    mic: /* @__PURE__ */ jsx("span", { className: "inline-flex text-[14px]", children: /* @__PURE__ */ jsx(Mic, { fontSize: "inherit" }) })
                  }
                }
              ) })
            ] })
          ] });
      }
    }
    if (isLoading) {
      return /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-[6px]", children: [
        /* @__PURE__ */ jsx("span", { className: "block md:hidden", children: loader }),
        /* @__PURE__ */ jsxs("div", { children: [
          /* @__PURE__ */ jsx("div", { className: "md:text-center", children: t("eleo-chat-voice-status-answering", "Answering") }),
          /* @__PURE__ */ jsx("div", { className: "hidden justify-center opacity-50 md:flex", children: t("eleo-click-or-esc-to-abort", "Click or ESC to abort") }),
          /* @__PURE__ */ jsx("div", { className: "flex justify-center md:hidden", children: /* @__PURE__ */ jsx(T, { keyName: "eleo-tap-mic-to-abort", params: { mic: /* @__PURE__ */ jsx(Mic, { fontSize: "inherit" }) } }) })
        ] })
      ] });
    }
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsxs("div", { className: "hidden md:block", children: [
        /* @__PURE__ */ jsx(T, { keyName: "eleo-chat-ptt-status-cta", children: "Click / hold SPACE to talk" }),
        /* @__PURE__ */ jsx("div", { className: "flex justify-center opacity-50", children: t("eleo-esc-to-abort", "ESC to abort") })
      ] }),
      /* @__PURE__ */ jsx("span", { className: " md:hidden", children: /* @__PURE__ */ jsx(
        T,
        {
          keyName: "eleo-chat-ptt-status-cta-mobile",
          defaultValue: "<div>Tap / hold <mic></mic></div><div>to talk</div>",
          params: {
            mic: /* @__PURE__ */ jsx("span", { className: "inline-flex text-[14px]", children: /* @__PURE__ */ jsx(Mic, { fontSize: "inherit" }) }),
            div: /* @__PURE__ */ jsx("div", { className: "flex items-center" })
          }
        }
      ) })
    ] });
  };
  return /* @__PURE__ */ jsx(
    AudioInputLayout,
    {
      getStatusText,
      isLoading,
      isRecording,
      speechVolume,
      onMouseDown: () => {
        if (isLoading) {
          handleStopRequest();
          handleStartRecording(true);
          setIsLoading(false);
          return;
        }
        startMicRef.current = performance.now();
        setActivationType("hold");
        handleChangeRecording();
      },
      onMouseUp: () => {
        if (startMicRef.current && performance.now() - startMicRef.current > 1e3) {
          handleStopRecording();
        } else {
          setActivationType("click");
        }
      },
      onClick: () => {
        if (!user && showSignupModal) {
          showSignupModal();
        }
      },
      loader: /* @__PURE__ */ jsx("div", { children: loader })
    }
  );
}

function ChatVoiceInput({
  dispatch,
  handleSubmit,
  audioStream,
  setAudioStream,
  chatLog,
  lastUserMessage,
  state,
  isChatbot = false,
  useTranscribe,
  t,
  T,
  chatId,
  isFromLibrary = false
}) {
  const [speechVolume, setSpeechVolume] = useState(false);
  const [voiceDetectedTime, setVoiceDetectedTime] = useState();
  const startMicRef = useRef();
  const {
    toggleTranscribe: handleChangeRecording,
    stopTranscribe: handleStopRecording,
    isLoading,
    isTranscribing: isRecording
  } = useTranscribe({
    callback: useCallback(
      (data) => {
        setAudioStream();
        let text = data;
        const lastMsg = lastUserMessage?.content;
        if (data.startsWith(lastMsg)) {
          text = data.slice(lastMsg.length);
        }
        dispatch({ type: "SET_INPUT", payload: text });
      },
      [dispatch, setAudioStream, chatLog]
    ),
    pauseCallback: useCallback(() => {
      setVoiceDetectedTime();
      handleSubmit();
    }, [handleSubmit]),
    voiceDetectedCallback: useCallback(() => {
      setVoiceDetectedTime(performance.now());
    }, []),
    setSpeechVolume,
    isStopOnPause: false,
    language: transcribeLanguageCodeMap[state.language?.code],
    isChatbot,
    chatId,
    isFromLibrary
  });
  useEffect(() => {
    function handleKeyDown(event) {
      if (event.code === "Escape") {
        if (isRecording) handleStopRecording();
      }
    }
    const handleVisibilityChange = () => {
      if (document.hidden) {
        handleStopRecording(true);
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    document.addEventListener("visibilitychange", handleVisibilityChange);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [handleStopRecording, isRecording]);
  const getStatusText = () => {
    if (isRecording) {
      return /* @__PURE__ */ jsxs(Fragment, { children: [
        t("eleo-chat-voice-status-listening-hold", "Listening..."),
        /* @__PURE__ */ jsx("div", { className: "hidden md:block", children: t("eleo-click-or-esc-to-abort", "Click or ESC to abort") }),
        /* @__PURE__ */ jsx("div", { className: "flex items-center md:hidden", children: /* @__PURE__ */ jsx(
          T,
          {
            keyName: "eleo-tap-mic-to-abort",
            defaultValue: "Tap <mic></mic> to abort",
            params: {
              mic: /* @__PURE__ */ jsx("span", { className: "inline-flex text-[14px]", children: /* @__PURE__ */ jsx(Mic, { fontSize: "inherit" }) })
            }
          }
        ) })
      ] });
    }
    if (isLoading) {
      return /* @__PURE__ */ jsxs("span", { className: "", children: [
        t("eleo-chat-voice-status-loading", "Loading..."),
        /* @__PURE__ */ jsx("div", {})
      ] });
    }
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx("span", { className: "hidden md:block", children: t("eleo-chat-voice-status-cta", "Click to start a conversation") }),
      /* @__PURE__ */ jsx("div", { className: "block md:hidden", children: /* @__PURE__ */ jsx("div", { className: "", children: /* @__PURE__ */ jsx(
        T,
        {
          keyName: "eleo-tap-to-start-conversation",
          defaultValue: "<div>Tap <mic></mic></div> <div>to start conversation</div>",
          params: {
            mic: /* @__PURE__ */ jsx("span", { className: "inline-flex text-[14px]", children: /* @__PURE__ */ jsx(Mic, { fontSize: "inherit" }) }),
            div: /* @__PURE__ */ jsx("div", { className: "flex items-center" })
          }
        }
      ) }) })
    ] });
  };
  return /* @__PURE__ */ jsx(
    AudioInputLayout,
    {
      getStatusText,
      isLoading,
      isRecording,
      onClick: () => {
      },
      onMouseDown: () => {
        startMicRef.current = performance.now();
        dispatch({ type: "SET_INPUT", payload: "" });
        if (audioStream && !isRecording) setAudioStream();
        handleChangeRecording();
      },
      onMouseUp: () => {
        if (startMicRef.current && performance.now() - startMicRef.current > 2e3) {
          handleStopRecording();
        }
      },
      speechVolume,
      loader: /* @__PURE__ */ jsx("span", { className: "text-brand-violet", children: /* @__PURE__ */ jsx(CircularProgress, { color: "inherit" }) }),
      voiceDetectedTime
    }
  );
}

const defaultAvatar = "data:image/svg+xml,%3c?xml%20version='1.0'%20encoding='utf-8'?%3e%3c!--%20Generator:%20Adobe%20Illustrator%2027.0.0,%20SVG%20Export%20Plug-In%20.%20SVG%20Version:%206.00%20Build%200)%20--%3e%3csvg%20version='1.1'%20id='Layer_2_00000119813837076930742270000010735148749587845254_'%20xmlns='http://www.w3.org/2000/svg'%20xmlns:xlink='http://www.w3.org/1999/xlink'%20x='0px'%20y='0px'%20viewBox='0%200%2026%2026'%20style='enable-background:new%200%200%2026%2026;'%20xml:space='preserve'%3e%3cstyle%20type='text/css'%3e%20.st0{fill:%23FFFFFF;}%20.st1{fill:%231C1C1C;}%20%3c/style%3e%3ccircle%20class='st0'%20cx='13'%20cy='12.6'%20r='11.3'/%3e%3cpath%20class='st1'%20d='M8.9,16.1c-0.5,0-0.9-0.2-1.2-0.5s-0.5-0.7-0.5-1.2s0.2-0.9,0.5-1.2s0.7-0.5,1.2-0.5c0.5,0,0.9,0.2,1.2,0.5%20s0.5,0.7,0.5,1.2s-0.2,0.9-0.5,1.2S9.4,16.1,8.9,16.1z%20M17.1,16.1c-0.5,0-0.9-0.2-1.2-0.5s-0.5-0.7-0.5-1.2s0.2-0.9,0.5-1.2%20s0.7-0.5,1.2-0.5c0.5,0,0.9,0.2,1.2,0.5s0.5,0.7,0.5,1.2s-0.2,0.9-0.5,1.2S17.6,16.1,17.1,16.1z%20M13,24c3.1,0,5.7-1.1,7.8-3.2%20S24,16.1,24,13c0-0.5,0-1.1-0.1-1.6c-0.1-0.5-0.2-1-0.4-1.5c-0.5,0.1-1,0.2-1.4,0.3c-0.5,0.1-1,0.1-1.5,0.1c-2.1,0-4.1-0.4-5.9-1.3%20s-3.4-2.1-4.7-3.7C9.2,6.9,8.1,8.5,6.8,9.8s-2.9,2.3-4.8,3V13c0,3.1,1.1,5.7,3.2,7.8S9.9,24,13,24L13,24z%20M13,25.4%20c-1.7,0-3.3-0.3-4.8-1c-1.5-0.6-2.8-1.5-3.9-2.6s-2-2.4-2.6-3.9c-0.6-1.5-1-3.1-1-4.8s0.3-3.3,1-4.8s1.5-2.8,2.6-3.9s2.4-2,3.9-2.6%20s3.1-1,4.8-1s3.3,0.3,4.8,1c1.5,0.6,2.8,1.5,3.9,2.6c1.1,1.1,2,2.4,2.6,3.9c0.6,1.5,1,3.1,1,4.8s-0.3,3.3-1,4.8%20c-0.6,1.5-1.5,2.8-2.6,3.9c-1.1,1.1-2.4,2-3.9,2.6C16.3,25,14.7,25.4,13,25.4z%20M9.9,2.4c1.1,2.2,2.7,3.9,4.7,4.9c2,1,4,1.5,6,1.5%20c0.4,0,0.8,0,1.3-0.1s0.8-0.1,1.2-0.2c-0.9-2-2.2-3.7-4.1-4.8C17.1,2.6,15.2,2,13,2c-0.6,0-1.1,0-1.7,0.1C10.8,2.2,10.3,2.3,9.9,2.4%20L9.9,2.4z%20M2.2,11.2C3.6,10.6,5,9.5,6.5,8.1S8.8,4.9,9,2.7C7.2,3.4,5.7,4.5,4.5,6C3.3,7.5,2.5,9.2,2.2,11.2L2.2,11.2z'/%3e%3c/svg%3e";

const eleoLogo = "data:image/png;base64,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";

const [SelectionProvider, useSelectionContext] = createContext("Selection");
const Selection = (props) => {
  const {
    children,
    open: openProp,
    defaultOpen,
    onOpenChange,
    whileSelect = false,
    disabled = false,
    openDelay,
    closeDelay
  } = props;
  const openTimerRef = React.useRef(0);
  const closeTimerRef = React.useRef(0);
  const [content, setContent] = React.useState(null);
  const [virtualRef, setVirtualRef] = React.useState({
    getBoundingClientRect: () => DOMRect.fromRect(),
    getClientRects: () => new DOMRectList()
  });
  const [open = false, setOpen] = useControllableState({
    prop: openProp,
    defaultProp: defaultOpen,
    onChange: onOpenChange
  });
  const handleOpen = React.useCallback(
    (callback) => {
      clearTimeout(closeTimerRef.current);
      openTimerRef.current = window.setTimeout(callback, openDelay);
    },
    [openDelay]
  );
  const handleClose = React.useCallback(() => {
    clearTimeout(openTimerRef.current);
    closeTimerRef.current = window.setTimeout(() => setOpen(false), closeDelay);
  }, [closeDelay, setOpen]);
  return /* @__PURE__ */ jsx(
    SelectionProvider,
    {
      open,
      onOpenChange: setOpen,
      onOpen: handleOpen,
      onClose: handleClose,
      whileSelect,
      virtualRef,
      onVirtualRefChange: setVirtualRef,
      content,
      onContentChange: setContent,
      disabled,
      children
    }
  );
};
const TRIGGER_NAME = "SelectionTrigger";
const SelectionTrigger = React.forwardRef(
  (props, forwardedRef) => {
    const context = useSelectionContext(TRIGGER_NAME);
    const ref = React.useRef(null);
    const composedRefs = useComposedRefs(forwardedRef, ref);
    const isTouchDevice = typeof window !== "undefined" && (navigator.maxTouchPoints > 0 || // @ts-ignore
    navigator.msMaxTouchPoints && navigator.msMaxTouchPoints > 0 || "ontouchstart" in window || window.matchMedia && window.matchMedia("(pointer: coarse)").matches);
    return context.whileSelect || isTouchDevice ? /* @__PURE__ */ jsx(SelectionTriggerWhileSelect, { ...props, ref: forwardedRef }) : /* @__PURE__ */ jsx(
      SelectionTriggerImpl,
      {
        ...props,
        ref: composedRefs,
        onPointerUp: (event) => {
          props.onPointerUp?.(event);
          context.onOpen(() => {
            const selection = document.getSelection();
            if (!selection) return;
            const trigger = ref.current;
            const wasSelectionInsideTrigger = trigger?.contains(selection.anchorNode);
            if (!wasSelectionInsideTrigger) return;
            if (selection.toString().trim() === "") return;
            if (selection.isCollapsed) return;
            const range = selection.getRangeAt(0);
            context.onOpenChange(true);
            context.onVirtualRefChange({
              getBoundingClientRect: () => range.getBoundingClientRect(),
              getClientRects: () => range.getClientRects()
            });
          });
        }
      }
    );
  }
);
SelectionTrigger.displayName = TRIGGER_NAME;
let originalBodyUserSelect;
const SelectionTriggerWhileSelect = React.forwardRef((props, forwardedRef) => {
  const context = useSelectionContext(TRIGGER_NAME);
  const [containSelection, setContainSelection] = React.useState(false);
  const ref = React.useRef(null);
  const pointerTypeRef = React.useRef("");
  const hasOpenedRef = React.useRef(false);
  const composedRefs = useComposedRefs(forwardedRef, ref);
  const handlePointerUp = React.useCallback(() => {
    setContainSelection(false);
  }, []);
  const { onOpen, onOpenChange, onVirtualRefChange } = context;
  React.useEffect(() => {
    if (!context.disabled) {
      const handleSelection = () => {
        props.onSelectionChange?.();
        const selection = document.getSelection();
        if (!selection) return;
        const node = ref.current;
        const wasSelectionInsideTrigger = node?.contains(selection.anchorNode);
        if (!wasSelectionInsideTrigger) {
          hasOpenedRef.current = false;
          return;
        }
        if (selection.isCollapsed) {
          hasOpenedRef.current = false;
          return;
        }
        const hasTextSelected = selection.toString().trim() !== "";
        if (hasTextSelected) {
          const range = selection?.getRangeAt(0);
          if (!hasOpenedRef.current) onOpen(() => onOpenChange(true));
          hasOpenedRef.current = true;
          onVirtualRefChange({
            getBoundingClientRect: () => range.getBoundingClientRect(),
            getClientRects: () => range.getClientRects()
          });
        }
      };
      document.addEventListener("selectionchange", handleSelection);
      return () => document.removeEventListener("selectionchange", handleSelection);
    }
  }, [context.disabled, onOpenChange, onOpen, onVirtualRefChange]);
  React.useEffect(() => {
    if (containSelection) {
      const body = document.body;
      originalBodyUserSelect = body.style.userSelect || body.style.webkitUserSelect;
      body.style.userSelect = "none";
      body.style.webkitUserSelect = "none";
      const preventContextMenu = (e) => {
        e.preventDefault();
        e.stopPropagation();
      };
      document.addEventListener("contextmenu", preventContextMenu, { capture: true });
      return () => {
        body.style.userSelect = originalBodyUserSelect;
        body.style.webkitUserSelect = originalBodyUserSelect;
        document.removeEventListener("contextmenu", preventContextMenu, true);
      };
    }
  }, [containSelection]);
  React.useEffect(() => {
    const isTouchDevice = typeof window !== "undefined" && (navigator.maxTouchPoints > 0 || // @ts-ignore
    navigator.msMaxTouchPoints && navigator.msMaxTouchPoints > 0 || "ontouchstart" in window || window.matchMedia && window.matchMedia("(pointer: coarse)").matches);
    if (!isTouchDevice) return;
    if (context.open) {
      const preventContextMenu = (e) => {
        e.preventDefault();
        e.stopPropagation();
      };
      document.addEventListener("contextmenu", preventContextMenu, { capture: true });
      return () => document.removeEventListener("contextmenu", preventContextMenu, true);
    }
  }, [context.open]);
  React.useEffect(() => {
    return () => document.removeEventListener("pointerup", handlePointerUp);
  }, [handlePointerUp]);
  return /* @__PURE__ */ jsx(
    SelectionTriggerImpl,
    {
      ...props,
      ref: composedRefs,
      onPointerDown: (event) => {
        props.onPointerDown?.(event);
        pointerTypeRef.current = event.pointerType;
        setContainSelection(true);
        document.addEventListener("pointerup", handlePointerUp, { once: true });
      },
      style: {
        userSelect: containSelection ? "text" : void 0,
        WebkitUserSelect: containSelection ? "text" : void 0,
        ...props.style
      }
    }
  );
});
SelectionTriggerWhileSelect.displayName = "SelectionTriggerWhileSelect";
const SelectionTriggerImpl = React.forwardRef((props, forwardedRef) => {
  const context = useSelectionContext(TRIGGER_NAME);
  const [disablePointerEvents, setDisablePointerEvents] = React.useState(false);
  const handlePointerUp = React.useCallback(() => {
    setDisablePointerEvents(false);
  }, []);
  const handleContextMenu = React.useCallback((event) => {
    event.preventDefault();
    event.stopPropagation();
  }, []);
  React.useEffect(() => {
    if (context.content && disablePointerEvents) {
      const content = context.content;
      const originalContentPointerEvents = content.style.pointerEvents;
      content.style.pointerEvents = "none";
      return () => {
        content.style.pointerEvents = originalContentPointerEvents;
      };
    }
  }, [context.content, disablePointerEvents]);
  React.useEffect(() => {
    if (context.open && disablePointerEvents) {
      setDisablePointerEvents(false);
    }
  }, [context.open, disablePointerEvents]);
  React.useEffect(() => {
    return () => document.removeEventListener("pointerup", handlePointerUp);
  }, [handlePointerUp]);
  return /* @__PURE__ */ jsx(
    Primitive.div,
    {
      ...props,
      ref: forwardedRef,
      onPointerDown: (event) => {
        props.onPointerDown?.(event);
        setDisablePointerEvents(true);
        document.addEventListener("pointerup", handlePointerUp, { once: true });
      },
      onContextMenu: handleContextMenu,
      style: {
        WebkitTouchCallout: "none",
        ...props.style
      }
    }
  );
});
SelectionTriggerImpl.displayName = "SelectionTriggerImpl";
const PORTAL_NAME = "SelectionPortal";
const [PortalProvider, usePortalContext] = createContext(PORTAL_NAME, {
  forceMount: void 0
});
const SelectionPortal = (props) => {
  const { forceMount, container, children } = props;
  const context = useSelectionContext(PORTAL_NAME);
  return /* @__PURE__ */ jsx(PortalProvider, { forceMount, children: /* @__PURE__ */ jsx(Presence, { present: forceMount || context.open, children: /* @__PURE__ */ jsx(Portal, { asChild: true, container, children }) }) });
};
SelectionPortal.displayName = PORTAL_NAME;
const CONTENT_NAME = "SelectionContent";
const SelectionContent = React.forwardRef(
  (props, forwardedRef) => {
    const portalContext = usePortalContext(CONTENT_NAME);
    const { forceMount = portalContext.forceMount, ...contentProps } = props;
    const context = useSelectionContext(CONTENT_NAME);
    return /* @__PURE__ */ jsx(Presence, { present: forceMount || context.open, children: /* @__PURE__ */ jsx(SelectionContentImpl, { ...contentProps, ref: forwardedRef }) });
  }
);
const [SelectionContentProvider, useContentContext] = createContext(CONTENT_NAME);
const SelectionContentImpl = React.forwardRef((props, forwardedRef) => {
  const {
    side = "top",
    sideOffset = 0,
    align = "center",
    alignOffset = 0,
    arrowPadding = 0,
    sticky = "partial",
    collisionBoundary = [],
    collisionPadding: collisionPaddingProp = 0,
    hideWhenDetached = false,
    avoidCollisions = true,
    onEscapeKeyDown,
    onPointerDownOutside,
    onFocusOutside,
    onInteractOutside,
    ...contentProps
  } = props;
  const context = useSelectionContext(CONTENT_NAME);
  const { onClose, onContentChange } = context;
  const [content, setContent] = React.useState(null);
  const isTouchDevice = typeof window !== "undefined" && (navigator.maxTouchPoints > 0 || // @ts-ignore
  navigator.msMaxTouchPoints && navigator.msMaxTouchPoints > 0 || "ontouchstart" in window || window.matchMedia && window.matchMedia("(pointer: coarse)").matches);
  const handleDismiss = React.useCallback(() => {
    if (isTouchDevice) {
      const sel = window.getSelection();
      if (sel && !sel.isCollapsed && sel.toString().trim()) return;
    }
    onClose();
  }, [isTouchDevice, onClose]);
  const composedRefs = useComposedRefs(forwardedRef, (node) => setContent(node));
  const [arrow$1, setArrow] = React.useState(null);
  const arrowSize = useSize(arrow$1);
  const arrowWidth = arrowSize?.width ?? 0;
  const arrowHeight = arrowSize?.height ?? 0;
  const desiredPlacement = side + (align !== "center" ? "-" + align : "");
  const collisionPadding = typeof collisionPaddingProp === "number" ? collisionPaddingProp : { top: 0, right: 0, bottom: 0, left: 0, ...collisionPaddingProp };
  const boundary = Array.isArray(collisionBoundary) ? collisionBoundary : [collisionBoundary];
  const hasExplicitBoundaries = boundary.length > 0;
  const detectOverflowOptions = {
    padding: collisionPadding,
    boundary: boundary.filter(isNotNull),
    altBoundary: hasExplicitBoundaries
  };
  const { x, y, strategy, placement, refs, middlewareData, isPositioned, update } = useFloating({
    strategy: "fixed",
    placement: desiredPlacement,
    whileElementsMounted: autoUpdate,
    middleware: [
      inline(),
      anchorCssProperties(),
      offset({ mainAxis: sideOffset + arrowHeight, alignmentAxis: alignOffset }),
      avoidCollisions ? flip(detectOverflowOptions) : void 0,
      avoidCollisions ? shift({
        mainAxis: true,
        crossAxis: false,
        limiter: sticky === "partial" ? limitShift() : void 0,
        ...detectOverflowOptions
      }) : void 0,
      arrow$1 ? arrow({ element: arrow$1, padding: arrowPadding }) : void 0,
      transformOrigin({ arrowWidth, arrowHeight }),
      hideWhenDetached ? hide({ strategy: "referenceHidden" }) : void 0
    ]
  });
  useLayoutEffect$1(() => {
    refs.setReference(context.virtualRef);
    onContentChange(refs.floating.current);
  }, [context.virtualRef, onContentChange, refs]);
  React.useEffect(() => {
    if (!context.open) return;
    let rafId;
    const handleScroll = () => {
      cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(update);
    };
    document.addEventListener("scroll", handleScroll, { capture: true, passive: true });
    return () => {
      document.removeEventListener("scroll", handleScroll, true);
      cancelAnimationFrame(rafId);
    };
  }, [context.open, update]);
  const [placedSide, placedAlign] = getSideAndAlignFromPlacement(placement);
  const arrowX = middlewareData.arrow?.x;
  const arrowY = middlewareData.arrow?.y;
  const cannotCenterArrow = middlewareData.arrow?.centerOffset !== 0;
  const [contentZIndex, setContentZIndex] = React.useState();
  useLayoutEffect$1(() => {
    if (content) setContentZIndex(window.getComputedStyle(content).zIndex);
  }, [content]);
  return /* @__PURE__ */ jsx(
    "div",
    {
      ref: refs.setFloating,
      style: {
        position: strategy,
        top: 0,
        left: 0,
        transform: isPositioned ? `translate3d(${Math.round(x ?? 0)}px, ${Math.round(y ?? 0)}px, 0)` : "translate3d(0, -200%, 0)",
        minWidth: "max-content",
        zIndex: contentZIndex
      },
      children: /* @__PURE__ */ jsx(
        SelectionContentProvider,
        {
          placedSide,
          onArrowChange: setArrow,
          arrowX,
          arrowY,
          shouldHideArrow: cannotCenterArrow,
          children: /* @__PURE__ */ jsx(
            DismissableLayer,
            {
              asChild: true,
              onEscapeKeyDown,
              onPointerDownOutside,
              onFocusOutside,
              onInteractOutside,
              onDismiss: handleDismiss,
              children: /* @__PURE__ */ jsx(
                Primitive.div,
                {
                  "data-side": placedSide,
                  "data-align": placedAlign,
                  "data-state": context.open ? "open" : "closed",
                  ...contentProps,
                  ref: composedRefs,
                  style: {
                    userSelect: "none",
                    ...contentProps.style,
                    animation: !isPositioned ? "none" : void 0,
                    opacity: middlewareData.hide?.referenceHidden ? 0 : void 0,
                    ["--selection-popover-content-transform-origin"]: [
                      middlewareData.transformOrigin?.x,
                      middlewareData.transformOrigin?.y
                    ].join(" ")
                  }
                }
              )
            }
          )
        }
      )
    }
  );
});
SelectionContentImpl.displayName = "SelectionContentImpl";
SelectionContent.displayName = CONTENT_NAME;
const ARROW_NAME = "SelectionArrow";
const OPPOSITE_SIDE = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
};
const SelectionArrow = React.forwardRef(
  (props, forwardedRef) => {
    const contentContext = useContentContext(ARROW_NAME);
    const baseSide = OPPOSITE_SIDE[contentContext.placedSide];
    return /* @__PURE__ */ jsx(
      "span",
      {
        ref: contentContext.onArrowChange,
        style: {
          position: "absolute",
          left: contentContext.arrowX,
          top: contentContext.arrowY,
          [baseSide]: 0,
          transformOrigin: {
            top: "",
            right: "0 0",
            bottom: "center 0",
            left: "100% 0"
          }[contentContext.placedSide],
          transform: {
            top: "translateY(100%)",
            right: "translateY(50%) rotate(90deg) translateX(-50%)",
            bottom: "rotate(180deg)",
            left: "translateY(50%) rotate(-90deg) translateX(50%)"
          }[contentContext.placedSide],
          visibility: contentContext.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ jsx(
          ArrowPrimitive.Root,
          {
            ...props,
            ref: forwardedRef,
            style: { ...props.style, display: "block" }
          }
        )
      }
    );
  }
);
SelectionArrow.displayName = ARROW_NAME;
function isNotNull(value) {
  return value !== null;
}
function getSideAndAlignFromPlacement(placement) {
  const [side, align = "center"] = placement.split("-");
  return [side, align];
}
const anchorCssProperties = () => ({
  name: "anchorCssProperties",
  async fn(data) {
    const { rects, elements, platform } = data;
    const { width, height } = rects.reference;
    const { width: popoverWidth, height: popoverHeight } = rects.floating;
    elements.floating.style.setProperty("--selection-popover-select-width", `${width}px`);
    elements.floating.style.setProperty("--selection-popover-select-height", `${height}px`);
    const newDimensions = await platform.getDimensions(elements.floating);
    if (popoverWidth !== newDimensions.width || popoverHeight !== newDimensions.height) {
      return { reset: { rects: true } };
    }
    return {};
  }
});
const transformOrigin = (options) => ({
  name: "transformOrigin",
  options,
  fn(data) {
    const { placement, rects, middlewareData } = data;
    const cannotCenterArrow = middlewareData.arrow?.centerOffset !== 0;
    const isArrowHidden = cannotCenterArrow;
    const arrowWidth = isArrowHidden ? 0 : options.arrowWidth;
    const arrowHeight = isArrowHidden ? 0 : options.arrowHeight;
    const [placedSide, placedAlign] = getSideAndAlignFromPlacement(placement);
    const noArrowAlign = { start: "0%", center: "50%", end: "100%" }[placedAlign];
    const arrowXCenter = (middlewareData.arrow?.x ?? 0) + arrowWidth / 2;
    const arrowYCenter = (middlewareData.arrow?.y ?? 0) + arrowHeight / 2;
    let x = "";
    let y = "";
    if (placedSide === "bottom") {
      x = isArrowHidden ? noArrowAlign : `${arrowXCenter}px`;
      y = `${-arrowHeight}px`;
    } else if (placedSide === "top") {
      x = isArrowHidden ? noArrowAlign : `${arrowXCenter}px`;
      y = `${rects.floating.height + arrowHeight}px`;
    } else if (placedSide === "right") {
      x = `${-arrowHeight}px`;
      y = isArrowHidden ? noArrowAlign : `${arrowYCenter}px`;
    } else if (placedSide === "left") {
      x = `${rects.floating.width + arrowHeight}px`;
      y = isArrowHidden ? noArrowAlign : `${arrowYCenter}px`;
    }
    return { data: { x, y } };
  }
});

const index = /*#__PURE__*/Object.freeze(/*#__PURE__*/Object.defineProperty({
  __proto__: null,
  Arrow: SelectionArrow,
  Content: SelectionContent,
  Portal: SelectionPortal,
  Root: Selection,
  Trigger: SelectionTrigger
}, Symbol.toStringTag, { value: 'Module' }));

const iconMap = {
  document: /* @__PURE__ */ jsx(Description, { fontSize: "inherit" }),
  website: /* @__PURE__ */ jsx(WebAsset, { fontSize: "inherit" }),
  image: /* @__PURE__ */ jsx(BrokenImageIcon, {})
};
function MessageContextItemBroken({ item }) {
  if (item.fileType === "story") return null;
  return /* @__PURE__ */ jsxs(
    "div",
    {
      title: item.name,
      className: "text-brand-text-secondary border-brand-pink  group relative flex h-[40px] max-w-[100px] items-center gap-[6px] rounded-[4px] border bg-black/5 p-2 pr-3 text-[12px]",
      children: [
        /* @__PURE__ */ jsx("div", { className: "text-brand-pink flex text-[24px]", children: iconMap[item.fileType] }),
        /* @__PURE__ */ jsx("div", { className: "truncate", children: /* @__PURE__ */ jsx("div", { className: "text-brand-pink min-w-0 max-w-[130px] truncate", children: item.name }) })
      ]
    }
  );
}

function LinkRenderer(props) {
  return (
    // eslint-disable-next-line
    /* @__PURE__ */ jsx("a", { href: props.href, target: "_blank", rel: "noreferrer", ...props, node: void 0, children: props.children })
  );
}
const Markdown = memo(function Markdown2({
  content,
  isSplitWords = false,
  className,
  t
}) {
  return /* @__PURE__ */ jsx(
    "div",
    {
      onCopy: handleCopyWithStyles,
      className: classNames(
        "prose prose-neutral markdown prose-pre:m-0 prose-pre:bg-transparent prose-pre:p-0 h-full w-full max-w-none leading-[1.375em] md:leading-normal",
        className
      ),
      children: /* @__PURE__ */ jsx(
        ReactMarkdown,
        {
          rehypePlugins: [rehypeRaw, rehypeKatex],
          remarkPlugins: [remarkMath, remarkGfm],
          components: {
            code({ inline, className: className2, children, ...props }) {
              const match = /language-(\w+)/.exec(className2 || "");
              return !inline && match ? /* @__PURE__ */ jsxs("div", { className: "group/code relative", children: [
                /* @__PURE__ */ jsx(Prism, { ...props, style: oneLight, language: match[1], PreTag: "div", children: String(children)?.replace(/\n$/, "") }),
                /* @__PURE__ */ jsx(
                  "div",
                  {
                    className: "xs:block absolute -top-2 right-0 hidden cursor-pointer opacity-0 group-hover/code:opacity-100",
                    onClick: () => CopyToClipBoard(String(children)?.replace(/\n$/, "")),
                    children: /* @__PURE__ */ jsx(ContentCopy, { className: "m-[8px]", fontSize: "small" })
                  }
                )
              ] }) : /* @__PURE__ */ jsx("code", { ...props, className: className2, children });
            },
            a: LinkRenderer,
            lang: (props) => /* @__PURE__ */ jsx("span", { className: "italic", children: props.children }),
            chat: (props) => /* @__PURE__ */ jsx(
              "a",
              {
                className: "text-brand-violet !inline underline",
                href: `/conversation/${props.id}`,
                target: "_blank",
                rel: "noreferrer",
                children: props.children
              }
            ),
            t: (props) => t(props.children, props.children),
            ...isSplitWords && {
              p: (params) => renderWords(params),
              li: (params) => renderWords(params),
              h1: (params) => renderWords(params),
              h2: (params) => renderWords(params),
              h3: (params) => renderWords(params),
              h4: (params) => renderWords(params),
              h5: (params) => renderWords(params),
              div: (params) => renderWords(params),
              article: (params) => renderWords(params),
              strong: (params) => renderWords(params),
              i: (params) => renderWords(params)
            }
          },
          children: processLatexDelimiters(content)
        }
      )
    }
  );
});
const renderWords = ({ node, children, ...props }) => {
  const TagName = node.tagName === "p" ? "div" : node.tagName;
  if (typeof children === "object" && children.length)
    children = children.map(
      (child) => typeof child === "string" ? child.split(/(\s+|\n)/).map((word, index) => {
        if (/(\s+|\n)/.test(word)) {
          return word;
        } else {
          if (!word.length) return "";
          return /* @__PURE__ */ jsx("span", { className: "hover:bg-brand-red/20 break-words", children: word }, index);
        }
      }) : child
    );
  return /* @__PURE__ */ jsx(
    TagName,
    {
      ...props,
      children: typeof children === "string" ? children.split(/(\s+|\n)/).map((word, index) => {
        if (/(\s+|\n)/.test(word)) {
          return word;
        } else {
          if (!word.length) return "";
          return /* @__PURE__ */ jsx("span", { className: "hover:bg-brand-red/20 break-words", children: word }, index);
        }
      }) : children
    }
  );
};

const MessageOptions = memo(function MessageOptions2({
  regenerateResponse,
  index,
  message,
  showShareModal,
  widget,
  handleTTS,
  width,
  isLoading,
  ttsIndex,
  handleCopy,
  t,
  isTranslatorVisible,
  showAdditionalOptions = true,
  responseSuggestion,
  fetchResponseSuggestion,
  toggleSuggestionVisibility,
  isTutorEnabled = true
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const handleClick = (e) => {
    setAnchorEl(e.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);
  const id = open ? "language-popover" : void 0;
  const handleSuggestionClick = () => {
    if (!responseSuggestion?.suggestion && fetchResponseSuggestion) {
      fetchResponseSuggestion();
    } else if (toggleSuggestionVisibility) {
      toggleSuggestionVisibility();
    }
  };
  if (width < 768) {
    return /* @__PURE__ */ jsxs(
      "div",
      {
        className: classNames(
          "mt-[6px] flex justify-end gap-[6px] rounded-b-lg",
          isLoading && "invisible"
        ),
        children: [
          widget ? /* @__PURE__ */ jsx(
            Microbutton,
            {
              variant: "plain",
              icon: /* @__PURE__ */ jsx(ContentCopy, { fontSize: "inherit" }),
              className: "hover:bg-brand-violet/10 text-brand-text-secondary/80 uppercase",
              onClick: () => {
                handleClose();
                handleCopy();
              }
            }
          ) : showAdditionalOptions ? /* @__PURE__ */ jsxs(Fragment, { children: [
            /* @__PURE__ */ jsx(
              Microbutton,
              {
                icon: /* @__PURE__ */ jsx(MoreVert, { fontSize: "inherit" }),
                variant: "plain",
                onClick: handleClick,
                className: "hover:bg-brand-violet/10 size-[40px]"
              }
            ),
            /* @__PURE__ */ jsx(
              Popover,
              {
                id,
                open,
                anchorEl,
                onClose: handleClose,
                anchorOrigin: {
                  vertical: "top",
                  horizontal: "right"
                },
                transformOrigin: {
                  vertical: "bottom",
                  horizontal: "right"
                },
                children: /* @__PURE__ */ jsxs("div", { className: "flex gap-2 p-2 py-3", children: [
                  /* @__PURE__ */ jsx(
                    Microbutton,
                    {
                      iconPlacement: "left",
                      icon: /* @__PURE__ */ jsx(Sparkle, { weight: "fill" }),
                      variant: "plain",
                      text: t("eleo-chat-regenerate", "regenerate"),
                      className: "hover:bg-brand-violet/10 text-brand-text-secondary/80 uppercase",
                      onClick: () => {
                        handleClose();
                        regenerateResponse(index - 1);
                      }
                    }
                  ),
                  /* @__PURE__ */ jsx(
                    Microbutton,
                    {
                      variant: "plain",
                      icon: /* @__PURE__ */ jsx(ContentCopy, { fontSize: "inherit" }),
                      className: "hover:bg-brand-violet/10 text-brand-text-secondary/80 uppercase",
                      onClick: () => {
                        handleClose();
                        handleCopy();
                      }
                    }
                  ),
                  /* @__PURE__ */ jsx(
                    Microbutton,
                    {
                      variant: "plain",
                      icon: /* @__PURE__ */ jsx(Share, { fontSize: "inherit" }),
                      className: "hover:bg-brand-violet/10 text-brand-text-secondary/80 uppercase",
                      onClick: () => {
                        handleClose();
                        showShareModal(message.content);
                      }
                    }
                  )
                ] })
              }
            )
          ] }) : null,
          isTutorEnabled && /* @__PURE__ */ jsx(
            Microbutton,
            {
              iconPlacement: "left",
              icon: /* @__PURE__ */ jsx(
                LightbulbOutlined,
                {
                  fontSize: "inherit",
                  className: classNames({
                    "text-yellow-400": responseSuggestion?.isVisible
                  })
                }
              ),
              variant: "plain",
              text: t("eleo-chat-suggestion", "suggestion"),
              className: "hover:bg-brand-violet/10 text-brand-text-secondary/80 uppercase",
              onClick: () => {
                handleClose();
                handleSuggestionClick();
              }
            }
          ),
          !widget ? /* @__PURE__ */ jsx(
            Microbutton,
            {
              variant: "plain",
              icon: ttsIndex === index ? /* @__PURE__ */ jsx(VolumeOff, { fontSize: "inherit" }) : /* @__PURE__ */ jsx(VolumeUp, { fontSize: "inherit" }),
              className: "hover:bg-brand-violet/10 text-brand-text-secondary/80 size-[40px] uppercase",
              onClick: () => {
                if (message?.content?.length)
                  handleTTS(replaceLinksWithString(message.content), index);
              }
            }
          ) : null,
          isTranslatorVisible && message.translation && /* @__PURE__ */ jsx("div", { className: "flex items-center", children: /* @__PURE__ */ jsx(
            MuiTooltip,
            {
              title: void 0,
              content: message.translation,
              placement: "bottom-end",
              offset: [0, -10],
              fontSize: 16,
              backgroundColor: "#fafafa",
              children: /* @__PURE__ */ jsx(Translate, { className: "text-blue-600", fontSize: "small" })
            }
          ) })
        ]
      }
    );
  }
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: classNames(
        "-mr-[10px] mt-[6px] flex justify-end gap-[6px] rounded-b-lg",
        isLoading && "invisible"
      ),
      children: [
        /* @__PURE__ */ jsx("div", { className: "flex gap-[6px]", children: showAdditionalOptions ? /* @__PURE__ */ jsxs(Fragment, { children: [
          !widget && /* @__PURE__ */ jsxs(Fragment, { children: [
            /* @__PURE__ */ jsx(
              Microbutton,
              {
                iconPlacement: "left",
                icon: /* @__PURE__ */ jsx(Sparkle, { weight: "fill" }),
                variant: "plain",
                text: t("eleo-chat-regenerate", "regenerate"),
                className: "hover:bg-brand-violet/10 text-brand-text-secondary/80 uppercase",
                onClick: () => regenerateResponse(index - 1)
              }
            ),
            /* @__PURE__ */ jsx("div", { className: "my-[5px] border-r" })
          ] }),
          /* @__PURE__ */ jsxs("div", { className: "flex", children: [
            /* @__PURE__ */ jsx(
              Microbutton,
              {
                variant: "plain",
                icon: /* @__PURE__ */ jsx(ContentCopy, { fontSize: "inherit" }),
                className: "hover:bg-brand-violet/10 text-brand-text-secondary/80 uppercase",
                onClick: handleCopy
              }
            ),
            !widget && /* @__PURE__ */ jsx(
              Microbutton,
              {
                variant: "plain",
                icon: /* @__PURE__ */ jsx(Share, { fontSize: "inherit" }),
                className: "hover:bg-brand-violet/10 text-brand-text-secondary/80 uppercase",
                onClick: () => showShareModal(message.content)
              }
            )
          ] }),
          !widget ? /* @__PURE__ */ jsx("div", { className: "my-[5px] border-r" }) : null
        ] }) : null }),
        !widget && isTutorEnabled && /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx(
            Microbutton,
            {
              iconPlacement: "left",
              icon: /* @__PURE__ */ jsx(
                LightbulbOutlined,
                {
                  fontSize: "inherit",
                  className: classNames({
                    "text-yellow-400": responseSuggestion?.isVisible
                  })
                }
              ),
              variant: "plain",
              text: t("redparrot-chat-suggestion", "suggestion"),
              className: "hover:bg-brand-violet/10 text-brand-text-secondary/80 uppercase",
              onClick: handleSuggestionClick
            }
          ),
          /* @__PURE__ */ jsx("div", { className: "my-[5px] border-r" })
        ] }),
        /* @__PURE__ */ jsx(
          Microbutton,
          {
            variant: "plain",
            icon: ttsIndex === index ? /* @__PURE__ */ jsx(VolumeOff, { fontSize: "inherit" }) : /* @__PURE__ */ jsx(VolumeUp, { fontSize: "inherit" }),
            className: classNames("hover:bg-brand-violet/10 text-brand-text-secondary/80 uppercase"),
            onClick: () => {
              if (message?.content?.length) handleTTS(replaceLinksWithString(message.content), index);
            }
          }
        ),
        isTranslatorVisible && message.translation && /* @__PURE__ */ jsx("div", { className: "-mr-1 ml-1 cursor-pointer", children: /* @__PURE__ */ jsx(
          MuiTooltip,
          {
            title: void 0,
            content: message.translation,
            placement: "bottom-end",
            offset: [0, -10],
            fontSize: 15,
            additionalStyles: { maxWidth: 500 },
            backgroundColor: "#fafafa",
            children: /* @__PURE__ */ jsx(Translate, { className: "text-blue-600", fontSize: "small" })
          }
        ) })
      ]
    }
  );
});

const ChatMessage = memo(function ChatMessage2({
  message,
  assistantLogo = eleoLogo,
  customAssistantLogo,
  widget = false,
  language,
  regenerateResponse,
  index: index$1,
  avatar,
  handleTTS,
  width,
  ttsIndex,
  setImagePreviewData,
  t,
  ViewContext,
  SocialShare,
  ContextMenu,
  downloadAudioFromStream,
  isTranslatorVisible = false,
  showAdditionalOptions = true,
  responseSuggestion,
  fetchResponseSuggestion,
  toggleSuggestionVisibility,
  isTutorEnabled = true
}) {
  const context = useContext(ViewContext);
  const contentRef = useRef();
  const [selectedText, setSelectedText] = useState("");
  const changeWritingDirection = detectRtlDirection(language);
  const navigate = useNavigate();
  if (message.role === "system") return null;
  const isLoading = message.content === "STATE_LOADING" || message.content === "STATE_LOADING_CONTEXT";
  const handleSelectionChange = () => {
    const selection = window.getSelection();
    if (selection && selection.toString()) {
      setSelectedText(selection.toString());
    }
  };
  const showShareModal = (content) => {
    context.modal.show({
      children: /* @__PURE__ */ jsxs("div", { children: [
        /* @__PURE__ */ jsx("p", { className: "text-brand-body !mb-[8px] text-center font-bold", children: t("eleo-share-content-modal-text", "Share content in Social Media") }),
        /* @__PURE__ */ jsx("div", { className: "flex h-[40px] justify-center", children: /* @__PURE__ */ jsx(
          SocialShare,
          {
            className: "flex w-full justify-center",
            description: encodeURI(content),
            url: window.location.origin
          }
        ) })
      ] }),
      modalCardClassNames: "!bg-brand-grey !px-[30px] !py-[20px]"
    });
  };
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: classNames("relative min-w-0 first:mt-auto", {
        "items-end justify-end sm:items-start": message.role === "user" && !widget,
        "flex gap-[5px]": widget,
        "flex flex-col sm:flex-row sm:items-end": !widget,
        "!flex-row-reverse": widget && message.role === "user"
      }),
      children: [
        /* @__PURE__ */ jsx(
          "div",
          {
            className: classNames(
              "hidden items-center justify-center rounded-full sm:mb-0 sm:flex",
              // !customAssistantLogo && message.role !== 'user' && 'bg-yellow-400',
              message.role === "user" ? "-right-[62px]" : "-left-[62px]",
              "bottom-0 mb-2 size-[42px] min-h-[42px] min-w-[42px] sm:absolute sm:mb-0"
            ),
            children: /* @__PURE__ */ jsx(
              "img",
              {
                className: classNames(
                  "rounded-full object-contain",
                  message.role === "user" ? "size-[42px] " : "size-[45px]",
                  {
                    "!size-[42px] !object-cover": widget && customAssistantLogo
                  }
                ),
                src: message.role === "user" ? avatar ?? defaultAvatar : customAssistantLogo?.length ? customAssistantLogo : assistantLogo,
                alt: "eleo logo"
              }
            )
          }
        ),
        /* @__PURE__ */ jsxs(Selection, { children: [
          /* @__PURE__ */ jsx(
            SelectionTrigger,
            {
              className: "h-full min-w-0 rounded-[10px] bg-white",
              onSelectionChange: handleSelectionChange,
              children: /* @__PURE__ */ jsxs(
                "div",
                {
                  className: classNames(
                    "sm:lead group relative rounded-[10px] p-[14px] !pb-[10px]  md:p-[30px]",
                    {
                      "bg-transparent pt-[20px] sm:mr-0": message.role === "user",
                      "border-brand-grey bg-brand-form-accent-lighter border sm:bg-white": message.role !== "user",
                      "rtl-text": changeWritingDirection,
                      "!pr-[5px]": widget && message.role === "user"
                    },
                    "message"
                  ),
                  onMouseUp: handleSelectionChange,
                  onTouchEnd: handleSelectionChange,
                  dir: changeWritingDirection ? "rtl" : "ltr",
                  children: [
                    isLoading ? /* @__PURE__ */ jsx(MessageLoader, { usesContext: message.content === "STATE_LOADING_CONTEXT", t }) : message.role === "assistant" ? /* @__PURE__ */ jsxs("div", { ref: contentRef, children: [
                      /* @__PURE__ */ jsx(Markdown, { content: message.content, t, isSplitWords: true }),
                      message.image && /* @__PURE__ */ jsxs(Fragment, { children: [
                        /* @__PURE__ */ jsx(
                          "img",
                          {
                            src: message.image,
                            alt: "",
                            className: "mb-2 max-h-[512px] cursor-pointer rounded-[4px]",
                            onClick: () => setImagePreviewData?.({
                              target: message.image,
                              isMobile: false,
                              isVisible: true
                            })
                          }
                        ),
                        t(
                          "eleo-image-generation-link",
                          "You can generate images in the <a>Images tab</a>",
                          {
                            // @ts-ignore
                            a: (
                              // eslint-disable-next-line
                              /* @__PURE__ */ jsx(
                                "span",
                                {
                                  className: "text-brand-violet cursor-pointer",
                                  onClick: () => navigate("/image")
                                }
                              )
                            )
                          }
                        )
                      ] })
                    ] }) : /* @__PURE__ */ jsx("div", { className: classNames("whitespace-break-spaces break-words"), children: message.content }),
                    message.role === "user" ? message.context?.length && message?.attachedFileInfo?.length ? /* @__PURE__ */ jsx("div", { className: "flex select-none flex-wrap items-center justify-end gap-[6px] p-[10px] pr-0", children: message.context?.map((item) => /* @__PURE__ */ jsx(
                      MessageContextItem,
                      {
                        item,
                        messageContext: message.context,
                        isEditable: false,
                        setImagePreviewData
                      },
                      item.id
                    )) }) : /* @__PURE__ */ jsx(Fragment, { children: message?.attachedFileInfo?.length ? /* @__PURE__ */ jsx("div", { className: "flex select-none flex-wrap items-center justify-end gap-[6px] p-[10px] pr-0", children: message?.attachedFileInfo?.map((item, i) => /* @__PURE__ */ jsx(MessageContextItemBroken, { item }, i)) }) : null }) : (
                      //  TODO render only after the message is loaded
                      /* @__PURE__ */ jsx(
                        MessageOptions,
                        {
                          regenerateResponse,
                          index: index$1,
                          message,
                          showShareModal,
                          widget,
                          handleTTS,
                          width,
                          isLoading,
                          ttsIndex,
                          handleCopy: () => CopyToClipBoard(
                            contentRef.current?.textContent,
                            t("eleo-message-copied-successfully", "Message copied successfully!"),
                            contentRef.current?.innerHTML
                          ),
                          t,
                          downloadAudioFromStream,
                          isTranslatorVisible,
                          showAdditionalOptions,
                          responseSuggestion,
                          fetchResponseSuggestion,
                          toggleSuggestionVisibility,
                          isTutorEnabled
                        }
                      )
                    )
                  ]
                }
              )
            }
          ),
          /* @__PURE__ */ jsx(SelectionPortal, { children: /* @__PURE__ */ jsx(
            SelectionContent,
            {
              side: width > 640 ? "bottom" : "top",
              sideOffset: 4,
              align: "start",
              collisionPadding: { bottom: 50 },
              className: "z-[9999]",
              children: /* @__PURE__ */ jsx(ContextMenu, { selectedText, enableEdit: false, handleTTS })
            }
          ) })
        ] })
      ]
    }
  );
});

const ModeSelector = memo(function ModeSelector2({ inputMode, setInputMode, t }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const options1 = [
    {
      value: "text",
      label: t("eleo-chat-mode-option-text-label", "Text chat"),
      shortLabel: t("eleo-chat-mode-option-text-short-label", "Text")
    },
    {
      value: "read",
      label: t("eleo-chat-mode-option-read-label", "Read answers aloud"),
      shortLabel: t("eleo-chat-mode-option-read-short-label", "Read")
    }
  ];
  const options2 = [
    {
      value: "voice",
      label: t("eleo-chat-mode-option-voice-label", "Voice chat"),
      shortLabel: t("eleo-chat-mode-option-voice-short-label", "Voice")
    },
    {
      value: "push",
      label: t("eleo-chat-mode-option-ptt-label", "Push to talk"),
      shortLabel: t("eleo-chat-mode-option-ptt-short-label", "Push")
    }
  ];
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const renderOption = (option) => /* @__PURE__ */ jsx(
    "label",
    {
      htmlFor: option.value,
      className: "text-brand-violet hover:bg-brand-violet/10 cursor-pointer rounded-[4px] p-[6px] transition-colors",
      children: /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-2", children: [
        /* @__PURE__ */ jsxs("div", { className: "relative flex items-center justify-center", children: [
          /* @__PURE__ */ jsx(
            "input",
            {
              id: option.value,
              type: "radio",
              name: option.value,
              className: "border-brand-violet text-brand-violet peer relative h-3 w-3 cursor-pointer appearance-none rounded-full border transition-all ",
              value: option.shortLabel,
              checked: inputMode === option.value,
              onChange: () => {
                handleClose();
                setInputMode(option.value);
              }
            }
          ),
          /* @__PURE__ */ jsx("span", { className: "text-brand-violet pointer-events-none absolute left-2/4 top-2/4 -translate-x-2/4 -translate-y-2/4 opacity-0 transition-opacity peer-checked:opacity-100", children: /* @__PURE__ */ jsx(
            "svg",
            {
              xmlns: "http://www.w3.org/2000/svg",
              className: "size-[6px]",
              viewBox: "0 0 16 16",
              fill: "currentColor",
              children: /* @__PURE__ */ jsx("circle", { "data-name": "ellipse", cx: "8", cy: "8", r: "8" })
            }
          ) })
        ] }),
        /* @__PURE__ */ jsx("div", { className: classNames("text-[13px]", inputMode === option.value && "font-medium"), children: option.label })
      ] })
    },
    option.value
  );
  const open = Boolean(anchorEl);
  const popoverId = open ? "context-popover" : void 0;
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      Microbutton,
      {
        iconPlacement: "none",
        variant: "transparent",
        onClick: handleClick,
        className: classNames("h-[30px] saturate-150"),
        children: /* @__PURE__ */ jsxs("div", { className: "flex items-center justify-between gap-2 text-[12px] font-medium", children: [
          /* @__PURE__ */ jsx("span", { className: "group flex min-w-[15px] text-[14px]", children: /* @__PURE__ */ jsx(RecordVoiceOver, { fontSize: "inherit", className: "fill-inherit" }) }),
          t("eleo-chat-mode-label", "Mode:"),
          /* @__PURE__ */ jsx("div", { className: "flex items-center gap-1", children: /* @__PURE__ */ jsx("div", { className: "max-w-[75px] truncate", children: [...options1, ...options2].find((option) => option.value === inputMode).shortLabel }) })
        ] })
      }
    ),
    /* @__PURE__ */ jsx(
      Popover,
      {
        id: popoverId,
        open,
        anchorEl,
        onClose: handleClose,
        anchorOrigin: {
          vertical: "top",
          horizontal: "right"
        },
        transformOrigin: {
          vertical: "bottom",
          horizontal: "right"
        },
        children: /* @__PURE__ */ jsxs("div", { className: classNames("flex w-[200px] flex-col rounded-[4px] bg-white p-2"), children: [
          options1.map((option) => renderOption(option)),
          /* @__PURE__ */ jsx("div", { className: "my-[7px] border-b px-2" }),
          options2.map((option) => renderOption(option))
        ] })
      }
    )
  ] });
});

const MobileMessageActions = memo(function MobileMessageActions2({
  isAssistant,
  isTranslationActive = false,
  onToggleTranslation,
  isHintActive = false,
  onToggleHint,
  onPlayAudio,
  isPlaying = false,
  isTutorEnabled = true,
  isTranslatorEnabled = true,
  responseSuggestion,
  fetchResponseSuggestion,
  toggleSuggestionVisibility
}) {
  const handleSuggestionClick = () => {
    if (!responseSuggestion?.suggestion && fetchResponseSuggestion) {
      fetchResponseSuggestion();
    } else if (toggleSuggestionVisibility) {
      toggleSuggestionVisibility();
    }
  };
  const buttonBaseClasses = ({
    role,
    isActive
  }) => classNames(
    "flex size-[40px] items-center justify-center rounded-full border shadow-[0_3px_8px_rgba(0,0,0,0.1)] transition-all duration-200 active:scale-95",
    { "bg-[#E6E2DE]": role === "assistant", "bg-white": role === "user" },
    isActive ? "text-brand-red border-brand-red" : "border-brand-gray/40"
  );
  if (isAssistant) {
    return /* @__PURE__ */ jsxs("div", { className: "mt-0.5 flex gap-2", children: [
      isTranslatorEnabled && onToggleTranslation && /* @__PURE__ */ jsx(
        "button",
        {
          className: buttonBaseClasses({ role: "assistant", isActive: isTranslationActive }),
          onClick: onToggleTranslation,
          "aria-label": "Toggle translation",
          type: "button",
          children: /* @__PURE__ */ jsx(Translate, {})
        }
      ),
      isTutorEnabled && /* @__PURE__ */ jsx(
        "button",
        {
          className: buttonBaseClasses({
            role: "assistant",
            isActive: isHintActive || responseSuggestion?.isVisible
          }),
          onClick: handleSuggestionClick,
          "aria-label": "Toggle suggestion",
          type: "button",
          children: /* @__PURE__ */ jsx(LightbulbOutlined, {})
        }
      ),
      onPlayAudio && /* @__PURE__ */ jsx(
        "button",
        {
          className: buttonBaseClasses({
            role: "assistant",
            isActive: isPlaying
          }),
          onClick: onPlayAudio,
          "aria-label": "Play audio",
          type: "button",
          children: isPlaying ? /* @__PURE__ */ jsx(VolumeOffOutlined, {}) : /* @__PURE__ */ jsx(VolumeUpOutlined, {})
        }
      )
    ] });
  }
  return /* @__PURE__ */ jsxs("div", { className: "mt-0.5 flex justify-end gap-2", children: [
    isTutorEnabled && onToggleHint && /* @__PURE__ */ jsx(
      "button",
      {
        className: buttonBaseClasses({
          role: "user",
          isActive: isHintActive
        }),
        onClick: onToggleHint,
        "aria-label": "Toggle feedback",
        type: "button",
        children: /* @__PURE__ */ jsx(LightbulbOutlined, {})
      }
    ),
    onPlayAudio && /* @__PURE__ */ jsx(
      "button",
      {
        className: buttonBaseClasses({
          role: "user",
          isActive: isPlaying
        }),
        onClick: onPlayAudio,
        "aria-label": "Play audio",
        type: "button",
        children: isPlaying ? /* @__PURE__ */ jsx(VolumeOffOutlined, {}) : /* @__PURE__ */ jsx(VolumeUpOutlined, {})
      }
    )
  ] });
});

const MobileChatMessage = memo(function MobileChatMessage2({
  message,
  index: index$1,
  t,
  isTranslationVisible = false,
  onToggleTranslation,
  isFeedbackVisible = false,
  onToggleFeedback,
  responseSuggestion,
  fetchResponseSuggestion,
  toggleSuggestionVisibility,
  handleTTS,
  ttsIndex,
  isTutorEnabled = true,
  isTranslatorEnabled = true,
  ContextMenu
}) {
  const contentRef = useRef(null);
  const [selectedText, setSelectedText] = useState("");
  if (message.role === "system") return null;
  const isLoading = message.content === "STATE_LOADING" || message.content === "STATE_LOADING_CONTEXT";
  const isAssistant = message.role === "assistant";
  const isUser = message.role === "user";
  const handleSelectionChange = () => {
    const selection = window.getSelection();
    if (selection && selection.toString()) {
      setSelectedText(selection.toString());
    }
  };
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: classNames("relative flex flex-col gap-2", {
        "items-start": isAssistant,
        "items-end": isUser
      }),
      children: [
        /* @__PURE__ */ jsxs(
          "div",
          {
            className: classNames(
              "relative max-w-[94%] px-[18px] py-[14px] text-base leading-[1.5] transition-all",
              {
                "rounded-[20px_20px_20px_4px] bg-[#E6E2DE] text-[#534B4F]": isAssistant,
                "rounded-[20px_20px_4px_20px] bg-white text-[#534B4F] shadow-[0_2px_8px_rgba(0,0,0,0.05)]": isUser
              }
            ),
            children: [
              /* @__PURE__ */ jsxs(Selection, { children: [
                /* @__PURE__ */ jsx(SelectionTrigger, { onSelectionChange: handleSelectionChange, children: isLoading ? /* @__PURE__ */ jsx(MessageLoader, { usesContext: message.content === "STATE_LOADING_CONTEXT", t }) : isAssistant ? /* @__PURE__ */ jsxs("div", { ref: contentRef, children: [
                  /* @__PURE__ */ jsx(Markdown, { content: message.content, t, isSplitWords: true }),
                  message.image && /* @__PURE__ */ jsx("img", { src: message.image, alt: "", className: "mb-2 max-h-[512px] rounded-[4px]" })
                ] }) : /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(Markdown, { content: message.content, t }) }) }),
                /* @__PURE__ */ jsx(SelectionPortal, { children: /* @__PURE__ */ jsx(
                  SelectionContent,
                  {
                    side: "top",
                    sideOffset: 4,
                    align: "start",
                    collisionPadding: { bottom: 50 },
                    className: "z-[9999]",
                    children: /* @__PURE__ */ jsx(ContextMenu, { selectedText, enableEdit: false, handleTTS })
                  }
                ) })
              ] }),
              isAssistant && isTranslationVisible && message.translation && /* @__PURE__ */ jsx("div", { className: "mt-[10px] border-t border-dotted border-[#534B4F]/30 pt-[10px]", children: /* @__PURE__ */ jsx("div", { className: "text-sm italic text-[#534B4F]/80", children: message.translation }) }),
              isAssistant && responseSuggestion?.isVisible && responseSuggestion?.suggestion && /* @__PURE__ */ jsxs("div", { className: "flex flex-col", children: [
                /* @__PURE__ */ jsx("div", { className: "mt-[10px] border-t border-dotted border-[#534B4F]/30 pt-[10px]" }),
                /* @__PURE__ */ jsxs("div", { className: "flex items-center justify-start gap-3", children: [
                  /* @__PURE__ */ jsxs("div", { className: "text-sm leading-[1.4] text-[#534B4F]", children: [
                    /* @__PURE__ */ jsx("span", { className: "mr-1 font-medium text-[#E30022]", children: t("redparrot-say", "Say:") }),
                    responseSuggestion.suggestion
                  ] }),
                  handleTTS && /* @__PURE__ */ jsx(
                    "button",
                    {
                      className: "flex size-9 shrink-0 cursor-pointer items-center justify-center rounded-full border border-[rgba(83,75,79,0.15)] bg-[#E6E2DE] shadow-[0_3px_8px_rgba(0,0,0,0.1)] transition-[transform,background-color] duration-100 active:scale-95 active:bg-[rgba(83,75,79,0.05)]",
                      type: "button",
                      onClick: (e) => {
                        e.stopPropagation();
                        handleTTS(responseSuggestion.suggestion, -1);
                      },
                      children: /* @__PURE__ */ jsx(VolumeUpOutlined, {})
                    }
                  )
                ] })
              ] })
            ]
          }
        ),
        !isLoading && /* @__PURE__ */ jsx(
          MobileMessageActions,
          {
            isAssistant,
            isTranslationActive: isTranslationVisible,
            onToggleTranslation,
            isHintActive: isAssistant ? responseSuggestion?.isVisible : isFeedbackVisible,
            onToggleHint: isAssistant ? void 0 : onToggleFeedback,
            onPlayAudio: () => handleTTS(message.content, index$1),
            isPlaying: ttsIndex === index$1,
            isTutorEnabled,
            isTranslatorEnabled,
            responseSuggestion,
            fetchResponseSuggestion,
            toggleSuggestionVisibility,
            t
          }
        ),
        isUser && isFeedbackVisible && message.tutorComment && message.tutorComment !== "." && /* @__PURE__ */ jsxs("div", { className: "mt-2 w-full max-w-[280px] animate-[mobile-slideDown_0.3s_ease-out] rounded-[4px_8px_8px_4px] border-l-4 border-[#FDBF49] bg-white px-4 py-3 text-sm text-[#534B4F] shadow-[0px_4px_12px_rgba(0,0,0,0.08)]", children: [
          /* @__PURE__ */ jsx("strong", { children: t("redparrot-grammar", "Grammar:") }),
          " ",
          message.tutorComment
        ] })
      ]
    }
  );
});

const MobileFloatingBar = ({
  mode,
  inputValue,
  onInputChange,
  handleSubmit,
  onOpenSettings,
  onExit,
  onSwitchToVoice,
  t,
  placeholder,
  useGetTranscription,
  lastMessage,
  languageCode,
  chatId,
  user,
  showSignupModal,
  audioStream,
  setAudioStream,
  handleStopRequest
}) => {
  const startMicRef = useRef(null);
  const recorderRef = useRef(createAudioRecorder());
  const getTranscription = useGetTranscription?.(true);
  const [isLoading, setIsLoading] = useState(false);
  const [isRecording, setIsRecording] = useState(false);
  const handleStopRecording = useCallback(
    async (isCancelRequest = false) => {
      try {
        const recording = await recorderRef.current.stop();
        setIsRecording(false);
        if (!recording || recording.durationMs < 250 || recording.size < 1024 || isCancelRequest)
          return;
        if (getTranscription) {
          getTranscription({
            recordingBlob: recording.blob,
            setIsLoading,
            callback: async (text) => {
              await handleSubmit(null, text);
            },
            ...languageCode && {
              language: languageCode
            },
            chatId,
            prompt: lastMessage
          });
        }
      } catch (err) {
        console.log(err);
        setIsRecording(false);
        setIsLoading(false);
      }
    },
    [handleSubmit, getTranscription, languageCode, chatId, lastMessage]
  );
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.hidden) {
        if (isRecording) handleStopRecording(true);
      }
    };
    document.addEventListener("visibilitychange", handleVisibilityChange);
    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [handleStopRecording, isRecording]);
  useEffect(() => {
    return () => {
      recorderRef.current.cancel().catch(() => {
      });
    };
  }, []);
  const handleStartRecording = useCallback(async () => {
    if (!user && showSignupModal) {
      return showSignupModal();
    }
    if (audioStream) setAudioStream(null);
    try {
      await recorderRef.current.cancel();
      await recorderRef.current.start();
      setIsRecording(true);
    } catch (err) {
    }
  }, [audioStream, setAudioStream, user, showSignupModal]);
  function handleChangeRecording() {
    if (isLoading) return;
    if (isRecording) {
      handleStopRecording();
    } else {
      handleStartRecording();
    }
  }
  const onMouseDown = () => {
    if (isLoading) {
      handleStopRequest();
      handleStartRecording();
      setIsLoading(false);
      return;
    }
    startMicRef.current = performance.now();
    handleChangeRecording();
  };
  const onMouseUp = () => {
    if (startMicRef.current && performance.now() - startMicRef.current > 1e3) {
      handleStopRecording();
    }
  };
  if (mode === "voice" || mode === "push") {
    return /* @__PURE__ */ jsx("div", { className: "absolute bottom-[30px] z-[100] flex w-full justify-center px-5", children: /* @__PURE__ */ jsxs("div", { className: "relative flex h-[72px] w-full max-w-[450px] items-center justify-between rounded-[40px] bg-[#FDF8F1] px-6 py-3 shadow-[0_8px_24px_rgba(0,0,0,0.12)] transition-all", children: [
      /* @__PURE__ */ jsx(
        "button",
        {
          className: "cursor-pointer rounded-full border-none bg-transparent p-2.5 transition-colors hover:bg-black/5",
          onClick: onOpenSettings,
          type: "button",
          children: /* @__PURE__ */ jsx(SettingsOutlined, { className: "text-[#534B4F]" })
        }
      ),
      /* @__PURE__ */ jsxs(
        "div",
        {
          className: classNames(
            "absolute left-1/2 top-1/2 h-20 w-20 -translate-x-1/2 -translate-y-1/2",
            {
              "mobile-mic-active": isRecording
            }
          ),
          children: [
            /* @__PURE__ */ jsx("div", { className: "mobile-mic-wave" }),
            /* @__PURE__ */ jsx("div", { className: "mobile-mic-wave" }),
            /* @__PURE__ */ jsx(
              "button",
              {
                className: "relative z-[2] flex size-20 cursor-pointer items-center justify-center rounded-full border-none bg-[#E30022] text-white shadow-[0_10px_20px_rgba(227,0,34,0.3)] transition-transform active:scale-95",
                onMouseDown: () => {
                  if ("ontouchstart" in window || navigator.maxTouchPoints > 0) return;
                  onMouseDown();
                },
                onMouseUp: () => {
                  if ("ontouchstart" in window || navigator.maxTouchPoints > 0) return;
                  onMouseUp();
                },
                onTouchStart: onMouseDown,
                onTouchEnd: onMouseUp,
                onContextMenu: (e) => e.preventDefault(),
                type: "button",
                children: isLoading ? /* @__PURE__ */ jsx(CircularProgress, { color: "inherit" }) : /* @__PURE__ */ jsx(Mic, { className: "text-white", style: { fontSize: 32 } })
              }
            )
          ]
        }
      ),
      onExit && /* @__PURE__ */ jsx(
        "button",
        {
          className: "cursor-pointer rounded-full border-none bg-transparent p-2.5 transition-colors hover:bg-black/5",
          onClick: onExit,
          type: "button",
          children: /* @__PURE__ */ jsx(LogoutOutlined, { className: "text-[#534B4F]" })
        }
      )
    ] }) });
  }
  return /* @__PURE__ */ jsx("div", { className: "absolute bottom-[30px] z-[100] flex w-full justify-center px-5", children: /* @__PURE__ */ jsxs("div", { className: "flex min-w-[300px] flex-wrap items-center gap-3 rounded-[28px] bg-[#FDF8F1] p-4 shadow-[0_8px_24px_rgba(0,0,0,0.12)] transition-all", children: [
    /* @__PURE__ */ jsxs("div", { className: "order-2 flex shrink-0 gap-2 pl-1", children: [
      /* @__PURE__ */ jsx(
        "button",
        {
          className: "cursor-pointer rounded-full border-none bg-transparent p-2.5 transition-colors hover:bg-black/5",
          onClick: onOpenSettings,
          type: "button",
          children: /* @__PURE__ */ jsx(SettingsOutlined, { className: "text-[#534B4F]" })
        }
      ),
      onExit && /* @__PURE__ */ jsx(
        "button",
        {
          className: "cursor-pointer rounded-full border-none bg-transparent p-2.5 transition-colors hover:bg-black/5",
          onClick: onExit,
          type: "button",
          children: /* @__PURE__ */ jsx(LogoutOutlined, { className: "text-[#534B4F]" })
        }
      )
    ] }),
    /* @__PURE__ */ jsxs("div", { className: "relative order-1 flex w-full flex-[0_0_100%]", children: [
      /* @__PURE__ */ jsx(
        "textarea",
        {
          className: "h-14 w-full resize-none rounded-[20px] border-none bg-white px-4 py-4 pr-10 font-[Rubik] text-base leading-6 text-[#534B4F] shadow-[inset_0_1px_3px_rgba(0,0,0,0.05)] outline-none placeholder:text-[#534B4F]/50",
          placeholder: placeholder || t("eleo-chat-input-placeholder", "Write a message..."),
          value: inputValue,
          onChange: (e) => onInputChange(e.target.value),
          rows: 1
        }
      ),
      onSwitchToVoice && /* @__PURE__ */ jsx(
        "div",
        {
          className: "absolute right-3 top-1/2 -translate-y-1/2 cursor-pointer opacity-60 transition-opacity hover:opacity-100",
          onClick: onSwitchToVoice,
          role: "button",
          tabIndex: 0,
          children: /* @__PURE__ */ jsx(Mic, { className: "text-[#534B4F]", style: { fontSize: 22 } })
        }
      )
    ] }),
    /* @__PURE__ */ jsx(
      "button",
      {
        className: "order-3 ml-auto flex size-12 shrink-0 cursor-pointer items-center justify-center rounded-full border-none bg-[#E30022] text-white shadow-[0_4px_10px_rgba(227,0,34,0.3)] transition-transform active:scale-95",
        onClick: handleSubmit,
        disabled: isLoading,
        type: "button",
        children: /* @__PURE__ */ jsx(ArrowUpward, { style: { fontSize: 22 } })
      }
    )
  ] }) });
};

const MobileSettingsSheet = memo(function MobileSettingsSheet2({
  isOpen,
  onClose,
  inputMode,
  onModeChange,
  onClearChat,
  onShowHistory,
  userCanAccessHistory = false,
  t
}) {
  const handleModeSelect = (mode) => {
    onModeChange(mode);
    onClose();
  };
  const handleClearChat = () => {
    onClearChat();
    onClose();
  };
  const handleShowHistory = () => {
    onShowHistory?.();
    onClose();
  };
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      "div",
      {
        className: classNames(
          "absolute inset-0 z-[200] bg-black/20 backdrop-blur-[10px] transition-opacity duration-300",
          isOpen ? "pointer-events-auto opacity-100" : "pointer-events-none opacity-0"
        ),
        onClick: onClose
      }
    ),
    /* @__PURE__ */ jsxs(
      "div",
      {
        className: classNames(
          "absolute left-0 z-[210] flex w-full flex-col rounded-t-[32px] bg-[#FDF8F1] px-6 pb-10 pt-6 shadow-[0_-5px_30px_rgba(0,0,0,0.1)] transition-[bottom] duration-300",
          isOpen ? "bottom-0" : "-bottom-full"
        ),
        style: { transitionTimingFunction: "cubic-bezier(0.25, 1, 0.5, 1)" },
        children: [
          /* @__PURE__ */ jsx(
            "div",
            {
              className: "mx-auto mb-6 h-1 w-10 shrink-0 cursor-pointer rounded-sm bg-[#E0E0E0] hover:bg-[#D0D0D0]",
              onClick: onClose
            }
          ),
          /* @__PURE__ */ jsxs("div", { className: "flex flex-1 flex-col gap-1", children: [
            /* @__PURE__ */ jsxs(
              "div",
              {
                className: classNames(
                  "flex cursor-pointer items-center gap-4 rounded-xl px-3 py-4 text-base text-[#534B4F] transition-colors active:bg-[#F5F5F5]",
                  { "bg-[#F5F5F5]": inputMode === "text" }
                ),
                onClick: () => handleModeSelect("text"),
                children: [
                  /* @__PURE__ */ jsx(ChatBubbleOutline, {}),
                  t("eleo-chat-mode-text", "Text chat")
                ]
              }
            ),
            /* @__PURE__ */ jsxs(
              "div",
              {
                className: classNames(
                  "flex cursor-pointer items-center gap-4 rounded-xl px-3 py-4 text-base text-[#534B4F] transition-colors active:bg-[#F5F5F5]",
                  { "bg-[#F5F5F5]": inputMode === "voice" }
                ),
                onClick: () => handleModeSelect("voice"),
                children: [
                  /* @__PURE__ */ jsx(MicNone, {}),
                  t("eleo-chat-mode-voice", "Voice chat")
                ]
              }
            ),
            /* @__PURE__ */ jsxs(
              "div",
              {
                className: classNames(
                  "flex cursor-pointer items-center gap-4 rounded-xl px-3 py-4 text-base text-[#534B4F] transition-colors active:bg-[#F5F5F5]",
                  { "bg-[#F5F5F5]": inputMode === "push" }
                ),
                onClick: () => handleModeSelect("push"),
                children: [
                  /* @__PURE__ */ jsx(TouchAppOutlined, {}),
                  t("eleo-chat-mode-push", "Push to talk")
                ]
              }
            ),
            /* @__PURE__ */ jsx("div", { className: "my-2 h-px bg-black/10" }),
            userCanAccessHistory && onShowHistory && /* @__PURE__ */ jsxs(
              "div",
              {
                className: "flex cursor-pointer items-center gap-4 rounded-xl px-3 py-4 text-base text-[#534B4F] transition-colors active:bg-[#F5F5F5]",
                onClick: handleShowHistory,
                children: [
                  /* @__PURE__ */ jsx(HistoryOutlined, {}),
                  t("eleo-tool-chat-history-header", "History")
                ]
              }
            ),
            /* @__PURE__ */ jsxs(
              "div",
              {
                className: "flex cursor-pointer items-center gap-4 rounded-xl px-3 py-4 text-base text-[#E30022] transition-colors active:bg-[#F5F5F5]",
                onClick: handleClearChat,
                children: [
                  /* @__PURE__ */ jsx(DeleteOutlined, {}),
                  t("eleo-chat-settings-clear-chat", "Clear chat")
                ]
              }
            )
          ] })
        ]
      }
    )
  ] });
});

const MobileChatUI = memo(function MobileChatUI2({
  messages,
  inputMode,
  setInputMode,
  message,
  setMessage,
  handleSubmit,
  handleTTS,
  ttsIndex,
  t,
  responseSuggestions,
  fetchResponseSuggestion,
  toggleSuggestionVisibility,
  onClearChat,
  onShowHistory,
  userCanAccessHistory = false,
  isTutorEnabled = true,
  isTranslatorEnabled = true,
  onExit,
  placeholder,
  ContextMenu,
  useGetTranscription,
  languageCode,
  chatId,
  user,
  showSignupModal,
  audioStream,
  setAudioStream,
  handleStopRequest
}) {
  const [isSettingsOpen, setIsSettingsOpen] = useState(false);
  const [translationVisibleFor, setTranslationVisibleFor] = useState(/* @__PURE__ */ new Set());
  const [feedbackVisibleFor, setFeedbackVisibleFor] = useState(/* @__PURE__ */ new Set());
  const chatAreaRef = useRef(null);
  const toggleTranslation = useCallback((index) => {
    setTranslationVisibleFor((prev) => {
      const newSet = new Set(prev);
      if (newSet.has(index)) {
        newSet.delete(index);
      } else {
        newSet.add(index);
      }
      return newSet;
    });
  }, []);
  const toggleFeedback = useCallback((index) => {
    setFeedbackVisibleFor((prev) => {
      const newSet = new Set(prev);
      if (newSet.has(index)) {
        newSet.delete(index);
      } else {
        newSet.add(index);
      }
      return newSet;
    });
  }, []);
  const handleOpenSettings = useCallback(() => {
    setIsSettingsOpen(true);
  }, []);
  const handleCloseSettings = useCallback(() => {
    setIsSettingsOpen(false);
  }, []);
  const handleModeChange = useCallback(
    (mode) => {
      setInputMode(mode);
      setIsSettingsOpen(false);
    },
    [setInputMode]
  );
  useEffect(() => {
    if (chatAreaRef.current) {
      setTimeout(() => {
        chatAreaRef.current?.scrollTo({
          top: chatAreaRef.current.scrollHeight,
          behavior: "smooth"
        });
      }, 100);
    }
  }, [messages.length]);
  const wordSelectRef = useRef(null);
  const clickCountRef = useRef(0);
  const handleSelectWord = useCallback((e) => {
    if (e.target.tagName !== "SPAN" || e.target.innerText.split(/(\s+|\n)/).length > 1) return;
    const range = document.createRange();
    clickCountRef.current += 1;
    if (clickCountRef.current === 2) {
      clearTimeout(wordSelectRef.current);
      wordSelectRef.current = setTimeout(() => {
        clickCountRef.current = 0;
      }, 300);
      return;
    } else if (clickCountRef.current === 3) {
      clearTimeout(wordSelectRef.current);
      clickCountRef.current = 0;
      return;
    }
    const selection = window.getSelection();
    selection.removeAllRanges();
    range.selectNodeContents(e.target);
    selection.addRange(range);
    wordSelectRef.current = setTimeout(() => {
      wordSelectRef.current = null;
      clickCountRef.current = 0;
    }, 300);
  }, []);
  const handleClearSelection = (e) => {
    if (e.target.tagName !== "SPAN" || e.target.innerText.split(/(\s+|\n)/).length > 1) return;
    const selection = window.getSelection();
    selection.removeAllRanges();
  };
  return /* @__PURE__ */ jsxs("div", { className: "relative flex h-full w-full flex-col overflow-hidden bg-[#FDF8F1]", children: [
    /* @__PURE__ */ jsx(
      "div",
      {
        className: classNames(
          "flex flex-1 flex-col gap-6 overflow-y-auto scroll-smooth px-5 pt-10 [&::-webkit-scrollbar-thumb]:rounded-[3px] [&::-webkit-scrollbar-thumb]:bg-black/10 [&::-webkit-scrollbar]:w-1.5",
          {
            "pb-[200px]": inputMode === "text",
            "pb-[125px]": inputMode === "voice" || inputMode === "push"
          }
        ),
        ref: chatAreaRef,
        onClick: handleSelectWord,
        onMouseDown: handleClearSelection,
        onTouchStart: handleClearSelection,
        children: messages.map((msg, index) => /* @__PURE__ */ jsx(
          MobileChatMessage,
          {
            message: msg,
            index,
            t,
            isTranslationVisible: translationVisibleFor.has(index),
            onToggleTranslation: () => toggleTranslation(index),
            isFeedbackVisible: feedbackVisibleFor.has(index),
            onToggleFeedback: () => toggleFeedback(index),
            responseSuggestion: responseSuggestions[index],
            fetchResponseSuggestion: () => fetchResponseSuggestion(index),
            toggleSuggestionVisibility: () => toggleSuggestionVisibility(index),
            handleTTS,
            ttsIndex,
            isTutorEnabled,
            isTranslatorEnabled,
            ContextMenu: (props) => /* @__PURE__ */ jsx(
              ContextMenu,
              {
                ...props,
                getTextContext: () => msg.content,
                enableTranslate: true,
                isLastMessage: index === messages.length - 1
              }
            )
          },
          index
        ))
      }
    ),
    /* @__PURE__ */ jsx(
      MobileFloatingBar,
      {
        mode: inputMode,
        inputValue: message,
        onInputChange: setMessage,
        handleSubmit,
        onOpenSettings: handleOpenSettings,
        onExit,
        onSwitchToVoice: inputMode === "text" ? () => setInputMode("push") : void 0,
        t,
        placeholder,
        useGetTranscription,
        lastMessage: messages[messages.length - 1]?.content,
        languageCode,
        chatId,
        user,
        showSignupModal,
        audioStream,
        setAudioStream,
        handleStopRequest
      }
    ),
    /* @__PURE__ */ jsx(
      MobileSettingsSheet,
      {
        isOpen: isSettingsOpen,
        onClose: handleCloseSettings,
        inputMode,
        onModeChange: handleModeChange,
        onClearChat,
        onShowHistory,
        userCanAccessHistory,
        t
      }
    )
  ] });
});

const DEFAULT_MODAL_DATA$1 = {
  isVisible: false,
  title: "",
  acceptLabel: "",
  cancelLabel: "",
  type: "",
  context: {}
};
function Modal({
  hideModal,
  containerClasses,
  isVisible,
  title,
  subtitle,
  content,
  acceptLabel,
  cancelLabel,
  callback,
  isValid,
  isPrimary = true,
  // Color scheme
  submitOnEnter = true,
  disableBorder = false,
  width = 280,
  acceptButtonClasses,
  disableCloseOnBackdropClick = false,
  useSecondaryAccept = false,
  secondaryAcceptLabel,
  t = (key, text) => text
}) {
  const transitionRef = useRef();
  const [isLoading, setIsLoading] = useState(false);
  const handleCloseModal = (e) => {
    e.stopPropagation();
    e.target === e.currentTarget && hideModal(false);
  };
  const handleSubmitModal = async (isSubmitSecondaryEffect = false) => {
    setIsLoading(true);
    try {
      await callback?.(isSubmitSecondaryEffect);
    } finally {
      setIsLoading(false);
      hideModal(true);
    }
  };
  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event.key === "Enter" && isVisible && isValid && !isLoading) {
        handleSubmitModal();
      }
    };
    if (submitOnEnter) document.addEventListener("keydown", handleKeyPress);
    return () => {
      document.removeEventListener("keydown", handleKeyPress);
    };
  }, [isVisible, isValid, isLoading]);
  if (!isVisible) return;
  return /* @__PURE__ */ jsx(CSSTransition, { nodeRef: transitionRef, in: true, appear: true, timeout: 0, classNames: "modal", children: /* @__PURE__ */ jsx(
    "div",
    {
      ref: transitionRef,
      className: "modal visible",
      onClick: (e) => !disableCloseOnBackdropClick && handleCloseModal(e),
      children: /* @__PURE__ */ jsx(
        "div",
        {
          className: classNames(
            "modal-content",
            "flex max-h-[90dvh] !max-w-[95dvw] rounded-[4px] bg-white lg:!w-[500px] lg:max-w-none"
          ),
          style: { width: `${width}px` },
          children: /* @__PURE__ */ jsxs("div", { className: classNames(containerClasses, "flex w-full flex-col"), children: [
            /* @__PURE__ */ jsxs(
              "div",
              {
                className: classNames(
                  "py-[14px] pl-[24px] pr-3",
                  disableBorder ? "pb-0" : "border-b"
                ),
                children: [
                  /* @__PURE__ */ jsxs("div", { className: "flex items-center justify-between", children: [
                    /* @__PURE__ */ jsx(
                      "div",
                      {
                        className: classNames(
                          "text-[14px] font-medium",
                          isPrimary && "text-brand-violet"
                        ),
                        children: title
                      }
                    ),
                    /* @__PURE__ */ jsx(
                      Microbutton,
                      {
                        variant: "plain",
                        icon: /* @__PURE__ */ jsx(Close, { fontSize: "inherit" }),
                        className: classNames(
                          "bg-transparent hover:bg-black/10",
                          isPrimary && "text-brand-violet"
                        ),
                        onClick: () => hideModal(false)
                      }
                    )
                  ] }),
                  subtitle && /* @__PURE__ */ jsx(
                    "div",
                    {
                      className: classNames("body-small opacity-60", isPrimary && "text-brand-violet"),
                      children: subtitle
                    }
                  )
                ]
              }
            ),
            content,
            /* @__PURE__ */ jsxs(
              "div",
              {
                className: classNames(
                  "flex flex-wrap items-center justify-center gap-[10px] px-[24px] py-[14px] md:flex-nowrap",
                  content && "border-t"
                ),
                children: [
                  /* @__PURE__ */ jsx(
                    Microbutton,
                    {
                      variant: "transparent-light",
                      type: "large-font",
                      text: cancelLabel ?? t("eleo-cancel", "cancel"),
                      className: classNames(
                        "h-[40px] flex-1 uppercase",
                        !isPrimary && "!text-brand-gray-dark bg-brand-gray-light"
                      ),
                      textClasses: "!font-bold",
                      onClick: () => hideModal(false),
                      disabled: isLoading
                    }
                  ),
                  useSecondaryAccept && secondaryAcceptLabel && /* @__PURE__ */ jsx(
                    Microbutton,
                    {
                      variant: "transparent-light",
                      type: "large-font",
                      disabled: !isValid,
                      text: secondaryAcceptLabel ?? t("eleo-save", "save"),
                      className: classNames(
                        "h-[40px] flex-1  uppercase",
                        !isValid && "opacity-80",
                        !isPrimary && "!text-brand-gray-dark bg-brand-gray-light",
                        acceptButtonClasses
                      ),
                      textClasses: "!font-bold",
                      isLoading,
                      onClick: () => handleSubmitModal(true)
                    }
                  ),
                  acceptLabel && /* @__PURE__ */ jsx(
                    Microbutton,
                    {
                      disabled: !isValid,
                      variant: "solid",
                      type: "large-font",
                      text: acceptLabel ?? t("eleo-save", "save"),
                      className: classNames(
                        "h-[40px] flex-1  uppercase",
                        !isValid && "opacity-80",
                        !isPrimary && "!text-brand-gray-dark bg-brand-gray-light",
                        acceptButtonClasses
                      ),
                      textClasses: "!font-bold",
                      isLoading,
                      onClick: () => handleSubmitModal(false)
                    }
                  )
                ]
              }
            )
          ] })
        }
      )
    }
  ) });
}

const DEFAULT_MODAL_DATA = {
  isVisible: false,
  title: "",
  subtitle: "",
  acceptLabel: "",
  type: "",
  context: {}
};
function ImageDisplay({
  image,
  imageData,
  preview,
  moreLikeThis,
  noupload,
  onModify,
  showShareModal,
  removeItem,
  previewProportions,
  imagePreviewData,
  setImagePreviewData,
  handleRename,
  handleMove,
  handleChangeDescription,
  galleries,
  selectedGallery,
  setSelectedGallery,
  ViewContext,
  clientId,
  setPending,
  saveToGallery,
  t = (key, text) => text,
  noModify = false,
  useDispatch: useDispatch2,
  disableEdit = false,
  isAdvancedDownload = true
}) {
  const context = useContext(ViewContext);
  const navigate = useNavigate();
  const dispatchAction = useDispatch2?.();
  const { width } = useWindowDimensions();
  const [anchorEl, setAnchorEl] = useState(null);
  const [modalData, setModalData] = useState(DEFAULT_MODAL_DATA);
  const [downloadName, setDownloadName] = useState("");
  const [dimentions, setDimentions] = useState();
  const [upscaleValue, setUpscaleValue] = useState(1);
  const newImageData = {
    ...imageData,
    template: void 0,
    allowStyles: void 0,
    promptId: void 0
  };
  useEffect(() => {
    if (!image) return;
    const img = new Image();
    img.onload = () => setDimentions({
      width: img.width,
      height: img.height
    });
    img.src = image;
    return () => {
      img.onload = null;
    };
  }, [image]);
  const handleCallback = async (type) => {
    switch (type) {
      case "download":
        if (upscaleValue === 1 || !clientId) {
          await downloadImage(
            image,
            downloadName ?? t("eleo-default-image-name", "Your image")
          );
          return;
        }
        try {
          const data = {
            clientId,
            front: true,
            data: { image, times: upscaleValue, action: "upscale", samples: 1 },
            promptId: v4()
          };
          dispatchAction(
            setPending({
              upscale: {
                id: data.promptId,
                name: downloadName ?? t("eleo-default-image-name", "Your image"),
                inQueue: true
              }
            })
          );
          await axios.post("/api/ai/comfy", data);
          successToast(
            t(
              "eleo-upscale-queued",
              "Your request has been queued. Image will be downloaded automatically"
            ),
            null,
            2e3
          );
        } catch (err) {
          dispatchAction(
            setPending({
              upscale: {}
            })
          );
          context.handleError(err);
        }
        break;
      case "gallery":
        if (!selectedGallery?.value)
          return errorToast(t("eleo-error-select-gallery", "Please select a gallery"));
        await saveToGallery(
          image,
          downloadName ?? image.split("generations/")[1],
          newImageData,
          selectedGallery.value
        );
        break;
    }
  };
  const handleOpenDownloadModal = () => {
    setDownloadName("");
    setUpscaleValue(1);
    setModalData({
      isVisible: true,
      title: t("eleo-download-modal-title", "Download image"),
      subtitle: isAdvancedDownload ? t(
        "eleo-download-modal-subtitle",
        "If you want to modify this image in the future, we rocmmend saving it in the Eleo gallery. This way you will have an access to the initial request during the modification."
      ) : void 0,
      acceptLabel: t("eleo-download", "download"),
      type: "download",
      context: {}
    });
  };
  const handleOpenGalleryModal = () => {
    setDownloadName("");
    setModalData({
      isVisible: true,
      title: t("eleo-gallery-modal-title", "Save to gallery"),
      acceptLabel: t("eleo-save", "save"),
      type: "gallery",
      context: {}
    });
  };
  const options = (dimensions) => {
    if (!dimensions) return [{}, {}, {}];
    const breakpoint1 = 3e5;
    const breakpoint2 = 11e7;
    let size;
    if (dimensions.width * dimensions.height < breakpoint1) size = 1;
    else if (dimensions.width * dimensions.height < breakpoint2) size = 2;
    else size = 4;
    const options2 = [
      {
        label: `${Math.floor(dimensions.width / size)}x${Math.floor(dimensions.height / size)}`,
        value: 1 / size
      },
      {
        label: `${Math.floor(2 * dimensions.width / size)}x${Math.floor(2 * dimensions.height / size)}`,
        value: 2 / size
      },
      {
        label: `${Math.floor(4 * dimensions.width / size)}x${Math.floor(4 * dimensions.height / size)}`,
        value: 4 / size
      }
    ];
    return options2;
  };
  const modalContent = {
    download: /* @__PURE__ */ jsxs("div", { className: "space-y-[20px] p-[24px]", children: [
      /* @__PURE__ */ jsxs("div", { className: "space-y-[5px]", children: [
        /* @__PURE__ */ jsx("p", { className: "body-small text-brand-gray-dark", children: t("eleo-download-modal-image-name", "Image name") }),
        /* @__PURE__ */ jsx(
          "input",
          {
            autoFocus: true,
            spellCheck: false,
            value: downloadName,
            onChange: (e) => setDownloadName(e.target.value),
            className: "h-[36px] w-full rounded-[4px] border bg-white py-[10px] pl-3 pr-[4px] text-[13px]",
            placeholder: t("eleo-download-modal-input-placeholder", "Enter image name")
          }
        )
      ] }),
      isAdvancedDownload && /* @__PURE__ */ jsxs("div", { className: "space-y-[5px]", children: [
        /* @__PURE__ */ jsx("p", { className: "body-small text-brand-gray-dark", children: t("eleo-download-modal-image-size", "Image size") }),
        /* @__PURE__ */ jsx(
          ButtonGroup,
          {
            className: "w-full",
            options: options(dimentions),
            value: Number(upscaleValue),
            onClick: (e) => setUpscaleValue(Number(e.target.value))
          }
        )
      ] })
    ] }),
    gallery: /* @__PURE__ */ jsxs("div", { className: "space-y-[5px] p-[24px]", children: [
      /* @__PURE__ */ jsx("p", { className: "body-small text-brand-gray-dark", children: t("eleo-modal-save-to-gallery-gallery-selection-label", "Choose gallery") }),
      /* @__PURE__ */ jsx(
        ReactSelect,
        {
          options: galleries?.filter((gallery) => !gallery.isMediaGallery),
          setSelectedValue: ({ value, label }) => setSelectedGallery && setSelectedGallery({ value, label }),
          value: selectedGallery,
          isClearable: false
        }
      ),
      /* @__PURE__ */ jsx("p", { className: "body-small text-brand-gray-dark", children: t("eleo-download-modal-image-name", "Image name") }),
      /* @__PURE__ */ jsx(
        "input",
        {
          autoFocus: true,
          spellCheck: false,
          value: downloadName,
          onChange: (e) => setDownloadName(e.target.value),
          className: "h-[36px] w-full rounded-[4px] border bg-white py-[10px] pl-3 pr-[4px] text-[13px]",
          placeholder: t("eleo-download-modal-input-placeholder", "Enter image name")
        }
      )
    ] })
  };
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);
  const popoverId = open ? "context-popover" : void 0;
  const contextMenu = image && /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs(
    "div",
    {
      className: classNames(
        "absolute bottom-[10px] right-[10px] flex items-center gap-1 rounded-[4px] bg-white p-1 opacity-0 shadow-[1px_1px_5px_#00000035] transition-opacity duration-200 ease-in-out group-focus-within:opacity-100 group-hover:opacity-100",
        anchorEl && "opacity-100"
      ),
      children: [
        width >= 1024 && /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx(
            Microbutton,
            {
              className: "bg-transparent",
              variant: "transparent-light",
              onClick: handleClick,
              icon: /* @__PURE__ */ jsx(MoreVert, { fontSize: "inherit" })
            }
          ),
          /* @__PURE__ */ jsx(
            Popover,
            {
              id: popoverId,
              open,
              anchorEl,
              onClose: handleClose,
              anchorOrigin: {
                vertical: "top",
                horizontal: "left"
              },
              transformOrigin: {
                vertical: "bottom",
                horizontal: "left"
              },
              children: /* @__PURE__ */ jsxs("div", { className: "space-y-[10px] p-2 pb-[10px]", children: [
                /* @__PURE__ */ jsx(
                  ListPosition,
                  {
                    icon: /* @__PURE__ */ jsx(Share, { fontSize: "inherit" }),
                    text: t("eleo-result-share", "Share"),
                    className: "w-[100px]",
                    onClick: () => {
                      handleClose();
                      showShareModal && showShareModal(image);
                    }
                  }
                ),
                preview && /* @__PURE__ */ jsx(
                  ListPosition,
                  {
                    icon: /* @__PURE__ */ jsx(CropFree, { fontSize: "inherit" }),
                    text: t("eleo-zoom", "Zoom"),
                    onClick: () => {
                      handleClose();
                      preview(image);
                    }
                  }
                )
              ] })
            }
          ),
          /* @__PURE__ */ jsx("div", { className: "border-brand-form-accent h-[18px] w-[1px] border-r" })
        ] }),
        !noupload && /* @__PURE__ */ jsx(
          Microbutton,
          {
            className: "bg-transparent",
            variant: "transparent-light",
            onClick: () => handleOpenGalleryModal(),
            title: t("eleo-title-upload", "Save this image in your gallery"),
            icon: /* @__PURE__ */ jsx(Save, { fontSize: "inherit" })
          }
        ),
        /* @__PURE__ */ jsx(
          Microbutton,
          {
            className: "h-[28px] bg-transparent",
            variant: "transparent-light",
            onClick: () => handleOpenDownloadModal(),
            title: t("eleo-title-download", "Download this image"),
            icon: /* @__PURE__ */ jsx(Download, { fontSize: "inherit" })
          }
        ),
        removeItem && !disableEdit && /* @__PURE__ */ jsx(
          Microbutton,
          {
            className: "h-[28px] bg-transparent",
            variant: "transparent-light",
            onClick: () => removeItem(image),
            icon: /* @__PURE__ */ jsx(Delete, { fontSize: "inherit" }),
            title: t("eleo-title-delete", "Delete this image")
          }
        ),
        handleRename && !disableEdit && /* @__PURE__ */ jsx(
          Microbutton,
          {
            className: "h-[28px] bg-transparent",
            variant: "transparent-light",
            onClick: handleRename,
            icon: /* @__PURE__ */ jsx(DriveFileRenameOutline, { fontSize: "inherit" }),
            title: t("eleo-title-rename", "Rename this image")
          }
        ),
        handleMove && /* @__PURE__ */ jsx(
          Microbutton,
          {
            className: "h-[28px] bg-transparent",
            variant: "transparent-light",
            onClick: handleMove,
            icon: /* @__PURE__ */ jsx(DriveFileMove, { fontSize: "inherit" }),
            title: t("eleo-title-move", "Move this image to another gallery")
          }
        ),
        handleChangeDescription && !disableEdit && /* @__PURE__ */ jsx(
          Microbutton,
          {
            className: "h-[28px] bg-transparent",
            variant: "transparent-light",
            onClick: handleChangeDescription,
            icon: /* @__PURE__ */ jsx(Description, { fontSize: "inherit" }),
            title: t("eleo-title-change-description", "Change this images description")
          }
        ),
        moreLikeThis ? /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx("div", { className: "border-brand-form-accent h-[18px] w-[1px] border-r" }),
          /* @__PURE__ */ jsx(
            Microbutton,
            {
              className: "bg-transparent",
              variant: "transparent-light",
              iconPlacement: "left",
              icon: /* @__PURE__ */ jsx(Sparkle, { fontSize: 18, weight: "fill" }),
              text: t("eleo-more-like-this", "More like this"),
              onClick: () => moreLikeThis()
            }
          )
        ] }) : !noModify && /* @__PURE__ */ jsx(
          Microbutton,
          {
            className: "h-[28px] bg-transparent",
            variant: "transparent-light",
            onClick: () => navigate("/image/modify", {
              state: {
                baseImage: image ?? "",
                imageData: newImageData
              }
            }),
            icon: /* @__PURE__ */ jsx(AutoAwesome, { fontSize: "inherit" }),
            title: t("eleo-title-modify", "Modify this image")
          }
        )
      ]
    }
  ) });
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    image ? /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsxs(
        "div",
        {
          className: "group relative max-h-full min-h-[200px] max-w-full rounded-[10px]",
          style: {
            aspectRatio: previewProportions
          },
          onClick: () => width < 1024 && preview && preview(image, true),
          children: [
            /* @__PURE__ */ jsx(
              "img",
              {
                className: classNames(
                  "h-full max-h-full w-full max-w-full rounded-[10px] object-contain",
                  noupload && "w-full"
                ),
                src: image,
                alt: "",
                loading: "lazy"
              }
            ),
            contextMenu
          ]
        }
      ),
      imagePreviewData && imagePreviewData.isVisible && imagePreviewData.target === image && /* @__PURE__ */ jsxs(
        "div",
        {
          className: classNames(
            "fixed inset-0 z-[999] flex flex-col items-center justify-between",
            imagePreviewData.isMobile ? "bg-black" : "bg-black/90"
          ),
          onClick: (e) => e.target === e.currentTarget && setImagePreviewData && setImagePreviewData((prev) => ({ ...prev, isVisible: false })),
          children: [
            /* @__PURE__ */ jsx("div", {}),
            /* @__PURE__ */ jsxs("div", { className: "relative lg:h-[70dvh]", children: [
              /* @__PURE__ */ jsx(
                "img",
                {
                  className: classNames(
                    "lg:max-h-auto max-h-[60dvh] object-contain shadow-lg lg:h-[70dvh] lg:w-full lg:bg-white lg:object-cover",
                    imagePreviewData.isMobile ? "w-full" : "w-[90vw] rounded-lg"
                  ),
                  src: imagePreviewData.target,
                  alt: ""
                }
              ),
              !imagePreviewData.isMobile && /* @__PURE__ */ jsx(
                Close,
                {
                  size: 32,
                  className: "text-brand-text-primary absolute -right-[2px] -top-8 hover:cursor-pointer",
                  onClick: () => setImagePreviewData && setImagePreviewData((prev) => ({ ...prev, isVisible: false }))
                }
              )
            ] }),
            /* @__PURE__ */ jsx(
              "div",
              {
                className: classNames(
                  "my-2 flex w-full items-center justify-center gap-[22px] px-[22px]",
                  !imagePreviewData.isMobile && "invisible"
                ),
                children: /* @__PURE__ */ jsxs(Fragment, { children: [
                  /* @__PURE__ */ jsx(
                    Microbutton,
                    {
                      className: "text-brand-text-primary size-[36px] bg-transparent",
                      variant: "plain",
                      onClick: handleClick,
                      icon: /* @__PURE__ */ jsx(MoreVert, { fontSize: "inherit" })
                    }
                  ),
                  /* @__PURE__ */ jsx(
                    Popover,
                    {
                      id: popoverId,
                      open,
                      anchorEl,
                      onClose: handleClose,
                      anchorOrigin: {
                        vertical: "top",
                        horizontal: "left"
                      },
                      transformOrigin: {
                        vertical: "bottom",
                        horizontal: "left"
                      },
                      children: /* @__PURE__ */ jsxs("div", { className: "space-y-[10px] p-2 pb-[10px]", children: [
                        /* @__PURE__ */ jsx(
                          ListPosition,
                          {
                            icon: /* @__PURE__ */ jsx(Share, { fontSize: "inherit" }),
                            text: t("eleo-result-share", "Share"),
                            className: "w-[100px]",
                            onClick: () => {
                              handleClose();
                              showShareModal && imagePreviewData.target && showShareModal(imagePreviewData.target);
                            }
                          }
                        ),
                        /* @__PURE__ */ jsx(
                          ListPosition,
                          {
                            icon: /* @__PURE__ */ jsx(AutoAwesome, { fontSize: "inherit" }),
                            text: t("eleo-modify", "Modify"),
                            onClick: () => navigate("/image/modify", {
                              state: {
                                baseImage: imagePreviewData.target ?? ""
                                // imageData: newImageData,
                              }
                            })
                          }
                        )
                      ] })
                    }
                  ),
                  /* @__PURE__ */ jsx(
                    Microbutton,
                    {
                      className: "text-brand-text-primary size-[36px] bg-transparent",
                      variant: "plain",
                      onClick: () => handleOpenGalleryModal(),
                      title: t("eleo-title-upload", "Save this image in your gallery"),
                      icon: /* @__PURE__ */ jsx(Save, { fontSize: "inherit" })
                    }
                  ),
                  /* @__PURE__ */ jsx(
                    Microbutton,
                    {
                      className: "text-brand-text-primary size-[36px] bg-transparent",
                      variant: "plain",
                      onClick: () => handleOpenDownloadModal(),
                      title: t("eleo-title-download", "Download this image"),
                      icon: /* @__PURE__ */ jsx(Download, { fontSize: "inherit" })
                    }
                  ),
                  /* @__PURE__ */ jsx("div", { className: "h-[18px] w-[1px] border-r border-white/15" }),
                  /* @__PURE__ */ jsx(
                    Microbutton,
                    {
                      className: "text-brand-text-primary h-[36px] bg-transparent",
                      variant: "plain",
                      iconPlacement: "left",
                      icon: /* @__PURE__ */ jsx(Sparkle, { fontSize: 18, weight: "fill" }),
                      text: t("eleo-more-like-this", "More like this"),
                      onClick: () => {
                        setImagePreviewData && setImagePreviewData((prev) => ({ ...prev, isVisible: false }));
                        moreLikeThis && moreLikeThis();
                      }
                    }
                  )
                ] })
              }
            )
          ]
        }
      )
    ] }) : /* @__PURE__ */ jsx(
      "div",
      {
        className: "bg-brand-form-accent-light max-h-full max-w-full rounded-[10px]",
        style: {
          aspectRatio: previewProportions ?? "1/1"
        }
      }
    ),
    /* @__PURE__ */ jsx(
      Modal,
      {
        isVisible: modalData.isVisible,
        containerClasses: "bg-black bg-opacity-[3%]",
        hideModal: () => setModalData(DEFAULT_MODAL_DATA),
        title: modalData.title,
        subtitle: modalData.subtitle,
        acceptLabel: modalData.acceptLabel,
        cancelLabel: t("eleo-cancel", "Cancel"),
        content: modalContent[modalData.type],
        callback: () => handleCallback(modalData.type),
        isValid: true
      }
    )
  ] });
}

function pathnameFromLink(link) {
  try {
    return new URL(link, "http://localhost").pathname;
  } catch {
    const cut = link.search(/[?#]/);
    return cut === -1 ? link : link.slice(0, cut);
  }
}
function getTabActiveState(tab, activeTab, pathname) {
  if (pathname && tab.link !== void 0) {
    const matchesLink = pathname === pathnameFromLink(tab.link);
    const matchesPrefix = tab.prefix ? pathname.startsWith(tab.prefix) : false;
    return matchesLink || matchesPrefix;
  }
  return activeTab !== void 0 && tab.id === activeTab;
}
function getTabStyles(isActive) {
  return classNames(
    "flex h-10 flex-shrink-0 items-center justify-center rounded-[12px] px-2 text-[14px] font-medium transition-all duration-200 sm:px-4",
    isActive ? "bg-white shadow-lg" : "text-[#534b4f] hover:bg-[#f8f8f8] hover:shadow-lg active:scale-95"
  );
}
function Tabs({ tabs, activeTab, onChange, className, type = "buttons" }) {
  const { pathname } = useLocation();
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: classNames(
        "-m-5 flex gap-2 overflow-x-auto p-5 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden",
        className
      ),
      children: tabs.map((tab) => {
        const isActive = getTabActiveState(tab, activeTab, pathname);
        if (type === "links" && tab.link !== void 0) {
          return /* @__PURE__ */ jsx(
            Link,
            {
              id: tab.tabId,
              to: tab.link,
              className: getTabStyles(isActive),
              children: tab.label
            },
            tab.id
          );
        }
        return /* @__PURE__ */ jsx(
          "button",
          {
            id: tab.tabId,
            type: "button",
            onClick: () => onChange?.(tab.id),
            className: classNames(getTabStyles(isActive), tab.className),
            children: tab.label
          },
          tab.id
        );
      })
    }
  );
}

const TranslatorOutput = memo(function TranslatorOutput2({
  outputValue,
  selectedWordIndex,
  onSelectWord
}) {
  return /* @__PURE__ */ jsx(Fragment, { children: outputValue.split(/(\s+|\n)/).map((word, index) => {
    if (/(\s+|\n)/.test(word)) {
      return word;
    } else {
      if (!word.length) return null;
      return /* @__PURE__ */ jsx(
        "span",
        {
          onClick: (e) => onSelectWord(e, index),
          className: classNames(
            "hover:bg-brand-violet/20",
            index === selectedWordIndex && "!bg-brand-violet text-brand-text-primary py-[2px]"
          ),
          children: word
        },
        index
      );
    }
  }) });
});

export { AppNav, AudioPlayer, Badge, BasicTooltip, Button, ButtonGroup, ChatActions, ChatMessage, ChatOptions, ChatPushToTalkInput, ChatTextInput, ChatVoiceInput, ChatbotGeneratorHeader, CheckBox, ConversationContext, CookieConsent, DEFAULT_MODAL_DATA$1 as DEFAULT_MODAL_DATA, DropDownMenuAlignmentEnum, DropDownMenuPlacementEnum, FeatureHeader, FormField, Header, HelpButton, History, ImageDisplay, Input, LanguageSelector, ListPosition, Markdown, MessageContext, MessageLoader, Microbutton, MobileChatMessage, MobileChatUI, MobileFloatingBar, MobileMessageActions, MobileSettingsSheet, Modal, ModalMenuItem, ModeSelector, ModelSelector, MuiTooltip, MultipleSelect, PublishItem, RadioBox, Range, ReactSelect, ResizableContainer, Select, index as SelectionPopover, Slider, SortableMultiSelect, StyledTooltip, Tabs, TextArea, Toggle, TokenEnum, ToolGeneratorLayoutPrimary, ToolLayoutPrimary, TranslatorOutput, TypingAnimation, UseEleoToday, createAudioRecorder, getAudioFileExtension, getAudioFileName };
